import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /**
   * The `Float` scalar type represents signed double-precision fractional.
   * In query it is displayed as a string.
   */
  CustomFloat: any;
  /**
   * The `Date` scalar type represents a Date
   * value as specified by
   * [iso8601](https://en.wikipedia.org/wiki/ISO_8601).
   */
  Date: any;
  /**
   * The `DateTime` scalar type represents a DateTime
   * value as specified by
   * [iso8601](https://en.wikipedia.org/wiki/ISO_8601).
   */
  DateTime: any;
  /** The `Decimal` scalar type represents a python Decimal. */
  Decimal: any;
  /**
   *
   *     Errors messages and codes mapped to
   *     fields or non fields errors.
   *     Example:
   *     {
   *         field_name: [
   *             {
   *                 "message": "error message",
   *                 "code": "error_code"
   *             }
   *         ],
   *         other_field: [
   *             {
   *                 "message": "error message",
   *                 "code": "error_code"
   *             }
   *         ],
   *         nonFieldErrors: [
   *             {
   *                 "message": "error message",
   *                 "code": "error_code"
   *             }
   *         ]
   *     }
   *
   */
  ExpectedErrorType: any;
  /**
   * The `GenericScalar` scalar type represents a generic
   * GraphQL scalar value that could be:
   * String, Boolean, Int, Float, List or Object.
   */
  GenericScalar: any;
  /**
   * Allows use of a JSON String for input / output from the GraphQL schema.
   *
   * Use of this type is *not recommended* as you lose the benefits of having a defined, static
   * schema (one of the key benefits of GraphQL).
   */
  JSONString: any;
  /**
   * The `Time` scalar type represents a Time value as
   * specified by
   * [iso8601](https://en.wikipedia.org/wiki/ISO_8601).
   */
  Time: any;
  /**
   * Create scalar that ignores normal serialization/deserialization, since
   * that will be handled by the multipart request spec
   */
  Upload: any;
};

/** An enumeration. */
export enum AccountsPayableCurrency {
  /** BYN */
  Byn = 'BYN',
  /** EUR */
  Eur = 'EUR',
  /** PLN */
  Pln = 'PLN',
  /** RUB */
  Rub = 'RUB',
  /** USD */
  Usd = 'USD'
}

export type AccountsPayableInput = {
  accountsPayable?: InputMaybe<Scalars['Float']>;
  date: Scalars['Date'];
};

export type AccountsPayableType = {
  __typename?: 'AccountsPayableType';
  agreement?: Maybe<AgreementType>;
  amountByn?: Maybe<Scalars['CustomFloat']>;
  amountForeign?: Maybe<Scalars['CustomFloat']>;
  currency: AccountsPayableCurrency;
  date: Scalars['Date'];
  id: Scalars['ID'];
  repaid: Scalars['Boolean'];
  startedAgreement: AgreementType;
};

/**
 * Invoiced against received. A reading, never a check.
 *
 * The two are supposed to differ — timing, the gateway's fee, receipts with no
 * invoice — so a gate on them could never go green. Shown side by side so the
 * size of the gap is visible, and named so it is not mistaken for a defect.
 */
export type AccrualComparisonType = {
  __typename?: 'AccrualComparisonType';
  /** received − invoiced. */
  difference?: Maybe<Scalars['Float']>;
  invoiceCount?: Maybe<Scalars['Int']>;
  /** Gross of PLN invoices ISSUED in the window. */
  invoiced?: Maybe<Scalars['Float']>;
  /** Cash actually received in the window (the revenue line). */
  received?: Maybe<Scalars['Float']>;
};

/**
 * Медаль в ERP.
 *
 * ТЗ 0040 фаза C: стала правимой. Прежний довод «править их в админке
 * методист умеет» перестал работать ровно там, где владелец сказал, что
 * редактирование должно быть в одном месте и по одному образцу.
 */
export type AchievementErpType = {
  __typename?: 'AchievementErpType';
  category: Scalars['String'];
  code: Scalars['String'];
  description: Scalars['String'];
  grantedCount?: Maybe<Scalars['Int']>;
  icon: Scalars['String'];
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  isSecret: Scalars['Boolean'];
  order: Scalars['Int'];
  points: Scalars['Int'];
  ruleKind: Scalars['String'];
  ruleParams?: Maybe<Scalars['JSONString']>;
  title: Scalars['String'];
};

export type AchievementInput = {
  category: Scalars['String'];
  code: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  icon?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  isSecret?: InputMaybe<Scalars['Boolean']>;
  order?: InputMaybe<Scalars['Int']>;
  points?: InputMaybe<Scalars['Int']>;
  ruleKind: Scalars['String'];
  ruleParams?: InputMaybe<Scalars['JSONString']>;
  title: Scalars['String'];
};

/**
 * Добавить кандидату операторов — сразу нескольких.
 *
 * Заменила `setCandidateOperator` (ТЗ 0067): «выбранный» перестал быть
 * одним, и мутация «поставь одного вместо всех» описывала правило, которого
 * больше нет. Выключенного оператора НЕ воскрешает — для этого есть явная
 * `reactivateCandidateOperator`.
 */
export type AddCandidateOperators = {
  __typename?: 'AddCandidateOperators';
  /** Сколько операторов РЕАЛЬНО добавлено. Может быть меньше запрошенного и даже нулём: уже активный пропускается молча, а выключенного человеком повторное добавление не воскрешает (правило липкости). Экран обязан говорить это число, а не длину своего запроса. */
  addedCount?: Maybe<Scalars['Int']>;
  candidate?: Maybe<FundingCandidateType>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
};

/** ERP: attach one downloadable file (multipart Upload) to a lesson. */
export type AddCareerLessonAttachment = {
  __typename?: 'AddCareerLessonAttachment';
  attachment?: Maybe<CareerLessonAttachmentType>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  lesson?: Maybe<CareerLessonType>;
  success?: Maybe<Scalars['Boolean']>;
};

export type AddNewRoleTeacher = {
  __typename?: 'AddNewRoleTeacher';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
  success?: Maybe<Scalars['Boolean']>;
  teacher?: Maybe<TeacherType>;
};

export type AddRoleStudentAndAgreement = {
  __typename?: 'AddRoleStudentAndAgreement';
  agreement?: Maybe<AgreementType>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
  success?: Maybe<Scalars['Boolean']>;
};

/**
 * Приложить ОДИН файл к существующей задаче (ТЗ 0066).
 *
 * Один файл на вызов — как у дипломов: multipart с несколькими файлами
 * отказывает целиком, и пользователь не понимает, какой из них виноват.
 * Клиент шлёт их подряд.
 */
export type AddStaffTaskAttachmentMutation = {
  __typename?: 'AddStaffTaskAttachmentMutation';
  attachment?: Maybe<StaffTaskAttachmentType>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
  task?: Maybe<StaffTaskType>;
};

export type AddStaffTaskCommentMutation = {
  __typename?: 'AddStaffTaskCommentMutation';
  comment?: Maybe<StaffTaskCommentType>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
  task?: Maybe<StaffTaskType>;
};

/**
 * Прицепить к задаче объекты (ТЗ 0064).
 *
 * Добавление, а не «пришлите весь список»: две вкладки, открытые рядом,
 * затирали бы правки друг друга, и снятая в одной связь молча возвращалась
 * бы из второй. Повтор уже существующей связи — не ошибка: `ignore_conflicts`
 * делает вызов идемпотентным, а человек, дважды выбравший одного студента,
 * хотел одного студента.
 */
export type AddStaffTaskLinksMutation = {
  __typename?: 'AddStaffTaskLinksMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
  task?: Maybe<StaffTaskType>;
};

export type AddTeacherApplication = {
  __typename?: 'AddTeacherApplication';
  application?: Maybe<ApplicationType>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type AddTeacherExist = {
  __typename?: 'AddTeacherExist';
  application?: Maybe<ApplicationType>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
  success?: Maybe<Scalars['Boolean']>;
};

/**
 * Roster-side connection over agreements — see docs/groups/groups_upgrade.md §B2.
 *
 * `total_count` is filled by the resolver before instantiating the
 * connection so the COUNT(*) is run once over the filtered queryset
 * (instead of `len(self.iterable)` re-counting the page slice).
 */
export type AgreementConnection = {
  __typename?: 'AgreementConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<AgreementEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An enumeration. */
export enum AgreementCurrency {
  /** BYN */
  Byn = 'BYN',
  /** EUR */
  Eur = 'EUR',
  /** PLN */
  Pln = 'PLN',
  /** RUB */
  Rub = 'RUB',
  /** USD */
  Usd = 'USD'
}

/** A Relay edge containing a `Agreement` and its cursor. */
export type AgreementEdge = {
  __typename?: 'AgreementEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<AgreementType>;
};

export type AgreementInput = {
  agreementTitle: Scalars['String'];
  comment?: InputMaybe<Scalars['String']>;
  countryId?: InputMaybe<Scalars['ID']>;
  currency: Scalars['String'];
  date?: InputMaybe<Scalars['Date']>;
  group_id: Scalars['ID'];
  partialAttendance?: InputMaybe<Scalars['Boolean']>;
  paymentByCompany?: InputMaybe<Scalars['Boolean']>;
  promocode?: InputMaybe<Scalars['String']>;
  resident?: InputMaybe<Scalars['Boolean']>;
  startAgreementBudget?: InputMaybe<Scalars['Float']>;
  terminated?: InputMaybe<Scalars['Boolean']>;
  terminatedDate?: InputMaybe<Scalars['Date']>;
  vat?: InputMaybe<Scalars['Boolean']>;
};

export type AgreementLessonsInput = {
  lastLessonId: Scalars['Int'];
  startLessonId: Scalars['Int'];
};

/**
 * Sort options for `GroupType.agreementsConnection`. Names match the
 * UI sort keys (`debt`, `percentPaid`, `name`, `status`) plus direction.
 */
export enum AgreementOrderByEnum {
  DebtAsc = 'DEBT_ASC',
  DebtDesc = 'DEBT_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  PercentPaidAsc = 'PERCENT_PAID_ASC',
  PercentPaidDesc = 'PERCENT_PAID_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC'
}

export type AgreementType = {
  __typename?: 'AgreementType';
  accountsPayable: Array<AccountsPayableType>;
  /** One-line `street, city zip_code` composed from the individual fields. Convenience for compact UIs. */
  address?: Maybe<Scalars['String']>;
  agreementTitle: Scalars['String'];
  attendancesInfo?: Maybe<Scalars['Float']>;
  budgetAmount?: Maybe<Scalars['CustomFloat']>;
  chargeback?: Maybe<ChargebackType>;
  /** From PandaDoc. */
  city?: Maybe<Scalars['String']>;
  comment?: Maybe<Scalars['String']>;
  company?: Maybe<CompanyType>;
  contributions: ContributionTypeConnection;
  contributionsCount?: Maybe<Scalars['Int']>;
  corrections?: Maybe<Array<Maybe<PaymentCorrectionType>>>;
  country?: Maybe<CountryType>;
  courseWorksAverage?: Maybe<Scalars['Float']>;
  currency: AgreementCurrency;
  date: Scalars['Date'];
  /** Σ unpaid remainder of the instalments that are ALREADY DUE (date < today) — THE debt number (ТЗ 0036). An instalment whose date has not arrived is a schedule, not a debt: see `upcomingAmount`. Do not recompute it as budget − paid on the client: an overpaid instalment must not settle the next one. */
  debtAmount?: Maybe<Scalars['CustomFloat']>;
  firstLesson?: Maybe<GroupLessonType>;
  freeOfCharge: Scalars['Boolean'];
  graduationProjectMark?: Maybe<Scalars['Float']>;
  group: MethodistGroupType;
  hwSummary?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  lastLesson?: Maybe<GroupLessonType>;
  /** Buyer's legal name (as it appears on the invoice). Sourced from the PandaDoc contract. */
  legalName?: Maybe<Scalars['String']>;
  /** Σ money received against this contract's instalments (ТЗ 0029 coverage: invoice net_paid + manual payments). */
  paidAmount?: Maybe<Scalars['CustomFloat']>;
  paidContributionsCount?: Maybe<Scalars['Int']>;
  /** PandaDoc contract this agreement was provisioned from (1:1), if any. */
  pandadocDocument?: Maybe<PandaDocDocumentType>;
  partialAttendance: Scalars['Boolean'];
  paymentByCompany: Scalars['Boolean'];
  payments?: Maybe<Array<Maybe<PaymentType>>>;
  promocode?: Maybe<Scalars['String']>;
  resident: Scalars['Boolean'];
  startAccountsPayable?: Maybe<AccountsPayableType>;
  statePrefinanced: Scalars['Boolean'];
  /** From PandaDoc. */
  street?: Maybe<Scalars['String']>;
  student: StudentType;
  /** Buyer's NIP / VAT-ID / УНП. From PandaDoc. */
  taxId?: Maybe<Scalars['String']>;
  terminated: Scalars['Boolean'];
  terminatedDate?: Maybe<Scalars['Date']>;
  transferOut: Scalars['Boolean'];
  transferOutPaidAmount: Scalars['Float'];
  /** Σ unpaid remainder of the instalments NOT yet due (date >= today) — «Предстоит». Complement of `debtAmount`; both have any plan write-down netted off, earliest instalment first. As a rule of thumb budget = paidAmount + debtAmount + upcomingAmount, but do NOT rely on it: `paidAmount` is real money received and is deliberately left un-clamped, so it exceeds the budget when a plan write-down was booked before the money arrived, and it also nets refunds that resolve to no instalment. */
  upcomingAmount?: Maybe<Scalars['CustomFloat']>;
  vat: Scalars['Boolean'];
  /** From PandaDoc. */
  zipCode?: Maybe<Scalars['String']>;
};


export type AgreementTypeContributionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['Date']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderByDateFilter?: InputMaybe<Scalars['Boolean']>;
};

export type AiFieldProvenanceType = {
  __typename?: 'AiFieldProvenanceType';
  field: Scalars['String'];
  runId?: Maybe<Scalars['ID']>;
  sourceKind?: Maybe<Scalars['String']>;
};

export type AiLanguageType = {
  __typename?: 'AiLanguageType';
  basis: Scalars['String'];
  language: Scalars['String'];
  level: Scalars['String'];
};

export type AiSkillType = {
  __typename?: 'AiSkillType';
  /** What the source actually EVIDENCES. For a CV these two usually match; for an interview transcript they can differ sharply, and that gap is the point. */
  assessedLevel: Scalars['String'];
  category: Scalars['String'];
  /** What the source CLAIMS: ''|none|basic|intermediate|advanced|expert. */
  claimedLevel: Scalars['String'];
  evidence: Scalars['String'];
  name: Scalars['String'];
  sourceKinds: Array<Scalars['String']>;
};

/**
 * One source's take on a free-text field. BOTH are kept — fusing two
 * summaries with a second LLM pass would be a new hallucination surface for no
 * operator value.
 */
export type AiSourceTextType = {
  __typename?: 'AiSourceTextType';
  sourceKind: Scalars['String'];
  text: Scalars['String'];
};

export type AllStoriesConnection = {
  __typename?: 'AllStoriesConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<AllStoriesEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `AllStories` and its cursor. */
export type AllStoriesEdge = {
  __typename?: 'AllStoriesEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<AllStoriesType>;
};

export type AllStoriesType = ArticlesType | NativeInfoType | SuccessStoriesType;

/**
 * Single-shot «+Студент в группу» from the group dashboard
 * (docs/groups/group_dashboard.md §G8, Variant B).
 *
 * The student already exists (search picker on the frontend); the
 * agreement carries the target `groupId` inside `agreement_input`.
 * Delegates to the existing `add_agreement_to_student` service so all
 * currency / contribution / attendance plumbing is shared with the rest
 * of the agreement-create flow — no duplicate validation paths.
 */
export type AppendStudentToGroupMutation = {
  __typename?: 'AppendStudentToGroupMutation';
  agreement?: Maybe<AgreementType>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type ApplicationConnection = {
  __typename?: 'ApplicationConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ApplicationEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An enumeration. */
export enum ApplicationCurrency {
  /** BYN */
  Byn = 'BYN',
  /** EUR */
  Eur = 'EUR',
  /** PLN */
  Pln = 'PLN',
  /** RUB */
  Rub = 'RUB',
  /** USD */
  Usd = 'USD'
}

/** An enumeration. */
export enum ApplicationDeleteAvailable {
  DeleteAvailable = 'delete_available',
  DeleteNotAvailable = 'delete_not_available',
  DeleteWithTeacher = 'delete_with_teacher'
}

/** A Relay edge containing a `Application` and its cursor. */
export type ApplicationEdge = {
  __typename?: 'ApplicationEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<ApplicationType>;
};

export type ApplicationFilterTypeConnection = {
  __typename?: 'ApplicationFilterTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ApplicationFilterTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `ApplicationFilterType` and its cursor. */
export type ApplicationFilterTypeEdge = {
  __typename?: 'ApplicationFilterTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<ApplicationType>;
};

export type ApplicationInputType = {
  comment?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['ID']>;
  currency: Currencies;
  date: Scalars['Date'];
  group: Scalars['ID'];
  lessonsCount: Scalars['Int'];
  riaPrice?: InputMaybe<Scalars['Float']>;
  servicePrice: Scalars['Float'];
  teacherType: EmploymentTypes;
  title: Scalars['String'];
};

export type ApplicationType = Node & {
  __typename?: 'ApplicationType';
  appointedLessonsCount: Scalars['Int'];
  comment?: Maybe<Scalars['String']>;
  country?: Maybe<CountryType>;
  currency: ApplicationCurrency;
  date: Scalars['Date'];
  deleteAvailable?: Maybe<ApplicationDeleteAvailable>;
  employmentType?: Maybe<EmploymentType>;
  group: MethodistGroupType;
  id: Scalars['ID'];
  isCompleted?: Maybe<Scalars['Boolean']>;
  isTerminated: Scalars['Boolean'];
  lastLessonDate?: Maybe<Scalars['Date']>;
  lessons: GroupLessonTypeConnection;
  lessonsCount: Scalars['Int'];
  riaPrice?: Maybe<Scalars['Float']>;
  servicePrice?: Maybe<Scalars['Float']>;
  teacher: TeacherFilterType;
  title: Scalars['String'];
};


export type ApplicationTypeLessonsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
};

export type ApplySuggestionsResultType = {
  __typename?: 'ApplySuggestionsResultType';
  accepted: Scalars['Int'];
  rejected: Scalars['Int'];
};

/**
 * Accept or reject course proposals.
 *
 * Accepting is the ONLY path that writes `Teacher.courses_can_teach`, and it
 * uses `.add()` — never `.set()`, which would wipe a list the operator curated
 * by hand. Rejecting writes no M2M at all.
 */
export type ApplyTeacherCourseSuggestions = {
  __typename?: 'ApplyTeacherCourseSuggestions';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  result?: Maybe<ApplySuggestionsResultType>;
  success?: Maybe<Scalars['Boolean']>;
};

export type ArchiveSurveyMutation = {
  __typename?: 'ArchiveSurveyMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
  survey?: Maybe<SurveyType>;
};

export type ArticlesConnection = {
  __typename?: 'ArticlesConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ArticlesEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `Articles` and its cursor. */
export type ArticlesEdge = {
  __typename?: 'ArticlesEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<ArticlesType>;
};

export type ArticlesType = {
  __typename?: 'ArticlesType';
  adviceText?: Maybe<Scalars['String']>;
  adviceTitle?: Maybe<Scalars['String']>;
  articleImage?: Maybe<Scalars['String']>;
  articleShortText?: Maybe<Scalars['String']>;
  author: AuthorsType;
  banner?: Maybe<CourseBanner>;
  date: Scalars['Date'];
  id: Scalars['ID'];
  native?: Maybe<NativeInfoType>;
  nativeTitle?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['String']>;
  previewImage?: Maybe<Scalars['String']>;
  published: Scalars['Boolean'];
  seoDescription: Scalars['String'];
  seoImage: Scalars['String'];
  seoKeywords: Scalars['String'];
  seoSlug?: Maybe<Scalars['String']>;
  seoTitle: Scalars['String'];
  storyText?: Maybe<Scalars['String']>;
  storyTime?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type AssignSurveyToGroupMutation = {
  __typename?: 'AssignSurveyToGroupMutation';
  assignment?: Maybe<SurveyAssignmentType>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
};

/**
 * Bulk MANUAL attach (spec 0038) — the plural of assignSurveyToGroup.
 *
 * Not built on setSurveyTargeting: that replaces the whole targeting block,
 * so «add these groups» would become read-modify-write, where one dropped
 * field silently destroys a rule and its assignments. The rows created here
 * are ordinary manual ones that rule resolution never touches.
 *
 * `success: true` WITH a populated `skipped[]` is the normal outcome, same
 * contract as setSurveyTargeting — a group without lesson N must not fail
 * the other twenty.
 */
export type AssignSurveyToGroupsMutation = {
  __typename?: 'AssignSurveyToGroupsMutation';
  assignments?: Maybe<Array<SurveyAssignmentType>>;
  createdCount?: Maybe<Scalars['Int']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  skipped?: Maybe<Array<SurveyTargetingSkipType>>;
  success?: Maybe<Scalars['Boolean']>;
};

/** Прикрепить анкету из справочника к уроку. */
export type AttachCareerExerciseTemplate = {
  __typename?: 'AttachCareerExerciseTemplate';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  lesson?: Maybe<CareerLessonType>;
  success?: Maybe<Scalars['Boolean']>;
};

/**
 * A bare URL — nothing stored, nothing analysable until a transcript is
 * pasted. Also the shape the legacy `Teacher.interviewRecording` migrated into.
 */
export type AttachTeacherInterviewLink = {
  __typename?: 'AttachTeacherInterviewLink';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  interview?: Maybe<TeacherInterviewType>;
  success?: Maybe<Scalars['Boolean']>;
};

/**
 * Link a synced Zoom recording; artifacts are pulled on commit.
 *
 * Eagerly, not lazily: Zoom's cloud retention expires `files[].download_url`
 * and a re-sync does not repair it, so a link we merely stored would rot.
 */
export type AttachTeacherInterviewZoom = {
  __typename?: 'AttachTeacherInterviewZoom';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  interview?: Maybe<TeacherInterviewType>;
  success?: Maybe<Scalars['Boolean']>;
};

/**
 * Одна правка отметки (ТЗ 0026).
 *
 * Плоский ObjectType, а не DjangoObjectType — ровно по той же причине, что и
 * у `MyLessonAttendanceType` ниже: модель ссылается на пользователя, и
 * автогенерация типа утащила бы его целиком.
 */
export type AttendanceChangeType = {
  __typename?: 'AttendanceChangeType';
  changedByName?: Maybe<Scalars['String']>;
  changedVia?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  newValue?: Maybe<Scalars['Boolean']>;
  oldValue?: Maybe<Scalars['Boolean']>;
  source?: Maybe<Scalars['String']>;
};

export type AttendanceType = Node & {
  __typename?: 'AttendanceType';
  attendance?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  lesson: GroupLessonType;
  markedAt?: Maybe<Scalars['DateTime']>;
  markedByName?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  student: StudentType;
};

export type AttendanceTypeConnection = {
  __typename?: 'AttendanceTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<AttendanceTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `AttendanceType` and its cursor. */
export type AttendanceTypeEdge = {
  __typename?: 'AttendanceTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<AttendanceType>;
};

export type AuthorsType = {
  __typename?: 'AuthorsType';
  articlesSet: Array<ArticlesType>;
  authorImage: Scalars['String'];
  authorName: Scalars['String'];
  authorPosition: Scalars['String'];
  id: Scalars['ID'];
  successstoriesSet: Array<SuccessStoriesType>;
};

export type BankAccountType = {
  __typename?: 'BankAccountType';
  currency?: Maybe<Scalars['String']>;
  iban?: Maybe<Scalars['String']>;
  includeInConsolidated?: Maybe<Scalars['Boolean']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isOwn?: Maybe<Scalars['Boolean']>;
  kind?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  netAmountPln?: Maybe<Scalars['Float']>;
  pk?: Maybe<Scalars['Int']>;
  requiresBalance?: Maybe<Scalars['Boolean']>;
  slug?: Maybe<Scalars['String']>;
  transactionsCount?: Maybe<Scalars['Int']>;
};

/** One import run — preview or commit. */
export type BankStatementImportType = {
  __typename?: 'BankStatementImportType';
  balanceGapCount?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdByName?: Maybe<Scalars['String']>;
  createdCount?: Maybe<Scalars['Int']>;
  dryRun?: Maybe<Scalars['Boolean']>;
  duplicateCount?: Maybe<Scalars['Int']>;
  errorMessage?: Maybe<Scalars['String']>;
  failedCount?: Maybe<Scalars['Int']>;
  fileHash?: Maybe<Scalars['String']>;
  fileName?: Maybe<Scalars['String']>;
  finishedAt?: Maybe<Scalars['DateTime']>;
  periodFrom?: Maybe<Scalars['Date']>;
  periodTo?: Maybe<Scalars['Date']>;
  pk?: Maybe<Scalars['Int']>;
  report?: Maybe<Scalars['JSONString']>;
  rowsTotal?: Maybe<Scalars['Int']>;
  source?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

/**
 * A preview the operator looks at before committing, or the commit itself.
 *
 * `alreadyImported` is the guard against the commonest operator mistake —
 * re-uploading last month's file. It is answered from `file_hash` BEFORE
 * parsing, so the answer costs nothing.
 *
 * `accountName` is the guard against the *expensive* one. When an account has
 * no IBAN on file yet there is nothing to contradict the operator's choice,
 * so a wrong pick would land a whole statement on the wrong account. Naming
 * the resolved account in the preview is what makes that visible while it is
 * still a preview.
 */
export type BankStatementUploadOutput = {
  __typename?: 'BankStatementUploadOutput';
  /** Файл сообщил счёту его номер: дальше выбирать не нужно. */
  accountIbanLearned?: Maybe<Scalars['Boolean']>;
  /** Счёт, на который лягут строки — по номеру из файла либо по явно выбранному. */
  accountName?: Maybe<Scalars['String']>;
  alreadyImported?: Maybe<Scalars['Boolean']>;
  dryRun?: Maybe<Scalars['Boolean']>;
  errors?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Итог четырёх шагов, отработавших сразу за импортом: что разнесено, спарено, распознано как выплата шлюза и привязано к документам. `null`, если это предпросмотр или обработку выключили аргументом `process`. */
  processingStats?: Maybe<Scalars['JSONString']>;
  run?: Maybe<BankStatementImportType>;
  success?: Maybe<Scalars['Boolean']>;
};

/**
 * What explains a transaction.
 *
 * A link never contributes to the report — the statement is summed from bank
 * rows alone — so it can be added or removed without moving a number.
 */
export type BankTransactionLinkType = {
  __typename?: 'BankTransactionLinkType';
  amountPln?: Maybe<Scalars['Float']>;
  confidence?: Maybe<Scalars['Int']>;
  matchSource?: Maybe<Scalars['String']>;
  pk?: Maybe<Scalars['Int']>;
  strategy?: Maybe<Scalars['String']>;
  targetId?: Maybe<Scalars['Int']>;
  targetLabel?: Maybe<Scalars['String']>;
  /** expense | invoice | payment | correction */
  targetType?: Maybe<Scalars['String']>;
};

export type BankTransactionOutput = {
  __typename?: 'BankTransactionOutput';
  errors?: Maybe<Array<Maybe<Scalars['String']>>>;
  success?: Maybe<Scalars['Boolean']>;
  transaction?: Maybe<BankTransactionType>;
};

export type BankTransactionPage = {
  __typename?: 'BankTransactionPage';
  items?: Maybe<Array<Maybe<BankTransactionType>>>;
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
  summary?: Maybe<BankTransactionSummary>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type BankTransactionSummary = {
  __typename?: 'BankTransactionSummary';
  count?: Maybe<Scalars['Int']>;
  inflowPln?: Maybe<Scalars['Float']>;
  outflowPln?: Maybe<Scalars['Float']>;
};

export type BankTransactionType = {
  __typename?: 'BankTransactionType';
  accountId?: Maybe<Scalars['Int']>;
  accountName?: Maybe<Scalars['String']>;
  /** Signed: outflow is negative, as in the statement. */
  amount?: Maybe<Scalars['Float']>;
  amountPln?: Maybe<Scalars['Float']>;
  appliedRuleId?: Maybe<Scalars['Int']>;
  balanceAfter?: Maybe<Scalars['Float']>;
  bookedAt?: Maybe<Scalars['Date']>;
  categoryGroup?: Maybe<Scalars['String']>;
  categoryName?: Maybe<Scalars['String']>;
  categorySlug?: Maybe<Scalars['String']>;
  categorySource?: Maybe<Scalars['String']>;
  counterpartyIban?: Maybe<Scalars['String']>;
  counterpartyName?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
  dedupBasis?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  direction?: Maybe<Scalars['String']>;
  internalReviewReason?: Maybe<Scalars['String']>;
  internalSource?: Maybe<Scalars['String']>;
  invoiceNumberHint?: Maybe<Scalars['String']>;
  isInternalTransfer?: Maybe<Scalars['Boolean']>;
  links?: Maybe<Array<Maybe<BankTransactionLinkType>>>;
  needsReview?: Maybe<Scalars['Boolean']>;
  notes?: Maybe<Scalars['String']>;
  pk?: Maybe<Scalars['Int']>;
  rawType?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type BaseTeacherInput = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  middleName?: InputMaybe<Scalars['String']>;
  phone: Scalars['String'];
};

export type BlackFridayLeadInput = {
  course_id?: InputMaybe<Scalars['Int']>;
  email: Scalars['String'];
  formName: Scalars['String'];
  name: Scalars['String'];
  phone: Scalars['String'];
  promocode?: InputMaybe<Scalars['String']>;
  referer?: InputMaybe<Scalars['String']>;
  roistatId: Scalars['String'];
  tittle: Scalars['String'];
  utmCampaign?: InputMaybe<Scalars['String']>;
  utmContent?: InputMaybe<Scalars['String']>;
  utmMedium?: InputMaybe<Scalars['String']>;
  utmSource?: InputMaybe<Scalars['String']>;
  utmTerm?: InputMaybe<Scalars['String']>;
};

/**
 * Suspend a student's LMS access by hand (ТЗ 0074 §3.4). The suspension
 * is tied to ALL the student's current unpaid invoices; no overdue invoice
 * is required. Idempotent for an already-suspended student.
 */
export type BlockStudentLmsAccessMutation = {
  __typename?: 'BlockStudentLmsAccessMutation';
  accessBlock?: Maybe<StudentAccessBlockType>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type BlogAllArticlesType = {
  __typename?: 'BlogAllArticlesType';
  id: Scalars['ID'];
  seoDescription: Scalars['String'];
  seoImage: Scalars['String'];
  seoKeywords: Scalars['String'];
  seoTitle: Scalars['String'];
};

export type BlogGraduateStoryType = {
  __typename?: 'BlogGraduateStoryType';
  description: Scalars['String'];
  id: Scalars['ID'];
  image: Scalars['String'];
  seoDescription: Scalars['String'];
  seoImage: Scalars['String'];
  seoKeywords: Scalars['String'];
  seoTitle: Scalars['String'];
  title: Scalars['String'];
};

export type BlogNativeType = {
  __typename?: 'BlogNativeType';
  description: Scalars['String'];
  id: Scalars['ID'];
  seoDescription: Scalars['String'];
  seoImage: Scalars['String'];
  seoKeywords: Scalars['String'];
  seoTitle: Scalars['String'];
  title: Scalars['String'];
};

/**
 * Send ONE message to many students of a group INDIVIDUALLY — a private
 * Slack DM or a single email each (never a group blast). Runs as a paced
 * background task; returns the broadcast job id the client polls (`broadcast
 * Job`) for live progress and the per-recipient outcome.
 */
export type BroadcastGroupMessage = {
  __typename?: 'BroadcastGroupMessage';
  broadcastJobId?: Maybe<Scalars['ID']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
  total?: Maybe<Scalars['Int']>;
};

/**
 * Live progress of a manager-initiated bulk broadcast: the running
 * sent/failed counts plus each recipient's outcome (who it didn't reach and
 * why).
 */
export type BroadcastJobType = {
  __typename?: 'BroadcastJobType';
  channel?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  errorMessage: Scalars['String'];
  failedCount: Scalars['Int'];
  finishedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  mailboxEmail: Scalars['String'];
  recipients: Array<BroadcastRecipientType>;
  sentCount: Scalars['Int'];
  startedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<Scalars['String']>;
  subject: Scalars['String'];
  total: Scalars['Int'];
};

/** One student targeted by a bulk broadcast + the delivery outcome. */
export type BroadcastRecipientType = {
  __typename?: 'BroadcastRecipientType';
  id: Scalars['ID'];
  reason: Scalars['String'];
  sentAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<Scalars['String']>;
  studentName: Scalars['String'];
};

export type BulkPublishVacancies = {
  __typename?: 'BulkPublishVacancies';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  published?: Maybe<Scalars['Int']>;
  success?: Maybe<Scalars['Boolean']>;
};

/**
 * Move many vacancies at once — the queue-draining action (spec 0035).
 *
 * `bulkPublishVacancies` only ever published; rejecting a night's drafts
 * meant one mutation per row, each triggering a full table reload. This is
 * set-based on the server and covers every status.
 */
export type BulkSetVacancyStatus = {
  __typename?: 'BulkSetVacancyStatus';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  moved?: Maybe<Scalars['Int']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type CeoInfoType = {
  __typename?: 'CEOInfoType';
  course?: Maybe<CourseFilterType>;
  description: Scalars['String'];
  id: Scalars['ID'];
  image: Scalars['String'];
  keywords: Scalars['String'];
  title: Scalars['String'];
};

export type CalendarSettingsMutationOutput = {
  __typename?: 'CalendarSettingsMutationOutput';
  calendarSettings?: Maybe<PaymentCalendarSettingsType>;
  errors?: Maybe<Array<Maybe<Scalars['String']>>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type CancelVideoUpload = {
  __typename?: 'CancelVideoUpload';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type CandidateEventType = {
  __typename?: 'CandidateEventType';
  changedAt: Scalars['DateTime'];
  changedByName?: Maybe<Scalars['String']>;
  fromOperatorName?: Maybe<Scalars['String']>;
  fromStatus?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  note?: Maybe<Scalars['String']>;
  toOperatorName?: Maybe<Scalars['String']>;
  toStatus: Scalars['String'];
};

/**
 * Одна связь «кандидат ↔ оператор» (ТЗ 0067).
 *
 * Активные — это те, по кому человеку идут письма о наборах; выключенные
 * остаются в журнале вместе с причиной, автором и датой. Экран обязан
 * показывать и те, и другие: «почему мы больше не ходим к этому оператору»
 * — вопрос, на который карточка должна отвечать без похода в журнал.
 */
export type CandidateOperatorLinkType = {
  __typename?: 'CandidateOperatorLinkType';
  addedAt: Scalars['DateTime'];
  addedByName?: Maybe<Scalars['String']>;
  deactivatedAt?: Maybe<Scalars['DateTime']>;
  deactivatedByName?: Maybe<Scalars['String']>;
  /** operator_declined | person_declined | signed_elsewhere | transferred | other */
  deactivationReason?: Maybe<Scalars['String']>;
  /** Причина по-русски — отдельного справочника причин на фронте держать не нужно. */
  deactivationReasonLabel?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  /** Пометка «ведущий». НИКОГО не глушит: письма идут по всем активным операторам. */
  isPrimary: Scalars['Boolean'];
  note?: Maybe<Scalars['String']>;
  operator: FundingOperatorType;
  /** auto | manual | import */
  source: Scalars['String'];
};

export type CareerApplicationInput = {
  appliedAt?: InputMaybe<Scalars['Date']>;
  applyUrl?: InputMaybe<Scalars['String']>;
  companyName?: InputMaybe<Scalars['String']>;
  nextActionAt?: InputMaybe<Scalars['Date']>;
  note?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  vacancyId?: InputMaybe<Scalars['ID']>;
};

/**
 * Отклик студента.
 *
 * 🔴 `note` — ЛИЧНОЕ. Резолвер отдаёт его только когда строка помечена
 * `_own_view`, а метку ставит исключительно LMS-резолвер. Компания, позиция,
 * статус и даты — операционные данные, HR обязан их видеть; «на интервью
 * хамили» — нет. Зеркало приёма `_engagement` / `myNotes` у урока.
 */
export type CareerApplicationType = {
  __typename?: 'CareerApplicationType';
  appliedAt?: Maybe<Scalars['Date']>;
  applyUrl: Scalars['String'];
  companyName: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  isPlacementConfirmed: Scalars['Boolean'];
  nextActionAt?: Maybe<Scalars['Date']>;
  note: Scalars['String'];
  position: Scalars['String'];
  source: Scalars['String'];
  status: Scalars['String'];
  studentId?: Maybe<Scalars['ID']>;
  studentName: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  vacancyId?: Maybe<Scalars['ID']>;
};

/**
 * The LMS landing payload: am I a member, and how far along am I.
 *
 * ТЗ 0039 доводка: тот же payload обслуживает предпросмотр методиста, у
 * которого участия нет вовсе. Поэтому `memberId` и `enrolledAt` стали
 * NULLABLE — выдуманный id был бы хуже честной пустоты: по нему фронт
 * однажды сходил бы за данными несуществующего участника.
 */
export type CareerCenterType = {
  __typename?: 'CareerCenterType';
  directionId?: Maybe<Scalars['ID']>;
  directionSource?: Maybe<Scalars['String']>;
  directionTitle?: Maybe<Scalars['String']>;
  enrolledAt?: Maybe<Scalars['DateTime']>;
  isPreview: Scalars['Boolean'];
  lessonsCompleted: Scalars['Int'];
  lessonsTotal: Scalars['Int'];
  memberId?: Maybe<Scalars['ID']>;
  status: Scalars['String'];
};

/** A canonical city — the option list behind the feed's city filter. */
export type CareerCityType = {
  __typename?: 'CareerCityType';
  country: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

/**
 * Курс, закрывающий пробелы карты. Одна основная и максимум две
 * альтернативы — список из десяти курсов не рекомендация, а каталог.
 */
export type CareerCourseRecommendationType = {
  __typename?: 'CareerCourseRecommendationType';
  access: Scalars['String'];
  careerOutcome: Scalars['String'];
  closesNodes: Array<Scalars['String']>;
  closesSkillNames: Array<Scalars['String']>;
  courseId: Scalars['ID'];
  courseName: Scalars['String'];
  courseUrl: Scalars['String'];
  criticalGaps: Scalars['Int'];
  durationLabel: Scalars['String'];
  importantGaps: Scalars['Int'];
  reasonCode: Scalars['String'];
  status: Scalars['String'];
};

/** Parent is the dict from `services.dashboard.funnel()`. */
export type CareerDashboardType = {
  __typename?: 'CareerDashboardType';
  applied: Scalars['Int'];
  members: Scalars['Int'];
  oldestDraftDays: Scalars['Int'];
  placed: Scalars['Int'];
  profileReady: Scalars['Int'];
  trained: Scalars['Int'];
  vacanciesDraft: Scalars['Int'];
  vacanciesDraftFromAgent: Scalars['Int'];
  vacanciesPublished: Scalars['Int'];
};

export type CareerDirectionType = {
  __typename?: 'CareerDirectionType';
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  order: Scalars['Int'];
  slug: Scalars['String'];
  title: Scalars['String'];
};

export type CareerExerciseAnswerInput = {
  fieldId: Scalars['ID'];
  value?: InputMaybe<Scalars['JSONString']>;
};

export type CareerExerciseAnswerType = {
  __typename?: 'CareerExerciseAnswerType';
  fieldId: Scalars['ID'];
  value?: Maybe<Scalars['JSONString']>;
};

/** Что попало в резюме, а что пропущено и почему (ТЗ 0039). */
export type CareerExerciseApplyReportType = {
  __typename?: 'CareerExerciseApplyReportType';
  profileCompleteness: Scalars['Int'];
  skippedTargets: Array<Scalars['String']>;
  writtenTargets: Array<Scalars['String']>;
};

export type CareerExerciseFieldInput = {
  binding?: InputMaybe<Scalars['String']>;
  bindingLanguage?: InputMaybe<Scalars['String']>;
  fieldType: Scalars['String'];
  helpText?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  label: Scalars['String'];
  maxLength?: InputMaybe<Scalars['Int']>;
  options?: InputMaybe<Array<Scalars['String']>>;
  placeholder?: InputMaybe<Scalars['String']>;
  required?: InputMaybe<Scalars['Boolean']>;
};

/** Поле анкеты урока (ТЗ 0039). */
export type CareerExerciseFieldType = {
  __typename?: 'CareerExerciseFieldType';
  binding: Scalars['String'];
  bindingLanguage?: Maybe<Scalars['String']>;
  fieldType: Scalars['String'];
  helpText: Scalars['String'];
  id: Scalars['ID'];
  label: Scalars['String'];
  maxLength?: Maybe<Scalars['Int']>;
  number: Scalars['Int'];
  options: Array<Scalars['String']>;
  placeholder: Scalars['String'];
  prefill?: Maybe<Scalars['JSONString']>;
  required: Scalars['Boolean'];
};

export type CareerExerciseSubmissionType = {
  __typename?: 'CareerExerciseSubmissionType';
  answers: Array<CareerExerciseAnswerType>;
  id: Scalars['ID'];
  submittedAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
};

/**
 * Анкета в справочнике (ТЗ 0040 фаза B).
 *
 * `lessonTitles`, а не только счётчик: перед правкой методисту нужно знать
 * не «сколько», а «каких именно» уроков это коснётся — иначе он правит
 * вслепую, а замок объясняет отказ уже постфактум.
 */
export type CareerExerciseTemplateType = {
  __typename?: 'CareerExerciseTemplateType';
  fields: Array<CareerExerciseFieldType>;
  hasSubmissions: Scalars['Boolean'];
  id: Scalars['ID'];
  intro: Scalars['String'];
  isActive: Scalars['Boolean'];
  lessonTitles: Array<Scalars['String']>;
  outro: Scalars['String'];
  submissionsCount: Scalars['Int'];
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

/**
 * Выбранная карьерная цель — это `GrowthTrack`, а не новая сущность.
 *
 * Заводить рядом с треком отдельную «цель» значило бы немедленно получить
 * экран, где выбрана профессия A, а целью названа B.
 */
export type CareerGoalType = {
  __typename?: 'CareerGoalType';
  icon: Scalars['String'];
  isChosen: Scalars['Boolean'];
  salaryCurrency: Scalars['String'];
  salaryFrom?: Maybe<Scalars['Int']>;
  salaryTo?: Maybe<Scalars['Int']>;
  skillProgress?: Maybe<CareerSkillProgressType>;
  targetSkillsMine: Scalars['Int'];
  targetSkillsTotal: Scalars['Int'];
  title: Scalars['String'];
  trackCode: Scalars['String'];
};

/**
 * Фаза пути — проекция этапов на четыре крупные карточки (ТЗ 0070).
 *
 * 🔴 У фазы НЕТ собственных `done`/`total`. Сложить уроки, проекты и галочки
 * резюме в одно число — это и есть непрозрачный «18 / 20», ради снятия
 * которого писалось 0070. Метрики остаются раздельными именно поэтому.
 */
export type CareerJourneySectionType = {
  __typename?: 'CareerJourneySectionType';
  blockReason?: Maybe<Scalars['String']>;
  isBlocked: Scalars['Boolean'];
  isCurrent: Scalars['Boolean'];
  key: Scalars['String'];
  metrics: Array<JourneyMetricType>;
  route: Scalars['String'];
  state: Scalars['String'];
};

/**
 * Весь маршрут одним запросом.
 *
 * Раньше этот экран собирался из шести запросов (`myCareerCenter`,
 * `myGrowth`, `mySkillMap`, `myCareerProfile`, `careerLessons`,
 * `careerVacancyFeed`) — около 68 SQL и шесть round-trip, и ни один из них
 * не отвечал на вопрос «что делать следующим».
 */
export type CareerJourneyType = {
  __typename?: 'CareerJourneyType';
  alignment: CareerProfileAlignmentType;
  applications: JourneyApplicationsType;
  cvChecklist: Array<JourneyCheckType>;
  goal?: Maybe<CareerGoalType>;
  hasGoal: Scalars['Boolean'];
  isMember: Scalars['Boolean'];
  isPreview: Scalars['Boolean'];
  locked: Array<JourneyLockedType>;
  memberStatus?: Maybe<Scalars['String']>;
  metrics: Array<JourneyMetricType>;
  nextAction?: Maybe<JourneyActionType>;
  phase: Scalars['String'];
  primaryAction?: Maybe<JourneyActionType>;
  readiness: Array<JourneyReadinessType>;
  secondaryActions: Array<JourneyActionType>;
  sections: Array<CareerJourneySectionType>;
  stages: Array<JourneyStageType>;
  weeklyTasks: Array<JourneyTaskType>;
};

export type CareerLessonAttachmentType = {
  __typename?: 'CareerLessonAttachmentType';
  contentType: Scalars['String'];
  id: Scalars['ID'];
  originalName: Scalars['String'];
  sizeBytes: Scalars['Int'];
  url?: Maybe<Scalars['String']>;
};

export type CareerLessonExerciseType = {
  __typename?: 'CareerLessonExerciseType';
  fields: Array<CareerExerciseFieldType>;
  hasSubmissions: Scalars['Boolean'];
  id: Scalars['ID'];
  intro: Scalars['String'];
  mySubmission?: Maybe<CareerExerciseSubmissionType>;
  outro: Scalars['String'];
  templateId: Scalars['ID'];
  templateTitle: Scalars['String'];
};

export type CareerLessonInput = {
  artifactHint?: InputMaybe<Scalars['String']>;
  completionKind?: InputMaybe<Scalars['String']>;
  content?: InputMaybe<Scalars['String']>;
  durationMin?: InputMaybe<Scalars['Int']>;
  isPublished?: InputMaybe<Scalars['Boolean']>;
  materialLanguage?: InputMaybe<Scalars['String']>;
  order: Scalars['Int'];
  outcomeKind?: InputMaybe<Scalars['String']>;
  outcomeLabel?: InputMaybe<Scalars['String']>;
  summary?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
};

/**
 * ERP-only completion funnel for one lesson (spec 0020). Parent is the
 * dict `services.engagement.lesson_funnel` produces per lesson.
 */
export type CareerLessonStatsType = {
  __typename?: 'CareerLessonStatsType';
  completedCount: Scalars['Int'];
  membersTotal: Scalars['Int'];
  openedCount: Scalars['Int'];
};

/**
 * Parent is a CareerLesson annotated by the resolver with
 * `_is_unlocked` and `_is_completed` for the calling viewer.
 *
 * ERP staff read the same type with both flags forced True — they author
 * the content, so there is nothing to gate.
 *
 * The engagement fields (`is_opened`, `my_notes`, `is_bookmarked`, …) read a
 * per-viewer `_engagement` row that ONLY the LMS `_decorate` attaches — so on
 * the ERP side they default to empty/false and `my_notes` can never leak a
 * student's private note to staff. `stats` is the mirror image: attached only
 * by the ERP query, null on the LMS.
 */
export type CareerLessonType = {
  __typename?: 'CareerLessonType';
  artifactHint: Scalars['String'];
  attachments: Array<CareerLessonAttachmentType>;
  attachmentsCount: Scalars['Int'];
  completedAt?: Maybe<Scalars['DateTime']>;
  completionKind: Scalars['String'];
  content?: Maybe<Scalars['String']>;
  durationMin?: Maybe<Scalars['Int']>;
  exercise?: Maybe<CareerLessonExerciseType>;
  hasExercise: Scalars['Boolean'];
  hasVideo: Scalars['Boolean'];
  id: Scalars['ID'];
  isBookmarked: Scalars['Boolean'];
  isCompleted: Scalars['Boolean'];
  isOpened: Scalars['Boolean'];
  isPublished: Scalars['Boolean'];
  isUnlocked: Scalars['Boolean'];
  materialLanguage: Scalars['String'];
  myNotes: Scalars['String'];
  openCount: Scalars['Int'];
  openedAt?: Maybe<Scalars['DateTime']>;
  order: Scalars['Int'];
  outcomeKind: Scalars['String'];
  outcomeLabel: Scalars['String'];
  peersCompleted?: Maybe<Scalars['Int']>;
  quizQuestions: Array<CareerQuizQuestionType>;
  quizQuestionsCount: Scalars['Int'];
  state: Scalars['String'];
  stats?: Maybe<CareerLessonStatsType>;
  summary: Scalars['String'];
  title: Scalars['String'];
  unlockAfter?: Maybe<CareerLessonUnlockType>;
  videoUrl?: Maybe<Scalars['String']>;
};

/**
 * Что откроет закрытый урок: пройти предыдущий (ТЗ 0071).
 *
 * Номер и название — данные, фразу собирает фронт: «Otworzy się po lekcji 5».
 */
export type CareerLessonUnlockType = {
  __typename?: 'CareerLessonUnlockType';
  lessonId: Scalars['ID'];
  order: Scalars['Int'];
  title: Scalars['String'];
};

export type CareerMemberInput = {
  directionId?: InputMaybe<Scalars['ID']>;
  notes?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
};

/**
 * One row of a member's learning map for the ERP per-member drawer
 * (spec 0020). Parent is a dict from `services.engagement.member_progress`.
 * Carries NO note text — staff see whether/when, never what.
 */
export type CareerMemberLessonProgressType = {
  __typename?: 'CareerMemberLessonProgressType';
  completedAt?: Maybe<Scalars['DateTime']>;
  isCompleted: Scalars['Boolean'];
  isOpened: Scalars['Boolean'];
  lessonId: Scalars['ID'];
  openCount: Scalars['Int'];
  openedAt?: Maybe<Scalars['DateTime']>;
  order: Scalars['Int'];
  title: Scalars['String'];
};

/** ERP row. Student/group refs are flat light fields on purpose. */
export type CareerMemberType = {
  __typename?: 'CareerMemberType';
  directionId?: Maybe<Scalars['ID']>;
  directionTitle?: Maybe<Scalars['String']>;
  enrolledAt: Scalars['DateTime'];
  groupId?: Maybe<Scalars['ID']>;
  groupName?: Maybe<Scalars['String']>;
  growth?: Maybe<MemberGrowthType>;
  id: Scalars['ID'];
  lessonsCompleted: Scalars['Int'];
  lessonsTotal: Scalars['Int'];
  notes: Scalars['String'];
  profile?: Maybe<CareerProfileType>;
  status: Scalars['String'];
  studentEmail?: Maybe<Scalars['String']>;
  studentId: Scalars['ID'];
  studentName: Scalars['String'];
};

/**
 * Спорит ли резюме с выбранной целью (ТЗ 0070).
 *
 * ⚠️ `profileDirection` — КОНТЕКСТ, а не часть оценки: связи «направление ↔
 * профессия» в модели нет, и выводить её эвристикой значило бы завести второе
 * определение цели.
 */
export type CareerProfileAlignmentType = {
  __typename?: 'CareerProfileAlignmentType';
  goalTitle?: Maybe<Scalars['String']>;
  goalTrackCode?: Maybe<Scalars['String']>;
  profileDirection: Scalars['String'];
  profileHeadline: Scalars['String'];
  status: Scalars['String'];
  suggestedHeadline?: Maybe<Scalars['String']>;
};

export type CareerProfileInput = {
  availableFrom?: InputMaybe<Scalars['Date']>;
  certificates?: InputMaybe<Array<ProfileCertificateInput>>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  customSkills?: InputMaybe<Array<Scalars['String']>>;
  cvLocales?: InputMaybe<Array<CvLocaleInput>>;
  desiredPosition?: InputMaybe<Scalars['String']>;
  desiredSalary?: InputMaybe<Scalars['String']>;
  education?: InputMaybe<Array<ProfileEducationInput>>;
  email?: InputMaybe<Scalars['String']>;
  experience?: InputMaybe<Array<ProfileExperienceInput>>;
  firstName?: InputMaybe<Scalars['String']>;
  githubUrl?: InputMaybe<Scalars['String']>;
  languages?: InputMaybe<Array<ProfileLanguageInput>>;
  lastName?: InputMaybe<Scalars['String']>;
  linkedinUrl?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  portfolioUrl?: InputMaybe<Scalars['String']>;
  projects?: InputMaybe<Array<ProfileProjectInput>>;
  relocationReady?: InputMaybe<Scalars['Boolean']>;
  seniority?: InputMaybe<Scalars['String']>;
  skills?: InputMaybe<Array<ProfileSkillInput>>;
  workMode?: InputMaybe<Scalars['String']>;
  workPermit?: InputMaybe<Scalars['String']>;
};

/**
 * The student's structured profile — canonical source of the CV.
 *
 * `is_searchable`/`contacts_visible` are the student's own opt-in flags,
 * returned only on their own profile.
 */
export type CareerProfileType = {
  __typename?: 'CareerProfileType';
  availableFrom?: Maybe<Scalars['Date']>;
  certificates: Array<CertificateType>;
  city: Scalars['String'];
  completeness: Scalars['Int'];
  contactsVisible: Scalars['Boolean'];
  country: Scalars['String'];
  customSkills: Array<Scalars['String']>;
  cvSkillSuggestions: Array<CvSkillSuggestionType>;
  desiredPosition: Scalars['String'];
  desiredSalary: Scalars['String'];
  education: Array<EducationType>;
  email: Scalars['String'];
  experience: Array<WorkExperienceType>;
  firstName: Scalars['String'];
  githubUrl: Scalars['String'];
  id: Scalars['ID'];
  isSearchable: Scalars['Boolean'];
  languages: Array<LanguageSkillType>;
  lastName: Scalars['String'];
  linkedinUrl: Scalars['String'];
  locales: Array<CvLocaleType>;
  phone: Scalars['String'];
  photoUrl?: Maybe<Scalars['String']>;
  portfolioUrl: Scalars['String'];
  projects: Array<PortfolioProjectType>;
  relocationReady: Scalars['Boolean'];
  seniority: Scalars['String'];
  skills: Array<StudentSkillType>;
  workMode: Scalars['String'];
  workPermit: Scalars['String'];
};

export type CareerQuizAnswerInput = {
  questionId: Scalars['ID'];
  selectedIndexes: Array<Scalars['Int']>;
};

export type CareerQuizQuestionInput = {
  correctIndexes: Array<Scalars['Int']>;
  options: Array<Scalars['String']>;
  text: Scalars['String'];
};

/**
 * A self-check question (spec 0020). `correct_indexes` is revealed ONLY to
 * the ERP author — the `_reveal` flag is attached by `careerLessonsErp`; on
 * the LMS answer flow it is always empty, so the answer key can't be read off
 * the question list before submitting.
 */
export type CareerQuizQuestionType = {
  __typename?: 'CareerQuizQuestionType';
  correctIndexes: Array<Scalars['Int']>;
  id: Scalars['ID'];
  options: Array<Scalars['String']>;
  order: Scalars['Int'];
  text: Scalars['String'];
};

/**
 * One graded question after submit — parent is a dict from
 * `services.quiz.submit_quiz`. The key is returned here because the answer is
 * already given (post-submit feedback).
 */
export type CareerQuizResultType = {
  __typename?: 'CareerQuizResultType';
  correct: Scalars['Boolean'];
  correctIndexes: Array<Scalars['Int']>;
  questionId: Scalars['ID'];
};

/**
 * Строка диалога добавления: кого можно зачислить и кто уже внутри.
 *
 * 🔴 `memberStatus` приходит С СЕРВЕРА, а не вычисляется в интерфейсе. Без
 * него оператор узнавал правду только из `skipped` в тосте — то есть уже
 * после того, как нажал «Добавить» и ничего не произошло.
 */
export type CareerRosterRowType = {
  __typename?: 'CareerRosterRowType';
  email: Scalars['String'];
  fullName: Scalars['String'];
  groupName?: Maybe<Scalars['String']>;
  memberStatus?: Maybe<Scalars['String']>;
  studentId: Scalars['ID'];
};

/** Колонка карты — группа навыков внутри профессии. */
export type CareerSkillClusterType = {
  __typename?: 'CareerSkillClusterType';
  code: Scalars['String'];
  description: Scalars['String'];
  icon: Scalars['String'];
  order: Scalars['Int'];
  title: Scalars['String'];
};

/**
 * Связь карты: 'hierarchy' — колонка и её навык, 'required' —
 * обязательная предпосылка, 'recommended' — рекомендуемый порядок.
 */
export type CareerSkillEdgeType = {
  __typename?: 'CareerSkillEdgeType';
  from: Scalars['ID'];
  kind: Scalars['String'];
  to: Scalars['ID'];
};

/** Один незакрытый обязательный навык — для «трёх ближайших пробелов». */
export type CareerSkillGapType = {
  __typename?: 'CareerSkillGapType';
  myLevel?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  priority: Scalars['String'];
  requiredLevel: Scalars['Int'];
  slug: Scalars['String'];
  status: Scalars['String'];
};

/**
 * Карта навыков выбранной профессии целиком.
 *
 * Один запрос на весь граф: дерево собирает клиент из плоского списка узлов.
 * Экран, делающий по запросу на узел, при шестидесяти навыках отвечал бы
 * минуту.
 */
export type CareerSkillGraphType = {
  __typename?: 'CareerSkillGraphType';
  clusters: Array<CareerSkillClusterType>;
  computedAt?: Maybe<Scalars['DateTime']>;
  edges: Array<CareerSkillEdgeType>;
  fallbackReason: Scalars['String'];
  isChosenGoal: Scalars['Boolean'];
  isFallback: Scalars['Boolean'];
  nodes: Array<CareerSkillNodeType>;
  recommendedCourses: Array<CareerCourseRecommendationType>;
  skillProgress: CareerSkillProgressType;
  trackCode: Scalars['String'];
  trackIcon: Scalars['String'];
  trackIsDefault: Scalars['Boolean'];
  trackTitle: Scalars['String'];
};

export type CareerSkillInput = {
  aliases?: InputMaybe<Array<Scalars['String']>>;
  category: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  levelCriteria?: InputMaybe<Array<SkillLevelCriteriaInput>>;
  name: Scalars['String'];
};

/** Узел карты: навык профессии и положение студента относительно него. */
export type CareerSkillNodeType = {
  __typename?: 'CareerSkillNodeType';
  clusterCode: Scalars['String'];
  demand?: Maybe<SkillDemandType>;
  description: Scalars['String'];
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  myLevel?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  priority: Scalars['String'];
  providers: Array<SkillProviderType>;
  requiredLevel: Scalars['Int'];
  requirementStatus: Scalars['String'];
  skill: SkillType;
  slug: Scalars['String'];
  source: Scalars['String'];
  status: Scalars['String'];
  upcoming?: Maybe<UpcomingUnlockType>;
};

/**
 * Пять независимых чисел из `career.services.skill_progress.progress`.
 *
 * 🔴 Клиент НЕ складывает их в проценты и не выводит одно из другого: у
 * «подтверждено школой» и «соответствует» разные смыслы, и сумма
 * «соответствует + подтверждено» — ровно та вторая правда, ради снятия
 * которой заведён этот тип.
 */
export type CareerSkillProgressType = {
  __typename?: 'CareerSkillProgressType';
  meetsRequiredLevelCount: Scalars['Int'];
  missingCount: Scalars['Int'];
  needsImprovementCount: Scalars['Int'];
  requiredCount: Scalars['Int'];
  verifiedMeetsRequiredLevelCount: Scalars['Int'];
};

export type CashBalanceMutationOutput = {
  __typename?: 'CashBalanceMutationOutput';
  cashBalance?: Maybe<CashBalanceSnapshotType>;
  errors?: Maybe<Array<Maybe<Scalars['String']>>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type CashBalanceSnapshotType = {
  __typename?: 'CashBalanceSnapshotType';
  amountPln?: Maybe<Scalars['Float']>;
  asOfDate: Scalars['Date'];
  comment: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  legalEntityId?: Maybe<Scalars['Int']>;
  pk?: Maybe<Scalars['Int']>;
};

export type CashFlowCategoryType = {
  __typename?: 'CashFlowCategoryType';
  group?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  learningPolicy?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  pk?: Maybe<Scalars['Int']>;
  section?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['Int']>;
};

export type CashFlowCheckType = {
  __typename?: 'CashFlowCheckType';
  code?: Maybe<Scalars['String']>;
  count?: Maybe<Scalars['Int']>;
  /** Russian prose. A fallback and what the logs show — the client builds its own sentence from `code` and `count` so the page is not half-translated. */
  detail?: Maybe<Scalars['String']>;
  /** PASS | REVIEW */
  status?: Maybe<Scalars['String']>;
  /** The specifics, as DATA rather than prose: account names, dates and amounts. Safe to append to a translated sentence, which `detail` is not. */
  subject?: Maybe<Scalars['String']>;
};

export type CashFlowControlType = {
  __typename?: 'CashFlowControlType';
  accounts?: Maybe<Array<Maybe<BankAccountType>>>;
  checks?: Maybe<Array<Maybe<CashFlowCheckType>>>;
  heuristicDedupCount?: Maybe<Scalars['Int']>;
  internalCount?: Maybe<Scalars['Int']>;
  internalUnpairedCount?: Maybe<Scalars['Int']>;
  needsReviewCount?: Maybe<Scalars['Int']>;
  rulesNeedingAttention?: Maybe<Scalars['Int']>;
  rulesTotal?: Maybe<Scalars['Int']>;
  transactionsCount?: Maybe<Scalars['Int']>;
  uncategorisedCount?: Maybe<Scalars['Int']>;
};

export type CashFlowPeriodType = {
  __typename?: 'CashFlowPeriodType';
  /** Running balance over the WHOLE history, not the window. */
  cash?: Maybe<Scalars['Float']>;
  /** Signed: an owner withdrawal stays on the financing line rather than becoming an operating expense. */
  funding?: Maybe<Scalars['Float']>;
  /** 2026-03 | 2026 Q1 | 2026 — never a localised label: the server does not know the viewer's language. */
  key?: Maybe<Scalars['String']>;
  /** revenue + returns + funding - outflow, exactly. */
  net?: Maybe<Scalars['Float']>;
  operatingCashFlow?: Maybe<Scalars['Float']>;
  /** Positive number. */
  outflow?: Maybe<Scalars['Float']>;
  /** Money in that landed in a NON-income category — a supplier refund, a tax rebate. Positive. Without it `revenue - outflow` does not equal `net`. */
  returns?: Maybe<Scalars['Float']>;
  /** Money in, income categories only. */
  revenue?: Maybe<Scalars['Float']>;
  /** Operations behind the column. A month built from three rows draws exactly like a month built from a hundred. */
  rows?: Maybe<Scalars['Int']>;
};

export type CashFlowReportType = {
  __typename?: 'CashFlowReportType';
  /** Invoiced beside received, for the same window. */
  accrual?: Maybe<AccrualComparisonType>;
  /** The day `closingCash` is true as of — the last booked date in the window. Null when the window holds no rows. Show it: the balance is as fresh as the last statement uploaded, which is not the same as today. */
  asOf?: Maybe<Scalars['Date']>;
  closingCash?: Maybe<Scalars['Float']>;
  currency?: Maybe<Scalars['String']>;
  grain?: Maybe<Scalars['String']>;
  internalExcludedCount?: Maybe<Scalars['Int']>;
  /** Does the ledger reach the end of the LAST column shown? False means that column is a part-period drawn like a whole one — mark it. Deliberately a statement about the DATA, not the calendar: July had ended by the wall clock while the statements only reached the 7th, so «Зарплаты, июль = 0» read as «зарплат не платили» rather than as «ещё не загружено». The row count cannot substitute: those seven days carried 30 operations, comfortably above any thin-period threshold. */
  lastPeriodComplete?: Maybe<Scalars['Boolean']>;
  /** Average monthly OPERATING outflow over the trailing complete months. Null when operations are not consuming cash. Owner funding is excluded — money put in is not the business paying for itself. */
  monthlyBurnPln?: Maybe<Scalars['Float']>;
  openingCash?: Maybe<Scalars['Float']>;
  periods?: Maybe<Array<Maybe<CashFlowPeriodType>>>;
  rateMissingCount?: Maybe<Scalars['Int']>;
  rows?: Maybe<Array<Maybe<CashFlowRowType>>>;
  /** Months the current cash covers at that burn. Null means not burning, not «infinite». */
  runwayMonths?: Maybe<Scalars['Float']>;
  totalFunding?: Maybe<Scalars['Float']>;
  totalOperatingCashFlow?: Maybe<Scalars['Float']>;
  totalOutflow?: Maybe<Scalars['Float']>;
  totalReturns?: Maybe<Scalars['Float']>;
  totalRevenue?: Maybe<Scalars['Float']>;
};

export type CashFlowRowType = {
  __typename?: 'CashFlowRowType';
  group?: Maybe<Scalars['String']>;
  hasChildren?: Maybe<Scalars['Boolean']>;
  key?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  /** 0 = group, 1 = category. */
  level?: Maybe<Scalars['Int']>;
  parentKey?: Maybe<Scalars['String']>;
  section?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Float']>;
  /** Positional, aligned to `periods`, explicit zeros. */
  values?: Maybe<Array<Maybe<Scalars['Float']>>>;
};

export type CashFlowRuleType = {
  __typename?: 'CashFlowRuleType';
  categoryName?: Maybe<Scalars['String']>;
  categorySlug?: Maybe<Scalars['String']>;
  direction?: Maybe<Scalars['String']>;
  health?: Maybe<Scalars['String']>;
  hitsCount?: Maybe<Scalars['Int']>;
  isActive?: Maybe<Scalars['Boolean']>;
  keyKind?: Maybe<Scalars['String']>;
  keyValue?: Maybe<Scalars['String']>;
  origin?: Maybe<Scalars['String']>;
  overridesCount?: Maybe<Scalars['Int']>;
  pk?: Maybe<Scalars['Int']>;
  priority?: Maybe<Scalars['Int']>;
  validFrom?: Maybe<Scalars['Date']>;
  validTo?: Maybe<Scalars['Date']>;
};

export type CashFlowRunOutput = {
  __typename?: 'CashFlowRunOutput';
  dryRun?: Maybe<Scalars['Boolean']>;
  errors?: Maybe<Array<Maybe<Scalars['String']>>>;
  stats?: Maybe<Scalars['JSONString']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type CashFlowSettingsOutput = {
  __typename?: 'CashFlowSettingsOutput';
  errors?: Maybe<Array<Maybe<Scalars['String']>>>;
  settings?: Maybe<CashFlowSettingsType>;
  success?: Maybe<Scalars['Boolean']>;
};

/**
 * The knobs an operator must be able to turn without a deploy.
 *
 * `ownPartyNames` is the one the feature cannot start without: until our own
 * names are listed, internal-transfer detection has nothing to match on, and
 * on the history that is 14 transfers showing up as both an expense and
 * revenue.
 */
export type CashFlowSettingsType = {
  __typename?: 'CashFlowSettingsType';
  internalTransferAutodetect?: Maybe<Scalars['Boolean']>;
  internalTransferWindowDays?: Maybe<Scalars['Int']>;
  ownPartyNames?: Maybe<Scalars['String']>;
  pk?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CategoryConnection = {
  __typename?: 'CategoryConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CategoryEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `Category` and its cursor. */
export type CategoryEdge = {
  __typename?: 'CategoryEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<CategoryType>;
};

export type CategoryType = {
  __typename?: 'CategoryType';
  categoryColumn?: Maybe<Scalars['String']>;
  courses: CourseFilterTypeConnection;
  id: Scalars['ID'];
  name: Scalars['String'];
};


export type CategoryTypeCoursesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  category_Name?: InputMaybe<Scalars['String']>;
  educationForm?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderByPublishDateFilter?: InputMaybe<Scalars['Boolean']>;
  readyToPublish?: InputMaybe<Scalars['Boolean']>;
  startDateFilter?: InputMaybe<Scalars['Boolean']>;
};

export type CertificateType = {
  __typename?: 'CertificateType';
  fileUrl?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  issuedAt?: Maybe<Scalars['Date']>;
  issuer: Scalars['String'];
  title: Scalars['String'];
  url: Scalars['String'];
};

export type ChangeAgreementGroupInput = {
  agreementId: Scalars['ID'];
  /** Clone the contribution schedule onto the new agreement. */
  copyContributions?: InputMaybe<Scalars['Boolean']>;
  /** Move payments dated >= effective_date to the new agreement. Linked Fakturownia invoices follow their Payment (1:1) — the bridge is not touched. */
  copyPayments?: InputMaybe<Scalars['Boolean']>;
  /** Date the move takes effect. Payments before this date stay on the old agreement; the old agreement is terminated with `terminated_date = effective_date`. */
  effectiveDate: Scalars['Date'];
  newGroupId: Scalars['ID'];
};

/**
 * Move a student from one group to another atomically.
 *
 * Created to back the "Перевести в другую группу" single-click action on
 * the new student card (`docs/fakturownia/student_card.md §6`). Replaces
 * the manual sequence of `editStudentWithAgreement` + chargeback +
 * new-agreement that finance currently has to chain by hand.
 */
export type ChangeAgreementGroupMutation = {
  __typename?: 'ChangeAgreementGroupMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
  newAgreement?: Maybe<AgreementType>;
  oldAgreement?: Maybe<AgreementType>;
  success?: Maybe<Scalars['Boolean']>;
};

export type ChangeCandidateStatus = {
  __typename?: 'ChangeCandidateStatus';
  candidate?: Maybe<FundingCandidateType>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type ChangeLessonDate = {
  __typename?: 'ChangeLessonDate';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type ChannelGroupLinkType = {
  __typename?: 'ChannelGroupLinkType';
  archived: Scalars['Boolean'];
  channelName: Scalars['String'];
  id: Scalars['ID'];
  slackChannelId: Scalars['String'];
};

/** An enumeration. */
export enum ChargebackCurrency {
  /** BYN */
  Byn = 'BYN',
  /** EUR */
  Eur = 'EUR',
  /** PLN */
  Pln = 'PLN',
  /** RUB */
  Rub = 'RUB',
  /** USD */
  Usd = 'USD'
}

export type ChargebackInput = {
  currency: Scalars['String'];
  date: Scalars['Date'];
  sum: Scalars['Float'];
};

export type ChargebackType = {
  __typename?: 'ChargebackType';
  agreement: AgreementType;
  amountByn?: Maybe<Scalars['CustomFloat']>;
  amountForeign?: Maybe<Scalars['CustomFloat']>;
  currency: ChargebackCurrency;
  date: Scalars['Date'];
  id: Scalars['ID'];
};

export type CheckStudentsDebtMutation = {
  __typename?: 'CheckStudentsDebtMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
  success?: Maybe<Scalars['Boolean']>;
};

/**
 * LMS: студент выбирает трек целью (ТЗ 0039).
 *
 * Открыто ЛЮБОМУ студенту, а не только участнику карьерного центра: трек —
 * продающая поверхность, и требовать членства значит показать её только тем,
 * кто уже выпустился.
 */
export type ChooseGrowthTrack = {
  __typename?: 'ChooseGrowthTrack';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
  trackCode?: Maybe<Scalars['String']>;
};

export type ClearCareerLessonVideo = {
  __typename?: 'ClearCareerLessonVideo';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  lesson?: Maybe<CareerLessonType>;
  success?: Maybe<Scalars['Boolean']>;
};

export type ClearGroupLessonLinkOverride = {
  __typename?: 'ClearGroupLessonLinkOverride';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  group?: Maybe<GroupType>;
  success?: Maybe<Scalars['Boolean']>;
};

/**
 * Состояние интеграции переписки по ОДНОЙ группе (ТЗ 0032).
 *
 * Главное поле — `verdict`: конкретная причина, по которой данных не видно,
 * а не набор цифр, из которых её надо выводить самому.
 */
export type CommsGroupHealthRow = {
  __typename?: 'CommsGroupHealthRow';
  channelsLinked: Scalars['Int'];
  /** Из привязанных каналов — сколько реально отдали историю. Меньше `channelsLinked` = в остальные бот не приглашён. */
  channelsMirrored: Scalars['Int'];
  groupId: Scalars['ID'];
  groupName: Scalars['String'];
  hasBotToken: Scalars['Boolean'];
  /** У ТЕКУЩЕГО менеджера сохранён личный xoxp-токен для этого воркспейса. Без него его личные переписки со студентами не зеркалятся: бот их видеть не может. */
  hasMyManagerToken: Scalars['Boolean'];
  /** Группа попадает в ежечасный прогон (последнее занятие не старше 30 дней либо занятий ещё нет). Вне окна остаётся только ручная кнопка «Обновить сообщения». */
  inSyncWindow: Scalars['Boolean'];
  lastInboundAt?: Maybe<Scalars['DateTime']>;
  lastSyncAt?: Maybe<Scalars['DateTime']>;
  mailThreads: Scalars['Int'];
  /** Участников воркспейса, за которыми стоит студент ИЛИ преподаватель. Ноль при ненулевом `membersTotal` — вся переписка считается исходящей и прочитанной, бейджи пусты. */
  membersMatched: Scalars['Int'];
  membersTotal: Scalars['Int'];
  /** Задан signing secret — события Slack приходят мгновенно. Без него синхронизация всё равно работает (ежечасно и по кнопке), но вебхук отбивается 403. */
  realtimeConfigured: Scalars['Boolean'];
  slackMessages: Scalars['Int'];
  studentsCount: Scalars['Int'];
  teamId: Scalars['String'];
  /** ok / no_workspace / workspace_disabled / no_bot_token / out_of_sync_window / no_channels / bot_not_in_channels / no_matched_members. */
  verdict: Scalars['String'];
  workspaceEnabled: Scalars['Boolean'];
  workspaceLinked: Scalars['Boolean'];
};

/** An enumeration. */
export enum CommsSyncRunStatus {
  /** Failed */
  Failed = 'FAILED',
  /** Retry */
  Retry = 'RETRY',
  /** Running */
  Running = 'RUNNING',
  /** Success */
  Success = 'SUCCESS'
}

/**
 * Один прогон синхронизации переписки — «когда в последний раз и чем
 * кончилось» (ТЗ 0032).
 */
export type CommsSyncRunType = {
  __typename?: 'CommsSyncRunType';
  errorMessage: Scalars['String'];
  finishedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  startedAt: Scalars['DateTime'];
  stats?: Maybe<Scalars['JSONString']>;
  status: CommsSyncRunStatus;
  taskName: Scalars['String'];
};

/** Состояние интеграций переписки: глобальный блок + строка на группу. */
export type CommunicationsHealth = {
  __typename?: 'CommunicationsHealth';
  gmailSyncEnabled: Scalars['Boolean'];
  groups: Array<CommsGroupHealthRow>;
  lastGmailRun?: Maybe<CommsSyncRunType>;
  lastSlackRun?: Maybe<CommsSyncRunType>;
  mailboxesEnabled: Scalars['Int'];
  /** Флаг SLACK_SYNC_ENABLED. Выключен → ежечасного прогона нет вовсе, работают только ручные кнопки. */
  slackSyncEnabled: Scalars['Boolean'];
};

export type CompanyConnection = {
  __typename?: 'CompanyConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CompanyEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `Company` and its cursor. */
export type CompanyEdge = {
  __typename?: 'CompanyEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<CompanyType>;
};

export type CompanyImageType = {
  __typename?: 'CompanyImageType';
  id: Scalars['ID'];
  image: Scalars['String'];
  studentAndCompanies: StudentAndCompaniesType;
};

export type CompanyInput = {
  comment?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  name: Scalars['String'];
  phone: Scalars['String'];
  registrationNumber: Scalars['String'];
  responsiblePerson: Scalars['String'];
};

export type CompanyType = Node & {
  __typename?: 'CompanyType';
  agreements: Array<AgreementType>;
  comment?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  phone: Scalars['String'];
  registrationNumber: Scalars['String'];
  responsiblePerson: Scalars['String'];
};

/** LMS: the student marks a lesson done, unlocking the next one. */
export type CompleteCareerLesson = {
  __typename?: 'CompleteCareerLesson';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  lessonsCompleted?: Maybe<Scalars['Int']>;
  lessonsTotal?: Maybe<Scalars['Int']>;
  reward?: Maybe<GrowthRewardType>;
  success?: Maybe<Scalars['Boolean']>;
};

/**
 * Подтвердить набор — или снять подтверждение.
 *
 * 🔴 Единственное разрешение на рассылку в домене (ТЗ 0054). Владелец:
 * «у набора должен быть статус, что он активный… она руками его делает,
 * что он активный. Это означает, что можно сделать рассылку… то есть набор
 * подтверждён».
 *
 * Отдельная мутация, а не поле в `saveFundingIntake`, по той же причине, по
 * которой подтверждение не поле в `_apply_patch`: это поступок, у него один
 * аргумент, и жать его будут из строки таблицы, где формы нет. Форма умеет
 * то же самое через `FundingIntakeInput.confirmed` — обе дороги ведут в
 * `services.intakes.confirm_intake`, второго правила не заводится.
 */
export type ConfirmFundingIntake = {
  __typename?: 'ConfirmFundingIntake';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  intake?: Maybe<FundingIntakeType>;
  success?: Maybe<Scalars['Boolean']>;
};

export type ContactEmailType = {
  __typename?: 'ContactEmailType';
  contactsPage: ContactsPageType;
  contactspage?: Maybe<ContactsPageType>;
  email: Scalars['String'];
  id: Scalars['ID'];
  title: Scalars['String'];
};

export type ContactPhoneType = {
  __typename?: 'ContactPhoneType';
  contactsPage: ContactsPageType;
  id: Scalars['ID'];
  phone: Scalars['String'];
  title: Scalars['String'];
};

export type ContactsPageType = {
  __typename?: 'ContactsPageType';
  address: Scalars['String'];
  emails: Array<ContactEmailType>;
  id: Scalars['ID'];
  mainEmail?: Maybe<ContactEmailType>;
  paymentsLogo: Array<PaymentLogoType>;
  phones: Array<ContactPhoneType>;
  registrationData: Scalars['String'];
  seoDescription: Scalars['String'];
  seoImage: Scalars['String'];
  seoKeywords: Scalars['String'];
  seoTitle: Scalars['String'];
};

export type ContributionConnection = {
  __typename?: 'ContributionConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ContributionEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `Contribution` and its cursor. */
export type ContributionEdge = {
  __typename?: 'ContributionEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<ContributionType>;
};

export type ContributionInput = {
  date: Scalars['Date'];
  /** Existing contribution of THIS agreement to update in place (pk or relay id). Omit for a new row. On updateStudentWithAgreement, existing rows whose id is absent from the list are deleted. Ignored on create. */
  id?: InputMaybe<Scalars['ID']>;
  sum: Scalars['Float'];
};

export type ContributionType = Node & {
  __typename?: 'ContributionType';
  agreement: AgreementType;
  agreementTitle?: Maybe<Scalars['String']>;
  amountByn?: Maybe<Scalars['CustomFloat']>;
  amountForeign?: Maybe<Scalars['CustomFloat']>;
  /** Покрыт ПОЛНОСТЬЮ (remainder ≈ 0). До ТЗ 0029 означало «есть хоть какое-то покрытие» — платёж на 1 PLN закрывал взнос на 2000. */
  complete: Scalars['Boolean'];
  /** Указан — возврат денег по этому взносу (отток), уменьшает покрытие. Пусто — списание плана по договору. */
  corrections: Array<PaymentCorrectionType>;
  /** Money actually received against this installment (net invoice paid totals + manual payment, deduped). */
  coveredAmount?: Maybe<Scalars['Float']>;
  date: Scalars['Date'];
  /** max(0, amount − coveredAmount) in agreement currency. */
  debt?: Maybe<Scalars['Float']>;
  delay?: Maybe<Scalars['Int']>;
  group?: Maybe<GroupsType>;
  id: Scalars['ID'];
  /** Fakturownia documents charging this installment (advance+final chains give several). */
  invoices?: Maybe<Array<Maybe<FakturowniaInvoiceType>>>;
  /** Деньги, полученные вне Fakturownia, в валюте договора. */
  manualPaidAmount: Scalars['Float'];
  manualPaidDate?: Maybe<Scalars['Date']>;
  /** Провенанс: «отмечено вручную» / «перенесено из legacy-платежа #123». */
  manualPaidNote: Scalars['String'];
  /** True when fully covered exclusively by a manual «отметить оплаченным» payment (no invoice money). */
  paidManually?: Maybe<Scalars['Boolean']>;
  /** LMS Payment that closed this scheduled installment. Null while unpaid. */
  payment?: Maybe<PaymentType>;
  person?: Maybe<Person>;
  remainder?: Maybe<Scalars['CustomFloat']>;
  /** future | awaiting | invoiced | overdue | partial | paid | paid_manual — derived on read from the linked Fakturownia invoices + the manual payment edge. */
  status?: Maybe<Scalars['String']>;
};

export type ContributionTypeConnection = {
  __typename?: 'ContributionTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ContributionTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `ContributionType` and its cursor. */
export type ContributionTypeEdge = {
  __typename?: 'ContributionTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<ContributionType>;
};

/**
 * Keyset connection over conversations — the dashboard browser and the
 * student / group / teacher correspondence panels (spec 0031).
 *
 * The sort key is `COALESCE(last_message_at, epoch)`: a conversation
 * mirrored before its first message has no `last_message_at`, and a cursor
 * over a NULL column cannot page such rows at all. Coalescing keeps them
 * pageable AND keeps them last, exactly where `nulls_last` used to put
 * them.
 */
export type ConversationConnection = {
  __typename?: 'ConversationConnection';
  edges?: Maybe<Array<ConversationEdge>>;
  pageInfo?: Maybe<MessagePageInfo>;
  /** Filtered total, independent of the cursor — the section header's counter. Counted up to a cap; see totalCountCapped. */
  totalCount: Scalars['Int'];
  /** True → there are MORE than totalCount rows and the count stopped at the cap (render «1000+»). A full COUNT over the whole conversation population would be paid on every page. */
  totalCountCapped?: Maybe<Scalars['Boolean']>;
};

export type ConversationEdge = {
  __typename?: 'ConversationEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<ConversationType>;
};

export type ConversationType = {
  __typename?: 'ConversationType';
  /** Human title: stored title (channel name / mail subject / DM counterpart) → linked student's «Фамилия Имя» → the raw external id. */
  displayTitle?: Maybe<Scalars['String']>;
  externalId: Scalars['String'];
  group?: Maybe<MethodistGroupType>;
  /** At least one INBOUND message here is not yet ticked «обработано» — the amber dot. Never looks at read state or at `status`. */
  hasUnhandled?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  kind?: Maybe<Scalars['String']>;
  lastInboundAt?: Maybe<Scalars['DateTime']>;
  lastMessageAt?: Maybe<Scalars['DateTime']>;
  lastOutboundAt?: Maybe<Scalars['DateTime']>;
  mailboxEmail: Scalars['String'];
  /** Manual handling lifecycle: open / in_progress / done. */
  status?: Maybe<Scalars['String']>;
  student?: Maybe<StudentType>;
  teacher?: Maybe<TeacherFilterType>;
  teamId: Scalars['String'];
  title: Scalars['String'];
  /** How many INBOUND messages are not yet ticked «обработано». 0 = nothing left to triage. */
  unhandledCount?: Maybe<Scalars['Int']>;
  /** Messages in this conversation not yet marked read (team-wide). 0 = fully read. */
  unreadCount?: Maybe<Scalars['Int']>;
  /** The study group this conversation belongs to: the group FK for channels, else the group owning the conversation's Slack workspace (team_id). Null for Gmail / legacy rows. */
  workspaceGroup?: Maybe<MethodistGroupType>;
};

export type CountryConnection = {
  __typename?: 'CountryConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CountryEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `Country` and its cursor. */
export type CountryEdge = {
  __typename?: 'CountryEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<CountryType>;
};

export type CountryType = {
  __typename?: 'CountryType';
  agreements: Array<AgreementType>;
  id: Scalars['ID'];
  title: Scalars['String'];
};

export type CourseBanner = {
  __typename?: 'CourseBanner';
  articlesSet: Array<ArticlesType>;
  course?: Maybe<CourseFilterType>;
  description: Scalars['String'];
  id: Scalars['ID'];
  native: Array<NativeInfoType>;
  successstoriesSet: Array<SuccessStoriesType>;
  title: Scalars['String'];
};

export type CourseCatalogPageType = {
  __typename?: 'CourseCatalogPageType';
  description: Scalars['String'];
  id: Scalars['ID'];
  seoDescription: Scalars['String'];
  seoImage: Scalars['String'];
  seoKeywords: Scalars['String'];
  seoTitle: Scalars['String'];
  title: Scalars['String'];
};

/**
 * Разбор «прошёл / не засчитано» по одному курсу — карточка участника.
 *
 * Отдаёт и ПРИЧИНУ, а не только вердикт: оператору нужно видеть, что данные
 * говорят «прошёл», а решение сотрудника это перебивает, — иначе кнопка
 * «не засчитывать» выглядит как действие в пустоту.
 */
export type CourseCompletionType = {
  __typename?: 'CourseCompletionType';
  completed: Scalars['Boolean'];
  courseId: Scalars['ID'];
  courseName: Scalars['String'];
  derived: Scalars['Boolean'];
  groupId?: Maybe<Scalars['ID']>;
  groupName: Scalars['String'];
  hasDiploma: Scalars['Boolean'];
  manualStatus: Scalars['String'];
};

export type CourseContributionPriceType = {
  __typename?: 'CourseContributionPriceType';
  amount: Scalars['Float'];
  contribution: CourseContributionType;
  currency?: Maybe<CurrencyType>;
  currencyTicker: Scalars['String'];
  id: Scalars['ID'];
};

export type CourseContributionType = {
  __typename?: 'CourseContributionType';
  course: CourseFilterType;
  description: Scalars['String'];
  id: Scalars['ID'];
  prices: Array<CourseContributionPriceType>;
};

export type CourseFilterType = Node & {
  __typename?: 'CourseFilterType';
  category?: Maybe<CategoryType>;
  ceoInfo?: Maybe<CeoInfoType>;
  contributions: Array<CourseContributionType>;
  courseBanner?: Maybe<CourseBanner>;
  courseDiscount?: Maybe<Scalars['Int']>;
  courseIcon?: Maybe<Scalars['String']>;
  courseRequirementsInfo?: Maybe<CourseRequirementsIntoType>;
  currency?: Maybe<Scalars['String']>;
  curriculumVitae?: Maybe<StudentCvType>;
  deleteAvailable?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  duration: Scalars['String'];
  educationForm?: Maybe<Scalars['String']>;
  educationprogram?: Maybe<EducationProgramType>;
  futureKnowledge?: Maybe<FutureKnowledgeType>;
  futureProfession?: Maybe<FutureProfessionType>;
  graduateFeedbacks: Array<GraduateFeedbackType>;
  graduationVideo?: Maybe<GraduationVideoType>;
  groups: MethodistGroupTypeConnection;
  id: Scalars['ID'];
  marketingModules: Array<CourseMarketingModuleType>;
  modules: Array<CourseModuleType>;
  name: Scalars['String'];
  price: Scalars['CustomFloat'];
  prices: Array<CoursePriceType>;
  publishDate: Scalars['Date'];
  readyToPublish: Scalars['Boolean'];
  salary?: Maybe<SalaryInfoType>;
  slug: Scalars['String'];
  teacherWeb?: Maybe<TeacherWebType>;
  teachers?: Maybe<TeacherFilterTypeConnection>;
  title?: Maybe<Scalars['String']>;
  videoTrailer?: Maybe<VideoTrailerType>;
};


export type CourseFilterTypeGroupsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  freePlacesGt?: InputMaybe<Scalars['Decimal']>;
  hideCompleted?: InputMaybe<Scalars['Date']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type CourseFilterTypeTeachersArgs = {
  after?: InputMaybe<Scalars['String']>;
  availability?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  course?: InputMaybe<Scalars['Decimal']>;
  first?: InputMaybe<Scalars['Int']>;
  hasDescription?: InputMaybe<Scalars['Boolean']>;
  hasInterview?: InputMaybe<Scalars['Boolean']>;
  hasPhoto?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  minRating?: InputMaybe<Scalars['Decimal']>;
  offset?: InputMaybe<Scalars['Int']>;
  siteDisplay?: InputMaybe<Scalars['Boolean']>;
};

export type CourseFilterTypeConnection = {
  __typename?: 'CourseFilterTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CourseFilterTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `CourseFilterType` and its cursor. */
export type CourseFilterTypeEdge = {
  __typename?: 'CourseFilterTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<CourseType>;
};

export type CourseLessonType = Node & {
  __typename?: 'CourseLessonType';
  courseProgram?: Maybe<EducationProgramType>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  index?: Maybe<Scalars['Int']>;
  lmsDescription: Scalars['String'];
  marketingModule?: Maybe<CourseMarketingModuleType>;
  module: CourseModuleType;
  name: Scalars['String'];
  number: Scalars['Int'];
  studentAttachments: StudentLessonAttachmentsTypeConnection;
  taskTypes: Array<Scalars['String']>;
  teacherAttachments: TeacherLessonAttachmentsTypeConnection;
};


export type CourseLessonTypeStudentAttachmentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type CourseLessonTypeTeacherAttachmentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type CourseLessonTypeConnection = {
  __typename?: 'CourseLessonTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CourseLessonTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `CourseLessonType` and its cursor. */
export type CourseLessonTypeEdge = {
  __typename?: 'CourseLessonTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<CourseLessonType>;
};

export type CourseMarketingModuleType = {
  __typename?: 'CourseMarketingModuleType';
  course: CourseFilterType;
  description: Scalars['String'];
  id: Scalars['ID'];
  lessons: CourseLessonTypeConnection;
  name: Scalars['String'];
};


export type CourseMarketingModuleTypeLessonsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type CourseModuleType = {
  __typename?: 'CourseModuleType';
  course: CourseFilterType;
  id: Scalars['ID'];
  lessons: CourseLessonTypeConnection;
  name: Scalars['String'];
  number: Scalars['Int'];
};


export type CourseModuleTypeLessonsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type CoursePriceType = {
  __typename?: 'CoursePriceType';
  amount: Scalars['Float'];
  course: CourseFilterType;
  currency?: Maybe<CurrencyType>;
  currencyTicker: Scalars['String'];
  id: Scalars['ID'];
};

/**
 * Рама курса — то, из чего построена его страница на сайте (ТЗ 0040).
 *
 * `exists=false` значит, что программы у курса нет вовсе: тогда экран должен
 * сказать это словами, а не показать три пустых поля.
 */
export type CourseProgramFrameType = {
  __typename?: 'CourseProgramFrameType';
  description: Scalars['String'];
  exists: Scalars['Boolean'];
  hours: Scalars['String'];
  marketingModules: Array<MarketingModuleType>;
  title: Scalars['String'];
};

/**
 * Занятие программы курса со сквозным номером (ТЗ 0040).
 *
 * Номер считается на лету, а не хранится: он и есть позиция в программе, и
 * отдельное поле разъезжалось бы с ней при каждой вставке занятия.
 */
export type CourseProgramLessonType = {
  __typename?: 'CourseProgramLessonType';
  lessonId: Scalars['ID'];
  lmsDescription: Scalars['String'];
  marketingModuleId?: Maybe<Scalars['ID']>;
  moduleId: Scalars['ID'];
  moduleName: Scalars['String'];
  name: Scalars['String'];
  number: Scalars['Int'];
  taskTypes: Array<Scalars['String']>;
};

export type CourseRequirementsIntoType = {
  __typename?: 'CourseRequirementsIntoType';
  course?: Maybe<CourseFilterType>;
  courseRequirements: Array<RequirementsType>;
  description: Scalars['String'];
  id: Scalars['ID'];
  title: Scalars['String'];
};

export type CourseSkillInput = {
  level?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['Int']>;
  skillId: Scalars['ID'];
  unlockLessonNumber?: InputMaybe<Scalars['Int']>;
};

/** Строка списка курсов во вкладке «Навыки»: сколько чему учит. */
export type CourseSkillSummaryType = {
  __typename?: 'CourseSkillSummaryType';
  courseId: Scalars['ID'];
  courseName: Scalars['String'];
  directionTitles: Array<Scalars['String']>;
  skillCount: Scalars['Int'];
};

/** Строка «этот курс даёт этот навык на таком уровне» (ТЗ 0039). */
export type CourseSkillType = {
  __typename?: 'CourseSkillType';
  courseId: Scalars['ID'];
  courseName: Scalars['String'];
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  level: Scalars['Int'];
  order: Scalars['Int'];
  skillCategory: Scalars['String'];
  skillId: Scalars['ID'];
  skillName: Scalars['String'];
  unlockLessonNumber?: Maybe<Scalars['Int']>;
};

export type CourseType = Node & {
  __typename?: 'CourseType';
  category?: Maybe<CategoryType>;
  ceoInfo?: Maybe<CeoInfoType>;
  contributions: Array<CourseContributionType>;
  courseBanner?: Maybe<CourseBanner>;
  courseDiscount?: Maybe<Scalars['Int']>;
  courseIcon?: Maybe<Scalars['String']>;
  courseRequirementsInfo?: Maybe<CourseRequirementsIntoType>;
  currency?: Maybe<Scalars['String']>;
  curriculumVitae?: Maybe<StudentCvType>;
  deleteAvailable?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  duration: Scalars['String'];
  educationForm?: Maybe<Scalars['String']>;
  educationprogram?: Maybe<EducationProgramType>;
  futureKnowledge?: Maybe<FutureKnowledgeType>;
  futureProfession?: Maybe<FutureProfessionType>;
  graduateFeedbacks: Array<GraduateFeedbackType>;
  graduationVideo?: Maybe<GraduationVideoType>;
  groups: MethodistGroupTypeConnection;
  id: Scalars['ID'];
  marketingModules: Array<CourseMarketingModuleType>;
  modules: Array<CourseModuleType>;
  name: Scalars['String'];
  price: Scalars['CustomFloat'];
  prices: Array<CoursePriceType>;
  publishDate: Scalars['Date'];
  readyToPublish: Scalars['Boolean'];
  salary?: Maybe<SalaryInfoType>;
  slug: Scalars['String'];
  teacherWeb?: Maybe<TeacherWebType>;
  teachers?: Maybe<TeacherFilterTypeConnection>;
  title?: Maybe<Scalars['String']>;
  videoTrailer?: Maybe<VideoTrailerType>;
};


export type CourseTypeGroupsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  freePlacesGt?: InputMaybe<Scalars['Decimal']>;
  hideCompleted?: InputMaybe<Scalars['Date']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type CourseTypeTeachersArgs = {
  after?: InputMaybe<Scalars['String']>;
  availability?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  course?: InputMaybe<Scalars['Decimal']>;
  first?: InputMaybe<Scalars['Int']>;
  hasDescription?: InputMaybe<Scalars['Boolean']>;
  hasInterview?: InputMaybe<Scalars['Boolean']>;
  hasPhoto?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  minRating?: InputMaybe<Scalars['Decimal']>;
  offset?: InputMaybe<Scalars['Int']>;
  siteDisplay?: InputMaybe<Scalars['Boolean']>;
};

export type CreateAgreementInput = {
  agreementTitle: Scalars['String'];
  companyComment?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['ID']>;
  contributions?: InputMaybe<Array<InputMaybe<ContributionInput>>>;
  countryId?: InputMaybe<Scalars['ID']>;
  currency: Scalars['String'];
  date: Scalars['Date'];
  firstLesson?: InputMaybe<Scalars['ID']>;
  groupId: Scalars['ID'];
  lastLesson?: InputMaybe<Scalars['ID']>;
  partialAttendance?: InputMaybe<Scalars['Boolean']>;
  paymentByCompany?: InputMaybe<Scalars['Boolean']>;
  promocode?: InputMaybe<Scalars['String']>;
  resident?: InputMaybe<Scalars['Boolean']>;
  startAgreementBudget?: InputMaybe<Scalars['Float']>;
  studentId: Scalars['ID'];
  usedPayables?: InputMaybe<Array<Scalars['ID']>>;
  vat?: InputMaybe<Scalars['Boolean']>;
};

export type CreateAgreementInputBase = {
  agreementTitle: Scalars['String'];
  companyComment?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['ID']>;
  contributions?: InputMaybe<Array<InputMaybe<ContributionInput>>>;
  countryId?: InputMaybe<Scalars['ID']>;
  currency: Scalars['String'];
  date: Scalars['Date'];
  firstLesson?: InputMaybe<Scalars['ID']>;
  groupId: Scalars['ID'];
  lastLesson?: InputMaybe<Scalars['ID']>;
  partialAttendance?: InputMaybe<Scalars['Boolean']>;
  paymentByCompany?: InputMaybe<Scalars['Boolean']>;
  promocode?: InputMaybe<Scalars['String']>;
  resident?: InputMaybe<Scalars['Boolean']>;
  startAgreementBudget?: InputMaybe<Scalars['Float']>;
  usedPayables?: InputMaybe<Array<Scalars['ID']>>;
  vat?: InputMaybe<Scalars['Boolean']>;
};

export type CreateAgreementMutation = {
  __typename?: 'CreateAgreementMutation';
  agreement?: Maybe<AgreementType>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type CreateBlackFridayLeadMutation = {
  __typename?: 'CreateBlackFridayLeadMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
  success?: Maybe<Scalars['Boolean']>;
};

/**
 * LMS: завести отклик.
 *
 * `duplicate` — ШТАТНЫЙ ответ, а не ошибка: повтор на ту же вакансию, пока
 * прежний отклик ещё в работе, возвращает существующую строку. Прецедент
 * домена — `erp_create_vacancy_draft`; штатная ситуация, отданная
 * исключением, читается вызывающим как сбой.
 */
export type CreateCareerApplication = {
  __typename?: 'CreateCareerApplication';
  application?: Maybe<CareerApplicationType>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  duplicate?: Maybe<Scalars['Boolean']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type CreateCompanyMutation = {
  __typename?: 'CreateCompanyMutation';
  company?: Maybe<CompanyType>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type CreateCourseMutation = {
  __typename?: 'CreateCourseMutation';
  course?: Maybe<CourseType>;
};

export type CreateDeferredPaymentsMutation = {
  __typename?: 'CreateDeferredPaymentsMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  deferredPayments?: Maybe<Array<Maybe<DeferredPaymentType>>>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type CreateExpenseCategoryMutation = {
  __typename?: 'CreateExpenseCategoryMutation';
  category?: Maybe<ExpenseCategoryType>;
  errors?: Maybe<Array<Maybe<Scalars['String']>>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type CreateGroupMutation = {
  __typename?: 'CreateGroupMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
  group?: Maybe<GroupType>;
  success?: Maybe<Scalars['Boolean']>;
};

export type CreateLeadMutation = {
  __typename?: 'CreateLeadMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type CreateLessonWhiteboardMutation = {
  __typename?: 'CreateLessonWhiteboardMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
  whiteboard?: Maybe<WhiteboardType>;
};

export type CreateManualLessonRecordingMutation = {
  __typename?: 'CreateManualLessonRecordingMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  lessonRecording?: Maybe<LessonRecordingType>;
  success?: Maybe<Scalars['Boolean']>;
};

export type CreateMaterialInput = {
  description?: InputMaybe<Scalars['String']>;
  dueDate?: InputMaybe<Scalars['Date']>;
  groupId: Scalars['ID'];
  kind: MaterialKindEnum;
  lessonId?: InputMaybe<Scalars['ID']>;
  title: Scalars['String'];
};

export type CreateMaterialMutation = {
  __typename?: 'CreateMaterialMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  material?: Maybe<MaterialType>;
  success?: Maybe<Scalars['Boolean']>;
};

export type CreateNewYearLeadMutation = {
  __typename?: 'CreateNewYearLeadMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type CreatePaymentCorrectionInput = {
  agreementId: Scalars['ID'];
  /** Positive magnitude. */
  amount: Scalars['Float'];
  currency: Scalars['String'];
  date: Scalars['Date'];
  /** Target one payment (reverse received money). Omit to correct the whole agreement / plan. */
  paymentId?: InputMaybe<Scalars['ID']>;
  reason: Scalars['String'];
};

export type CreatePaymentCorrectionMutation = {
  __typename?: 'CreatePaymentCorrectionMutation';
  correction?: Maybe<PaymentCorrectionType>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type CreatePaymentInput = {
  agreementId: Scalars['ID'];
  /** Amount in the agreement's currency. amount_byn / amount_foreign are derived from this (CurrencyService). */
  amountAgreement: Scalars['Float'];
  /** If provided, atomically link the new payment to this Contribution (the scheduled installment). Both must belong to the same agreement; the contribution must be unlinked. */
  contributionId?: InputMaybe<Scalars['ID']>;
  /** Must equal the agreement's currency, otherwise CURRENCY_MISMATCH. */
  currency: Scalars['String'];
  date: Scalars['Date'];
};

/**
 * Create a free-standing Payment on an agreement (no Fakturownia link).
 *
 * Mirrors `createPaymentForFakturowniaInvoice` but starts from the
 * agreement instead of an invoice — finance often records a payment
 * before any invoice exists. Link to an invoice later via
 * `linkFakturowniaInvoiceToPayment`.
 */
export type CreatePaymentMutation = {
  __typename?: 'CreatePaymentMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  payment?: Maybe<PaymentType>;
  success?: Maybe<Scalars['Boolean']>;
};

export type CreatePaymentsMutation = {
  __typename?: 'CreatePaymentsMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
  payments?: Maybe<Array<Maybe<PaymentType>>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type CreateStaffTaskInput = {
  agreementId?: InputMaybe<Scalars['ID']>;
  assigneeId?: InputMaybe<Scalars['ID']>;
  description?: InputMaybe<Scalars['String']>;
  dueDate?: InputMaybe<Scalars['Date']>;
  groupId?: InputMaybe<Scalars['ID']>;
  links?: InputMaybe<Array<InputMaybe<TaskLinkInput>>>;
  priority?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['Date']>;
  status?: InputMaybe<Scalars['String']>;
  studentId?: InputMaybe<Scalars['ID']>;
  subject?: InputMaybe<TaskSubjectInput>;
  title: Scalars['String'];
};

export type CreateStaffTaskMutation = {
  __typename?: 'CreateStaffTaskMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
  task?: Maybe<StaffTaskType>;
};

export type CreateStudentNoteInput = {
  body: Scalars['String'];
  groupId?: InputMaybe<Scalars['ID']>;
  pinned?: InputMaybe<Scalars['Boolean']>;
  /** neutral | positive | negative */
  sentiment?: InputMaybe<Scalars['String']>;
  studentId?: InputMaybe<Scalars['ID']>;
};

export type CreateStudentNoteMutation = {
  __typename?: 'CreateStudentNoteMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  note?: Maybe<StudentNoteType>;
  success?: Maybe<Scalars['Boolean']>;
};

export type CreateSurveyMutation = {
  __typename?: 'CreateSurveyMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
  survey?: Maybe<SurveyType>;
};

/**
 * Spin a staff task off a student's message («создать задачу из вопроса»).
 *
 * The task inherits the conversation's student/group; the assignee defaults
 * to the acting manager and must always be ERP staff. Side effects record
 * the reaction: the message is marked handled + linked to the task, and an
 * `open` conversation moves to `in_progress`. One task per message — a
 * retry / second manager gets `already_linked` instead of a duplicate.
 */
export type CreateTaskFromMessageMutation = {
  __typename?: 'CreateTaskFromMessageMutation';
  conversation?: Maybe<ConversationType>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  message?: Maybe<MessageType>;
  success?: Maybe<Scalars['Boolean']>;
  task?: Maybe<StaffTaskType>;
};

/**
 * Create a STANDALONE teacher WITHOUT any application/group assignment —
 * add «свободных» преподавателей на будущее (собеседование/курсы/рейтинг
 * заполняются на карточке). Distinct from `createUniqueTeacher`, which
 * requires an application.
 */
export type CreateTeacher = {
  __typename?: 'CreateTeacher';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
  success?: Maybe<Scalars['Boolean']>;
  teacher?: Maybe<TeacherType>;
};

export type CreateUniqueTeacher = {
  __typename?: 'CreateUniqueTeacher';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
  success?: Maybe<Scalars['Boolean']>;
  teacher?: Maybe<TeacherType>;
};

/** An enumeration. */
export enum Currencies {
  Byn = 'BYN',
  Eur = 'EUR',
  Pln = 'PLN',
  Rub = 'RUB',
  Usd = 'USD'
}

export type CurrencyType = {
  __typename?: 'CurrencyType';
  coursecontributionpriceSet: Array<CourseContributionPriceType>;
  coursepriceSet: Array<CoursePriceType>;
  id: Scalars['ID'];
  ticker: Scalars['String'];
};

export type CustomErrorType = {
  __typename?: 'CustomErrorType';
  code?: Maybe<Scalars['String']>;
  field?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
};

/** SDL: {token, success, errors, user, unarchiving, customErrors, refreshToken}. */
export type CustomObtainJsonWebToken = {
  __typename?: 'CustomObtainJSONWebToken';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
  refreshToken?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
  token?: Maybe<Scalars['String']>;
  unarchiving?: Maybe<Scalars['Boolean']>;
  user?: Maybe<UserNode>;
};

/** То же, что в `graphql_jwt`, но с нашей формой ответа (success/errors). */
export type CustomRefreshToken = {
  __typename?: 'CustomRefreshToken';
  errors?: Maybe<Scalars['ExpectedErrorType']>;
  payload?: Maybe<Scalars['GenericScalar']>;
  refreshToken?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
  token?: Maybe<Scalars['String']>;
};

/** SDL: {success, errors, customErrors}. */
export type CustomSendPasswordResetEmail = {
  __typename?: 'CustomSendPasswordResetEmail';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type CustomUserInput = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  middleName?: InputMaybe<Scalars['String']>;
  phone: Scalars['String'];
  roles: Scalars['String'];
};

export type CustomUserType = Node & {
  __typename?: 'CustomUserType';
  dateJoined: Scalars['DateTime'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  id: Scalars['ID'];
  /** Określa czy użytkownika należy uważać za aktywnego. Odznacz zamiast usuwać konto. */
  isActive: Scalars['Boolean'];
  /** Określa czy użytkownik może zalogować się do panelu administracyjnego. */
  isStaff: Scalars['Boolean'];
  /** Oznacza, że ten użytkownik ma wszystkie uprawnienia bez ich jawnego przypisywania. */
  isSuperuser: Scalars['Boolean'];
  lastLogin?: Maybe<Scalars['DateTime']>;
  lastName: Scalars['String'];
  middleName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  roles: Array<Scalars['String']>;
  student?: Maybe<StudentType>;
  teacher?: Maybe<TeacherFilterType>;
  /** Wymagana. 150 lub mniej znaków. Jedynie litery, cyfry i @/./+/-/_. */
  username: Scalars['String'];
};

/** Языковая версия текста CV — едет вместе с профилем (0072). */
export type CvLocaleInput = {
  about?: InputMaybe<Scalars['String']>;
  jobTitle?: InputMaybe<Scalars['String']>;
  language: Scalars['String'];
};

export type CvLocaleType = {
  __typename?: 'CvLocaleType';
  about: Scalars['String'];
  jobTitle: Scalars['String'];
  language: Scalars['String'];
};

/** Навык словаря, упомянутый в CV, но не оценённый студентом (0072). */
export type CvSkillSuggestionType = {
  __typename?: 'CvSkillSuggestionType';
  mentionedAs: Scalars['String'];
  skill: SkillType;
};

export type DataProcessingPolicyAgreementType = Node & {
  __typename?: 'DataProcessingPolicyAgreementType';
  agreementDate: Scalars['Date'];
  content: Scalars['String'];
  displayPage: DataProcessingPolicyType;
  file: Scalars['String'];
  /** The ID of the object */
  id: Scalars['ID'];
};

export type DataProcessingPolicyAgreementTypeConnection = {
  __typename?: 'DataProcessingPolicyAgreementTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<DataProcessingPolicyAgreementTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `DataProcessingPolicyAgreementType` and its cursor. */
export type DataProcessingPolicyAgreementTypeEdge = {
  __typename?: 'DataProcessingPolicyAgreementTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<DataProcessingPolicyAgreementType>;
};

export type DataProcessingPolicyType = {
  __typename?: 'DataProcessingPolicyType';
  actualPublicOfferAgreement?: Maybe<DataProcessingPolicyAgreementType>;
  id: Scalars['ID'];
  publicOfferAgreements: DataProcessingPolicyAgreementTypeConnection;
  seoDescription: Scalars['String'];
  seoImage: Scalars['String'];
  seoKeywords: Scalars['String'];
  seoTitle: Scalars['String'];
  title: Scalars['String'];
};


export type DataProcessingPolicyTypePublicOfferAgreementsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type DayOfClassInput = {
  endTime?: InputMaybe<Scalars['Time']>;
  startTime?: InputMaybe<Scalars['Time']>;
  weekDay: Scalars['Int'];
};

export type DayOfClassType = {
  __typename?: 'DayOfClassType';
  endTime: Scalars['Time'];
  group: MethodistGroupType;
  id: Scalars['ID'];
  startTime: Scalars['Time'];
  weekDay: Scalars['Int'];
};

/**
 * Выключить оператора у кандидата. Причина обязательна.
 *
 * Единственное, что прекращает письма конкретного оператора (кроме
 * терминального статуса кандидата). Строку связи не удаляет — она остаётся
 * журналом и объясняет, почему к оператору больше не ходят.
 */
export type DeactivateCandidateOperator = {
  __typename?: 'DeactivateCandidateOperator';
  candidate?: Maybe<FundingCandidateType>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
};

/**
 * One student with at least one overdue unpaid instalment (corrections /
 * transfer-aware). `currently_blocked` lets the ERP render the toggle state
 * without a second query.
 */
export type DebtorCandidateType = {
  __typename?: 'DebtorCandidateType';
  currentlyBlocked: Scalars['Boolean'];
  maxOverdueDays: Scalars['Int'];
  overdueAmount: Scalars['Float'];
  overdueInvoiceCount: Scalars['Int'];
  student: StudentType;
};

export type DeferredPaymentConnection = {
  __typename?: 'DeferredPaymentConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<DeferredPaymentEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An enumeration. */
export enum DeferredPaymentCurrency {
  /** BYN */
  Byn = 'BYN',
  /** EUR */
  Eur = 'EUR',
  /** PLN */
  Pln = 'PLN',
  /** RUB */
  Rub = 'RUB',
  /** USD */
  Usd = 'USD'
}

/** A Relay edge containing a `DeferredPayment` and its cursor. */
export type DeferredPaymentEdge = {
  __typename?: 'DeferredPaymentEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<DeferredPaymentType>;
};

export type DeferredPaymentInput = {
  agreementTitle?: InputMaybe<Scalars['String']>;
  currency?: InputMaybe<Scalars['String']>;
  date: Scalars['Date'];
  deferredPaymentId?: InputMaybe<Scalars['ID']>;
  studentFullname?: InputMaybe<Scalars['String']>;
  sum?: InputMaybe<Scalars['Float']>;
  userInput: Scalars['String'];
};

export type DeferredPaymentType = Node & {
  __typename?: 'DeferredPaymentType';
  agreementCurrency?: Maybe<Scalars['String']>;
  agreementId?: Maybe<Scalars['Int']>;
  agreementTitle?: Maybe<Scalars['String']>;
  currency?: Maybe<DeferredPaymentCurrency>;
  date: Scalars['Date'];
  id: Scalars['ID'];
  studentFullname?: Maybe<Scalars['String']>;
  sum?: Maybe<Scalars['CustomFloat']>;
  userInput: Scalars['String'];
};

export type DeleteCareerApplication = {
  __typename?: 'DeleteCareerApplication';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  deleted?: Maybe<Scalars['Boolean']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type DeleteCourseMutation = {
  __typename?: 'DeleteCourseMutation';
  course?: Maybe<CourseType>;
};

export type DeleteExpenseMutation = {
  __typename?: 'DeleteExpenseMutation';
  errors?: Maybe<Array<Maybe<Scalars['String']>>>;
  success?: Maybe<Scalars['Boolean']>;
};

/**
 * Удалить заявку-дубль или тестовую (задача #95).
 *
 * Отказывает (`candidate_in_use`), если человеку уже писали или строка
 * пришла из Notion, — тогда архив: `saveFundingCandidate(id, input:
 * {isArchived: true})` меняет только этот флаг. Правила — в
 * `services.candidates.delete_candidate`.
 */
export type DeleteFundingCandidate = {
  __typename?: 'DeleteFundingCandidate';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  deletedId?: Maybe<Scalars['ID']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type DeleteFundingIntake = {
  __typename?: 'DeleteFundingIntake';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type DeleteGroupMutation = {
  __typename?: 'DeleteGroupMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type DeleteMaterialMutation = {
  __typename?: 'DeleteMaterialMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type DeletePaymentCorrectionMutation = {
  __typename?: 'DeletePaymentCorrectionMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
};

/**
 * Delete a Payment. Refuses if a FakturowniaInvoice is still linked —
 * the operator must call `unlinkFakturowniaInvoice` first so the invoice
 * isn't left orphaned with `payment_id → DELETED`.
 */
export type DeletePaymentMutation = {
  __typename?: 'DeletePaymentMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type DeletePlannedPaymentOutput = {
  __typename?: 'DeletePlannedPaymentOutput';
  errors?: Maybe<Array<Maybe<Scalars['String']>>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type DeleteStaffTaskCommentMutation = {
  __typename?: 'DeleteStaffTaskCommentMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
  task?: Maybe<StaffTaskType>;
};

export type DeleteStaffTaskMutation = {
  __typename?: 'DeleteStaffTaskMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
};

/**
 * Detach a diploma. The S3 object is left in place deliberately — a
 * student may hold a live signed URL, and a leaked object beats a document
 * that vanished mid-download. The orphaned key goes to the audit log.
 */
export type DeleteStudentDiplomaMutation = {
  __typename?: 'DeleteStudentDiplomaMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type DeleteStudentNoteMutation = {
  __typename?: 'DeleteStudentNoteMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type DeleteSurveyAssignmentMutation = {
  __typename?: 'DeleteSurveyAssignmentMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type DeleteTeacherApplication = {
  __typename?: 'DeleteTeacherApplication';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
  success?: Maybe<Scalars['Boolean']>;
};

/** Remove the row AND the S3 object — this is the right-to-erasure path. */
export type DeleteTeacherDocument = {
  __typename?: 'DeleteTeacherDocument';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
  teacherId?: Maybe<Scalars['ID']>;
};

/**
 * Remove the row AND the S3 objects.
 *
 * Deliberately unlike the diploma rule (which leaves the object because a
 * student may hold a live signed URL): this is candidate personal data under a
 * retention policy, so erasure is the point.
 */
export type DeleteTeacherInterview = {
  __typename?: 'DeleteTeacherInterview';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
  teacherId?: Maybe<Scalars['ID']>;
};

/**
 * Hard-delete a draft/rejected vacancy. Anything further along refuses
 * with `vacancy_locked` and points at the archive — see
 * `services.vacancies.delete_vacancy` for why the fence is this narrow.
 */
export type DeleteVacancy = {
  __typename?: 'DeleteVacancy';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  deletedInteractions?: Maybe<Scalars['Int']>;
  ok?: Maybe<Scalars['Boolean']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type DeleteZoomRecordingMutation = {
  __typename?: 'DeleteZoomRecordingMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
  zoomRecording?: Maybe<ZoomRecordingType>;
};

/**
 * Удалить пачку записей одним подтверждением (ТЗ 0043).
 *
 * До этого удаление было поштучным и требовало НАБРАТЬ РУКАМИ строку
 * «DELETE <pk>» на каждую запись. Чистка десятка видео превращалась в десять
 * диалогов с печатью идентификатора, и ей просто не пользовались.
 *
 * Пакет не падает целиком из-за одной проблемной строки: каждая получает свой
 * исход, и оператор видит, что именно не ушло и почему.
 */
export type DeleteZoomRecordingsMutation = {
  __typename?: 'DeleteZoomRecordingsMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  queued: Scalars['Int'];
  rows: Array<ZoomBulkDeleteRowType>;
  skipped: Scalars['Int'];
  success?: Maybe<Scalars['Boolean']>;
};

export type DemoType = {
  __typename?: 'DemoType';
  totalCount?: Maybe<Scalars['Int']>;
};

/** Снять анкету с урока. */
export type DetachCareerExerciseTemplate = {
  __typename?: 'DetachCareerExerciseTemplate';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  lesson?: Maybe<CareerLessonType>;
  success?: Maybe<Scalars['Boolean']>;
};

export type DiplomaCandidateType = {
  __typename?: 'DiplomaCandidateType';
  fullName?: Maybe<Scalars['String']>;
  student: DiplomaStudentType;
};

export type DiplomaDownloadUrlType = {
  __typename?: 'DiplomaDownloadUrlType';
  expiresAt: Scalars['DateTime'];
  url: Scalars['String'];
};

/** An enumeration. */
export enum DiplomaLanguageEnum {
  En = 'EN',
  Pl = 'PL'
}

export type DiplomaMatchPreviewType = {
  __typename?: 'DiplomaMatchPreviewType';
  rows: Array<DiplomaMatchRowType>;
  summary: DiplomaMatchSummaryType;
  unmatchedStudents: Array<UnmatchedStudentType>;
};

/**
 * One dry-run match result. `file_name` is the join key back to the
 * client's File objects — the commit sends explicit ids, never a match.
 */
export type DiplomaMatchRowType = {
  __typename?: 'DiplomaMatchRowType';
  candidates: Array<DiplomaCandidateType>;
  confidence?: Maybe<Scalars['Float']>;
  fileName: Scalars['String'];
  language?: Maybe<DiplomaLanguageEnum>;
  matchedBy?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  student?: Maybe<DiplomaStudentType>;
  /** Non-null ⇒ committing this row OVERWRITES an existing diploma. The commit refuses unless the operator confirmed that specific row. */
  wouldReplace?: Maybe<DiplomaType>;
};

export type DiplomaMatchSummaryType = {
  __typename?: 'DiplomaMatchSummaryType';
  ambiguous: Scalars['Int'];
  duplicates: Scalars['Int'];
  matched: Scalars['Int'];
  noMatch: Scalars['Int'];
  total: Scalars['Int'];
  willReplace: Scalars['Int'];
};

/** Minimal student identity for the ERP diplomas table. */
export type DiplomaStudentType = {
  __typename?: 'DiplomaStudentType';
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lastName?: Maybe<Scalars['String']>;
};

/** ERP view of one attached diploma. No file URL — see module docstring. */
export type DiplomaType = {
  __typename?: 'DiplomaType';
  contentType?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  language: DiplomaLanguageEnum;
  originalName?: Maybe<Scalars['String']>;
  pk?: Maybe<Scalars['Int']>;
  sizeBytes?: Maybe<Scalars['Int']>;
  source?: Maybe<Scalars['String']>;
  uploadedAt?: Maybe<Scalars['DateTime']>;
  uploadedByName?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['Int']>;
};

/** One bank row that explains a document. */
export type DocumentCashFlowRowType = {
  __typename?: 'DocumentCashFlowRowType';
  accountName?: Maybe<Scalars['String']>;
  amount?: Maybe<Scalars['Float']>;
  bookedAt?: Maybe<Scalars['Date']>;
  confidence?: Maybe<Scalars['Int']>;
  counterpartyName?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  matchSource?: Maybe<Scalars['String']>;
  pk?: Maybe<Scalars['Int']>;
};

/**
 * «Где эти деньги в банке» for one invoice / expense / payment.
 *
 * A root query rather than a field on `FakturowniaInvoiceType` and friends:
 * those types are shared by both frontends and several features, and widening
 * them for this would churn their generated hooks for consumers that never
 * asked. This is additive and reachable from any card.
 *
 * `status` is the honest three-way answer, because «пары в банке нет» is a
 * legitimate outcome — 61 % of the expense side is card payments with no
 * document at all, and pretending otherwise would make every SaaS charge look
 * like a problem.
 */
export type DocumentCashFlowType = {
  __typename?: 'DocumentCashFlowType';
  rows?: Maybe<Array<Maybe<DocumentCashFlowRowType>>>;
  settlementBookedAt?: Maybe<Scalars['Date']>;
  settlementProvider?: Maybe<Scalars['String']>;
  settlementRef?: Maybe<Scalars['String']>;
  /** linked — есть банковские строки; in_settlement — пришло в составе расчёта шлюза; none — пары в банке не найдено. */
  status?: Maybe<Scalars['String']>;
  totalPln?: Maybe<Scalars['Float']>;
};

export type DuplicateSurveyMutation = {
  __typename?: 'DuplicateSurveyMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
  survey?: Maybe<SurveyType>;
};

export type EditStaffTaskCommentMutation = {
  __typename?: 'EditStaffTaskCommentMutation';
  comment?: Maybe<StaffTaskCommentType>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type EducationProgramType = {
  __typename?: 'EducationProgramType';
  course: CourseFilterType;
  description: Scalars['String'];
  id: Scalars['ID'];
  lessons: CourseLessonTypeConnection;
  numberOfHours: Scalars['String'];
  title: Scalars['String'];
};


export type EducationProgramTypeLessonsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type EducationType = {
  __typename?: 'EducationType';
  degree: Scalars['String'];
  endMonth?: Maybe<Scalars['Int']>;
  endYear?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  institution: Scalars['String'];
  specialization: Scalars['String'];
  startMonth?: Maybe<Scalars['Int']>;
  startYear?: Maybe<Scalars['Int']>;
};

export type EmploymentInputType = {
  individualEntrepreneur?: InputMaybe<IndividualEntrepreneurInput>;
  legalEntity?: InputMaybe<LegalEntityInput>;
  naturalPerson?: InputMaybe<NaturalPersonInput>;
  selfEmployed?: InputMaybe<SelfEmployedInput>;
};

export type EmploymentType = IndividualEntrepreneurType | LegalEntityType | NaturalPersonType | SelfEmployedType;

/** An enumeration. */
export enum EmploymentTypes {
  /** individual_entrepreneur */
  Ie = 'IE',
  /** legal_entity */
  Le = 'LE',
  /** natural_person */
  Np = 'NP',
  /** self_employed */
  Se = 'SE'
}

/** Add students and/or a whole graduating group to the centre. */
export type EnrollCareerMembers = {
  __typename?: 'EnrollCareerMembers';
  created?: Maybe<Scalars['Int']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  reactivated?: Maybe<Scalars['Int']>;
  skipped?: Maybe<Scalars['Int']>;
  success?: Maybe<Scalars['Boolean']>;
};

/** An enumeration. */
export enum ExchangeRateCurrency {
  /** BYN */
  Byn = 'BYN',
  /** EUR */
  Eur = 'EUR',
  /** PLN */
  Pln = 'PLN',
  /** RUB */
  Rub = 'RUB',
  /** USD */
  Usd = 'USD'
}

export type ExchangeRateMutationOutput = {
  __typename?: 'ExchangeRateMutationOutput';
  errors?: Maybe<Array<Maybe<Scalars['String']>>>;
  exchangeRate?: Maybe<ExchangeRateType>;
  success?: Maybe<Scalars['Boolean']>;
};

export type ExchangeRateType = {
  __typename?: 'ExchangeRateType';
  comment: Scalars['String'];
  createdAt: Scalars['DateTime'];
  currency: ExchangeRateCurrency;
  effectiveFrom: Scalars['Date'];
  id: Scalars['ID'];
  pk?: Maybe<Scalars['Int']>;
  rateToPln?: Maybe<Scalars['Float']>;
};

/** Одна цель записи в резюме и типы полей, которые она принимает. */
export type ExerciseBindingType = {
  __typename?: 'ExerciseBindingType';
  fieldTypes: Array<Scalars['String']>;
  isCollection: Scalars['Boolean'];
  label: Scalars['String'];
  needsLanguage: Scalars['Boolean'];
  subFields: Array<Scalars['String']>;
  value: Scalars['String'];
};

/** Один тип поля из словаря конструктора (ТЗ 0039). */
export type ExerciseFieldKindType = {
  __typename?: 'ExerciseFieldKindType';
  hasOptions: Scalars['Boolean'];
  label: Scalars['String'];
  value: Scalars['String'];
};

/**
 * Словарь конструктора анкет (ТЗ 0039).
 *
 * 🔴 Существует ради ОДНОГО: чтобы матрица «какой тип поля какая привязка
 * принимает» жила в одном месте. Скопируй её в ERP руками — и через месяц
 * конструктор начнёт предлагать привязку, которую сервер отбивает, причём
 * молча для того, кто её выбрал.
 */
export type ExerciseVocabularyType = {
  __typename?: 'ExerciseVocabularyType';
  bindings: Array<ExerciseBindingType>;
  fieldTypes: Array<ExerciseFieldKindType>;
  maxFields: Scalars['Int'];
  maxOptions: Scalars['Int'];
};

export type ExistEmploymentInputType = {
  individualEntrepreneur?: InputMaybe<ExistIndividualEntrepreneurInput>;
  legalEntity?: InputMaybe<ExistLegalEntityInput>;
  naturalPerson?: InputMaybe<ExistNaturalPersonInput>;
  selfEmployed?: InputMaybe<ExistSelfEmployedInput>;
};

export type ExistIndividualEntrepreneurInput = {
  accountNumber: Scalars['String'];
  bankTitle: Scalars['String'];
  bic: Scalars['String'];
  existId?: InputMaybe<Scalars['ID']>;
  inn: Scalars['String'];
  registrationAddress: Scalars['String'];
};

export type ExistLegalEntityInput = {
  accountNumber: Scalars['String'];
  bankTitle: Scalars['String'];
  bic: Scalars['String'];
  existId?: InputMaybe<Scalars['ID']>;
  inn: Scalars['String'];
  registrationAddress: Scalars['String'];
  tittle: Scalars['String'];
};

export type ExistNaturalPersonInput = {
  accountNumber: Scalars['String'];
  bankTitle: Scalars['String'];
  bic: Scalars['String'];
  existId?: InputMaybe<Scalars['ID']>;
  nationality: Scalars['ID'];
  passportNumber: Scalars['String'];
  registrationAddress: Scalars['String'];
};

export type ExistSelfEmployedInput = {
  accountNumber: Scalars['String'];
  bankTitle: Scalars['String'];
  bic: Scalars['String'];
  existId?: InputMaybe<Scalars['ID']>;
  inn: Scalars['String'];
  nationality: Scalars['ID'];
  passportNumber: Scalars['String'];
  registrationAddress: Scalars['String'];
};

/**
 * One row of an `expense_aggregates` response.
 *
 * `group` carries the bucket key — a category slug, an ISO month
 * (`YYYY-MM`) or a legal-entity id — depending on the query's
 * `group_by` parameter. `total` is the PLN sum of `amount_pln` (the FX
 * cache) in that bucket, so multi-currency rows aggregate correctly.
 */
export type ExpenseAggregateRow = {
  __typename?: 'ExpenseAggregateRow';
  count?: Maybe<Scalars['Int']>;
  group?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Float']>;
};

export type ExpenseCategoryType = {
  __typename?: 'ExpenseCategoryType';
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  name: Scalars['String'];
  pk?: Maybe<Scalars['Int']>;
  slug: Scalars['String'];
};

/** An enumeration. */
export enum ExpenseCurrency {
  /** BYN */
  Byn = 'BYN',
  /** EUR */
  Eur = 'EUR',
  /** PLN */
  Pln = 'PLN',
  /** RUB */
  Rub = 'RUB',
  /** USD */
  Usd = 'USD'
}

export type ExpenseInput = {
  amount: Scalars['Float'];
  categorySlug?: InputMaybe<Scalars['String']>;
  counterpartyName?: InputMaybe<Scalars['String']>;
  counterpartyTaxNo?: InputMaybe<Scalars['String']>;
  currency: Scalars['String'];
  date: Scalars['Date'];
  description?: InputMaybe<Scalars['String']>;
  documentUrl?: InputMaybe<Scalars['String']>;
  legalEntityId?: InputMaybe<Scalars['ID']>;
  notes?: InputMaybe<Scalars['String']>;
  paidAt?: InputMaybe<Scalars['Date']>;
  /** none | weekly | monthly (default none). */
  recurrence?: InputMaybe<Scalars['String']>;
  /** 1–31 for monthly recurrence. */
  recurrenceDay?: InputMaybe<Scalars['Int']>;
  recurrenceUntil?: InputMaybe<Scalars['Date']>;
  /** Link a received Fakturownia invoice — prefills and locks amount/currency/date/counterparty from it, sets source='fakturownia'. */
  relatedFakturowniaInvoiceId?: InputMaybe<Scalars['ID']>;
  relatedGroupId?: InputMaybe<Scalars['ID']>;
  relatedTeacherId?: InputMaybe<Scalars['ID']>;
  /** planned | confirmed | paid | cancelled (default planned). */
  status?: InputMaybe<Scalars['String']>;
};

export type ExpenseMutationOutput = {
  __typename?: 'ExpenseMutationOutput';
  errors?: Maybe<Array<Maybe<Scalars['String']>>>;
  expense?: Maybe<ExpenseType>;
  success?: Maybe<Scalars['Boolean']>;
};

/** An enumeration. */
export enum ExpenseRecurrence {
  /** Monthly */
  Monthly = 'MONTHLY',
  /** Brak */
  None = 'NONE',
  /** Weekly */
  Weekly = 'WEEKLY'
}

/** An enumeration. */
export enum ExpenseSource {
  /** Fakturownia */
  Fakturownia = 'FAKTUROWNIA',
  /** Manual */
  Manual = 'MANUAL'
}

/** An enumeration. */
export enum ExpenseStatus {
  /** Cancelled */
  Cancelled = 'CANCELLED',
  /** Confirmed */
  Confirmed = 'CONFIRMED',
  /** Paid */
  Paid = 'PAID',
  /** Planned */
  Planned = 'PLANNED'
}

export type ExpenseType = {
  __typename?: 'ExpenseType';
  amount?: Maybe<Scalars['Float']>;
  /** FX cache of `amount` converted to PLN at `date`. Null when no ExchangeRate exists for the currency. */
  amountPln?: Maybe<Scalars['Float']>;
  category?: Maybe<ExpenseCategoryType>;
  /** The linked Fakturownia corrective invoice's `correction_reason`, when this is a correction. */
  correctionReason?: Maybe<Scalars['String']>;
  /** Supplier / recipient name (free-text) */
  counterpartyName: Scalars['String'];
  /** NIP / УНП / VAT — optional */
  counterpartyTaxNo: Scalars['String'];
  createdAt: Scalars['DateTime'];
  currency: ExpenseCurrency;
  /** Document/issue date */
  date: Scalars['Date'];
  description: Scalars['String'];
  documentUrl?: Maybe<Scalars['String']>;
  /** When this bill is due — the linked cost invoice's `payment_to`. Null for a manual expense: no document, no deadline to promise. */
  dueAt?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  /** True when this expense mirrors a Fakturownia corrective invoice (kind='correction'). The amount is signed (usually negative) so the original and its correction net out; a metadata-only correction carries amount 0. */
  isCorrection?: Maybe<Scalars['Boolean']>;
  /** Due date passed and still not paid. Computed here rather than in the browser so «overdue» means the same thing to every viewer regardless of their clock or timezone. */
  isOverdue?: Maybe<Scalars['Boolean']>;
  notes: Scalars['String'];
  /** When the money actually left our account (may differ from `date`). */
  paidAt?: Maybe<Scalars['Date']>;
  pk?: Maybe<Scalars['Int']>;
  /** none = one-off; weekly steps +7 days from `date`; monthly repeats on `recurrence_day`. */
  recurrence: ExpenseRecurrence;
  /** 1–31 for monthly recurrence; clamped to the last day of short months. Ignored for weekly (uses `date.day`). */
  recurrenceDay?: Maybe<Scalars['Int']>;
  /** Inclusive end; empty means open-ended (until changed). */
  recurrenceUntil?: Maybe<Scalars['Date']>;
  /** Set for rows mirrored from a Fakturownia cost document. Acts as the idempotency key for the bridge. */
  relatedFakturowniaInvoice?: Maybe<FakturowniaInvoiceType>;
  /** Optional — when the spend belongs to a specific group (teacher payout per group, group materials, etc.) */
  relatedGroup?: Maybe<MethodistGroupType>;
  relatedTeacher?: Maybe<TeacherFilterType>;
  source: ExpenseSource;
  /** Lifecycle status, for parity with the payment calendar. */
  status: ExpenseStatus;
  updatedAt: Scalars['DateTime'];
};

/**
 * Preflight verdict — «can we issue for this installment, and if not why».
 *
 * Backed by the SAME `services.billability.check_billability` the mutation
 * and the group job call, so the greyed-out button and the server's answer
 * can never disagree.
 */
export type FakturowniaBillabilityType = {
  __typename?: 'FakturowniaBillabilityType';
  agreementId?: Maybe<Scalars['Int']>;
  amount?: Maybe<Scalars['Float']>;
  billable: Scalars['Boolean'];
  buyerAddress?: Maybe<Scalars['String']>;
  buyerEmail?: Maybe<Scalars['String']>;
  buyerName?: Maybe<Scalars['String']>;
  buyerTaxNo?: Maybe<Scalars['String']>;
  contributionId?: Maybe<Scalars['Int']>;
  courseName?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
  groupName?: Maybe<Scalars['String']>;
  /** Which buyer fields are blank, for MISSING_BUYER_*. */
  missingFields?: Maybe<Array<Scalars['String']>>;
  paymentTo?: Maybe<Scalars['Date']>;
  /** Rendered line-item preview — exactly what will be printed on the document. */
  positionName?: Maybe<Scalars['String']>;
  /** Machine code, empty when billable. */
  reason?: Maybe<Scalars['String']>;
  studentName?: Maybe<Scalars['String']>;
  /** The VAT rate that WILL be sent, from settings — e.g. '23' or 'zw'. Lets the UI show the real rate instead of a hardcoded chip. */
  taxRate?: Maybe<Scalars['String']>;
};

export type FakturowniaBillingJobEnqueueOutput = {
  __typename?: 'FakturowniaBillingJobEnqueueOutput';
  billableCount?: Maybe<Scalars['Int']>;
  errorCode?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<Scalars['String']>>>;
  job?: Maybe<FakturowniaBillingJobType>;
  skippedCount?: Maybe<Scalars['Int']>;
  success?: Maybe<Scalars['Boolean']>;
  total?: Maybe<Scalars['Int']>;
};

export type FakturowniaBillingJobRowType = {
  __typename?: 'FakturowniaBillingJobRowType';
  agreement: AgreementType;
  amount?: Maybe<Scalars['Float']>;
  contribution?: Maybe<ContributionType>;
  currency: Scalars['String'];
  id: Scalars['ID'];
  invoice?: Maybe<FakturowniaInvoiceType>;
  invoiceNumber?: Maybe<Scalars['String']>;
  issuedAt?: Maybe<Scalars['DateTime']>;
  job: FakturowniaBillingJobType;
  pk?: Maybe<Scalars['Int']>;
  reason?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  studentName?: Maybe<Scalars['String']>;
  viewUrl?: Maybe<Scalars['String']>;
};

export type FakturowniaBillingJobType = {
  __typename?: 'FakturowniaBillingJobType';
  celeryTaskId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<CustomUserType>;
  errorMessage: Scalars['String'];
  failedCount: Scalars['Int'];
  finishedAt?: Maybe<Scalars['DateTime']>;
  group: MethodistGroupType;
  id: Scalars['ID'];
  issuedCount: Scalars['Int'];
  paymentTo?: Maybe<Scalars['Date']>;
  pk?: Maybe<Scalars['Int']>;
  rows?: Maybe<Array<FakturowniaBillingJobRowType>>;
  skippedCount: Scalars['Int'];
  startedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<Scalars['String']>;
  total: Scalars['Int'];
};

export type FakturowniaGroupBillingPreviewType = {
  __typename?: 'FakturowniaGroupBillingPreviewType';
  billableCount: Scalars['Int'];
  rows: Array<FakturowniaBillabilityType>;
  skippedCount: Scalars['Int'];
  total: Scalars['Int'];
};

/**
 * One bucket of `fakturownia_invoice_aggregates`.
 *
 * Phase 4 contract: every monetary value here is in **PLN (zł)**. The
 * project is PL-only and all invoice amounts come from Fakturownia in
 * złoty; we no longer compute or surface a separate BYN-converted total.
 * `total_outstanding` excludes paid invoices (status='paid' → 0).
 */
export type FakturowniaInvoiceAggregateRow = {
  __typename?: 'FakturowniaInvoiceAggregateRow';
  count?: Maybe<Scalars['Int']>;
  /** Bucket key — format depends on group_by */
  group?: Maybe<Scalars['String']>;
  totalGross?: Maybe<Scalars['Float']>;
  totalOutstanding?: Maybe<Scalars['Float']>;
  totalPaid?: Maybe<Scalars['Float']>;
};

/** An enumeration. */
export enum FakturowniaInvoiceDirection {
  /** Issued (we billed) */
  Issued = 'ISSUED',
  /** Received (we were billed) */
  Received = 'RECEIVED'
}

/** An enumeration. */
export enum FakturowniaInvoiceGroupMatchSource {
  /** Auto */
  Auto = 'AUTO',
  /** Manual */
  Manual = 'MANUAL',
  /** Brak */
  None = 'NONE'
}

/** An enumeration. */
export enum FakturowniaInvoiceMatchStatus {
  /** Auto matched */
  Auto = 'AUTO',
  /** Manually matched */
  Manual = 'MANUAL',
  /** Not applicable */
  NotApplicable = 'NOT_APPLICABLE',
  /** Unmatched */
  Unmatched = 'UNMATCHED'
}

export type FakturowniaInvoiceType = {
  __typename?: 'FakturowniaInvoiceType';
  /** Fakturownia's `accounting_kind` — purchases / media / salary / fuel / fixed_assets / expenses / ... */
  accountingKind: Scalars['String'];
  /** Reverse relation — advance invoices under this estimate (children with kind='advance'). */
  advances?: Maybe<Array<Maybe<FakturowniaInvoiceType>>>;
  /** Convenience shortcut for `payment.agreement` — the договор this invoice is part of. Null when payment is null. Use this for grouping invoices on a student's card without resolving Payment first. */
  agreement?: Maybe<AgreementType>;
  /** On issued invoices = the student / customer. On received invoices buyer/seller swap visually but stay stable in JSON — here `buyer_*` carries the supplier. */
  buyerEmail: Scalars['String'];
  buyerName: Scalars['String'];
  buyerTaxNo: Scalars['String'];
  /** The installment this document charges (N:1). Set by the sync auto-matcher or the linkInvoiceToContribution mutation. */
  contribution?: Maybe<ContributionType>;
  /** none | auto | manual — manual pins the link, the auto-matcher never re-points it. */
  contributionMatchSource?: Maybe<Scalars['String']>;
  correctionReason: Scalars['String'];
  /** Reverse relation — correction invoices amending this one (children with kind='correction'). */
  corrections?: Maybe<Array<Maybe<FakturowniaInvoiceType>>>;
  createdAt: Scalars['DateTime'];
  currency: Scalars['String'];
  direction: FakturowniaInvoiceDirection;
  fakturowniaId: Scalars['Int'];
  /** Mirror of Fakturownia's /payments.json rows for this invoice. Fakturownia can split a single invoice across several receipt records (deposit + balance, etc.); they all show up here. */
  fakturowniaPayments?: Maybe<Array<Maybe<FakturowniaPaymentType>>>;
  fakturowniaUpdatedAt?: Maybe<Scalars['DateTime']>;
  /** Reverse relation — the closing 'final' invoice under this estimate, if it has been issued (first child with kind='final'). */
  finalInvoice?: Maybe<FakturowniaInvoiceType>;
  /** Which chain links this invoice to a group. CANONICAL = payment.agreement.group; LEGACY_LINKED_GROUP = only the deprecated linked_group FK. Frontend uses this to badge rows still backed by the legacy mirror during the Phase-13 rollout (see §G7). */
  groupFilterSource?: Maybe<GroupFilterSourceEnum>;
  groupMatchSource: FakturowniaInvoiceGroupMatchSource;
  id: Scalars['ID'];
  /** kind=='advance' — partial-payment tax invoice that's part of an estimate chain. */
  isAdvance?: Maybe<Scalars['Boolean']>;
  /** Shortcut for kind=='correction'. Frontend uses this to tag the row as «correction to FV/N» visually. */
  isCorrection?: Maybe<Scalars['Boolean']>;
  /** kind in (estimate, client_order) — the chain root / order document. Informational, not summed in aggregates. */
  isEstimate?: Maybe<Scalars['Boolean']>;
  /** kind=='final' — closing tax invoice that pairs with advance(s) under the same estimate. */
  isFinal?: Maybe<Scalars['Boolean']>;
  /** True for estimate / client_order / proforma — informational documents excluded from revenue sums. */
  isQuotation?: Maybe<Scalars['Boolean']>;
  issueDate?: Maybe<Scalars['Date']>;
  /** vat / proforma / correction / bill / receipt / advance / final / ... */
  kind: Scalars['String'];
  linkedAt?: Maybe<Scalars['DateTime']>;
  /** DEPRECATED: use invoice.payment.agreement.group. */
  linkedGroup?: Maybe<MethodistGroupType>;
  /** DEPRECATED: use invoice.payment.agreement.student. */
  linkedStudent?: Maybe<StudentType>;
  matchStatus: FakturowniaInvoiceMatchStatus;
  /** price_gross after netting child correction invoices. */
  netGross?: Maybe<Scalars['Float']>;
  /** paid after netting refunds on child corrections. */
  netPaid?: Maybe<Scalars['Float']>;
  number: Scalars['String'];
  outstanding?: Maybe<Scalars['Float']>;
  paid?: Maybe<Scalars['Float']>;
  /** When the money actually arrived, per Fakturownia. Not the same as `issue_date` — measured on the history they differ for 82 % of paid invoices. It was always present in `raw_payload`; the separate `/payments.json` mirror returns nothing for this account, so this is the only receipt date we have. */
  paidDate?: Maybe<Scalars['Date']>;
  /** Points to the Fakturownia document this one references. Set for kind=correction (→ amended doc) and for kind=advance/final (→ parent estimate). */
  parentInvoice?: Maybe<FakturowniaInvoiceType>;
  /** 1:1 link to the LMS students.Payment that this invoice settles. Null when the invoice hasn't been reconciled yet — operators close that gap via the createPaymentForFakturowniaInvoice / linkFakturowniaInvoiceToPayment mutations. */
  payment?: Maybe<PaymentType>;
  paymentTo?: Maybe<Scalars['Date']>;
  /** Online-payment URL, when the document has one. Often null — only ~16% of issued invoices carry it. */
  paymentUrl?: Maybe<Scalars['String']>;
  pk?: Maybe<Scalars['Int']>;
  priceGross?: Maybe<Scalars['Float']>;
  priceNet?: Maybe<Scalars['Float']>;
  /** Why the auto-provisioner refused to create the hidden Payment for this paid invoice (CURRENCY_MISMATCH / NO_PAYMENT_DATE). Empty when not blocked — surfaces as «требует внимания» in the ERP. */
  provisionBlockedReason?: Maybe<Scalars['String']>;
  rawPayload?: Maybe<Scalars['JSONString']>;
  sellDate?: Maybe<Scalars['Date']>;
  sellerName: Scalars['String'];
  status?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  /** Public preview URL of the document in Fakturownia. */
  viewUrl?: Maybe<Scalars['String']>;
};

export type FakturowniaMutationOutput = {
  __typename?: 'FakturowniaMutationOutput';
  /** True when a document DEFINITELY exists in Fakturownia despite success=false. Not the whole at-risk set — errorCode=FAKTUROWNIA_AMBIGUOUS also means a document may exist. Check both before deciding not to warn. */
  documentCreated?: Maybe<Scalars['Boolean']>;
  /** Machine code for the failure, e.g. AGREEMENT_STATE_PREFINANCED, MISSING_BUYER_ADDRESS, ISSUE_IN_FLIGHT. Null on success. */
  errorCode?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<Scalars['String']>>>;
  invoice?: Maybe<FakturowniaInvoiceType>;
  success?: Maybe<Scalars['Boolean']>;
};

/** Mirror of one row in Fakturownia's `/payments.json`. N:1 to invoice. */
export type FakturowniaPaymentType = {
  __typename?: 'FakturowniaPaymentType';
  createdAt: Scalars['DateTime'];
  currency: Scalars['String'];
  fakturowniaId: Scalars['Int'];
  fakturowniaUpdatedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  /** N:1 to FakturowniaInvoice — Fakturownia may split one invoice across several payment records. */
  invoice: FakturowniaInvoiceType;
  /** Fakturownia payment kind — cash / transfer / card / ... */
  kind: Scalars['String'];
  paidDate?: Maybe<Scalars['Date']>;
  pk?: Maybe<Scalars['Int']>;
  price?: Maybe<Scalars['Float']>;
  rawPayload?: Maybe<Scalars['JSONString']>;
  updatedAt: Scalars['DateTime'];
};

/** An enumeration. */
export enum FakturowniaSyncRunStatus {
  /** Failed */
  Failed = 'FAILED',
  /** Running */
  Running = 'RUNNING',
  /** Success */
  Success = 'SUCCESS'
}

export type FakturowniaSyncRunType = {
  __typename?: 'FakturowniaSyncRunType';
  celeryTaskId: Scalars['String'];
  durationSeconds?: Maybe<Scalars['Float']>;
  errorMessage: Scalars['String'];
  finishedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  pk?: Maybe<Scalars['Int']>;
  startedAt: Scalars['DateTime'];
  stats?: Maybe<Scalars['JSONString']>;
  status: FakturowniaSyncRunStatus;
  taskName: Scalars['String'];
};

/**
 * Compact "is the mirror up-to-date?" snapshot for dashboard widgets.
 *
 * A single object the frontend can poll on a tick: when did the last
 * successful sync finish, how many invoices it touched, and whether a
 * new run is currently in flight (so the spinner stays on).
 */
export type FakturowniaSyncStatus = {
  __typename?: 'FakturowniaSyncStatus';
  /** True while a run is in progress. */
  isRunning?: Maybe<Scalars['Boolean']>;
  /** The most recent run, regardless of outcome. */
  lastRun?: Maybe<FakturowniaSyncRunType>;
  /** The most recent run that finished with status='success'. Use this for 'last synced at HH:MM' captions; `last_run` may carry a fresher 'failed' that hasn't been retried yet. */
  lastSuccess?: Maybe<FakturowniaSyncRunType>;
  /** Invoice-issuing attempts whose outcome is UNKNOWN — a document may exist in Fakturownia that we have no record of. Each one also blocks its installment from being billed again. Non-zero needs attention: an invisible orphan blocks that взнос forever. */
  orphanSuspectedCount?: Maybe<Scalars['Int']>;
};

/**
 * «Занятие проведено» + комментарий.
 *
 * ТЗ 0026 забрал отсюда посещаемость: она сохраняется поштучно через
 * `lmsSetAttendance`. Аргумент `attendances` стал НЕобязательным — снятие
 * `required` обратно совместимо, поэтому старый бандл, оставшийся в кэше
 * браузера преподавателя после выката бэкенда, продолжит работать как
 * раньше. Удалять аргумент — следующим релизом.
 */
export type FinishLmsLessonMutation = {
  __typename?: 'FinishLmsLessonMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
  success?: Maybe<Scalars['Boolean']>;
};

/** Flag/unflag one message (team-wide global state). */
export type FlagMessageMutation = {
  __typename?: 'FlagMessageMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  message?: Maybe<MessageType>;
  success?: Maybe<Scalars['Boolean']>;
};

/**
 * Одна строка анкеты как её прислала форма.
 *
 * Пара, а не словарь: порядок вопросов несущий, а `JSONString` на экране —
 * это фигурные скобки, которые человек читать не должен.
 */
export type FormAnswerType = {
  __typename?: 'FormAnswerType';
  /** Имя поля в camelCase — им же подписан ключ локали `pages.dofinansowanie.fields.<field>`. */
  field: Scalars['String'];
  value: Scalars['String'];
};

/**
 * Заявка с публичной формы — сырое, что пришло, и что с ним стало.
 *
 * До ТЗ 0046 у этой таблицы не было ни типа, ни запроса: она жила только в
 * Django-админке, где нет даже фильтра «не разобрано». Триаж идёт в
 * try/except, и упавшая заявка оставалась с пустым `processed_at` и текстом
 * ошибки, которого никто никогда не видел.
 *
 * `payload` наружу НЕ отдаём: это сырой ввод анонимного человека, и место
 * ему в карточке кандидата, куда триаж его уже разложил, а не в списке.
 */
export type FormSubmissionType = {
  __typename?: 'FormSubmissionType';
  candidateEmployerName?: Maybe<Scalars['String']>;
  candidateEmploymentStatus?: Maybe<Scalars['String']>;
  candidateId?: Maybe<Scalars['ID']>;
  candidateName?: Maybe<Scalars['String']>;
  candidateOperatorId?: Maybe<Scalars['ID']>;
  /** ID всех АКТИВНЫХ операторов кандидата. Окно разбора сверяет состав по ним: имена склеены через запятую, а запятая встречается и внутри названия оператора. */
  candidateOperatorIds: Array<Scalars['ID']>;
  candidateOperatorName?: Maybe<Scalars['String']>;
  candidateOperatorSetAt?: Maybe<Scalars['DateTime']>;
  /** Кто назначил, когда это сделал человек. Пусто у робота и у импорта. */
  candidateOperatorSetBy?: Maybe<Scalars['String']>;
  /** Откуда у кандидата оператор: robot (подобрал автоподбор) / manual (назначил человек) / import (приехало из Notion) / пусто. Прямой ответ на «что такое разобрано автоматически»: на 27.08.2026 это `import` у ВСЕХ 673 кандидатов с оператором — автоподбор не отработал ни разу, журнал воронки пуст. */
  candidateOperatorSource?: Maybe<Scalars['String']>;
  /** Этап воронки, на котором человек сейчас. */
  candidateStatus?: Maybe<Scalars['String']>;
  candidateVoivodeship?: Maybe<Scalars['String']>;
  /** Чтобы поиск оператора в окне разбора стартовал сузённым по региону человека, а не по всем 127. */
  candidateVoivodeshipId?: Maybe<Scalars['ID']>;
  email?: Maybe<Scalars['String']>;
  /** Гео-идентификаторы, которых нет в нашем справочнике. Пусто, пока сайт соблюдает контракт. Непустое означает ровно одно: человек уехал в ручной разбор не потому, что не заполнил географию, а потому что прислал не наш идентификатор. */
  geoRejected: Array<GeoRejectionType>;
  id: Scalars['ID'];
  /** Что именно прислала форма — известные поля в устойчивом порядке, служебные ключи выброшены. 🔴 Карточка кандидата показывает ВЫВЕДЕННЫЕ значения, и вопрос «что реально прислал человек» ими не отвечается: ровно на этой разнице жил дефект `phoneRaw`, когда сырая заявка телефон хранила, а карточка нет. */
  payloadAnswers: Array<FormAnswerType>;
  phone?: Maybe<Scalars['String']>;
  processError?: Maybe<Scalars['String']>;
  processedAt?: Maybe<Scalars['DateTime']>;
  /** honeypot | too_fast — отклонена как автоматическая. */
  rejectedReason?: Maybe<Scalars['String']>;
  /** failed | pending | needs_operator | linked | rejected. 🔴 `linked` разделено надвое: «разобрана» означало лишь «строка кандидата создана» и молчала о том, движется ли человек. */
  state: Scalars['String'];
  submittedAt: Scalars['DateTime'];
  utmCampaign?: Maybe<Scalars['String']>;
  utmSource?: Maybe<Scalars['String']>;
};

/** Column counts for the funnel board, plus the two review queues. */
export type FundingBoardType = {
  __typename?: 'FundingBoardType';
  ambiguousMatches: Scalars['Int'];
  buckets: Array<StatusBucketType>;
  depositWaiting: Scalars['Int'];
  groups: Array<StatusGroupType>;
  /**
   * Кандидаты без оператора — вся очередь подбора целиком.
   *
   * 🔴 Заменило пару `operatorNone` / `operatorSeveral`. Оба считались по M2M `candidate.operators` — журналу «кого рассматривали», который заполняют импорт из Notion и ручное назначение. Правила подбора живут в `candidates.operators_for` и в этот журнал не пишут никогда: на 200 свежих кандидатах два числа не совпали НИ РАЗУ. Хуже всего было у «не подошёл никто»: по правилам из 136 кандидатов без оператора пустой список не получается НИ У КОГО (медиана 6), то есть очередь называла самым тяжёлым случаем то, чего не существует.
   */
  operatorMissing: Scalars['Int'];
  operatorsWithoutCoverage: Scalars['Int'];
  /** Сколько операторов ждут, чтобы человек посмотрел изменившуюся страницу. */
  pageChangedOperators: Scalars['Int'];
  /** Второй вид доски (ТЗ 0058): те же 15 статусов, сгруппированные в 4 категории владельца — новая заявка / в работе / успех / выбыл. */
  stages: Array<StatusGroupType>;
  /** Заявки с публичной формы, разобранные, но без назначенного оператора. Это работа, а не готовое. */
  submissionsNeedOperator: Scalars['Int'];
  /** Сколько адресов слежения выглядят не страницей новостей. Очередь на разбор человеком — как неразобранная география: робот только называет подозрение, адрес меняет человек. */
  suspiciousUrls: Scalars['Int'];
  total: Scalars['Int'];
  unresolvedPlaces: Scalars['Int'];
};

export type FundingCandidateInput = {
  appliedAt?: InputMaybe<Scalars['Date']>;
  approvedAmount?: InputMaybe<Scalars['Float']>;
  assignedToId?: InputMaybe<Scalars['ID']>;
  city?: InputMaybe<Scalars['String']>;
  courseId?: InputMaybe<Scalars['ID']>;
  decisionAt?: InputMaybe<Scalars['Date']>;
  declineReason?: InputMaybe<Scalars['String']>;
  desiredStartMonth?: InputMaybe<Scalars['Date']>;
  email?: InputMaybe<Scalars['String']>;
  employerCanApply?: InputMaybe<Scalars['Boolean']>;
  employerName?: InputMaybe<Scalars['String']>;
  employerPowiatId?: InputMaybe<Scalars['ID']>;
  employerSameVoivodeship?: InputMaybe<Scalars['String']>;
  employerVoivodeshipId?: InputMaybe<Scalars['ID']>;
  employmentStatus?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  fullName?: InputMaybe<Scalars['String']>;
  hasDisabilityCertificate?: InputMaybe<Scalars['Boolean']>;
  inFinancialHardship?: InputMaybe<Scalars['Boolean']>;
  is50Plus?: InputMaybe<Scalars['Boolean']>;
  isAdult?: InputMaybe<Scalars['Boolean']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isDeposit?: InputMaybe<Scalars['Boolean']>;
  isUnemployed?: InputMaybe<Scalars['Boolean']>;
  jdgSuspended?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  legalEntityId?: InputMaybe<Scalars['ID']>;
  notes?: InputMaybe<Scalars['String']>;
  outcome?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  powiatId?: InputMaybe<Scalars['ID']>;
  preferredTracks?: InputMaybe<Array<Scalars['String']>>;
  reminderAt?: InputMaybe<Scalars['DateTime']>;
  /** ID wsparcia. Нормализуется при сохранении; префикс до первого «_» привязывает оператора с таким номером проекта (только добавляет связь). */
  supportId?: InputMaybe<Scalars['String']>;
  taskNote?: InputMaybe<Scalars['String']>;
  testDrive?: InputMaybe<Scalars['Boolean']>;
  usedFundingBefore?: InputMaybe<Scalars['Boolean']>;
  voivodeshipId?: InputMaybe<Scalars['ID']>;
};

/**
 * One person in the funnel — one row, per the owner's decision.
 *
 * `events` is what makes that shape survivable: an operator change or a
 * status move is recorded there, so "BUR refused, we moved to KFS" stays
 * reconstructable even though the current state is single-valued.
 */
export type FundingCandidateType = {
  __typename?: 'FundingCandidateType';
  activeOperatorsCount: Scalars['Int'];
  agreementTitle?: Maybe<Scalars['String']>;
  appliedAt?: Maybe<Scalars['Date']>;
  approvedAmount?: Maybe<Scalars['Float']>;
  assignedToId?: Maybe<Scalars['ID']>;
  assignedToName?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  courseId?: Maybe<Scalars['ID']>;
  courseName?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  currency?: Maybe<Scalars['String']>;
  decisionAt?: Maybe<Scalars['Date']>;
  declineReason?: Maybe<Scalars['String']>;
  desiredStartMonth?: Maybe<Scalars['Date']>;
  disabledOperatorsCount: Scalars['Int'];
  email?: Maybe<Scalars['String']>;
  employerCanApply?: Maybe<Scalars['Boolean']>;
  employerName?: Maybe<Scalars['String']>;
  employerPowiat?: Maybe<PowiatType>;
  employerSameVoivodeship?: Maybe<Scalars['String']>;
  employerVoivodeship?: Maybe<VoivodeshipType>;
  employmentStatus?: Maybe<Scalars['String']>;
  events: Array<CandidateEventType>;
  firstName?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  hasDisabilityCertificate?: Maybe<Scalars['Boolean']>;
  /** Есть работодатель — значит KFS в принципе применим. */
  hasEmployer: Scalars['Boolean'];
  id: Scalars['ID'];
  inFinancialHardship?: Maybe<Scalars['Boolean']>;
  intake?: Maybe<FundingIntakeType>;
  is50Plus?: Maybe<Scalars['Boolean']>;
  isAdult?: Maybe<Scalars['Boolean']>;
  isArchived: Scalars['Boolean'];
  isDeposit: Scalars['Boolean'];
  /** Кандидат уже учится у нас. Считается на лету — студентов заводят четыре независимых пути, и сохранённый флаг протух бы на первом же из них. */
  isStudent: Scalars['Boolean'];
  isUnemployed?: Maybe<Scalars['Boolean']>;
  jdgSuspended?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  legalEntityName?: Maybe<Scalars['String']>;
  linkedUserEmail?: Maybe<Scalars['String']>;
  linkedUserId?: Maybe<Scalars['ID']>;
  linkedUserName?: Maybe<Scalars['String']>;
  matchRule: Scalars['String'];
  matchStatus: Scalars['String'];
  notes?: Maybe<Scalars['String']>;
  /** Все связи, включая выключенные, — журнал «кого рассматривали» с причинами. */
  operatorLinks: Array<CandidateOperatorLinkType>;
  /** АКТИВНЫЕ операторы кандидата: человеку идут письма о наборах у КАЖДОГО из них. Несколько — норма, а не повод для разбора. */
  operators: Array<FundingOperatorType>;
  outcome?: Maybe<Scalars['String']>;
  ownContributionAmount?: Maybe<Scalars['Float']>;
  phone?: Maybe<Scalars['String']>;
  powiat?: Maybe<PowiatType>;
  powiatRaw?: Maybe<Scalars['String']>;
  preferredTracks: Array<Scalars['String']>;
  /** Пометка «ведущий оператор». С ТЗ 0067 она никого не глушит и может быть пустой у человека с работающими операторами — аудиторию рассылок задают активные связи. */
  primaryOperator?: Maybe<FundingOperatorType>;
  reminderAt?: Maybe<Scalars['DateTime']>;
  source: Scalars['String'];
  status: Scalars['String'];
  statusChangedAt: Scalars['DateTime'];
  studentId?: Maybe<Scalars['ID']>;
  /** ID wsparcia (FEDS.07.04-IP.02-0004/23_121/7.4B/2026/USZ). Часть до первого «_» — номер проекта оператора; хранится нормализованным. Пустая строка — не внесён. */
  supportId?: Maybe<Scalars['String']>;
  taskNote?: Maybe<Scalars['String']>;
  testDrive: Scalars['Boolean'];
  updatedAt: Scalars['DateTime'];
  usedFundingBefore?: Maybe<Scalars['Boolean']>;
  userLocked: Scalars['Boolean'];
  voivodeship?: Maybe<VoivodeshipType>;
};

/** Набор внутри другого запроса — им пользуется «посмотрел и завёл». */
export type FundingIntakeInput = {
  announcedAt?: InputMaybe<Scalars['Date']>;
  confirmed?: InputMaybe<Scalars['Boolean']>;
  endsAtTime?: InputMaybe<Scalars['Time']>;
  endsOn?: InputMaybe<Scalars['Date']>;
  id?: InputMaybe<Scalars['ID']>;
  note?: InputMaybe<Scalars['String']>;
  sourceUrl?: InputMaybe<Scalars['String']>;
  startsAtTime?: InputMaybe<Scalars['Time']>;
  startsOn?: InputMaybe<Scalars['Date']>;
  status?: InputMaybe<Scalars['String']>;
};

export type FundingIntakeType = {
  __typename?: 'FundingIntakeType';
  announcedAt?: Maybe<Scalars['Date']>;
  candidatesCount: Scalars['Int'];
  /** Когда человек подтвердил набор. Заполнено — робот рассылает по этому окну; пусто — молчит, сколько бы лет окно ни висело. Единственное разрешение на рассылку в домене (ТЗ 0054). */
  confirmedAt?: Maybe<Scalars['DateTime']>;
  /** Кто подтвердил. Имя, а не id: экран показывает его человеку, а карточки пользователя отсюда не открывают. */
  confirmedByName?: Maybe<Scalars['String']>;
  /** Сколько дней осталось до конца (у идущего) или до открытия (у будущего). Пусто — у бессрочного окна конца нет, и «сколько осталось» не бывает. */
  daysLeft?: Maybe<Scalars['Int']>;
  /** Час закрытия набора, если оператор его назвал. */
  endsAtTime?: Maybe<Scalars['Time']>;
  endsOn?: Maybe<Scalars['Date']>;
  /**
   * Когда уйдёт ПЕРВОЕ письмо по этому окну, или пусто, если не уйдёт. То же правило, что у `mail.firstPlannedOn`, — считает одна функция.
   *
   * Отдельным полем, потому что список окон спрашивает только дату: сводка целиком стоит двух запросов на окно, а на странице их пятьдесят.
   */
  firstPlannedOn?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  /** Что уже сделала рассылка по ЭТОМУ окну: сколько ушло, сколько отбито дедупликацией, сколько с ошибкой, и когда уйдёт следующее письмо. Одним полем, а не тремя запросами `fundingNotificationsTotal` со статусами: три отдельных счётчика к одному вопросу — это три запроса и три места, где можно забыть фильтр. */
  mail: IntakeMailType;
  note?: Maybe<Scalars['String']>;
  notifiedAt?: Maybe<Scalars['DateTime']>;
  notifiedCount: Scalars['Int'];
  /** С кем работает оператор набора: b2b | b2c. Третьим рядом с именем и программой — признак показывается ВЕЗДЕ, где оператора называют, а не только там, где его выбирают (ТЗ 0053). */
  operatorClientType?: Maybe<Scalars['String']>;
  operatorId: Scalars['ID'];
  operatorName?: Maybe<Scalars['String']>;
  operatorProgramType?: Maybe<Scalars['String']>;
  /** Что видно в колонке «Состояние»: upcoming | running | ended | cancelled | unknown. Считается ИЗ ДАТ на сервере — тем же выражением, что и фильтр, иначе колонка и фильтр отвечали бы на разные вопросы. */
  phase?: Maybe<Scalars['String']>;
  sourceUrl?: Maybe<Scalars['String']>;
  /** Час открытия набора, если оператор его назвал. Отдельно от даты: на голую дату опираются проверки живости окна, ограничение «один набор на дату» и подстановки в письмах — час их не трогает. */
  startsAtTime?: Maybe<Scalars['Time']>;
  startsOn?: Maybe<Scalars['Date']>;
  status: Scalars['String'];
  waitingCandidatesCount: Scalars['Int'];
};

/**
 * Одно письмо робота — то, что менеджер видит в карточке кандидата.
 *
 * `dedupKey` наружу не отдаём: это внутренний ключ идемпотентности, и на
 * экране он был бы шумом. Повод (`kind`) отвечает на тот же вопрос словами.
 */
export type FundingNotificationType = {
  __typename?: 'FundingNotificationType';
  bounceReason?: Maybe<Scalars['String']>;
  bouncedAt?: Maybe<Scalars['DateTime']>;
  candidateId: Scalars['ID'];
  candidateName?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  deliveredAt?: Maybe<Scalars['DateTime']>;
  /** Итог доставки одним словом: bounced | dropped | unsubscribed | opened | delivered | sent | pending | failed. */
  deliveryState: Scalars['String'];
  dropReason?: Maybe<Scalars['String']>;
  droppedAt?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  firstOpenedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  intakeEndsOn?: Maybe<Scalars['Date']>;
  intakeId?: Maybe<Scalars['ID']>;
  intakeStartsOn?: Maybe<Scalars['Date']>;
  kind: Scalars['String'];
  openCount: Scalars['Int'];
  /** С кем работает оператор письма: b2b | b2c (ТЗ 0053). */
  operatorClientType?: Maybe<Scalars['String']>;
  operatorId?: Maybe<Scalars['ID']>;
  operatorName?: Maybe<Scalars['String']>;
  reason?: Maybe<Scalars['String']>;
  sentAt?: Maybe<Scalars['DateTime']>;
  status: Scalars['String'];
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
};

export type FundingOperatorInput = {
  acceptsEmployerApplications?: InputMaybe<Scalars['Boolean']>;
  acceptsUnemployed?: InputMaybe<Scalars['Boolean']>;
  comment?: InputMaybe<Scalars['String']>;
  coverageScope?: InputMaybe<Scalars['String']>;
  decisionDays?: InputMaybe<Scalars['Int']>;
  documentsNote?: InputMaybe<Scalars['String']>;
  documentsUrl?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  greenCompetences?: InputMaybe<Scalars['Boolean']>;
  implementationEnd?: InputMaybe<Scalars['Date']>;
  implementationStart?: InputMaybe<Scalars['Date']>;
  instructionReady?: InputMaybe<Scalars['Boolean']>;
  instructionUrl?: InputMaybe<Scalars['String']>;
  internalNote?: InputMaybe<Scalars['String']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  maxAmount?: InputMaybe<Scalars['Float']>;
  maxAmountCurrency?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  newsUrl?: InputMaybe<Scalars['String']>;
  operatorInstructionUrl?: InputMaybe<Scalars['String']>;
  ownContributionPercent?: InputMaybe<Scalars['Float']>;
  paymentMethod?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  powiatIds?: InputMaybe<Array<Scalars['ID']>>;
  programName?: InputMaybe<Scalars['String']>;
  programType: Scalars['String'];
  /** Nr projektu. Нормализуется при сохранении (пробелы, регистр); сохранение привязывает кандидатов, чей ID wsparcia начинается с этого номера и «_». */
  projectNumber?: InputMaybe<Scalars['String']>;
  projectUrl?: InputMaybe<Scalars['String']>;
  rollingIntake?: InputMaybe<Scalars['Boolean']>;
  servedStatuses?: InputMaybe<Array<Scalars['String']>>;
  supportsAge50Plus?: InputMaybe<Scalars['Boolean']>;
  supportsDisabled?: InputMaybe<Scalars['Boolean']>;
  voivodeshipId?: InputMaybe<Scalars['ID']>;
};

export type FundingOperatorType = {
  __typename?: 'FundingOperatorType';
  acceptsEmployerApplications: Scalars['Boolean'];
  acceptsUnemployed: Scalars['Boolean'];
  /** Почему последняя проверка страницы не удалась. Пусто — значит удалась. */
  automationError?: Maybe<Scalars['String']>;
  automationStatus: Scalars['String'];
  candidatesCount: Scalars['Int'];
  /** С кем работает оператор: `b2b` (заявку подаёт работодатель) или `b2c` (человек подаёт сам). Считает СЕРВЕР из колонки Notion `Dla pracodawcy`, чтобы фильтр и подпись в строке не разошлись. У KFS всегда `b2b` — это свойство инструмента, а не оператора. */
  clientType?: Maybe<Scalars['String']>;
  comment?: Maybe<Scalars['String']>;
  /** Строки покрытия есть, но ни одна не разобрана — такой оператор не подберётся никому. */
  coverageIncomplete: Scalars['Boolean'];
  coverageScope: Scalars['String'];
  createdAt: Scalars['DateTime'];
  /** Ближайшее незакрытое окно набора, если есть. */
  currentIntake?: Maybe<FundingIntakeType>;
  decisionDays?: Maybe<Scalars['Int']>;
  documentsNote?: Maybe<Scalars['String']>;
  documentsUrl?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  greenCompetences: Scalars['Boolean'];
  /** Есть ли у оператора подтверждённое живое окно — то есть пишет ли робот его кандидатам. Разрешение живёт на самом наборе (`FundingIntakeType.confirmedAt`); здесь только сводка для строки списка. */
  hasConfirmedIntake?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  implementationEnd?: Maybe<Scalars['Date']>;
  implementationStart?: Maybe<Scalars['Date']>;
  instructionReady: Scalars['Boolean'];
  /** Инструкция, которая уходит студенту по почте. */
  instructionUrl?: Maybe<Scalars['String']>;
  /** Период набора: `running` / `soon` / `rolling` / `none`. */
  intakePeriod?: Maybe<Scalars['String']>;
  intakes: Array<FundingIntakeType>;
  internalNote?: Maybe<Scalars['String']>;
  isActive: Scalars['Boolean'];
  lastNotifiedAt?: Maybe<Scalars['DateTime']>;
  maxAmount?: Maybe<Scalars['Float']>;
  maxAmountCurrency?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  /** В названии стоит FIRMY/przedsiębiorstwa. ⚠️ Значение `clientType` этим НЕ переопределяется — владелец выбрал колонку источника. Но у шести операторов название и галка расходятся, и такую строку стоит поправить руками. */
  nameSaysB2b: Scalars['Boolean'];
  /** Страница «aktualności» — за ней следит робот. */
  newsUrl?: Maybe<Scalars['String']>;
  /** Отдельная ссылка оператора — раньше молча терялась. */
  operatorInstructionUrl?: Maybe<Scalars['String']>;
  ownContributionPercent?: Maybe<Scalars['Float']>;
  pageChanged: Scalars['Boolean'];
  pageChangedAt?: Maybe<Scalars['DateTime']>;
  /** Чем замечено изменение: `links` — сдвинулся список ссылок (сильный сигнал), `text` — только текст страницы (слабый, работает лишь там, где ссылок нет вовсе). */
  pageChangedReason?: Maybe<Scalars['String']>;
  /** Что появилось и что исчезло на странице с тех пор, как человек её разбирал. Считается на чтение из двух подписей — хранимый диф пришлось бы кому-то склеивать. */
  pageDiff?: Maybe<PageDiffType>;
  pageHashCheckedAt?: Maybe<Scalars['DateTime']>;
  /** Сколько ссылок робот нашёл при последней проверке. Ноль означает, что фингерпринтить нечего: страница открылась, но робот на ней слеп. */
  pageLinksCount?: Maybe<Scalars['Int']>;
  /** Что робот видит на странице: changed | quiet | never. Три значения и один вопрос — «обновилась или нет, и когда проверяли». Поломки слежения сюда НЕ попадают: у оператора без единой удачной проверки это `never`, а почему именно — знает журнал прогонов. Считается сервером, чтобы фильтр, счётчик и подпись в строке не разошлись. */
  pageState?: Maybe<Scalars['String']>;
  /** Есть ли подпись по тексту. Отдаём признак, а не хэш: наружу нужен ответ «следим ли», а не сами байты. */
  pageTextWatched: Scalars['Boolean'];
  paymentMethod?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  powiats: Array<PowiatType>;
  /** Строки покрытия, которые не удалось сопоставить со справочником — видны, чтобы пробел не был тихим. */
  powiatsUnresolved: Array<Scalars['String']>;
  programName?: Maybe<Scalars['String']>;
  programType: Scalars['String'];
  /** Nr projektu (FEDS.07.04-IP.02-0004/23). С него начинается ID wsparcia участников; хранится нормализованным (без лишних пробелов, заглавными). Пустая строка — номер не внесён. */
  projectNumber?: Maybe<Scalars['String']>;
  projectUrl?: Maybe<Scalars['String']>;
  rollingIntake: Scalars['Boolean'];
  servedStatuses: Array<Scalars['String']>;
  supportsAge50Plus: Scalars['Boolean'];
  supportsDisabled: Scalars['Boolean'];
  updatedAt: Scalars['DateTime'];
  /** Адрес слежения выглядит не страницей новостей: search / analytics / epoch / homepage. Пусто — вопросов нет. Робот такое НЕ чинит: правильный листинг не угадывается, адрес меняет человек. */
  urlSuspect?: Maybe<Scalars['String']>;
  voivodeship?: Maybe<VoivodeshipType>;
};

export type FundingStatsType = {
  __typename?: 'FundingStatsType';
  buckets: Array<StatsBucketType>;
  depositWaiting: Scalars['Int'];
  dimension: Scalars['String'];
  medianDecisionDays?: Maybe<Scalars['Float']>;
  total: Scalars['Int'];
};

export type FutureKnowledgeType = {
  __typename?: 'FutureKnowledgeType';
  course?: Maybe<CourseFilterType>;
  descriptions: Array<KnowledgeDescriptionType>;
  id: Scalars['ID'];
  title: Scalars['String'];
};

export type FutureProfessionType = {
  __typename?: 'FutureProfessionType';
  course?: Maybe<CourseFilterType>;
  description: Scalars['String'];
  id: Scalars['ID'];
  title: Scalars['String'];
};

/**
 * An invoice that could be inside this batch.
 *
 * `preselected` marks a greedy set that lands inside the fee band, so the
 * operator starts from a plausible answer instead of an empty list.
 */
export type GatewaySettlementCandidateType = {
  __typename?: 'GatewaySettlementCandidateType';
  alreadyInSettlementId?: Maybe<Scalars['Int']>;
  amount?: Maybe<Scalars['Float']>;
  invoiceId?: Maybe<Scalars['Int']>;
  issueDate?: Maybe<Scalars['Date']>;
  number?: Maybe<Scalars['String']>;
  preselected?: Maybe<Scalars['Boolean']>;
};

export type GatewaySettlementItemType = {
  __typename?: 'GatewaySettlementItemType';
  amount?: Maybe<Scalars['Float']>;
  invoiceId?: Maybe<Scalars['Int']>;
  invoiceNumber?: Maybe<Scalars['String']>;
  kind?: Maybe<Scalars['String']>;
  matchSource?: Maybe<Scalars['String']>;
  pk?: Maybe<Scalars['Int']>;
};

export type GatewaySettlementOutput = {
  __typename?: 'GatewaySettlementOutput';
  errors?: Maybe<Array<Maybe<Scalars['String']>>>;
  settlement?: Maybe<GatewaySettlementType>;
  success?: Maybe<Scalars['Boolean']>;
};

export type GatewaySettlementType = {
  __typename?: 'GatewaySettlementType';
  /** Net of the gateway's fee. */
  amountBank?: Maybe<Scalars['Float']>;
  bankTransactionId?: Maybe<Scalars['Int']>;
  bookedAt?: Maybe<Scalars['Date']>;
  /** The gateway BATCH number. */
  externalRef?: Maybe<Scalars['String']>;
  /** Σ composition − received. Analytical only — never a row in the cash-flow report. */
  feeAmount?: Maybe<Scalars['Float']>;
  feeSource?: Maybe<Scalars['String']>;
  items?: Maybe<Array<Maybe<GatewaySettlementItemType>>>;
  itemsTotal?: Maybe<Scalars['Float']>;
  merchantCode?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  pk?: Maybe<Scalars['Int']>;
  provider?: Maybe<Scalars['String']>;
  reasonCode?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  unallocated?: Maybe<Scalars['Float']>;
};

/** A raw place string awaiting (or holding) a human decision. */
export type GeoAliasType = {
  __typename?: 'GeoAliasType';
  candidatePowiats: Array<PowiatType>;
  contextVoivodeship?: Maybe<VoivodeshipType>;
  hits: Scalars['Int'];
  id: Scalars['ID'];
  normalized?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  powiat?: Maybe<PowiatType>;
  rawValue: Scalars['String'];
  status: Scalars['String'];
  suggestedPowiat?: Maybe<PowiatType>;
  suggestionScore?: Maybe<Scalars['Float']>;
  voivodeship?: Maybe<VoivodeshipType>;
  wholeVoivodeship: Scalars['Boolean'];
};

/**
 * Гео-значение, которое форма прислала, а справочник не признал.
 *
 * Сторож, а не запрет: заявка принимается, отправителю ничего не отвечают
 * (см. `intake_form.geo_rejections`), но менеджер видит разницу между
 * «человек не заполнил повят» и «сайт прислал повят, которого нет».
 */
export type GeoRejectionType = {
  __typename?: 'GeoRejectionType';
  /** voivodeshipId | powiatId | employerVoivodeshipId | employerPowiatId */
  key: Scalars['String'];
  /** Как прислали. */
  value: Scalars['String'];
};

/** A shared mailbox available to send FROM (compose a new email). */
export type GmailMailboxType = {
  __typename?: 'GmailMailboxType';
  displayName: Scalars['String'];
  email: Scalars['String'];
  enabled: Scalars['Boolean'];
  id: Scalars['ID'];
};

/**
 * Teacher grades a student's homework — with or without a submission
 * (non-submitters get `not_done`). Writes through to
 * journals.StudentsMark.hw_mark; the comment lives on the submission.
 */
export type GradeHomeworkMutation = {
  __typename?: 'GradeHomeworkMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  row?: Maybe<HomeworkRosterRowType>;
  success?: Maybe<Scalars['Boolean']>;
};

export type GraduateFeedbackConnection = {
  __typename?: 'GraduateFeedbackConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GraduateFeedbackEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `GraduateFeedback` and its cursor. */
export type GraduateFeedbackEdge = {
  __typename?: 'GraduateFeedbackEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<GraduateFeedbackType>;
};

export type GraduateFeedbackType = {
  __typename?: 'GraduateFeedbackType';
  course: CourseFilterTypeConnection;
  date: Scalars['Date'];
  feedback: Scalars['String'];
  graduateName: Scalars['String'];
  graduatePhoto?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  resourceIcon: Scalars['String'];
};


export type GraduateFeedbackTypeCourseArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  category_Name?: InputMaybe<Scalars['String']>;
  educationForm?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderByPublishDateFilter?: InputMaybe<Scalars['Boolean']>;
  readyToPublish?: InputMaybe<Scalars['Boolean']>;
  startDateFilter?: InputMaybe<Scalars['Boolean']>;
};

export type GraduationVideoType = {
  __typename?: 'GraduationVideoType';
  course?: Maybe<CourseFilterType>;
  description: Scalars['String'];
  id: Scalars['ID'];
  title: Scalars['String'];
  url: Scalars['String'];
};

/** Per-student attendance row inside `groupAttendanceSummary`. */
export type GroupAttendanceStudentRow = {
  __typename?: 'GroupAttendanceStudentRow';
  /** attended / expected_lessons × 100. 0 when expected_lessons is 0. */
  attendanceRate: Scalars['Float'];
  /** StudentAttendance rows with attendance=True for the expected lessons. */
  attended: Scalars['Int'];
  /** True when attendance_rate < threshold OR the student has no expected lessons yet — the UI treats both as «needs attention». */
  belowThreshold: Scalars['Boolean'];
  /** Passed lessons the student was expected to attend (clipped by agreement.terminated_date when set). */
  expectedLessons: Scalars['Int'];
  fullName: Scalars['String'];
  /** expected_lessons − attended (skipped + not marked). */
  missed: Scalars['Int'];
  studentId: Scalars['ID'];
};

/**
 * Group-level attendance rollup for the dashboard KpiStrip + ScheduleTab.
 *
 * Replaces the per-lesson fan-out the frontend used to do
 * (`journal(groupId)` + `attendances` per lesson) with a single resolver
 * pass. Threshold value comes from `settings.GROUP_ATTENDANCE_THRESHOLD`
 * so it can be tuned without a release.
 */
export type GroupAttendanceSummary = {
  __typename?: 'GroupAttendanceSummary';
  /** Mean attendance_rate over students who had at least one expected lesson. Students with 0 expected lessons are skipped from the average but still flagged below. */
  averageAttendance: Scalars['Float'];
  groupId: Scalars['ID'];
  /** GroupLesson.finished=True — the denominator for expected_lessons before per-student clipping. */
  passedLessons: Scalars['Int'];
  students: Array<GroupAttendanceStudentRow>;
  studentsBelowThresholdCount: Scalars['Int'];
  /** The 0..100 cutoff used to compute below_threshold per student. */
  threshold: Scalars['Float'];
  totalLessons: Scalars['Int'];
  /** ТЗ 0026: прошедшие занятия с finished=False. Разрыв между «посещаемость проставлена» и «занятие закрыто»: такое занятие не попадает в passed_lessons и не идёт в выплату преподавателю. */
  unclosedLessons: Scalars['Int'];
};

/**
 * A group's Slack channel for the whole-group inbox: the configured
 * channel (`ChannelGroupLink`, discovered via `conversations.list`) merged
 * with its `Conversation` mirror when one exists — so channels that haven't
 * received a message yet still appear (fixes the «нет каналов» blank list).
 */
export type GroupChannelRow = {
  __typename?: 'GroupChannelRow';
  channelName: Scalars['String'];
  conversationId?: Maybe<Scalars['ID']>;
  hasUnhandled: Scalars['Boolean'];
  lastMessageAt?: Maybe<Scalars['DateTime']>;
  slackChannelId: Scalars['String'];
  teamId: Scalars['String'];
  unreadCount: Scalars['Int'];
};

/**
 * The communicator middle-column badge aggregate for one group —
 * computed server-side in two set-based queries (spec 0008). Replaces the
 * frontend's ~10-page conversationsBrowser drain.
 */
export type GroupCommsIndex = {
  __typename?: 'GroupCommsIndex';
  channelsUnhandled: Scalars['Boolean'];
  channelsUnread: Scalars['Int'];
  groupId: Scalars['ID'];
  mailUnhandled: Scalars['Boolean'];
  mailUnreadTotal: Scalars['Int'];
  pendingConversations: Scalars['Int'];
  slackUnhandled: Scalars['Boolean'];
  slackUnreadTotal: Scalars['Int'];
  students: Array<StudentCommsBadgeRow>;
  /** Преподаватели, ведущие группу, с теми же счётчиками (ТЗ 0032). Массовая кнопка «обслужить группу» их НЕ трогает — решение владельца. */
  teachers: Array<TeacherCommsBadgeRow>;
};

export type GroupConnection = {
  __typename?: 'GroupConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GroupEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/**
 * One roster row: the student plus whichever languages are attached.
 *
 * Shaped per-student rather than per-file so the ERP table renders directly
 * (student | PL | EN | actions) without a client-side group-by.
 */
export type GroupDiplomaRowType = {
  __typename?: 'GroupDiplomaRowType';
  agreementTitle?: Maybe<Scalars['String']>;
  en?: Maybe<DiplomaType>;
  pl?: Maybe<DiplomaType>;
  student: DiplomaStudentType;
};

/** A Relay edge containing a `Group` and its cursor. */
export type GroupEdge = {
  __typename?: 'GroupEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<GroupType>;
};

/**
 * Which path linked this invoice to the group it was filtered by.
 *
 * Used by `fakturowniaInvoices(group_id)` during the Phase-13 rollout
 * (docs/groups/group_dashboard.md §G7) so the frontend can show a
 * "legacy" badge on rows that only matched because the canonical
 * `payment → agreement → group` chain hadn't reached them yet.
 * Distinct from the existing `group_match_source` field, which records
 * how the legacy `linked_group` FK itself was assigned.
 */
export enum GroupFilterSourceEnum {
  Canonical = 'CANONICAL',
  LegacyLinkedGroup = 'LEGACY_LINKED_GROUP'
}

export type GroupInput = {
  course_id: Scalars['Int'];
  currency: Scalars['String'];
  daysOfClass: Array<DayOfClassInput>;
  name: Scalars['String'];
  price: Scalars['Float'];
  startDate: Scalars['Date'];
};

export type GroupLessonConnection = {
  __typename?: 'GroupLessonConnection';
  comment?: Maybe<Scalars['String']>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GroupLessonEdge>>;
  groupName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `GroupLesson` and its cursor. */
export type GroupLessonEdge = {
  __typename?: 'GroupLessonEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<GroupLessonType>;
};

export type GroupLessonForLmsType = Node & {
  __typename?: 'GroupLessonForLMSType';
  additional?: Maybe<Scalars['Boolean']>;
  comment?: Maybe<Scalars['String']>;
  date: Scalars['Date'];
  endTime: Scalars['Time'];
  finished: Scalars['Boolean'];
  hasJoinLink?: Maybe<Scalars['Boolean']>;
  hasStudentAttachment?: Maybe<Scalars['Boolean']>;
  hasStudentMarks?: Maybe<Scalars['Boolean']>;
  hasTeacherAttachment?: Maybe<Scalars['Boolean']>;
  homeworkAssignmentId?: Maybe<Scalars['ID']>;
  homeworkAvailable?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  index?: Maybe<Scalars['Int']>;
  lessonNumber?: Maybe<Scalars['Int']>;
  linkOverrideActive?: Maybe<Scalars['Boolean']>;
  lmsDescription?: Maybe<Scalars['String']>;
  marks: StudentsMarkTypeConnection;
  /** Optional — for group-wide handouts leave NULL; for per-lesson homework point at the specific GroupLesson. */
  materials: Array<MaterialType>;
  module: GroupModuleType;
  name: Scalars['String'];
  needToFinish?: Maybe<Scalars['Boolean']>;
  number: Scalars['Int'];
  startTime: Scalars['Time'];
  students: StudentTypeConnection;
  taskTypes: Array<Scalars['String']>;
  teacher?: Maybe<TeacherType>;
  teacherApplication?: Maybe<ApplicationType>;
  video?: Maybe<Scalars['String']>;
  whiteboardId?: Maybe<Scalars['ID']>;
  zoomProcessingLogs: ZoomProcessingLogTypeConnection;
  zoomRecordingMeta?: Maybe<LessonRecordingType>;
};


export type GroupLessonForLmsTypeMarksArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  lessonId?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  taskType?: InputMaybe<Scalars['String']>;
};


export type GroupLessonForLmsTypeStudentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type GroupLessonForLmsTypeZoomProcessingLogsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type GroupLessonType = Node & {
  __typename?: 'GroupLessonType';
  additional?: Maybe<Scalars['Boolean']>;
  attendances: AttendanceTypeConnection;
  comment?: Maybe<Scalars['String']>;
  date: Scalars['Date'];
  endTime: Scalars['Time'];
  finished: Scalars['Boolean'];
  hasStudentMarks?: Maybe<Scalars['Boolean']>;
  homeworkStats?: Maybe<LessonHomeworkStatsType>;
  id: Scalars['ID'];
  index?: Maybe<Scalars['Int']>;
  lessonNumber?: Maybe<Scalars['Int']>;
  lmsDescription?: Maybe<Scalars['String']>;
  marks: StudentsMarkTypeConnection;
  /** Optional — for group-wide handouts leave NULL; for per-lesson homework point at the specific GroupLesson. */
  materials: Array<MaterialType>;
  module: GroupModuleType;
  name: Scalars['String'];
  needToFinish?: Maybe<Scalars['Boolean']>;
  number: Scalars['Int'];
  startTime: Scalars['Time'];
  students: StudentTypeConnection;
  studentsAttachments: StudentLessonAttachmentTypeConnection;
  taskTypes: Array<Scalars['String']>;
  teacher?: Maybe<TeacherType>;
  teacherApplication?: Maybe<ApplicationType>;
  teachersAttachments: TeacherLessonAttachmentTypeConnection;
  video?: Maybe<Scalars['String']>;
  whiteboardId?: Maybe<Scalars['ID']>;
  zoomProcessingLogs: ZoomProcessingLogTypeConnection;
  zoomRecordingMeta?: Maybe<LessonRecordingType>;
};


export type GroupLessonTypeAttendancesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type GroupLessonTypeMarksArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  lessonId?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  taskType?: InputMaybe<Scalars['String']>;
};


export type GroupLessonTypeStudentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type GroupLessonTypeStudentsAttachmentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type GroupLessonTypeTeachersAttachmentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type GroupLessonTypeZoomProcessingLogsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type GroupLessonTypeConnection = {
  __typename?: 'GroupLessonTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GroupLessonTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `GroupLessonType` and its cursor. */
export type GroupLessonTypeEdge = {
  __typename?: 'GroupLessonTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<GroupLessonType>;
};

/**
 * Временная ссылка на день (spec 0013). Плоский ObjectType поверх модели
 * (НЕ DjangoObjectType — чтобы ничего не авто-протекло в другие типы);
 * отдаётся только role-gated резолвером на GroupType.
 */
export type GroupLinkOverrideType = {
  __typename?: 'GroupLinkOverrideType';
  createdAt?: Maybe<Scalars['DateTime']>;
  date: Scalars['Date'];
  id: Scalars['ID'];
  joinUrl: Scalars['String'];
  setByName?: Maybe<Scalars['String']>;
  setVia?: Maybe<Scalars['String']>;
};

/**
 * One row of the ERP recipient picker: a student plus, when relevant, the
 * most recent unpaid invoice we would reference in the email.
 */
export type GroupMailCandidateType = {
  __typename?: 'GroupMailCandidateType';
  /** True when every agreement of the student in this group is terminated. Only ever true when the query was asked with includeTerminated. */
  agreementTerminated: Scalars['Boolean'];
  agreementTitle?: Maybe<Scalars['String']>;
  daysOverdue: Scalars['Int'];
  email?: Maybe<Scalars['String']>;
  invoiceCurrency?: Maybe<Scalars['String']>;
  invoiceDueDate?: Maybe<Scalars['Date']>;
  invoiceId?: Maybe<Scalars['ID']>;
  invoiceIssueDate?: Maybe<Scalars['Date']>;
  invoiceNumber?: Maybe<Scalars['String']>;
  invoiceOutstanding?: Maybe<Scalars['Float']>;
  invoiceUrl?: Maybe<Scalars['String']>;
  isOverdue: Scalars['Boolean'];
  lastMailedAt?: Maybe<Scalars['DateTime']>;
  studentId: Scalars['ID'];
  studentName: Scalars['String'];
};

export type GroupModuleType = {
  __typename?: 'GroupModuleType';
  group: MethodistGroupType;
  id: Scalars['ID'];
  lessons: GroupLessonTypeConnection;
  name: Scalars['String'];
};


export type GroupModuleTypeLessonsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
};

/**
 * One group's at-a-glance signals for the account-manager command-center
 * dashboard (spec 0003 redesign): enrolment, contribution-based debt (NOT
 * Fakturownia), unanswered Slack/email, and open/overdue tasks. `debtTotal`
 * is the largest single-currency debt (with its `debtCurrency`); the group
 * card shows the full per-currency money model.
 *
 * ТЗ 0036: `debtTotal` / `debtorsCount` count only the OVERDUE plan
 * (instalment date < today). `upcomingTotal` is the not-yet-due plan in the
 * same currency — kept off the debt figure so the board ranks groups by real
 * exposure rather than by how far ahead their payment plans run.
 */
export type GroupOverviewRow = {
  __typename?: 'GroupOverviewRow';
  course: Scalars['String'];
  debtCurrency: Scalars['String'];
  debtTotal: Scalars['Float'];
  debtorsCount: Scalars['Int'];
  groupId: Scalars['ID'];
  /** Дата ПОСЛЕДНЕГО занятия группы (MAX по modules→lessons), включая будущие — то же выражение, которым фильтрует `activeWithinDays`. NULL у группы, у которой занятий ещё нет: это нормальное состояние новой группы, а не сбой, и клиент обязан считать такую группу ИДУЩЕЙ. */
  lastLessonDate?: Maybe<Scalars['Date']>;
  name: Scalars['String'];
  openTasksCount: Scalars['Int'];
  overdueTasksCount: Scalars['Int'];
  startDate?: Maybe<Scalars['Date']>;
  studentsCount: Scalars['Int'];
  /** Число студентов группы, у которых есть хотя бы одно НЕОБРАБОТАННОЕ входящее сообщение (Message.is_handled=False, direction=inbound) — оранжевая точка. Считает уникальных студентов, а не сообщения: студент, написавший и в Slack, и на почту, — один. Канал группы (без студента) добавляет +1 за себя. Прочитанность и статус диалога не учитываются. */
  unhandledStudentsCount: Scalars['Int'];
  /** Число НЕПРОЧИТАННЫХ сообщений (Message.is_read=False) по диалогам группы: её каналы плюс личные диалоги её АКТИВНЫХ студентов (Slack DM / Gmail) — та же популяция и способ атрибуции, что и unhandledStudentsCount. Каждое непрочитанное сообщение считается один раз (per-conversation unreadCount). Обычно совпадает с суммой бейджей внутри группы, но может немного отличаться: средняя колонка коммуникатора дополнительно показывает отчисленных студентов с непрочитанным и внероестерных собеседников из DM, которых этот счётчик по активным студентам не учитывает. */
  unreadMessagesCount: Scalars['Int'];
  /** Число студентов группы, у которых есть хотя бы одно непрочитанное сообщение (Message.is_read=False). Считает уникальных студентов, а не сообщения/диалоги; каналы (без студента) в счётчик не входят. */
  unreadStudentsCount: Scalars['Int'];
  upcomingTotal: Scalars['Float'];
};

/**
 * Group-level marks rollup — §G4. `average_mark` is a weighted mean
 * across students who have at least one mark; null when the journal is
 * empty.
 */
export type GroupPerformanceSummary = {
  __typename?: 'GroupPerformanceSummary';
  averageMark?: Maybe<Scalars['Float']>;
  bottom: Array<StudentPerfRow>;
  groupId: Scalars['ID'];
  studentsWithoutMarks: Scalars['Int'];
  top: Array<StudentPerfRow>;
};

/**
 * Занятие группы для выбора «навык появляется здесь» (ТЗ 0041).
 *
 * Дата и `isOver` не украшение: правило, поставленное на уже прошедшее
 * занятие, начислит навык той же ночью, и методист обязан видеть это ДО
 * сохранения, а не узнавать по факту.
 */
export type GroupProgramLessonType = {
  __typename?: 'GroupProgramLessonType';
  date?: Maybe<Scalars['Date']>;
  isOver: Scalars['Boolean'];
  lessonId: Scalars['ID'];
  moduleName: Scalars['String'];
  name: Scalars['String'];
  number: Scalars['Int'];
};

/**
 * Per-currency revenue rollup for the group dashboard KpiStrip
 * (docs/groups/group_dashboard.md §G5). Lets the frontend drop the
 * heavy `agreements[].payments[]` payload on big groups.
 */
export type GroupRevenueAggregates = {
  __typename?: 'GroupRevenueAggregates';
  groupId: Scalars['ID'];
  rows: Array<GroupRevenueRow>;
};

/**
 * One currency bucket of `groupRevenueAggregates` (§G5).
 *
 * Mirrors the client-side aggregation in `KpiStrip.tsx`: Number-coerce
 * decimals, clamp debt at 0.
 *
 * ТЗ 0036: `debt` is the OVERDUE plan only (instalment date < today) and
 * `upcoming` is the rest, so `budget = paid + debt + upcoming`. Do not
 * recompute either as `budget − paid` on the client — that collapses the two
 * back into one and re-introduces the future plan as debt.
 */
export type GroupRevenueRow = {
  __typename?: 'GroupRevenueRow';
  agreementsActive: Scalars['Int'];
  budget: Scalars['Float'];
  currency: Scalars['String'];
  debt: Scalars['Float'];
  paid: Scalars['Float'];
  studentsWithDebt: Scalars['Int'];
  upcoming: Scalars['Float'];
};

/**
 * Строка набора навыков группы (ТЗ 0041).
 *
 * Занятие — ССЫЛКА, а не номер: у группы оно существует строкой в базе, и
 * ссылка переживает перенос, переименование и вставку соседнего занятия.
 * Пусто — навык приходит по завершении курса. Чужое занятие сервер отвергает
 * ошибкой: «навык не пришёл» и «навык привязан к занятию соседней группы»
 * выглядят на экране одинаково, и второе не должно сохраняться молча.
 */
export type GroupSkillInput = {
  level?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['Int']>;
  skillId: Scalars['ID'];
  unlockLessonId?: InputMaybe<Scalars['ID']>;
};

/**
 * Строка «эта ГРУППА даёт этот навык на таком уровне» (ТЗ 0041).
 *
 * Занятие приходит и ссылкой, и номером. Ссылка — то, что хранится и чем
 * живёт начисление; номер считается на лету как позиция в расписании и нужен
 * ровно для подписи «№12», которую методист привык видеть.
 *
 * `unlockLessonId` пустое означает «навык придёт по завершении курса». В
 * отличие от прежнего предпросмотра, случая «правило указывает в пустоту»
 * здесь не бывает вовсе: связать можно только с занятием этой же группы.
 */
export type GroupSkillType = {
  __typename?: 'GroupSkillType';
  groupId: Scalars['ID'];
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  level: Scalars['Int'];
  order: Scalars['Int'];
  skillCategory: Scalars['String'];
  skillId: Scalars['ID'];
  skillName: Scalars['String'];
  unlockLessonDate?: Maybe<Scalars['Date']>;
  unlockLessonId?: Maybe<Scalars['ID']>;
  unlockLessonIsOver: Scalars['Boolean'];
  unlockLessonName?: Maybe<Scalars['String']>;
  unlockLessonNumber?: Maybe<Scalars['Int']>;
};

export type GroupType = Node & {
  __typename?: 'GroupType';
  activeLinkOverride?: Maybe<GroupLinkOverrideType>;
  agreements: Array<AgreementType>;
  agreementsConnection?: Maybe<AgreementConnection>;
  classesDays: Array<DayOfClassType>;
  comment?: Maybe<Scalars['String']>;
  contributionsSum?: Maybe<Scalars['CustomFloat']>;
  conversations: Array<ConversationType>;
  course: CourseFilterType;
  currency?: Maybe<Scalars['String']>;
  datetimeNextLesson?: Maybe<Scalars['DateTime']>;
  daysOfClass: Array<Scalars['Int']>;
  deleteAvailable?: Maybe<Scalars['Boolean']>;
  /** Optional — when the spend belongs to a specific group (teacher payout per group, group materials, etc.) */
  expenses: Array<ExpenseType>;
  /** DEPRECATED: use invoice.payment.agreement.group. */
  fakturowniaInvoices: Array<FakturowniaInvoiceType>;
  freeLessonsCount?: Maybe<Scalars['Int']>;
  freePlaces?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  isFree: Scalars['Boolean'];
  lessonJoinUrl?: Maybe<Scalars['String']>;
  lessons?: Maybe<Array<GroupLessonType>>;
  lessonsCount?: Maybe<Scalars['Int']>;
  materials: Array<MaterialType>;
  maxStudentsCount: Scalars['Int'];
  modules: Array<GroupModuleType>;
  name: Scalars['String'];
  notes: Array<StudentNoteType>;
  passedLessonsCount?: Maybe<Scalars['Int']>;
  price?: Maybe<Scalars['CustomFloat']>;
  publishedLms: Scalars['Boolean'];
  publishedLmsForMethodist: Scalars['Boolean'];
  publishedLmsForTeacher: Scalars['Boolean'];
  slackChannels: Array<ChannelGroupLinkType>;
  slackWorkspace?: Maybe<SlackWorkspaceLinkType>;
  startDate: Scalars['Date'];
  statusFinished?: Maybe<Scalars['Boolean']>;
  studentsCount?: Maybe<Scalars['Int']>;
  teacherLeads: ApplicationFilterTypeConnection;
  teachers?: Maybe<Array<Maybe<TeacherType>>>;
  zoomAccount?: Maybe<ZoomAccountType>;
  zoomSchedules: GroupZoomScheduleTypeConnection;
};


export type GroupTypeAgreementsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  hasDebt?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<AgreementOrderByEnum>;
  query?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<RosterStatusEnum>;
};


export type GroupTypeTeacherLeadsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  byGroupId?: InputMaybe<Scalars['Decimal']>;
  first?: InputMaybe<Scalars['Int']>;
  isTerminated?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type GroupTypeZoomSchedulesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type GroupZoomScheduleConnection = {
  __typename?: 'GroupZoomScheduleConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GroupZoomScheduleEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `GroupZoomSchedule` and its cursor. */
export type GroupZoomScheduleEdge = {
  __typename?: 'GroupZoomScheduleEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<GroupZoomScheduleType>;
};

export type GroupZoomScheduleSlotInput = {
  isActive?: InputMaybe<Scalars['Boolean']>;
  runTime: Scalars['Time'];
  weekDay: Scalars['Int'];
};

export type GroupZoomScheduleType = Node & {
  __typename?: 'GroupZoomScheduleType';
  createdAt: Scalars['DateTime'];
  group: MethodistGroupType;
  /** The ID of the object */
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  runTime: Scalars['Time'];
  updatedAt: Scalars['DateTime'];
  weekDay: GroupZoomScheduleWeekDay;
  weekDayDisplay?: Maybe<Scalars['String']>;
};

export type GroupZoomScheduleTypeConnection = {
  __typename?: 'GroupZoomScheduleTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GroupZoomScheduleTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `GroupZoomScheduleType` and its cursor. */
export type GroupZoomScheduleTypeEdge = {
  __typename?: 'GroupZoomScheduleTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<GroupZoomScheduleType>;
};

/** An enumeration. */
export enum GroupZoomScheduleWeekDay {
  /** Monday */
  A_0 = 'A_0',
  /** Tuesday */
  A_1 = 'A_1',
  /** Wednesday */
  A_2 = 'A_2',
  /** Thursday */
  A_3 = 'A_3',
  /** Friday */
  A_4 = 'A_4',
  /** Saturday */
  A_5 = 'A_5',
  /** Sunday */
  A_6 = 'A_6'
}

export type GroupsType = {
  __typename?: 'GroupsType';
  agreements: Array<AgreementType>;
  classesDays: Array<DayOfClassType>;
  comment?: Maybe<Scalars['String']>;
  conversations: Array<ConversationType>;
  course: CourseFilterType;
  /** Optional — when the spend belongs to a specific group (teacher payout per group, group materials, etc.) */
  expenses: Array<ExpenseType>;
  /** DEPRECATED: use invoice.payment.agreement.group. */
  fakturowniaInvoices: Array<FakturowniaInvoiceType>;
  id: Scalars['ID'];
  isFree: Scalars['Boolean'];
  materials: Array<MaterialType>;
  maxStudentsCount: Scalars['Int'];
  modules: Array<GroupModuleType>;
  name: Scalars['String'];
  notes: Array<StudentNoteType>;
  publishedLms: Scalars['Boolean'];
  publishedLmsForMethodist: Scalars['Boolean'];
  publishedLmsForTeacher: Scalars['Boolean'];
  slackChannels: Array<ChannelGroupLinkType>;
  slackWorkspace?: Maybe<SlackWorkspaceLinkType>;
  startDate: Scalars['Date'];
  teacherLeads: ApplicationFilterTypeConnection;
  zoomAccount?: Maybe<ZoomAccountType>;
  zoomSchedules: GroupZoomScheduleTypeConnection;
};


export type GroupsTypeTeacherLeadsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  byGroupId?: InputMaybe<Scalars['Decimal']>;
  first?: InputMaybe<Scalars['Int']>;
  isTerminated?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type GroupsTypeZoomSchedulesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

/** Медаль глазами студента: получена или на каком расстоянии. */
export type GrowthAchievementType = {
  __typename?: 'GrowthAchievementType';
  category: Scalars['String'];
  code: Scalars['String'];
  current: Scalars['Int'];
  description: Scalars['String'];
  earned: Scalars['Boolean'];
  earnedAt?: Maybe<Scalars['DateTime']>;
  hidden: Scalars['Boolean'];
  icon: Scalars['String'];
  locked: Scalars['Boolean'];
  points: Scalars['Int'];
  progressKind: Scalars['String'];
  target: Scalars['Int'];
  title: Scalars['String'];
};

/**
 * Курс в рекомендации трека — чип с названием, без ссылки.
 *
 * Не `CourseType`: тот объявлен `DjangoObjectType` без `fields`/`exclude`,
 * то есть выкладывает наружу ВСЮ модель курса. Тащить его в студенческий
 * контур ради названия — это отдать заодно всё, что к курсу когда-либо
 * припишут.
 *
 * 🔴 Имя строится `links.public_name`, а НЕ дефолтным резолвером. Раньше
 * здесь отдавалось сырое `Course.name` — внутреннее имя ERP со служебными
 * пометками («DEMO · … — выпуск»), — и это не всплывало только потому, что
 * блок «рекомендуем» был ПУСТ у каждого студента: `recommended_courses`
 * ходил через скоупнутый `Course.objects`. Как только скоуп обошли
 * (`services/course_scope.py`), блок наполнился, и внутреннее имя поехало на
 * экран. Ровно то, что вычищено в карте навыков и в «что дальше».
 *
 * Источник — ВИТРИНА САЙТА (`SiteCourse`): фильтровать нечего, в ней по
 * построению лежит только продаваемое, а слаг уникален. Прежде здесь стоял
 * курс из ERP, и приходилось и обходить скоуп юрлица, и вычищать служебные
 * пометки из внутреннего имени.
 *
 * ТЗ 0039, доводка UX: `url` добавлен по претензии владельца — курсы в треке
 * были жёлтыми пилюлями, на которые нельзя нажать. Название курса без
 * перехода на него в продающем разделе — это тупик ровно там, где начинается
 * продажа.
 */
export type GrowthCourseType = {
  __typename?: 'GrowthCourseType';
  id: Scalars['ID'];
  name: Scalars['String'];
  url: Scalars['String'];
};

/**
 * Ступень лестницы уровней (ТЗ 0039, доводка UX).
 *
 * Пороги живут кортежем `GROWTH_LEVELS` в константах и меняются выкатом;
 * дублировать их на фронте значило бы завести вторую правду о том же.
 */
export type GrowthLevelType = {
  __typename?: 'GrowthLevelType';
  index: Scalars['Int'];
  reached: Scalars['Boolean'];
  threshold: Scalars['Int'];
  title: Scalars['String'];
};

/** Экран «Мой рост» целиком. */
export type GrowthOverviewType = {
  __typename?: 'GrowthOverviewType';
  achievements: Array<GrowthAchievementType>;
  availableTotal: Scalars['Int'];
  isCareerMember: Scalars['Boolean'];
  level: Scalars['Int'];
  levelFloorXp: Scalars['Int'];
  levelTitle: Scalars['String'];
  levels: Array<GrowthLevelType>;
  lockedTotal: Scalars['Int'];
  nextLevelXp?: Maybe<Scalars['Int']>;
  tracks: Array<GrowthTrackType>;
  xp: Scalars['Int'];
};

/**
 * Что выдано ИМЕННО ЭТИМ действием (ТЗ 0039, доводка).
 *
 * Возвращается из завершения урока, сдачи анкеты и репоста, чтобы интерфейс
 * показал награду в момент действия. Пустые списки — норма: значит на этот
 * раз ничего нового не заработано, и уведомление показывать не нужно.
 */
export type GrowthRewardType = {
  __typename?: 'GrowthRewardType';
  grantedTitles: Array<Scalars['String']>;
  promoCodes: Array<Scalars['String']>;
};

/**
 * Правило выдачи для формы акции (ТЗ 0039, доводка).
 *
 * Отдаётся сервером по той же причине, что и словарь конструктора анкет:
 * копия списка в TypeScript однажды разойдётся с реестром, и форма предложит
 * правило, которого сервер не знает.
 */
export type GrowthRuleType = {
  __typename?: 'GrowthRuleType';
  label: Scalars['String'];
  paramKey: Scalars['String'];
  progressKind: Scalars['String'];
  value: Scalars['String'];
};

/** Шаг профессии — то, что редактор правит построчно. */
export type GrowthStepErpType = {
  __typename?: 'GrowthStepErpType';
  description: Scalars['String'];
  ruleKind: Scalars['String'];
  ruleParams?: Maybe<Scalars['JSONString']>;
  title: Scalars['String'];
};

export type GrowthStepInput = {
  description?: InputMaybe<Scalars['String']>;
  ruleKind: Scalars['String'];
  ruleParams?: InputMaybe<Scalars['JSONString']>;
  title: Scalars['String'];
};

/** Трек в ERP — только чтение, с составом целей. */
export type GrowthTrackErpType = {
  __typename?: 'GrowthTrackErpType';
  chosenCount?: Maybe<Scalars['Int']>;
  code: Scalars['String'];
  description: Scalars['String'];
  icon: Scalars['String'];
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  longDescription: Scalars['String'];
  order: Scalars['Int'];
  salaryCurrency: Scalars['String'];
  salaryFrom?: Maybe<Scalars['Int']>;
  salaryTo?: Maybe<Scalars['Int']>;
  siteCourseIds: Array<Scalars['ID']>;
  stepRows: Array<GrowthStepErpType>;
  steps: Array<Scalars['String']>;
  targetSkillIds: Array<Scalars['ID']>;
  targetSkills: Array<Scalars['String']>;
  title: Scalars['String'];
};

export type GrowthTrackInput = {
  code: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  icon?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  longDescription?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  salaryCurrency?: InputMaybe<Scalars['String']>;
  salaryFrom?: InputMaybe<Scalars['Int']>;
  salaryTo?: InputMaybe<Scalars['Int']>;
  siteCourseIds?: InputMaybe<Array<Scalars['ID']>>;
  skillIds?: InputMaybe<Array<Scalars['ID']>>;
  steps?: InputMaybe<Array<GrowthStepInput>>;
  title: Scalars['String'];
};

export type GrowthTrackStepType = {
  __typename?: 'GrowthTrackStepType';
  current: Scalars['Int'];
  description: Scalars['String'];
  progressKind: Scalars['String'];
  satisfied: Scalars['Boolean'];
  target: Scalars['Int'];
  title: Scalars['String'];
};

export type GrowthTrackType = {
  __typename?: 'GrowthTrackType';
  chosen: Scalars['Boolean'];
  code: Scalars['String'];
  description: Scalars['String'];
  icon: Scalars['String'];
  missingSkills: Array<SkillType>;
  recommendedCourses: Array<GrowthCourseType>;
  steps: Array<GrowthTrackStepType>;
  stepsDone: Scalars['Int'];
  stepsTotal: Scalars['Int'];
  title: Scalars['String'];
};

/**
 * Parent is a HomeworkAiReview. Staff-facing ONLY — never reachable
 * from the student types below.
 */
export type HomeworkAiReviewType = {
  __typename?: 'HomeworkAiReviewType';
  aiJustification?: Maybe<Scalars['String']>;
  aiModel?: Maybe<Scalars['String']>;
  aiScore?: Maybe<Scalars['Int']>;
  aiSummary?: Maybe<Scalars['String']>;
  analyzedAt?: Maybe<Scalars['DateTime']>;
  assignmentSource?: Maybe<Scalars['String']>;
  errorMessage?: Maybe<Scalars['String']>;
  filesUsedCount?: Maybe<Scalars['Int']>;
  promptVersion?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  suspicionNotes?: Maybe<Scalars['String']>;
  suspiciousContent: Scalars['Boolean'];
  truncatedBasis?: Maybe<Scalars['Boolean']>;
};

/**
 * Parent is {'lesson': GroupLesson, 'assignment': Material|None,
 * 'has_teacher_assignment': bool, 'submission': ..., 'hw_mark': ...,
 * 'can_submit': bool} from services.roster.my_lesson_homework.
 *
 * The assignment is optional (rev.3): when the teacher created nothing,
 * `has_teacher_assignment` is False, `title`/`text` are null, and the LMS
 * shows a "see the lesson materials" note over an open submit form.
 */
export type HomeworkAssignmentForStudentType = {
  __typename?: 'HomeworkAssignmentForStudentType';
  canSubmit: Scalars['Boolean'];
  dueDate?: Maybe<Scalars['Date']>;
  hasTeacherAssignment: Scalars['Boolean'];
  id: Scalars['ID'];
  lessonId: Scalars['ID'];
  mySubmission?: Maybe<MyHomeworkSubmissionType>;
  text?: Maybe<Scalars['String']>;
  textbookRef?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

/** Parent is a materials.Material (kind=HOMEWORK). Staff-facing. */
export type HomeworkAssignmentType = {
  __typename?: 'HomeworkAssignmentType';
  dueDate?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  lessonId: Scalars['ID'];
  text: Scalars['String'];
  textbookRef: Scalars['String'];
  title: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

/**
 * Parent is {'student': Student, 'submission': HomeworkSubmission|None,
 * 'hw_mark': str|None} from services.roster.
 */
export type HomeworkRosterRowType = {
  __typename?: 'HomeworkRosterRowType';
  hwMark?: Maybe<Scalars['String']>;
  studentId: Scalars['ID'];
  studentName: Scalars['String'];
  submission?: Maybe<HomeworkSubmissionType>;
};

/**
 * Parent is a HomeworkSubmission (ai_review/graded_by select_related
 * by the services). Staff-facing.
 */
export type HomeworkSubmissionType = {
  __typename?: 'HomeworkSubmissionType';
  aiReview?: Maybe<HomeworkAiReviewType>;
  attempt: Scalars['Int'];
  fileName?: Maybe<Scalars['String']>;
  fileSizeBytes?: Maybe<Scalars['Int']>;
  githubUrl?: Maybe<Scalars['String']>;
  gradedAt?: Maybe<Scalars['DateTime']>;
  gradedByName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  status: Scalars['String'];
  submittedAt: Scalars['DateTime'];
  teacherComment?: Maybe<Scalars['String']>;
};

export type ImportRunType = {
  __typename?: 'ImportRunType';
  dryRun: Scalars['Boolean'];
  durationSeconds?: Maybe<Scalars['Float']>;
  errorMessage?: Maybe<Scalars['String']>;
  finishedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  startedAt: Scalars['DateTime'];
  /** Кто запустил. Пусто у прогонов по расписанию и у запусков из терминала — там пользователя нет. */
  startedByName?: Maybe<Scalars['String']>;
  stats?: Maybe<Scalars['JSONString']>;
  status: Scalars['String'];
  taskName: Scalars['String'];
  /** beat | cli | erp — по расписанию, из терминала или кнопкой в ERP. */
  triggerSource: Scalars['String'];
};

export type IndividualEntrepreneurInput = {
  accountNumber: Scalars['String'];
  bankTitle: Scalars['String'];
  bic: Scalars['String'];
  inn: Scalars['String'];
  registrationAddress: Scalars['String'];
};

export type IndividualEntrepreneurType = Node & {
  __typename?: 'IndividualEntrepreneurType';
  accountNumber: Scalars['String'];
  bankTitle: Scalars['String'];
  bic: Scalars['String'];
  id: Scalars['ID'];
  inn: Scalars['String'];
  registrationAddress: Scalars['String'];
};

/**
 * Что рассылка уже сделала по одному окну набора (спека 0055).
 *
 * ⚠️ `pending` здесь НЕ «в очереди на отправку». Очереди у домена нет:
 * задача пишет строку и тут же пытается отправить. `pending` означает, что
 * попытка не завершилась — процесс умер между записью и отправкой.
 */
export type IntakeMailType = {
  __typename?: 'IntakeMailType';
  failed: Scalars['Int'];
  /** Когда уйдёт ПЕРВОЕ письмо: за семь дней до открытия. Пусто — если окно не подтверждено, уже началось или закрыто: рассылать по нему нечего или уже поздно. */
  firstPlannedOn?: Maybe<Scalars['Date']>;
  /** Ближайший запуск задачи рассылки. Считается из расписания beat, а не из данных: «письмо запланировано» без времени читается как «когда-нибудь». */
  nextRunAt?: Maybe<Scalars['DateTime']>;
  pending: Scalars['Int'];
  sent: Scalars['Int'];
  waiting: Scalars['Int'];
};

/**
 * A synced `ZoomRecording` offered in the picker.
 *
 * ⚠️ Deliberately does NOT expose `files`. `allZoomRecordings` returns it as
 * `files: JSONString!`, and those entries carry raw Zoom `download_url`s —
 * this narrow type is a security improvement over reusing that query, not just
 * a role workaround.
 */
export type InterviewZoomCandidateType = {
  __typename?: 'InterviewZoomCandidateType';
  accountEmail?: Maybe<Scalars['String']>;
  accountId?: Maybe<Scalars['ID']>;
  durationMinutes: Scalars['Int'];
  /** Zoom produced a TRANSCRIPT/CC file. False means the interview will be video-only until someone pastes a transcript — Zoom only transcribes when *Audio transcript* is enabled on that account, and never retroactively. */
  hasTranscript: Scalars['Boolean'];
  hasVideo: Scalars['Boolean'];
  id: Scalars['ID'];
  isAlreadyAttached: Scalars['Boolean'];
  /** Older than ZOOM_INTERVIEW_RETENTION_WARN_DAYS: Zoom may have expired the download URLs, and a re-sync cannot repair them. */
  retentionWarning: Scalars['Boolean'];
  startTime?: Maybe<Scalars['DateTime']>;
  topic: Scalars['String'];
  totalSizeBytes?: Maybe<Scalars['Float']>;
};

/** What a manual «Обновить из Zoom» actually did. */
export type InterviewZoomRefreshType = {
  __typename?: 'InterviewZoomRefreshType';
  accountsSynced: Scalars['Int'];
  /** True when the 60s double-click guard swallowed the call; the counters are then all zero and nothing was fetched. */
  cooldown: Scalars['Boolean'];
  created: Scalars['Int'];
  skippedNoAccount: Scalars['Int'];
  skippedProcessing: Scalars['Int'];
  updated: Scalars['Int'];
};

/** Выдать код конкретному студенту руками — в обход правила. */
export type IssuePromoCode = {
  __typename?: 'IssuePromoCode';
  code?: Maybe<Scalars['String']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
};

/**
 * ЕДИНСТВЕННОЕ следующее действие.
 *
 * 🔴 Никогда не указывает на заблокированный этап: CTA, который сервер
 * откажет, — худший вид интерфейса, потому что виноватым выглядит человек.
 */
export type JourneyActionType = {
  __typename?: 'JourneyActionType';
  dueDate?: Maybe<Scalars['Date']>;
  estimatedMinutes?: Maybe<Scalars['Int']>;
  expectedOutcome: Scalars['String'];
  id: Scalars['ID'];
  kind: Scalars['String'];
  position?: Maybe<Scalars['Int']>;
  positionTotal?: Maybe<Scalars['Int']>;
  reasonCode: Scalars['String'];
  route: Scalars['String'];
  stageKey?: Maybe<Scalars['String']>;
  subjectTitle: Scalars['String'];
  targetId?: Maybe<Scalars['ID']>;
};

/** Сводка по откликам для дорожной карты. */
export type JourneyApplicationsType = {
  __typename?: 'JourneyApplicationsType';
  active: Scalars['Int'];
  applied: Scalars['Int'];
  hired: Scalars['Int'];
  interview: Scalars['Int'];
  nextFollowUp?: Maybe<CareerApplicationType>;
  offer: Scalars['Int'];
  recent: Array<CareerApplicationType>;
  rejected: Scalars['Int'];
  total: Scalars['Int'];
};

/**
 * Одна проверка полноты резюме.
 *
 * Ключ машинный (`has_name`, `has_skills`, …), подпись подбирает локаль:
 * сервер говорит по-русски, интерфейс — по-польски.
 */
export type JourneyCheckType = {
  __typename?: 'JourneyCheckType';
  isDone: Scalars['Boolean'];
  key: Scalars['String'];
};

/**
 * Возможность, закрытая этому зрителю, и КОД причины.
 *
 * 🔴 Приходит с сервера. Раньше не-участника выбрасывал 404, и продающий
 * раздел приходилось держать на отдельном корне; теперь он остаётся на
 * странице и читает объяснение с одним CTA. Вычислять блокировку на клиенте
 * нельзя — правило разъедется с серверным.
 */
export type JourneyLockedType = {
  __typename?: 'JourneyLockedType';
  key: Scalars['String'];
  reasonCode: Scalars['String'];
};

/**
 * Одно ЧИСЛО маршрута. `target` пуст там, где цели нет вовсе (откликов не
 * бывает «сколько положено»).
 */
export type JourneyMetricType = {
  __typename?: 'JourneyMetricType';
  isBlocked?: Maybe<Scalars['Boolean']>;
  isDone?: Maybe<Scalars['Boolean']>;
  key: Scalars['String'];
  route?: Maybe<Scalars['String']>;
  target?: Maybe<Scalars['Int']>;
  value: Scalars['Int'];
};

/** Готовность по направлению — ПРОЕКЦИЯ этапов, не второй расчёт. */
export type JourneyReadinessType = {
  __typename?: 'JourneyReadinessType';
  key: Scalars['String'];
  level: Scalars['String'];
  target: Scalars['Int'];
  value: Scalars['Int'];
};

/**
 * Один этап маршрута.
 *
 * 🔴 `done`/`total` — ШТУКИ, не проценты. Требование владельца прямое:
 * «7 из 18 карьерных шагов» человеку говорит, что делать, «39%» не говорит
 * ничего. Каждое число берётся из функции, которая обслуживает экран, куда
 * ведёт `route`, — счётчик и кнопка обязаны считать одним предикатом.
 *
 * `isDone` отдаётся сервером, а не выводится клиентом из `done >= total`:
 * при `total == 0` этап НЕ выполнен («учиться нечему» ≠ «отучился»), и
 * клиентская формула ошиблась бы ровно здесь.
 */
export type JourneyStageType = {
  __typename?: 'JourneyStageType';
  blockReason?: Maybe<Scalars['String']>;
  done: Scalars['Int'];
  isBlocked: Scalars['Boolean'];
  isDone: Scalars['Boolean'];
  key: Scalars['String'];
  route: Scalars['String'];
  targetId?: Maybe<Scalars['ID']>;
  total: Scalars['Int'];
};

/**
 * Задача недели. Их не больше трёх, и они НЕ ХРАНЯТСЯ.
 *
 * Хранимая задача потребовала бы срока жизни, ночной уборки и состояния
 * «отклонена». Следствие названо вслух: задачу нельзя отложить, её можно
 * только выполнить.
 */
export type JourneyTaskType = {
  __typename?: 'JourneyTaskType';
  dueDate?: Maybe<Scalars['Date']>;
  key: Scalars['String'];
  route: Scalars['String'];
  subject: Scalars['String'];
  targetId?: Maybe<Scalars['ID']>;
};

export type KnowledgeDescriptionType = {
  __typename?: 'KnowledgeDescriptionType';
  description: Scalars['String'];
  futureKnowledge: FutureKnowledgeType;
  id: Scalars['ID'];
};

export type LmsAuthenticationInput = {
  email: Scalars['String'];
  scope: Scalars['String'];
};

export type LanguageSkillType = {
  __typename?: 'LanguageSkillType';
  id: Scalars['ID'];
  language: Scalars['String'];
  level: Scalars['String'];
};

export type LeadInput = {
  course_id?: InputMaybe<Scalars['Int']>;
  email?: InputMaybe<Scalars['String']>;
  formName: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
  phone: Scalars['String'];
  promocode?: InputMaybe<Scalars['String']>;
  referer?: InputMaybe<Scalars['String']>;
  roistatId: Scalars['String'];
  tittle: Scalars['String'];
  utmCampaign?: InputMaybe<Scalars['String']>;
  utmContent?: InputMaybe<Scalars['String']>;
  utmMedium?: InputMaybe<Scalars['String']>;
  utmSource?: InputMaybe<Scalars['String']>;
  utmTerm?: InputMaybe<Scalars['String']>;
};

export type LegalEntityInput = {
  accountNumber: Scalars['String'];
  bankTitle: Scalars['String'];
  bic: Scalars['String'];
  inn: Scalars['String'];
  registrationAddress: Scalars['String'];
  tittle: Scalars['String'];
};

export type LegalEntityPublicOfferAgreementType = Node & {
  __typename?: 'LegalEntityPublicOfferAgreementType';
  agreementDate: Scalars['Date'];
  content: Scalars['String'];
  displayPage: LegalEntityPublicOfferPageType;
  file: Scalars['String'];
  /** The ID of the object */
  id: Scalars['ID'];
};

export type LegalEntityPublicOfferAgreementTypeConnection = {
  __typename?: 'LegalEntityPublicOfferAgreementTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<LegalEntityPublicOfferAgreementTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `LegalEntityPublicOfferAgreementType` and its cursor. */
export type LegalEntityPublicOfferAgreementTypeEdge = {
  __typename?: 'LegalEntityPublicOfferAgreementTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<LegalEntityPublicOfferAgreementType>;
};

export type LegalEntityPublicOfferPageType = {
  __typename?: 'LegalEntityPublicOfferPageType';
  actualPublicOfferAgreement?: Maybe<LegalEntityPublicOfferAgreementType>;
  id: Scalars['ID'];
  publicOfferAgreements: LegalEntityPublicOfferAgreementTypeConnection;
  seoDescription: Scalars['String'];
  seoImage: Scalars['String'];
  seoKeywords: Scalars['String'];
  seoTitle: Scalars['String'];
  title: Scalars['String'];
};


export type LegalEntityPublicOfferPageTypePublicOfferAgreementsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type LegalEntityType = Node & {
  __typename?: 'LegalEntityType';
  accountNumber: Scalars['String'];
  bankTitle: Scalars['String'];
  bic: Scalars['String'];
  id: Scalars['ID'];
  inn: Scalars['String'];
  registrationAddress: Scalars['String'];
  tittle: Scalars['String'];
};

export type LessonAttachmentsForLmsType = {
  __typename?: 'LessonAttachmentsForLMSType';
  file: Scalars['String'];
  id: Scalars['ID'];
  title: Scalars['String'];
};

export type LessonAttachmentsType = {
  __typename?: 'LessonAttachmentsType';
  file?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  title?: Maybe<Scalars['String']>;
};

export type LessonAttendancesType = Node & {
  __typename?: 'LessonAttendancesType';
  attendance?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  lesson: GroupLessonType;
  markedAt?: Maybe<Scalars['DateTime']>;
  markedByName?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  student: StudentType;
};

/**
 * Parent is the stats dict from services.eligibility
 * (homework_stats_for_lessons) — dict keys match the snake_case field
 * names, so graphene's default resolver handles them.
 */
export type LessonHomeworkStatsType = {
  __typename?: 'LessonHomeworkStatsType';
  aiDoneCount: Scalars['Int'];
  /** Строка преподавателя «глава 7, задачи 1–4», если есть. */
  assignmentRef?: Maybe<Scalars['String']>;
  /** teacher_text | teacher_ref | textbook | none. `none` = задания нет И учебник не прикреплён — единственное значение, требующее действия. */
  assignmentSource: Scalars['String'];
  gradedCount: Scalars['Int'];
  hasAssignment: Scalars['Boolean'];
  lessonId: Scalars['ID'];
  submittedCount: Scalars['Int'];
  suspiciousCount: Scalars['Int'];
  textbookFileCount: Scalars['Int'];
  textbookFileName?: Maybe<Scalars['String']>;
  totalStudents: Scalars['Int'];
};

export type LessonInput = {
  additional?: InputMaybe<Scalars['Boolean']>;
  lmsDescription?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  studentsAttachments?: InputMaybe<Array<Scalars['Int']>>;
  taskTypes?: InputMaybe<Array<Scalars['String']>>;
  teachersAttachments?: InputMaybe<Array<Scalars['Int']>>;
};

/**
 * ERP «Кто заходил» по занятию (spec 0013, уточнён ТЗ 0026).
 *
 * Строка = ЧЕЛОВЕК, а не клик: до 0026 тип резолвился из сырых
 * `LessonJoinClick`, и счётчик в заголовке поповера считал нажатия, а не
 * людей. Теперь резолвится из dict-ов `clicks_with_attendance`, `clickedAt`
 * — время первого входа, а `attendanceState` показывает расхождение между
 * «заходил» и тем, что стоит в журнале.
 */
export type LessonJoinClickType = {
  __typename?: 'LessonJoinClickType';
  /** present | absent | unmarked | none */
  attendanceState: Scalars['String'];
  clickedAt: Scalars['DateTime'];
  clicksCount: Scalars['Int'];
  id: Scalars['ID'];
  role?: Maybe<Scalars['String']>;
  userName: Scalars['String'];
};

export type LessonMarkInput = {
  hwMark?: InputMaybe<StudentHwTypeEnum>;
  mark?: InputMaybe<Scalars['Int']>;
  student_id: Scalars['Int'];
};

export type LessonRecordingConnection = {
  __typename?: 'LessonRecordingConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<LessonRecordingEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `LessonRecording` and its cursor. */
export type LessonRecordingEdge = {
  __typename?: 'LessonRecordingEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<LessonRecordingType>;
};

/** An enumeration. */
export enum LessonRecordingMatchedBy {
  /** Auto */
  Auto = 'AUTO',
  /** Manual */
  Manual = 'MANUAL'
}

/** An enumeration. */
export enum LessonRecordingStatus {
  /** AI completed */
  AiCompleted = 'AI_COMPLETED',
  /** AI processing */
  AiProcessing = 'AI_PROCESSING',
  /** Downloading */
  Downloading = 'DOWNLOADING',
  /** Failed */
  Failed = 'FAILED',
  /** Matched */
  Matched = 'MATCHED',
  /** Published */
  Published = 'PUBLISHED',
  /** Skipped */
  Skipped = 'SKIPPED',
  /** Uploaded */
  Uploaded = 'UPLOADED'
}

export type LessonRecordingType = Node & {
  __typename?: 'LessonRecordingType';
  aiModel: Scalars['String'];
  aiSummary: Scalars['String'];
  aiTimecodes: Scalars['JSONString'];
  ambiguous: Scalars['Boolean'];
  audioS3Key: Scalars['String'];
  /** Processing is stopped (or stalled) and can be resumed. */
  canResume: Scalars['Boolean'];
  chatS3Key: Scalars['String'];
  createdAt: Scalars['DateTime'];
  errorMessage: Scalars['String'];
  /** The ID of the object */
  id: Scalars['ID'];
  lastAttemptAt?: Maybe<Scalars['DateTime']>;
  lesson?: Maybe<GroupLessonForLmsType>;
  matchedBy: LessonRecordingMatchedBy;
  matchedByUser?: Maybe<CustomUserType>;
  processingLogs?: Maybe<Array<Maybe<ZoomProcessingLogType>>>;
  retryCount: Scalars['Int'];
  status: LessonRecordingStatus;
  transcriptS3Key: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  zoomRecording?: Maybe<ZoomRecordingType>;
};

/**
 * Что даёт занятие — глазами студента (ТЗ 0040, доводка).
 *
 * Живёт в карьерном домене, а отдаётся студенческим типом группы: связка
 * «курс → навык → занятие» принадлежит карьере, а спрашивают её с расписания.
 */
export type LessonSkillUnlockType = {
  __typename?: 'LessonSkillUnlockType';
  isOver: Scalars['Boolean'];
  lessonId?: Maybe<Scalars['ID']>;
  lessonNumber: Scalars['Int'];
  skills: Array<SkillType>;
};

/** An enumeration. */
export enum LessonTaskTypeEnum {
  /** coursework */
  Coursework = 'coursework',
  /** graduation_project */
  GraduationProject = 'graduation_project',
  /** homework */
  Homework = 'homework'
}

/**
 * Файл учебника занятия — `groups.StudentAttachment` (ТЗ 0026).
 *
 * ⚠️ Ссылки здесь НЕТ намеренно. `LessonAttachmentsType.resolve_file`
 * минтит presigned-URL с TTL 20 секунд; положив его в карточку ДЗ, мы бы
 * отдали студенту заведомо протухшую ссылку. Клиент получает `id` и
 * открывает файл существующим просмотрщиком, который минтит URL в момент
 * клика.
 */
export type LessonTextbookFileType = {
  __typename?: 'LessonTextbookFileType';
  fileName: Scalars['String'];
  id: Scalars['ID'];
  isPdf: Scalars['Boolean'];
  title: Scalars['String'];
};

/**
 * Pin a funnel person to an account by hand.
 *
 * The manual decision is durable: `user_locked` stops the automatic
 * re-matcher from ever re-pointing this row.
 */
export type LinkCandidateToUser = {
  __typename?: 'LinkCandidateToUser';
  candidate?: Maybe<FundingCandidateType>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
};

/** Map a Slack channel id to a Group. */
export type LinkChannelGroupMutation = {
  __typename?: 'LinkChannelGroupMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type LinkContributionInput = {
  contributionId: Scalars['ID'];
  paymentId: Scalars['ID'];
};

/**
 * Attach an existing Payment to an existing Contribution (1:1).
 *
 * Used by the frontend "Перепривязать" / "Привязать существующий платёж"
 * action on the schedule row. The happy path also flips
 * `contribution.complete=True` and recomputes `remainder` via
 * `Contribution.save()` (§9.5).
 */
export type LinkContributionToPaymentMutation = {
  __typename?: 'LinkContributionToPaymentMutation';
  contribution?: Maybe<ContributionType>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  payment?: Maybe<PaymentType>;
  success?: Maybe<Scalars['Boolean']>;
};

export type LinkLessonWhiteboardMutation = {
  __typename?: 'LinkLessonWhiteboardMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
  whiteboard?: Maybe<WhiteboardType>;
};

/**
 * Attach a PandaDoc document to an existing agreement (manual link from
 * the student card). Does not create a Student/Agreement and does not touch
 * `provisioned_at`.
 */
export type LinkPandadocDocumentMutation = {
  __typename?: 'LinkPandadocDocumentMutation';
  document?: Maybe<PandaDocDocumentType>;
  errors?: Maybe<Scalars['JSONString']>;
};

/**
 * Attach a `trainer` PandaDoc document to a Teacher (from the teacher
 * card). The teacher analog of LinkPandadocDocumentMutation.
 */
export type LinkPandadocTeacherMutation = {
  __typename?: 'LinkPandadocTeacherMutation';
  document?: Maybe<PandaDocDocumentType>;
  errors?: Maybe<Scalars['JSONString']>;
};

/**
 * Map a Slack user id to a Student OR a Teacher (for DM mirroring). The
 * manual fallback for auto-matching by email — a person may sit in Slack
 * under an email we don't know.
 */
export type LinkSlackUserMutation = {
  __typename?: 'LinkSlackUserMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
};

/**
 * Read-only public subset of `students.StudentAccessBlock` for the LMS.
 *
 * Only the fields the LMS banner needs — never the operator/audit fields.
 * Resolves to None unless the student is actually blocked, so `me
 * { lmsAccessBlock }` is null for everyone with access.
 *
 * `reason` holds the operator's internal note and MUST NOT reach the
 * student, so it always resolves to null (see resolve_lms_access_block).
 * The field is kept on the type only so the LMS `UserFields` fragment that
 * still selects `reason` stays valid.
 *
 * ТЗ 0074: `blocked_at` + `amounts_due` — what the student still owes on the
 * invoices the suspension is tied to, PER CURRENCY (never added up).
 * `overdue_amount` is the pre-0074 single-number snapshot.
 */
export type LmsAccessBlockType = {
  __typename?: 'LmsAccessBlockType';
  amountsDue: Array<LmsAmountDueType>;
  blockedAt?: Maybe<Scalars['DateTime']>;
  isBlocked: Scalars['Boolean'];
  overdueAmount?: Maybe<Scalars['Float']>;
  reason?: Maybe<Scalars['String']>;
};

/** An amount in ONE currency (ТЗ 0074) — currencies are never summed. */
export type LmsAmountDueType = {
  __typename?: 'LmsAmountDueType';
  amount: Scalars['Float'];
  currency: Scalars['String'];
};

export type LmsAttendanceType = {
  attendance: Scalars['Boolean'];
  id: Scalars['Int'];
};

export type LmsBlockEventType = {
  __typename?: 'LmsBlockEventType';
  /** suspended | restored */
  action: Scalars['String'];
  /** Null for the robot. */
  actorName?: Maybe<Scalars['String']>;
  amountsDue: Array<LmsAmountDueType>;
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  invoices: Array<LmsBlockInvoiceType>;
  notifications: Array<LmsBlockNotificationType>;
  notifyStudent: Scalars['Boolean'];
  reason?: Maybe<Scalars['String']>;
  /** robot | manual */
  source: Scalars['String'];
};

/**
 * An invoice a suspension is (or was) tied to. Live rows carry the
 * current outstanding; history rows the snapshot taken at the event.
 */
export type LmsBlockInvoiceType = {
  __typename?: 'LmsBlockInvoiceType';
  /** Still owed (net of corrections). */
  amount?: Maybe<Scalars['Float']>;
  currency?: Maybe<Scalars['String']>;
  daysOverdue: Scalars['Int'];
  fakturowniaId?: Maybe<Scalars['String']>;
  gross?: Maybe<Scalars['Float']>;
  invoiceId?: Maybe<Scalars['ID']>;
  isPaid?: Maybe<Scalars['Boolean']>;
  number?: Maybe<Scalars['String']>;
  paymentTo?: Maybe<Scalars['Date']>;
  paymentUrl?: Maybe<Scalars['String']>;
  viewUrl?: Maybe<Scalars['String']>;
};

export type LmsBlockNotificationType = {
  __typename?: 'LmsBlockNotificationType';
  /** email | slack */
  channel: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  error?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  /** suspended | restored */
  kind: Scalars['String'];
  sentAt?: Maybe<Scalars['DateTime']>;
  skipReason?: Maybe<Scalars['String']>;
  /** pending | sending | sent | skipped | failed */
  status: Scalars['String'];
};

export type LmsBlockRunType = {
  __typename?: 'LmsBlockRunType';
  errorMessage?: Maybe<Scalars['String']>;
  finishedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  startedAt?: Maybe<Scalars['DateTime']>;
  stats?: Maybe<Scalars['JSONString']>;
  /** running | success | failed */
  status: Scalars['String'];
  taskName: Scalars['String'];
  triggerSource?: Maybe<Scalars['String']>;
};

export type LmsBlockSendgridTemplatesType = {
  __typename?: 'LmsBlockSendgridTemplatesType';
  /** sendgrid_unavailable | sendgrid_forbidden */
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  success: Scalars['Boolean'];
  templates: Array<SendgridTemplateType>;
};

/**
 * Partial update: an omitted / null field keeps its value. A template id
 * `""` clears the template. Template NAMES are not accepted — they are read
 * from SendGrid.
 */
export type LmsBlockSettingsInput = {
  mailEnabled?: InputMaybe<Scalars['Boolean']>;
  overdueDays?: InputMaybe<Scalars['Int']>;
  restoredTemplateId?: InputMaybe<Scalars['String']>;
  robotEnabled?: InputMaybe<Scalars['Boolean']>;
  slackEnabled?: InputMaybe<Scalars['Boolean']>;
  suspendedTemplateId?: InputMaybe<Scalars['String']>;
};

export type LmsBlockSettingsType = {
  __typename?: 'LmsBlockSettingsType';
  /** Admin / FinanceManager — may call saveLmsBlockSettings and sendLmsBlockTestEmail. */
  canEdit: Scalars['Boolean'];
  mailEnabled: Scalars['Boolean'];
  /** Days past payment_to before an invoice suspends access (1..90). */
  overdueDays: Scalars['Int'];
  restoredTemplateId?: Maybe<Scalars['String']>;
  restoredTemplateName?: Maybe<Scalars['String']>;
  /** ERP switch; effective only together with serverRobotAllowed. */
  robotEnabled: Scalars['Boolean'];
  /** env LMS_BLOCK_MAIL_ENABLED — master switch for emails and the test email. */
  serverMailAllowed: Scalars['Boolean'];
  /** env LMS_BLOCK_ROBOT_ENABLED — master switch; false → the robot never runs. */
  serverRobotAllowed: Scalars['Boolean'];
  /** env LMS_BLOCK_SLACK_ENABLED. */
  serverSlackAllowed: Scalars['Boolean'];
  slackEnabled: Scalars['Boolean'];
  suspendedTemplateId?: Maybe<Scalars['String']>;
  suspendedTemplateName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedByName?: Maybe<Scalars['String']>;
};

/** A field of one element of a list variable (`invoices[]`, `totals[]`). */
export type LmsBlockTemplateVariableFieldType = {
  __typename?: 'LmsBlockTemplateVariableFieldType';
  descriptionPl: Scalars['String'];
  descriptionRu: Scalars['String'];
  /** Value in the example data (first list element). */
  example?: Maybe<Scalars['JSONString']>;
  name: Scalars['String'];
  /** string | number */
  type: Scalars['String'];
};

export type LmsBlockTemplateVariableType = {
  __typename?: 'LmsBlockTemplateVariableType';
  descriptionPl: Scalars['String'];
  descriptionRu: Scalars['String'];
  /** Value in lmsBlockTemplateExample(kind: "suspended"). */
  example?: Maybe<Scalars['JSONString']>;
  /** Element fields of a list variable; empty for scalars. */
  fields: Array<LmsBlockTemplateVariableFieldType>;
  name: Scalars['String'];
  /** string | number | list */
  type: Scalars['String'];
};

export type LmsClearTodayLessonLink = {
  __typename?: 'LmsClearTodayLessonLink';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type LmsJoinLesson = {
  __typename?: 'LmsJoinLesson';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  redirectUrl?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

/**
 * Подсказка журнала преподавателя: первый клик студента (spec 0013).
 * Резолвится из dict-ов сервиса first_clicks_per_student.
 */
export type LmsLessonJoinClickType = {
  __typename?: 'LmsLessonJoinClickType';
  clickedAt: Scalars['DateTime'];
  studentId: Scalars['Int'];
  studentName: Scalars['String'];
};

/** An enumeration. */
export enum LmsRoles {
  /** Methodist */
  Methodist = 'METHODIST',
  /** Student */
  Student = 'STUDENT',
  /** Teacher */
  Teacher = 'TEACHER'
}

/**
 * Поштучная отметка преподавателем из LMS (ТЗ 0026).
 *
 * Заменяет пакетное сохранение внутри `finishLmsLesson`. Возвращает ту же
 * сущность `LessonAttendancesType`, что отдаёт `groupLessonAttendanceForLms`
 * — Apollo нормализует её по `id`, поэтому оптимистичное обновление на
 * фронте работает без ручного `cache.modify`.
 */
export type LmsSetAttendanceMutation = {
  __typename?: 'LmsSetAttendanceMutation';
  attendance?: Maybe<LessonAttendancesType>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type LmsSetTodayLessonLink = {
  __typename?: 'LmsSetTodayLessonLink';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type LmsSuspensionGroupType = {
  __typename?: 'LmsSuspensionGroupType';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type LmsSuspensionPageType = {
  __typename?: 'LmsSuspensionPageType';
  items: Array<LmsSuspensionRowType>;
  total: Scalars['Int'];
};

/**
 * One row of the «Wstrzymany dostęp» tab.
 *
 * * `active` — a current suspension: live `invoices`, notifications of the
 *   suspension event;
 * * `history` — one restoration: `blockedAt/By/source` from the suspension
 *   it ended, `restoredAt/By/Source` from the restoration, invoices as
 *   snapshotted at suspension, notifications of BOTH events (see `kind`);
 * * `skipped` — not suspended although an invoice is past the threshold:
 *   `skipReason` (`waiting_dofinansowanie` | `waived`), live invoices.
 */
export type LmsSuspensionRowType = {
  __typename?: 'LmsSuspensionRowType';
  amountsDue: Array<LmsAmountDueType>;
  blockedAt?: Maybe<Scalars['DateTime']>;
  blockedByName?: Maybe<Scalars['String']>;
  groups: Array<LmsSuspensionGroupType>;
  invoices: Array<LmsBlockInvoiceType>;
  notifications: Array<LmsBlockNotificationType>;
  reason?: Maybe<Scalars['String']>;
  restoredAt?: Maybe<Scalars['DateTime']>;
  restoredByName?: Maybe<Scalars['String']>;
  restoredSource?: Maybe<Scalars['String']>;
  skipReason?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  studentEmail?: Maybe<Scalars['String']>;
  studentId: Scalars['ID'];
  studentName: Scalars['String'];
};

/** A mailing run: live send progress plus aggregate delivery telemetry. */
export type MailJobType = {
  __typename?: 'MailJobType';
  bouncedCount: Scalars['Int'];
  clickedCount: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  createdByName?: Maybe<Scalars['String']>;
  deliveredCount: Scalars['Int'];
  errorMessage: Scalars['String'];
  failedCount: Scalars['Int'];
  finishedAt?: Maybe<Scalars['DateTime']>;
  fromEmail: Scalars['String'];
  id: Scalars['ID'];
  openedCount: Scalars['Int'];
  recipients: Array<MailRecipientType>;
  sentCount: Scalars['Int'];
  startedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<Scalars['String']>;
  /** Blank ⇒ the template's own subject is used. */
  subjectOverride: Scalars['String'];
  templateId: Scalars['String'];
  templateName: Scalars['String'];
  total: Scalars['Int'];
};

export type MailRecipientInput = {
  /** Invoice to reference in the email. Omit for templates that don't mention one (e.g. 'course starts soon'). */
  invoiceId?: InputMaybe<Scalars['ID']>;
  studentId: Scalars['ID'];
};

/** Per-recipient outcome: whether we sent it, and what SendGrid reported. */
export type MailRecipientType = {
  __typename?: 'MailRecipientType';
  bounceReason: Scalars['String'];
  bouncedAt?: Maybe<Scalars['DateTime']>;
  clickCount: Scalars['Int'];
  deliveredAt?: Maybe<Scalars['DateTime']>;
  dropReason: Scalars['String'];
  droppedAt?: Maybe<Scalars['DateTime']>;
  /** Snapshot of the address used — the account email may change later. */
  email: Scalars['String'];
  firstClickedAt?: Maybe<Scalars['DateTime']>;
  firstOpenedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  invoiceCurrency?: Maybe<Scalars['String']>;
  invoiceNumber?: Maybe<Scalars['String']>;
  invoiceOutstanding?: Maybe<Scalars['Float']>;
  lastClickUrl: Scalars['String'];
  openCount: Scalars['Int'];
  reason: Scalars['String'];
  sentAt?: Maybe<Scalars['DateTime']>;
  spamAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<Scalars['String']>;
  studentId: Scalars['ID'];
  studentName: Scalars['String'];
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
};

export type MainPageInfoType = {
  __typename?: 'MainPageInfoType';
  description: Scalars['String'];
  id: Scalars['ID'];
  image: Scalars['String'];
  seoDescription: Scalars['String'];
  seoImage: Scalars['String'];
  seoKeywords: Scalars['String'];
  seoTitle: Scalars['String'];
  title: Scalars['String'];
};

export type MainTeacherWebType = Node & {
  __typename?: 'MainTeacherWebType';
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  mainTeachers: TeacherFilterTypeConnection;
  title?: Maybe<Scalars['String']>;
};


export type MainTeacherWebTypeMainTeachersArgs = {
  after?: InputMaybe<Scalars['String']>;
  availability?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  course?: InputMaybe<Scalars['Decimal']>;
  first?: InputMaybe<Scalars['Int']>;
  hasDescription?: InputMaybe<Scalars['Boolean']>;
  hasInterview?: InputMaybe<Scalars['Boolean']>;
  hasPhoto?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  minRating?: InputMaybe<Scalars['Decimal']>;
  offset?: InputMaybe<Scalars['Int']>;
  siteDisplay?: InputMaybe<Scalars['Boolean']>;
};

export type MainTeacherWebTypeConnection = {
  __typename?: 'MainTeacherWebTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<MainTeacherWebTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `MainTeacherWebType` and its cursor. */
export type MainTeacherWebTypeEdge = {
  __typename?: 'MainTeacherWebTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<MainTeacherWebType>;
};

/** «Прочитать всё». */
export type MarkAllStaffNotificationsRead = {
  __typename?: 'MarkAllStaffNotificationsRead';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
  summary?: Maybe<StaffNotificationsSummaryType>;
};

/** LMS: record that the student opened a lesson — viewed, NOT completed. */
export type MarkCareerLessonOpened = {
  __typename?: 'MarkCareerLessonOpened';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  openCount?: Maybe<Scalars['Int']>;
  success?: Maybe<Scalars['Boolean']>;
};

/**
 * Record an off-invoice payment against an installment.
 *
 * ТЗ 0029: writes `manual_paid_amount` / `manual_paid_date` on the instalment
 * itself — no hidden ledger row. Amount defaults to the remainder. The row
 * then reads «оплачен вручную» (fully covered with zero invoice money).
 */
export type MarkContributionPaidManuallyMutation = {
  __typename?: 'MarkContributionPaidManuallyMutation';
  contribution?: Maybe<ContributionType>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
};

/**
 * Set the read flag on every message of a conversation.
 *
 * `read=false` is «Вернуть в работу»: it clears `is_handled` on the inbound
 * messages too (spec 0030 round 2). Clearing only `is_read` produced an
 * unread-but-handled dialog, which is EXCLUDED from the `unhandledOnly`
 * queue — so the manager's "I'll come back to this" gesture removed the
 * dialog from the very list they come back through. It is also the only
 * thread-level way back from a cascade or a bulk clear.
 */
export type MarkConversationReadMutation = {
  __typename?: 'MarkConversationReadMutation';
  conversation?: Maybe<ConversationType>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
  updated?: Maybe<Scalars['Int']>;
};

/**
 * Bulk «Прочитано и обработано» over a scope (spec 0030).
 *
 * The whole point of the communicator rework: closing an inbox used to cost
 * one click per message per student per channel. This sets both flags over
 * a whole dialog, student, group, or the entire filtered browser list, in a
 * constant number of statements.
 *
 * Reversible, not one-directional (round 2): the payload carries the exact
 * ids it flipped so `revertMessagesTriage` can put them back. Both UPDATEs
 * only ever go False → True, so reverting those very rows to False restores
 * the prior state exactly — no "was it already read?" guessing.
 */
export type MarkConversationsHandledMutation = {
  __typename?: 'MarkConversationsHandledMutation';
  conversations?: Maybe<Array<ConversationType>>;
  conversationsAffected?: Maybe<Scalars['Int']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  handledMessageIds?: Maybe<Array<Scalars['ID']>>;
  messagesAffected?: Maybe<Scalars['Int']>;
  messagesHandled?: Maybe<Scalars['Int']>;
  messagesRead?: Maybe<Scalars['Int']>;
  readMessageIds?: Maybe<Array<Scalars['ID']>>;
  success?: Maybe<Scalars['Boolean']>;
  truncated?: Maybe<Scalars['Boolean']>;
  undoable?: Maybe<Scalars['Boolean']>;
};

export type MarkLessonMissingRecordingMutation = {
  __typename?: 'MarkLessonMissingRecordingMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  lessonRecording?: Maybe<LessonRecordingType>;
  success?: Maybe<Scalars['Boolean']>;
};

/** Mark one message read/unread (team-wide global state). */
export type MarkMessageReadMutation = {
  __typename?: 'MarkMessageReadMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  message?: Maybe<MessageType>;
  success?: Maybe<Scalars['Boolean']>;
};

/** Отметить конкретные строки прочитанными. */
export type MarkStaffNotificationsRead = {
  __typename?: 'MarkStaffNotificationsRead';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
  summary?: Maybe<StaffNotificationsSummaryType>;
};

/** LMS: a member saves a vacancy or marks that they applied. */
export type MarkVacancyInteraction = {
  __typename?: 'MarkVacancyInteraction';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
  vacancy?: Maybe<VacancyType>;
};

export type MarketingModuleType = {
  __typename?: 'MarketingModuleType';
  description: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
};

/**
 * A document this row might be explaining.
 *
 * Offered rather than applied whenever the answer is not unambiguous: a wrong
 * link is worse than none, because it looks reconciled.
 */
export type MatchCandidateType = {
  __typename?: 'MatchCandidateType';
  amount?: Maybe<Scalars['Float']>;
  confidence?: Maybe<Scalars['Int']>;
  label?: Maybe<Scalars['String']>;
  strategy?: Maybe<Scalars['String']>;
  targetId?: Maybe<Scalars['Int']>;
  targetType?: Maybe<Scalars['String']>;
};

/**
 * Dry-run: propose a (student, language) for each file NAME.
 *
 * A mutation rather than a query only because clients treat it as an action;
 * it performs no writes.
 */
export type MatchDiplomaFilesMutation = {
  __typename?: 'MatchDiplomaFilesMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  preview?: Maybe<DiplomaMatchPreviewType>;
  success?: Maybe<Scalars['Boolean']>;
};

export type MaterialAttachmentType = {
  __typename?: 'MaterialAttachmentType';
  contentType: Scalars['String'];
  id: Scalars['ID'];
  material: MaterialType;
  originalName: Scalars['String'];
  pk?: Maybe<Scalars['Int']>;
  sizeBytes: Scalars['Int'];
  uploadedAt: Scalars['DateTime'];
  /** Signed S3 URL with the project's default TTL. The frontend treats this as opaque; the link expires after `LESSON_RECORDING_VIDEO_EXPIRE` (settings). */
  url?: Maybe<Scalars['String']>;
};

/** An enumeration. */
export enum MaterialKindEnum {
  Homework = 'HOMEWORK',
  Other = 'OTHER',
  Reading = 'READING',
  Video = 'VIDEO'
}

export type MaterialType = {
  __typename?: 'MaterialType';
  attachments: Array<MaterialAttachmentType>;
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<CustomUserType>;
  description: Scalars['String'];
  /** HOMEWORK only; ignored for other kinds. */
  dueDate?: Maybe<Scalars['Date']>;
  group: MethodistGroupType;
  id: Scalars['ID'];
  kind: MaterialKindEnum;
  /** Optional — for group-wide handouts leave NULL; for per-lesson homework point at the specific GroupLesson. */
  lesson?: Maybe<GroupLessonType>;
  pk?: Maybe<Scalars['Int']>;
  title: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

/** Состояние MCP-доступа текущего пользователя. */
export type McpAccessType = {
  __typename?: 'McpAccessType';
  /** Почему подключиться нельзя, если `enabled` = false. Пусто, когда всё в порядке. Без этого поля страница показывала зелёный статус пользователю без юрлица, а клиент получал отказ на первом же вызове. */
  blockedReason?: Maybe<Scalars['String']>;
  callsLast30Days: Scalars['Int'];
  connections: Array<McpConnectionType>;
  /** Можно ли этому пользователю подключить ИИ ПРЯМО СЕЙЧАС: проверены все условия входа, а не только рубильник. */
  enabled: Scalars['Boolean'];
  /** Адрес, который вводят в клиенте. Пуст, если MCP выключен или не настроен MCP_PUBLIC_URL. */
  endpoint?: Maybe<Scalars['String']>;
};

/**
 * Живое подключение внешнего ИИ.
 *
 * Подключение — это REFRESH-токен, а не access. Access живёт 8 часов и
 * пересоздаётся при каждом обновлении, refresh — 30 дней; список, собранный
 * по access-токенам, показывал «Пока никто не подключён» уже наутро после
 * подключения, хотя клиент был жив и восстанавливался сам. Кнопки «Отозвать»
 * в этот момент просто не существовало.
 */
export type McpConnectionType = {
  __typename?: 'McpConnectionType';
  /** Название клиента, который подключился (Claude и т.п.) */
  application?: Maybe<Scalars['String']>;
  /** Когда подключение последний раз обновлялось. НЕ время первого подключения: токены ротируются, и при каждом обновлении дата сдвигается. */
  created?: Maybe<Scalars['DateTime']>;
  /** Когда истекает текущий короткий токен доступа. Само подключение переживает эту дату — клиент обновит токен молча. Пусто, если активного токена сейчас нет. */
  expires?: Maybe<Scalars['DateTime']>;
  /** Непрозрачный идентификатор подключения. Передаётся в `revokeMcpConnection` как есть; разбирать его не нужно. */
  id: Scalars['ID'];
  /** Последний вызов инструмента этим пользователем — берётся из журнала MCP, а не из самого токена. */
  lastUsed?: Maybe<Scalars['DateTime']>;
  scope?: Maybe<Scalars['String']>;
};

/**
 * Рост и бонусы студента глазами менеджера (ТЗ 0039, доводка).
 *
 * 🔴 Ради этого блока всё и затевалось с точки зрения продаж: следующий курс
 * оформляет живой человек, а он про промокод студента не знал ничего —
 * коды лежали в отдельной вкладке, найти их можно было только поиском по
 * фамилии, то есть в момент разговора — никогда.
 */
export type MemberGrowthType = {
  __typename?: 'MemberGrowthType';
  codes: Array<PromoCodeType>;
  level: Scalars['Int'];
  levelTitle: Scalars['String'];
  medalsEarned: Scalars['Int'];
  medalsTotal: Scalars['Int'];
  nextCourses: Array<NextCourseType>;
  trackIsDefault: Scalars['Boolean'];
  trackTitle?: Maybe<Scalars['String']>;
  xp: Scalars['Int'];
};

/** Слить дубль справочника в целевой навык («React» и «ReactJS»). */
export type MergeCareerSkills = {
  __typename?: 'MergeCareerSkills';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  movedCourseSkills?: Maybe<Scalars['Int']>;
  movedProjects?: Maybe<Scalars['Int']>;
  movedStudentSkills?: Maybe<Scalars['Int']>;
  movedVacancies?: Maybe<Scalars['Int']>;
  skill?: Maybe<SkillType>;
  success?: Maybe<Scalars['Boolean']>;
};

/**
 * Keyset (sent_at, id) connection — correct under head inserts, unlike an
 * offset cursor that would skip/dup as new messages arrive.
 */
export type MessageConnection = {
  __typename?: 'MessageConnection';
  edges?: Maybe<Array<MessageEdge>>;
  pageInfo?: Maybe<MessagePageInfo>;
};

export type MessageEdge = {
  __typename?: 'MessageEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<MessageType>;
};

export type MessagePageInfo = {
  __typename?: 'MessagePageInfo';
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage?: Maybe<Scalars['Boolean']>;
};

export type MessageType = {
  __typename?: 'MessageType';
  /** Human name of the author: stored author_name (Gmail / reply mirrors) → workspace member name from SlackUserLink (linked student «Фамилия Имя», otherwise Slack display name) → the raw external id. */
  authorDisplay?: Maybe<Scalars['String']>;
  authorExternalId: Scalars['String'];
  authorName: Scalars['String'];
  body: Scalars['String'];
  channelName?: Maybe<Scalars['String']>;
  conversationId?: Maybe<Scalars['ID']>;
  direction?: Maybe<Scalars['String']>;
  externalId: Scalars['String'];
  id: Scalars['ID'];
  isFlagged: Scalars['Boolean'];
  isHandled: Scalars['Boolean'];
  isRead: Scalars['Boolean'];
  kind?: Maybe<Scalars['String']>;
  linkedTask?: Maybe<StaffTaskType>;
  sentAt: Scalars['DateTime'];
};

export type MetaContribution = {
  __typename?: 'MetaContribution';
  /** Deprecated from 1.3.0 version. */
  contributionsCount?: Maybe<Scalars['Int']>;
  contributionsNums: Array<Maybe<Scalars['Int']>>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type MetaCourses = {
  __typename?: 'MetaCourses';
  totalCount?: Maybe<Scalars['Int']>;
};

export type MetaDeferredPayment = Node & {
  __typename?: 'MetaDeferredPayment';
  deferredPaymentsDate?: Maybe<Scalars['Date']>;
  /** The ID of the object */
  id: Scalars['ID'];
  totalCount?: Maybe<Scalars['Int']>;
};

export type MetaDeferredPaymentConnection = {
  __typename?: 'MetaDeferredPaymentConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<MetaDeferredPaymentEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `MetaDeferredPayment` and its cursor. */
export type MetaDeferredPaymentEdge = {
  __typename?: 'MetaDeferredPaymentEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<MetaDeferredPayment>;
};

export type MetaGroups = {
  __typename?: 'MetaGroups';
  totalCount?: Maybe<Scalars['Int']>;
};

export type MetaStudents = {
  __typename?: 'MetaStudents';
  agreementsCount?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type MetaTeacherApplications = {
  __typename?: 'MetaTeacherApplications';
  totalCount?: Maybe<Scalars['Int']>;
};

export type MetaTeachers = {
  __typename?: 'MetaTeachers';
  /** Returns applications count */
  applicationsCount?: Maybe<Scalars['Int']>;
  /** Returns teachers count */
  totalCount?: Maybe<Scalars['Int']>;
};

export type MetaUsersSettings = {
  __typename?: 'MetaUsersSettings';
  totalCount?: Maybe<Scalars['Int']>;
};

export type MethodistGroupType = Node & {
  __typename?: 'MethodistGroupType';
  activeLinkOverride?: Maybe<GroupLinkOverrideType>;
  agreements: Array<AgreementType>;
  agreementsConnection?: Maybe<AgreementConnection>;
  classesDays: Array<DayOfClassType>;
  comment?: Maybe<Scalars['String']>;
  contributionsSum?: Maybe<Scalars['CustomFloat']>;
  conversations: Array<ConversationType>;
  course: CourseFilterType;
  currency?: Maybe<Scalars['String']>;
  datetimeNextLesson?: Maybe<Scalars['DateTime']>;
  daysOfClass: Array<Scalars['Int']>;
  deleteAvailable?: Maybe<Scalars['Boolean']>;
  /** Optional — when the spend belongs to a specific group (teacher payout per group, group materials, etc.) */
  expenses: Array<ExpenseType>;
  /** DEPRECATED: use invoice.payment.agreement.group. */
  fakturowniaInvoices: Array<FakturowniaInvoiceType>;
  freeLessonsCount?: Maybe<Scalars['Int']>;
  freePlaces?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  isFree: Scalars['Boolean'];
  lessonJoinUrl?: Maybe<Scalars['String']>;
  lessons?: Maybe<Array<GroupLessonType>>;
  lessonsCount?: Maybe<Scalars['Int']>;
  materials: Array<MaterialType>;
  maxStudentsCount: Scalars['Int'];
  modules: Array<GroupModuleType>;
  name: Scalars['String'];
  notes: Array<StudentNoteType>;
  passedLessonsCount?: Maybe<Scalars['Int']>;
  price?: Maybe<Scalars['CustomFloat']>;
  publishedLms: Scalars['Boolean'];
  publishedLmsForMethodist: Scalars['Boolean'];
  publishedLmsForTeacher: Scalars['Boolean'];
  slackChannels: Array<ChannelGroupLinkType>;
  slackWorkspace?: Maybe<SlackWorkspaceLinkType>;
  startDate: Scalars['Date'];
  statusFinished?: Maybe<Scalars['Boolean']>;
  studentsCount?: Maybe<Scalars['Int']>;
  teacherLeads: ApplicationFilterTypeConnection;
  teachers?: Maybe<Array<Maybe<TeacherType>>>;
  zoomAccount?: Maybe<ZoomAccountType>;
  zoomSchedules: GroupZoomScheduleTypeConnection;
};


export type MethodistGroupTypeAgreementsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  hasDebt?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<AgreementOrderByEnum>;
  query?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<RosterStatusEnum>;
};


export type MethodistGroupTypeTeacherLeadsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  byGroupId?: InputMaybe<Scalars['Decimal']>;
  first?: InputMaybe<Scalars['Int']>;
  isTerminated?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type MethodistGroupTypeZoomSchedulesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type MethodistGroupTypeConnection = {
  __typename?: 'MethodistGroupTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<MethodistGroupTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `MethodistGroupType` and its cursor. */
export type MethodistGroupTypeEdge = {
  __typename?: 'MethodistGroupTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<MethodistGroupType>;
};

export type MethodistLessonType = Node & {
  __typename?: 'MethodistLessonType';
  additional?: Maybe<Scalars['Boolean']>;
  attendances: AttendanceTypeConnection;
  comment?: Maybe<Scalars['String']>;
  date: Scalars['Date'];
  endTime: Scalars['Time'];
  finished: Scalars['Boolean'];
  firstLessonAgreements: Array<AgreementType>;
  hasJoinLink?: Maybe<Scalars['Boolean']>;
  hasStudentAttachment?: Maybe<Scalars['Boolean']>;
  hasStudentMarks?: Maybe<Scalars['Boolean']>;
  hasTeacherAttachment?: Maybe<Scalars['Boolean']>;
  homeworkAssignmentId?: Maybe<Scalars['ID']>;
  homeworkAvailable?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  index?: Maybe<Scalars['Int']>;
  lastLessonAgreements: Array<AgreementType>;
  lessonNumber?: Maybe<Scalars['Int']>;
  linkOverrideActive?: Maybe<Scalars['Boolean']>;
  lmsDescription?: Maybe<Scalars['String']>;
  marks: StudentsMarkTypeConnection;
  /** Optional — for group-wide handouts leave NULL; for per-lesson homework point at the specific GroupLesson. */
  materials: Array<MaterialType>;
  module: GroupModuleType;
  name: Scalars['String'];
  needToFinish?: Maybe<Scalars['Boolean']>;
  number: Scalars['Int'];
  startTime: Scalars['Time'];
  students: StudentTypeConnection;
  studentsAttachments: StudentLessonAttachmentTypeConnection;
  taskTypes: Array<Scalars['String']>;
  teacher?: Maybe<TeacherType>;
  teacherApplication?: Maybe<ApplicationType>;
  teachersAttachments: TeacherLessonAttachmentTypeConnection;
  video?: Maybe<Scalars['String']>;
  whiteboardId?: Maybe<Scalars['ID']>;
  zoomProcessingLogs: ZoomProcessingLogTypeConnection;
  zoomRecordingMeta?: Maybe<LessonRecordingType>;
};


export type MethodistLessonTypeAttendancesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type MethodistLessonTypeMarksArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  lessonId?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  taskType?: InputMaybe<Scalars['String']>;
};


export type MethodistLessonTypeStudentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type MethodistLessonTypeStudentsAttachmentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type MethodistLessonTypeTeachersAttachmentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type MethodistLessonTypeZoomProcessingLogsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

/** Чего не хватает до трека и какой курс это даёт. */
export type MissingSkillType = {
  __typename?: 'MissingSkillType';
  demand?: Maybe<SkillDemandType>;
  providers: Array<SkillProviderType>;
  skill: SkillType;
  upcoming?: Maybe<UpcomingUnlockType>;
};

export type ModuleInput = {
  lessons: Array<InputMaybe<LessonInput>>;
  name: Scalars['String'];
};

export type MonthBudget = {
  __typename?: 'MonthBudget';
  BYN?: Maybe<Scalars['CustomFloat']>;
  EUR?: Maybe<Scalars['CustomFloat']>;
  PLN?: Maybe<Scalars['CustomFloat']>;
  RUB?: Maybe<Scalars['CustomFloat']>;
  USD?: Maybe<Scalars['CustomFloat']>;
  month?: Maybe<Scalars['Int']>;
};

export type MoveStaffTaskInput = {
  afterId?: InputMaybe<Scalars['ID']>;
  beforeId?: InputMaybe<Scalars['ID']>;
  clearDueDate?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  targetDueDate?: InputMaybe<Scalars['Date']>;
  targetStatus?: InputMaybe<Scalars['String']>;
};

/**
 * Drag-and-drop a task on the command-center board: optionally change its
 * column (status or due date) and reposition it between two neighbours — all
 * atomically.
 */
export type MoveStaffTaskMutation = {
  __typename?: 'MoveStaffTaskMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
  task?: Maybe<StaffTaskType>;
};

export type Mutation = {
  __typename?: 'Mutation';
  /**
   * Добавить кандидату операторов — сразу нескольких.
   *
   * Заменила `setCandidateOperator` (ТЗ 0067): «выбранный» перестал быть
   * одним, и мутация «поставь одного вместо всех» описывала правило, которого
   * больше нет. Выключенного оператора НЕ воскрешает — для этого есть явная
   * `reactivateCandidateOperator`.
   */
  addCandidateOperators?: Maybe<AddCandidateOperators>;
  /** ERP: attach one downloadable file (multipart Upload) to a lesson. */
  addCareerLessonAttachment?: Maybe<AddCareerLessonAttachment>;
  /**
   * Put an invoice into a batch by hand.
   *
   * The primary path, not a fallback: automatic composition is anchored on
   * invoice issue dates because receipt-level records do not exist here, and it
   * composes only a handful of batches unambiguously. The operator finishing the
   * job is the expected workflow.
   */
  addGatewaySettlementItem?: Maybe<GatewaySettlementOutput>;
  /**
   * Приложить ОДИН файл к существующей задаче (ТЗ 0066).
   *
   * Один файл на вызов — как у дипломов: multipart с несколькими файлами
   * отказывает целиком, и пользователь не понимает, какой из них виноват.
   * Клиент шлёт их подряд.
   */
  addStaffTaskAttachment?: Maybe<AddStaffTaskAttachmentMutation>;
  addStaffTaskComment?: Maybe<AddStaffTaskCommentMutation>;
  /**
   * Прицепить к задаче объекты (ТЗ 0064).
   *
   * Добавление, а не «пришлите весь список»: две вкладки, открытые рядом,
   * затирали бы правки друг друга, и снятая в одной связь молча возвращалась
   * бы из второй. Повтор уже существующей связи — не ошибка: `ignore_conflicts`
   * делает вызов идемпотентным, а человек, дважды выбравший одного студента,
   * хотел одного студента.
   */
  addStaffTaskLinks?: Maybe<AddStaffTaskLinksMutation>;
  addTeacherApplication?: Maybe<AddTeacherApplication>;
  addTeacherExist?: Maybe<AddTeacherExist>;
  addTeacherRole?: Maybe<AddNewRoleTeacher>;
  appendRolesUserSettings?: Maybe<UserSettingsRolesAddMutation>;
  appendStudentRoleAndAgreement?: Maybe<AddRoleStudentAndAgreement>;
  /**
   * Single-shot «+Студент в группу» from the group dashboard
   * (docs/groups/group_dashboard.md §G8, Variant B).
   *
   * The student already exists (search picker on the frontend); the
   * agreement carries the target `groupId` inside `agreement_input`.
   * Delegates to the existing `add_agreement_to_student` service so all
   * currency / contribution / attendance plumbing is shared with the rest
   * of the agreement-create flow — no duplicate validation paths.
   */
  appendStudentToGroup?: Maybe<AppendStudentToGroupMutation>;
  /**
   * Accept or reject course proposals.
   *
   * Accepting is the ONLY path that writes `Teacher.courses_can_teach`, and it
   * uses `.add()` — never `.set()`, which would wipe a list the operator curated
   * by hand. Rejecting writes no M2M at all.
   */
  applyTeacherCourseSuggestions?: Maybe<ApplyTeacherCourseSuggestions>;
  archiveSurvey?: Maybe<ArchiveSurveyMutation>;
  assignSurveyToGroup?: Maybe<AssignSurveyToGroupMutation>;
  /**
   * Bulk MANUAL attach (spec 0038) — the plural of assignSurveyToGroup.
   *
   * Not built on setSurveyTargeting: that replaces the whole targeting block,
   * so «add these groups» would become read-modify-write, where one dropped
   * field silently destroys a rule and its assignments. The rows created here
   * are ordinary manual ones that rule resolution never touches.
   *
   * `success: true` WITH a populated `skipped[]` is the normal outcome, same
   * contract as setSurveyTargeting — a group without lesson N must not fail
   * the other twenty.
   */
  assignSurveyToGroups?: Maybe<AssignSurveyToGroupsMutation>;
  /** Прикрепить анкету из справочника к уроку. */
  attachCareerExerciseTemplate?: Maybe<AttachCareerExerciseTemplate>;
  /**
   * A bare URL — nothing stored, nothing analysable until a transcript is
   * pasted. Also the shape the legacy `Teacher.interviewRecording` migrated into.
   */
  attachTeacherInterviewLink?: Maybe<AttachTeacherInterviewLink>;
  /**
   * Link a synced Zoom recording; artifacts are pulled on commit.
   *
   * Eagerly, not lazily: Zoom's cloud retention expires `files[].download_url`
   * and a re-sync does not repair it, so a link we merely stored would rot.
   */
  attachTeacherInterviewZoom?: Maybe<AttachTeacherInterviewZoom>;
  /**
   * Suspend a student's LMS access by hand (ТЗ 0074 §3.4). The suspension
   * is tied to ALL the student's current unpaid invoices; no overdue invoice
   * is required. Idempotent for an already-suspended student.
   */
  blockStudentLmsAccess?: Maybe<BlockStudentLmsAccessMutation>;
  /**
   * Send ONE message to many students of a group INDIVIDUALLY — a private
   * Slack DM or a single email each (never a group blast). Runs as a paced
   * background task; returns the broadcast job id the client polls (`broadcast
   * Job`) for live progress and the per-recipient outcome.
   */
  broadcastGroupMessage?: Maybe<BroadcastGroupMessage>;
  bulkPublishVacancies?: Maybe<BulkPublishVacancies>;
  /**
   * Move many vacancies at once — the queue-draining action (spec 0035).
   *
   * `bulkPublishVacancies` only ever published; rejecting a night's drafts
   * meant one mutation per row, each triggering a full table reload. This is
   * set-based on the server and covers every status.
   */
  bulkSetVacancyStatus?: Maybe<BulkSetVacancyStatus>;
  cancelVideoUpload?: Maybe<CancelVideoUpload>;
  /**
   * Move a student from one group to another atomically.
   *
   * Created to back the "Перевести в другую группу" single-click action on
   * the new student card (`docs/fakturownia/student_card.md §6`). Replaces
   * the manual sequence of `editStudentWithAgreement` + chargeback +
   * new-agreement that finance currently has to chain by hand.
   */
  changeAgreementGroup?: Maybe<ChangeAgreementGroupMutation>;
  changeCandidateStatus?: Maybe<ChangeCandidateStatus>;
  changeLessonDates?: Maybe<ChangeLessonDate>;
  checkStudentDebt?: Maybe<CheckStudentsDebtMutation>;
  /**
   * LMS: студент выбирает трек целью (ТЗ 0039).
   *
   * Открыто ЛЮБОМУ студенту, а не только участнику карьерного центра: трек —
   * продающая поверхность, и требовать членства значит показать её только тем,
   * кто уже выпустился.
   */
  chooseGrowthTrack?: Maybe<ChooseGrowthTrack>;
  /**
   * Take the review flag off a row somebody has looked at.
   *
   * `needs_review` had exactly one way out — marking the row an internal
   * transfer — so a row flagged for a weak dedup key or for an orphaned rule
   * stayed flagged forever and the counter only ever grew. A number that cannot
   * go down stops being a signal and becomes decoration.
   */
  clearBankTransactionReview?: Maybe<BankTransactionOutput>;
  clearCareerLessonVideo?: Maybe<ClearCareerLessonVideo>;
  clearGroupLessonLinkOverride?: Maybe<ClearGroupLessonLinkOverride>;
  /** LMS: the student marks a lesson done, unlocking the next one. */
  completeCareerLesson?: Maybe<CompleteCareerLesson>;
  /**
   * The operator answering «запомнить это правило?» with yes.
   *
   * No proposal is stored server-side and none needs to be: the suggestion is a
   * pure function of (row, category), so confirming it just recomputes the same
   * signal and commits. That keeps the answer idempotent and avoids a table
   * whose rows would go stale the moment either side changed.
   *
   * `retroactive` decides whether the rule also repaints the rows it matches
   * that are not already classified by hand. Off by default — applying a new
   * rule backwards changes closed months, and that must be a decision, not a
   * side effect.
   */
  confirmCashFlowRule?: Maybe<SetCategoryOutput>;
  /**
   * Подтвердить набор — или снять подтверждение.
   *
   * 🔴 Единственное разрешение на рассылку в домене (ТЗ 0054). Владелец:
   * «у набора должен быть статус, что он активный… она руками его делает,
   * что он активный. Это означает, что можно сделать рассылку… то есть набор
   * подтверждён».
   *
   * Отдельная мутация, а не поле в `saveFundingIntake`, по той же причине, по
   * которой подтверждение не поле в `_apply_patch`: это поступок, у него один
   * аргумент, и жать его будут из строки таблицы, где формы нет. Форма умеет
   * то же самое через `FundingIntakeInput.confirmed` — обе дороги ведут в
   * `services.intakes.confirm_intake`, второго правила не заводится.
   */
  confirmFundingIntake?: Maybe<ConfirmFundingIntake>;
  createAgreement?: Maybe<CreateAgreementMutation>;
  createBlackFridayLead?: Maybe<CreateBlackFridayLeadMutation>;
  /**
   * LMS: завести отклик.
   *
   * `duplicate` — ШТАТНЫЙ ответ, а не ошибка: повтор на ту же вакансию, пока
   * прежний отклик ещё в работе, возвращает существующую строку. Прецедент
   * домена — `erp_create_vacancy_draft`; штатная ситуация, отданная
   * исключением, читается вызывающим как сбой.
   */
  createCareerApplication?: Maybe<CreateCareerApplication>;
  createCompany?: Maybe<CreateCompanyMutation>;
  createCourse?: Maybe<CreateCourseMutation>;
  /** @deprecated Legacy deferred-Payment entry (ТЗ 0004); the flow is retired. */
  createDeferredPayments?: Maybe<CreateDeferredPaymentsMutation>;
  createExpense?: Maybe<ExpenseMutationOutput>;
  createExpenseCategory?: Maybe<CreateExpenseCategoryMutation>;
  createGroup?: Maybe<CreateGroupMutation>;
  createLead?: Maybe<CreateLeadMutation>;
  createLessonWhiteboard?: Maybe<CreateLessonWhiteboardMutation>;
  createManualLessonRecording?: Maybe<CreateManualLessonRecordingMutation>;
  createMaterial?: Maybe<CreateMaterialMutation>;
  createNewYearLead?: Maybe<CreateNewYearLeadMutation>;
  /**
   * Create a free-standing Payment on an agreement (no Fakturownia link).
   *
   * Mirrors `createPaymentForFakturowniaInvoice` but starts from the
   * agreement instead of an invoice — finance often records a payment
   * before any invoice exists. Link to an invoice later via
   * `linkFakturowniaInvoiceToPayment`.
   * @deprecated Legacy: Payment is a hidden system record (ТЗ 0004). Use linkInvoiceToContribution / markContributionPaidManually.
   */
  createPayment?: Maybe<CreatePaymentMutation>;
  createPaymentCorrection?: Maybe<CreatePaymentCorrectionMutation>;
  /**
   * Create a `students.Payment` on `agreement_id` from the invoice's
   * amount/currency/date and link it 1:1 to the invoice.
   *
   * The amount is taken from `invoice.paid` (the Fakturownia "paid" total).
   * Currency must match between agreement and invoice — we don't auto-FX
   * here because finance wants explicit conversions.
   * @deprecated Legacy: Payment is a hidden system record (ТЗ 0004). Use linkInvoiceToContribution / markContributionPaidManually.
   */
  createPaymentForFakturowniaInvoice?: Maybe<FakturowniaMutationOutput>;
  /** @deprecated Legacy bulk Payment entry (ТЗ 0004). Use linkInvoiceToContribution / markContributionPaidManually. */
  createPayments?: Maybe<CreatePaymentsMutation>;
  createPlannedPayment?: Maybe<PlannedPaymentMutationOutput>;
  createStaffTask?: Maybe<CreateStaffTaskMutation>;
  createStudentNote?: Maybe<CreateStudentNoteMutation>;
  createStudentWithAgreement?: Maybe<StudentWithAgreementCreateMutation>;
  createSurvey?: Maybe<CreateSurveyMutation>;
  /**
   * Spin a staff task off a student's message («создать задачу из вопроса»).
   *
   * The task inherits the conversation's student/group; the assignee defaults
   * to the acting manager and must always be ERP staff. Side effects record
   * the reaction: the message is marked handled + linked to the task, and an
   * `open` conversation moves to `in_progress`. One task per message — a
   * retry / second manager gets `already_linked` instead of a duplicate.
   */
  createTaskFromMessage?: Maybe<CreateTaskFromMessageMutation>;
  /**
   * Create a STANDALONE teacher WITHOUT any application/group assignment —
   * add «свободных» преподавателей на будущее (собеседование/курсы/рейтинг
   * заполняются на карточке). Distinct from `createUniqueTeacher`, which
   * requires an application.
   */
  createTeacher?: Maybe<CreateTeacher>;
  createUniqueTeacher?: Maybe<CreateUniqueTeacher>;
  /**
   * SDL: {success, errors, customErrors}.
   *
   * ТЗ 0021, стадия 4 — вместо `graphql_auth.mutations.Register`. Полей
   * token/refreshToken тут нет и быть не должно: пакет доливал их только при
   * `ALLOW_LOGIN_NOT_VERIFIED=True`, а в проекте настройка False.
   */
  createUser?: Maybe<RegisterMutation>;
  /** SDL: {token, success, errors, user, unarchiving, customErrors, refreshToken}. */
  customLogin?: Maybe<CustomObtainJsonWebToken>;
  /**
   * Выключить оператора у кандидата. Причина обязательна.
   *
   * Единственное, что прекращает письма конкретного оператора (кроме
   * терминального статуса кандидата). Строку связи не удаляет — она остаётся
   * журналом и объясняет, почему к оператору больше не ходят.
   */
  deactivateCandidateOperator?: Maybe<DeactivateCandidateOperator>;
  deleteCareerApplication?: Maybe<DeleteCareerApplication>;
  /**
   * Remove a rule outright.
   *
   * Rows it classified keep their category — deletion is about the rule, not
   * about rewriting the ledger behind it.
   */
  deleteCashFlowRule?: Maybe<CashFlowRunOutput>;
  deleteCourse?: Maybe<DeleteCourseMutation>;
  deleteExpense?: Maybe<DeleteExpenseMutation>;
  /**
   * Удалить заявку-дубль или тестовую (задача #95).
   *
   * Отказывает (`candidate_in_use`), если человеку уже писали или строка
   * пришла из Notion, — тогда архив: `saveFundingCandidate(id, input:
   * {isArchived: true})` меняет только этот флаг. Правила — в
   * `services.candidates.delete_candidate`.
   */
  deleteFundingCandidate?: Maybe<DeleteFundingCandidate>;
  deleteFundingIntake?: Maybe<DeleteFundingIntake>;
  deleteGroup?: Maybe<DeleteGroupMutation>;
  deleteMaterial?: Maybe<DeleteMaterialMutation>;
  /**
   * Delete a Payment. Refuses if a FakturowniaInvoice is still linked —
   * the operator must call `unlinkFakturowniaInvoice` first so the invoice
   * isn't left orphaned with `payment_id → DELETED`.
   * @deprecated Legacy: kept only to drain orphan Payments (ТЗ 0004).
   */
  deletePayment?: Maybe<DeletePaymentMutation>;
  deletePaymentCorrection?: Maybe<DeletePaymentCorrectionMutation>;
  deletePlannedPayment?: Maybe<DeletePlannedPaymentOutput>;
  deleteStaffTask?: Maybe<DeleteStaffTaskMutation>;
  deleteStaffTaskComment?: Maybe<DeleteStaffTaskCommentMutation>;
  /**
   * Detach a diploma. The S3 object is left in place deliberately — a
   * student may hold a live signed URL, and a leaked object beats a document
   * that vanished mid-download. The orphaned key goes to the audit log.
   */
  deleteStudentDiploma?: Maybe<DeleteStudentDiplomaMutation>;
  deleteStudentNote?: Maybe<DeleteStudentNoteMutation>;
  deleteSurveyAssignment?: Maybe<DeleteSurveyAssignmentMutation>;
  deleteTeacherApplication?: Maybe<DeleteTeacherApplication>;
  /** Remove the row AND the S3 object — this is the right-to-erasure path. */
  deleteTeacherDocument?: Maybe<DeleteTeacherDocument>;
  /**
   * Remove the row AND the S3 objects.
   *
   * Deliberately unlike the diploma rule (which leaves the object because a
   * student may hold a live signed URL): this is candidate personal data under a
   * retention policy, so erasure is the point.
   */
  deleteTeacherInterview?: Maybe<DeleteTeacherInterview>;
  deleteUserSettings?: Maybe<UserSettingsDeleteMutation>;
  /**
   * Hard-delete a draft/rejected vacancy. Anything further along refuses
   * with `vacancy_locked` and points at the archive — see
   * `services.vacancies.delete_vacancy` for why the fence is this narrow.
   */
  deleteVacancy?: Maybe<DeleteVacancy>;
  deleteZoomRecording?: Maybe<DeleteZoomRecordingMutation>;
  /**
   * Удалить пачку записей одним подтверждением (ТЗ 0043).
   *
   * До этого удаление было поштучным и требовало НАБРАТЬ РУКАМИ строку
   * «DELETE <pk>» на каждую запись. Чистка десятка видео превращалась в десять
   * диалогов с печатью идентификатора, и ей просто не пользовались.
   *
   * Пакет не падает целиком из-за одной проблемной строки: каждая получает свой
   * исход, и оператор видит, что именно не ушло и почему.
   */
  deleteZoomRecordings?: Maybe<DeleteZoomRecordingsMutation>;
  /** SDL: {token, success, errors, user, unarchiving, customErrors, refreshToken}. */
  demoCustomLogin?: Maybe<CustomObtainJsonWebToken>;
  /** Снять анкету с урока. */
  detachCareerExerciseTemplate?: Maybe<DetachCareerExerciseTemplate>;
  detectGatewaySettlements?: Maybe<CashFlowRunOutput>;
  duplicateSurvey?: Maybe<DuplicateSurveyMutation>;
  editStaffTaskComment?: Maybe<EditStaffTaskCommentMutation>;
  /** Add students and/or a whole graduating group to the centre. */
  enrollCareerMembers?: Maybe<EnrollCareerMembers>;
  /**
   * «Занятие проведено» + комментарий.
   *
   * ТЗ 0026 забрал отсюда посещаемость: она сохраняется поштучно через
   * `lmsSetAttendance`. Аргумент `attendances` стал НЕобязательным — снятие
   * `required` обратно совместимо, поэтому старый бандл, оставшийся в кэше
   * браузера преподавателя после выката бэкенда, продолжит работать как
   * раньше. Удалять аргумент — следующим релизом.
   */
  finishLmsLesson?: Maybe<FinishLmsLessonMutation>;
  /** Flag/unflag one message (team-wide global state). */
  flagMessage?: Maybe<FlagMessageMutation>;
  /**
   * Teacher grades a student's homework — with or without a submission
   * (non-submitters get `not_done`). Writes through to
   * journals.StudentsMark.hw_mark; the comment lives on the submission.
   */
  gradeHomework?: Maybe<GradeHomeworkMutation>;
  /**
   * Create a REAL invoice in Fakturownia for one installment.
   *
   * The unit of work is the **agreement**, not the student: a student may
   * hold several agreements, and this also makes the group job's per-row unit
   * identical to this mutation's, so both share one service.
   *
   * Everything hard lives in `services.issuing` — five layers of duplicate
   * protection around a vendor that has no idempotency key and whose
   * documents cannot be deleted from here. This class is only the GraphQL
   * skin: gate, resolve ids, translate the outcome.
   */
  issueInvoiceForContribution?: Maybe<FakturowniaMutationOutput>;
  /**
   * Enqueue a background run that issues invoices for a whole group.
   *
   * Returns immediately with the job; the frontend polls
   * `fakturowniaBillingJob(id)`. It has to be a job, not a synchronous loop:
   * every non-BYN row costs an invoice POST plus up to two live FX lookups
   * from `Contribution.save()`, so a 200-row group runs for 7-13 minutes.
   */
  issueInvoicesForGroup?: Maybe<FakturowniaBillingJobEnqueueOutput>;
  /** Выдать код конкретному студенту руками — в обход правила. */
  issuePromoCode?: Maybe<IssuePromoCode>;
  /**
   * Attach a document to a bank row by hand.
   *
   * Needed wherever the matcher honestly cannot decide — which is most of the
   * expense side, since card payments for SaaS have no document at all.
   */
  linkBankTransaction?: Maybe<BankTransactionOutput>;
  /**
   * Pin a funnel person to an account by hand.
   *
   * The manual decision is durable: `user_locked` stops the automatic
   * re-matcher from ever re-pointing this row.
   */
  linkCandidateToUser?: Maybe<LinkCandidateToUser>;
  /** Map a Slack channel id to a Group. */
  linkChannelGroup?: Maybe<LinkChannelGroupMutation>;
  /**
   * Attach an existing Payment to an existing Contribution (1:1).
   *
   * Used by the frontend "Перепривязать" / "Привязать существующий платёж"
   * action on the schedule row. The happy path also flips
   * `contribution.complete=True` and recomputes `remainder` via
   * `Contribution.save()` (§9.5).
   * @deprecated Legacy: kept only to drain orphan Payments (ТЗ 0004). Use linkInvoiceToContribution.
   */
  linkContributionToPayment?: Maybe<LinkContributionToPaymentMutation>;
  /**
   * Attach an existing `students.Payment` to a Fakturownia invoice 1:1.
   *
   * Use when an operator has identified the LMS payment that corresponds to
   * this invoice (e.g. they already imported it from a bank statement).
   * The Payment is OneToOne — if it's already linked to a different
   * invoice the call fails with `Payment already linked`.
   * @deprecated Legacy payment-first link (ТЗ 0004). Use linkInvoiceToContribution; the hidden Payment is provisioned automatically.
   */
  linkFakturowniaInvoiceToPayment?: Maybe<FakturowniaMutationOutput>;
  /**
   * ТЗ 0004 — pin an issued invoice to the installment it charges.
   *
   * The PRIMARY business link of the unified «взнос» model. Manual link sets
   * `contribution_match_source='manual'` so the sync auto-matcher never
   * re-points it. If the invoice is already fully paid, the hidden Payment is
   * provisioned immediately (no waiting for the next sync).
   */
  linkInvoiceToContribution?: Maybe<FakturowniaMutationOutput>;
  linkLessonWhiteboard?: Maybe<LinkLessonWhiteboardMutation>;
  /**
   * Attach a PandaDoc document to an existing agreement (manual link from
   * the student card). Does not create a Student/Agreement and does not touch
   * `provisioned_at`.
   */
  linkPandadocDocument?: Maybe<LinkPandadocDocumentMutation>;
  /**
   * Attach a `trainer` PandaDoc document to a Teacher (from the teacher
   * card). The teacher analog of LinkPandadocDocumentMutation.
   */
  linkPandadocTeacher?: Maybe<LinkPandadocTeacherMutation>;
  /**
   * Map a Slack user id to a Student OR a Teacher (for DM mirroring). The
   * manual fallback for auto-matching by email — a person may sit in Slack
   * under an email we don't know.
   */
  linkSlackUser?: Maybe<LinkSlackUserMutation>;
  lmsClearTodayLessonLink?: Maybe<LmsClearTodayLessonLink>;
  lmsJoinLesson?: Maybe<LmsJoinLesson>;
  /**
   * Поштучная отметка преподавателем из LMS (ТЗ 0026).
   *
   * Заменяет пакетное сохранение внутри `finishLmsLesson`. Возвращает ту же
   * сущность `LessonAttendancesType`, что отдаёт `groupLessonAttendanceForLms`
   * — Apollo нормализует её по `id`, поэтому оптимистичное обновление на
   * фронте работает без ручного `cache.modify`.
   */
  lmsSetAttendance?: Maybe<LmsSetAttendanceMutation>;
  lmsSetTodayLessonLink?: Maybe<LmsSetTodayLessonLink>;
  lmsStudentSignUp?: Maybe<StudentSignUpLmsMutation>;
  /** «Прочитать всё». */
  markAllStaffNotificationsRead?: Maybe<MarkAllStaffNotificationsRead>;
  /** LMS: record that the student opened a lesson — viewed, NOT completed. */
  markCareerLessonOpened?: Maybe<MarkCareerLessonOpened>;
  /**
   * Record an off-invoice payment against an installment.
   *
   * ТЗ 0029: writes `manual_paid_amount` / `manual_paid_date` on the instalment
   * itself — no hidden ledger row. Amount defaults to the remainder. The row
   * then reads «оплачен вручную» (fully covered with zero invoice money).
   */
  markContributionPaidManually?: Maybe<MarkContributionPaidManuallyMutation>;
  /**
   * Set the read flag on every message of a conversation.
   *
   * `read=false` is «Вернуть в работу»: it clears `is_handled` on the inbound
   * messages too (spec 0030 round 2). Clearing only `is_read` produced an
   * unread-but-handled dialog, which is EXCLUDED from the `unhandledOnly`
   * queue — so the manager's "I'll come back to this" gesture removed the
   * dialog from the very list they come back through. It is also the only
   * thread-level way back from a cascade or a bulk clear.
   */
  markConversationRead?: Maybe<MarkConversationReadMutation>;
  /**
   * Bulk «Прочитано и обработано» over a scope (spec 0030).
   *
   * The whole point of the communicator rework: closing an inbox used to cost
   * one click per message per student per channel. This sets both flags over
   * a whole dialog, student, group, or the entire filtered browser list, in a
   * constant number of statements.
   *
   * Reversible, not one-directional (round 2): the payload carries the exact
   * ids it flipped so `revertMessagesTriage` can put them back. Both UPDATEs
   * only ever go False → True, so reverting those very rows to False restores
   * the prior state exactly — no "was it already read?" guessing.
   */
  markConversationsHandled?: Maybe<MarkConversationsHandledMutation>;
  markGatewaySettlementReconciled?: Maybe<GatewaySettlementOutput>;
  markLessonMissingRecording?: Maybe<MarkLessonMissingRecordingMutation>;
  /** Mark one message read/unread (team-wide global state). */
  markMessageRead?: Maybe<MarkMessageReadMutation>;
  /** Отметить конкретные строки прочитанными. */
  markStaffNotificationsRead?: Maybe<MarkStaffNotificationsRead>;
  /** LMS: a member saves a vacancy or marks that they applied. */
  markVacancyInteraction?: Maybe<MarkVacancyInteraction>;
  /**
   * Dry-run: propose a (student, language) for each file NAME.
   *
   * A mutation rather than a query only because clients treat it as an action;
   * it performs no writes.
   */
  matchDiplomaFiles?: Maybe<MatchDiplomaFilesMutation>;
  /**
   * DEPRECATED. Pin invoice to a Student/Group without touching Payment.
   *
   * Kept so the old frontend keeps working during the migration. New code
   * should call `linkFakturowniaInvoiceToPayment` or
   * `createPaymentForFakturowniaInvoice` instead.
   * @deprecated Legacy (ТЗ 0004). Use linkInvoiceToContribution instead.
   */
  matchFakturowniaInvoice?: Maybe<FakturowniaMutationOutput>;
  /** Слить дубль справочника в целевой навык («React» и «ReactJS»). */
  mergeCareerSkills?: Maybe<MergeCareerSkills>;
  /**
   * Drag-and-drop a task on the command-center board: optionally change its
   * column (status or due date) and reposition it between two neighbours — all
   * atomically.
   */
  moveStaffTask?: Maybe<MoveStaffTaskMutation>;
  /** Сброс пароля по токену из письма. SDL: {success, errors}. */
  passwordReset?: Maybe<PasswordReset>;
  /** Установка первого пароля по токену из письма. SDL: {success, errors}. */
  passwordSet?: Maybe<PasswordSet>;
  /**
   * «Обработать загруженное» — четыре шага одной кнопкой.
   *
   * Загрузка файла вносит строки и на этом останавливается: категорию из
   * выписки взять неоткуда (в ней есть дата, сумма, сальдо и назначение — но не
   * категория), а парность, выплаты шлюза и документы никто не считает сам.
   * Раньше это были четыре отдельных нажатия, и **порядок между двумя из них
   * обязателен**: распознавание выплат шлюза должно идти до сопоставления
   * документов, иначе выплата получит случайно равную ей фактуру.
   *
   * Порядок теперь свойство кода (`services/pipeline.STEP_ORDER`), а не памяти
   * оператора. Один шаг упал — конвейер останавливается и говорит, на каком:
   * наполовину обработанный реестр, о котором не сказали, хуже отказа.
   */
  processUploadedStatement?: Maybe<CashFlowRunOutput>;
  /** Create students + agreements + first contribution from PandaDoc docs. */
  provisionStudents?: Maybe<ProvisionStudentsMutation>;
  publishGroup?: Maybe<PublishGroupToLms>;
  /** Вернуть выключенного оператора в работу — решение человека. */
  reactivateCandidateOperator?: Maybe<ReactivateCandidateOperator>;
  /**
   * Rebuild the merged profile from the existing good runs — no new AI call.
   *
   * Idempotent by construction (`merge_profiles` is pure and ordered), so this is
   * safe to press twice; it exists for the case where a run landed while the
   * merge shape changed.
   */
  recomputeTeacherAiProfile?: Maybe<RecomputeTeacherAiProfile>;
  reconcileGatewaySettlements?: Maybe<CashFlowRunOutput>;
  /**
   * Кнопка «Проверить сейчас».
   *
   * То же, что делает ночная задача. Сверка НЕ трогает деньги: ни договор, ни
   * взносы, ни фактуры — она лишь помечает коды использованными.
   */
  reconcilePromoCodes?: Maybe<ReconcilePromoCodes>;
  recordPlacement?: Maybe<RecordPlacement>;
  /** One-call refresh: accounts + all recordings + account usage. */
  refreshAllZoomData?: Maybe<RefreshAllZoomDataMutation>;
  /**
   * Pull a date window straight from Zoom, synchronously.
   *
   * Load-bearing, not a nicety: with production defaults the only scheduled sync
   * is `zoom_hourly_dispatch`, which early-returns unless a `GroupZoomSchedule`
   * slot falls in the current 15-minute bucket, so an interview recorded at a
   * quiet hour may never appear on its own.
   */
  refreshInterviewZoomRecordings?: Maybe<RefreshInterviewZoomRecordings>;
  /** То же, что в `graphql_jwt`, но с нашей формой ответа (success/errors). */
  refreshToken?: Maybe<CustomRefreshToken>;
  /**
   * LMS: студент нажал «Поделиться» (ТЗ 0039, шаг 7).
   *
   * 🔴 Повторное нажатие возвращает `counted=false`, а НЕ ошибку: бонус за этот
   * канал уже выдан, но делиться можно сколько угодно, и ошибка на кнопке
   * «Поделиться» читается как поломка.
   *
   * ⚠️ Мутация фиксирует нажатие НАШЕЙ кнопки, а не публикацию: проверить
   * публикацию у LinkedIn и Facebook невозможно без OAuth от имени студента.
   *
   * Медали и коды возвращаются СРАЗУ, чтобы фронт показал награду без
   * перезапроса — иначе связь между действием и наградой теряется.
   */
  registerShare?: Maybe<RegisterShare>;
  remindDebtors?: Maybe<RemindDebtorsMutation>;
  removeCareerLessonAttachment?: Maybe<RemoveCareerLessonAttachment>;
  removeGatewaySettlementItem?: Maybe<GatewaySettlementOutput>;
  removeStaffTaskAttachment?: Maybe<RemoveStaffTaskAttachmentMutation>;
  /**
   * Снять одну связь — по id СТРОКИ связи.
   *
   * Не по паре «вид + объект»: строка снимается и тогда, когда объекта уже нет
   * в базе, а пары для него не построишь — именно ради этого случая связь и
   * показывается как «объект удалён», а не прячется.
   */
  removeStaffTaskLink?: Maybe<RemoveStaffTaskLinkMutation>;
  renameWhiteboard?: Maybe<RenameWhiteboardMutation>;
  /**
   * Re-extract signer contact data (email/phone/name) on already-synced
   * documents and re-pull the details of rows a local re-parse can't fix.
   *
   * The repair button for «у студента нет договоров» / «новая папка не
   * появилась»: it applies the current parser to the whole cached inventory
   * instead of waiting for each document to change in PandaDoc.
   *
   * Admin-only (unlike the plain sync): a run can queue the entire inventory
   * for a `/details` re-fetch, which costs hours of the PandaDoc rate-limit
   * budget.
   */
  reparsePandadocRecipients?: Maybe<ReparsePandadocRecipientsMutation>;
  reprocessAi?: Maybe<ReprocessAiMutation>;
  /** Заказать выгрузку данных для P&L. Файл собирается в фоне. */
  requestPnlExport?: Maybe<RequestPnlExportMutation>;
  /**
   * Force the auto-matcher to run again on a specific invoice — useful
   * when buyer_email changed, the student was just created, or a new
   * Payment row was just imported and we want to recheck the link.
   */
  rerunFakturowniaMatcher?: Maybe<FakturowniaMutationOutput>;
  /**
   * Teacher re-queues the AI analysis of a submission («Перепроверить»).
   * Answers AI_DISABLED while the HOMEWORK_AI_ENABLED flag is off.
   */
  rerunHomeworkAiReview?: Maybe<RerunHomeworkAiReviewMutation>;
  /**
   * Аварийный выход: снять сдачи, чтобы можно было переделать анкету.
   *
   * 🔴 Снимает сдачи по ВСЕМ урокам, куда анкета прикреплена, — замок общий,
   * и половинчатый сброс оставил бы его запертым без объяснения. НЕ удаляет
   * `CareerLessonProgress` (иначе одна опечатка методиста перезакрыла бы урок
   * всему потоку) и НЕ откатывает записанное в резюме: эти данные уже
   * принадлежат студенту. Асимметрию надо писать в подтверждении прямым
   * текстом.
   */
  resetCareerExerciseTemplate?: Maybe<ResetCareerExerciseTemplate>;
  /**
   * Settle «этот признак уже ведёт в другую категорию».
   *
   * `REPLACE` closes the old rule at today's date and opens the new one from
   * it, so rows booked earlier keep the category they already had. That is what
   * `valid_from` / `valid_to` / `superseded_by` were declared for — until now
   * nothing wrote them, and a supplier changing category in July would have
   * repainted a closed March.
   */
  resolveCashFlowRuleConflict?: Maybe<SetCategoryOutput>;
  /**
   * Settle one raw place string.
   *
   * Either outcome PINS the row — the auto-resolver never re-points a
   * manually settled string on any later import.
   */
  resolveGeoAlias?: Maybe<ResolveGeoAlias>;
  /**
   * Вернуть студенту доступ к занятиям курса — ремонт, а не смена договора.
   *
   * Только строки посещаемости (= доступ в LMS) и запись в аудит: деньги,
   * взносы и `terminated` не трогаются. Аддитивна — может лишь добавить
   * студенту занятия, которых у него нет, поэтому безопасна к повторному
   * нажатию и возвращает `restoredLessons = 0`, когда возвращать нечего.
   */
  restoreCourseAccess?: Maybe<RestoreCourseAccessMutation>;
  /**
   * Разобрать заявку с формы заново (ТЗ 0046).
   *
   * Триаж идёт автоматически и в `try/except`: заявка пишется одной
   * транзакцией, а разбор — отдельно и после, чтобы падение разбора не теряло
   * лид. Цена в том, что упавшая заявка молча остаётся с пустым
   * `processed_at`, и до этой мутации починить её из интерфейса было нельзя —
   * только руками в БД.
   *
   * Идемпотентна: повторный разбор уже подшитой заявки найдёт того же
   * кандидата и заполнит те же пустые поля.
   *
   * Она же — способ отменить ложное срабатывание ловушки (ТЗ 0047). Заявку,
   * отклонённую как автоматическую, менеджер разбирает этой же кнопкой, и
   * удачный разбор снимает пометку: человек посмотрел и решил, а его решение
   * старше эвристики.
   */
  retryFormSubmission?: Maybe<RetryFormSubmission>;
  retryLessonRecording?: Maybe<RetryLessonRecordingMutation>;
  /**
   * Re-queue the artifact pull — the recovery path when Zoom's transcript
   * landed after the video, or a worker died mid-download.
   */
  retryTeacherInterviewDownload?: Maybe<RetryTeacherInterviewDownload>;
  /**
   * Undo a manual «оплачен вручную» mark.
   *
   * ТЗ 0029: clears `manual_paid_*` on the instalment. Money that came through
   * an invoice is untouched — that is corrected with a corrective invoice or a
   * `PaymentCorrection`, not here.
   */
  revertManualContributionPayment?: Maybe<RevertManualContributionPaymentMutation>;
  /**
   * Undo for a triage action — put exactly these rows back (spec 0030 r2).
   *
   * Both the bulk clear and the per-message cascade only ever flip
   * False → True, so clearing the very ids they reported restores the prior
   * state exactly. That is why undo takes explicit ids rather than a scope:
   * re-deriving the set would also catch rows that were already read before,
   * and un-read them.
   *
   * Deliberately no separate permission tier: whoever may clear may un-clear.
   */
  revertMessagesTriage?: Maybe<RevertMessagesTriageMutation>;
  /**
   * «Посмотрел» — человек разобрал изменение на странице оператора.
   *
   * Ровно один поступок и ровно один эффект: снять флаг «страница обновилась».
   * Владелец описал цикл так: «мы следим за страницей только лишь в том смысле,
   * поменялась она или нет. Если да — руками смотрим, что конкретно поменялось,
   * и снова меняем статус руками, что не поменялось».
   *
   * 🔴 Раньше сюда приходил `automation_status`, и мутация одновременно
   * снимала флаг И выдавала разрешение на рассылку. Отсюда росли четыре
   * кнопки — «есть набор», «набора нет», «надо править карточку», — про
   * которые владелец сказал: «что это за хуйню, не понимаю, что это». Два
   * разных решения в одной мутации требовали от человека принять их сразу,
   * хотя второе относится к НАБОРУ, а не к странице. Разрешение переехало на
   * окно (`FundingIntake.confirmed_at`), и здесь остался только флаг.
   *
   * Флаг снимает ТОЛЬКО эта мутация: робот его лишь поднимает. Иначе
   * «заметили» и «разобрали» слились бы в один факт, и второе изменение
   * подряд съело бы первое.
   *
   * 🔴 `intake` — «посмотрел, и там объявлен вот такой набор» (ТЗ 0048).
   * Аргумент остаётся: «разобрал» и «записал увиденный набор» — один поход
   * менеджера, и одна транзакция здесь честнее двух запросов с фронта, между
   * которыми помещается отказ. Подтверждение приходит внутри `intake`
   * (`confirmed: true`) — там же, где живёт.
   */
  reviewOperatorPage?: Maybe<ReviewOperatorPage>;
  /** Отозвать выданный токен: клиент отключится немедленно. */
  revokeMcpConnection?: Maybe<RevokeMcpConnectionMutation>;
  /** Отозвать код. Студенту он перестаёт показываться. */
  revokePromoCode?: Maybe<RevokePromoCode>;
  /** SDL: {revoked: Int, success, errors}. */
  revokeToken?: Maybe<RevokeToken>;
  /**
   * Undo one committed import — the only way out was the Django admin.
   *
   * Refuses rather than destroys. A row that has been touched since the import
   * carries a decision somebody made: a category set by hand, a link to a
   * document, a verdict about an internal transfer. Deleting those to undo a
   * misfiled statement would be trading one mistake for a worse one, so the
   * mutation stops and names the rows.
   *
   * `dryRun` says what WOULD go, because «удалить 1262 операции» is not a
   * sentence anyone should read for the first time in the past tense.
   */
  rollbackBankStatementImport?: Maybe<CashFlowRunOutput>;
  runAutoMatching?: Maybe<RunAutoMatchingMutation>;
  runCashFlowCategorization?: Maybe<CashFlowRunOutput>;
  runCashFlowMatching?: Maybe<CashFlowRunOutput>;
  /**
   * Запустить фоновую задачу робота по кнопке.
   *
   * Все три флага расписания по умолчанию выключены, и до этой мутации
   * единственным способом что-то прогнать был терминал сервера.
   *
   * 🔴 Ставим в ОЧЕРЕДЬ, а не выполняем синхронно: обход ста с лишним
   * страниц операторов идёт с паузой между запросами и в HTTP-таймаут не
   * уложится. Результат появится строкой в журнале прогонов.
   *
   * `dry_run` едет в очередь вместе с задачей: сухость живёт в самой задаче
   * (`services/dry_run.py`), значит воркер выполнит сухой прогон сухим — ни
   * записей, ни писем. Что он собирался сделать, видно заметками в строке
   * журнала.
   *
   * По умолчанию — СУХОЙ. Кнопок пять, они стоят в ряд, и промах по одной из
   * них не имеет права разослать сотни писем.
   */
  runFundingTask?: Maybe<RunFundingTask>;
  runInternalTransferDetection?: Maybe<CashFlowRunOutput>;
  /**
   * Queue a competency analysis of a document's extracted text.
   *
   * The result merges with any interview run into ONE profile: the CV carries
   * self-declared CLAIMS, the transcript carries observed behaviour, and
   * `profile_merge` keeps both tagged by source rather than fusing them.
   *
   * `NO_DOCUMENT_TEXT` is a precondition, not a failure — no run row is created,
   * exactly as with a missing transcript.
   */
  runTeacherDocumentAnalysis?: Maybe<RunTeacherDocumentAnalysis>;
  /**
   * Queue a competency analysis of one interview's transcript.
   *
   * Two non-failures answered as customErrors rather than a failed run row:
   * · `AI_DISABLED` — the kill switch is off; the panel stays visible with a
   *   disabled button so «why is there no AI?» is answerable.
   * · `NO_TRANSCRIPT` — a PRECONDITION. It must not create a `failed` row,
   *   because «нет входа» is not an analysis that went wrong: it must not burn a
   *   retry or paint the panel red. The UI offers «вставить расшифровку».
   */
  runTeacherInterviewAnalysis?: Maybe<RunTeacherInterviewAnalysis>;
  /**
   * Завести или поправить медаль.
   *
   * Удаления нет: `AchievementGrant` — append-only журнал выданного, и
   * `CASCADE` снёс бы вместе с медалью историю начислений и очки, которые
   * студент уже видел.
   */
  saveAchievement?: Maybe<SaveAchievement>;
  /**
   * Завести или переписать анкету в справочнике (ТЗ 0040 фаза B).
   *
   * Раньше это была `SetCareerLessonExercise`: анкета собиралась ВНУТРИ урока
   * и жила только в нём. Владелец попросил обратного — «создавать на отдельной
   * странице, потом прикреплять к урокам», — и мутация переехала на шаблон.
   */
  saveCareerExerciseTemplate?: Maybe<SaveCareerExerciseTemplate>;
  /** LMS: the student's PRIVATE note on a lesson (never shown to staff). */
  saveCareerLessonNotes?: Maybe<SaveCareerLessonNotes>;
  saveCareerProfile?: Maybe<SaveCareerProfile>;
  /** Upsert the per-language prose overlay (title + about) for the CV. */
  saveCvText?: Maybe<SaveCvText>;
  /**
   * Create or edit a candidate.
   *
   * Note what is NOT here: `status` and `primary_operator`. Both move through
   * their own mutations so every transition is written to
   * `FundingCandidateEvent` — under one-row-per-person that log is the only
   * history there is.
   */
  saveFundingCandidate?: Maybe<SaveFundingCandidate>;
  /**
   * Набор заводит и правит человек — робот только двигает статус (ТЗ 0048).
   *
   * Мутация написана в ТЗ 0046 и до ТЗ 0048 **не вызывалась ни одним
   * экраном**: формы набора не существовало. Три дефекта, разобранные в
   * `save_intake`, прожили в ней ровно поэтому — их некому было предъявить.
   */
  saveFundingIntake?: Maybe<SaveFundingIntake>;
  /**
   * Create or update an operator, then re-expand its coverage index.
   *
   * Coverage is DERIVED — `services.geo.rebuild_coverage` runs on every save,
   * so the (operator × powiat) matching index can never drift away from the
   * declared scope.
   */
  saveFundingOperator?: Maybe<SaveFundingOperator>;
  /**
   * Завести или поправить профессию (ТЗ 0040 фаза C).
   *
   * Удаления нет: у трека висит `StudentTrackChoice` — выбор студента, и
   * удалить трек значит молча отобрать у человека цель, которую он себе
   * поставил. Есть скрытие.
   */
  saveGrowthTrack?: Maybe<SaveGrowthTrack>;
  /**
   * Save the LMS suspension settings. Validation: overdueDays 1..90
   * (`invalid_overdue_days`); mail may be enabled only with BOTH templates
   * (`template_required`); a new template id (or one never checked) must
   * exist in SendGrid (`template_not_found`) and its name is copied from
   * SendGrid; SendGrid unreachable → `sendgrid_unavailable` /
   * `sendgrid_forbidden`, nothing saved. Audited (from → to).
   *
   * The SendGrid check (network) runs against an unlocked read, BEFORE the
   * transaction; the final validation runs again INSIDE it, on the row
   * re-read under `select_for_update` with this call's partial input laid
   * over it — a concurrent save (e.g. clearing a template while this call
   * enables mail) cannot produce a row that breaks the rules.
   */
  saveLmsBlockSettings?: Maybe<SaveLmsBlockSettingsMutation>;
  /** Завести или поправить курс витрины (что школа продаёт). */
  saveSiteCourse?: Maybe<SaveSiteCourse>;
  /** Full-list save of the school-wide component library (spec 0010 rev.2). */
  saveWhiteboardLibrary?: Maybe<SaveWhiteboardLibraryMutation>;
  saveWhiteboardScene?: Maybe<SaveWhiteboardSceneMutation>;
  seedCashFlowRules?: Maybe<CashFlowRunOutput>;
  /** Reply into a Gmail thread; mirrors the sent message locally. */
  sendGmailReply?: Maybe<SendGmailReplyMutation>;
  /**
   * Send a dynamic-template email to selected students of a group.
   *
   * Each recipient gets their OWN message with their own name, amount and pay
   * link — never a shared blast. Returns the job id to poll (`mailJob`) for live
   * progress and per-recipient delivery status.
   */
  sendGroupTemplateEmail?: Maybe<SendGroupTemplateEmail>;
  sendLmsAuthEmail?: Maybe<SendAuthenticationCode>;
  /**
   * Send a suspension / restoration template with the EXAMPLE data to the
   * calling staff member (or LMS_BLOCK_MAIL_TEST_RECIPIENT when set). Needs env
   * LMS_BLOCK_MAIL_ENABLED (`disabled_on_server`), not the ERP mail switch.
   * Writes no AccessBlockNotification.
   */
  sendLmsBlockTestEmail?: Maybe<SendLmsBlockTestEmailMutation>;
  sendMorningReport?: Maybe<SendMorningReportMutation>;
  /**
   * Compose and send a BRAND-NEW email from a chosen shared mailbox (not a
   * reply). Mirrors it locally as a new gmail-thread conversation.
   */
  sendNewEmail?: Maybe<SendNewEmailMutation>;
  /** SDL: {success, errors, customErrors}. */
  sendPasswordResetEmail?: Maybe<CustomSendPasswordResetEmail>;
  /**
   * Post a message into one of a group's Slack channels — including the
   * FIRST one, before any Conversation mirror exists. Lets a manager start a
   * channel thread instead of only replying into an existing dialog.
   */
  sendSlackChannelMessage?: Maybe<SendSlackChannelMessage>;
  /** Reply into a Slack conversation; mirrors the sent message locally. */
  sendSlackMessage?: Maybe<SendSlackMessageMutation>;
  /**
   * Manually flag/unflag a contract as «бесплатный договор».
   *
   * Excludes the contract from ALL debt/overdue detection (student-card totals,
   * LMS-block candidates, debtors list, payment calendar) while leaving it
   * active — so the student keeps LMS access to the group. Like `transfer_out`
   * it also relaxes the FULL-zeroing correction guard, so the paid invoice can
   * be corrected to zero without pretending the contract was transferred.
   * Restricted to Admin/FinanceManager and audited — it silences a real debt, so
   * a rank-and-file operator must not be able to set it.
   */
  setAgreementFreeOfCharge?: Maybe<SetAgreementFreeOfChargeMutation>;
  /**
   * Manually flag/unflag a contract as «финансирование государством».
   *
   * The student is pre-financed by the state: intermediate documents
   * (proforma/advance/VAT) are not a debt — only an unpaid overdue FINAL
   * invoice is — and the plan/contributions owe nothing until then. Debt gates
   * honor this across totals, LMS block, debtors list and calendar. Restricted
   * to Admin/FinanceManager and audited.
   */
  setAgreementStatePrefinanced?: Maybe<SetAgreementStatePrefinancedMutation>;
  /**
   * Manually flag/unflag an agreement as «переведён из этой группы».
   *
   * The flag relaxes the FULL-zeroing limit on corrections (partials work
   * without it) and the carry-out money guards (still capped at `paid_amount`).
   * Restricted to Admin/FinanceManager and audited — it must not be settable by
   * a rank-and-file operator, and never via a self-declared termination reason.
   */
  setAgreementTransferOut?: Maybe<SetAgreementTransferOutMutation>;
  setBankTransactionCategory?: Maybe<SetCategoryOutput>;
  /**
   * Classify a selection of rows in one decision.
   *
   * Learning is collapsed by signal: twenty rows of one contractor teach ONE
   * rule, not twenty. Done as N single calls the operator would get twenty
   * answers to one decision, nineteen of them «правило уже было».
   */
  setBankTransactionCategoryBulk?: Maybe<CashFlowRunOutput>;
  setBankTransactionInternal?: Maybe<BankTransactionOutput>;
  /**
   * Пометить ведущего оператора (или снять пометку).
   *
   * ⚠️ Пометка НИКОГО НЕ ГЛУШИТ: письма продолжают уходить от всех активных
   * операторов. До ТЗ 0067 эта же запись означала «перевод, старый
   * замолкает» — теперь замолкание делается явно и с причиной.
   */
  setCandidatePrimaryOperator?: Maybe<SetCandidatePrimaryOperator>;
  /**
   * LMS: сменить статус отклика.
   *
   * 🔴 `hired` НЕ создаёт `PlacementRecord`, НЕ переводит участника в `placed`
   * и НЕ выдаёт медаль. Самозаявленное трудоустройство не может стать KPI
   * школы, а на архивном участнике автоперевод в `placed` (статус АКТИВНЫЙ)
   * молча вернул бы доступ в центр мимо явной разархивации. Строка лишь встаёт
   * в очередь подтверждения сотруднику.
   */
  setCareerApplicationStatus?: Maybe<SetCareerApplicationStatus>;
  /** LMS: toggle a lesson bookmark for the calling student. */
  setCareerLessonBookmark?: Maybe<SetCareerLessonBookmark>;
  /** ERP: replace a lesson's self-check quiz (delete-and-recreate). */
  setCareerLessonQuiz?: Maybe<SetCareerLessonQuiz>;
  /**
   * Убрать из карьерного центра или вернуть обратно.
   *
   * 🔴 Это НЕ удаление. Пропадает только доступ: строка участника, прогресс по
   * урокам, отклики и запись о трудоустройстве остаются нетронутыми, и вернуть
   * человека можно тем же действием. Так решено владельцем.
   *
   * Массовая с самого начала — оператор чистит ошибочно добавленную группу
   * целиком. Отдельная мутация «на одного» была бы тем же кодом, а триста
   * вызовов подряд — тремястами перезагрузками списка (тот же довод, что у
   * `bulkSetVacancyStatus`).
   */
  setCareerMembersAccess?: Maybe<SetCareerMembersAccess>;
  /**
   * Спрятать навык из автокомплита или вернуть обратно.
   *
   * Мутации удаления НЕТ намеренно: `Skill.delete()` каскадит `StudentSkill`,
   * то есть стирает навык из резюме всех владельцев, и вычищает теги вакансий.
   */
  setCareerSkillActive?: Maybe<SetCareerSkillActive>;
  /**
   * Загрузить свою картинку навыка или убрать её (ТЗ 0039, доводка UX).
   *
   * Иконка НЕОБЯЗАТЕЛЬНА: без неё фронт рисует встроенный логотип по `slug`, а
   * если и его нет — буквенную плашку по категории. Поэтому «убрать» здесь не
   * оставляет пустое место, а возвращает автоподбор, и оператору не приходится
   * держать картинку только для того, чтобы строка не выглядела сломанной.
   *
   * Загрузка идёт мультипартом и пишется сервером — тем же путём, что видео
   * урока и вложения; настраивать CORS бакета не нужно.
   */
  setCareerSkillIcon?: Maybe<SetCareerSkillIcon>;
  setCashBalance?: Maybe<CashBalanceMutationOutput>;
  /** Set a conversation's handling status (open / in_progress / done). */
  setConversationStatus?: Maybe<SetConversationStatusMutation>;
  /** Ручное «зачтено / не засчитывать» по паре студент-курс. */
  setCourseCompletion?: Maybe<SetCourseCompletion>;
  /**
   * Переписать программу курса (ТЗ 0040 фаза C).
   *
   * До этого программу можно было только загрузить Excel-импортом из
   * Django-админки: опечатка чинилась перезаливкой файла целиком.
   */
  setCourseProgram?: Maybe<SetCourseProgram>;
  /**
   * Задать набор навыков курса целиком — ШАБЛОН для будущих групп.
   *
   * 🔴 Пересчёта начислений здесь больше нет (ТЗ 0041). Набор курса перестал
   * быть действующим правилом: начисление читает набор ГРУППЫ, снятый с курса
   * в момент её создания. Правка шаблона по решению владельца не догоняет уже
   * идущие группы — иначе студент старой группы получал бы навык не на том
   * занятии, ради чего перенос и делался. Пересчёт ставит `SetGroupSkills`.
   */
  setCourseSkills?: Maybe<SetCourseSkills>;
  setExchangeRate?: Maybe<ExchangeRateMutationOutput>;
  /**
   * One-click status change (planned / confirmed / paid / cancelled).
   *
   * Lighter than `updateExpense`: the register, the calendar and the
   * teacher-payout list flip a status inline without rebuilding the whole
   * input. `apply_status_transition` derives `paid_at` from the target status
   * (paid → stamp today unless already set / supplied; non-paid → clear).
   * Allowed on `source='fakturownia'` rows too — status is a manual field,
   * not part of the money lock the bridge owns.
   */
  setExpenseStatus?: Maybe<ExpenseMutationOutput>;
  /**
   * DEPRECATED. Change just the legacy `linked_group` column.
   * Use `linkFakturowniaInvoiceToPayment` to set the canonical chain.
   * @deprecated The group is now reached as invoice.contribution.agreement.group (ТЗ 0004).
   */
  setFakturowniaInvoiceGroup?: Maybe<FakturowniaMutationOutput>;
  /** Pin the fee by hand when the composition cannot explain the remainder. */
  setGatewaySettlementFee?: Maybe<GatewaySettlementOutput>;
  setGroupLessonLink?: Maybe<SetGroupLessonLink>;
  setGroupLessonLinkOverride?: Maybe<SetGroupLessonLinkOverride>;
  /**
   * Задать набор навыков ГРУППЫ целиком (ТЗ 0041).
   *
   * Пересчёт начислений НЕ делается здесь: группа с тремя десятками студентов
   * и дюжиной навыков — это сотни записей внутри GraphQL-запроса. Ставим
   * задачу; при недоступном брокере считаем синхронно, но не молча.
   */
  setGroupSkills?: Maybe<SetGroupSkills>;
  setGroupZoomAccount?: Maybe<SetGroupZoomAccountMutation>;
  /** Set a group's Zoom account and fully replace its processing slots. */
  setGroupZoomSchedule?: Maybe<SetGroupZoomScheduleMutation>;
  /**
   * Mark one message handled/unhandled — обработано (team-wide global).
   *
   * With `cascade` (spec 0030) the tick also closes everything ABOVE it in
   * the same dialog: reading and handling a later message means the earlier
   * ones were dealt with too, which is how a human actually works a thread.
   * Un-ticking never cascades — see the branch below.
   */
  setMessageHandled?: Maybe<SetMessageHandledMutation>;
  /**
   * Студент сам оценил уровень навыка (0072): из паспорта навыка или из
   * подсказки «Wspomniano w CV». Подтверждённый школой уровень не понижается.
   */
  setMySkillLevel?: Maybe<SetMySkillLevel>;
  /**
   * Save the ACTING manager's personal Slack user token (xoxp) for a
   * group's workspace — DM replies to students then go out as the manager
   * himself, and his person-to-person DMs become pullable by sync. The token
   * is validated via auth.test and must belong to the group's workspace.
   * Write-only: no query ever returns it.
   */
  setMySlackUserToken?: Maybe<SetMySlackUserTokenMutation>;
  setPaymentCalendarSettings?: Maybe<CalendarSettingsMutationOutput>;
  /** The student's own opt-in to partner search (Ф3) + contact visibility. */
  setProfileSearchable?: Maybe<SetProfileSearchable>;
  /** Включить или выключить акцию. Удаления нет: коды уже у людей на руках. */
  setPromoCampaignActive?: Maybe<SetPromoCampaignActive>;
  /**
   * Bulk-assign question topics (spec 0038).
   *
   * Deliberately NOT routed through `updateSurvey`: that takes a whole survey
   * payload and would make retagging 40 questions across 12 surveys twelve
   * read-modify-write round trips. A topic is a label, not part of the answer
   * contract, so it stays editable even on a survey that already has answers —
   * that is precisely how historical surveys enter the analytics.
   */
  setQuestionMetrics?: Maybe<SetQuestionMetricsMutation>;
  /**
   * Bind (or update) the Slack workspace for a group. Only the bot token is
   * really needed (no OAuth flow): a blank team id is resolved via auth.test.
   * `team_id` stays as an advanced override; `signing_secret` matters only for
   * the optional realtime webhook.
   */
  setSlackWorkspace?: Maybe<SetSlackWorkspaceMutation>;
  setStudentsMarks?: Maybe<SetStudentsMarksMutation>;
  /**
   * Replace the survey's whole «Аудитория и триггер» block.
   *
   * One bulk call, not N `assignSurveyToGroup`s: dropping a group from a rule
   * needs a diff against the previous state, which only the server holds.
   *
   * `success: true` WITH a populated `targeting.skipped[]` is the normal
   * outcome — the rules saved and some groups simply have no lesson N. Only
   * rule-level problems (INVALID_PLAN / COURSE_MISMATCH / PLAN_LOCKED /
   * ARCHIVED / NOT_FOUND) come back as customErrors with success=False.
   */
  setSurveyTargeting?: Maybe<SetSurveyTargetingMutation>;
  /**
   * Paste the text of a document whose extraction failed.
   *
   * The recovery path for a SCANNED CV: the PDF is perfectly valid, it simply
   * has no text layer, and there is no OCR in this system. Mirrors
   * `setTeacherInterviewTranscript` so the AI layer keeps reading one field and
   * never learns where the text came from.
   */
  setTeacherDocumentText?: Maybe<SetTeacherDocumentText>;
  /**
   * Paste a transcript or interview notes.
   *
   * In v1 this is the PRIMARY route to an analysable interview: Zoom only emits
   * a transcript when *Audio transcript* is enabled on that account (and never
   * retroactively), and this system has no speech-to-text of its own.
   */
  setTeacherInterviewTranscript?: Maybe<SetTeacherInterviewTranscript>;
  /**
   * Update the control-panel profile fields — rating, internal note,
   * interview-recording link, and the courses-can-teach list. Only the fields
   * actually passed are changed; `rating=0` clears the rating.
   */
  setTeacherProfile?: Maybe<SetTeacherProfile>;
  setVacancyStatus?: Maybe<SetVacancyStatus>;
  /**
   * Open a Slack DM with a student OR a teacher and post the first message,
   * before any Conversation exists — so a manager can write first. Sent AS the
   * manager (his xoxp user token; a bot can't hold a 1:1 DM).
   */
  startSlackDm?: Maybe<StartSlackDm>;
  /**
   * Return a signed Slack authorize URL so the ACTING manager can grant his
   * personal xoxp user token for a group's workspace in one click — no
   * api.slack.com, no copy-paste. The browser then navigates to Slack; on
   * "Allow" Slack redirects to `slack_oauth_callback`, which stores the token.
   *
   * Identity + group are captured HERE (under the JWT this mutation runs behind)
   * and sealed into a short-lived signed `state` (django.core.signing), because
   * the callback is a plain browser redirect that carries no JWT.
   */
  startSlackUserOauth?: Maybe<StartSlackUserOauthMutation>;
  /** Выдать одноразовую ссылку привязки. */
  startTelegramLink?: Maybe<StartTelegramLink>;
  /** Сдача анкеты студентом (LMS). */
  submitCareerLessonExercise?: Maybe<SubmitCareerLessonExercise>;
  /**
   * LMS: score the student's answers and record an attempt (self-check —
   * never gates the lesson).
   */
  submitCareerQuiz?: Maybe<SubmitCareerQuiz>;
  /**
   * Публичная форма приёма заявок. ЕДИНСТВЕННАЯ анонимная запись в домене.
   *
   * Три правила, каждое из которых существует из-за конкретного риска:
   *
   * * **ответ одинаков для знакомого и незнакомого e-mail** — иначе форма
   *   становится оракулом перебора адресов, и её ответ собирается скриптом.
   *   По той же причине здесь нет ни «вы уже подавали заявку», ни возврата
   *   идентификатора кандидата;
   * * **`CustomUser` не создаётся никогда** — e-mail и телефон у пользователя
   *   уникальны, и анонимная запись заняла бы адрес, на который потом
   *   резолвится реальный подписанный договор;
   * * **сначала сохраняется сырая заявка, потом отдельно триаж** — лид не
   *   должен теряться из-за того, что упала дедупликация.
   *
   * Ошибка триажа НЕ отменяет приём: заявка уже в базе, менеджер разберёт её
   * из админки, а причина остаётся в `process_error`.
   */
  submitFundingForm?: Maybe<SubmitFundingForm>;
  /**
   * Student submits (or replaces) their homework: a GitHub link AND/OR a
   * ZIP archive (at least one, both allowed together). Re-submitting after
   * grading resets the grade. No teacher assignment is required (rev.3).
   */
  submitHomework?: Maybe<SubmitHomeworkMutation>;
  submitSurveyResponse?: Maybe<SubmitSurveyResponseMutation>;
  /** Sync accounts + every cloud recording in Zoom for a date range. */
  syncAllZoomRecordings?: Maybe<SyncAllZoomRecordingsMutation>;
  /**
   * On-demand «обновить сообщения»: enqueue a Slack backfill PLUS a Gmail
   * backfill of the latest mail (metadata-first, so it's cheap). Without
   * group_id it syncs every ENABLED workspace of an ACTIVE group (last lesson
   * within SYNC_ACTIVE_DAYS, or no lessons yet — spec 0032; the old predicate
   * demanded a FUTURE lesson and on real data matched nothing) plus legacy
   * channel links; with group_id it
   * syncs that group's workspace regardless of activity — the group-card
   * button keeps working for finished groups. Async via Celery — the button
   * returns immediately; new messages appear once the worker finishes.
   */
  syncCommunicationsNow?: Maybe<SyncCommunicationsNowMutation>;
  /**
   * On-demand 'refresh mail' button: enqueue a Gmail backfill of the latest
   * ~100 messages per mailbox. Runs async via Celery so the request returns
   * immediately; the new mail appears once the worker finishes.
   */
  syncGmailNow?: Maybe<SyncGmailNowMutation>;
  /**
   * Create (if needed) and refill the group's SendGrid contact list.
   *
   * Idempotent — contacts are upserted by email, so re-running re-syncs rather
   * than duplicating. SendGrid processes the upload asynchronously, so the
   * contact count updates a few seconds later.
   */
  syncGroupSendgridList?: Maybe<SyncGroupSendgridList>;
  /**
   * Кнопка «Пересчитать навыки» на карточке участника.
   *
   * 🔴 Поля обязаны покрывать ВСЮ сводку `skill_grant.grant_for_student`:
   * ответ собирается как `cls(**stats)`, и лишний ключ — это `TypeError`, то
   * есть пятисотка на кнопку. Так и было с `reattributed`: сводка его отдавала
   * с самого начала, а поля для него не завели, и кнопка падала на любом
   * студенте (ТЗ 0040, попутная находка). Тест `test_sync_button_returns_full_stats`
   * держит два списка вместе.
   */
  syncStudentCourseSkills?: Maybe<SyncStudentCourseSkills>;
  syncZoomAccounts?: Maybe<SyncZoomAccountsMutation>;
  syncZoomRecordings?: Maybe<SyncZoomRecordingsMutation>;
  /** Refresh the Zoom account usage summary (storage quota + counts). */
  syncZoomUsage?: Maybe<SyncZoomUsageMutation>;
  /**
   * Safe one-click agreement termination — see docs/groups/groups_upgrade.md §B3.
   *
   * Replaces the chained `updateStudentWithAgreement` workaround that
   * re-sent the student's PII just to flip `terminated=True`. This mutation
   * touches only the agreement and writes an audit log entry; contributions
   * and deferred payments are deliberately left alone.
   */
  terminateAgreement?: Maybe<TerminateAgreementMutation>;
  toggleAchievement?: Maybe<ToggleAchievement>;
  /**
   * Скрыть или вернуть анкету. Удаления нет: оно снесло бы сдачи вместе с
   * журналом того, что уехало студентам в резюме.
   */
  toggleCareerExerciseTemplate?: Maybe<ToggleCareerExerciseTemplate>;
  toggleGrowthTrack?: Maybe<ToggleGrowthTrack>;
  toggleSiteCourse?: Maybe<ToggleSiteCourse>;
  /**
   * Group-scoped Fakturownia sync — docs/groups/group_dashboard.md §G10.
   *
   * Same Celery task as `triggerFakturowniaSync`, but the dedup lock is
   * scoped per `(group_id, period)` so a busy operator can fire syncs
   * for several groups without the global trigger getting in the way.
   * The payer-email UNION (agreement.buyer_email + student.email) is
   * recorded in the audit log and the returned `message`; narrowing the
   * actual Fakturownia API call by that list is intentionally deferred —
   * the mirror only ever grows, and the new canonical `groupId` filter
   * (§G7) will surface the new rows on the group's FinancesTab as soon
   * as the sync completes.
   */
  triggerFakturowniaGroupSync?: Maybe<TriggerFakturowniaGroupSyncMutation>;
  /**
   * Fire-and-forget: enqueue a Fakturownia sync via Celery.
   *
   * The frontend pattern is: call this mutation → poll
   * `fakturownia_sync_status` until `is_running` flips back to false →
   * read `last_run.stats` to render "synced N invoices". The returned
   * `last_run` is the state *before* the new task starts so the UI can
   * show "synced 14:23 (… enqueueing new run …)" instantly.
   */
  triggerFakturowniaSync?: Maybe<TriggerFakturowniaSyncMutation>;
  /**
   * Enqueue a full PandaDoc re-sync (list + details, with student folder
   * backfill). Powers the dashboard 'refresh everything' button — the Celery
   * task self-chains until the whole details backlog is drained.
   */
  triggerPandadocSync?: Maybe<TriggerPandadocSyncMutation>;
  /**
   * Manual Zoom sync scoped to one group — docs/groups/group_dashboard.md
   * §G9. Re-runs `sync_recordings` for the window and the matcher against
   * the group's lessons. 60-sec dedup lock per group so a frantic operator
   * doesn't queue ten copies.
   */
  triggerZoomGroupProcess?: Maybe<TriggerZoomGroupProcessMutation>;
  /**
   * Restore a student's LMS access by hand (ТЗ 0074 §3.4). The already
   * overdue invoices the suspension was tied to are forgiven (`waived`) — a
   * NEW overdue invoice (or a tied one that was not due yet) suspends again.
   */
  unblockStudentLmsAccess?: Maybe<UnblockStudentLmsAccessMutation>;
  unlinkBankTransaction?: Maybe<BankTransactionOutput>;
  unlinkCandidateFromUser?: Maybe<UnlinkCandidateFromUser>;
  /**
   * Detach the Payment from a Contribution. The Payment stays alive as
   * an orphan (visible in the "вне графика" block); the Contribution
   * flips back to `complete=False, remainder=amount_foreign`.
   * @deprecated Legacy: use unlinkInvoiceFromContribution (ТЗ 0004).
   */
  unlinkContribution?: Maybe<UnlinkContributionMutation>;
  /**
   * Drop both `payment` and the legacy `linked_*` columns, returning the
   * invoice to `unmatched`. The Payment row itself is left intact — finance
   * may still want it for the agreement's ledger; only the bridge is removed.
   * @deprecated Legacy payment-first unlink (ТЗ 0004). Use unlinkInvoiceFromContribution.
   */
  unlinkFakturowniaInvoice?: Maybe<FakturowniaMutationOutput>;
  /**
   * Drop the invoice → contribution link and re-derive the installment's
   * coverage. The invoice's Payment (if provisioned) stays attached to the
   * invoice — real received money is never destroyed here.
   */
  unlinkInvoiceFromContribution?: Maybe<FakturowniaMutationOutput>;
  unlinkLessonRecording?: Maybe<UnlinkLessonRecordingMutation>;
  unlinkLessonWhiteboard?: Maybe<UnlinkLessonWhiteboardMutation>;
  /** Detach a manually-linked PandaDoc document from its agreement. */
  unlinkPandadocDocument?: Maybe<UnlinkPandadocDocumentMutation>;
  /** Detach a PandaDoc document from its teacher. */
  unlinkPandadocTeacher?: Maybe<UnlinkPandadocTeacherMutation>;
  unlinkTelegram?: Maybe<UnlinkTelegram>;
  updateAttendance?: Maybe<UpdateAttendanceMutation>;
  updateCareerApplication?: Maybe<UpdateCareerApplication>;
  updateCareerMember?: Maybe<UpdateCareerMember>;
  /**
   * Turn a rule off, re-prioritise it, or point it at another category.
   *
   * Disabling does not roll back what the rule already classified: those rows
   * keep their category and are re-flagged `orphaned` on the next run, so a
   * closed month cannot move because someone switched a rule off.
   */
  updateCashFlowRule?: Maybe<SetCategoryOutput>;
  /**
   * Edit the global settings row.
   *
   * Exposed because internal-transfer detection is inert until `ownPartyNames`
   * is filled in, and on production there was no way to fill it in at all — the
   * model was in neither the admin nor the schema.
   */
  updateCashFlowSettings?: Maybe<CashFlowSettingsOutput>;
  updateCompany?: Maybe<UpdateCompanyMutation>;
  updateCourse?: Maybe<UpdateCourseMutation>;
  updateExpense?: Maybe<ExpenseMutationOutput>;
  updateGroup?: Maybe<UpdateGroupMutation>;
  updateJournal?: Maybe<UpdateJournalsMutation>;
  updateMaterial?: Maybe<UpdateMaterialMutation>;
  /**
   * Patch a Payment's amount and/or date.
   *
   * Re-derives `amount_byn` / `amount_foreign` via `PaymentBase.save()` —
   * that's how the existing forms-based path keeps the chargeback / debt
   * tables consistent.
   * @deprecated Legacy: Payments are system-provisioned (ТЗ 0004) and not edited by operators.
   */
  updatePayment?: Maybe<UpdatePaymentMutation>;
  updatePaymentCorrection?: Maybe<UpdatePaymentCorrectionMutation>;
  updatePlannedPayment?: Maybe<PlannedPaymentMutationOutput>;
  updateStaffNotificationSettings?: Maybe<UpdateStaffNotificationSettings>;
  updateStaffTask?: Maybe<UpdateStaffTaskMutation>;
  updateStudentNote?: Maybe<UpdateStudentNoteMutation>;
  updateStudentWithAgreement?: Maybe<StudentWithAgreementUpdateMutation>;
  updateSurvey?: Maybe<UpdateSurveyMutation>;
  updateSurveyAssignment?: Maybe<UpdateSurveyAssignmentMutation>;
  /** Move a task between statuses; stamps/clears `completed_at` on done. */
  updateTaskStatus?: Maybe<UpdateTaskStatusMutation>;
  updateTeacherApplication?: Maybe<UpdateTeacherApplication>;
  updateTeacherWithType?: Maybe<UpdateTeacherWithTypeMutation>;
  updateUserSettings?: Maybe<UserSettingsUpdateMutation>;
  /**
   * Load a statement from the browser — the entry point of the whole loop.
   *
   * Defaults to a preview: the operator sees how many rows are new, how many
   * are duplicates, which accounts and categories the file names that we do not
   * know, where the running balance disagrees, and twenty repaired descriptions
   * to eyeball the encoding. Only then do they commit.
   *
   * Re-uploading a file that was already committed is the commonest operator
   * mistake, so it is answered from `file_hash` before the file is even parsed.
   * Import is idempotent regardless — this just makes the answer immediate and
   * legible instead of "0 created, 1262 duplicates".
   *
   * The format is recognised from the first bytes, never from a dropdown: PKO
   * calls both its XLSX dashboard export and its legacy BIFF workbook «Excel»,
   * and a wrong pick would not fail — it would mis-parse.
   */
  uploadBankStatement?: Maybe<BankStatementUploadOutput>;
  /**
   * ERP: upload a lesson video (multipart, server-side write to the private
   * bucket — the same path as attachments, diplomas and the Django-admin file
   * widget, so no bucket CORS is required).
   */
  uploadCareerLessonVideo?: Maybe<UploadCareerLessonVideo>;
  uploadLessonVideo?: Maybe<UploadLessonVideo>;
  /** Attach or replace one student's diploma in one language. */
  uploadStudentDiploma?: Maybe<UploadStudentDiplomaMutation>;
  /**
   * Upload a CV (or certificate / portfolio) and extract its text.
   *
   * Extraction runs INLINE, not in Celery: `pypdf` on a resume is milliseconds,
   * and a background hop would make the client poll for a status that is already
   * known by the time this response is written.
   *
   * Versioned, never replaced — a re-sent CV becomes v2 and v1 stays readable.
   */
  uploadTeacherDocument?: Maybe<UploadTeacherDocument>;
  /**
   * Multipart upload for an interview recorded outside Zoom.
   *
   * One mutation per file, the diploma rule. Capped at
   * MAX_TEACHER_INTERVIEW_VIDEO_BYTES: a full 90-minute 1080p recording is
   * 1-2 GB, and raising nginx `client_max_body_size` to match would affect every
   * endpoint and pin one sync gunicorn worker for the whole transfer — such
   * recordings belong on the Zoom path, which streams server-to-server.
   */
  uploadTeacherInterviewVideo?: Maybe<UploadTeacherInterviewVideo>;
  /**
   * Pastes an image onto a board (spec 0010 rev.3): the bytes go to the
   * private bucket, the scene keeps only the fileId reference.
   */
  uploadWhiteboardFile?: Maybe<UploadWhiteboardFileMutation>;
  upsertCareerLesson?: Maybe<UpsertCareerLesson>;
  /** Завести или поправить навык справочника. */
  upsertCareerSkill?: Maybe<UpsertCareerSkill>;
  /**
   * Teacher creates or edits the lesson's homework assignment (backed by
   * materials.Material kind=HOMEWORK; ≤1 per lesson via this path).
   */
  upsertHomeworkAssignment?: Maybe<UpsertHomeworkAssignmentMutation>;
  /** Завести или поправить акцию (ТЗ 0039, шаг 6). */
  upsertPromoCampaign?: Maybe<UpsertPromoCampaign>;
  /** ERP: текст поста правится БЕЗ выката — это маркетинг, а не интерфейс. */
  upsertShareTemplate?: Maybe<UpsertShareTemplate>;
  upsertVacancy?: Maybe<UpsertVacancy>;
  /** SDL: {payload: GenericScalar, success, errors}. */
  verifyToken?: Maybe<VerifyToken>;
  /**
   * Zero an UNPAID contribution's amount on a transfer-out agreement.
   *
   * `Contribution.save()` re-derives `remainder = amount_foreign` for any
   * unpaid row, so "set remainder=0" is impossible — the legitimate way to
   * drop a contribution to zero is to set its AMOUNT to 0. This is strictly
   * gated:
   *
   * * the agreement must be `terminated` AND `transfer_out` — i.e. wound down
   *   via `ChangeAgreementGroup`, which clones the schedule onto the NEW group,
   *   so the obligation is re-attributed there, not erased; and
   * * the contribution must NOT have a linked Payment — real received money is
   *   never destroyed here. To move already-received cash out of the old group,
   *   use a Chargeback / AccountsPayable carry-out (capped at `paid_amount`),
   *   not this mutation.
   *
   * Every call is audited. The old terminated contract is already excluded from
   * debtors / finance / the calendar by the `terminated_date` cutoff; zeroing
   * additionally makes the old agreement read literally zero, which is what the
   * "обнулить старую группу" workflow asks for.
   */
  zeroOutContribution?: Maybe<ZeroOutContributionMutation>;
};


export type MutationAddCandidateOperatorsArgs = {
  candidateId: Scalars['ID'];
  note?: InputMaybe<Scalars['String']>;
  operatorIds: Array<Scalars['ID']>;
};


export type MutationAddCareerLessonAttachmentArgs = {
  file: Scalars['Upload'];
  lessonId: Scalars['ID'];
};


export type MutationAddGatewaySettlementItemArgs = {
  invoiceId: Scalars['ID'];
  kind?: InputMaybe<Scalars['String']>;
  settlementId: Scalars['ID'];
};


export type MutationAddStaffTaskAttachmentArgs = {
  commentId?: InputMaybe<Scalars['ID']>;
  file: Scalars['Upload'];
  taskId: Scalars['ID'];
};


export type MutationAddStaffTaskCommentArgs = {
  body?: InputMaybe<Scalars['String']>;
  files?: InputMaybe<Array<InputMaybe<Scalars['Upload']>>>;
  taskId: Scalars['ID'];
};


export type MutationAddStaffTaskLinksArgs = {
  links: Array<TaskLinkInput>;
  taskId: Scalars['ID'];
};


export type MutationAddTeacherApplicationArgs = {
  application: ApplicationInputType;
  teacherId: Scalars['ID'];
};


export type MutationAddTeacherExistArgs = {
  application: ApplicationInputType;
  employmentTypes: ExistEmploymentInputType;
  teacherId: Scalars['ID'];
};


export type MutationAddTeacherRoleArgs = {
  application: ApplicationInputType;
  employmentTypes: EmploymentInputType;
  siteDisplay?: InputMaybe<Scalars['Boolean']>;
  userId: Scalars['ID'];
};


export type MutationAppendRolesUserSettingsArgs = {
  roles: Scalars['String'];
  userId: Scalars['ID'];
};


export type MutationAppendStudentRoleAndAgreementArgs = {
  agreementInput: CreateAgreementInputBase;
  userId: Scalars['ID'];
};


export type MutationAppendStudentToGroupArgs = {
  agreementInput: CreateAgreementInputBase;
  studentId: Scalars['ID'];
};


export type MutationApplyTeacherCourseSuggestionsArgs = {
  action: Scalars['String'];
  suggestionIds: Array<Scalars['ID']>;
  teacherId: Scalars['ID'];
};


export type MutationArchiveSurveyArgs = {
  id: Scalars['ID'];
  isArchived: Scalars['Boolean'];
};


export type MutationAssignSurveyToGroupArgs = {
  groupId: Scalars['ID'];
  surveyId: Scalars['ID'];
  triggerLessonId: Scalars['ID'];
};


export type MutationAssignSurveyToGroupsArgs = {
  groupIds: Array<Scalars['ID']>;
  surveyId: Scalars['ID'];
  triggerKind: Scalars['String'];
  triggerLessonNumber?: InputMaybe<Scalars['Int']>;
};


export type MutationAttachCareerExerciseTemplateArgs = {
  lessonId: Scalars['ID'];
  templateId: Scalars['ID'];
};


export type MutationAttachTeacherInterviewLinkArgs = {
  recordedAt?: InputMaybe<Scalars['DateTime']>;
  teacherId: Scalars['ID'];
  title?: InputMaybe<Scalars['String']>;
  url: Scalars['String'];
};


export type MutationAttachTeacherInterviewZoomArgs = {
  teacherId: Scalars['ID'];
  title?: InputMaybe<Scalars['String']>;
  zoomRecordingId: Scalars['ID'];
};


export type MutationBlockStudentLmsAccessArgs = {
  notifyStudent?: InputMaybe<Scalars['Boolean']>;
  reason?: InputMaybe<Scalars['String']>;
  studentId: Scalars['ID'];
};


export type MutationBroadcastGroupMessageArgs = {
  channel: Scalars['String'];
  groupId: Scalars['ID'];
  mailboxEmail?: InputMaybe<Scalars['String']>;
  studentIds: Array<Scalars['ID']>;
  subject?: InputMaybe<Scalars['String']>;
  text: Scalars['String'];
};


export type MutationBulkPublishVacanciesArgs = {
  ids: Array<Scalars['ID']>;
};


export type MutationBulkSetVacancyStatusArgs = {
  ids: Array<Scalars['ID']>;
  status: Scalars['String'];
};


export type MutationCancelVideoUploadArgs = {
  lessonId: Scalars['Int'];
};


export type MutationChangeAgreementGroupArgs = {
  input: ChangeAgreementGroupInput;
};


export type MutationChangeCandidateStatusArgs = {
  candidateId: Scalars['ID'];
  note?: InputMaybe<Scalars['String']>;
  status: Scalars['String'];
};


export type MutationChangeLessonDatesArgs = {
  groupId: Scalars['Int'];
  newDate: Scalars['Date'];
  oldDate: Scalars['Date'];
};


export type MutationCheckStudentDebtArgs = {
  agreementsInput: Array<InputMaybe<Scalars['String']>>;
};


export type MutationChooseGrowthTrackArgs = {
  trackCode: Scalars['String'];
};


export type MutationClearBankTransactionReviewArgs = {
  id: Scalars['ID'];
};


export type MutationClearCareerLessonVideoArgs = {
  lessonId: Scalars['ID'];
};


export type MutationClearGroupLessonLinkOverrideArgs = {
  date: Scalars['Date'];
  groupId: Scalars['Int'];
};


export type MutationCompleteCareerLessonArgs = {
  artifactUrl?: InputMaybe<Scalars['String']>;
  lessonId: Scalars['ID'];
};


export type MutationConfirmCashFlowRuleArgs = {
  categorySlug: Scalars['String'];
  retroactive?: InputMaybe<Scalars['Boolean']>;
  transactionId: Scalars['ID'];
};


export type MutationConfirmFundingIntakeArgs = {
  confirmed: Scalars['Boolean'];
  id: Scalars['ID'];
};


export type MutationCreateAgreementArgs = {
  agreementInput: CreateAgreementInput;
};


export type MutationCreateBlackFridayLeadArgs = {
  bfLeadInput: BlackFridayLeadInput;
};


export type MutationCreateCareerApplicationArgs = {
  input: CareerApplicationInput;
};


export type MutationCreateCompanyArgs = {
  companyInput: CompanyInput;
};


export type MutationCreateCourseArgs = {
  name?: InputMaybe<Scalars['String']>;
};


export type MutationCreateDeferredPaymentsArgs = {
  deferredPaymentsInput?: InputMaybe<Array<InputMaybe<DeferredPaymentInput>>>;
};


export type MutationCreateExpenseArgs = {
  input: ExpenseInput;
};


export type MutationCreateExpenseCategoryArgs = {
  name: Scalars['String'];
  slug: Scalars['String'];
};


export type MutationCreateGroupArgs = {
  groupInput: GroupInput;
  moduleInput: Array<InputMaybe<ModuleInput>>;
};


export type MutationCreateLeadArgs = {
  leadInput: LeadInput;
};


export type MutationCreateLessonWhiteboardArgs = {
  lessonId: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
};


export type MutationCreateManualLessonRecordingArgs = {
  lessonId: Scalars['ID'];
  zoomRecordingId: Scalars['ID'];
};


export type MutationCreateMaterialArgs = {
  input: CreateMaterialInput;
};


export type MutationCreateNewYearLeadArgs = {
  nyLeadInput: NewYearLeadInput;
};


export type MutationCreatePaymentArgs = {
  input: CreatePaymentInput;
};


export type MutationCreatePaymentCorrectionArgs = {
  input: CreatePaymentCorrectionInput;
};


export type MutationCreatePaymentForFakturowniaInvoiceArgs = {
  agreementId: Scalars['ID'];
  invoiceId: Scalars['ID'];
  paymentDate?: InputMaybe<Scalars['Date']>;
};


export type MutationCreatePaymentsArgs = {
  paymentsInput?: InputMaybe<Array<InputMaybe<PaymentInput>>>;
};


export type MutationCreatePlannedPaymentArgs = {
  input: PlannedPaymentInput;
};


export type MutationCreateStaffTaskArgs = {
  files?: InputMaybe<Array<InputMaybe<Scalars['Upload']>>>;
  input: CreateStaffTaskInput;
};


export type MutationCreateStudentNoteArgs = {
  input: CreateStudentNoteInput;
};


export type MutationCreateStudentWithAgreementArgs = {
  agreementInput: CreateAgreementInputBase;
  studentInput: StudentInput;
};


export type MutationCreateSurveyArgs = {
  input: SurveyInput;
};


export type MutationCreateTaskFromMessageArgs = {
  assigneeId?: InputMaybe<Scalars['ID']>;
  description?: InputMaybe<Scalars['String']>;
  dueDate?: InputMaybe<Scalars['Date']>;
  groupId?: InputMaybe<Scalars['ID']>;
  messageId: Scalars['ID'];
  priority?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
};


export type MutationCreateTeacherArgs = {
  teacher: NewTeacherInput;
};


export type MutationCreateUniqueTeacherArgs = {
  application: ApplicationInputType;
  employmentTypes: EmploymentInputType;
  teacher: NewTeacherInput;
};


export type MutationCreateUserArgs = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  middleName?: InputMaybe<Scalars['String']>;
  phone: Scalars['String'];
  roles: Scalars['String'];
};


export type MutationCustomLoginArgs = {
  authenticationCode?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  password?: InputMaybe<Scalars['String']>;
  scope: Scalars['String'];
};


export type MutationDeactivateCandidateOperatorArgs = {
  candidateId: Scalars['ID'];
  note?: InputMaybe<Scalars['String']>;
  operatorId: Scalars['ID'];
  reason: Scalars['String'];
};


export type MutationDeleteCareerApplicationArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteCashFlowRuleArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteCourseArgs = {
  courseId?: InputMaybe<Scalars['ID']>;
};


export type MutationDeleteExpenseArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteFundingCandidateArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteFundingIntakeArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteGroupArgs = {
  groupId: Scalars['Int'];
};


export type MutationDeleteMaterialArgs = {
  id: Scalars['ID'];
};


export type MutationDeletePaymentArgs = {
  id: Scalars['ID'];
};


export type MutationDeletePaymentCorrectionArgs = {
  id: Scalars['ID'];
};


export type MutationDeletePlannedPaymentArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteStaffTaskArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteStaffTaskCommentArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteStudentDiplomaArgs = {
  diplomaId: Scalars['ID'];
};


export type MutationDeleteStudentNoteArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteSurveyAssignmentArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteTeacherApplicationArgs = {
  applicationId: Scalars['ID'];
};


export type MutationDeleteTeacherDocumentArgs = {
  documentId: Scalars['ID'];
};


export type MutationDeleteTeacherInterviewArgs = {
  interviewId: Scalars['ID'];
};


export type MutationDeleteUserSettingsArgs = {
  userId?: InputMaybe<Scalars['ID']>;
};


export type MutationDeleteVacancyArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteZoomRecordingArgs = {
  confirm: Scalars['String'];
  id: Scalars['ID'];
};


export type MutationDeleteZoomRecordingsArgs = {
  confirm: Scalars['Boolean'];
  ids: Array<Scalars['ID']>;
};


export type MutationDemoCustomLoginArgs = {
  authenticationCode?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  password?: InputMaybe<Scalars['String']>;
  scope: Scalars['String'];
};


export type MutationDetachCareerExerciseTemplateArgs = {
  lessonId: Scalars['ID'];
};


export type MutationDetectGatewaySettlementsArgs = {
  dateFrom?: InputMaybe<Scalars['Date']>;
  dateTo?: InputMaybe<Scalars['Date']>;
  dryRun?: InputMaybe<Scalars['Boolean']>;
};


export type MutationDuplicateSurveyArgs = {
  id: Scalars['ID'];
};


export type MutationEditStaffTaskCommentArgs = {
  body: Scalars['String'];
  id: Scalars['ID'];
};


export type MutationEnrollCareerMembersArgs = {
  directionId?: InputMaybe<Scalars['ID']>;
  groupId?: InputMaybe<Scalars['ID']>;
  studentIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type MutationFinishLmsLessonArgs = {
  attendances?: InputMaybe<Array<LmsAttendanceType>>;
  comment: Scalars['String'];
  groupLessonId: Scalars['Int'];
};


export type MutationFlagMessageArgs = {
  flagged?: InputMaybe<Scalars['Boolean']>;
  messageId: Scalars['ID'];
};


export type MutationGradeHomeworkArgs = {
  attempt?: InputMaybe<Scalars['Int']>;
  comment?: InputMaybe<Scalars['String']>;
  hwMark: Scalars['String'];
  lessonId: Scalars['ID'];
  studentId: Scalars['ID'];
};


export type MutationIssueInvoiceForContributionArgs = {
  agreementId: Scalars['ID'];
  allowReissue?: InputMaybe<Scalars['Boolean']>;
  contributionId?: InputMaybe<Scalars['ID']>;
  paymentTo?: InputMaybe<Scalars['Date']>;
};


export type MutationIssueInvoicesForGroupArgs = {
  agreementIds?: InputMaybe<Array<Scalars['ID']>>;
  expectedBillableCount?: InputMaybe<Scalars['Int']>;
  groupId: Scalars['ID'];
  paymentTo?: InputMaybe<Scalars['Date']>;
};


export type MutationIssuePromoCodeArgs = {
  campaignId: Scalars['ID'];
  studentId: Scalars['ID'];
};


export type MutationLinkBankTransactionArgs = {
  targetId: Scalars['ID'];
  targetType: Scalars['String'];
  transactionId: Scalars['ID'];
};


export type MutationLinkCandidateToUserArgs = {
  candidateId: Scalars['ID'];
  userId: Scalars['ID'];
};


export type MutationLinkChannelGroupArgs = {
  channelName?: InputMaybe<Scalars['String']>;
  groupId: Scalars['ID'];
  slackChannelId: Scalars['String'];
};


export type MutationLinkContributionToPaymentArgs = {
  input: LinkContributionInput;
};


export type MutationLinkFakturowniaInvoiceToPaymentArgs = {
  invoiceId: Scalars['ID'];
  paymentId: Scalars['ID'];
};


export type MutationLinkInvoiceToContributionArgs = {
  contributionId: Scalars['ID'];
  invoiceId: Scalars['ID'];
};


export type MutationLinkLessonWhiteboardArgs = {
  lessonId: Scalars['ID'];
  whiteboardId: Scalars['ID'];
};


export type MutationLinkPandadocDocumentArgs = {
  agreementId: Scalars['ID'];
  pandadocId: Scalars['String'];
};


export type MutationLinkPandadocTeacherArgs = {
  pandadocId: Scalars['String'];
  teacherId: Scalars['ID'];
};


export type MutationLinkSlackUserArgs = {
  email?: InputMaybe<Scalars['String']>;
  groupId?: InputMaybe<Scalars['ID']>;
  slackUserId: Scalars['String'];
  studentId?: InputMaybe<Scalars['ID']>;
  teacherId?: InputMaybe<Scalars['ID']>;
};


export type MutationLmsClearTodayLessonLinkArgs = {
  groupId: Scalars['Int'];
};


export type MutationLmsJoinLessonArgs = {
  groupLessonId: Scalars['Int'];
};


export type MutationLmsSetAttendanceArgs = {
  attendance: Scalars['Boolean'];
  attendanceId: Scalars['Int'];
};


export type MutationLmsSetTodayLessonLinkArgs = {
  groupId: Scalars['Int'];
  joinUrl: Scalars['String'];
};


export type MutationLmsStudentSignUpArgs = {
  studentInput: StudentSignUpInput;
};


export type MutationMarkAllStaffNotificationsReadArgs = {
  before?: InputMaybe<Scalars['DateTime']>;
  kinds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  maxAgeDays?: InputMaybe<Scalars['Int']>;
};


export type MutationMarkCareerLessonOpenedArgs = {
  lessonId: Scalars['ID'];
};


export type MutationMarkContributionPaidManuallyArgs = {
  amount?: InputMaybe<Scalars['Float']>;
  contributionId: Scalars['ID'];
  date: Scalars['Date'];
  note?: InputMaybe<Scalars['String']>;
};


export type MutationMarkConversationReadArgs = {
  conversationId: Scalars['ID'];
  read?: InputMaybe<Scalars['Boolean']>;
};


export type MutationMarkConversationsHandledArgs = {
  conversationId?: InputMaybe<Scalars['ID']>;
  dateFrom?: InputMaybe<Scalars['Date']>;
  dateTo?: InputMaybe<Scalars['Date']>;
  groupId?: InputMaybe<Scalars['ID']>;
  kinds?: InputMaybe<Array<Scalars['String']>>;
  scope: Scalars['String'];
  search?: InputMaybe<Scalars['String']>;
  studentId?: InputMaybe<Scalars['ID']>;
  teacherId?: InputMaybe<Scalars['ID']>;
  unhandledOnly?: InputMaybe<Scalars['Boolean']>;
};


export type MutationMarkGatewaySettlementReconciledArgs = {
  notes: Scalars['String'];
  settlementId: Scalars['ID'];
};


export type MutationMarkLessonMissingRecordingArgs = {
  lessonId: Scalars['ID'];
};


export type MutationMarkMessageReadArgs = {
  messageId: Scalars['ID'];
  read?: InputMaybe<Scalars['Boolean']>;
};


export type MutationMarkStaffNotificationsReadArgs = {
  ids: Array<Scalars['ID']>;
  kinds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  maxAgeDays?: InputMaybe<Scalars['Int']>;
};


export type MutationMarkVacancyInteractionArgs = {
  kind: Scalars['String'];
  vacancyId: Scalars['ID'];
};


export type MutationMatchDiplomaFilesArgs = {
  fileNames: Array<Scalars['String']>;
  groupId: Scalars['ID'];
};


export type MutationMatchFakturowniaInvoiceArgs = {
  groupId?: InputMaybe<Scalars['ID']>;
  invoiceId: Scalars['ID'];
  studentId: Scalars['ID'];
};


export type MutationMergeCareerSkillsArgs = {
  sourceId: Scalars['ID'];
  targetId: Scalars['ID'];
};


export type MutationMoveStaffTaskArgs = {
  input: MoveStaffTaskInput;
};


export type MutationPasswordResetArgs = {
  newPassword1: Scalars['String'];
  newPassword2: Scalars['String'];
  token: Scalars['String'];
};


export type MutationPasswordSetArgs = {
  newPassword1: Scalars['String'];
  newPassword2: Scalars['String'];
  token: Scalars['String'];
};


export type MutationProcessUploadedStatementArgs = {
  dateFrom?: InputMaybe<Scalars['Date']>;
  dateTo?: InputMaybe<Scalars['Date']>;
  dryRun?: InputMaybe<Scalars['Boolean']>;
};


export type MutationProvisionStudentsArgs = {
  contributionAmount: Scalars['Float'];
  currency: Scalars['String'];
  documents: Array<ProvisionDocOverrideInput>;
  groupId: Scalars['ID'];
};


export type MutationPublishGroupArgs = {
  groupId: Scalars['ID'];
  publishedForTeachers?: InputMaybe<Scalars['Boolean']>;
  publishedLms: Scalars['Boolean'];
  publishedLmsForMethodist?: InputMaybe<Scalars['Boolean']>;
};


export type MutationReactivateCandidateOperatorArgs = {
  candidateId: Scalars['ID'];
  note?: InputMaybe<Scalars['String']>;
  operatorId: Scalars['ID'];
};


export type MutationRecomputeTeacherAiProfileArgs = {
  teacherId: Scalars['ID'];
};


export type MutationReconcileGatewaySettlementsArgs = {
  dryRun?: InputMaybe<Scalars['Boolean']>;
  settlementIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};


export type MutationRecordPlacementArgs = {
  input: PlacementInput;
  memberId: Scalars['ID'];
};


export type MutationRefreshAllZoomDataArgs = {
  dateFrom?: InputMaybe<Scalars['Date']>;
  dateTo?: InputMaybe<Scalars['Date']>;
};


export type MutationRefreshInterviewZoomRecordingsArgs = {
  dateFrom: Scalars['Date'];
  dateTo: Scalars['Date'];
};


export type MutationRefreshTokenArgs = {
  activeRole?: InputMaybe<LmsRoles>;
  refreshToken: Scalars['String'];
  scope?: InputMaybe<Scalars['String']>;
};


export type MutationRegisterShareArgs = {
  channel: Scalars['String'];
};


export type MutationRemindDebtorsArgs = {
  agreementTitles: Array<Scalars['String']>;
};


export type MutationRemoveCareerLessonAttachmentArgs = {
  attachmentId: Scalars['ID'];
};


export type MutationRemoveGatewaySettlementItemArgs = {
  itemId: Scalars['ID'];
};


export type MutationRemoveStaffTaskAttachmentArgs = {
  attachmentId: Scalars['ID'];
};


export type MutationRemoveStaffTaskLinkArgs = {
  linkId: Scalars['ID'];
};


export type MutationRenameWhiteboardArgs = {
  name: Scalars['String'];
  whiteboardId: Scalars['ID'];
};


export type MutationReparsePandadocRecipientsArgs = {
  markRefetch?: InputMaybe<Scalars['Boolean']>;
};


export type MutationReprocessAiArgs = {
  id: Scalars['ID'];
};


export type MutationRequestPnlExportArgs = {
  fileFormat: Scalars['String'];
  groupId?: InputMaybe<Scalars['ID']>;
  language?: InputMaybe<Scalars['String']>;
  monthFrom: Scalars['String'];
  monthTo: Scalars['String'];
};


export type MutationRerunFakturowniaMatcherArgs = {
  invoiceId: Scalars['ID'];
};


export type MutationRerunHomeworkAiReviewArgs = {
  submissionId: Scalars['ID'];
};


export type MutationResetCareerExerciseTemplateArgs = {
  confirm: Scalars['Boolean'];
  templateId: Scalars['ID'];
};


export type MutationResolveCashFlowRuleConflictArgs = {
  categorySlug: Scalars['String'];
  strategy: Scalars['String'];
  transactionId: Scalars['ID'];
};


export type MutationResolveGeoAliasArgs = {
  id: Scalars['ID'];
  ignore?: InputMaybe<Scalars['Boolean']>;
  powiatId?: InputMaybe<Scalars['ID']>;
};


export type MutationRestoreCourseAccessArgs = {
  agreementId: Scalars['ID'];
};


export type MutationRetryFormSubmissionArgs = {
  id: Scalars['ID'];
};


export type MutationRetryLessonRecordingArgs = {
  id: Scalars['ID'];
};


export type MutationRetryTeacherInterviewDownloadArgs = {
  interviewId: Scalars['ID'];
};


export type MutationRevertManualContributionPaymentArgs = {
  contributionId: Scalars['ID'];
};


export type MutationRevertMessagesTriageArgs = {
  handledMessageIds?: InputMaybe<Array<Scalars['ID']>>;
  readMessageIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type MutationReviewOperatorPageArgs = {
  intake?: InputMaybe<FundingIntakeInput>;
  operatorId: Scalars['ID'];
};


export type MutationRevokeMcpConnectionArgs = {
  id: Scalars['ID'];
};


export type MutationRevokePromoCodeArgs = {
  id: Scalars['ID'];
  reason?: InputMaybe<Scalars['String']>;
};


export type MutationRevokeTokenArgs = {
  refreshToken: Scalars['String'];
};


export type MutationRollbackBankStatementImportArgs = {
  dryRun?: InputMaybe<Scalars['Boolean']>;
  importId: Scalars['ID'];
};


export type MutationRunAutoMatchingArgs = {
  date: Scalars['Date'];
};


export type MutationRunCashFlowCategorizationArgs = {
  dateFrom?: InputMaybe<Scalars['Date']>;
  dateTo?: InputMaybe<Scalars['Date']>;
  dryRun?: InputMaybe<Scalars['Boolean']>;
};


export type MutationRunCashFlowMatchingArgs = {
  dateFrom?: InputMaybe<Scalars['Date']>;
  dateTo?: InputMaybe<Scalars['Date']>;
  dryRun?: InputMaybe<Scalars['Boolean']>;
};


export type MutationRunFundingTaskArgs = {
  dryRun?: InputMaybe<Scalars['Boolean']>;
  task: Scalars['String'];
};


export type MutationRunInternalTransferDetectionArgs = {
  dateFrom?: InputMaybe<Scalars['Date']>;
  dateTo?: InputMaybe<Scalars['Date']>;
  dryRun?: InputMaybe<Scalars['Boolean']>;
};


export type MutationRunTeacherDocumentAnalysisArgs = {
  documentId: Scalars['ID'];
};


export type MutationRunTeacherInterviewAnalysisArgs = {
  interviewId: Scalars['ID'];
};


export type MutationSaveAchievementArgs = {
  input: AchievementInput;
};


export type MutationSaveCareerExerciseTemplateArgs = {
  fields: Array<CareerExerciseFieldInput>;
  intro?: InputMaybe<Scalars['String']>;
  outro?: InputMaybe<Scalars['String']>;
  templateId?: InputMaybe<Scalars['ID']>;
  title: Scalars['String'];
};


export type MutationSaveCareerLessonNotesArgs = {
  lessonId: Scalars['ID'];
  notes: Scalars['String'];
};


export type MutationSaveCareerProfileArgs = {
  clearPhoto?: InputMaybe<Scalars['Boolean']>;
  input: CareerProfileInput;
  photo?: InputMaybe<Scalars['Upload']>;
};


export type MutationSaveCvTextArgs = {
  about?: InputMaybe<Scalars['String']>;
  jobTitle?: InputMaybe<Scalars['String']>;
  language: Scalars['String'];
};


export type MutationSaveFundingCandidateArgs = {
  id?: InputMaybe<Scalars['ID']>;
  input: FundingCandidateInput;
};


export type MutationSaveFundingIntakeArgs = {
  announcedAt?: InputMaybe<Scalars['Date']>;
  confirmed?: InputMaybe<Scalars['Boolean']>;
  endsAtTime?: InputMaybe<Scalars['Time']>;
  endsOn?: InputMaybe<Scalars['Date']>;
  id?: InputMaybe<Scalars['ID']>;
  note?: InputMaybe<Scalars['String']>;
  operatorId: Scalars['ID'];
  sourceUrl?: InputMaybe<Scalars['String']>;
  startsAtTime?: InputMaybe<Scalars['Time']>;
  startsOn?: InputMaybe<Scalars['Date']>;
  status?: InputMaybe<Scalars['String']>;
};


export type MutationSaveFundingOperatorArgs = {
  id?: InputMaybe<Scalars['ID']>;
  input: FundingOperatorInput;
};


export type MutationSaveGrowthTrackArgs = {
  input: GrowthTrackInput;
};


export type MutationSaveLmsBlockSettingsArgs = {
  input: LmsBlockSettingsInput;
};


export type MutationSaveSiteCourseArgs = {
  input: SiteCourseInput;
};


export type MutationSaveWhiteboardLibraryArgs = {
  expectedVersion: Scalars['Int'];
  itemsJson: Scalars['String'];
};


export type MutationSaveWhiteboardSceneArgs = {
  expectedVersion: Scalars['Int'];
  sceneJson: Scalars['String'];
  whiteboardId: Scalars['ID'];
};


export type MutationSeedCashFlowRulesArgs = {
  dryRun?: InputMaybe<Scalars['Boolean']>;
};


export type MutationSendGmailReplyArgs = {
  conversationId: Scalars['ID'];
  text: Scalars['String'];
};


export type MutationSendGroupTemplateEmailArgs = {
  groupId: Scalars['ID'];
  recipients: Array<MailRecipientInput>;
  subjectOverride?: InputMaybe<Scalars['String']>;
  templateId: Scalars['String'];
  templateName?: InputMaybe<Scalars['String']>;
};


export type MutationSendLmsAuthEmailArgs = {
  authenticationInput: LmsAuthenticationInput;
};


export type MutationSendLmsBlockTestEmailArgs = {
  kind: Scalars['String'];
  templateId?: InputMaybe<Scalars['String']>;
};


export type MutationSendMorningReportArgs = {
  date?: InputMaybe<Scalars['Date']>;
};


export type MutationSendNewEmailArgs = {
  mailboxEmail: Scalars['String'];
  studentId?: InputMaybe<Scalars['ID']>;
  subject?: InputMaybe<Scalars['String']>;
  teacherId?: InputMaybe<Scalars['ID']>;
  text: Scalars['String'];
  toEmail: Scalars['String'];
};


export type MutationSendPasswordResetEmailArgs = {
  email: Scalars['String'];
};


export type MutationSendSlackChannelMessageArgs = {
  groupId: Scalars['ID'];
  slackChannelId: Scalars['String'];
  text: Scalars['String'];
};


export type MutationSendSlackMessageArgs = {
  conversationId: Scalars['ID'];
  text: Scalars['String'];
};


export type MutationSetAgreementFreeOfChargeArgs = {
  agreementId: Scalars['ID'];
  freeOfCharge: Scalars['Boolean'];
};


export type MutationSetAgreementStatePrefinancedArgs = {
  agreementId: Scalars['ID'];
  statePrefinanced: Scalars['Boolean'];
};


export type MutationSetAgreementTransferOutArgs = {
  agreementId: Scalars['ID'];
  transferOut: Scalars['Boolean'];
};


export type MutationSetBankTransactionCategoryArgs = {
  categorySlug?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  learn?: InputMaybe<Scalars['Boolean']>;
};


export type MutationSetBankTransactionCategoryBulkArgs = {
  categorySlug?: InputMaybe<Scalars['String']>;
  ids: Array<Scalars['ID']>;
  learn?: InputMaybe<Scalars['Boolean']>;
};


export type MutationSetBankTransactionInternalArgs = {
  id: Scalars['ID'];
  isInternal: Scalars['Boolean'];
};


export type MutationSetCandidatePrimaryOperatorArgs = {
  candidateId: Scalars['ID'];
  note?: InputMaybe<Scalars['String']>;
  operatorId?: InputMaybe<Scalars['ID']>;
};


export type MutationSetCareerApplicationStatusArgs = {
  id: Scalars['ID'];
  status: Scalars['String'];
};


export type MutationSetCareerLessonBookmarkArgs = {
  isBookmarked: Scalars['Boolean'];
  lessonId: Scalars['ID'];
};


export type MutationSetCareerLessonQuizArgs = {
  lessonId: Scalars['ID'];
  questions: Array<CareerQuizQuestionInput>;
};


export type MutationSetCareerMembersAccessArgs = {
  memberIds: Array<Scalars['ID']>;
  removed: Scalars['Boolean'];
};


export type MutationSetCareerSkillActiveArgs = {
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
};


export type MutationSetCareerSkillIconArgs = {
  clear?: InputMaybe<Scalars['Boolean']>;
  icon?: InputMaybe<Scalars['Upload']>;
  id: Scalars['ID'];
};


export type MutationSetCashBalanceArgs = {
  amountPln: Scalars['Float'];
  asOfDate: Scalars['Date'];
  comment?: InputMaybe<Scalars['String']>;
  legalEntityId?: InputMaybe<Scalars['ID']>;
};


export type MutationSetConversationStatusArgs = {
  conversationId: Scalars['ID'];
  status: Scalars['String'];
};


export type MutationSetCourseCompletionArgs = {
  courseId: Scalars['ID'];
  note?: InputMaybe<Scalars['String']>;
  status: Scalars['String'];
  studentId: Scalars['ID'];
};


export type MutationSetCourseProgramArgs = {
  courseId: Scalars['ID'];
  modules: Array<ProgramModuleInput>;
};


export type MutationSetCourseSkillsArgs = {
  courseId: Scalars['ID'];
  rows: Array<CourseSkillInput>;
};


export type MutationSetExchangeRateArgs = {
  comment?: InputMaybe<Scalars['String']>;
  currency: Scalars['String'];
  effectiveFrom: Scalars['Date'];
  rateToPln: Scalars['Float'];
};


export type MutationSetExpenseStatusArgs = {
  id: Scalars['ID'];
  paidAt?: InputMaybe<Scalars['Date']>;
  status: Scalars['String'];
};


export type MutationSetFakturowniaInvoiceGroupArgs = {
  groupId?: InputMaybe<Scalars['ID']>;
  invoiceId: Scalars['ID'];
};


export type MutationSetGatewaySettlementFeeArgs = {
  feeAmount: Scalars['Float'];
  settlementId: Scalars['ID'];
};


export type MutationSetGroupLessonLinkArgs = {
  groupId: Scalars['Int'];
  joinUrl: Scalars['String'];
};


export type MutationSetGroupLessonLinkOverrideArgs = {
  date?: InputMaybe<Scalars['Date']>;
  groupId: Scalars['Int'];
  joinUrl: Scalars['String'];
};


export type MutationSetGroupSkillsArgs = {
  groupId: Scalars['ID'];
  rows: Array<GroupSkillInput>;
};


export type MutationSetGroupZoomAccountArgs = {
  groupId: Scalars['ID'];
  zoomAccountId?: InputMaybe<Scalars['ID']>;
};


export type MutationSetGroupZoomScheduleArgs = {
  groupId: Scalars['ID'];
  slots: Array<GroupZoomScheduleSlotInput>;
  zoomAccountId?: InputMaybe<Scalars['ID']>;
};


export type MutationSetMessageHandledArgs = {
  cascade?: InputMaybe<Scalars['Boolean']>;
  handled?: InputMaybe<Scalars['Boolean']>;
  messageId: Scalars['ID'];
};


export type MutationSetMySkillLevelArgs = {
  level: Scalars['Int'];
  skillId: Scalars['ID'];
};


export type MutationSetMySlackUserTokenArgs = {
  groupId: Scalars['ID'];
  userToken: Scalars['String'];
};


export type MutationSetPaymentCalendarSettingsArgs = {
  incomeOffsetDays?: InputMaybe<Scalars['Int']>;
  legalEntityId?: InputMaybe<Scalars['ID']>;
  teacherPayoutDay?: InputMaybe<Scalars['Int']>;
};


export type MutationSetProfileSearchableArgs = {
  contactsVisible?: InputMaybe<Scalars['Boolean']>;
  isSearchable: Scalars['Boolean'];
};


export type MutationSetPromoCampaignActiveArgs = {
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
};


export type MutationSetQuestionMetricsArgs = {
  items: Array<QuestionMetricInput>;
};


export type MutationSetSlackWorkspaceArgs = {
  botToken?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  groupId: Scalars['ID'];
  oauthClientId?: InputMaybe<Scalars['String']>;
  oauthClientSecret?: InputMaybe<Scalars['String']>;
  signingSecret?: InputMaybe<Scalars['String']>;
  teamId?: InputMaybe<Scalars['String']>;
  workspaceName?: InputMaybe<Scalars['String']>;
};


export type MutationSetStudentsMarksArgs = {
  date: Scalars['Date'];
  lessonId: Scalars['Int'];
  studentsMarks: Array<InputMaybe<LessonMarkInput>>;
  taskType: LessonTaskTypeEnum;
};


export type MutationSetSurveyTargetingArgs = {
  plans: Array<SurveyPlanInput>;
  surveyId: Scalars['ID'];
};


export type MutationSetTeacherDocumentTextArgs = {
  documentId: Scalars['ID'];
  text: Scalars['String'];
};


export type MutationSetTeacherInterviewTranscriptArgs = {
  interviewId: Scalars['ID'];
  text: Scalars['String'];
};


export type MutationSetTeacherProfileArgs = {
  coursesCanTeachIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  internalNote?: InputMaybe<Scalars['String']>;
  interviewRecording?: InputMaybe<Scalars['String']>;
  rating?: InputMaybe<Scalars['Int']>;
  teacherId: Scalars['ID'];
};


export type MutationSetVacancyStatusArgs = {
  id: Scalars['ID'];
  status: Scalars['String'];
};


export type MutationStartSlackDmArgs = {
  groupId: Scalars['ID'];
  studentId?: InputMaybe<Scalars['ID']>;
  teacherId?: InputMaybe<Scalars['ID']>;
  text: Scalars['String'];
};


export type MutationStartSlackUserOauthArgs = {
  groupId: Scalars['ID'];
};


export type MutationSubmitCareerLessonExerciseArgs = {
  answers: Array<CareerExerciseAnswerInput>;
  lessonId: Scalars['ID'];
};


export type MutationSubmitCareerQuizArgs = {
  answers: Array<CareerQuizAnswerInput>;
  lessonId: Scalars['ID'];
};


export type MutationSubmitFundingFormArgs = {
  payload: Scalars['JSONString'];
  recaptchaToken?: InputMaybe<Scalars['String']>;
  utm?: InputMaybe<Scalars['JSONString']>;
};


export type MutationSubmitHomeworkArgs = {
  file?: InputMaybe<Scalars['Upload']>;
  githubUrl?: InputMaybe<Scalars['String']>;
  lessonId: Scalars['ID'];
};


export type MutationSubmitSurveyResponseArgs = {
  answers: Array<SurveyAnswerInput>;
  assignmentId: Scalars['ID'];
};


export type MutationSyncAllZoomRecordingsArgs = {
  dateFrom?: InputMaybe<Scalars['Date']>;
  dateTo?: InputMaybe<Scalars['Date']>;
};


export type MutationSyncCommunicationsNowArgs = {
  groupId?: InputMaybe<Scalars['ID']>;
};


export type MutationSyncGroupSendgridListArgs = {
  groupId: Scalars['ID'];
};


export type MutationSyncStudentCourseSkillsArgs = {
  studentId: Scalars['ID'];
};


export type MutationSyncZoomRecordingsArgs = {
  date: Scalars['Date'];
};


export type MutationTerminateAgreementArgs = {
  agreementId: Scalars['ID'];
  comment?: InputMaybe<Scalars['String']>;
  terminatedDate?: InputMaybe<Scalars['Date']>;
  terminatedReason?: InputMaybe<TerminatedReasonEnum>;
};


export type MutationToggleAchievementArgs = {
  achievementId: Scalars['ID'];
  isActive: Scalars['Boolean'];
};


export type MutationToggleCareerExerciseTemplateArgs = {
  isActive: Scalars['Boolean'];
  templateId: Scalars['ID'];
};


export type MutationToggleGrowthTrackArgs = {
  isActive: Scalars['Boolean'];
  trackId: Scalars['ID'];
};


export type MutationToggleSiteCourseArgs = {
  isActive: Scalars['Boolean'];
  siteCourseId: Scalars['ID'];
};


export type MutationTriggerFakturowniaGroupSyncArgs = {
  groupId: Scalars['ID'];
  period?: InputMaybe<Scalars['String']>;
};


export type MutationTriggerFakturowniaSyncArgs = {
  dateFrom?: InputMaybe<Scalars['String']>;
  dateTo?: InputMaybe<Scalars['String']>;
  period?: InputMaybe<Scalars['String']>;
};


export type MutationTriggerZoomGroupProcessArgs = {
  dateFrom?: InputMaybe<Scalars['Date']>;
  dateTo?: InputMaybe<Scalars['Date']>;
  groupId: Scalars['ID'];
};


export type MutationUnblockStudentLmsAccessArgs = {
  notifyStudent?: InputMaybe<Scalars['Boolean']>;
  reason?: InputMaybe<Scalars['String']>;
  studentId: Scalars['ID'];
};


export type MutationUnlinkBankTransactionArgs = {
  linkId: Scalars['ID'];
};


export type MutationUnlinkCandidateFromUserArgs = {
  candidateId: Scalars['ID'];
};


export type MutationUnlinkContributionArgs = {
  contributionId: Scalars['ID'];
};


export type MutationUnlinkFakturowniaInvoiceArgs = {
  invoiceId: Scalars['ID'];
};


export type MutationUnlinkInvoiceFromContributionArgs = {
  invoiceId: Scalars['ID'];
};


export type MutationUnlinkLessonRecordingArgs = {
  id: Scalars['ID'];
};


export type MutationUnlinkLessonWhiteboardArgs = {
  lessonId: Scalars['ID'];
};


export type MutationUnlinkPandadocDocumentArgs = {
  pandadocId: Scalars['String'];
};


export type MutationUnlinkPandadocTeacherArgs = {
  pandadocId: Scalars['String'];
};


export type MutationUpdateAttendanceArgs = {
  attendance: Scalars['Boolean'];
  attendanceId: Scalars['Int'];
};


export type MutationUpdateCareerApplicationArgs = {
  id: Scalars['ID'];
  input: CareerApplicationInput;
};


export type MutationUpdateCareerMemberArgs = {
  id: Scalars['ID'];
  input: CareerMemberInput;
};


export type MutationUpdateCashFlowRuleArgs = {
  categorySlug?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  isActive?: InputMaybe<Scalars['Boolean']>;
  priority?: InputMaybe<Scalars['Int']>;
  resetHealth?: InputMaybe<Scalars['Boolean']>;
};


export type MutationUpdateCashFlowSettingsArgs = {
  internalTransferAutodetect?: InputMaybe<Scalars['Boolean']>;
  internalTransferWindowDays?: InputMaybe<Scalars['Int']>;
  ownPartyNames?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateCompanyArgs = {
  companyId: Scalars['ID'];
  companyInput: UpdateCompanyInput;
};


export type MutationUpdateCourseArgs = {
  courseId?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateExpenseArgs = {
  input: UpdateExpenseInput;
};


export type MutationUpdateGroupArgs = {
  groupId: Scalars['Int'];
  groupInput: UpdateGroupInput;
};


export type MutationUpdateJournalArgs = {
  comment: Scalars['String'];
  daysOfClass: Array<DayOfClassInput>;
  groupId: Scalars['Int'];
  modules: Array<InputMaybe<UpdateModuleInput>>;
};


export type MutationUpdateMaterialArgs = {
  id: Scalars['ID'];
  input: UpdateMaterialInput;
};


export type MutationUpdatePaymentArgs = {
  input: UpdatePaymentInput;
};


export type MutationUpdatePaymentCorrectionArgs = {
  input: UpdatePaymentCorrectionInput;
};


export type MutationUpdatePlannedPaymentArgs = {
  input: UpdatePlannedPaymentInput;
};


export type MutationUpdateStaffNotificationSettingsArgs = {
  input: StaffNotificationSettingsInput;
};


export type MutationUpdateStaffTaskArgs = {
  input: UpdateStaffTaskInput;
};


export type MutationUpdateStudentNoteArgs = {
  input: UpdateStudentNoteInput;
};


export type MutationUpdateStudentWithAgreementArgs = {
  agreementId?: InputMaybe<Scalars['ID']>;
  updateStudentInput: UpdateStudentInput;
};


export type MutationUpdateSurveyArgs = {
  id: Scalars['ID'];
  input: SurveyInput;
};


export type MutationUpdateSurveyAssignmentArgs = {
  id: Scalars['ID'];
  isActive?: InputMaybe<Scalars['Boolean']>;
  triggerLessonId?: InputMaybe<Scalars['ID']>;
};


export type MutationUpdateTaskStatusArgs = {
  id: Scalars['ID'];
  status: Scalars['String'];
};


export type MutationUpdateTeacherApplicationArgs = {
  application: UpdateApplicationInputType;
};


export type MutationUpdateTeacherWithTypeArgs = {
  employmentInput: ExistEmploymentInputType;
  teacherId?: InputMaybe<Scalars['ID']>;
  teacherInput: TeacherWithTypeInput;
};


export type MutationUpdateUserSettingsArgs = {
  userId?: InputMaybe<Scalars['ID']>;
  userSettingsInput: CustomUserInput;
};


export type MutationUploadBankStatementArgs = {
  accountSlug?: InputMaybe<Scalars['String']>;
  dryRun?: InputMaybe<Scalars['Boolean']>;
  file: Scalars['Upload'];
  process?: InputMaybe<Scalars['Boolean']>;
  sheetName?: InputMaybe<Scalars['String']>;
};


export type MutationUploadCareerLessonVideoArgs = {
  lessonId: Scalars['ID'];
  video: Scalars['Upload'];
};


export type MutationUploadLessonVideoArgs = {
  lessonId: Scalars['Int'];
  videoUrl: Scalars['String'];
};


export type MutationUploadStudentDiplomaArgs = {
  file: Scalars['Upload'];
  groupId: Scalars['ID'];
  language: DiplomaLanguageEnum;
  replaceExisting?: InputMaybe<Scalars['Boolean']>;
  studentId: Scalars['ID'];
};


export type MutationUploadTeacherDocumentArgs = {
  file: Scalars['Upload'];
  kind?: InputMaybe<Scalars['String']>;
  teacherId: Scalars['ID'];
};


export type MutationUploadTeacherInterviewVideoArgs = {
  file: Scalars['Upload'];
  recordedAt?: InputMaybe<Scalars['DateTime']>;
  teacherId: Scalars['ID'];
  title?: InputMaybe<Scalars['String']>;
};


export type MutationUploadWhiteboardFileArgs = {
  file: Scalars['Upload'];
  fileId: Scalars['String'];
  mimeType?: InputMaybe<Scalars['String']>;
  whiteboardId: Scalars['ID'];
};


export type MutationUpsertCareerLessonArgs = {
  id?: InputMaybe<Scalars['ID']>;
  input: CareerLessonInput;
};


export type MutationUpsertCareerSkillArgs = {
  input: CareerSkillInput;
};


export type MutationUpsertHomeworkAssignmentArgs = {
  dueDate?: InputMaybe<Scalars['Date']>;
  lessonId: Scalars['ID'];
  text?: InputMaybe<Scalars['String']>;
  textbookRef?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};


export type MutationUpsertPromoCampaignArgs = {
  input: PromoCampaignInput;
};


export type MutationUpsertShareTemplateArgs = {
  input: ShareTemplateInput;
};


export type MutationUpsertVacancyArgs = {
  id?: InputMaybe<Scalars['ID']>;
  input: VacancyInput;
};


export type MutationVerifyTokenArgs = {
  token: Scalars['String'];
};


export type MutationZeroOutContributionArgs = {
  contributionId: Scalars['ID'];
};

/**
 * LMS student-self view. Reachable ONLY from `myDiplomas`.
 *
 * Carries `group_name`/`course_name` because a student who studied in two
 * groups would otherwise see two indistinguishable «Diploma (PL)» rows.
 */
export type MyDiplomaType = {
  __typename?: 'MyDiplomaType';
  courseName?: Maybe<Scalars['String']>;
  groupName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  issuedAt?: Maybe<Scalars['DateTime']>;
  language: DiplomaLanguageEnum;
  originalName?: Maybe<Scalars['String']>;
  sizeBytes?: Maybe<Scalars['Int']>;
};

/** Parent is {'submission': HomeworkSubmission, 'hw_mark': str|None}. */
export type MyHomeworkSubmissionType = {
  __typename?: 'MyHomeworkSubmissionType';
  attempt: Scalars['Int'];
  fileName?: Maybe<Scalars['String']>;
  githubUrl?: Maybe<Scalars['String']>;
  hwMark?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  status: Scalars['String'];
  submittedAt: Scalars['DateTime'];
  teacherComment?: Maybe<Scalars['String']>;
};

/**
 * One row of the signed-in student's OWN attendance record (spec 0013
 * follow-up). Parent is a `journals.StudentAttendance`.
 *
 * Deliberately a hand-built ObjectType rather than a DjangoObjectType on
 * StudentAttendance: that model hangs off Student/GroupLesson, and exposing
 * it as a Django type would let the LMS schema walk back to other students'
 * rows. Everything here is the requester's own by construction.
 */
export type MyLessonAttendanceType = {
  __typename?: 'MyLessonAttendanceType';
  attendance?: Maybe<Scalars['Boolean']>;
  date?: Maybe<Scalars['Date']>;
  lessonId: Scalars['ID'];
  lessonName: Scalars['String'];
  lessonNumber: Scalars['Int'];
  markedAt?: Maybe<Scalars['DateTime']>;
  source?: Maybe<Scalars['String']>;
};

/** Навык студента с пометкой, кто его подтвердил. */
export type MySkillType = {
  __typename?: 'MySkillType';
  demand?: Maybe<SkillDemandType>;
  grantedCourseName?: Maybe<Scalars['String']>;
  grantedLessonNumber?: Maybe<Scalars['Int']>;
  isHidden: Scalars['Boolean'];
  level: Scalars['Int'];
  providers: Array<SkillProviderType>;
  skill: SkillType;
  source: Scalars['String'];
};

/**
 * A teacher's own aggregate view (LMS scope, behind
 * SURVEY_TEACHER_SELF_VIEW_ENABLED).
 *
 * There is deliberately NO comments field: surveys are именные, and a field
 * that sometimes returns comment text is a field someone eventually fills.
 * No per-group split either — a group is too small to be anonymous.
 */
export type MyTeachingFeedbackType = {
  __typename?: 'MyTeachingFeedbackType';
  /** Null until at least SURVEY_TEACHER_SELF_VIEW_MIN_RATINGS ratings exist (k-anonymity). `ratingsCount` is reported honestly so the teacher can see why. */
  average?: Maybe<Scalars['Float']>;
  byCourse: Array<TeacherRatingBucketType>;
  ratingsCount: Scalars['Int'];
};

export type NativeInfoConnection = {
  __typename?: 'NativeInfoConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<NativeInfoEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `NativeInfo` and its cursor. */
export type NativeInfoEdge = {
  __typename?: 'NativeInfoEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<NativeInfoType>;
};

export type NativeInfoType = {
  __typename?: 'NativeInfoType';
  articlesSet: Array<ArticlesType>;
  date: Scalars['Date'];
  description: Scalars['String'];
  id: Scalars['ID'];
  image: Scalars['String'];
  interviewLink: Scalars['String'];
  interviewText: Scalars['String'];
  nativeBanner?: Maybe<CourseBanner>;
  published: Scalars['Boolean'];
  seoDescription: Scalars['String'];
  seoImage: Scalars['String'];
  seoKeywords: Scalars['String'];
  seoSlug?: Maybe<Scalars['String']>;
  seoTitle: Scalars['String'];
  successstoriesSet: Array<SuccessStoriesType>;
  title: Scalars['String'];
};

export type NaturalPersonInput = {
  accountNumber: Scalars['String'];
  bankTitle: Scalars['String'];
  bic: Scalars['String'];
  nationality: Scalars['ID'];
  passportNumber: Scalars['String'];
  registrationAddress: Scalars['String'];
};

export type NaturalPersonType = Node & {
  __typename?: 'NaturalPersonType';
  accountNumber: Scalars['String'];
  bankTitle: Scalars['String'];
  bic: Scalars['String'];
  id: Scalars['ID'];
  nationality: CountryType;
  passportNumber: Scalars['String'];
  registrationAddress: Scalars['String'];
};

export type NewTeacherInput = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  middleName?: InputMaybe<Scalars['String']>;
  phone: Scalars['String'];
  siteDisplay?: InputMaybe<Scalars['Boolean']>;
};

export type NewYearLeadInput = {
  age: Scalars['String'];
  city: Scalars['String'];
  country: Scalars['String'];
  course_id?: InputMaybe<Scalars['Int']>;
  email: Scalars['String'];
  formName: Scalars['String'];
  message: Scalars['String'];
  name: Scalars['String'];
  phone: Scalars['String'];
  promocode?: InputMaybe<Scalars['String']>;
  referer?: InputMaybe<Scalars['String']>;
  roistatId: Scalars['String'];
  tittle: Scalars['String'];
  utmCampaign?: InputMaybe<Scalars['String']>;
  utmContent?: InputMaybe<Scalars['String']>;
  utmMedium?: InputMaybe<Scalars['String']>;
  utmSource?: InputMaybe<Scalars['String']>;
  utmTerm?: InputMaybe<Scalars['String']>;
};

/**
 * Следующий курс для выпускника (ТЗ 0039, доводка).
 *
 * Перепродажа между главными курсами школы: считается из нехватки по треку,
 * а не из отдельного списка «кто кому продаёт» — такой список разъехался бы
 * с программами курсов в первый же месяц.
 */
export type NextCourseType = {
  __typename?: 'NextCourseType';
  adds: Array<Scalars['String']>;
  courseId: Scalars['ID'];
  courseName: Scalars['String'];
  courseUrl: Scalars['String'];
  covered: Scalars['Int'];
  totalMissing: Scalars['Int'];
};

/** An object with an ID */
export type Node = {
  /** The ID of the object */
  id: Scalars['ID'];
};

/**
 * Разница между тем, что на странице сейчас, и тем, что видел человек.
 *
 * Списки обрезаны, числа — нет: у оператора с месячным архивом в подписи
 * сотня строк, и вываливать её в карточку бессмысленно, а «появилось 174»
 * говорит о масштабе честнее любого списка.
 */
export type PageDiffType = {
  __typename?: 'PageDiffType';
  added: Array<Scalars['String']>;
  addedTotal: Scalars['Int'];
  /** Есть ли с чем сравнивать. `false` — изменение заметили до того, как робот начал сохранять подпись. */
  comparable: Scalars['Boolean'];
  removed: Array<Scalars['String']>;
  removedTotal: Scalars['Int'];
};

/** The Relay compliant `PageInfo` type, containing data necessary to paginate this connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

/** Everything the standalone dashboard renders, computed server-side. */
export type PandaDocAnalyticsType = {
  __typename?: 'PandaDocAnalyticsType';
  conversionByCourse?: Maybe<Array<Maybe<PandaDocCourseConversion>>>;
  conversionKpi?: Maybe<PandaDocConversionKpi>;
  conversionSeries?: Maybe<PandaDocConversionSeriesGroup>;
  course?: Maybe<Scalars['String']>;
  granularity?: Maybe<Scalars['String']>;
  ttsByCourse?: Maybe<Array<Maybe<PandaDocCourseTts>>>;
  ttsHistogram?: Maybe<PandaDocHistogram>;
  ttsKpi?: Maybe<PandaDocTtsKpi>;
  ttsMedianSeries?: Maybe<PandaDocTtsMedianSeries>;
  volumeKpi?: Maybe<PandaDocVolumeKpi>;
  volumeSeries?: Maybe<PandaDocVolumeSeries>;
  window?: Maybe<PandaDocWindow>;
};

export type PandaDocConversionKpi = {
  __typename?: 'PandaDocConversionKpi';
  active?: Maybe<Scalars['Int']>;
  activePct?: Maybe<Scalars['Int']>;
  lost?: Maybe<Scalars['Int']>;
  lostPct?: Maybe<Scalars['Int']>;
  ratePct?: Maybe<Scalars['Int']>;
  sent?: Maybe<Scalars['Int']>;
  signed?: Maybe<Scalars['Int']>;
  signedPct?: Maybe<Scalars['Int']>;
};

/** Sent→signed conversion stacked per bucket. */
export type PandaDocConversionSeries = {
  __typename?: 'PandaDocConversionSeries';
  active?: Maybe<Array<Maybe<Scalars['Int']>>>;
  labels?: Maybe<Array<Maybe<Scalars['String']>>>;
  lost?: Maybe<Array<Maybe<Scalars['Int']>>>;
  signed?: Maybe<Array<Maybe<Scalars['Int']>>>;
};

export type PandaDocConversionSeriesGroup = {
  __typename?: 'PandaDocConversionSeriesGroup';
  dofin?: Maybe<PandaDocConversionSeries>;
  students?: Maybe<PandaDocConversionSeries>;
};

/** Volume series: a count per timeline bucket. */
export type PandaDocCountSeries = {
  __typename?: 'PandaDocCountSeries';
  labels?: Maybe<Array<Maybe<Scalars['String']>>>;
  values?: Maybe<Array<Maybe<Scalars['Int']>>>;
};

export type PandaDocCourseConversion = {
  __typename?: 'PandaDocCourseConversion';
  active?: Maybe<Scalars['Int']>;
  course?: Maybe<Scalars['String']>;
  lost?: Maybe<Scalars['Int']>;
  signed?: Maybe<Scalars['Int']>;
};

export type PandaDocCourseTts = {
  __typename?: 'PandaDocCourseTTS';
  avgDays?: Maybe<Scalars['Float']>;
  course?: Maybe<Scalars['String']>;
  sample?: Maybe<Scalars['Int']>;
};

export type PandaDocDocumentConnection = {
  __typename?: 'PandaDocDocumentConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<PandaDocDocumentEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An enumeration. */
export enum PandaDocDocumentDocType {
  /** Co-financing */
  Dofin = 'DOFIN',
  /** Other */
  Other = 'OTHER',
  /** Student agreement */
  Student = 'STUDENT',
  /** Trainer agreement */
  Trainer = 'TRAINER'
}

/** A Relay edge containing a `PandaDocDocument` and its cursor. */
export type PandaDocDocumentEdge = {
  __typename?: 'PandaDocDocumentEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<PandaDocDocumentType>;
};

/** An enumeration. */
export enum PandaDocDocumentOutcome {
  /** In progress */
  Active = 'ACTIVE',
  /** Not signed */
  Lost = 'LOST',
  /** Signed */
  Signed = 'SIGNED'
}

export type PandaDocDocumentType = Node & {
  __typename?: 'PandaDocDocumentType';
  /** LMS Agreement (договор) that was created from this signed document. Null until the document is provisioned via the `provisionStudents` mutation. */
  agreement?: Maybe<AgreementType>;
  contractUrl: Scalars['String'];
  course: Scalars['String'];
  dateCompleted?: Maybe<Scalars['DateTime']>;
  dateCreated?: Maybe<Scalars['DateTime']>;
  dateModified?: Maybe<Scalars['DateTime']>;
  dateSent?: Maybe<Scalars['DateTime']>;
  detailsFetched: Scalars['Boolean'];
  docType: PandaDocDocumentDocType;
  folderName: Scalars['String'];
  /** The ID of the object */
  id: Scalars['ID'];
  /** provisioned | linked | candidate — link state of the document relative to an LMS agreement (student) or a Teacher. */
  matchType?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  outcome: PandaDocDocumentOutcome;
  pandadocId: Scalars['String'];
  pk?: Maybe<Scalars['Int']>;
  /** Timestamp the document was turned into a Student + Agreement. Null while the document is still pending or has been signed but not yet provisioned. */
  provisionedAt?: Maybe<Scalars['DateTime']>;
  recipientEmail: Scalars['String'];
  recipientPhone: Scalars['String'];
  status: Scalars['String'];
  syncedAt: Scalars['DateTime'];
  /** Teacher this trainer document is linked to (teacher card). Null for student / unlinked documents. */
  teacher?: Maybe<TeacherType>;
  ttsHours?: Maybe<Scalars['Float']>;
  unavailable: Scalars['Boolean'];
};

export type PandaDocHistogram = {
  __typename?: 'PandaDocHistogram';
  labels?: Maybe<Array<Maybe<Scalars['String']>>>;
  values?: Maybe<Array<Maybe<Scalars['Int']>>>;
};

/** Sync-health snapshot, sourced from `PandaDocSyncState` (req 3). */
export type PandaDocSyncStatusType = {
  __typename?: 'PandaDocSyncStatusType';
  detailsPending?: Maybe<Scalars['Int']>;
  documentsCount?: Maybe<Scalars['Int']>;
  lastDetailsSyncAt?: Maybe<Scalars['DateTime']>;
  lastDocumentsPulled?: Maybe<Scalars['Int']>;
  lastError?: Maybe<Scalars['String']>;
  lastListSyncAt?: Maybe<Scalars['DateTime']>;
  lastRunStatus?: Maybe<Scalars['String']>;
  newestDocDate?: Maybe<Scalars['DateTime']>;
  syncRunning?: Maybe<Scalars['Boolean']>;
};

export type PandaDocTtsKpi = {
  __typename?: 'PandaDocTTSKpi';
  meanHours?: Maybe<Scalars['Float']>;
  medianHours?: Maybe<Scalars['Float']>;
  pct3d?: Maybe<Scalars['Int']>;
  pct24h?: Maybe<Scalars['Int']>;
  sample?: Maybe<Scalars['Int']>;
};

export type PandaDocTtsMedianSeries = {
  __typename?: 'PandaDocTTSMedianSeries';
  dofin?: Maybe<PandaDocTtsSeries>;
  students?: Maybe<PandaDocTtsSeries>;
  trainers?: Maybe<PandaDocTtsSeries>;
};

/** Median time-to-sign (days) per bucket; null where the bucket is empty. */
export type PandaDocTtsSeries = {
  __typename?: 'PandaDocTTSSeries';
  labels?: Maybe<Array<Maybe<Scalars['String']>>>;
  values?: Maybe<Array<Maybe<Scalars['Float']>>>;
};

export type PandaDocVolumeKpi = {
  __typename?: 'PandaDocVolumeKpi';
  dofin?: Maybe<Scalars['Int']>;
  last30?: Maybe<Scalars['Int']>;
  students?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['Int']>;
  trainers?: Maybe<Scalars['Int']>;
};

export type PandaDocVolumeSeries = {
  __typename?: 'PandaDocVolumeSeries';
  dofin?: Maybe<PandaDocCountSeries>;
  students?: Maybe<PandaDocCountSeries>;
  trainers?: Maybe<PandaDocCountSeries>;
};

export type PandaDocWindow = {
  __typename?: 'PandaDocWindow';
  docsLoaded?: Maybe<Scalars['Int']>;
  maxDate?: Maybe<Scalars['Date']>;
  minDate?: Maybe<Scalars['Date']>;
  signedCount?: Maybe<Scalars['Int']>;
  totalInDb?: Maybe<Scalars['Int']>;
};

/** Сброс пароля по токену из письма. SDL: {success, errors}. */
export type PasswordReset = {
  __typename?: 'PasswordReset';
  errors?: Maybe<Scalars['ExpectedErrorType']>;
  success?: Maybe<Scalars['Boolean']>;
};

/** Установка первого пароля по токену из письма. SDL: {success, errors}. */
export type PasswordSet = {
  __typename?: 'PasswordSet';
  errors?: Maybe<Scalars['ExpectedErrorType']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type PaymentCalendarDayType = {
  __typename?: 'PaymentCalendarDayType';
  date?: Maybe<Scalars['Date']>;
  endBalancePln?: Maybe<Scalars['Float']>;
  expenseRows?: Maybe<Array<Maybe<PaymentCalendarRowType>>>;
  expenseTotalPln?: Maybe<Scalars['Float']>;
  hasRateMissing?: Maybe<Scalars['Boolean']>;
  incomeRows?: Maybe<Array<Maybe<PaymentCalendarRowType>>>;
  incomeTotalPln?: Maybe<Scalars['Float']>;
  openingBalancePln?: Maybe<Scalars['Float']>;
  receivedRows?: Maybe<Array<Maybe<PaymentCalendarRowType>>>;
  receivedTotalPln?: Maybe<Scalars['Float']>;
  tone?: Maybe<Scalars['String']>;
};

export type PaymentCalendarRowType = {
  __typename?: 'PaymentCalendarRowType';
  amount?: Maybe<Scalars['Float']>;
  amountPln?: Maybe<Scalars['Float']>;
  balanceAfterPln?: Maybe<Scalars['Float']>;
  comment?: Maybe<Scalars['String']>;
  contributionId?: Maybe<Scalars['Int']>;
  counterpartyName?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['Date']>;
  direction?: Maybe<Scalars['String']>;
  editable?: Maybe<Scalars['Boolean']>;
  expenseId?: Maybe<Scalars['Int']>;
  incomeState?: Maybe<Scalars['String']>;
  /** Fakturownia UI view_url from the mirrored payload; empty when the document has none. */
  invoiceExternalUrl?: Maybe<Scalars['String']>;
  /** Internal FakturowniaInvoice pk — ERP invoice detail page. */
  invoiceId?: Maybe<Scalars['Int']>;
  invoiceNumber?: Maybe<Scalars['String']>;
  kind?: Maybe<Scalars['String']>;
  plannedPaymentId?: Maybe<Scalars['Int']>;
  rateMissing?: Maybe<Scalars['Boolean']>;
  relatedGroupId?: Maybe<Scalars['Int']>;
  relatedTeacherId?: Maybe<Scalars['Int']>;
  source?: Maybe<Scalars['String']>;
  sourceRef?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  toneAfter?: Maybe<Scalars['String']>;
};

export type PaymentCalendarSettingsType = {
  __typename?: 'PaymentCalendarSettingsType';
  id: Scalars['ID'];
  /** Money is expected this many days after invoice/installment date. */
  incomeOffsetDays: Scalars['Int'];
  legalEntityId?: Maybe<Scalars['Int']>;
  /** Day of month M+1 on which month M's lessons are paid. */
  teacherPayoutDay: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};

export type PaymentCalendarType = {
  __typename?: 'PaymentCalendarType';
  dateFrom?: Maybe<Scalars['Date']>;
  dateTo?: Maybe<Scalars['Date']>;
  days?: Maybe<Array<Maybe<PaymentCalendarDayType>>>;
  hasRateMissing?: Maybe<Scalars['Boolean']>;
  hasShortfall?: Maybe<Scalars['Boolean']>;
  minBalancePln?: Maybe<Scalars['Float']>;
  openingBalancePln?: Maybe<Scalars['Float']>;
  totalAwaitedPln?: Maybe<Scalars['Float']>;
  totalExpensePln?: Maybe<Scalars['Float']>;
  totalIncomePln?: Maybe<Scalars['Float']>;
  totalOverduePln?: Maybe<Scalars['Float']>;
  totalReceivedPln?: Maybe<Scalars['Float']>;
  totalToPayPln?: Maybe<Scalars['Float']>;
};

/** An enumeration. */
export enum PaymentCorrectionCurrency {
  /** BYN */
  Byn = 'BYN',
  /** EUR */
  Eur = 'EUR',
  /** PLN */
  Pln = 'PLN',
  /** RUB */
  Rub = 'RUB',
  /** USD */
  Usd = 'USD'
}

/**
 * A correction line (корректировка) — amount is the positive magnitude;
 * `payment` is the target payment (null → whole-agreement / plan correction).
 */
export type PaymentCorrectionType = {
  __typename?: 'PaymentCorrectionType';
  agreement: AgreementType;
  amountByn?: Maybe<Scalars['CustomFloat']>;
  amountForeign?: Maybe<Scalars['CustomFloat']>;
  /** Указан — возврат денег по этому взносу (отток), уменьшает покрытие. Пусто — списание плана по договору. */
  contribution?: Maybe<ContributionType>;
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<CustomUserType>;
  currency: PaymentCorrectionCurrency;
  date: Scalars['Date'];
  id: Scalars['ID'];
  /** True — возврат (уменьшает полученное). False — списание плана по договору (уменьшает бюджет). */
  isRefund: Scalars['Boolean'];
  /** Целевой платёж (разворот полученного); null — ко всему договору/плану. */
  payment?: Maybe<PaymentType>;
  reason?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

/** An enumeration. */
export enum PaymentCurrency {
  /** BYN */
  Byn = 'BYN',
  /** EUR */
  Eur = 'EUR',
  /** PLN */
  Pln = 'PLN',
  /** RUB */
  Rub = 'RUB',
  /** USD */
  Usd = 'USD'
}

export type PaymentInput = {
  agreement_id: Scalars['ID'];
  currency: Scalars['String'];
  date: Scalars['Date'];
  deferredPaymentId?: InputMaybe<Scalars['ID']>;
  sum: Scalars['Float'];
};

export type PaymentLogoType = {
  __typename?: 'PaymentLogoType';
  contactsPage: ContactsPageType;
  id: Scalars['ID'];
  logo: Scalars['String'];
};

export type PaymentRulesPageType = {
  __typename?: 'PaymentRulesPageType';
  id: Scalars['ID'];
  rules: Scalars['String'];
  seoDescription: Scalars['String'];
  seoImage: Scalars['String'];
  seoKeywords: Scalars['String'];
  seoTitle: Scalars['String'];
  title: Scalars['String'];
};

/** An enumeration. */
export enum PaymentSource {
  /** Авто из оплаченной фактуры */
  InvoiceAuto = 'INVOICE_AUTO',
  /** Ручная отметка «оплачен» */
  ManualPaid = 'MANUAL_PAID',
  /** Создан оператором (legacy) */
  Operator = 'OPERATOR'
}

export type PaymentType = {
  __typename?: 'PaymentType';
  agreement: AgreementType;
  amountAgreement: Scalars['Float'];
  amountByn?: Maybe<Scalars['CustomFloat']>;
  amountForeign?: Maybe<Scalars['CustomFloat']>;
  /** Scheduled contribution this payment satisfies. Null for orphan payments (returns, advances, top-ups, payments on agreements without a schedule). */
  contribution?: Maybe<ContributionType>;
  /** DEPRECATED (ТЗ 0029): раньше корректировка возврата цеплялась за скрытый платёж. Теперь — за взнос (`contribution`). Поле живёт до сноса таблицы платежей. */
  corrections: Array<PaymentCorrectionType>;
  currency: PaymentCurrency;
  date: Scalars['Date'];
  /** Linked Fakturownia invoice (1:1), if any. */
  fakturowniaInvoice?: Maybe<FakturowniaInvoiceType>;
  id: Scalars['ID'];
  source: PaymentSource;
};

export type PaymentsVerificationType = {
  __typename?: 'PaymentsVerificationType';
  agreementTitle?: Maybe<Scalars['String']>;
  agreement_id?: Maybe<Scalars['ID']>;
  currency?: Maybe<Scalars['String']>;
  fullname?: Maybe<Scalars['String']>;
  studentId?: Maybe<Scalars['ID']>;
};

/**
 * Parent is a SurveyAssignment from the pending service (survey +
 * group + trigger lesson select_related, questions prefetched) — the full
 * payload the fill page needs, no second query.
 */
export type PendingSurveyType = {
  __typename?: 'PendingSurveyType';
  assignmentId: Scalars['ID'];
  description: Scalars['String'];
  groupName: Scalars['String'];
  lessonName: Scalars['String'];
  lessonNumber: Scalars['Int'];
  questions: Array<SurveyQuestionForStudentType>;
  /** Who the teacher_rating / teacher_comment questions are about — the trigger lesson's teacher. Null when the lesson has none; the client then omits the attribution line rather than asking to rate an unnamed person. */
  teacherName?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type Person = {
  __typename?: 'Person';
  firstName?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  middleName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
};

export type PlacementInput = {
  applicationId?: InputMaybe<Scalars['ID']>;
  companyName: Scalars['String'];
  note?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['String']>;
  salary?: InputMaybe<Scalars['Int']>;
  salaryCurrency?: InputMaybe<Scalars['String']>;
  startedAt?: InputMaybe<Scalars['Date']>;
  vacancyId?: InputMaybe<Scalars['ID']>;
};

export type PlacementRecordType = {
  __typename?: 'PlacementRecordType';
  companyName: Scalars['String'];
  confirmedAt: Scalars['DateTime'];
  id: Scalars['ID'];
  memberId: Scalars['ID'];
  position: Scalars['String'];
  startedAt?: Maybe<Scalars['Date']>;
  studentName: Scalars['String'];
};

/** An enumeration. */
export enum PlannedPaymentCurrency {
  /** BYN */
  Byn = 'BYN',
  /** EUR */
  Eur = 'EUR',
  /** PLN */
  Pln = 'PLN',
  /** RUB */
  Rub = 'RUB',
  /** USD */
  Usd = 'USD'
}

/** An enumeration. */
export enum PlannedPaymentDirection {
  /** Expense */
  Expense = 'EXPENSE',
  /** Income */
  Income = 'INCOME'
}

export type PlannedPaymentInput = {
  amount: Scalars['Float'];
  categorySlug?: InputMaybe<Scalars['String']>;
  comment?: InputMaybe<Scalars['String']>;
  currency?: InputMaybe<Scalars['String']>;
  date: Scalars['Date'];
  direction: Scalars['String'];
  kind?: InputMaybe<Scalars['String']>;
  legalEntityId?: InputMaybe<Scalars['ID']>;
  periodDate?: InputMaybe<Scalars['Date']>;
  periodMonth?: InputMaybe<Scalars['Int']>;
  periodYear?: InputMaybe<Scalars['Int']>;
  recurrence?: InputMaybe<Scalars['String']>;
  recurrenceDay?: InputMaybe<Scalars['Int']>;
  recurrenceUntil?: InputMaybe<Scalars['Date']>;
  relatedApplicationId?: InputMaybe<Scalars['ID']>;
  relatedContributionId?: InputMaybe<Scalars['ID']>;
  relatedExpenseId?: InputMaybe<Scalars['ID']>;
  relatedFakturowniaInvoiceId?: InputMaybe<Scalars['ID']>;
  relatedGroupId?: InputMaybe<Scalars['ID']>;
  relatedTeacherId?: InputMaybe<Scalars['ID']>;
  status?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

/** An enumeration. */
export enum PlannedPaymentKind {
  /** Expense occurrence override */
  ExpenseOccurrenceOverride = 'EXPENSE_OCCURRENCE_OVERRIDE',
  /** Income override */
  IncomeOverride = 'INCOME_OVERRIDE',
  /** Manual one-off */
  Manual = 'MANUAL',
  /** Recurring template */
  Recurring = 'RECURRING',
  /** Teacher payout override */
  TeacherPayoutOverride = 'TEACHER_PAYOUT_OVERRIDE'
}

export type PlannedPaymentMutationOutput = {
  __typename?: 'PlannedPaymentMutationOutput';
  errors?: Maybe<Array<Maybe<Scalars['String']>>>;
  plannedPayment?: Maybe<PlannedPaymentType>;
  success?: Maybe<Scalars['Boolean']>;
};

/** An enumeration. */
export enum PlannedPaymentRecurrence {
  /** Monthly */
  Monthly = 'MONTHLY',
  /** Brak */
  None = 'NONE'
}

/** An enumeration. */
export enum PlannedPaymentStatus {
  /** Cancelled */
  Cancelled = 'CANCELLED',
  /** Confirmed */
  Confirmed = 'CONFIRMED',
  /** Paid */
  Paid = 'PAID',
  /** Planned */
  Planned = 'PLANNED'
}

export type PlannedPaymentType = {
  __typename?: 'PlannedPaymentType';
  amount?: Maybe<Scalars['Float']>;
  amountPln?: Maybe<Scalars['Float']>;
  categorySlug?: Maybe<Scalars['String']>;
  comment: Scalars['String'];
  createdAt: Scalars['DateTime'];
  currency: PlannedPaymentCurrency;
  /** Predicted payment date (user-editable). For recurring templates this is the first occurrence. */
  date: Scalars['Date'];
  direction: PlannedPaymentDirection;
  id: Scalars['ID'];
  kind: PlannedPaymentKind;
  legalEntityId?: Maybe<Scalars['Int']>;
  periodMonth?: Maybe<Scalars['Int']>;
  periodYear?: Maybe<Scalars['Int']>;
  pk?: Maybe<Scalars['Int']>;
  recurrence: PlannedPaymentRecurrence;
  /** 1–31; clamped to the last day of short months. */
  recurrenceDay?: Maybe<Scalars['Int']>;
  /** Inclusive end; empty means open-ended (until changed). */
  recurrenceUntil?: Maybe<Scalars['Date']>;
  relatedApplicationId?: Maybe<Scalars['Int']>;
  relatedContributionId?: Maybe<Scalars['Int']>;
  relatedFakturowniaInvoiceId?: Maybe<Scalars['Int']>;
  relatedGroupId?: Maybe<Scalars['Int']>;
  relatedTeacherId?: Maybe<Scalars['Int']>;
  status: PlannedPaymentStatus;
  /** Short label shown in the day cell / row. */
  title: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type PnlExportFileType = {
  __typename?: 'PnlExportFileType';
  contentBase64: Scalars['String'];
  contentType: Scalars['String'];
  fileName: Scalars['String'];
};

/**
 * Группа для выбора в выгрузке P&L. Отдельное поле, а не `groups`:
 * FinanceManager нет в правах на запросы групп, а выбирать группу ему нужно.
 */
export type PnlExportGroupType = {
  __typename?: 'PnlExportGroupType';
  courseName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  startDate?: Maybe<Scalars['Date']>;
};

/**
 * Заказ выгрузки. Байтов файла здесь нет — они отдаются `pnlExportFile`.
 *
 * `status` / `fileFormat` — строки, а не Enum: graphene отдал бы их
 * UPPERCASE, и сравнение на фронте молча не сработало бы.
 */
export type PnlExportRunType = {
  __typename?: 'PnlExportRunType';
  createdAt?: Maybe<Scalars['DateTime']>;
  createdByName?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  fileFormat: Scalars['String'];
  fileName?: Maybe<Scalars['String']>;
  finishedAt?: Maybe<Scalars['DateTime']>;
  groupId?: Maybe<Scalars['ID']>;
  groupName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isDownloadable: Scalars['Boolean'];
  isFilePurged: Scalars['Boolean'];
  language: Scalars['String'];
  monthFrom: Scalars['String'];
  monthTo: Scalars['String'];
  size?: Maybe<Scalars['Int']>;
  stats?: Maybe<Scalars['JSONString']>;
  status: Scalars['String'];
};

export type PortfolioProjectType = {
  __typename?: 'PortfolioProjectType';
  demoUrl: Scalars['String'];
  description: Scalars['String'];
  id: Scalars['ID'];
  repoUrl: Scalars['String'];
  role: Scalars['String'];
  technologies: Array<SkillType>;
  technologyIds: Array<Scalars['ID']>;
  technologyNames: Array<Scalars['String']>;
  title: Scalars['String'];
};

export type PowiatType = {
  __typename?: 'PowiatType';
  code: Scalars['String'];
  id: Scalars['ID'];
  kind: Scalars['String'];
  /** Чем строка совпала с запросом, если совпала НЕ именем: гминой, прежним названием или упразднённым. Без этого `karkonoski` в ответ на «kow» (гмина Kowary) выглядит ошибкой поиска. Заполняется только при поиске. */
  matchedAlias?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  voivodeshipId?: Maybe<Scalars['ID']>;
  voivodeshipName?: Maybe<Scalars['String']>;
};

export type PrivateIndividualPublicOfferAgreementType = Node & {
  __typename?: 'PrivateIndividualPublicOfferAgreementType';
  agreementDate: Scalars['Date'];
  content: Scalars['String'];
  displayPage: PrivateIndividualPublicOfferPageType;
  file: Scalars['String'];
  /** The ID of the object */
  id: Scalars['ID'];
};

export type PrivateIndividualPublicOfferAgreementTypeConnection = {
  __typename?: 'PrivateIndividualPublicOfferAgreementTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<PrivateIndividualPublicOfferAgreementTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `PrivateIndividualPublicOfferAgreementType` and its cursor. */
export type PrivateIndividualPublicOfferAgreementTypeEdge = {
  __typename?: 'PrivateIndividualPublicOfferAgreementTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<PrivateIndividualPublicOfferAgreementType>;
};

export type PrivateIndividualPublicOfferPageType = {
  __typename?: 'PrivateIndividualPublicOfferPageType';
  actualPublicOfferAgreement?: Maybe<PrivateIndividualPublicOfferAgreementType>;
  id: Scalars['ID'];
  publicOfferAgreements: PrivateIndividualPublicOfferAgreementTypeConnection;
  seoDescription: Scalars['String'];
  seoImage: Scalars['String'];
  seoKeywords: Scalars['String'];
  seoTitle: Scalars['String'];
  title: Scalars['String'];
};


export type PrivateIndividualPublicOfferPageTypePublicOfferAgreementsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

/** Наш курс, ведущий в профессию, — со ссылкой на страницу курса. */
export type ProfessionCourseType = {
  __typename?: 'ProfessionCourseType';
  completed: Scalars['Boolean'];
  courseId: Scalars['ID'];
  courseName: Scalars['String'];
  courseUrl: Scalars['String'];
};

/** Целевой навык профессии с пометкой «у меня уже есть». */
export type ProfessionSkillType = {
  __typename?: 'ProfessionSkillType';
  category: Scalars['String'];
  have: Scalars['Boolean'];
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  myLevel?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  priority: Scalars['String'];
  requiredLevel: Scalars['Int'];
  requirementStatus: Scalars['String'];
  slug: Scalars['String'];
};

/**
 * Карточка профессии (ТЗ 0039, доводка UX).
 *
 * Это тот же `GrowthTrack`, показанный как рассказ о работе, а не как цель
 * в списке. Отдельного типа профессии нет намеренно: две сущности про одно
 * разошлись бы через месяц.
 */
export type ProfessionType = {
  __typename?: 'ProfessionType';
  about: Scalars['String'];
  code: Scalars['String'];
  courses: Array<ProfessionCourseType>;
  hasRequirements: Scalars['Boolean'];
  haveCount: Scalars['Int'];
  icon: Scalars['String'];
  isChosen: Scalars['Boolean'];
  liveVacancies: Scalars['Int'];
  nextCourse?: Maybe<CareerCourseRecommendationType>;
  salaryCurrency: Scalars['String'];
  salaryFrom?: Maybe<Scalars['Int']>;
  salaryTo?: Maybe<Scalars['Int']>;
  skillProgress: CareerSkillProgressType;
  skills: Array<ProfessionSkillType>;
  steps: Array<GrowthTrackStepType>;
  stepsDone: Scalars['Int'];
  stepsTotal: Scalars['Int'];
  summary: Scalars['String'];
  title: Scalars['String'];
  topGaps: Array<CareerSkillGapType>;
  totalCount: Scalars['Int'];
};

export type ProfessionalSkillType = {
  __typename?: 'ProfessionalSkillType';
  description: Scalars['String'];
  id: Scalars['ID'];
  studentCv: StudentCvType;
};

export type ProfileCertificateInput = {
  id?: InputMaybe<Scalars['ID']>;
  issuedAt?: InputMaybe<Scalars['Date']>;
  issuer?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  url?: InputMaybe<Scalars['String']>;
};

export type ProfileEducationInput = {
  degree?: InputMaybe<Scalars['String']>;
  endMonth?: InputMaybe<Scalars['Int']>;
  endYear?: InputMaybe<Scalars['Int']>;
  institution?: InputMaybe<Scalars['String']>;
  specialization?: InputMaybe<Scalars['String']>;
  startMonth?: InputMaybe<Scalars['Int']>;
  startYear?: InputMaybe<Scalars['Int']>;
};

export type ProfileExperienceInput = {
  company?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  endMonth?: InputMaybe<Scalars['Int']>;
  endYear?: InputMaybe<Scalars['Int']>;
  isCurrent?: InputMaybe<Scalars['Boolean']>;
  position?: InputMaybe<Scalars['String']>;
  startMonth?: InputMaybe<Scalars['Int']>;
  startYear?: InputMaybe<Scalars['Int']>;
};

export type ProfileLanguageInput = {
  language: Scalars['String'];
  level?: InputMaybe<Scalars['String']>;
};

export type ProfileProjectInput = {
  demoUrl?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  repoUrl?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Scalars['String']>;
  technologyIds?: InputMaybe<Array<Scalars['ID']>>;
  title: Scalars['String'];
};

export type ProfileSkillInput = {
  isHidden?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  skillId: Scalars['ID'];
  years?: InputMaybe<Scalars['Float']>;
};

export type ProgramLessonInput = {
  id?: InputMaybe<Scalars['ID']>;
  lmsDescription?: InputMaybe<Scalars['String']>;
  marketingModuleId?: InputMaybe<Scalars['ID']>;
  name: Scalars['String'];
  taskTypes?: InputMaybe<Array<Scalars['String']>>;
};

export type ProgramModuleInput = {
  id?: InputMaybe<Scalars['ID']>;
  lessons?: InputMaybe<Array<ProgramLessonInput>>;
  name: Scalars['String'];
};

export type PromoCampaignInput = {
  code: Scalars['String'];
  currency?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  discountKind?: InputMaybe<Scalars['String']>;
  discountValue?: InputMaybe<Scalars['Float']>;
  hardExpiresAt?: InputMaybe<Scalars['Date']>;
  id?: InputMaybe<Scalars['ID']>;
  maxCodes?: InputMaybe<Scalars['Int']>;
  prefix?: InputMaybe<Scalars['String']>;
  ruleKind?: InputMaybe<Scalars['String']>;
  ruleParams?: InputMaybe<Scalars['JSONString']>;
  title: Scalars['String'];
  ttlDays?: InputMaybe<Scalars['Int']>;
};

/** Акция в ERP. Счётчики штампуются на строки, не аннотируются. */
export type PromoCampaignType = {
  __typename?: 'PromoCampaignType';
  code: Scalars['String'];
  currency: Scalars['String'];
  description: Scalars['String'];
  discountKind: Scalars['String'];
  discountValue: Scalars['Float'];
  hardExpiresAt?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  issuedCount?: Maybe<Scalars['Int']>;
  maxCodes: Scalars['Int'];
  prefix: Scalars['String'];
  redeemedCount?: Maybe<Scalars['Int']>;
  ruleKind: Scalars['String'];
  ruleParams?: Maybe<Scalars['JSONString']>;
  title: Scalars['String'];
  ttlDays: Scalars['Int'];
};

/** Строка списка кодов для оператора. */
export type PromoCodeErpType = {
  __typename?: 'PromoCodeErpType';
  agreementId?: Maybe<Scalars['ID']>;
  agreementTitle?: Maybe<Scalars['String']>;
  campaignCode: Scalars['String'];
  code: Scalars['String'];
  expiresAt?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  isAmbiguous: Scalars['Boolean'];
  redeemedAt?: Maybe<Scalars['DateTime']>;
  revokeReason: Scalars['String'];
  status: Scalars['String'];
  studentId: Scalars['ID'];
  studentName: Scalars['String'];
};

/** Код глазами студента: что даёт, до какого числа, использован ли. */
export type PromoCodeType = {
  __typename?: 'PromoCodeType';
  campaignDescription: Scalars['String'];
  campaignTitle: Scalars['String'];
  code: Scalars['String'];
  currency: Scalars['String'];
  discountKind: Scalars['String'];
  discountValue: Scalars['Float'];
  expiresAt?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  status: Scalars['String'];
};

/**
 * One selected PandaDoc document, with optional manager corrections.
 *
 * A document is provisioned only if it appears in this list — deselected
 * documents are simply omitted. Any non-null field overrides the value
 * parsed from PandaDoc (used mainly to supply a missing phone).
 */
export type ProvisionDocOverrideInput = {
  email?: InputMaybe<Scalars['String']>;
  existingUserId?: InputMaybe<Scalars['ID']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  middleName?: InputMaybe<Scalars['String']>;
  pandadocId: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
};

/** Per-document outcome of a provisioning run. */
export type ProvisionResultItem = {
  __typename?: 'ProvisionResultItem';
  agreementId?: Maybe<Scalars['ID']>;
  error?: Maybe<Scalars['JSONString']>;
  pandadocId?: Maybe<Scalars['String']>;
  skipped?: Maybe<Scalars['Boolean']>;
  success?: Maybe<Scalars['Boolean']>;
};

/** Create students + agreements + first contribution from PandaDoc docs. */
export type ProvisionStudentsMutation = {
  __typename?: 'ProvisionStudentsMutation';
  errors?: Maybe<Scalars['JSONString']>;
  results?: Maybe<Array<Maybe<ProvisionResultItem>>>;
};

/** A PandaDoc folder == a study group; groups its signed contracts. */
export type ProvisioningFolder = {
  __typename?: 'ProvisioningFolder';
  detectedCourseId?: Maybe<Scalars['ID']>;
  detectedCourseName?: Maybe<Scalars['String']>;
  existingGroupId?: Maybe<Scalars['ID']>;
  existingGroupName?: Maybe<Scalars['String']>;
  folderName?: Maybe<Scalars['String']>;
  folderUuid?: Maybe<Scalars['String']>;
  studentDocs?: Maybe<Array<Maybe<ProvisioningStudentDoc>>>;
};

/** A signed student contract, ready to be turned into a Student. */
export type ProvisioningStudentDoc = {
  __typename?: 'ProvisioningStudentDoc';
  alreadyProvisioned?: Maybe<Scalars['Boolean']>;
  contractUrl?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  existingUserId?: Maybe<Scalars['ID']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  outcome?: Maybe<Scalars['String']>;
  pandadocId?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  phoneMissing?: Maybe<Scalars['Boolean']>;
  pk?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  studentExists?: Maybe<Scalars['Boolean']>;
  userExists?: Maybe<Scalars['Boolean']>;
};

export type PublishGroupToLms = {
  __typename?: 'PublishGroupToLMS';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
  group?: Maybe<GroupType>;
  success?: Maybe<Scalars['Boolean']>;
};

export type Query = {
  __typename?: 'Query';
  agreement?: Maybe<AgreementType>;
  /** Tasks tied to one agreement (договор). */
  agreementTasks: Array<StaffTaskType>;
  allArticles?: Maybe<ArticlesConnection>;
  allCompanies?: Maybe<CompanyConnection>;
  allContributions?: Maybe<ContributionConnection>;
  allCountries?: Maybe<CountryConnection>;
  allCourseCategories?: Maybe<CategoryConnection>;
  allCourses?: Maybe<CourseFilterTypeConnection>;
  allDeferredPayments?: Maybe<DeferredPaymentConnection>;
  allGroupZoomSchedules?: Maybe<GroupZoomScheduleConnection>;
  allGroups?: Maybe<GroupConnection>;
  allGroupsForLms?: Maybe<UnionGroupConnection>;
  allLessonRecordings?: Maybe<LessonRecordingConnection>;
  allNatives?: Maybe<NativeInfoConnection>;
  allStories?: Maybe<AllStoriesConnection>;
  allStudents?: Maybe<StudentConnection>;
  allStudentsAchievement?: Maybe<StudentsAchievementConnection>;
  allSuccessStories?: Maybe<SuccessStoriesConnection>;
  allTeachers?: Maybe<TeacherFilterTypeConnection>;
  allTeachersApplications?: Maybe<ApplicationFilterTypeConnection>;
  allUsersSettings?: Maybe<UsersSettingsConnection>;
  allZoomAccounts?: Maybe<ZoomAccountConnection>;
  allZoomLessons?: Maybe<ZoomLessonConnection>;
  allZoomProcessingLog?: Maybe<ZoomProcessingLogConnection>;
  allZoomRecordings?: Maybe<ZoomRecordingConnection>;
  article?: Maybe<ArticlesType>;
  articleBySlug?: Maybe<ArticlesType>;
  /** ТЗ 0026: то же для ERP. Отдельное поле, а не общий резолвер: `permissions_checker` принимает ровно один scope. */
  attendanceHistory: Array<AttendanceChangeType>;
  bankAccounts?: Maybe<Array<Maybe<BankAccountType>>>;
  /** Import history, newest first. Previews included — seeing what a file WOULD do is half of what the log is for. */
  bankStatementImports?: Maybe<Array<Maybe<BankStatementImportType>>>;
  bankTransaction?: Maybe<BankTransactionType>;
  /** Documents this row might be explaining. Offered, not applied — the matcher only links when the answer is unambiguous. */
  bankTransactionMatchCandidates?: Maybe<Array<Maybe<MatchCandidateType>>>;
  bankTransactions?: Maybe<BankTransactionPage>;
  blogAllArticles?: Maybe<BlogAllArticlesType>;
  blogGraduateStory?: Maybe<BlogGraduateStoryType>;
  blogNative?: Maybe<BlogNativeType>;
  /** Live progress of a bulk broadcast the acting manager launched: running sent/failed counts + each recipient's outcome. Null if it isn't the manager's own job. */
  broadcastJob?: Maybe<BroadcastJobType>;
  /** Spec 0039. Medal dictionary, read-only: it is edited in Django admin, but not seeing it from the ERP at all means not knowing what students are rewarded for. */
  careerAchievements: Array<AchievementErpType>;
  /** Отклики студента глазами персонала. Личная заметка студента НЕ отдаётся — только компания, позиция, статус и даты. */
  careerApplicationsErp: Array<CareerApplicationType>;
  /** City dictionary for the feed filter. */
  careerCities: Array<CareerCityType>;
  /** Spec 0039. Course list for the skills tab: how many skills each course confers and which directions it feeds. */
  careerCourseSkillSummary: Array<CourseSkillSummaryType>;
  /** Spec 0039. What a course teaches. Without `courseId` — every link, for the editor's overview. */
  careerCourseSkills: Array<CourseSkillType>;
  /** The ERP funnel: members → trained → profile → applied → placed. */
  careerDashboard: CareerDashboardType;
  careerDirections: Array<CareerDirectionType>;
  /** Direction dictionary for the feed filter. The client used to scrape these out of the feed's own rows, which meant an empty first page left it with no filter at all. */
  careerDirectionsLms: Array<CareerDirectionType>;
  /** Spec 0040 phase B. The exercise catalogue: build once, attach to lessons. Carries the edit lock and WHICH lessons already use each one. */
  careerExerciseTemplates: Array<CareerExerciseTemplateType>;
  /** Spec 0039. Field types and resume bindings for the lesson-exercise builder, with the compatibility matrix. Served so the ERP builder cannot drift from the server rules it is validated against. */
  careerExerciseVocabulary: ExerciseVocabularyType;
  /** Кого можно добавить в центр: состав группы или поиск по ФИО. У каждой строки — memberStatus, чтобы уже состоящие были видны ДО нажатия «Добавить». */
  careerGroupRoster: Array<CareerRosterRowType>;
  /** Spec 0041. What THIS group confers. Cloned from the course when the group was created; edited per group ever since, because a course changes and a running group must not change under its students. */
  careerGroupSkills: Array<GroupSkillType>;
  /** Spec 0039. Rule vocabulary for the promo-campaign form. Served so the ERP form cannot offer a rule the server does not know — the same reason the exercise vocabulary is served rather than copied into TypeScript. */
  careerGrowthRules: Array<GrowthRuleType>;
  /** Spec 0039. Career tracks with their target skills and steps, read-only. */
  careerGrowthTracks: Array<GrowthTrackErpType>;
  /** One published career lesson. Locked lessons resolve without a body — same filter as the listing, so a guessed id leaks nothing. */
  careerLesson?: Maybe<CareerLessonType>;
  /** Published career lessons with per-viewer lock state. A locked lesson carries no content/video/attachments. */
  careerLessons: Array<CareerLessonType>;
  /** All career lessons including unpublished ones. Staff author this content, so no lock gate applies. Each row carries a `stats` completion funnel (spec 0020). */
  careerLessonsErp: Array<CareerLessonType>;
  careerMemberDetail?: Maybe<CareerMemberType>;
  /** One member's learning map — opened/completed per lesson (spec 0020). Carries no private note text. */
  careerMemberProgress: Array<CareerMemberLessonProgressType>;
  /** Career-centre participants for the ERP table. */
  careerMembers: Array<CareerMemberType>;
  /** Очередь подтверждения трудоустройства: студент отметил «вышел на работу», школа ещё не записала. Очередь ВЫВОДИТСЯ предикатом, а не хранится флагом — иначе она разъедется с откатом статуса студентом. */
  careerPlacementConfirmations: Array<CareerApplicationType>;
  /** Spec 0039 UX pass. The profession guide — what each job actually does, which skills it needs (flagged against the caller's own), which of OUR courses lead there, and how many live vacancies our board holds. Open to ANY student, like myGrowth: it is a sales surface, and the student still studying is the readiest buyer. */
  careerProfessions: Array<ProfessionType>;
  /** Spec 0039 step 6. Promo campaigns with issued/redeemed counters stamped on the rows. */
  careerPromoCampaigns: Array<PromoCampaignType>;
  /** Spec 0039 step 6. Issued codes, newest first. */
  careerPromoCodes: Array<PromoCodeErpType>;
  /** Spec 0039. Post texts per channel and language, editable from the ERP without a deploy. */
  careerShareTemplates: Array<ShareTemplateType>;
  /** Spec 0040 phase C. The storefront catalogue: what the school SELLS, with the skills each page trades on. Was seed-only, so a price-list edit needed a deploy. */
  careerSiteCourses: Array<SiteCourseErpType>;
  /** Spec 0039 UX pass. One skill on its OWN page: what it is, whether the caller has it and from where, how many live vacancies our board holds, which of OUR courses teach it and which professions need it. The drawer it replaces could not be linked to, opened from elsewhere, or returned to with Back. */
  careerSkillDetail?: Maybe<SkillDetailType>;
  /** Skill dictionary for the profile editor's autocomplete. */
  careerSkills: Array<SkillType>;
  /** Skill dictionary for the ERP vacancy form and the MCP intake tool. The LMS-scoped `careerSkills` is gated on the Student role, so an ERP token cannot read it. `withStats` defaults to false so the vacancy form's multiselect stays one cheap query. */
  careerSkillsErp: Array<SkillType>;
  /** Spec 0039. Per-course verdict for the member card, with the reason — derived, diploma, or a staff decision. */
  careerStudentCompletions: Array<CourseCompletionType>;
  /** Spec 0040. Icon vocabulary for the profession form. Professions have no official logo, so the picker offers a curated set; served rather than copied into TypeScript so the form cannot offer a value upsertTrack rejects. */
  careerTrackIcons: Array<TrackIconType>;
  /** Published vacancies for a career-centre member; empty for non-members. `savedOnly` narrows the feed to what this member saved. */
  careerVacancies: Array<VacancyType>;
  /** Vacancies for the ERP board (all statuses). `applyUrl` matches on the NORMALIZED link, so utm tags and a trailing slash do not defeat it. `freshness` is 'fresh'|'expired'; archived rows are included unless `hideArchived` is set. */
  careerVacanciesErp: Array<VacancyType>;
  /** One published vacancy; same filter as the feed, so a guessed id can't reach a draft. */
  careerVacancy?: Maybe<VacancyType>;
  /** Vacancies for the ERP board, paged. `orderBy` is createdAt|publishedAt|title|status, `orderDir` asc|desc; the queue drains oldest-first. `source` is filtered SERVER-side — a client-side filter would filter within a page once paging exists, which is wrong, not merely slow. */
  careerVacancyBoard: VacancyBoardConnection;
  careerVacancyErp?: Maybe<VacancyType>;
  /** Published vacancies, ranked against the caller. `matchMode` is 'GOAL' (the chosen profession's requirements) or 'PROFILE' (what the student can do today); omitted, it is GOAL only when a profession was EXPLICITLY chosen — a default track never silently reranks the whole feed. `sort` is 'relevance' | 'newest'. `relevanceApplied` is false when there is no signal at all — the feed is then honestly date-ordered and the UI must not claim a match. `matchContext` reports what was ACTUALLY applied, which is what makes the per-vacancy `matchedSkillCount` readable: in GOAL mode it counts the profession's requirements, in PROFILE mode the student's own skills. */
  careerVacancyFeed: VacancyConnection;
  cashBalances?: Maybe<Array<Maybe<CashBalanceSnapshotType>>>;
  cashFlowCategories?: Maybe<Array<Maybe<CashFlowCategoryType>>>;
  cashFlowControl?: Maybe<CashFlowControlType>;
  /** Cash-flow statement. Built from bank transactions only — expenses and invoices enrich a row but are never summed alongside it. */
  cashFlowReport?: Maybe<CashFlowReportType>;
  cashFlowRules?: Maybe<Array<Maybe<CashFlowRuleType>>>;
  cashFlowSettings?: Maybe<CashFlowSettingsType>;
  /** The Slack channel currently linked to a group (or null). */
  channelGroupLink?: Maybe<ChannelGroupLinkType>;
  /** Состояние интеграций переписки по всем группам: что настроено, что синхронизируется и — главное — ПОЧЕМУ по группе не видно данных (поле verdict). Отвечает на вопрос «настроил не так или баг», на который раньше не отвечало ничто (ТЗ 0032). */
  communicationsHealth: CommunicationsHealth;
  company?: Maybe<CompanyType>;
  contactsPage?: Maybe<ContactsPageType>;
  /** Newest-first keyset page of ONE conversation's messages (spec 0008) — the paginated replacement for the deprecated conversationMessages: the panel opens on the newest 30 and pages back to older ones via `after`. */
  conversationThread: MessageConnection;
  /** Dashboard communications browser: keyset-paginated conversations (newest activity first) filterable by group, student, date range (last activity day, both ends inclusive) and text (dialog title + student name; message bodies are deliberately NOT searched — unindexed). unhandledOnly=true (default) keeps only dialogs with an inbound message not yet ticked «обработано» — the amber-dot queue. */
  conversationsBrowser: ConversationConnection;
  course?: Maybe<CourseType>;
  courseBySlug?: Maybe<CourseType>;
  courseCatalogPage?: Maybe<CourseCatalogPageType>;
  /** Spec 0040 revision. The course FRAME — programme title, hours, description and the marketing modules the site page is built from. ERP showed a flat lesson list and said nothing about the frame existing at all. */
  courseProgramFrame: CourseProgramFrameType;
  /** Spec 0040. The course programme's lessons in flat order, so the methodist picks «after lesson N» by NAME instead of remembering a number. */
  courseProgramLessons: Array<CourseProgramLessonType>;
  coursesGraduateFeedback?: Maybe<GraduateFeedbackConnection>;
  dataProcessingPolicyPage?: Maybe<DataProcessingPolicyType>;
  /** Debtors by the CONTRIBUTION plan: an instalment overdue by more than settings.DEBTOR_OVERDUE_DAYS and not covered, excluding terminated / transferred-out / free / fully-corrected agreements. Optionally scoped to one group. Since ТЗ 0074 it does NOT decide LMS suspension (that is the invoice rule — see lmsSuspensions). */
  debtorCandidates: Array<DebtorCandidateType>;
  demoGroupsCount?: Maybe<DemoType>;
  /** Short-lived presigned GET for one diploma. ERP staff only; the student's own path is `myDiplomaDownloadUrl`. */
  diplomaDownloadUrl?: Maybe<DiplomaDownloadUrlType>;
  /** Where this document's money is in the bank. «Не найдено» is a legitimate answer, not an error — most card payments have no document to pair with. */
  documentCashFlow?: Maybe<DocumentCashFlowType>;
  exchangeRates?: Maybe<Array<Maybe<ExchangeRateType>>>;
  expense?: Maybe<ExpenseType>;
  expenseAggregates?: Maybe<Array<Maybe<ExpenseAggregateRow>>>;
  expenseCategories?: Maybe<Array<Maybe<ExpenseCategoryType>>>;
  expenses?: Maybe<Array<Maybe<ExpenseType>>>;
  /** Progress of a group billing run. Scoped by role, NOT by creator (unlike broadcastJob): the rows carry invoice data every FAKTUROWNIA_ACCESS_ROLES holder can already read via fakturowniaInvoices, and finance genuinely needs to see a colleague's run. */
  fakturowniaBillingJob?: Maybe<FakturowniaBillingJobType>;
  /** Preflight for «Выставить фактуру» — same check the mutation runs, so the UI can grey out the button and say why, and preview exactly what will be sent. */
  fakturowniaContributionBillability: FakturowniaBillabilityType;
  /** Per-agreement preflight for the whole group — the bulk-issue picker. Non-billable rows are RETURNED, not filtered out: «пропущено» has to be visible or the operator believes the whole group was billed. */
  fakturowniaGroupBillingPreview: FakturowniaGroupBillingPreviewType;
  fakturowniaInvoice?: Maybe<FakturowniaInvoiceType>;
  /** Aggregated sums for KPI / charts. PLN by contract — no FX conversion. Quotation-kinds are excluded by default so estimate+advance+final chains aren't double-counted. */
  fakturowniaInvoiceAggregates?: Maybe<Array<Maybe<FakturowniaInvoiceAggregateRow>>>;
  fakturowniaInvoices?: Maybe<Array<Maybe<FakturowniaInvoiceType>>>;
  fakturowniaSyncRuns?: Maybe<Array<Maybe<FakturowniaSyncRunType>>>;
  /** One-shot 'is the mirror fresh?' snapshot for dashboard widgets. Combines the most recent run with the most recent successful run so the UI can show both 'last synced HH:MM' and 'sync failed'. */
  fakturowniaSyncStatus?: Maybe<FakturowniaSyncStatus>;
  fakturowniaUnmatchedCount?: Maybe<Scalars['Int']>;
  financeBudget?: Maybe<Array<Maybe<MonthBudget>>>;
  financeMonthBudget?: Maybe<WeeksBudgetInfo>;
  financePlan?: Maybe<Array<Maybe<MonthBudget>>>;
  financeYears?: Maybe<Array<Maybe<Scalars['Int']>>>;
  /** Счётчики по колонкам воронки плюс обе очереди разбора. Принимает те же фильтры, что и `fundingCandidates`, КРОМЕ `status`/`statusGroup`: сегмент не считает сам себя, иначе выбор одной группы обнулил бы остальные. */
  fundingBoard: FundingBoardType;
  fundingCandidate?: Maybe<FundingCandidateType>;
  /** Панель дофинансирования на карточке студента. Нужен один из userId / studentId. */
  fundingCandidateForUser?: Maybe<FundingCandidateType>;
  /** Срез воронки. Измерения: funnel, operator, geo, outcome_month. Неизвестное — ошибка, а не тихий откат. */
  fundingCandidateStats: FundingStatsType;
  /** Не больше 200 строк за раз — общее число спрашивайте у `fundingCandidatesTotal` с теми же фильтрами. */
  fundingCandidates: Array<FundingCandidateType>;
  /** Все заявки этого человека, если их несколько. */
  fundingCandidatesForUser: Array<FundingCandidateType>;
  fundingCandidatesTotal: Scalars['Int'];
  /** Одна заявка — для окна ручного разбора. Отдельный запрос, потому что окну нужны ТЯЖЁЛЫЕ поля (ответы формы, происхождение оператора), а списку из пятидесяти строк они стоили бы подзапроса на строку. */
  fundingFormSubmission?: Maybe<FormSubmissionType>;
  /** Заявки с публичной формы; `state` = failed|pending|needs_operator|linked|rejected. `needs_operator` — разобрана, но оператор не назначен: это работа, и она не должна теряться среди готовых. Отклонённые как автоматические в остальные состояния НЕ попадают. */
  fundingFormSubmissions: Array<FormSubmissionType>;
  /** Сколько всего заявок под тем же фильтром. Экран писал длину страницы, а форма набирает заявки бесконечно. */
  fundingFormSubmissionsTotal: Scalars['Int'];
  /** Адрес публичной формы заявки — тот, что менеджер даёт человеку, и тот же, что робот подставляет в письмо. Отдаётся с сервера, а не зашит во фронт, чтобы адрес имел ровно одно определение: до ТЗ 0061 он не существовал в коде вовсе и жил вшитой строкой внутри текстов шаблонов SendGrid. */
  fundingFormUrl: Scalars['String'];
  /** Очередь разбора: строки покрытия, которые импорт не смог сопоставить со справочником. */
  fundingGeoAliases: Array<GeoAliasType>;
  /** Один прогон — для карточки. Отдельное поле, а не поиск по загруженной странице: иначе ссылка на прогон, вытесненный из окна списка, открывала бы пустоту. */
  fundingImportRun?: Maybe<ImportRunType>;
  fundingImportRuns: Array<ImportRunType>;
  /** Сколько прогонов всего под теми же фильтрами. Без счётчика экран печатал длину страницы и читался как «прогонов всего 25» — а пачка ручных прогонов выдавила бы из этого окна всю ночную серию. */
  fundingImportRunsTotal: Scalars['Int'];
  /** Одно окно набора. Карточки набора не было вовсе: окно жило строкой в таблице и строкой внутри карточки оператора, а рассылка — третьим местом. */
  fundingIntake?: Maybe<FundingIntakeType>;
  /**
   * Окна набора по всем операторам с фильтрами.
   *
   * 🔴 Заменило `fundingUpcomingIntakes`, которое было не списком, а ОДНИМ срезом: живые окна в пределах горизонта. Из 123 окон в базе там было видно 18, а 105 не показывались никогда — ни при каком горизонте.
   */
  fundingIntakes: Array<FundingIntakeType>;
  /** Сколько всего окон под теми же фильтрами. */
  fundingIntakesTotal: Scalars['Int'];
  /** Журнал писем домена. Без `candidateId` — общий список. */
  fundingNotifications: Array<FundingNotificationType>;
  fundingNotificationsTotal: Scalars['Int'];
  fundingOperator?: Maybe<FundingOperatorType>;
  /** Реестр операторов BUR и KFS в одной таблице. `powiatId` учитывает и общепольских операторов. Не больше 200 строк за раз — общее число спрашивайте у `fundingOperatorsTotal` с теми же фильтрами. */
  fundingOperators: Array<FundingOperatorType>;
  /** Сколько всего операторов под теми же фильтрами. Без него экран показывал длину страницы и врал: «Операторы 50» при 124 в базе. */
  fundingOperatorsTotal: Scalars['Int'];
  fundingPowiats: Array<PowiatType>;
  /** Сколько заявок в каждом состоянии — плитки над списком. Считается ТЕМ ЖЕ фильтром и под теми же остальными условиями, что и сам список: плитка это кнопка, и она обязана приводить ровно к обещанному числу. */
  fundingSubmissionStates: Array<SubmissionStateCountType>;
  /** По строке на задачу робота: когда ходила последний раз и ходит ли по расписанию. Считается ОТДЕЛЬНО от списка прогонов — десяток ручных запусков одной задачи вытеснил бы остальные из окна, и сводка соврала бы. */
  fundingTaskSummary: Array<TaskSummaryType>;
  fundingVoivodeships: Array<VoivodeshipType>;
  /** Что мешает роботу следить: по строке на причину. Живёт ЗДЕСЬ, а не в реестре операторов — поломки убраны с глаз менеджера (ТЗ 0054), но не из системы: без этой сводки оператор без адреса выглядит ровно как спокойный. */
  fundingWatchHealth: Array<WatchHealthType>;
  /** Сколько РАЗНЫХ операторов, у которых слежение не работает. Отдельным числом, потому что строки `fundingWatchHealth` складывать нельзя: причины пересекаются, а имена в них обрезаны потолком. */
  fundingWatchOperatorsBroken: Scalars['Int'];
  gatewaySettlement?: Maybe<GatewaySettlementType>;
  /** Invoices that could be inside this batch, with a greedy pre-selection that lands in the fee band. */
  gatewaySettlementCandidates?: Maybe<Array<Maybe<GatewaySettlementCandidateType>>>;
  gatewaySettlements?: Maybe<Array<Maybe<GatewaySettlementType>>>;
  /** Shared mailboxes available to send FROM when composing a new email (enabled only). */
  gmailMailboxes: Array<GmailMailboxType>;
  group?: Maybe<GroupType>;
  /** Group dashboard — passed/expected lessons rollup plus per-student attendance rate, with a settings-driven threshold flag for the «attention» badge. Replaces the per-lesson fan-out the frontend used to do. See docs/groups/group_dashboard.md §G3. */
  groupAttendanceSummary?: Maybe<GroupAttendanceSummary>;
  /** The communicator middle-column badge aggregate for one group: per-student unread/unhandled splits + the whole-group Slack/mail totals, computed server-side in two set-based queries (spec 0008). Replaces the frontend's multi-page conversationsBrowser drain. */
  groupCommsIndex: GroupCommsIndex;
  /** @deprecated Unbounded (loads every conversation ever). Use groupConversationsPage — the keyset-paginated replacement (spec 0031). */
  groupConversations: Array<ConversationType>;
  /** Conversations whose `group` FK is this group (its Slack channels) — the keyset page replacing groupConversations. NOT the whole communicator population: students' DMs and mail live under conversationsBrowser(groupId:). */
  groupConversationsPage: ConversationConnection;
  /** Diploma roster of the group — one row per student with an ACTIVE agreement, carrying their PL/EN diplomas. Students on a terminated agreement are excluded. */
  groupDiplomas: Array<GroupDiplomaRowType>;
  groupForLms?: Maybe<UnionGroupType>;
  /** ТЗ 0026: матрица «студент × занятие» для журнала ERP — оценка за ДЗ и факт сдачи. Один батч на всю группу. */
  groupHomeworkMarksForErp: Array<StudentLessonHwMarkType>;
  groupHomeworkOverviewForErp: Array<LessonHomeworkStatsType>;
  groupLessonAttachment?: Maybe<LessonAttachmentsType>;
  groupLessonAttachmentForLms?: Maybe<Array<Maybe<LessonAttachmentsForLmsType>>>;
  groupLessonAttendanceForLms?: Maybe<Array<Maybe<LessonAttendancesType>>>;
  /** Recipient picker rows for a group: one per student, with their latest unpaid invoice when there is one. */
  groupMailCandidates: Array<GroupMailCandidateType>;
  /** Newest-first keyset feed of all of a group's Slack messages (every channel + its students' DMs), with search / unread / flagged / unhandled / per-channel filters. */
  groupMessages: MessageConnection;
  groupNotes: Array<StudentNoteType>;
  /** Per-group marks rollup: weighted average + top/bottom 3 by avg mark. Terminated agreements are excluded. See docs/groups/group_dashboard.md §G4. */
  groupPerformanceSummary?: Maybe<GroupPerformanceSummary>;
  /** Spec 0041. This group's own lessons in flat order, with the date and whether they are already over — the picker for «the skill appears here». */
  groupProgramLessons: Array<GroupProgramLessonType>;
  /** Per-currency revenue rollup over the group's active agreements (budget / paid / debt / agreementsActive / studentsWithDebt). Mirrors KpiStrip.tsx so the frontend can drop the heavy `agreements[].payments[]` payload for big groups. See §G5. */
  groupRevenueAggregates?: Maybe<GroupRevenueAggregates>;
  /** Every Slack channel configured for a group (ChannelGroupLink, discovered via conversations.list), merged with its Conversation mirror — so channels with no ingested messages yet still appear in the inbox. */
  groupSlackChannels: Array<GroupChannelRow>;
  groupSurveyAssignments: Array<SurveyAssignmentType>;
  groupTasks: Array<StaffTaskType>;
  groupWhiteboards: Array<WhiteboardMetaType>;
  /**
   * Account-manager command-center rollup: one row per enrolled group with students count, contribution-based debt (NOT Fakturownia), debtors count, unanswered Slack/email and open/overdue task counts.
   *
   * `activeWithinDays` (spec 0031) keeps only groups whose LAST lesson is within that many days, plus groups with no lessons yet (a brand-new group must not be invisible until its first lesson happens). Omit it for every group — the command-center KPI totals and the MCP tool depend on the unfiltered set, so it must stay opt-in.
   */
  groupsOverview: Array<GroupOverviewRow>;
  /** Whether the AI review pipeline is switched on (HOMEWORK_AI_ENABLED). The teacher UI hides the AI card and the re-run control when this is false — without it the control is always rendered and always fails with AI_DISABLED. */
  homeworkAiEnabled: Scalars['Boolean'];
  /** One row per eligible student: submission + journal hw_mark. LMS scope: the lesson's teacher or a methodist (read-only). */
  homeworkRoster: Array<HomeworkRosterRowType>;
  /** Short-lived presigned GET for a submission's ZIP. Students get their own file only; teachers — their lessons'; methodists — read-only access. */
  homeworkSubmissionDownloadUrl?: Maybe<Scalars['String']>;
  homeworkSubmissionDownloadUrlForErp?: Maybe<Scalars['String']>;
  /** Synced Zoom recordings offered as a hiring interview. Deliberately does NOT expose `files` — those entries carry raw Zoom download URLs. */
  interviewZoomCandidates: Array<InterviewZoomCandidateType>;
  /** ZOOM_INTERVIEW_ACCOUNT_EMAIL resolved to an account id, or null. A DEFAULT filter for the picker, never a restriction. */
  interviewZoomDefaultAccountId?: Maybe<Scalars['ID']>;
  journal?: Maybe<GroupLessonConnection>;
  legalEntityPublicOfferPage?: Maybe<LegalEntityPublicOfferPageType>;
  lessonForLms?: Maybe<UnionLessonType>;
  /** The lesson's homework assignment (staff view). LMS scope: the lesson's teacher or a methodist. */
  lessonHomework?: Maybe<HomeworkAssignmentType>;
  lessonHomeworkSubmissionsForErp: Array<HomeworkRosterRowType>;
  /** ERP «Кто заходил»: клики «Присоединиться к занятию» по занятию (spec 0013). */
  lessonJoinClicks?: Maybe<Array<Maybe<LessonJoinClickType>>>;
  /** ТЗ 0026: файлы учебника занятия — то, что студент видит во вкладке «Материалы». Отдельное корневое поле, а не поле на типе задания: `lessonHomework` возвращает null, когда задания нет, а именно в этом случае учебник и нужен обеим сторонам. Ссылок не отдаёт — только id, по которому клиент открывает штатный просмотрщик. */
  lessonTextbookFiles: Array<LessonTextbookFileType>;
  lessonWhiteboard?: Maybe<WhiteboardType>;
  lessonWhiteboardForErp?: Maybe<WhiteboardType>;
  /** ТЗ 0026: история правок одной отметки — преподавателю своего занятия. Отвечает на «кто снял галочку»: до 0026 ответа не существовало вовсе. */
  lmsAttendanceHistory: Array<AttendanceChangeType>;
  /** ТЗ 0074: the suspension robot's most recent run. */
  lmsBlockRobotLastRun?: Maybe<LmsBlockRunType>;
  /** ТЗ 0074: SendGrid dynamic templates for the settings picker; SendGrid errors as customErrors. */
  lmsBlockSendgridTemplates: LmsBlockSendgridTemplatesType;
  /** ТЗ 0074: LMS suspension settings (robot, threshold, email / Slack, SendGrid templates). */
  lmsBlockSettings: LmsBlockSettingsType;
  /** ТЗ 0074: example dynamic_template_data for kind suspended | restored — the SendGrid «test data». */
  lmsBlockTemplateExample: Scalars['JSONString'];
  /** ТЗ 0074: variables sent to the SendGrid templates (dynamic_template_data), described in Polish and Russian. */
  lmsBlockTemplateVariables: Array<LmsBlockTemplateVariableType>;
  lmsJournal?: Maybe<GroupLessonType>;
  /** Подсказки журнала преподавателя: первый клик каждого студента по занятию (spec 0013). */
  lmsLessonJoinClicks?: Maybe<Array<Maybe<LmsLessonJoinClickType>>>;
  /** ТЗ 0074 «Wstrzymany dostęp»: status = active | history | skipped; search by first/last name or email; offset/limit (≤200) pagination. */
  lmsSuspensions: LmsSuspensionPageType;
  /** One mailing run — poll this for live send progress and per-recipient delivery status. */
  mailJob?: Maybe<MailJobType>;
  /** Mailing history for a group, newest first. */
  mailJobs: Array<MailJobType>;
  mainPageInfo?: Maybe<MainPageInfoType>;
  mainTeachersWeb?: Maybe<MainTeacherWebType>;
  /** Group-scoped study materials list. STUDENT scope callers see only materials in groups where they have an active agreement. */
  materials: Array<Maybe<MaterialType>>;
  me?: Maybe<UserNode>;
  metaContributions?: Maybe<MetaContribution>;
  metaCourses?: Maybe<MetaCourses>;
  metaDeferredPayments?: Maybe<MetaDeferredPaymentConnection>;
  metaGroups?: Maybe<MetaGroups>;
  metaStudents?: Maybe<MetaStudents>;
  metaTeachers?: Maybe<MetaTeachers>;
  metaTeachersApplications?: Maybe<MetaTeacherApplications>;
  metaUsersSettings?: Maybe<MetaUsersSettings>;
  /** The signed-in student's OWN attendance for one group, lesson by lesson. The teacher has always recorded this (and even sees Zoom join-time chips), but none of it reached the student — they could not answer «сколько я пропустил». Self-scoped: there is no student argument, the row set is derived from the token. */
  myAttendance: Array<MyLessonAttendanceType>;
  /** Собственный журнал поиска работы. Пусто у не-участника и у методиста-смотрящего: это личные данные. */
  myCareerApplications: Array<CareerApplicationType>;
  /** The logged-in student's career-centre membership and training progress; null if not enrolled. LMS scope + Student role only. */
  myCareerCenter?: Maybe<CareerCenterType>;
  /** Дорожная карта: цель, шесть этапов со счётчиками, ОДНО следующее действие, до трёх задач недели, готовность и список закрытых возможностей с кодом причины. Открыто ЛЮБОМУ студенту, не только участнику центра: экран витринный, а закрытое приходит помеченным, а не четырёхсотчетвёртым. */
  myCareerJourney?: Maybe<CareerJourneyType>;
  /** The logged-in student's own structured career profile (created on first read). Any Student, self only. */
  myCareerProfile?: Maybe<CareerProfileType>;
  /** Spec 0070. A profession as a MAP: clusters, skill nodes with a server-computed status, and the dependency edges between them. Without `trackCode` — the caller's goal. `null` means the system has no active professions at all — a profession without data still answers, with `isFallback` set, because an unexplained empty canvas reads as a breakage. */
  myCareerSkillGraph?: Maybe<CareerSkillGraphType>;
  /** Short-lived presigned GET for one of the student's OWN diplomas. Minted per click, never listed. */
  myDiplomaDownloadUrl?: Maybe<DiplomaDownloadUrlType>;
  /** The logged-in student's own diplomas, newest first. LMS scope + Student role only; takes no arguments. */
  myDiplomas: Array<MyDiplomaType>;
  /** Spec 0039. XP, medals and career tracks. 🔴 Open to ANY student, not only career-centre members: it is a sales surface, and the student still studying is the readiest buyer. Medals unreachable outside the centre come back `locked`, never hidden. */
  myGrowth?: Maybe<GrowthOverviewType>;
  /** The logged-in student's own issued Fakturownia invoices (paid + unpaid), in due-date order. LMS scope + Student role only. */
  myInvoices?: Maybe<Array<Maybe<StudentInvoiceType>>>;
  /** The lesson's homework assignment with the logged-in student's own submission and (once graded) mark + teacher comment. Null when the lesson has no assignment yet. LMS scope + Student role only. */
  myLessonHomework?: Maybe<HomeworkAssignmentForStudentType>;
  /** MCP-доступ текущего пользователя: включён ли, куда подключаться и какие клиенты подключены сейчас. */
  myMcpAccess: McpAccessType;
  /** Spec 0039 step 6. The caller's own promo codes. Revoked and expired ones are not shown: a code that will be refused at the till is worse than no code. */
  myPromoCodes: Array<PromoCodeType>;
  /** Spec 0039 step 7. Ready-made post text and the share window URL per channel. Instagram comes back with a null shareUrl on purpose: it has no web share endpoint. */
  myShareOptions: Array<ShareOptionType>;
  /** Spec 0039 step 5. What the student has, what the chosen track still needs, and WHICH COURSE teaches it. Demand numbers come from the nightly snapshot and describe OUR board, not the labour market — the UI must say so. */
  mySkillMap?: Maybe<SkillMapType>;
  /** Whether the ACTING manager has saved his personal Slack user token (xoxp) for this group's workspace. The token itself is never returned. */
  mySlackUserToken: SlackUserTokenStatusType;
  /** Surveys this student already answered, with their own answers (spec 0027). Their own data, so returning the answers is safe — but the student is derived from the token and there is deliberately NO studentId argument. */
  mySubmittedSurveys: Array<SubmittedSurveyType>;
  /** The logged-in student's pending (unanswered, open) surveys, questions included. LMS scope + Student role only. */
  mySurveys: Array<PendingSurveyType>;
  /** Tasks assigned to the current user. */
  myTasks: Array<StaffTaskType>;
  /** The logged-in TEACHER's own survey feedback — aggregate only, course-level, k-anonymous, never comment text. Returns null unless SURVEY_TEACHER_SELF_VIEW_ENABLED. */
  myTeachingFeedback?: Maybe<MyTeachingFeedbackType>;
  native?: Maybe<NativeInfoType>;
  nativeBySlug?: Maybe<NativeInfoType>;
  /** Подбор оператора: жёсткие фильтры — география и форма занятости, остальное только оценивает шансы. */
  operatorsForCandidate: Array<FundingOperatorType>;
  pandadocAnalytics?: Maybe<PandaDocAnalyticsType>;
  pandadocDocuments?: Maybe<PandaDocDocumentConnection>;
  pandadocProvisioningFolders?: Maybe<Array<Maybe<ProvisioningFolder>>>;
  pandadocSyncStatus?: Maybe<PandaDocSyncStatusType>;
  paymentCalendar?: Maybe<PaymentCalendarType>;
  paymentCalendarSettings?: Maybe<PaymentCalendarSettingsType>;
  paymentRulesPage?: Maybe<PaymentRulesPageType>;
  paymentsVerification?: Maybe<Array<Maybe<PaymentsVerificationType>>>;
  plannedPayments?: Maybe<Array<Maybe<PlannedPaymentType>>>;
  /** Готовый файл выгрузки P&L в base64. */
  pnlExportFile?: Maybe<PnlExportFileType>;
  /** Группы юрлица сотрудника для выгрузки P&L (ТЗ 0075). */
  pnlExportGroups?: Maybe<Array<PnlExportGroupType>>;
  /** Последние выгрузки данных для P&L (ТЗ 0075), видимые сотруднику. */
  pnlExportRuns?: Maybe<Array<PnlExportRunType>>;
  privateIndividualPublicOfferPage?: Maybe<PrivateIndividualPublicOfferPageType>;
  /** Справочник повятов для ПУБЛИЧНОЙ формы заявки. */
  publicFundingPowiats: Array<PowiatType>;
  /** Справочник воеводств для ПУБЛИЧНОЙ формы заявки. */
  publicFundingVoivodeships: Array<VoivodeshipType>;
  /** Received Fakturownia cost documents eligible to back an Expense (excludes quotations; by default also excludes invoices already linked to an Expense). */
  receivedInvoicesForExpense?: Maybe<Array<Maybe<ReceivedInvoiceForExpenseType>>>;
  /** Most recently created LessonRecordings (newest first) for the ERP «recently matched» list. `mine` limits to matches made by the current user; `limit` caps the result set (default 20). */
  recentlyMatchedLessonRecordings?: Maybe<Array<Maybe<LessonRecordingType>>>;
  /** Who a reply to this conversation will be sent as, for the acting manager: him personally (his Slack token), the workspace bot, or the shared mailbox. */
  replyIdentity: ReplyIdentityType;
  robotTxt?: Maybe<RobotTxtType>;
  /** The SendGrid contact list mirroring this group's students, or null if it has not been created yet. */
  sendgridGroupList?: Maybe<SendgridGroupListType>;
  /** Dynamic templates available in SendGrid, for the mailing template picker. Read live from the API. */
  sendgridTemplates: Array<SendgridTemplateType>;
  /** The exact backend URL to register as each Slack app's OAuth «Redirect URL» (server setting SLACK_OAUTH_REDIRECT_URI). Empty → the one-click «Подключить мой Slack» flow isn't configured server-side. */
  slackOauthRedirectUri?: Maybe<Scalars['String']>;
  /** The Slack user currently linked to a student (or null). */
  slackUserLink?: Maybe<SlackUserLinkType>;
  /** The Slack workspace bound to a group (or null). */
  slackWorkspaceLink?: Maybe<SlackWorkspaceLinkType>;
  /** Human members of the group's Slack workspace (mirrored by sync). By default only those not yet matched to a student — the manual-matching worklist. */
  slackWorkspaceMembers: Array<SlackUserLinkType>;
  staffNotificationSettings?: Maybe<StaffNotificationSettingsType>;
  /** The feed itself. Loaded on opening the popup, never in the poll. */
  staffNotifications?: Maybe<StaffNotificationPageType>;
  /** Bell counter. Polled once per `pollSeconds`; one SELECT. */
  staffNotificationsSummary?: Maybe<StaffNotificationsSummaryType>;
  /** Одна задача целиком — для окна карточки (ТЗ 0064). Отдельно от ленты, потому что здесь выбирают тела реплик, а в ленте это были бы тексты всех реплик по всем задачам. */
  staffTask?: Maybe<StaffTaskType>;
  /** Короткоживущая подписанная ссылка на один файл задачи (ТЗ 0066). Отдельный резолвер, а не поле в типе: так ссылка минтится по клику, не оседает в кеше клиента и каждая выдача попадает в аудит. */
  staffTaskAttachmentUrl?: Maybe<TaskAttachmentUrlType>;
  /** Flexible task feed for the command center: filter by group / student / agreement / teacher / assignee, by a due-date range (due_from..due_to) and a title/description search; ordered open-first then by due date. */
  staffTasks: Array<StaffTaskType>;
  /** Counts over the SAME selection `staffTasks` returns, for the command-center header. Takes the identical arguments on purpose: a header number computed from a different population than the list under it is worse than no number — the previous one summed a per-GROUP rollup and could not see group-less tasks at all (spec 0063). */
  staffTasksSummary: StaffTasksSummaryType;
  /** Active ERP staff (management roles) — the only valid task assignees. */
  staffUsers: Array<StaffUserType>;
  student?: Maybe<StudentType>;
  /** The stored LMS-access block for a student (null if the student was never blocked). */
  studentAccessBlock?: Maybe<StudentAccessBlockType>;
  /** ТЗ 0074: the student's suspensions and restorations, newest first, with what was sent. */
  studentAccessBlockEvents: Array<LmsBlockEventType>;
  /** @deprecated Unbounded (loads every conversation ever). Use studentConversationsPage — the keyset-paginated replacement (spec 0031). */
  studentConversations: Array<ConversationType>;
  /** A student's dialogs, newest activity first — the keyset page replacing studentConversations. Includes group-DM (mpim) participations, not just dialogs owned by this student. */
  studentConversationsPage: ConversationConnection;
  studentHomeworkForErp: Array<StudentHomeworkRowType>;
  studentMarks?: Maybe<StudentsMarkConnection>;
  /** Aggregated communicator hover-card (spec 0009). `finance` and per-group financing flags are null for viewers without payment roles; the whole result is null when the student does not exist. */
  studentMiniCard?: Maybe<StudentMiniCard>;
  studentNotes: Array<StudentNoteType>;
  /** One student's answers, for their ERP card. The LMS twin `mySubmittedSurveys` deliberately has NO studentId argument — that asymmetry is the anti-IDOR design, not an oversight. Gated tighter than the aggregates: this pairs a named student with their free-text opinion of a named teacher. */
  studentSurveyResponses?: Maybe<StudentSurveyHistoryType>;
  studentTasks: Array<StaffTaskType>;
  studentsCompaniesInfo?: Maybe<StudentAndCompaniesType>;
  studentsForJournal?: Maybe<StudentConnection>;
  studentsMarks?: Maybe<StudentConnection>;
  studentsReviews?: Maybe<StudentsReviewsType>;
  successStoriesBlock?: Maybe<SuccessStoriesBlockType>;
  successStory?: Maybe<SuccessStoriesType>;
  successStoryBySlug?: Maybe<SuccessStoriesType>;
  survey?: Maybe<SurveyType>;
  /** Cross-survey metrics for ONE разрез. dimension: course | group | teacher | lesson_number | month | survey | metric | question_type. The date window applies to the TRIGGER LESSON's date, never to submission time — otherwise responseRate's numerator and denominator would be windowed differently. The teacher dimension uses the lesson's CURRENT teacher (live); teacherSurveyFeedback is snapshotted and remains the authority for anything about a named person. */
  surveyAnalytics: Array<SurveyAnalyticsRowType>;
  surveyAssignmentResults?: Maybe<SurveyAssignmentResultsType>;
  /** The survey's audience, seen FROM the survey — the reverse of groupSurveyAssignments(groupId). Same rows and the same builder as surveySummary.groupBreakdown. */
  surveyAssignments: Array<SurveyGroupBreakdownType>;
  /** The free-text feed with full context. Keyset-paginated: the feed is read newest-first while new responses arrive, and OFFSET paging would repeat or skip rows as the head shifts. */
  surveyComments: SurveyCommentPageType;
  /** One question, split by a dimension. Distributions come from the same aggregation as surveySummary, so `total` is guaranteed identical to the matching questionResults entry. Null when the question is not part of the survey. */
  surveyQuestionBreakdown?: Maybe<SurveyQuestionBreakdownType>;
  /** Every question across every survey with its topic and a suggestion — the bulk-tagging screen. Without tagging the topic dimensions answer nothing, and tagging one question at a time inside each constructor is work nobody does. */
  surveyQuestionTags: Array<SurveyQuestionTagRowType>;
  surveyResponseDetail?: Maybe<SurveyResponseDetailType>;
  /** Respondents × questions for one survey — the answer table. Same answers as surveyAssignmentResults, laid out so different people's answers sit side by side instead of one drawer at a time. */
  surveyResponseMatrix?: Maybe<SurveyResponseMatrixType>;
  /** Outliers worth acting on. Unlike teacherSurveyLeaderboard — which RETURNS thin rows flagged enoughData=false, because hiding a teacher would imply they are fine — an under-sampled alert is noise, so rows below minSample are suppressed. sampleSize is reported on every survivor. */
  surveySignals: Array<SurveySignalType>;
  /** Pooled results across ALL of the survey's groups, plus a per-group breakdown. Same per-question aggregation as surveyAssignmentResults, wider pool. */
  surveySummary?: Maybe<SurveySummaryType>;
  /** Candidate groups for the constructor's picker, each with the lesson the trigger resolves to or the reason it would be skipped — so «в группе нет занятия №8» is visible BEFORE saving. */
  surveyTargetGroups: Array<SurveyTargetGroupType>;
  /** The survey's saved targeting rules (spec 0027). The counters are zero here — they describe a save, not a read. */
  surveyTargeting?: Maybe<SurveyTargetingType>;
  /** How many questions still carry no topic. Drives the «N вопросов без темы» prompt. */
  surveyUntaggedCount: Scalars['Int'];
  /** Survey templates. `courseId` narrows to that course's surveys PLUS universal ones (what the attach popup needs); archived rows are hidden unless `includeArchived`. */
  surveys: Array<SurveyType>;
  /** Размер, количество и белый список расширений, которые принимает сервер. Клиент их не повторяет, а читает. */
  taskAttachmentLimits: TaskAttachmentLimitsType;
  /** Виды связей, доступные ЭТОМУ пользователю (ТЗ 0064). Клиент не хардкодит список и не предлагает вид, поиск по которому всё равно вернёт пусто: право на задачи шире, чем право на преподавателей или дофинансирование. */
  taskLinkKinds: Array<TaskLinkKindType>;
  /** Подсказки для пикера связей: ОДИН резолвер на все виды. Ищет по выборке, скоупленной правилами своего домена — прицепить можно только то, что человек и так видит. Неизвестный или запрещённый вид даёт пусто, а не ошибку. */
  taskLinkSearch: Array<TaskLinkType>;
  teacher?: Maybe<TeacherType>;
  /** The merged AI competency profile (spec 0028 C). ADVISORY: render it under a «draft, not a decision» label with `aiModel`/`promptVersion`/`analyzedAt` visible. Returns null until an analysis has run. */
  teacherAiProfile?: Maybe<TeacherAiProfileType>;
  teacherApplication?: Maybe<ApplicationType>;
  /** Groups on a course the teacher is qualified for (`coursesCanTeach`) that still have future lessons with no live teacher application. */
  teacherCandidateGroups: Array<TeacherCandidateGroupType>;
  /**
   * A teacher's threads (Slack DM + Gmail) — the teacher analog of studentConversations. Visible in the group context of the communicator; not in the dashboard queue (spec 0033).
   * @deprecated Unbounded (loads every conversation ever). Use teacherConversationsPage — the keyset-paginated replacement (spec 0031).
   */
  teacherConversations: Array<ConversationType>;
  /** A teacher's dialogs, newest activity first — the keyset page replacing teacherConversations. */
  teacherConversationsPage: ConversationConnection;
  /** A short-lived signed GET. Audited on every issue. */
  teacherDocumentDownloadUrl?: Maybe<Scalars['String']>;
  /** The extracted body — exactly what the AI read. Exposed so the assessment is auditable. */
  teacherDocumentText?: Maybe<TeacherDocumentTextType>;
  /** Uploaded candidate documents, newest first. Every kind is VERSIONED — the newest row of a kind carries `isCurrent: true` and older ones are kept on purpose. */
  teacherDocuments: Array<TeacherDocumentType>;
  /** The transcript body — fetched separately because it is large and only the transcript drawer needs it. */
  teacherInterviewTranscript?: Maybe<TeacherInterviewTranscriptType>;
  /** A short-lived signed GET for the stored MP4 (or the bare external URL for a link-interview). Audited on every issue. */
  teacherInterviewVideoUrl?: Maybe<Scalars['String']>;
  teacherInterviews: Array<TeacherInterviewType>;
  /** Forward-looking load: weekly histogram, hours/week, a load band, and a per-application rollup. Counts FUTURE lessons — `lessonsCount - scheduledLessons` is a planning gap, not remaining work. */
  teacherLoad?: Maybe<TeacherLoadType>;
  /** One teacher's survey feedback: rating trend, per-course and per-group splits, and the named comment feed. */
  teacherSurveyFeedback?: Maybe<TeacherSurveyFeedbackReportType>;
  /** Every teacher with survey feedback, WEAKEST FIRST. Windowed on purpose — Teacher.studentRating is an all-time all-course number and cannot answer «кто слаб на этом курсе в этом квартале». */
  teacherSurveyLeaderboard: Array<TeacherLeaderboardRowType>;
  teachersPageInfo?: Maybe<TeachersPageInfoType>;
  /** Dialogs holding an INBOUND message no manager has ticked «обработано» yet — the amber-dot work queue. Read state and dialog status play no part. */
  unhandledConversations: Array<ConversationType>;
  user?: Maybe<UserNode>;
  users?: Maybe<UserNodeConnection>;
  verifyStudent?: Maybe<VerifiedStudent>;
  verifyTeacher?: Maybe<VerifiedTeacher>;
  whiteboardLibrary?: Maybe<WhiteboardLibraryType>;
  zoomAccountUsage?: Maybe<ZoomAccountUsageType>;
  zoomAuditLog?: Maybe<ZoomAuditLogConnection>;
  zoomDashboard?: Maybe<ZoomDashboardType>;
  zoomLesson?: Maybe<GroupLessonForLmsType>;
};


export type QueryAgreementArgs = {
  agreementId: Scalars['ID'];
};


export type QueryAgreementTasksArgs = {
  agreementId: Scalars['ID'];
  includeClosed?: InputMaybe<Scalars['Boolean']>;
};


export type QueryAllArticlesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryAllCompaniesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
};


export type QueryAllContributionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  contributionNum?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
};


export type QueryAllCountriesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryAllCourseCategoriesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryAllCoursesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  category_Name?: InputMaybe<Scalars['String']>;
  educationForm?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderByPublishDateFilter?: InputMaybe<Scalars['Boolean']>;
  query?: InputMaybe<Scalars['String']>;
  readyToPublish?: InputMaybe<Scalars['Boolean']>;
  startDateFilter?: InputMaybe<Scalars['Boolean']>;
};


export type QueryAllDeferredPaymentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
};


export type QueryAllGroupZoomSchedulesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  groupId?: InputMaybe<Scalars['ID']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  weekDay?: InputMaybe<Scalars['Int']>;
};


export type QueryAllGroupsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  hasZoomAccount?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  zoomAccountId?: InputMaybe<Scalars['ID']>;
};


export type QueryAllGroupsForLmsArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  courseId?: InputMaybe<Scalars['ID']>;
  finished?: InputMaybe<Scalars['Boolean']>;
  first?: InputMaybe<Scalars['Int']>;
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  last?: InputMaybe<Scalars['Int']>;
  lessonDate?: InputMaybe<Scalars['Date']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryAllLessonRecordingsArgs = {
  after?: InputMaybe<Scalars['String']>;
  ambiguousOnly?: InputMaybe<Scalars['Boolean']>;
  before?: InputMaybe<Scalars['String']>;
  courseId?: InputMaybe<Scalars['ID']>;
  dateFrom?: InputMaybe<Scalars['Date']>;
  dateTo?: InputMaybe<Scalars['Date']>;
  first?: InputMaybe<Scalars['Int']>;
  groupId?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
};


export type QueryAllNativesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  excludedNatives?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryAllStoriesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  excludeArticles?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  excludeStories?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  excludedNatives?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  first?: InputMaybe<Scalars['Int']>;
  includeNatives?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryAllStudentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
};


export type QueryAllStudentsAchievementArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
};


export type QueryAllSuccessStoriesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryAllTeachersArgs = {
  after?: InputMaybe<Scalars['String']>;
  availability?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  course?: InputMaybe<Scalars['Decimal']>;
  first?: InputMaybe<Scalars['Int']>;
  hasDescription?: InputMaybe<Scalars['Boolean']>;
  hasInterview?: InputMaybe<Scalars['Boolean']>;
  hasPhoto?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  minRating?: InputMaybe<Scalars['Decimal']>;
  offset?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  siteDisplay?: InputMaybe<Scalars['Boolean']>;
};


export type QueryAllTeachersApplicationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  byGroupId?: InputMaybe<Scalars['Decimal']>;
  first?: InputMaybe<Scalars['Int']>;
  groupsFilter?: InputMaybe<Scalars['Boolean']>;
  isTerminated?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
};


export type QueryAllUsersSettingsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
};


export type QueryAllZoomAccountsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryAllZoomLessonsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  courseId?: InputMaybe<Scalars['ID']>;
  dateFrom: Scalars['Date'];
  dateTo: Scalars['Date'];
  first?: InputMaybe<Scalars['Int']>;
  groupId?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
};


export type QueryAllZoomProcessingLogArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  dateFrom?: InputMaybe<Scalars['Date']>;
  dateTo?: InputMaybe<Scalars['Date']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  lessonId?: InputMaybe<Scalars['ID']>;
  lessonRecordingId?: InputMaybe<Scalars['ID']>;
  level?: InputMaybe<Scalars['String']>;
  step?: InputMaybe<Scalars['String']>;
};


export type QueryAllZoomRecordingsArgs = {
  accountId?: InputMaybe<Scalars['ID']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  dateFrom?: InputMaybe<Scalars['Date']>;
  dateTo?: InputMaybe<Scalars['Date']>;
  first?: InputMaybe<Scalars['Int']>;
  groupId?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  orphanOnly?: InputMaybe<Scalars['Boolean']>;
  showDeleted?: InputMaybe<Scalars['Boolean']>;
  tooShort?: InputMaybe<Scalars['Boolean']>;
};


export type QueryArticleArgs = {
  articleId?: InputMaybe<Scalars['ID']>;
};


export type QueryArticleBySlugArgs = {
  slug: Scalars['String'];
};


export type QueryAttendanceHistoryArgs = {
  attendanceId: Scalars['Int'];
};


export type QueryBankAccountsArgs = {
  includeInactive?: InputMaybe<Scalars['Boolean']>;
};


export type QueryBankStatementImportsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
};


export type QueryBankTransactionArgs = {
  id: Scalars['ID'];
};


export type QueryBankTransactionMatchCandidatesArgs = {
  transactionId: Scalars['ID'];
};


export type QueryBankTransactionsArgs = {
  accountIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  categorySlugs?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  categorySource?: InputMaybe<Scalars['String']>;
  dateFrom?: InputMaybe<Scalars['Date']>;
  dateTo?: InputMaybe<Scalars['Date']>;
  direction?: InputMaybe<Scalars['String']>;
  isInternalTransfer?: InputMaybe<Scalars['Boolean']>;
  needsReview?: InputMaybe<Scalars['Boolean']>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  uncategorisedOnly?: InputMaybe<Scalars['Boolean']>;
};


export type QueryBroadcastJobArgs = {
  id: Scalars['ID'];
};


export type QueryCareerApplicationsErpArgs = {
  memberId?: InputMaybe<Scalars['ID']>;
  status?: InputMaybe<Scalars['String']>;
  studentId?: InputMaybe<Scalars['ID']>;
};


export type QueryCareerCitiesArgs = {
  search?: InputMaybe<Scalars['String']>;
};


export type QueryCareerCourseSkillsArgs = {
  courseId?: InputMaybe<Scalars['ID']>;
};


export type QueryCareerDirectionsArgs = {
  includeInactive?: InputMaybe<Scalars['Boolean']>;
};


export type QueryCareerExerciseTemplatesArgs = {
  includeHidden?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryCareerGroupRosterArgs = {
  groupId?: InputMaybe<Scalars['ID']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryCareerGroupSkillsArgs = {
  groupId: Scalars['ID'];
};


export type QueryCareerLessonArgs = {
  id: Scalars['ID'];
};


export type QueryCareerMemberDetailArgs = {
  id: Scalars['ID'];
};


export type QueryCareerMemberProgressArgs = {
  memberId: Scalars['ID'];
};


export type QueryCareerMembersArgs = {
  directionId?: InputMaybe<Scalars['ID']>;
  search?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
};


export type QueryCareerPromoCampaignsArgs = {
  includeInactive?: InputMaybe<Scalars['Boolean']>;
};


export type QueryCareerPromoCodesArgs = {
  campaignId?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
};


export type QueryCareerSiteCoursesArgs = {
  includeHidden?: InputMaybe<Scalars['Boolean']>;
};


export type QueryCareerSkillDetailArgs = {
  slug: Scalars['String'];
};


export type QueryCareerSkillsArgs = {
  category?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryCareerSkillsErpArgs = {
  category?: InputMaybe<Scalars['String']>;
  includeInactive?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  withStats?: InputMaybe<Scalars['Boolean']>;
};


export type QueryCareerStudentCompletionsArgs = {
  studentId: Scalars['ID'];
};


export type QueryCareerVacanciesArgs = {
  directionId?: InputMaybe<Scalars['ID']>;
  savedOnly?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  seniority?: InputMaybe<Scalars['String']>;
  skillId?: InputMaybe<Scalars['ID']>;
  workMode?: InputMaybe<Scalars['String']>;
};


export type QueryCareerVacanciesErpArgs = {
  applyUrl?: InputMaybe<Scalars['String']>;
  createdFrom?: InputMaybe<Scalars['Date']>;
  createdTo?: InputMaybe<Scalars['Date']>;
  directionId?: InputMaybe<Scalars['ID']>;
  freshness?: InputMaybe<Scalars['String']>;
  hideArchived?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  skillIds?: InputMaybe<Array<Scalars['ID']>>;
  status?: InputMaybe<Scalars['String']>;
};


export type QueryCareerVacancyArgs = {
  id: Scalars['ID'];
};


export type QueryCareerVacancyBoardArgs = {
  after?: InputMaybe<Scalars['String']>;
  applyUrl?: InputMaybe<Scalars['String']>;
  createdFrom?: InputMaybe<Scalars['Date']>;
  createdTo?: InputMaybe<Scalars['Date']>;
  directionId?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  freshness?: InputMaybe<Scalars['String']>;
  hasDuplicates?: InputMaybe<Scalars['Boolean']>;
  hideArchived?: InputMaybe<Scalars['Boolean']>;
  orderBy?: InputMaybe<Scalars['String']>;
  orderDir?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  skillIds?: InputMaybe<Array<Scalars['ID']>>;
  source?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
};


export type QueryCareerVacancyErpArgs = {
  id: Scalars['ID'];
};


export type QueryCareerVacancyFeedArgs = {
  after?: InputMaybe<Scalars['String']>;
  cityId?: InputMaybe<Scalars['ID']>;
  directionId?: InputMaybe<Scalars['ID']>;
  employmentType?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  freshness?: InputMaybe<Scalars['String']>;
  matchMode?: InputMaybe<Scalars['String']>;
  salaryFrom?: InputMaybe<Scalars['Int']>;
  savedOnly?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  seniority?: InputMaybe<Scalars['String']>;
  skillIds?: InputMaybe<Array<Scalars['ID']>>;
  sort?: InputMaybe<Scalars['String']>;
  trackCode?: InputMaybe<Scalars['String']>;
  workMode?: InputMaybe<Scalars['String']>;
};


export type QueryCashBalancesArgs = {
  legalEntityId?: InputMaybe<Scalars['ID']>;
};


export type QueryCashFlowCategoriesArgs = {
  includeInactive?: InputMaybe<Scalars['Boolean']>;
};


export type QueryCashFlowReportArgs = {
  accountIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  dateFrom?: InputMaybe<Scalars['Date']>;
  dateTo?: InputMaybe<Scalars['Date']>;
  grain?: InputMaybe<Scalars['String']>;
  includeInternal?: InputMaybe<Scalars['Boolean']>;
  legalEntityId?: InputMaybe<Scalars['ID']>;
};


export type QueryCashFlowRulesArgs = {
  health?: InputMaybe<Scalars['String']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  needsAttention?: InputMaybe<Scalars['Boolean']>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
};


export type QueryChannelGroupLinkArgs = {
  groupId: Scalars['ID'];
};


export type QueryCompanyArgs = {
  id: Scalars['ID'];
};


export type QueryConversationThreadArgs = {
  after?: InputMaybe<Scalars['String']>;
  conversationId: Scalars['ID'];
  first?: InputMaybe<Scalars['Int']>;
};


export type QueryConversationsBrowserArgs = {
  after?: InputMaybe<Scalars['String']>;
  dateFrom?: InputMaybe<Scalars['Date']>;
  dateTo?: InputMaybe<Scalars['Date']>;
  first?: InputMaybe<Scalars['Int']>;
  groupId?: InputMaybe<Scalars['ID']>;
  kinds?: InputMaybe<Array<Scalars['String']>>;
  search?: InputMaybe<Scalars['String']>;
  studentId?: InputMaybe<Scalars['ID']>;
  unhandledOnly?: InputMaybe<Scalars['Boolean']>;
};


export type QueryCourseArgs = {
  courseId?: InputMaybe<Scalars['ID']>;
};


export type QueryCourseBySlugArgs = {
  slug: Scalars['String'];
};


export type QueryCourseProgramFrameArgs = {
  courseId: Scalars['ID'];
};


export type QueryCourseProgramLessonsArgs = {
  courseId: Scalars['ID'];
};


export type QueryCoursesGraduateFeedbackArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryDebtorCandidatesArgs = {
  groupId?: InputMaybe<Scalars['ID']>;
};


export type QueryDiplomaDownloadUrlArgs = {
  diplomaId: Scalars['ID'];
};


export type QueryDocumentCashFlowArgs = {
  targetId: Scalars['ID'];
  targetType: Scalars['String'];
};


export type QueryExchangeRatesArgs = {
  currency?: InputMaybe<Scalars['String']>;
};


export type QueryExpenseArgs = {
  id: Scalars['ID'];
};


export type QueryExpenseAggregatesArgs = {
  dateFrom?: InputMaybe<Scalars['Date']>;
  dateTo?: InputMaybe<Scalars['Date']>;
  groupBy?: InputMaybe<Scalars['String']>;
  teacherId?: InputMaybe<Scalars['ID']>;
};


export type QueryExpensesArgs = {
  categorySlug?: InputMaybe<Scalars['String']>;
  dateFrom?: InputMaybe<Scalars['Date']>;
  dateTo?: InputMaybe<Scalars['Date']>;
  groupId?: InputMaybe<Scalars['ID']>;
  legalEntityId?: InputMaybe<Scalars['ID']>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  recurrence?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  studentId?: InputMaybe<Scalars['ID']>;
  teacherId?: InputMaybe<Scalars['ID']>;
};


export type QueryFakturowniaBillingJobArgs = {
  id: Scalars['ID'];
};


export type QueryFakturowniaContributionBillabilityArgs = {
  agreementId: Scalars['ID'];
  contributionId?: InputMaybe<Scalars['ID']>;
};


export type QueryFakturowniaGroupBillingPreviewArgs = {
  groupId: Scalars['ID'];
};


export type QueryFakturowniaInvoiceArgs = {
  id: Scalars['ID'];
};


export type QueryFakturowniaInvoiceAggregatesArgs = {
  dateFrom?: InputMaybe<Scalars['Date']>;
  dateTo?: InputMaybe<Scalars['Date']>;
  direction?: InputMaybe<Scalars['String']>;
  groupBy: Scalars['String'];
  groupId?: InputMaybe<Scalars['ID']>;
  includeQuotations?: InputMaybe<Scalars['Boolean']>;
  studentId?: InputMaybe<Scalars['ID']>;
};


export type QueryFakturowniaInvoicesArgs = {
  agreementId?: InputMaybe<Scalars['ID']>;
  dateFrom?: InputMaybe<Scalars['Date']>;
  dateTo?: InputMaybe<Scalars['Date']>;
  direction?: InputMaybe<Scalars['String']>;
  groupId?: InputMaybe<Scalars['ID']>;
  kind?: InputMaybe<Scalars['String']>;
  matchStatus?: InputMaybe<Scalars['String']>;
  needsLinkOnly?: InputMaybe<Scalars['Boolean']>;
  overdueOnly?: InputMaybe<Scalars['Boolean']>;
  page?: InputMaybe<Scalars['Int']>;
  parentId?: InputMaybe<Scalars['ID']>;
  paymentId?: InputMaybe<Scalars['ID']>;
  perPage?: InputMaybe<Scalars['Int']>;
  provisionBlockedOnly?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  studentId?: InputMaybe<Scalars['ID']>;
  unpaidOnly?: InputMaybe<Scalars['Boolean']>;
};


export type QueryFakturowniaSyncRunsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
};


export type QueryFinanceBudgetArgs = {
  year: Scalars['Int'];
};


export type QueryFinanceMonthBudgetArgs = {
  month: Scalars['Int'];
  year: Scalars['Int'];
};


export type QueryFinancePlanArgs = {
  year: Scalars['Int'];
};


export type QueryFundingBoardArgs = {
  assignedToId?: InputMaybe<Scalars['ID']>;
  employmentStatus?: InputMaybe<Scalars['String']>;
  includeArchived?: InputMaybe<Scalars['Boolean']>;
  isDeposit?: InputMaybe<Scalars['Boolean']>;
  isStudent?: InputMaybe<Scalars['Boolean']>;
  legalEntityId?: InputMaybe<Scalars['ID']>;
  matchStatus?: InputMaybe<Scalars['String']>;
  needsOperatorReview?: InputMaybe<Scalars['Boolean']>;
  operatorId?: InputMaybe<Scalars['ID']>;
  operatorMatch?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  voivodeshipId?: InputMaybe<Scalars['ID']>;
};


export type QueryFundingCandidateArgs = {
  id: Scalars['ID'];
};


export type QueryFundingCandidateForUserArgs = {
  studentId?: InputMaybe<Scalars['ID']>;
  userId?: InputMaybe<Scalars['ID']>;
};


export type QueryFundingCandidateStatsArgs = {
  dimension: Scalars['String'];
  employmentStatus?: InputMaybe<Scalars['String']>;
  includeArchived?: InputMaybe<Scalars['Boolean']>;
  isDeposit?: InputMaybe<Scalars['Boolean']>;
  isStudent?: InputMaybe<Scalars['Boolean']>;
  matchStatus?: InputMaybe<Scalars['String']>;
  operatorId?: InputMaybe<Scalars['ID']>;
  search?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  statusGroup?: InputMaybe<Scalars['String']>;
  voivodeshipId?: InputMaybe<Scalars['ID']>;
};


export type QueryFundingCandidatesArgs = {
  assignedToId?: InputMaybe<Scalars['ID']>;
  employmentStatus?: InputMaybe<Scalars['String']>;
  includeArchived?: InputMaybe<Scalars['Boolean']>;
  isDeposit?: InputMaybe<Scalars['Boolean']>;
  isStudent?: InputMaybe<Scalars['Boolean']>;
  legalEntityId?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  matchStatus?: InputMaybe<Scalars['String']>;
  needsOperatorReview?: InputMaybe<Scalars['Boolean']>;
  offset?: InputMaybe<Scalars['Int']>;
  operatorId?: InputMaybe<Scalars['ID']>;
  operatorMatch?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  statusGroup?: InputMaybe<Scalars['String']>;
  voivodeshipId?: InputMaybe<Scalars['ID']>;
};


export type QueryFundingCandidatesForUserArgs = {
  studentId?: InputMaybe<Scalars['ID']>;
  userId?: InputMaybe<Scalars['ID']>;
};


export type QueryFundingCandidatesTotalArgs = {
  assignedToId?: InputMaybe<Scalars['ID']>;
  employmentStatus?: InputMaybe<Scalars['String']>;
  includeArchived?: InputMaybe<Scalars['Boolean']>;
  isDeposit?: InputMaybe<Scalars['Boolean']>;
  isStudent?: InputMaybe<Scalars['Boolean']>;
  legalEntityId?: InputMaybe<Scalars['ID']>;
  matchStatus?: InputMaybe<Scalars['String']>;
  needsOperatorReview?: InputMaybe<Scalars['Boolean']>;
  operatorId?: InputMaybe<Scalars['ID']>;
  operatorMatch?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  statusGroup?: InputMaybe<Scalars['String']>;
  voivodeshipId?: InputMaybe<Scalars['ID']>;
};


export type QueryFundingFormSubmissionArgs = {
  id: Scalars['ID'];
};


export type QueryFundingFormSubmissionsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  submittedFrom?: InputMaybe<Scalars['Date']>;
  submittedTo?: InputMaybe<Scalars['Date']>;
};


export type QueryFundingFormSubmissionsTotalArgs = {
  search?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  submittedFrom?: InputMaybe<Scalars['Date']>;
  submittedTo?: InputMaybe<Scalars['Date']>;
};


export type QueryFundingGeoAliasesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
};


export type QueryFundingImportRunArgs = {
  id: Scalars['ID'];
};


export type QueryFundingImportRunsArgs = {
  dryRun?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
  taskName?: InputMaybe<Scalars['String']>;
  triggerSource?: InputMaybe<Scalars['String']>;
};


export type QueryFundingImportRunsTotalArgs = {
  dryRun?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<Scalars['String']>;
  taskName?: InputMaybe<Scalars['String']>;
  triggerSource?: InputMaybe<Scalars['String']>;
};


export type QueryFundingIntakeArgs = {
  id: Scalars['ID'];
};


export type QueryFundingIntakesArgs = {
  confirmation?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  operatorId?: InputMaybe<Scalars['ID']>;
  phase?: InputMaybe<Array<Scalars['String']>>;
  search?: InputMaybe<Scalars['String']>;
  startsFrom?: InputMaybe<Scalars['Date']>;
  startsTo?: InputMaybe<Scalars['Date']>;
};


export type QueryFundingIntakesTotalArgs = {
  confirmation?: InputMaybe<Scalars['String']>;
  operatorId?: InputMaybe<Scalars['ID']>;
  phase?: InputMaybe<Array<Scalars['String']>>;
  search?: InputMaybe<Scalars['String']>;
  startsFrom?: InputMaybe<Scalars['Date']>;
  startsTo?: InputMaybe<Scalars['Date']>;
};


export type QueryFundingNotificationsArgs = {
  candidateId?: InputMaybe<Scalars['ID']>;
  dateFrom?: InputMaybe<Scalars['Date']>;
  dateTo?: InputMaybe<Scalars['Date']>;
  deliveryState?: InputMaybe<Scalars['String']>;
  intakeId?: InputMaybe<Scalars['ID']>;
  kind?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  operatorId?: InputMaybe<Scalars['ID']>;
  search?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
};


export type QueryFundingNotificationsTotalArgs = {
  candidateId?: InputMaybe<Scalars['ID']>;
  dateFrom?: InputMaybe<Scalars['Date']>;
  dateTo?: InputMaybe<Scalars['Date']>;
  deliveryState?: InputMaybe<Scalars['String']>;
  intakeId?: InputMaybe<Scalars['ID']>;
  kind?: InputMaybe<Scalars['String']>;
  operatorId?: InputMaybe<Scalars['ID']>;
  search?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
};


export type QueryFundingOperatorArgs = {
  id: Scalars['ID'];
};


export type QueryFundingOperatorsArgs = {
  clientType?: InputMaybe<Scalars['String']>;
  intakeConfirmation?: InputMaybe<Scalars['String']>;
  intakePeriod?: InputMaybe<Scalars['String']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  pageChanged?: InputMaybe<Scalars['Boolean']>;
  pageSegment?: InputMaybe<Scalars['String']>;
  paymentMethod?: InputMaybe<Scalars['String']>;
  powiatId?: InputMaybe<Scalars['ID']>;
  programType?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  urlSuspect?: InputMaybe<Scalars['Boolean']>;
  voivodeshipId?: InputMaybe<Scalars['ID']>;
};


export type QueryFundingOperatorsTotalArgs = {
  clientType?: InputMaybe<Scalars['String']>;
  intakeConfirmation?: InputMaybe<Scalars['String']>;
  intakePeriod?: InputMaybe<Scalars['String']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  pageChanged?: InputMaybe<Scalars['Boolean']>;
  pageSegment?: InputMaybe<Scalars['String']>;
  paymentMethod?: InputMaybe<Scalars['String']>;
  powiatId?: InputMaybe<Scalars['ID']>;
  programType?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  urlSuspect?: InputMaybe<Scalars['Boolean']>;
  voivodeshipId?: InputMaybe<Scalars['ID']>;
};


export type QueryFundingPowiatsArgs = {
  search?: InputMaybe<Scalars['String']>;
  voivodeshipId?: InputMaybe<Scalars['ID']>;
};


export type QueryFundingSubmissionStatesArgs = {
  search?: InputMaybe<Scalars['String']>;
  submittedFrom?: InputMaybe<Scalars['Date']>;
  submittedTo?: InputMaybe<Scalars['Date']>;
};


export type QueryGatewaySettlementArgs = {
  id: Scalars['ID'];
};


export type QueryGatewaySettlementCandidatesArgs = {
  settlementId: Scalars['ID'];
};


export type QueryGatewaySettlementsArgs = {
  dateFrom?: InputMaybe<Scalars['Date']>;
  dateTo?: InputMaybe<Scalars['Date']>;
  provider?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
};


export type QueryGroupArgs = {
  groupId?: InputMaybe<Scalars['ID']>;
};


export type QueryGroupAttendanceSummaryArgs = {
  groupId: Scalars['ID'];
};


export type QueryGroupCommsIndexArgs = {
  groupId: Scalars['ID'];
};


export type QueryGroupConversationsArgs = {
  groupId: Scalars['ID'];
};


export type QueryGroupConversationsPageArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  groupId: Scalars['ID'];
  kinds?: InputMaybe<Array<Scalars['String']>>;
};


export type QueryGroupDiplomasArgs = {
  groupId: Scalars['ID'];
};


export type QueryGroupForLmsArgs = {
  groupId?: InputMaybe<Scalars['ID']>;
};


export type QueryGroupHomeworkMarksForErpArgs = {
  groupId: Scalars['ID'];
};


export type QueryGroupHomeworkOverviewForErpArgs = {
  groupId: Scalars['ID'];
};


export type QueryGroupLessonAttachmentArgs = {
  attachmentId?: InputMaybe<Scalars['ID']>;
  attachmentRole?: InputMaybe<Scalars['String']>;
};


export type QueryGroupLessonAttachmentForLmsArgs = {
  attachmentRole?: InputMaybe<Scalars['String']>;
  groupLessonId?: InputMaybe<Scalars['ID']>;
};


export type QueryGroupLessonAttendanceForLmsArgs = {
  groupLessonId?: InputMaybe<Scalars['ID']>;
};


export type QueryGroupMailCandidatesArgs = {
  groupId: Scalars['ID'];
  includeTerminated?: InputMaybe<Scalars['Boolean']>;
  mode?: InputMaybe<Scalars['String']>;
};


export type QueryGroupMessagesArgs = {
  after?: InputMaybe<Scalars['String']>;
  channelId?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  flaggedOnly?: InputMaybe<Scalars['Boolean']>;
  groupId: Scalars['ID'];
  search?: InputMaybe<Scalars['String']>;
  unhandledOnly?: InputMaybe<Scalars['Boolean']>;
  unreadOnly?: InputMaybe<Scalars['Boolean']>;
};


export type QueryGroupNotesArgs = {
  groupId: Scalars['ID'];
};


export type QueryGroupPerformanceSummaryArgs = {
  groupId: Scalars['ID'];
};


export type QueryGroupProgramLessonsArgs = {
  groupId: Scalars['ID'];
};


export type QueryGroupRevenueAggregatesArgs = {
  groupId: Scalars['ID'];
};


export type QueryGroupSlackChannelsArgs = {
  groupId: Scalars['ID'];
};


export type QueryGroupSurveyAssignmentsArgs = {
  groupId: Scalars['ID'];
};


export type QueryGroupTasksArgs = {
  groupId: Scalars['ID'];
  includeClosed?: InputMaybe<Scalars['Boolean']>;
};


export type QueryGroupWhiteboardsArgs = {
  groupId: Scalars['ID'];
};


export type QueryGroupsOverviewArgs = {
  activeWithinDays?: InputMaybe<Scalars['Int']>;
  onlyIssues?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryHomeworkRosterArgs = {
  lessonId: Scalars['ID'];
};


export type QueryHomeworkSubmissionDownloadUrlArgs = {
  submissionId: Scalars['ID'];
};


export type QueryHomeworkSubmissionDownloadUrlForErpArgs = {
  submissionId: Scalars['ID'];
};


export type QueryInterviewZoomCandidatesArgs = {
  accountId?: InputMaybe<Scalars['ID']>;
  dateFrom?: InputMaybe<Scalars['Date']>;
  dateTo?: InputMaybe<Scalars['Date']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryJournalArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  groupId: Scalars['ID'];
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryLessonForLmsArgs = {
  groupLessonId?: InputMaybe<Scalars['ID']>;
};


export type QueryLessonHomeworkArgs = {
  lessonId: Scalars['ID'];
};


export type QueryLessonHomeworkSubmissionsForErpArgs = {
  lessonId: Scalars['ID'];
};


export type QueryLessonJoinClicksArgs = {
  lessonId: Scalars['Int'];
};


export type QueryLessonTextbookFilesArgs = {
  lessonId: Scalars['ID'];
};


export type QueryLessonWhiteboardArgs = {
  lessonId: Scalars['ID'];
};


export type QueryLessonWhiteboardForErpArgs = {
  lessonId: Scalars['ID'];
};


export type QueryLmsAttendanceHistoryArgs = {
  attendanceId: Scalars['Int'];
};


export type QueryLmsBlockTemplateExampleArgs = {
  kind: Scalars['String'];
};


export type QueryLmsJournalArgs = {
  groupLessonId: Scalars['ID'];
};


export type QueryLmsLessonJoinClicksArgs = {
  groupLessonId: Scalars['Int'];
};


export type QueryLmsSuspensionsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
};


export type QueryMailJobArgs = {
  id: Scalars['ID'];
};


export type QueryMailJobsArgs = {
  groupId: Scalars['ID'];
  limit?: InputMaybe<Scalars['Int']>;
};


export type QueryMaterialsArgs = {
  groupId: Scalars['ID'];
  kind?: InputMaybe<MaterialKindEnum>;
  lessonId?: InputMaybe<Scalars['ID']>;
};


export type QueryMetaContributionsArgs = {
  contributionNum?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
};


export type QueryMetaCoursesArgs = {
  query?: InputMaybe<Scalars['String']>;
};


export type QueryMetaDeferredPaymentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryMetaGroupsArgs = {
  query?: InputMaybe<Scalars['String']>;
};


export type QueryMetaStudentsArgs = {
  query?: InputMaybe<Scalars['String']>;
};


export type QueryMetaTeachersArgs = {
  query?: InputMaybe<Scalars['String']>;
};


export type QueryMetaTeachersApplicationsArgs = {
  query?: InputMaybe<Scalars['String']>;
};


export type QueryMetaUsersSettingsArgs = {
  query?: InputMaybe<Scalars['String']>;
};


export type QueryMyAttendanceArgs = {
  groupId: Scalars['ID'];
};


export type QueryMyCareerApplicationsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
};


export type QueryMyCareerSkillGraphArgs = {
  trackCode?: InputMaybe<Scalars['String']>;
};


export type QueryMyDiplomaDownloadUrlArgs = {
  diplomaId: Scalars['ID'];
};


export type QueryMyLessonHomeworkArgs = {
  lessonId: Scalars['ID'];
};


export type QueryMyShareOptionsArgs = {
  language?: InputMaybe<Scalars['String']>;
};


export type QueryMySlackUserTokenArgs = {
  groupId: Scalars['ID'];
};


export type QueryMyTasksArgs = {
  includeClosed?: InputMaybe<Scalars['Boolean']>;
};


export type QueryNativeArgs = {
  nativeId?: InputMaybe<Scalars['ID']>;
};


export type QueryNativeBySlugArgs = {
  slug: Scalars['String'];
};


export type QueryOperatorsForCandidateArgs = {
  candidateId: Scalars['ID'];
};


export type QueryPandadocAnalyticsArgs = {
  course?: InputMaybe<Scalars['String']>;
  dateFrom?: InputMaybe<Scalars['Date']>;
  dateTo?: InputMaybe<Scalars['Date']>;
  docType?: InputMaybe<Scalars['String']>;
  granularity?: InputMaybe<Scalars['String']>;
};


export type QueryPandadocDocumentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  agreementId?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['String']>;
  course?: InputMaybe<Scalars['String']>;
  dateFrom?: InputMaybe<Scalars['Date']>;
  dateTo?: InputMaybe<Scalars['Date']>;
  docType?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  groupId?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  outcome?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  studentId?: InputMaybe<Scalars['ID']>;
  studentMatches?: InputMaybe<Scalars['Boolean']>;
  teacherId?: InputMaybe<Scalars['ID']>;
  teacherMatches?: InputMaybe<Scalars['Boolean']>;
  unlinked?: InputMaybe<Scalars['Boolean']>;
};


export type QueryPandadocProvisioningFoldersArgs = {
  course?: InputMaybe<Scalars['String']>;
};


export type QueryPaymentCalendarArgs = {
  dateFrom: Scalars['Date'];
  dateTo: Scalars['Date'];
  legalEntityId?: InputMaybe<Scalars['ID']>;
};


export type QueryPaymentCalendarSettingsArgs = {
  legalEntityId?: InputMaybe<Scalars['ID']>;
};


export type QueryPaymentsVerificationArgs = {
  query: Array<InputMaybe<Scalars['String']>>;
};


export type QueryPlannedPaymentsArgs = {
  dateFrom?: InputMaybe<Scalars['Date']>;
  dateTo?: InputMaybe<Scalars['Date']>;
  direction?: InputMaybe<Scalars['String']>;
  kind?: InputMaybe<Scalars['String']>;
  legalEntityId?: InputMaybe<Scalars['ID']>;
};


export type QueryPnlExportFileArgs = {
  id: Scalars['ID'];
};


export type QueryPnlExportRunsArgs = {
  groupId?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
};


export type QueryPublicFundingPowiatsArgs = {
  voivodeshipId?: InputMaybe<Scalars['ID']>;
};


export type QueryReceivedInvoicesForExpenseArgs = {
  dateFrom?: InputMaybe<Scalars['Date']>;
  dateTo?: InputMaybe<Scalars['Date']>;
  unlinkedOnly?: InputMaybe<Scalars['Boolean']>;
};


export type QueryRecentlyMatchedLessonRecordingsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  mine?: InputMaybe<Scalars['Boolean']>;
};


export type QueryReplyIdentityArgs = {
  conversationId: Scalars['ID'];
};


export type QuerySendgridGroupListArgs = {
  groupId: Scalars['ID'];
};


export type QuerySlackUserLinkArgs = {
  studentId: Scalars['ID'];
};


export type QuerySlackWorkspaceLinkArgs = {
  groupId: Scalars['ID'];
};


export type QuerySlackWorkspaceMembersArgs = {
  groupId: Scalars['ID'];
  unmatchedOnly?: InputMaybe<Scalars['Boolean']>;
};


export type QueryStaffNotificationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  kinds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  maxAgeDays?: InputMaybe<Scalars['Int']>;
  unreadOnly?: InputMaybe<Scalars['Boolean']>;
};


export type QueryStaffNotificationsSummaryArgs = {
  kinds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  maxAgeDays?: InputMaybe<Scalars['Int']>;
};


export type QueryStaffTaskArgs = {
  id: Scalars['ID'];
};


export type QueryStaffTaskAttachmentUrlArgs = {
  attachmentId: Scalars['ID'];
};


export type QueryStaffTasksArgs = {
  agreementId?: InputMaybe<Scalars['ID']>;
  assigneeIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  assigneeMe?: InputMaybe<Scalars['Boolean']>;
  closedWithinDays?: InputMaybe<Scalars['Int']>;
  dueFrom?: InputMaybe<Scalars['Date']>;
  dueTo?: InputMaybe<Scalars['Date']>;
  groupId?: InputMaybe<Scalars['ID']>;
  includeClosed?: InputMaybe<Scalars['Boolean']>;
  links?: InputMaybe<Array<InputMaybe<TaskLinkInput>>>;
  priorities?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  search?: InputMaybe<Scalars['String']>;
  statuses?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  studentId?: InputMaybe<Scalars['ID']>;
  teacherId?: InputMaybe<Scalars['ID']>;
};


export type QueryStaffTasksSummaryArgs = {
  agreementId?: InputMaybe<Scalars['ID']>;
  assigneeIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  assigneeMe?: InputMaybe<Scalars['Boolean']>;
  closedWithinDays?: InputMaybe<Scalars['Int']>;
  dueFrom?: InputMaybe<Scalars['Date']>;
  dueTo?: InputMaybe<Scalars['Date']>;
  groupId?: InputMaybe<Scalars['ID']>;
  includeClosed?: InputMaybe<Scalars['Boolean']>;
  links?: InputMaybe<Array<InputMaybe<TaskLinkInput>>>;
  priorities?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  search?: InputMaybe<Scalars['String']>;
  statuses?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  studentId?: InputMaybe<Scalars['ID']>;
  teacherId?: InputMaybe<Scalars['ID']>;
};


export type QueryStudentArgs = {
  id: Scalars['ID'];
};


export type QueryStudentAccessBlockArgs = {
  studentId: Scalars['ID'];
};


export type QueryStudentAccessBlockEventsArgs = {
  studentId: Scalars['ID'];
};


export type QueryStudentConversationsArgs = {
  studentId: Scalars['ID'];
};


export type QueryStudentConversationsPageArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  kinds?: InputMaybe<Array<Scalars['String']>>;
  studentId: Scalars['ID'];
};


export type QueryStudentHomeworkForErpArgs = {
  studentId: Scalars['ID'];
};


export type QueryStudentMarksArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  lessonsId: Scalars['ID'];
};


export type QueryStudentMiniCardArgs = {
  studentId: Scalars['ID'];
};


export type QueryStudentNotesArgs = {
  studentId: Scalars['ID'];
};


export type QueryStudentSurveyResponsesArgs = {
  groupId?: InputMaybe<Scalars['ID']>;
  includePending?: InputMaybe<Scalars['Boolean']>;
  studentId: Scalars['ID'];
  surveyId?: InputMaybe<Scalars['ID']>;
};


export type QueryStudentTasksArgs = {
  includeClosed?: InputMaybe<Scalars['Boolean']>;
  studentId: Scalars['ID'];
};


export type QueryStudentsForJournalArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  groupId: Scalars['Int'];
  last?: InputMaybe<Scalars['Int']>;
  lessonsId: Array<InputMaybe<Scalars['Int']>>;
};


export type QueryStudentsMarksArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  lessonsId: Scalars['ID'];
};


export type QuerySuccessStoryArgs = {
  storyId?: InputMaybe<Scalars['ID']>;
};


export type QuerySuccessStoryBySlugArgs = {
  slug: Scalars['String'];
};


export type QuerySurveyArgs = {
  id: Scalars['ID'];
};


export type QuerySurveyAnalyticsArgs = {
  dimension: Scalars['String'];
  filter?: InputMaybe<SurveyAnalyticsFilter>;
};


export type QuerySurveyAssignmentResultsArgs = {
  assignmentId: Scalars['ID'];
};


export type QuerySurveyAssignmentsArgs = {
  groupIds?: InputMaybe<Array<Scalars['ID']>>;
  onlyActive?: InputMaybe<Scalars['Boolean']>;
  origin?: InputMaybe<Scalars['String']>;
  planId?: InputMaybe<Scalars['ID']>;
  search?: InputMaybe<Scalars['String']>;
  surveyId: Scalars['ID'];
};


export type QuerySurveyCommentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SurveyAnalyticsFilter>;
  first?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sentiment?: InputMaybe<Scalars['String']>;
};


export type QuerySurveyQuestionBreakdownArgs = {
  dimension: Scalars['String'];
  filter?: InputMaybe<SurveyAnalyticsFilter>;
  questionId: Scalars['ID'];
  surveyId: Scalars['ID'];
};


export type QuerySurveyQuestionTagsArgs = {
  courseId?: InputMaybe<Scalars['ID']>;
  onlyUntagged?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QuerySurveyResponseDetailArgs = {
  responseId: Scalars['ID'];
};


export type QuerySurveyResponseMatrixArgs = {
  groupIds?: InputMaybe<Array<Scalars['ID']>>;
  surveyId: Scalars['ID'];
};


export type QuerySurveySignalsArgs = {
  dimensions?: InputMaybe<Array<Scalars['String']>>;
  filter?: InputMaybe<SurveyAnalyticsFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  minSample?: InputMaybe<Scalars['Int']>;
};


export type QuerySurveySummaryArgs = {
  dateFrom?: InputMaybe<Scalars['Date']>;
  dateTo?: InputMaybe<Scalars['Date']>;
  groupIds?: InputMaybe<Array<Scalars['ID']>>;
  planId?: InputMaybe<Scalars['ID']>;
  surveyId: Scalars['ID'];
};


export type QuerySurveyTargetGroupsArgs = {
  courseId?: InputMaybe<Scalars['ID']>;
  onlyActive?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  surveyId?: InputMaybe<Scalars['ID']>;
  triggerKind?: InputMaybe<Scalars['String']>;
  triggerLessonNumber?: InputMaybe<Scalars['Int']>;
};


export type QuerySurveyTargetingArgs = {
  surveyId: Scalars['ID'];
};


export type QuerySurveysArgs = {
  courseId?: InputMaybe<Scalars['ID']>;
  includeArchived?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryTaskLinkSearchArgs = {
  kind: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
};


export type QueryTeacherArgs = {
  teacherId?: InputMaybe<Scalars['ID']>;
};


export type QueryTeacherAiProfileArgs = {
  teacherId: Scalars['ID'];
};


export type QueryTeacherApplicationArgs = {
  applicationId: Scalars['ID'];
};


export type QueryTeacherCandidateGroupsArgs = {
  teacherId: Scalars['ID'];
};


export type QueryTeacherConversationsArgs = {
  teacherId: Scalars['ID'];
};


export type QueryTeacherConversationsPageArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  kinds?: InputMaybe<Array<Scalars['String']>>;
  teacherId: Scalars['ID'];
};


export type QueryTeacherDocumentDownloadUrlArgs = {
  documentId: Scalars['ID'];
};


export type QueryTeacherDocumentTextArgs = {
  documentId: Scalars['ID'];
};


export type QueryTeacherDocumentsArgs = {
  kind?: InputMaybe<Scalars['String']>;
  teacherId: Scalars['ID'];
};


export type QueryTeacherInterviewTranscriptArgs = {
  interviewId: Scalars['ID'];
};


export type QueryTeacherInterviewVideoUrlArgs = {
  interviewId: Scalars['ID'];
};


export type QueryTeacherInterviewsArgs = {
  teacherId: Scalars['ID'];
};


export type QueryTeacherLoadArgs = {
  horizonDays?: InputMaybe<Scalars['Int']>;
  teacherId: Scalars['ID'];
};


export type QueryTeacherSurveyFeedbackArgs = {
  bucket?: InputMaybe<Scalars['String']>;
  courseId?: InputMaybe<Scalars['ID']>;
  dateFrom?: InputMaybe<Scalars['Date']>;
  dateTo?: InputMaybe<Scalars['Date']>;
  groupId?: InputMaybe<Scalars['ID']>;
  teacherId: Scalars['ID'];
};


export type QueryTeacherSurveyLeaderboardArgs = {
  courseId?: InputMaybe<Scalars['ID']>;
  dateFrom?: InputMaybe<Scalars['Date']>;
  dateTo?: InputMaybe<Scalars['Date']>;
  minResponses?: InputMaybe<Scalars['Int']>;
};


export type QueryUserArgs = {
  id: Scalars['ID'];
};


export type QueryUsersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  email_Icontains?: InputMaybe<Scalars['String']>;
  email_Istartswith?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  firstName?: InputMaybe<Scalars['String']>;
  firstName_Icontains?: InputMaybe<Scalars['String']>;
  firstName_Istartswith?: InputMaybe<Scalars['String']>;
  last?: InputMaybe<Scalars['Int']>;
  lastName?: InputMaybe<Scalars['String']>;
  lastName_Icontains?: InputMaybe<Scalars['String']>;
  lastName_Istartswith?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  phone?: InputMaybe<Scalars['String']>;
  phone_Icontains?: InputMaybe<Scalars['String']>;
  phone_Istartswith?: InputMaybe<Scalars['String']>;
};


export type QueryVerifyStudentArgs = {
  email: Scalars['String'];
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  middleName?: InputMaybe<Scalars['String']>;
  phone: Scalars['String'];
};


export type QueryVerifyTeacherArgs = {
  teacherInput: BaseTeacherInput;
};


export type QueryZoomAuditLogArgs = {
  action?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  dateFrom?: InputMaybe<Scalars['Date']>;
  dateTo?: InputMaybe<Scalars['Date']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  targetKind?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['ID']>;
};


export type QueryZoomDashboardArgs = {
  dateFrom: Scalars['Date'];
  dateTo: Scalars['Date'];
};


export type QueryZoomLessonArgs = {
  groupLessonId: Scalars['ID'];
};

export type QuestionMetricInput = {
  metric: Scalars['String'];
  questionId: Scalars['ID'];
};

/** Вернуть выключенного оператора в работу — решение человека. */
export type ReactivateCandidateOperator = {
  __typename?: 'ReactivateCandidateOperator';
  candidate?: Maybe<FundingCandidateType>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
};

/**
 * A received Fakturownia invoice as a candidate for linking to an
 * Expense (the picker in the expense form). A trimmed projection of
 * `FakturowniaInvoice` — only the fields the picker needs to display and to
 * prefill the expense on selection.
 */
export type ReceivedInvoiceForExpenseType = {
  __typename?: 'ReceivedInvoiceForExpenseType';
  accountingKind?: Maybe<Scalars['String']>;
  buyerName?: Maybe<Scalars['String']>;
  buyerTaxNo?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
  issueDate?: Maybe<Scalars['Date']>;
  kind?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  paymentTo?: Maybe<Scalars['Date']>;
  pk?: Maybe<Scalars['Int']>;
  priceGross?: Maybe<Scalars['Float']>;
  /** Invoice status (issued/sent/paid/partial/rejected) — lets the form auto-set the expense to 'paid' when a paid invoice is linked. */
  status?: Maybe<Scalars['String']>;
};

/**
 * Rebuild the merged profile from the existing good runs — no new AI call.
 *
 * Idempotent by construction (`merge_profiles` is pure and ordered), so this is
 * safe to press twice; it exists for the case where a run landed while the
 * merge shape changed.
 */
export type RecomputeTeacherAiProfile = {
  __typename?: 'RecomputeTeacherAiProfile';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  profile?: Maybe<TeacherAiProfileType>;
  success?: Maybe<Scalars['Boolean']>;
};

/**
 * Кнопка «Проверить сейчас».
 *
 * То же, что делает ночная задача. Сверка НЕ трогает деньги: ни договор, ни
 * взносы, ни фактуры — она лишь помечает коды использованными.
 */
export type ReconcilePromoCodes = {
  __typename?: 'ReconcilePromoCodes';
  ambiguous?: Maybe<Scalars['Int']>;
  checked?: Maybe<Scalars['Int']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  expired?: Maybe<Scalars['Int']>;
  redeemed?: Maybe<Scalars['Int']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type RecordPlacement = {
  __typename?: 'RecordPlacement';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  placement?: Maybe<PlacementRecordType>;
  success?: Maybe<Scalars['Boolean']>;
};

/** One-call refresh: accounts + all recordings + account usage. */
export type RefreshAllZoomDataMutation = {
  __typename?: 'RefreshAllZoomDataMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
};

/**
 * Pull a date window straight from Zoom, synchronously.
 *
 * Load-bearing, not a nicety: with production defaults the only scheduled sync
 * is `zoom_hourly_dispatch`, which early-returns unless a `GroupZoomSchedule`
 * slot falls in the current 15-minute bucket, so an interview recorded at a
 * quiet hour may never appear on its own.
 */
export type RefreshInterviewZoomRecordings = {
  __typename?: 'RefreshInterviewZoomRecordings';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  result?: Maybe<InterviewZoomRefreshType>;
  success?: Maybe<Scalars['Boolean']>;
};

/**
 * SDL: {success, errors, customErrors}.
 *
 * ТЗ 0021, стадия 4 — вместо `graphql_auth.mutations.Register`. Полей
 * token/refreshToken тут нет и быть не должно: пакет доливал их только при
 * `ALLOW_LOGIN_NOT_VERIFIED=True`, а в проекте настройка False.
 */
export type RegisterMutation = {
  __typename?: 'RegisterMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
  success?: Maybe<Scalars['Boolean']>;
};

/**
 * LMS: студент нажал «Поделиться» (ТЗ 0039, шаг 7).
 *
 * 🔴 Повторное нажатие возвращает `counted=false`, а НЕ ошибку: бонус за этот
 * канал уже выдан, но делиться можно сколько угодно, и ошибка на кнопке
 * «Поделиться» читается как поломка.
 *
 * ⚠️ Мутация фиксирует нажатие НАШЕЙ кнопки, а не публикацию: проверить
 * публикацию у LinkedIn и Facebook невозможно без OAuth от имени студента.
 *
 * Медали и коды возвращаются СРАЗУ, чтобы фронт показал награду без
 * перезапроса — иначе связь между действием и наградой теряется.
 */
export type RegisterShare = {
  __typename?: 'RegisterShare';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  result?: Maybe<ShareResultType>;
  success?: Maybe<Scalars['Boolean']>;
};

export type RemindDebtorsMutation = {
  __typename?: 'RemindDebtorsMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type RemoveCareerLessonAttachment = {
  __typename?: 'RemoveCareerLessonAttachment';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type RemoveStaffTaskAttachmentMutation = {
  __typename?: 'RemoveStaffTaskAttachmentMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
  task?: Maybe<StaffTaskType>;
};

/**
 * Снять одну связь — по id СТРОКИ связи.
 *
 * Не по паре «вид + объект»: строка снимается и тогда, когда объекта уже нет
 * в базе, а пары для него не построишь — именно ради этого случая связь и
 * показывается как «объект удалён», а не прячется.
 */
export type RemoveStaffTaskLinkMutation = {
  __typename?: 'RemoveStaffTaskLinkMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
  task?: Maybe<StaffTaskType>;
};

export type RenameWhiteboardMutation = {
  __typename?: 'RenameWhiteboardMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
  whiteboard?: Maybe<WhiteboardType>;
};

/**
 * Re-extract signer contact data (email/phone/name) on already-synced
 * documents and re-pull the details of rows a local re-parse can't fix.
 *
 * The repair button for «у студента нет договоров» / «новая папка не
 * появилась»: it applies the current parser to the whole cached inventory
 * instead of waiting for each document to change in PandaDoc.
 *
 * Admin-only (unlike the plain sync): a run can queue the entire inventory
 * for a `/details` re-fetch, which costs hours of the PandaDoc rate-limit
 * budget.
 */
export type ReparsePandadocRecipientsMutation = {
  __typename?: 'ReparsePandadocRecipientsMutation';
  enqueued?: Maybe<Scalars['Boolean']>;
  message?: Maybe<Scalars['String']>;
  syncStatus?: Maybe<PandaDocSyncStatusType>;
};

/**
 * Who a reply to this conversation will be sent as, for the ACTING
 * manager — mirrors services/reply._token_for WITHOUT network healing
 * (read path).
 */
export type ReplyIdentityType = {
  __typename?: 'ReplyIdentityType';
  /** Human name; '' → the frontend renders its localized fallback (e.g. «Slack-бот»). */
  name: Scalars['String'];
  /** 'manager' | 'bot' | 'mailbox' */
  via: Scalars['String'];
};

export type ReprocessAiMutation = {
  __typename?: 'ReprocessAiMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  lessonRecording?: Maybe<LessonRecordingType>;
  success?: Maybe<Scalars['Boolean']>;
};

/** Заказать выгрузку данных для P&L. Файл собирается в фоне. */
export type RequestPnlExportMutation = {
  __typename?: 'RequestPnlExportMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  run?: Maybe<PnlExportRunType>;
  success?: Maybe<Scalars['Boolean']>;
};

export type RequirementsType = {
  __typename?: 'RequirementsType';
  courseRequirements: CourseRequirementsIntoType;
  description: Scalars['String'];
  id: Scalars['ID'];
  title: Scalars['String'];
};

/**
 * Teacher re-queues the AI analysis of a submission («Перепроверить»).
 * Answers AI_DISABLED while the HOMEWORK_AI_ENABLED flag is off.
 */
export type RerunHomeworkAiReviewMutation = {
  __typename?: 'RerunHomeworkAiReviewMutation';
  aiReviewStatus?: Maybe<Scalars['String']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
};

/**
 * Аварийный выход: снять сдачи, чтобы можно было переделать анкету.
 *
 * 🔴 Снимает сдачи по ВСЕМ урокам, куда анкета прикреплена, — замок общий,
 * и половинчатый сброс оставил бы его запертым без объяснения. НЕ удаляет
 * `CareerLessonProgress` (иначе одна опечатка методиста перезакрыла бы урок
 * всему потоку) и НЕ откатывает записанное в резюме: эти данные уже
 * принадлежат студенту. Асимметрию надо писать в подтверждении прямым
 * текстом.
 */
export type ResetCareerExerciseTemplate = {
  __typename?: 'ResetCareerExerciseTemplate';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  deletedSubmissions?: Maybe<Scalars['Int']>;
  success?: Maybe<Scalars['Boolean']>;
};

/**
 * Settle one raw place string.
 *
 * Either outcome PINS the row — the auto-resolver never re-points a
 * manually settled string on any later import.
 */
export type ResolveGeoAlias = {
  __typename?: 'ResolveGeoAlias';
  alias?: Maybe<GeoAliasType>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
};

/**
 * TZ-2 — ответственный менеджер студента.
 *
 * Per-student связь сейчас не существует ни в БД, ни в CRM-интеграции
 * (`CRMUser` — singleton, общий на всю систему). Резолвер на `StudentType`
 * возвращает `None` до отдельного продуктового решения. Тип нужен,
 * чтобы фронт мог писать запрос без падения на компиляции схемы.
 * См. docs/student_card/update_card.md TZ-2.
 */
export type ResponsibleManagerType = {
  __typename?: 'ResponsibleManagerType';
  fullName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

/**
 * Вернуть студенту доступ к занятиям курса — ремонт, а не смена договора.
 *
 * Только строки посещаемости (= доступ в LMS) и запись в аудит: деньги,
 * взносы и `terminated` не трогаются. Аддитивна — может лишь добавить
 * студенту занятия, которых у него нет, поэтому безопасна к повторному
 * нажатию и возвращает `restoredLessons = 0`, когда возвращать нечего.
 */
export type RestoreCourseAccessMutation = {
  __typename?: 'RestoreCourseAccessMutation';
  agreement?: Maybe<AgreementType>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
  restoredLessons?: Maybe<Scalars['Int']>;
  success?: Maybe<Scalars['Boolean']>;
};

/**
 * Разобрать заявку с формы заново (ТЗ 0046).
 *
 * Триаж идёт автоматически и в `try/except`: заявка пишется одной
 * транзакцией, а разбор — отдельно и после, чтобы падение разбора не теряло
 * лид. Цена в том, что упавшая заявка молча остаётся с пустым
 * `processed_at`, и до этой мутации починить её из интерфейса было нельзя —
 * только руками в БД.
 *
 * Идемпотентна: повторный разбор уже подшитой заявки найдёт того же
 * кандидата и заполнит те же пустые поля.
 *
 * Она же — способ отменить ложное срабатывание ловушки (ТЗ 0047). Заявку,
 * отклонённую как автоматическую, менеджер разбирает этой же кнопкой, и
 * удачный разбор снимает пометку: человек посмотрел и решил, а его решение
 * старше эвристики.
 */
export type RetryFormSubmission = {
  __typename?: 'RetryFormSubmission';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  submission?: Maybe<FormSubmissionType>;
  success?: Maybe<Scalars['Boolean']>;
};

export type RetryLessonRecordingMutation = {
  __typename?: 'RetryLessonRecordingMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  lessonRecording?: Maybe<LessonRecordingType>;
  success?: Maybe<Scalars['Boolean']>;
};

/**
 * Re-queue the artifact pull — the recovery path when Zoom's transcript
 * landed after the video, or a worker died mid-download.
 */
export type RetryTeacherInterviewDownload = {
  __typename?: 'RetryTeacherInterviewDownload';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  interview?: Maybe<TeacherInterviewType>;
  success?: Maybe<Scalars['Boolean']>;
};

/**
 * Undo a manual «оплачен вручную» mark.
 *
 * ТЗ 0029: clears `manual_paid_*` on the instalment. Money that came through
 * an invoice is untouched — that is corrected with a corrective invoice or a
 * `PaymentCorrection`, not here.
 */
export type RevertManualContributionPaymentMutation = {
  __typename?: 'RevertManualContributionPaymentMutation';
  contribution?: Maybe<ContributionType>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
};

/**
 * Undo for a triage action — put exactly these rows back (spec 0030 r2).
 *
 * Both the bulk clear and the per-message cascade only ever flip
 * False → True, so clearing the very ids they reported restores the prior
 * state exactly. That is why undo takes explicit ids rather than a scope:
 * re-deriving the set would also catch rows that were already read before,
 * and un-read them.
 *
 * Deliberately no separate permission tier: whoever may clear may un-clear.
 */
export type RevertMessagesTriageMutation = {
  __typename?: 'RevertMessagesTriageMutation';
  conversations?: Maybe<Array<ConversationType>>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  messagesReverted?: Maybe<Scalars['Int']>;
  success?: Maybe<Scalars['Boolean']>;
};

/**
 * «Посмотрел» — человек разобрал изменение на странице оператора.
 *
 * Ровно один поступок и ровно один эффект: снять флаг «страница обновилась».
 * Владелец описал цикл так: «мы следим за страницей только лишь в том смысле,
 * поменялась она или нет. Если да — руками смотрим, что конкретно поменялось,
 * и снова меняем статус руками, что не поменялось».
 *
 * 🔴 Раньше сюда приходил `automation_status`, и мутация одновременно
 * снимала флаг И выдавала разрешение на рассылку. Отсюда росли четыре
 * кнопки — «есть набор», «набора нет», «надо править карточку», — про
 * которые владелец сказал: «что это за хуйню, не понимаю, что это». Два
 * разных решения в одной мутации требовали от человека принять их сразу,
 * хотя второе относится к НАБОРУ, а не к странице. Разрешение переехало на
 * окно (`FundingIntake.confirmed_at`), и здесь остался только флаг.
 *
 * Флаг снимает ТОЛЬКО эта мутация: робот его лишь поднимает. Иначе
 * «заметили» и «разобрали» слились бы в один факт, и второе изменение
 * подряд съело бы первое.
 *
 * 🔴 `intake` — «посмотрел, и там объявлен вот такой набор» (ТЗ 0048).
 * Аргумент остаётся: «разобрал» и «записал увиденный набор» — один поход
 * менеджера, и одна транзакция здесь честнее двух запросов с фронта, между
 * которыми помещается отказ. Подтверждение приходит внутри `intake`
 * (`confirmed: true`) — там же, где живёт.
 */
export type ReviewOperatorPage = {
  __typename?: 'ReviewOperatorPage';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  operator?: Maybe<FundingOperatorType>;
  success?: Maybe<Scalars['Boolean']>;
};

/** Отозвать выданный токен: клиент отключится немедленно. */
export type RevokeMcpConnectionMutation = {
  __typename?: 'RevokeMcpConnectionMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
};

/** Отозвать код. Студенту он перестаёт показываться. */
export type RevokePromoCode = {
  __typename?: 'RevokePromoCode';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
};

/** SDL: {revoked: Int, success, errors}. */
export type RevokeToken = {
  __typename?: 'RevokeToken';
  errors?: Maybe<Scalars['ExpectedErrorType']>;
  revoked?: Maybe<Scalars['Int']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type RobotTxtType = {
  __typename?: 'RobotTxtType';
  id: Scalars['ID'];
  robotContent: Scalars['String'];
};

/** Roster status filter — see docs/groups/groups_upgrade.md §B2. */
export enum RosterStatusEnum {
  Active = 'ACTIVE',
  All = 'ALL',
  Terminated = 'TERMINATED'
}

/**
 * What learning a rule from this row would mean.
 *
 * `wouldAffect` counts only rows automation is allowed to touch — promising to
 * reclassify something a human already decided would be a lie.
 */
export type RulePreviewType = {
  __typename?: 'RulePreviewType';
  direction?: Maybe<Scalars['String']>;
  keyKind?: Maybe<Scalars['String']>;
  keyValue?: Maybe<Scalars['String']>;
  samples?: Maybe<Array<Maybe<Scalars['String']>>>;
  wouldAffect?: Maybe<Scalars['Int']>;
};

export type RunAutoMatchingMutation = {
  __typename?: 'RunAutoMatchingMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
};

/**
 * Запустить фоновую задачу робота по кнопке.
 *
 * Все три флага расписания по умолчанию выключены, и до этой мутации
 * единственным способом что-то прогнать был терминал сервера.
 *
 * 🔴 Ставим в ОЧЕРЕДЬ, а не выполняем синхронно: обход ста с лишним
 * страниц операторов идёт с паузой между запросами и в HTTP-таймаут не
 * уложится. Результат появится строкой в журнале прогонов.
 *
 * `dry_run` едет в очередь вместе с задачей: сухость живёт в самой задаче
 * (`services/dry_run.py`), значит воркер выполнит сухой прогон сухим — ни
 * записей, ни писем. Что он собирался сделать, видно заметками в строке
 * журнала.
 *
 * По умолчанию — СУХОЙ. Кнопок пять, они стоят в ряд, и промах по одной из
 * них не имеет права разослать сотни писем.
 */
export type RunFundingTask = {
  __typename?: 'RunFundingTask';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
  /** Идентификатор задачи в celery. */
  taskId?: Maybe<Scalars['String']>;
  /** Ответил ли хоть один воркер. `false` означает, что задача легла в очередь, а брать её некому. */
  workerOnline?: Maybe<Scalars['Boolean']>;
};

/**
 * Queue a competency analysis of a document's extracted text.
 *
 * The result merges with any interview run into ONE profile: the CV carries
 * self-declared CLAIMS, the transcript carries observed behaviour, and
 * `profile_merge` keeps both tagged by source rather than fusing them.
 *
 * `NO_DOCUMENT_TEXT` is a precondition, not a failure — no run row is created,
 * exactly as with a missing transcript.
 */
export type RunTeacherDocumentAnalysis = {
  __typename?: 'RunTeacherDocumentAnalysis';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  run?: Maybe<TeacherAiRunType>;
  success?: Maybe<Scalars['Boolean']>;
};

/**
 * Queue a competency analysis of one interview's transcript.
 *
 * Two non-failures answered as customErrors rather than a failed run row:
 * · `AI_DISABLED` — the kill switch is off; the panel stays visible with a
 *   disabled button so «why is there no AI?» is answerable.
 * · `NO_TRANSCRIPT` — a PRECONDITION. It must not create a `failed` row,
 *   because «нет входа» is not an analysis that went wrong: it must not burn a
 *   retry or paint the panel red. The UI offers «вставить расшифровку».
 */
export type RunTeacherInterviewAnalysis = {
  __typename?: 'RunTeacherInterviewAnalysis';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  run?: Maybe<TeacherAiRunType>;
  success?: Maybe<Scalars['Boolean']>;
};

export type SalaryInfoType = {
  __typename?: 'SalaryInfoType';
  companyCount: Scalars['String'];
  course?: Maybe<CourseFilterType>;
  dataSource: Scalars['String'];
  id: Scalars['ID'];
  marketDemand: Scalars['String'];
  marketInfo: Scalars['String'];
  maxSeniorValue: Scalars['Int'];
  minJuniorValue: Scalars['Int'];
  minMiddleValue: Scalars['Int'];
  minSeniorValue: Scalars['Int'];
  title: Scalars['String'];
};

/**
 * Завести или поправить медаль.
 *
 * Удаления нет: `AchievementGrant` — append-only журнал выданного, и
 * `CASCADE` снёс бы вместе с медалью историю начислений и очки, которые
 * студент уже видел.
 */
export type SaveAchievement = {
  __typename?: 'SaveAchievement';
  achievement?: Maybe<AchievementErpType>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
};

/**
 * Завести или переписать анкету в справочнике (ТЗ 0040 фаза B).
 *
 * Раньше это была `SetCareerLessonExercise`: анкета собиралась ВНУТРИ урока
 * и жила только в нём. Владелец попросил обратного — «создавать на отдельной
 * странице, потом прикреплять к урокам», — и мутация переехала на шаблон.
 */
export type SaveCareerExerciseTemplate = {
  __typename?: 'SaveCareerExerciseTemplate';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
  template?: Maybe<CareerExerciseTemplateType>;
};

/** LMS: the student's PRIVATE note on a lesson (never shown to staff). */
export type SaveCareerLessonNotes = {
  __typename?: 'SaveCareerLessonNotes';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  notes?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type SaveCareerProfile = {
  __typename?: 'SaveCareerProfile';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  profile?: Maybe<CareerProfileType>;
  success?: Maybe<Scalars['Boolean']>;
};

/** Upsert the per-language prose overlay (title + about) for the CV. */
export type SaveCvText = {
  __typename?: 'SaveCvText';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  profile?: Maybe<CareerProfileType>;
  success?: Maybe<Scalars['Boolean']>;
};

/**
 * Create or edit a candidate.
 *
 * Note what is NOT here: `status` and `primary_operator`. Both move through
 * their own mutations so every transition is written to
 * `FundingCandidateEvent` — under one-row-per-person that log is the only
 * history there is.
 */
export type SaveFundingCandidate = {
  __typename?: 'SaveFundingCandidate';
  candidate?: Maybe<FundingCandidateType>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
  /** Исход привязки оператора по ID wsparcia (задача #96). Пусто — `supportId` не передан или пуст. linked — связь добавлена; already_linked — уже в работе; switched_off — связь выключена человеком и НЕ оживлена; no_prefix — в ID нет «_»; no_operator — АКТИВНОГО оператора с таким номером нет (выключенный не цепляется); ambiguous — номер у нескольких активных операторов, привязка пропущена. */
  supportIdLink?: Maybe<Scalars['String']>;
};

/**
 * Набор заводит и правит человек — робот только двигает статус (ТЗ 0048).
 *
 * Мутация написана в ТЗ 0046 и до ТЗ 0048 **не вызывалась ни одним
 * экраном**: формы набора не существовало. Три дефекта, разобранные в
 * `save_intake`, прожили в ней ровно поэтому — их некому было предъявить.
 */
export type SaveFundingIntake = {
  __typename?: 'SaveFundingIntake';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  intake?: Maybe<FundingIntakeType>;
  success?: Maybe<Scalars['Boolean']>;
};

/**
 * Create or update an operator, then re-expand its coverage index.
 *
 * Coverage is DERIVED — `services.geo.rebuild_coverage` runs on every save,
 * so the (operator × powiat) matching index can never drift away from the
 * declared scope.
 */
export type SaveFundingOperator = {
  __typename?: 'SaveFundingOperator';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  /** Сколько кандидатов привязано этим сохранением. Уже связанные (и выключенные человеком) не считаются. */
  linkedCandidatesCount?: Maybe<Scalars['Int']>;
  operator?: Maybe<FundingOperatorType>;
  /** Исход привязки кандидатов по номеру проекта (задача #96): linked — выполнена (сколько — в `linkedCandidatesCount`, может быть 0); ambiguous — этот номер стоит ещё у одного АКТИВНОГО оператора, и НИКТО не привязан; no_operator — сам оператор выключен, кандидатов не цепляет; no_prefix — номера нет. */
  projectNumberLink?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

/**
 * Завести или поправить профессию (ТЗ 0040 фаза C).
 *
 * Удаления нет: у трека висит `StudentTrackChoice` — выбор студента, и
 * удалить трек значит молча отобрать у человека цель, которую он себе
 * поставил. Есть скрытие.
 */
export type SaveGrowthTrack = {
  __typename?: 'SaveGrowthTrack';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
  track?: Maybe<GrowthTrackErpType>;
};

/**
 * Save the LMS suspension settings. Validation: overdueDays 1..90
 * (`invalid_overdue_days`); mail may be enabled only with BOTH templates
 * (`template_required`); a new template id (or one never checked) must
 * exist in SendGrid (`template_not_found`) and its name is copied from
 * SendGrid; SendGrid unreachable → `sendgrid_unavailable` /
 * `sendgrid_forbidden`, nothing saved. Audited (from → to).
 *
 * The SendGrid check (network) runs against an unlocked read, BEFORE the
 * transaction; the final validation runs again INSIDE it, on the row
 * re-read under `select_for_update` with this call's partial input laid
 * over it — a concurrent save (e.g. clearing a template while this call
 * enables mail) cannot produce a row that breaks the rules.
 */
export type SaveLmsBlockSettingsMutation = {
  __typename?: 'SaveLmsBlockSettingsMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  settings?: Maybe<LmsBlockSettingsType>;
  success?: Maybe<Scalars['Boolean']>;
};

/** Завести или поправить курс витрины (что школа продаёт). */
export type SaveSiteCourse = {
  __typename?: 'SaveSiteCourse';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  siteCourse?: Maybe<SiteCourseErpType>;
  success?: Maybe<Scalars['Boolean']>;
};

/** Full-list save of the school-wide component library (spec 0010 rev.2). */
export type SaveWhiteboardLibraryMutation = {
  __typename?: 'SaveWhiteboardLibraryMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  library?: Maybe<WhiteboardLibraryType>;
  success?: Maybe<Scalars['Boolean']>;
  version?: Maybe<Scalars['Int']>;
};

export type SaveWhiteboardSceneMutation = {
  __typename?: 'SaveWhiteboardSceneMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  sceneVersion?: Maybe<Scalars['Int']>;
  success?: Maybe<Scalars['Boolean']>;
  whiteboard?: Maybe<WhiteboardType>;
};

export type SelfEmployedInput = {
  accountNumber: Scalars['String'];
  bankTitle: Scalars['String'];
  bic: Scalars['String'];
  inn: Scalars['String'];
  nationality: Scalars['ID'];
  passportNumber: Scalars['String'];
  registrationAddress: Scalars['String'];
};

export type SelfEmployedType = Node & {
  __typename?: 'SelfEmployedType';
  accountNumber: Scalars['String'];
  bankTitle: Scalars['String'];
  bic: Scalars['String'];
  id: Scalars['ID'];
  inn: Scalars['String'];
  nationality: CountryType;
  passportNumber: Scalars['String'];
  registrationAddress: Scalars['String'];
};

export type SendAuthenticationCode = {
  __typename?: 'SendAuthenticationCode';
  createdAt?: Maybe<Scalars['DateTime']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
  success?: Maybe<Scalars['Boolean']>;
};

/** Reply into a Gmail thread; mirrors the sent message locally. */
export type SendGmailReplyMutation = {
  __typename?: 'SendGmailReplyMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  message?: Maybe<MessageType>;
  success?: Maybe<Scalars['Boolean']>;
};

/**
 * Send a dynamic-template email to selected students of a group.
 *
 * Each recipient gets their OWN message with their own name, amount and pay
 * link — never a shared blast. Returns the job id to poll (`mailJob`) for live
 * progress and per-recipient delivery status.
 */
export type SendGroupTemplateEmail = {
  __typename?: 'SendGroupTemplateEmail';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  mailJobId?: Maybe<Scalars['ID']>;
  success?: Maybe<Scalars['Boolean']>;
  total?: Maybe<Scalars['Int']>;
};

/**
 * Send a suspension / restoration template with the EXAMPLE data to the
 * calling staff member (or LMS_BLOCK_MAIL_TEST_RECIPIENT when set). Needs env
 * LMS_BLOCK_MAIL_ENABLED (`disabled_on_server`), not the ERP mail switch.
 * Writes no AccessBlockNotification.
 */
export type SendLmsBlockTestEmailMutation = {
  __typename?: 'SendLmsBlockTestEmailMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  sentTo?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type SendMorningReportMutation = {
  __typename?: 'SendMorningReportMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
};

/**
 * Compose and send a BRAND-NEW email from a chosen shared mailbox (not a
 * reply). Mirrors it locally as a new gmail-thread conversation.
 */
export type SendNewEmailMutation = {
  __typename?: 'SendNewEmailMutation';
  conversationId?: Maybe<Scalars['ID']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  message?: Maybe<MessageType>;
  success?: Maybe<Scalars['Boolean']>;
};

/**
 * Post a message into one of a group's Slack channels — including the
 * FIRST one, before any Conversation mirror exists. Lets a manager start a
 * channel thread instead of only replying into an existing dialog.
 */
export type SendSlackChannelMessage = {
  __typename?: 'SendSlackChannelMessage';
  conversationId?: Maybe<Scalars['ID']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  message?: Maybe<MessageType>;
  success?: Maybe<Scalars['Boolean']>;
};

/** Reply into a Slack conversation; mirrors the sent message locally. */
export type SendSlackMessageMutation = {
  __typename?: 'SendSlackMessageMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  message?: Maybe<MessageType>;
  success?: Maybe<Scalars['Boolean']>;
};

/** The SendGrid Marketing list mirroring a group's students. */
export type SendgridGroupListType = {
  __typename?: 'SendgridGroupListType';
  /** Contacts confirmed by the last finished import — not necessarily the current roster size. */
  contactCount: Scalars['Int'];
  errorMessage: Scalars['String'];
  id: Scalars['ID'];
  lastSyncStatus?: Maybe<Scalars['String']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  name: Scalars['String'];
  sendgridListId: Scalars['String'];
};

/** A dynamic template read live from the SendGrid API (not stored here). */
export type SendgridTemplateType = {
  __typename?: 'SendgridTemplateType';
  id: Scalars['String'];
  name: Scalars['String'];
  subject?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
  versionId?: Maybe<Scalars['String']>;
};

/**
 * Manually flag/unflag a contract as «бесплатный договор».
 *
 * Excludes the contract from ALL debt/overdue detection (student-card totals,
 * LMS-block candidates, debtors list, payment calendar) while leaving it
 * active — so the student keeps LMS access to the group. Like `transfer_out`
 * it also relaxes the FULL-zeroing correction guard, so the paid invoice can
 * be corrected to zero without pretending the contract was transferred.
 * Restricted to Admin/FinanceManager and audited — it silences a real debt, so
 * a rank-and-file operator must not be able to set it.
 */
export type SetAgreementFreeOfChargeMutation = {
  __typename?: 'SetAgreementFreeOfChargeMutation';
  agreement?: Maybe<AgreementType>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
  success?: Maybe<Scalars['Boolean']>;
};

/**
 * Manually flag/unflag a contract as «финансирование государством».
 *
 * The student is pre-financed by the state: intermediate documents
 * (proforma/advance/VAT) are not a debt — only an unpaid overdue FINAL
 * invoice is — and the plan/contributions owe nothing until then. Debt gates
 * honor this across totals, LMS block, debtors list and calendar. Restricted
 * to Admin/FinanceManager and audited.
 */
export type SetAgreementStatePrefinancedMutation = {
  __typename?: 'SetAgreementStatePrefinancedMutation';
  agreement?: Maybe<AgreementType>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
  success?: Maybe<Scalars['Boolean']>;
};

/**
 * Manually flag/unflag an agreement as «переведён из этой группы».
 *
 * The flag relaxes the FULL-zeroing limit on corrections (partials work
 * without it) and the carry-out money guards (still capped at `paid_amount`).
 * Restricted to Admin/FinanceManager and audited — it must not be settable by
 * a rank-and-file operator, and never via a self-declared termination reason.
 */
export type SetAgreementTransferOutMutation = {
  __typename?: 'SetAgreementTransferOutMutation';
  agreement?: Maybe<AgreementType>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
  success?: Maybe<Scalars['Boolean']>;
};

/**
 * Пометить ведущего оператора (или снять пометку).
 *
 * ⚠️ Пометка НИКОГО НЕ ГЛУШИТ: письма продолжают уходить от всех активных
 * операторов. До ТЗ 0067 эта же запись означала «перевод, старый
 * замолкает» — теперь замолкание делается явно и с причиной.
 */
export type SetCandidatePrimaryOperator = {
  __typename?: 'SetCandidatePrimaryOperator';
  candidate?: Maybe<FundingCandidateType>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
};

/**
 * LMS: сменить статус отклика.
 *
 * 🔴 `hired` НЕ создаёт `PlacementRecord`, НЕ переводит участника в `placed`
 * и НЕ выдаёт медаль. Самозаявленное трудоустройство не может стать KPI
 * школы, а на архивном участнике автоперевод в `placed` (статус АКТИВНЫЙ)
 * молча вернул бы доступ в центр мимо явной разархивации. Строка лишь встаёт
 * в очередь подтверждения сотруднику.
 */
export type SetCareerApplicationStatus = {
  __typename?: 'SetCareerApplicationStatus';
  application?: Maybe<CareerApplicationType>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
};

/** LMS: toggle a lesson bookmark for the calling student. */
export type SetCareerLessonBookmark = {
  __typename?: 'SetCareerLessonBookmark';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  isBookmarked?: Maybe<Scalars['Boolean']>;
  success?: Maybe<Scalars['Boolean']>;
};

/** ERP: replace a lesson's self-check quiz (delete-and-recreate). */
export type SetCareerLessonQuiz = {
  __typename?: 'SetCareerLessonQuiz';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  lesson?: Maybe<CareerLessonType>;
  success?: Maybe<Scalars['Boolean']>;
};

/**
 * Убрать из карьерного центра или вернуть обратно.
 *
 * 🔴 Это НЕ удаление. Пропадает только доступ: строка участника, прогресс по
 * урокам, отклики и запись о трудоустройстве остаются нетронутыми, и вернуть
 * человека можно тем же действием. Так решено владельцем.
 *
 * Массовая с самого начала — оператор чистит ошибочно добавленную группу
 * целиком. Отдельная мутация «на одного» была бы тем же кодом, а триста
 * вызовов подряд — тремястами перезагрузками списка (тот же довод, что у
 * `bulkSetVacancyStatus`).
 */
export type SetCareerMembersAccess = {
  __typename?: 'SetCareerMembersAccess';
  changed?: Maybe<Scalars['Int']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  missing?: Maybe<Scalars['Int']>;
  success?: Maybe<Scalars['Boolean']>;
  unchanged?: Maybe<Scalars['Int']>;
};

/**
 * Спрятать навык из автокомплита или вернуть обратно.
 *
 * Мутации удаления НЕТ намеренно: `Skill.delete()` каскадит `StudentSkill`,
 * то есть стирает навык из резюме всех владельцев, и вычищает теги вакансий.
 */
export type SetCareerSkillActive = {
  __typename?: 'SetCareerSkillActive';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  skill?: Maybe<SkillType>;
  success?: Maybe<Scalars['Boolean']>;
};

/**
 * Загрузить свою картинку навыка или убрать её (ТЗ 0039, доводка UX).
 *
 * Иконка НЕОБЯЗАТЕЛЬНА: без неё фронт рисует встроенный логотип по `slug`, а
 * если и его нет — буквенную плашку по категории. Поэтому «убрать» здесь не
 * оставляет пустое место, а возвращает автоподбор, и оператору не приходится
 * держать картинку только для того, чтобы строка не выглядела сломанной.
 *
 * Загрузка идёт мультипартом и пишется сервером — тем же путём, что видео
 * урока и вложения; настраивать CORS бакета не нужно.
 */
export type SetCareerSkillIcon = {
  __typename?: 'SetCareerSkillIcon';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  skill?: Maybe<SkillType>;
  success?: Maybe<Scalars['Boolean']>;
};

export type SetCategoryOutput = {
  __typename?: 'SetCategoryOutput';
  conflictingRule?: Maybe<CashFlowRuleType>;
  errors?: Maybe<Array<Maybe<Scalars['String']>>>;
  preview?: Maybe<RulePreviewType>;
  rule?: Maybe<CashFlowRuleType>;
  ruleOutcome?: Maybe<Scalars['String']>;
  ruleReason?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
  transaction?: Maybe<BankTransactionType>;
};

export type SetCompanyInput = {
  companyComment?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['ID']>;
};

/** Set a conversation's handling status (open / in_progress / done). */
export type SetConversationStatusMutation = {
  __typename?: 'SetConversationStatusMutation';
  conversation?: Maybe<ConversationType>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
};

/** Ручное «зачтено / не засчитывать» по паре студент-курс. */
export type SetCourseCompletion = {
  __typename?: 'SetCourseCompletion';
  completedCourseIds?: Maybe<Array<Scalars['ID']>>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
};

/**
 * Переписать программу курса (ТЗ 0040 фаза C).
 *
 * До этого программу можно было только загрузить Excel-импортом из
 * Django-админки: опечатка чинилась перезаливкой файла целиком.
 */
export type SetCourseProgram = {
  __typename?: 'SetCourseProgram';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  lessons?: Maybe<Scalars['Int']>;
  lessonsRemoved?: Maybe<Scalars['Int']>;
  lessonsWithoutMarketing?: Maybe<Scalars['Int']>;
  modules?: Maybe<Scalars['Int']>;
  success?: Maybe<Scalars['Boolean']>;
};

/**
 * Задать набор навыков курса целиком — ШАБЛОН для будущих групп.
 *
 * 🔴 Пересчёта начислений здесь больше нет (ТЗ 0041). Набор курса перестал
 * быть действующим правилом: начисление читает набор ГРУППЫ, снятый с курса
 * в момент её создания. Правка шаблона по решению владельца не догоняет уже
 * идущие группы — иначе студент старой группы получал бы навык не на том
 * занятии, ради чего перенос и делался. Пересчёт ставит `SetGroupSkills`.
 */
export type SetCourseSkills = {
  __typename?: 'SetCourseSkills';
  added?: Maybe<Scalars['Int']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  deactivated?: Maybe<Scalars['Int']>;
  success?: Maybe<Scalars['Boolean']>;
  updated?: Maybe<Scalars['Int']>;
};

export type SetGroupLessonLink = {
  __typename?: 'SetGroupLessonLink';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  group?: Maybe<GroupType>;
  success?: Maybe<Scalars['Boolean']>;
};

export type SetGroupLessonLinkOverride = {
  __typename?: 'SetGroupLessonLinkOverride';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  group?: Maybe<GroupType>;
  success?: Maybe<Scalars['Boolean']>;
};

/**
 * Задать набор навыков ГРУППЫ целиком (ТЗ 0041).
 *
 * Пересчёт начислений НЕ делается здесь: группа с тремя десятками студентов
 * и дюжиной навыков — это сотни записей внутри GraphQL-запроса. Ставим
 * задачу; при недоступном брокере считаем синхронно, но не молча.
 */
export type SetGroupSkills = {
  __typename?: 'SetGroupSkills';
  added?: Maybe<Scalars['Int']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  deactivated?: Maybe<Scalars['Int']>;
  success?: Maybe<Scalars['Boolean']>;
  updated?: Maybe<Scalars['Int']>;
};

export type SetGroupZoomAccountMutation = {
  __typename?: 'SetGroupZoomAccountMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
};

/** Set a group's Zoom account and fully replace its processing slots. */
export type SetGroupZoomScheduleMutation = {
  __typename?: 'SetGroupZoomScheduleMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  schedules?: Maybe<Array<Maybe<GroupZoomScheduleType>>>;
  success?: Maybe<Scalars['Boolean']>;
};

/**
 * Mark one message handled/unhandled — обработано (team-wide global).
 *
 * With `cascade` (spec 0030) the tick also closes everything ABOVE it in
 * the same dialog: reading and handling a later message means the earlier
 * ones were dealt with too, which is how a human actually works a thread.
 * Un-ticking never cascades — see the branch below.
 */
export type SetMessageHandledMutation = {
  __typename?: 'SetMessageHandledMutation';
  conversation?: Maybe<ConversationType>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  handledMessageIds?: Maybe<Array<Scalars['ID']>>;
  message?: Maybe<MessageType>;
  readMessageIds?: Maybe<Array<Scalars['ID']>>;
  success?: Maybe<Scalars['Boolean']>;
  truncated?: Maybe<Scalars['Boolean']>;
};

/**
 * Студент сам оценил уровень навыка (0072): из паспорта навыка или из
 * подсказки «Wspomniano w CV». Подтверждённый школой уровень не понижается.
 */
export type SetMySkillLevel = {
  __typename?: 'SetMySkillLevel';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  profile?: Maybe<CareerProfileType>;
  skill?: Maybe<StudentSkillType>;
  success?: Maybe<Scalars['Boolean']>;
};

/**
 * Save the ACTING manager's personal Slack user token (xoxp) for a
 * group's workspace — DM replies to students then go out as the manager
 * himself, and his person-to-person DMs become pullable by sync. The token
 * is validated via auth.test and must belong to the group's workspace.
 * Write-only: no query ever returns it.
 */
export type SetMySlackUserTokenMutation = {
  __typename?: 'SetMySlackUserTokenMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
};

/** The student's own opt-in to partner search (Ф3) + contact visibility. */
export type SetProfileSearchable = {
  __typename?: 'SetProfileSearchable';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  profile?: Maybe<CareerProfileType>;
  success?: Maybe<Scalars['Boolean']>;
};

/** Включить или выключить акцию. Удаления нет: коды уже у людей на руках. */
export type SetPromoCampaignActive = {
  __typename?: 'SetPromoCampaignActive';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
};

/**
 * Bulk-assign question topics (spec 0038).
 *
 * Deliberately NOT routed through `updateSurvey`: that takes a whole survey
 * payload and would make retagging 40 questions across 12 surveys twelve
 * read-modify-write round trips. A topic is a label, not part of the answer
 * contract, so it stays editable even on a survey that already has answers —
 * that is precisely how historical surveys enter the analytics.
 */
export type SetQuestionMetricsMutation = {
  __typename?: 'SetQuestionMetricsMutation';
  changedCount?: Maybe<Scalars['Int']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
};

/**
 * Bind (or update) the Slack workspace for a group. Only the bot token is
 * really needed (no OAuth flow): a blank team id is resolved via auth.test.
 * `team_id` stays as an advanced override; `signing_secret` matters only for
 * the optional realtime webhook.
 */
export type SetSlackWorkspaceMutation = {
  __typename?: 'SetSlackWorkspaceMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type SetStudentsMarksMutation = {
  __typename?: 'SetStudentsMarksMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
  studentsMarks?: Maybe<StudentsMarkConnection>;
  success?: Maybe<Scalars['Boolean']>;
};


export type SetStudentsMarksMutationStudentsMarksArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/**
 * Replace the survey's whole «Аудитория и триггер» block.
 *
 * One bulk call, not N `assignSurveyToGroup`s: dropping a group from a rule
 * needs a diff against the previous state, which only the server holds.
 *
 * `success: true` WITH a populated `targeting.skipped[]` is the normal
 * outcome — the rules saved and some groups simply have no lesson N. Only
 * rule-level problems (INVALID_PLAN / COURSE_MISMATCH / PLAN_LOCKED /
 * ARCHIVED / NOT_FOUND) come back as customErrors with success=False.
 */
export type SetSurveyTargetingMutation = {
  __typename?: 'SetSurveyTargetingMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
  targeting?: Maybe<SurveyTargetingType>;
};

/**
 * Paste the text of a document whose extraction failed.
 *
 * The recovery path for a SCANNED CV: the PDF is perfectly valid, it simply
 * has no text layer, and there is no OCR in this system. Mirrors
 * `setTeacherInterviewTranscript` so the AI layer keeps reading one field and
 * never learns where the text came from.
 */
export type SetTeacherDocumentText = {
  __typename?: 'SetTeacherDocumentText';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  document?: Maybe<TeacherDocumentType>;
  success?: Maybe<Scalars['Boolean']>;
};

/**
 * Paste a transcript or interview notes.
 *
 * In v1 this is the PRIMARY route to an analysable interview: Zoom only emits
 * a transcript when *Audio transcript* is enabled on that account (and never
 * retroactively), and this system has no speech-to-text of its own.
 */
export type SetTeacherInterviewTranscript = {
  __typename?: 'SetTeacherInterviewTranscript';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  interview?: Maybe<TeacherInterviewType>;
  success?: Maybe<Scalars['Boolean']>;
};

/**
 * Update the control-panel profile fields — rating, internal note,
 * interview-recording link, and the courses-can-teach list. Only the fields
 * actually passed are changed; `rating=0` clears the rating.
 */
export type SetTeacherProfile = {
  __typename?: 'SetTeacherProfile';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
  teacher?: Maybe<TeacherType>;
};

export type SetVacancyStatus = {
  __typename?: 'SetVacancyStatus';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
  vacancy?: Maybe<VacancyType>;
};

/**
 * Один канал: готовый текст и ссылка окна шеринга.
 *
 * 🔴 `shareUrl` у Instagram приходит `null` — и это НЕ забытая ссылка:
 * веб-эндпоинта шеринга у него не существует. Фронт по этому признаку рисует
 * «скопировать текст» вместо «поделиться».
 *
 * Текст передаётся отдельно, потому что положить его в окно шеринга нельзя
 * ни в одном канале: LinkedIn принимает только `url`, Facebook — только `u`.
 */
export type ShareOptionType = {
  __typename?: 'ShareOptionType';
  bonusAvailable: Scalars['Boolean'];
  bonusPoints: Scalars['Int'];
  bonusPromo: Scalars['Boolean'];
  channel: Scalars['String'];
  shareUrl?: Maybe<Scalars['String']>;
  targetUrl: Scalars['String'];
  text: Scalars['String'];
};

/** Итог нажатия: засчитано ли и что за это дали. */
export type ShareResultType = {
  __typename?: 'ShareResultType';
  counted: Scalars['Boolean'];
  grantedTitles: Array<Scalars['String']>;
  promoCodes: Array<Scalars['String']>;
};

export type ShareTemplateInput = {
  channel: Scalars['String'];
  isActive?: InputMaybe<Scalars['Boolean']>;
  language: Scalars['String'];
  targetUrl?: InputMaybe<Scalars['String']>;
  text: Scalars['String'];
};

/**
 * Текст поста для экрана в ERP (ТЗ 0039, доводка).
 *
 * Мутация правки была с самого начала, а экрана не было — то есть обещание
 * «менять формулировку без выката» выполнялось только через Django-admin,
 * куда владелец не ходит.
 */
export type ShareTemplateType = {
  __typename?: 'ShareTemplateType';
  channel: Scalars['String'];
  isActive: Scalars['Boolean'];
  language: Scalars['String'];
  targetUrl: Scalars['String'];
  text: Scalars['String'];
};

/**
 * Курс витрины: то, что школа ПРОДАЁТ (ТЗ 0040 фаза C).
 *
 * Заводился сидом, то есть правка прайс-листа требовала выката.
 */
export type SiteCourseErpType = {
  __typename?: 'SiteCourseErpType';
  careerOutcome: Scalars['String'];
  durationLabel: Scalars['String'];
  erpCourseId?: Maybe<Scalars['ID']>;
  erpCourseName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  name: Scalars['String'];
  order: Scalars['Int'];
  skills: Array<SiteCourseSkillErpType>;
  slug: Scalars['String'];
};

export type SiteCourseInput = {
  careerOutcome?: InputMaybe<Scalars['String']>;
  durationLabel?: InputMaybe<Scalars['String']>;
  erpCourseId?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  skills?: InputMaybe<Array<SiteCourseSkillInput>>;
  slug: Scalars['String'];
};

export type SiteCourseSkillErpType = {
  __typename?: 'SiteCourseSkillErpType';
  level: Scalars['Int'];
  skillId: Scalars['ID'];
  skillName: Scalars['String'];
};

export type SiteCourseSkillInput = {
  level?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['Int']>;
  skillId: Scalars['ID'];
};

/**
 * Востребованность навыка ПО НАШЕЙ ДОСКЕ (ТЗ 0039).
 *
 * ⚠️ `computedAt` отдаётся не для красоты: счётчик без даты выглядит живым
 * даже тогда, когда ночная задача не отрабатывала неделю. И формулировка на
 * экране обязана быть «в нашей ленте», а не «на рынке»: доска, набитая
 * питоновскими вакансиями, по построению объявит Python самым востребованным.
 */
export type SkillDemandType = {
  __typename?: 'SkillDemandType';
  band: Scalars['Int'];
  computedAt?: Maybe<Scalars['DateTime']>;
  liveVacancies: Scalars['Int'];
  rank: Scalars['Int'];
};

/**
 * Навык целиком — для его СОБСТВЕННОЙ страницы (ТЗ 0039, доводка UX).
 *
 * Шторку нельзя ни дать ссылкой, ни открыть с другого экрана, ни вернуть
 * кнопкой «назад». Владелец: «открывается справа поп-ап — не очевидно».
 * Поэтому у навыка появился адрес, а у адреса — этот тип.
 */
export type SkillDetailType = {
  __typename?: 'SkillDetailType';
  demand?: Maybe<SkillDemandType>;
  grantedCourseName?: Maybe<Scalars['String']>;
  grantedLessonNumber?: Maybe<Scalars['Int']>;
  mentionedInCv: Scalars['Boolean'];
  myLevel?: Maybe<Scalars['Int']>;
  mySource?: Maybe<Scalars['String']>;
  professions: Array<SkillProfessionType>;
  providers: Array<SkillProviderType>;
  skill: SkillType;
};

export type SkillLevelCriteriaInput = {
  example?: InputMaybe<Scalars['String']>;
  level: Scalars['Int'];
  points: Array<Scalars['String']>;
};

/** «Что нужно уметь на уровне N» — пункты методиста (ТЗ 0072). */
export type SkillLevelCriteriaType = {
  __typename?: 'SkillLevelCriteriaType';
  example: Scalars['String'];
  level: Scalars['Int'];
  points: Array<Scalars['String']>;
};

/** Карта навыков целиком. */
export type SkillMapType = {
  __typename?: 'SkillMapType';
  demandComputedAt?: Maybe<Scalars['DateTime']>;
  mine: Array<MySkillType>;
  missing: Array<MissingSkillType>;
  nextCourses: Array<NextCourseType>;
  trackCode?: Maybe<Scalars['String']>;
  trackIsDefault: Scalars['Boolean'];
  trackTitle?: Maybe<Scalars['String']>;
};

/** Профессия, которой нужен этот навык, — обратный взгляд на цели трека. */
export type SkillProfessionType = {
  __typename?: 'SkillProfessionType';
  code: Scalars['String'];
  haveCount: Scalars['Int'];
  icon: Scalars['String'];
  skillProgress: CareerSkillProgressType;
  summary: Scalars['String'];
  title: Scalars['String'];
  totalCount: Scalars['Int'];
  usageNote: Scalars['String'];
};

/**
 * Курс, который даёт навык, — ответ на «а где это взять».
 *
 * 🔴 `courseUrl` ведёт на МАРКЕТИНГОВЫЙ САЙТ, а не внутрь ЛМС: витрины
 * курсов в ЛМС нет вовсе, и без этой ссылки продающая петля обрывалась —
 * экран говорил «не хватает Kubernetes, его даёт курс DevOps», и идти было
 * некуда.
 */
export type SkillProviderType = {
  __typename?: 'SkillProviderType';
  completed: Scalars['Boolean'];
  courseId: Scalars['ID'];
  courseName: Scalars['String'];
  courseUrl: Scalars['String'];
  level: Scalars['Int'];
};

/**
 * A dictionary skill — used by the profile editor's autocomplete and, via
 * `careerSkillsErp`, by the MCP vacancy-intake tool.
 */
export type SkillType = {
  __typename?: 'SkillType';
  aliases: Array<Scalars['String']>;
  category: Scalars['String'];
  courseCount?: Maybe<Scalars['Int']>;
  courseLevel?: Maybe<Scalars['Int']>;
  demandBand?: Maybe<Scalars['Int']>;
  demandComputedAt?: Maybe<Scalars['DateTime']>;
  demandVacancies?: Maybe<Scalars['Int']>;
  description: Scalars['String'];
  holderCount?: Maybe<Scalars['Int']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  levelCriteria: Array<SkillLevelCriteriaType>;
  name: Scalars['String'];
  slug: Scalars['String'];
  unlockLevel?: Maybe<Scalars['Int']>;
};

export type SlackUserLinkType = {
  __typename?: 'SlackUserLinkType';
  displayName: Scalars['String'];
  email: Scalars['String'];
  id: Scalars['ID'];
  slackUserId: Scalars['String'];
  student?: Maybe<StudentType>;
  teamId: Scalars['String'];
};

/**
 * Whether the ACTING manager has an xoxp token for a workspace. The token
 * itself is write-only (never leaves the server).
 */
export type SlackUserTokenStatusType = {
  __typename?: 'SlackUserTokenStatusType';
  hasToken: Scalars['Boolean'];
  slackUserId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SlackWorkspaceLinkType = {
  __typename?: 'SlackWorkspaceLinkType';
  channelCount?: Maybe<Scalars['Int']>;
  enabled: Scalars['Boolean'];
  id: Scalars['ID'];
  oauthConfigured?: Maybe<Scalars['Boolean']>;
  teamId: Scalars['String'];
  workspaceName: Scalars['String'];
};

/**
 * Из-за чего звенит браузер.
 *
 * Предикат («мой открытый высокий приоритет со сроком уже») живёт ТОЛЬКО на
 * сервере: копия на клиенте была бы вторым определением того же правила и
 * неизбежно разошлась бы с этим.
 */
export type SoundAlarmType = {
  __typename?: 'SoundAlarmType';
  active: Scalars['Boolean'];
  taskId?: Maybe<Scalars['ID']>;
  title?: Maybe<Scalars['String']>;
};

export type StaffNotificationEdgeType = {
  __typename?: 'StaffNotificationEdgeType';
  cursor: Scalars['String'];
  node: StaffNotificationType;
};

export type StaffNotificationKindType = {
  __typename?: 'StaffNotificationKindType';
  enabled: Scalars['Boolean'];
  key: Scalars['String'];
  label: Scalars['String'];
};

export type StaffNotificationPageType = {
  __typename?: 'StaffNotificationPageType';
  edges: Array<StaffNotificationEdgeType>;
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage: Scalars['Boolean'];
  unreadCount: Scalars['Int'];
};

/**
 * Все поля необязательны: экран сохраняет по одному контролу.
 *
 * `clear_quiet_hours` отдельным флагом, а не «пустым значением»: в GraphQL
 * «не прислали» и «прислали null» на входе неразличимы, и без флага сбросить
 * тихие часы было бы нечем.
 */
export type StaffNotificationSettingsInput = {
  clearQuietHours?: InputMaybe<Scalars['Boolean']>;
  enabledKinds?: InputMaybe<Array<Scalars['String']>>;
  pollSeconds?: InputMaybe<Scalars['Int']>;
  quietFrom?: InputMaybe<Scalars['Time']>;
  quietTo?: InputMaybe<Scalars['Time']>;
  repeatAfterMinutes?: InputMaybe<Scalars['Int']>;
  robotRules?: InputMaybe<Array<Scalars['String']>>;
  soundEnabled?: InputMaybe<Scalars['Boolean']>;
  telegramEnabled?: InputMaybe<Scalars['Boolean']>;
};

export type StaffNotificationSettingsType = {
  __typename?: 'StaffNotificationSettingsType';
  availableKinds: Array<StaffNotificationKindType>;
  availableRobotRules: Array<StaffRobotRuleType>;
  enabledKinds: Array<Scalars['String']>;
  pollSeconds: Scalars['Int'];
  quietFrom?: Maybe<Scalars['Time']>;
  quietTo?: Maybe<Scalars['Time']>;
  repeatAfterMinutes: Scalars['Int'];
  robotRules: Array<Scalars['String']>;
  soundEnabled: Scalars['Boolean'];
  /** False when the bot is not configured server-side — the UI must say so instead of offering a dead button. */
  telegramAvailable: Scalars['Boolean'];
  /** Set when the person blocked the bot. Shown in the UI: otherwise they believe they are subscribed while the channel is silently dead. */
  telegramBlockedAt?: Maybe<Scalars['DateTime']>;
  telegramEnabled: Scalars['Boolean'];
  telegramLinked: Scalars['Boolean'];
  telegramLinkedAt?: Maybe<Scalars['DateTime']>;
  telegramUsername: Scalars['String'];
};

export type StaffNotificationType = {
  __typename?: 'StaffNotificationType';
  /** Who triggered it. NULL means the robot did. */
  actorName?: Maybe<Scalars['String']>;
  body: Scalars['String'];
  createdAt: Scalars['DateTime'];
  dueDate?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  /** Kind key from the server-side registry. Deliberately a String, not an Enum: kinds are added without a migration and an Enum would make every addition a breaking schema change for the clients. */
  kind: Scalars['String'];
  priority: Scalars['String'];
  /** NULL means unread. A timestamp, not a flag: «read at 12:40» answers the question a reader actually has. */
  readAt?: Maybe<Scalars['DateTime']>;
  taskId: Scalars['ID'];
  title: Scalars['String'];
};

/**
 * Счётчик колокольчика. Его и опрашивает клиент раз в минуту.
 *
 * Отдельно от ленты, потому что тянуть список в каждом опросе дорого, а
 * расходиться с ним нельзя: обе выборки строит одна функция с одинаковыми
 * аргументами (`services/feed.py::scoped_notifications`), и `unreadCount`
 * приходит ТАКЖЕ в ответе ленты — то есть в момент открытия попапа число и
 * список взяты из одного запроса.
 */
export type StaffNotificationsSummaryType = {
  __typename?: 'StaffNotificationsSummaryType';
  latestCreatedAt?: Maybe<Scalars['DateTime']>;
  latestId?: Maybe<Scalars['ID']>;
  /** How often the client should poll. The SERVER dictates the pace so it can be raised by a setting instead of a frontend release. */
  pollSeconds: Scalars['Int'];
  soundAlarm: SoundAlarmType;
  /** Capped at 1000: an exact COUNT would be paid on every poll for a number nobody reads. */
  totalCount: Scalars['Int'];
  unreadCount: Scalars['Int'];
};

export type StaffRobotRuleType = {
  __typename?: 'StaffRobotRuleType';
  /** Whether the rule is switched on server-side at all. Subscribing to a rule nobody runs must not look like a working setting. */
  available: Scalars['Boolean'];
  /** Whether I am subscribed to this rule. */
  enabled: Scalars['Boolean'];
  key: Scalars['String'];
  label: Scalars['String'];
};

/**
 * Файл, приложенный к задаче или к реплике (ТЗ 0066).
 *
 * 🔴 Поля `url` здесь НЕТ и быть не должно. Ссылку минтит отдельный
 * корневой резолвер `staffTaskAttachmentUrl` — по клику. Иначе подписанная
 * ссылка (а это bearer-токен) уезжает в каждый ответ ленты, оседает в
 * Apollo-кеше и в breadcrumbs Sentry, а её TTL начинает тикать в момент
 * показа списка, а не в момент, когда файл понадобился. Правило ТЗ 0016.
 */
export type StaffTaskAttachmentType = {
  __typename?: 'StaffTaskAttachmentType';
  /** Может ли ЭТОТ пользователь удалить файл. Считает сервер той же функцией, что охраняет мутацию: клиентская копия правила в этом же окне уже однажды разошлась с серверной. */
  canDelete: Scalars['Boolean'];
  /** Непусто — файл приложен к реплике обсуждения, а не к самой задаче. */
  commentId?: Maybe<Scalars['ID']>;
  contentType: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  /** Считает сервер по СВОЕМУ типу (выведенному из сигнатуры содержимого), а не по расширению имени. */
  isImage: Scalars['Boolean'];
  originalName: Scalars['String'];
  sizeBytes: Scalars['Int'];
  uploadedByName?: Maybe<Scalars['String']>;
};

/**
 * Реплика в обсуждении задачи (ТЗ 0064).
 *
 * `authorId` — плоский скаляр, а не объект пользователя, ровно по той же
 * причине, что и у `StaffTaskType.assignee_id`: FK развернулся бы в тип, у
 * которого наружу торчат телефон, роли и обходы на студента с преподавателем.
 * Наружу уходят только id и отображаемое имя.
 */
export type StaffTaskCommentType = {
  __typename?: 'StaffTaskCommentType';
  attachments: Array<StaffTaskAttachmentType>;
  authorId?: Maybe<Scalars['ID']>;
  authorName?: Maybe<Scalars['String']>;
  body: Scalars['String'];
  /** Может ли ЭТОТ пользователь править и удалять реплику. Считает сервер тем же правилом, что и мутации: клиент, сравнивающий id автора сам, заводит вторую копию правила — и она уже разошлась (`UserNode.id` это relay-строка, а `authorId` — сырой ключ). */
  canEdit: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  /** Когда правили. NULL — не правили ни разу. */
  editedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
};

export type StaffTaskType = {
  __typename?: 'StaffTaskType';
  assigneeId?: Maybe<Scalars['ID']>;
  assigneeName?: Maybe<Scalars['String']>;
  attachments: Array<StaffTaskAttachmentType>;
  attachmentsCount: Scalars['Int'];
  comments: Array<StaffTaskCommentType>;
  commentsCount: Scalars['Int'];
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  createdByName?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  dueDate?: Maybe<Scalars['Date']>;
  fromMessage?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  links: Array<TaskLinkType>;
  position: Scalars['Int'];
  priority?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['Date']>;
  status?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

/**
 * Счётчики по ТОЙ ЖЕ выборке, что отдаёт `staffTasks`.
 *
 * Существуют, чтобы число в шапке и список под ним нельзя было развести:
 * оба считаются `_scoped_staff_tasks` с одними аргументами. «Просрочено» и
 * «на сегодня» берутся только среди ОТКРЫТЫХ — закрытая задача со вчерашним
 * сроком не долг, а история.
 */
export type StaffTasksSummaryType = {
  __typename?: 'StaffTasksSummaryType';
  openCount: Scalars['Int'];
  overdueCount: Scalars['Int'];
  todayCount: Scalars['Int'];
};

/**
 * Lightweight ERP-staff row for assignee dropdowns (plain ObjectType so
 * it doesn't fight users' relay UserNode over the model registry).
 */
export type StaffUserType = {
  __typename?: 'StaffUserType';
  email: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  roles: Array<Scalars['String']>;
};

/**
 * Open a Slack DM with a student OR a teacher and post the first message,
 * before any Conversation exists — so a manager can write first. Sent AS the
 * manager (his xoxp user token; a bot can't hold a 1:1 DM).
 */
export type StartSlackDm = {
  __typename?: 'StartSlackDm';
  conversationId?: Maybe<Scalars['ID']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  message?: Maybe<MessageType>;
  success?: Maybe<Scalars['Boolean']>;
};

/**
 * Return a signed Slack authorize URL so the ACTING manager can grant his
 * personal xoxp user token for a group's workspace in one click — no
 * api.slack.com, no copy-paste. The browser then navigates to Slack; on
 * "Allow" Slack redirects to `slack_oauth_callback`, which stores the token.
 *
 * Identity + group are captured HERE (under the JWT this mutation runs behind)
 * and sealed into a short-lived signed `state` (django.core.signing), because
 * the callback is a plain browser redirect that carries no JWT.
 */
export type StartSlackUserOauthMutation = {
  __typename?: 'StartSlackUserOauthMutation';
  authorizeUrl?: Maybe<Scalars['String']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
};

/** Выдать одноразовую ссылку привязки. */
export type StartTelegramLink = {
  __typename?: 'StartTelegramLink';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  link?: Maybe<TelegramLinkType>;
  success?: Maybe<Scalars['Boolean']>;
};

/** Одна точка среза аналитики. */
export type StatsBucketType = {
  __typename?: 'StatsBucketType';
  key: Scalars['String'];
  label: Scalars['String'];
  share?: Maybe<Scalars['Float']>;
  value: Scalars['Int'];
};

export type StatusBucketType = {
  __typename?: 'StatusBucketType';
  count: Scalars['Int'];
  status: Scalars['String'];
};

export type StatusGroupType = {
  __typename?: 'StatusGroupType';
  count: Scalars['Int'];
  key: Scalars['String'];
  statuses: Array<Scalars['String']>;
  title: Scalars['String'];
};

export type StudentAccessBlockType = {
  __typename?: 'StudentAccessBlockType';
  /** Still owed on blocking_invoices, per currency. */
  amountsDue: Array<LmsAmountDueType>;
  blockedAt?: Maybe<Scalars['DateTime']>;
  blockedByName?: Maybe<Scalars['String']>;
  /** Invoices the active suspension is tied to (empty when not blocked). */
  blockingInvoices: Array<LmsBlockInvoiceType>;
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  isBlocked: Scalars['Boolean'];
  lastEvent?: Maybe<LmsBlockEventType>;
  manualOverride: Scalars['Boolean'];
  maxOverdueDays: Scalars['Int'];
  overdueAmount?: Maybe<Scalars['Float']>;
  overdueInvoiceCount: Scalars['Int'];
  reason: Scalars['String'];
  /** robot | manual */
  source?: Maybe<Scalars['String']>;
  unblockedAt?: Maybe<Scalars['DateTime']>;
  unblockedByName?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type StudentAndCompaniesType = {
  __typename?: 'StudentAndCompaniesType';
  companiesDescription: Scalars['String'];
  companyImages: Array<CompanyImageType>;
  id: Scalars['ID'];
  studentsCount: Scalars['Int'];
  studentsDescription: Scalars['String'];
};

export type StudentCvType = {
  __typename?: 'StudentCVType';
  certificateImage: Scalars['String'];
  course?: Maybe<CourseFilterType>;
  id: Scalars['ID'];
  professionalSkills: Array<ProfessionalSkillType>;
  salary: Scalars['String'];
  studentImage: Scalars['String'];
  title: Scalars['String'];
  workingPosition: Scalars['String'];
};

/**
 * Per-student communicator badges: one row per roster student (zeroed
 * when they have no conversations) plus `in_roster=False` rows for
 * workspace-DM counterparts outside the roster.
 */
export type StudentCommsBadgeRow = {
  __typename?: 'StudentCommsBadgeRow';
  email: Scalars['String'];
  firstName: Scalars['String'];
  inRoster: Scalars['Boolean'];
  lastName: Scalars['String'];
  studentId: Scalars['ID'];
  /** True when EVERY agreement of the student in this group is terminated (the frontend hides such a row unless it still has unread messages). */
  terminated: Scalars['Boolean'];
  /** The student still has at least one INBOUND message no manager has ticked «обработано» — the amber dot. Independent of read state and of dialog status. */
  unhandled: Scalars['Boolean'];
  unhandledMail: Scalars['Boolean'];
  unhandledSlack: Scalars['Boolean'];
  unread: Scalars['Int'];
  unreadMail: Scalars['Int'];
  unreadSlack: Scalars['Int'];
};

export type StudentConnection = {
  __typename?: 'StudentConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<StudentEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `Student` and its cursor. */
export type StudentEdge = {
  __typename?: 'StudentEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<StudentType>;
};

/**
 * Группа глазами СТУДЕНТА.
 *
 * ТЗ 0040 доводка: сюда, а не в `GroupType`, кладётся план навыков. Тип —
 * потомок, поэтому поле достаётся только студенческому контуру; общий и
 * методистский остаются без него, и «что я получу» не превращается в лишнее
 * поле на экранах персонала.
 */
export type StudentGroupType = Node & {
  __typename?: 'StudentGroupType';
  activeLinkOverride?: Maybe<GroupLinkOverrideType>;
  agreements: Array<AgreementType>;
  agreementsConnection?: Maybe<AgreementConnection>;
  classesDays: Array<DayOfClassType>;
  comment?: Maybe<Scalars['String']>;
  contributionsSum?: Maybe<Scalars['CustomFloat']>;
  conversations: Array<ConversationType>;
  course: CourseFilterType;
  currency?: Maybe<Scalars['String']>;
  datetimeNextLesson?: Maybe<Scalars['DateTime']>;
  daysOfClass: Array<Scalars['Int']>;
  deleteAvailable?: Maybe<Scalars['Boolean']>;
  /** Optional — when the spend belongs to a specific group (teacher payout per group, group materials, etc.) */
  expenses: Array<ExpenseType>;
  /** DEPRECATED: use invoice.payment.agreement.group. */
  fakturowniaInvoices: Array<FakturowniaInvoiceType>;
  freeLessonsCount?: Maybe<Scalars['Int']>;
  freePlaces?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  isFree: Scalars['Boolean'];
  lessonJoinUrl?: Maybe<Scalars['String']>;
  lessons?: Maybe<Array<GroupLessonType>>;
  lessonsCount?: Maybe<Scalars['Int']>;
  materials: Array<MaterialType>;
  maxStudentsCount: Scalars['Int'];
  modules: Array<GroupModuleType>;
  name: Scalars['String'];
  notes: Array<StudentNoteType>;
  passedLessonsCount?: Maybe<Scalars['Int']>;
  price?: Maybe<Scalars['CustomFloat']>;
  publishedLms: Scalars['Boolean'];
  publishedLmsForMethodist: Scalars['Boolean'];
  publishedLmsForTeacher: Scalars['Boolean'];
  skillPlan: Array<LessonSkillUnlockType>;
  slackChannels: Array<ChannelGroupLinkType>;
  slackWorkspace?: Maybe<SlackWorkspaceLinkType>;
  startDate: Scalars['Date'];
  statusFinished?: Maybe<Scalars['Boolean']>;
  studentsCount?: Maybe<Scalars['Int']>;
  teacherLeads: ApplicationFilterTypeConnection;
  teachers?: Maybe<Array<Maybe<TeacherType>>>;
  zoomAccount?: Maybe<ZoomAccountType>;
  zoomSchedules: GroupZoomScheduleTypeConnection;
};


/**
 * Группа глазами СТУДЕНТА.
 *
 * ТЗ 0040 доводка: сюда, а не в `GroupType`, кладётся план навыков. Тип —
 * потомок, поэтому поле достаётся только студенческому контуру; общий и
 * методистский остаются без него, и «что я получу» не превращается в лишнее
 * поле на экранах персонала.
 */
export type StudentGroupTypeAgreementsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  hasDebt?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<AgreementOrderByEnum>;
  query?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<RosterStatusEnum>;
};


/**
 * Группа глазами СТУДЕНТА.
 *
 * ТЗ 0040 доводка: сюда, а не в `GroupType`, кладётся план навыков. Тип —
 * потомок, поэтому поле достаётся только студенческому контуру; общий и
 * методистский остаются без него, и «что я получу» не превращается в лишнее
 * поле на экранах персонала.
 */
export type StudentGroupTypeTeacherLeadsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  byGroupId?: InputMaybe<Scalars['Decimal']>;
  first?: InputMaybe<Scalars['Int']>;
  isTerminated?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/**
 * Группа глазами СТУДЕНТА.
 *
 * ТЗ 0040 доводка: сюда, а не в `GroupType`, кладётся план навыков. Тип —
 * потомок, поэтому поле достаётся только студенческому контуру; общий и
 * методистский остаются без него, и «что я получу» не превращается в лишнее
 * поле на экранах персонала.
 */
export type StudentGroupTypeZoomSchedulesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

/** Parent is a history dict from services.roster (ERP student card). */
export type StudentHomeworkRowType = {
  __typename?: 'StudentHomeworkRowType';
  assignmentTitle: Scalars['String'];
  groupId: Scalars['ID'];
  groupName: Scalars['String'];
  hwMark?: Maybe<Scalars['String']>;
  lessonId: Scalars['ID'];
  lessonName: Scalars['String'];
  submission?: Maybe<HomeworkSubmissionType>;
};

/** An enumeration. */
export enum StudentHwTypeEnum {
  ContainsErrors = 'CONTAINS_ERRORS',
  Done = 'DONE',
  NotDone = 'NOT_DONE'
}

export type StudentInput = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  middleName?: InputMaybe<Scalars['String']>;
  phone: Scalars['String'];
};

/**
 * PUBLIC student-facing subset of FakturowniaInvoice for `myInvoices`.
 *
 * Hand-built (NOT a DjangoObjectType) so nothing can leak — only the
 * whitelisted fields below exist. Fed FakturowniaInvoice instances by
 * `student_invoices_qs`; scalar fields auto-resolve off the model, the rest
 * are cast/computed here. `is_overdue`/`days_overdue` use the standard
 * overdue definition (payment_to < today AND status != 'paid') PLUS a
 * student-facing `outstanding > 0` guard so a fully-covered invoice never
 * reads as overdue with a zero balance.
 * `view_url`/`payment_url` are read from the stored Fakturownia JSON so the
 * student can open (and, where enabled, pay) the invoice on Fakturownia's
 * hosted page — no extra sync/migration needed.
 */
export type StudentInvoiceType = {
  __typename?: 'StudentInvoiceType';
  /** Reason taken from the correction document(s), if given. */
  correctionReason?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
  daysOverdue?: Maybe<Scalars['Int']>;
  fakturowniaId?: Maybe<Scalars['String']>;
  /** Unpaid and past the suspension threshold per the ТЗ 0074 rule, or tied to the student's active suspension. */
  isBlocking: Scalars['Boolean'];
  /** This invoice has been amended by at least one correction document; the amounts below are already netted. */
  isCorrected?: Maybe<Scalars['Boolean']>;
  isOverdue?: Maybe<Scalars['Boolean']>;
  issueDate?: Maybe<Scalars['Date']>;
  number?: Maybe<Scalars['String']>;
  outstanding?: Maybe<Scalars['Float']>;
  paid?: Maybe<Scalars['Float']>;
  paymentTo?: Maybe<Scalars['Date']>;
  paymentUrl?: Maybe<Scalars['String']>;
  priceGross?: Maybe<Scalars['Float']>;
  status?: Maybe<Scalars['String']>;
  viewUrl?: Maybe<Scalars['String']>;
};

export type StudentLessonAttachmentType = Node & {
  __typename?: 'StudentLessonAttachmentType';
  file: Scalars['String'];
  id: Scalars['ID'];
  lesson?: Maybe<GroupLessonType>;
  title: Scalars['String'];
};

export type StudentLessonAttachmentTypeConnection = {
  __typename?: 'StudentLessonAttachmentTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<StudentLessonAttachmentTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `StudentLessonAttachmentType` and its cursor. */
export type StudentLessonAttachmentTypeEdge = {
  __typename?: 'StudentLessonAttachmentTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<StudentLessonAttachmentType>;
};

export type StudentLessonAttachmentsType = Node & {
  __typename?: 'StudentLessonAttachmentsType';
  courseLesson?: Maybe<CourseLessonType>;
  file?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  title: Scalars['String'];
};

export type StudentLessonAttachmentsTypeConnection = {
  __typename?: 'StudentLessonAttachmentsTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<StudentLessonAttachmentsTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `StudentLessonAttachmentsType` and its cursor. */
export type StudentLessonAttachmentsTypeEdge = {
  __typename?: 'StudentLessonAttachmentsTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<StudentLessonAttachmentsType>;
};

export type StudentLessonConnection = {
  __typename?: 'StudentLessonConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<StudentLessonEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `StudentLesson` and its cursor. */
export type StudentLessonEdge = {
  __typename?: 'StudentLessonEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<StudentLessonNodeType>;
};

/**
 * Одна ячейка «студент × занятие» для журнала ERP (ТЗ 0026).
 *
 * Оценка за домашку не была видна в журнале ВООБЩЕ — только в двух вкладках
 * ДЗ. Матрица считается одним батчем на группу: журнал самая горячая таблица
 * ERP, и поштучный запрос на сорок занятий там недопустим.
 */
export type StudentLessonHwMarkType = {
  __typename?: 'StudentLessonHwMarkType';
  hwMark?: Maybe<Scalars['String']>;
  lessonId: Scalars['ID'];
  studentId: Scalars['ID'];
  submitted: Scalars['Boolean'];
};

/**
 * TZ-1 — one row of the student's lessons feed.
 *
 * `attended` and `mark` come from per-student records (StudentAttendance /
 * StudentsMark) attached as queryset annotations by
 * `students.services.academic.annotate_student_lessons`. Built as a
 * graphene.ObjectType (not DjangoObjectType) because these fields are
 * student-scoped, not lesson-intrinsic.
 */
export type StudentLessonNodeType = Node & {
  __typename?: 'StudentLessonNodeType';
  attended?: Maybe<Scalars['Boolean']>;
  date?: Maybe<Scalars['Date']>;
  /** The ID of the object */
  id: Scalars['ID'];
  lessonNumber?: Maybe<Scalars['Int']>;
  mark?: Maybe<Scalars['Float']>;
  name?: Maybe<Scalars['String']>;
};

export type StudentLessonType = Node & {
  __typename?: 'StudentLessonType';
  additional?: Maybe<Scalars['Boolean']>;
  attendances: AttendanceTypeConnection;
  comment?: Maybe<Scalars['String']>;
  date: Scalars['Date'];
  endTime: Scalars['Time'];
  finished: Scalars['Boolean'];
  firstLessonAgreements: Array<AgreementType>;
  hasJoinLink?: Maybe<Scalars['Boolean']>;
  hasStudentAttachment?: Maybe<Scalars['Boolean']>;
  hasStudentMarks?: Maybe<Scalars['Boolean']>;
  hasTeacherAttachment?: Maybe<Scalars['Boolean']>;
  homeworkAssignmentId?: Maybe<Scalars['ID']>;
  homeworkAvailable?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  index?: Maybe<Scalars['Int']>;
  lastLessonAgreements: Array<AgreementType>;
  lessonNumber?: Maybe<Scalars['Int']>;
  linkOverrideActive?: Maybe<Scalars['Boolean']>;
  lmsDescription?: Maybe<Scalars['String']>;
  marks: StudentsMarkTypeConnection;
  /** Optional — for group-wide handouts leave NULL; for per-lesson homework point at the specific GroupLesson. */
  materials: Array<MaterialType>;
  module: GroupModuleType;
  name: Scalars['String'];
  needToFinish?: Maybe<Scalars['Boolean']>;
  number: Scalars['Int'];
  startTime: Scalars['Time'];
  students: StudentTypeConnection;
  studentsAttachments: StudentLessonAttachmentTypeConnection;
  taskTypes: Array<Scalars['String']>;
  teacher?: Maybe<TeacherType>;
  teacherApplication?: Maybe<ApplicationType>;
  teachersAttachments: TeacherLessonAttachmentTypeConnection;
  video?: Maybe<Scalars['String']>;
  whiteboardId?: Maybe<Scalars['ID']>;
  zoomProcessingLogs: ZoomProcessingLogTypeConnection;
  zoomRecordingMeta?: Maybe<LessonRecordingType>;
};


export type StudentLessonTypeAttendancesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type StudentLessonTypeMarksArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  lessonId?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  taskType?: InputMaybe<Scalars['String']>;
};


export type StudentLessonTypeStudentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type StudentLessonTypeStudentsAttachmentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type StudentLessonTypeTeachersAttachmentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type StudentLessonTypeZoomProcessingLogsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type StudentMiniCard = {
  __typename?: 'StudentMiniCard';
  email: Scalars['String'];
  finance?: Maybe<StudentMiniCardFinance>;
  firstName: Scalars['String'];
  groups: Array<StudentMiniCardGroupRow>;
  isLmsBlocked: Scalars['Boolean'];
  lastName: Scalars['String'];
  middleName?: Maybe<Scalars['String']>;
  notesCount: Scalars['Int'];
  openTasksCount: Scalars['Int'];
  phone?: Maybe<Scalars['String']>;
  recentNotes: Array<StudentNoteType>;
  recentTasks: Array<StaffTaskType>;
  studentId: Scalars['ID'];
  /** Spec 0038. Null for viewers outside SURVEY_INSIGHT_ROLES — the block carries a teacher's name and a verbatim quote, unlike the counts around it. `null` means «hidden from this viewer», not «no surveys». */
  surveys?: Maybe<StudentMiniCardSurveys>;
};

export type StudentMiniCardFinance = {
  __typename?: 'StudentMiniCardFinance';
  blockReason?: Maybe<Scalars['String']>;
  isBlocked: Scalars['Boolean'];
  isDebtor: Scalars['Boolean'];
  maxOverdueDays: Scalars['Int'];
  overdueAmount: Scalars['Float'];
  overdueInvoiceCount: Scalars['Int'];
  overdueSince?: Maybe<Scalars['Date']>;
  totals: StudentTotals;
};

/**
 * One agreement = one group membership row. A retake student can have
 * two rows with the same group — disambiguated by `agreement_title`.
 */
export type StudentMiniCardGroupRow = {
  __typename?: 'StudentMiniCardGroupRow';
  agreementId: Scalars['ID'];
  agreementTitle: Scalars['String'];
  courseName?: Maybe<Scalars['String']>;
  freeOfCharge?: Maybe<Scalars['Boolean']>;
  groupId: Scalars['ID'];
  groupName: Scalars['String'];
  paymentByCompany?: Maybe<Scalars['Boolean']>;
  statePrefinanced?: Maybe<Scalars['Boolean']>;
  status: Scalars['String'];
  terminatedDate?: Maybe<Scalars['Date']>;
};

/** One recent survey answer, as the manager needs to read it at a glance. */
export type StudentMiniCardSurveySignal = {
  __typename?: 'StudentMiniCardSurveySignal';
  /** The freshest thing the student actually wrote, trimmed. Null when they only gave ratings. */
  excerpt?: Maybe<Scalars['String']>;
  groupName: Scalars['String'];
  lessonNumber?: Maybe<Scalars['Int']>;
  responseId: Scalars['ID'];
  score?: Maybe<Scalars['Float']>;
  sentiment: Scalars['String'];
  submittedAt: Scalars['DateTime'];
  surveyTitle: Scalars['String'];
  teacherName?: Maybe<Scalars['String']>;
};

/**
 * Spec 0038 — what the student has been saying about the course.
 *
 * Every field resolves on its own rather than being built eagerly:
 * `pendingCount` costs two queries and most hover renders never ask for it.
 */
export type StudentMiniCardSurveys = {
  __typename?: 'StudentMiniCardSurveys';
  avgScore?: Maybe<Scalars['Float']>;
  lastSubmittedAt?: Maybe<Scalars['DateTime']>;
  negativeCount: Scalars['Int'];
  pendingCount: Scalars['Int'];
  recentSignals: Array<StudentMiniCardSurveySignal>;
  respondedCount: Scalars['Int'];
};

export type StudentNoteType = {
  __typename?: 'StudentNoteType';
  authorName?: Maybe<Scalars['String']>;
  body: Scalars['String'];
  createdAt: Scalars['DateTime'];
  group?: Maybe<MethodistGroupType>;
  id: Scalars['ID'];
  pinned: Scalars['Boolean'];
  sentiment?: Maybe<Scalars['String']>;
  student?: Maybe<StudentType>;
  updatedAt: Scalars['DateTime'];
};

/** One row of `groupPerformanceSummary.top`/`bottom`/`students`. */
export type StudentPerfRow = {
  __typename?: 'StudentPerfRow';
  averageMark: Scalars['Float'];
  fullName: Scalars['String'];
  marksCount: Scalars['Int'];
  studentId: Scalars['ID'];
};

export type StudentSignUpInput = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  phone: Scalars['String'];
  recaptchaToken: Scalars['String'];
};

export type StudentSignUpLmsMutation = {
  __typename?: 'StudentSignUpLMSMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
  student?: Maybe<StudentType>;
  success?: Maybe<Scalars['Boolean']>;
};

export type StudentSkillType = {
  __typename?: 'StudentSkillType';
  category: Scalars['String'];
  grantedAt?: Maybe<Scalars['DateTime']>;
  grantedCourseName?: Maybe<Scalars['String']>;
  grantedLessonNumber?: Maybe<Scalars['Int']>;
  iconUrl?: Maybe<Scalars['String']>;
  isHidden: Scalars['Boolean'];
  level: Scalars['Int'];
  name: Scalars['String'];
  skillId: Scalars['ID'];
  slug: Scalars['String'];
  source: Scalars['String'];
  years?: Maybe<Scalars['Float']>;
};

/** Everything the student card's «Опросы» tab shows. */
export type StudentSurveyHistoryType = {
  __typename?: 'StudentSurveyHistoryType';
  avgScore?: Maybe<Scalars['Float']>;
  fullName: Scalars['String'];
  negativeCount: Scalars['Int'];
  pending: Array<StudentSurveyPendingRowType>;
  pendingCount: Scalars['Int'];
  respondedCount: Scalars['Int'];
  responses: Array<StudentSurveyResponseRowType>;
  studentId: Scalars['ID'];
};

/** A survey the student was asked but has not answered. */
export type StudentSurveyPendingRowType = {
  __typename?: 'StudentSurveyPendingRowType';
  assignmentId: Scalars['ID'];
  groupId: Scalars['ID'];
  groupName: Scalars['String'];
  lessonDate?: Maybe<Scalars['Date']>;
  lessonId: Scalars['ID'];
  lessonName: Scalars['String'];
  lessonNumber?: Maybe<Scalars['Int']>;
  surveyId: Scalars['ID'];
  surveyTitle: Scalars['String'];
  teacherName?: Maybe<Scalars['String']>;
};

/** One answered survey on the student's card. */
export type StudentSurveyResponseRowType = {
  __typename?: 'StudentSurveyResponseRowType';
  answers: Array<SurveyAnswerViewType>;
  assignmentId: Scalars['ID'];
  courseName?: Maybe<Scalars['String']>;
  excerpt?: Maybe<Scalars['String']>;
  groupId: Scalars['ID'];
  groupName: Scalars['String'];
  lessonDate?: Maybe<Scalars['Date']>;
  lessonId: Scalars['ID'];
  lessonName: Scalars['String'];
  lessonNumber?: Maybe<Scalars['Int']>;
  minScore?: Maybe<Scalars['Float']>;
  questions: Array<SurveyQuestionType>;
  responseId: Scalars['ID'];
  score?: Maybe<Scalars['Float']>;
  scoredAnswersCount: Scalars['Int'];
  sentiment: Scalars['String'];
  submittedAt: Scalars['DateTime'];
  surveyId: Scalars['ID'];
  surveyTitle: Scalars['String'];
  teacherId?: Maybe<Scalars['ID']>;
  teacherName?: Maybe<Scalars['String']>;
};

export type StudentTimelineConnection = {
  __typename?: 'StudentTimelineConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<StudentTimelineEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `StudentTimeline` and its cursor. */
export type StudentTimelineEdge = {
  __typename?: 'StudentTimelineEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<StudentTimelineEventType>;
};

export type StudentTimelineEventType = Node & {
  __typename?: 'StudentTimelineEventType';
  date: Scalars['Date'];
  /** The ID of the object */
  id: Scalars['ID'];
  label?: Maybe<Scalars['String']>;
  meta?: Maybe<Scalars['GenericScalar']>;
  type: TimelineEventTypeEnum;
};

/**
 * Wrapper so the field can grow extra aggregates later without a
 * breaking schema change (e.g. `top_level_currency`, `as_of`).
 */
export type StudentTotals = {
  __typename?: 'StudentTotals';
  byCurrency: Array<StudentTotalsRow>;
};

/**
 * One row per currency, over the active debt-bearing agreements.
 *
 * `total_debt` is Σ «взнос» debt of the instalments ALREADY DUE (ТЗ 0036:
 * date < today), with any plan write-down netted off earliest-first; the rest
 * of the unpaid plan is `total_upcoming`. `total_paid` is Σ instalment
 * coverage clamped per instalment — NOT `budget − debt` (that formula would
 * book the whole future plan as paid once the date gate landed).
 * `totalBudget = totalPaid + totalDebt + totalUpcoming` holds except when a
 * plan write-down was booked before the money arrived: the write-down lowers
 * the budget while the money received stays visible in full.
 * `outstanding_invoices` is the Fakturownia outstanding on `issued` invoices
 * reached dual-chain.
 */
export type StudentTotalsRow = {
  __typename?: 'StudentTotalsRow';
  agreementsActive: Scalars['Int'];
  agreementsTerminated: Scalars['Int'];
  currency: Scalars['String'];
  outstandingInvoices: Scalars['Float'];
  totalBudget: Scalars['Float'];
  totalDebt: Scalars['Float'];
  totalPaid: Scalars['Float'];
  totalUpcoming: Scalars['Float'];
};

export type StudentType = Node & {
  __typename?: 'StudentType';
  accountsPayables?: Maybe<Array<Maybe<AccountsPayableType>>>;
  acquisitionSource?: Maybe<Scalars['String']>;
  agreementIsActive?: Maybe<Scalars['Boolean']>;
  agreementTitle?: Maybe<AgreementType>;
  agreements: Array<AgreementType>;
  attendancePercent?: Maybe<Scalars['Float']>;
  attendances: AttendanceTypeConnection;
  averageMark?: Maybe<Scalars['Float']>;
  conversations: Array<ConversationType>;
  crmLink?: Maybe<Scalars['String']>;
  /** DEPRECATED: use invoice.payment.agreement.student. */
  fakturowniaInvoices: Array<FakturowniaInvoiceType>;
  groupsCount?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  /** True while the student's LMS access is suspended (ТЗ 0074: unpaid invoices — by the robot or by hand). Bare boolean by design — block details are ERP-only. */
  isLmsBlocked?: Maybe<Scalars['Boolean']>;
  lesson: GroupLessonTypeConnection;
  lessons?: Maybe<StudentLessonConnection>;
  marks: StudentsMarkTypeConnection;
  notes: Array<StudentNoteType>;
  registrationDate?: Maybe<Scalars['Date']>;
  responsibleManager?: Maybe<ResponsibleManagerType>;
  slackLinks: Array<SlackUserLinkType>;
  timeline?: Maybe<StudentTimelineConnection>;
  /** Σ budget / paid / debt / outstanding-invoices, grouped by currency. See docs/fakturownia/student_card.md §7. */
  totals?: Maybe<StudentTotals>;
  updatedAt: Scalars['DateTime'];
  user?: Maybe<CustomUserType>;
};


export type StudentTypeAttendancesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type StudentTypeLessonArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
};


export type StudentTypeLessonsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type StudentTypeMarksArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  lessonId?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  taskType?: InputMaybe<Scalars['String']>;
};


export type StudentTypeTimelineArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type StudentTypeConnection = {
  __typename?: 'StudentTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<StudentTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `StudentType` and its cursor. */
export type StudentTypeEdge = {
  __typename?: 'StudentTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<StudentType>;
};

export type StudentWithAgreementCreateMutation = {
  __typename?: 'StudentWithAgreementCreateMutation';
  agreement?: Maybe<AgreementType>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type StudentWithAgreementUpdateMutation = {
  __typename?: 'StudentWithAgreementUpdateMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
  student?: Maybe<StudentType>;
  success?: Maybe<Scalars['Boolean']>;
};

export type StudentsAchievementConnection = {
  __typename?: 'StudentsAchievementConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<StudentsAchievementEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `StudentsAchievement` and its cursor. */
export type StudentsAchievementEdge = {
  __typename?: 'StudentsAchievementEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<AgreementType>;
};

export type StudentsMarkConnection = {
  __typename?: 'StudentsMarkConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<StudentsMarkEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `StudentsMark` and its cursor. */
export type StudentsMarkEdge = {
  __typename?: 'StudentsMarkEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<StudentsMarkType>;
};

/** An enumeration. */
export enum StudentsMarkHwMark {
  /** Содержит ошибки */
  ContainsErrors = 'CONTAINS_ERRORS',
  /** Выполнено */
  Done = 'DONE',
  /** Не выполнено */
  NotDone = 'NOT_DONE'
}

/** An enumeration. */
export enum StudentsMarkTaskType {
  /** Курсовая работа */
  Coursework = 'COURSEWORK',
  /** Дипломный проект */
  GraduationProject = 'GRADUATION_PROJECT',
  /** Домашнее задание */
  Homework = 'HOMEWORK'
}

export type StudentsMarkType = Node & {
  __typename?: 'StudentsMarkType';
  date: Scalars['Date'];
  hwMark?: Maybe<StudentsMarkHwMark>;
  id: Scalars['ID'];
  lesson: GroupLessonType;
  /** Od 1 do 10 */
  mark?: Maybe<Scalars['Int']>;
  student: StudentType;
  taskType?: Maybe<StudentsMarkTaskType>;
};

export type StudentsMarkTypeConnection = {
  __typename?: 'StudentsMarkTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<StudentsMarkTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `StudentsMarkType` and its cursor. */
export type StudentsMarkTypeEdge = {
  __typename?: 'StudentsMarkTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<StudentsMarkType>;
};

export type StudentsReviewsType = {
  __typename?: 'StudentsReviewsType';
  description: Scalars['String'];
  id: Scalars['ID'];
  markCountText: Scalars['String'];
  markText: Scalars['String'];
  marks: Scalars['Float'];
  marksCount: Scalars['Int'];
  seoDescription: Scalars['String'];
  seoImage: Scalars['String'];
  seoKeywords: Scalars['String'];
  seoTitle: Scalars['String'];
  title: Scalars['String'];
};

/**
 * Одна плитка над списком заявок: состояние и сколько их.
 *
 * Отдельный список, а не пять полей: состояния — открытый ряд, и новое
 * пришлось бы добавлять в трёх местах вместо одного.
 */
export type SubmissionStateCountType = {
  __typename?: 'SubmissionStateCountType';
  count: Scalars['Int'];
  state: Scalars['String'];
};

/** Сдача анкеты студентом (LMS). */
export type SubmitCareerLessonExercise = {
  __typename?: 'SubmitCareerLessonExercise';
  applyReport?: Maybe<CareerExerciseApplyReportType>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  lessonsCompleted?: Maybe<Scalars['Int']>;
  lessonsTotal?: Maybe<Scalars['Int']>;
  reward?: Maybe<GrowthRewardType>;
  submission?: Maybe<CareerExerciseSubmissionType>;
  success?: Maybe<Scalars['Boolean']>;
};

/**
 * LMS: score the student's answers and record an attempt (self-check —
 * never gates the lesson).
 */
export type SubmitCareerQuiz = {
  __typename?: 'SubmitCareerQuiz';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  maxScore?: Maybe<Scalars['Int']>;
  results?: Maybe<Array<CareerQuizResultType>>;
  score?: Maybe<Scalars['Int']>;
  success?: Maybe<Scalars['Boolean']>;
};

/**
 * Публичная форма приёма заявок. ЕДИНСТВЕННАЯ анонимная запись в домене.
 *
 * Три правила, каждое из которых существует из-за конкретного риска:
 *
 * * **ответ одинаков для знакомого и незнакомого e-mail** — иначе форма
 *   становится оракулом перебора адресов, и её ответ собирается скриптом.
 *   По той же причине здесь нет ни «вы уже подавали заявку», ни возврата
 *   идентификатора кандидата;
 * * **`CustomUser` не создаётся никогда** — e-mail и телефон у пользователя
 *   уникальны, и анонимная запись заняла бы адрес, на который потом
 *   резолвится реальный подписанный договор;
 * * **сначала сохраняется сырая заявка, потом отдельно триаж** — лид не
 *   должен теряться из-за того, что упала дедупликация.
 *
 * Ошибка триажа НЕ отменяет приём: заявка уже в базе, менеджер разберёт её
 * из админки, а причина остаётся в `process_error`.
 */
export type SubmitFundingForm = {
  __typename?: 'SubmitFundingForm';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
};

/**
 * Student submits (or replaces) their homework: a GitHub link AND/OR a
 * ZIP archive (at least one, both allowed together). Re-submitting after
 * grading resets the grade. No teacher assignment is required (rev.3).
 */
export type SubmitHomeworkMutation = {
  __typename?: 'SubmitHomeworkMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  submission?: Maybe<MyHomeworkSubmissionType>;
  success?: Maybe<Scalars['Boolean']>;
};

export type SubmitSurveyResponseMutation = {
  __typename?: 'SubmitSurveyResponseMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
};

/**
 * Parent is a SurveyResponse of the logged-in student (spec 0027).
 *
 * Includes the student's own answers — their own data. The resolver derives
 * the student from the token and takes no `studentId`, which is exactly what
 * made the original `pendingSurveysCount` an IDOR.
 */
export type SubmittedSurveyType = {
  __typename?: 'SubmittedSurveyType';
  answers: Array<SurveyAnswerViewType>;
  groupName: Scalars['String'];
  lessonName: Scalars['String'];
  lessonNumber: Scalars['Int'];
  questions: Array<SurveyQuestionForStudentType>;
  responseId: Scalars['ID'];
  submittedAt: Scalars['DateTime'];
  surveyTitle: Scalars['String'];
};

export type SuccessStoriesBlockType = {
  __typename?: 'SuccessStoriesBlockType';
  id: Scalars['ID'];
  stories: Array<SuccessStoriesType>;
  title: Scalars['String'];
};

export type SuccessStoriesConnection = {
  __typename?: 'SuccessStoriesConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<SuccessStoriesEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `SuccessStories` and its cursor. */
export type SuccessStoriesEdge = {
  __typename?: 'SuccessStoriesEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<SuccessStoriesType>;
};

export type SuccessStoriesType = {
  __typename?: 'SuccessStoriesType';
  adviceText?: Maybe<Scalars['String']>;
  adviceTitle?: Maybe<Scalars['String']>;
  author: AuthorsType;
  banner?: Maybe<CourseBanner>;
  date: Scalars['Date'];
  id: Scalars['ID'];
  interview?: Maybe<Scalars['String']>;
  interviewText?: Maybe<Scalars['String']>;
  native?: Maybe<NativeInfoType>;
  nativeTitle?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['String']>;
  previewImage?: Maybe<Scalars['String']>;
  published: Scalars['Boolean'];
  seoDescription: Scalars['String'];
  seoImage: Scalars['String'];
  seoKeywords: Scalars['String'];
  seoSlug?: Maybe<Scalars['String']>;
  seoTitle: Scalars['String'];
  storyBlock: Array<SuccessStoriesBlockType>;
  storyImage?: Maybe<Scalars['String']>;
  storyShortText?: Maybe<Scalars['String']>;
  storyText?: Maybe<Scalars['String']>;
  storyTime?: Maybe<Scalars['String']>;
  studentImage?: Maybe<Scalars['String']>;
  studentName?: Maybe<Scalars['String']>;
  thesis: Array<ThesesType>;
  title: Scalars['String'];
};

/**
 * The shared filter for every analytics query.
 *
 * An InputObjectType on a QUERY deviates from the house style (every other
 * query here takes flat kwargs). It earns the deviation: the same twelve
 * fields feed `surveyAnalytics`, `surveyQuestionBreakdown`, `surveyComments`
 * and `surveySignals` — flat kwargs would be four copies kept in sync by
 * hand, and codegen gives the ERP ONE TS type it can hold as filter-panel
 * state and pass to all of them.
 */
export type SurveyAnalyticsFilter = {
  courseIds?: InputMaybe<Array<Scalars['ID']>>;
  /** Filters the TRIGGER LESSON's date, NOT the submission time. `eligibleCount` is a property of the roster and has no submission date — windowing the numerator while the denominator stays open is what made responseRate wrong before spec 0038. */
  dateFrom?: InputMaybe<Scalars['Date']>;
  dateTo?: InputMaybe<Scalars['Date']>;
  groupIds?: InputMaybe<Array<Scalars['ID']>>;
  includeArchivedSurveys?: InputMaybe<Scalars['Boolean']>;
  lessonNumberFrom?: InputMaybe<Scalars['Int']>;
  lessonNumberTo?: InputMaybe<Scalars['Int']>;
  /** Question topics: lesson | teacher | materials | homework | platform | support | nps. Selects QUESTIONS, not attachments — this is what makes «средняя оценка учебника по курсу» meaningful across DIFFERENT surveys. While it is set, avgScore / negativeShare / eligible / responseRate come back null: those are computed across ALL of a response's questions and would otherwise silently answer a different question than the one on screen. */
  metrics?: InputMaybe<Array<Scalars['String']>>;
  onlyActive?: InputMaybe<Scalars['Boolean']>;
  /** manual | plan */
  origin?: InputMaybe<Scalars['String']>;
  planId?: InputMaybe<Scalars['ID']>;
  search?: InputMaybe<Scalars['String']>;
  surveyIds?: InputMaybe<Array<Scalars['ID']>>;
  teacherIds?: InputMaybe<Array<Scalars['ID']>>;
};

/** One bucket of the chosen dimension. */
export type SurveyAnalyticsRowType = {
  __typename?: 'SurveyAnalyticsRowType';
  answersCount: Scalars['Int'];
  /** null for the question-level dimensions (metric, question_type): a roster cannot be attributed to a topic. */
  assignmentsCount?: Maybe<Scalars['Int']>;
  /** 1–10 */
  avgNps?: Maybe<Scalars['Float']>;
  /** 1–5, pooling `rating` + `teacher_rating` exactly as surveySummary does. */
  avgRating?: Maybe<Scalars['Float']>;
  avgScore?: Maybe<Scalars['Float']>;
  /** 1–5, teacher_rating only */
  avgTeacherRating?: Maybe<Scalars['Float']>;
  eligibleCount?: Maybe<Scalars['Int']>;
  /** null = the «—» bucket (e.g. a lesson with no teacher). The row is still returned. */
  key?: Maybe<Scalars['ID']>;
  label: Scalars['String'];
  /** Percent of SCALE ANSWERS at or below the bad-answer cutoff. Defined for every dimension, unlike negativeShare which is response-level. */
  lowAnswersShare?: Maybe<Scalars['Float']>;
  /** Percent of RESPONSES with at least one bad answer. Null for question-level dimensions — there the answer-level `lowAnswersShare` is the meaningful one. */
  negativeShare?: Maybe<Scalars['Float']>;
  responseRate?: Maybe<Scalars['Float']>;
  responsesCount: Scalars['Int'];
  sortKey: Scalars['String'];
  studentsCount: Scalars['Int'];
  /** How many DIFFERENT surveys this bucket pools. avgScore is only comparable within one survey, so the UI greys it out when this is > 1. */
  surveysCount: Scalars['Int'];
  yesShare?: Maybe<Scalars['Float']>;
};

export type SurveyAnswerInput = {
  questionId: Scalars['ID'];
  value: Scalars['JSONString'];
};

/** Parent is a SurveyAnswer. */
export type SurveyAnswerViewType = {
  __typename?: 'SurveyAnswerViewType';
  questionId: Scalars['ID'];
  value: Scalars['JSONString'];
};

/** Parent is the dict built by services.results.assignment_results. */
export type SurveyAssignmentResultsType = {
  __typename?: 'SurveyAssignmentResultsType';
  assignment: SurveyAssignmentType;
  questionResults: Array<SurveyQuestionResultType>;
  respondents: Array<SurveyRespondentStatusType>;
};

/**
 * Parent is a SurveyAssignment (survey/group/trigger_lesson+module
 * select_related by the queries).
 */
export type SurveyAssignmentType = {
  __typename?: 'SurveyAssignmentType';
  createdAt: Scalars['DateTime'];
  eligibleCount: Scalars['Int'];
  groupId: Scalars['ID'];
  groupName: Scalars['String'];
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  lessonDate?: Maybe<Scalars['Date']>;
  lessonId: Scalars['ID'];
  lessonName: Scalars['String'];
  lessonNumber: Scalars['Int'];
  /** 'manual' | 'plan' (spec 0027). Survives the rule's deletion, so the UI can still say «создано правилом». */
  origin: Scalars['String'];
  /** The targeting rule that owns this row; null for a manual attach, and for a rule-made row whose rule was deleted. */
  planId?: Maybe<Scalars['ID']>;
  respondedCount: Scalars['Int'];
  surveyId: Scalars['ID'];
  surveyTitle: Scalars['String'];
};

/** Keyset page over the comment feed. */
export type SurveyCommentPageType = {
  __typename?: 'SurveyCommentPageType';
  /** Pass back as `after` for the next page. Null when the feed is exhausted. */
  cursor?: Maybe<Scalars['String']>;
  hasNext: Scalars['Boolean'];
  items: Array<SurveyCommentType>;
};

/** A free-text answer with everything needed to act on it. */
export type SurveyCommentType = {
  __typename?: 'SurveyCommentType';
  answerId: Scalars['ID'];
  courseName?: Maybe<Scalars['String']>;
  groupId: Scalars['ID'];
  groupName: Scalars['String'];
  lessonDate?: Maybe<Scalars['Date']>;
  lessonNumber?: Maybe<Scalars['Int']>;
  metric: Scalars['String'];
  questionId: Scalars['ID'];
  questionText: Scalars['String'];
  responseId: Scalars['ID'];
  score?: Maybe<Scalars['Float']>;
  sentiment: Scalars['String'];
  studentId: Scalars['ID'];
  studentName: Scalars['String'];
  submittedAt: Scalars['DateTime'];
  surveyId: Scalars['ID'];
  surveyTitle: Scalars['String'];
  teacherId?: Maybe<Scalars['ID']>;
  teacherName?: Maybe<Scalars['String']>;
  text: Scalars['String'];
};

/** Parent is {'key', 'label', 'count'}. */
export type SurveyDistributionBucketType = {
  __typename?: 'SurveyDistributionBucketType';
  count: Scalars['Int'];
  key: Scalars['String'];
  label: Scalars['String'];
};

/**
 * One attachment of a survey to a group.
 *
 * Parent is a row of `services.assignments.survey_assignment_rows`, shared
 * verbatim by `surveySummary.groupBreakdown` and by `surveyAssignments`
 * (spec 0038) — the two directions of the same fact, so they must not be
 * built twice.
 *
 * The name reads oddly for the survey-side query: it is kept because
 * renaming would change the generated TS type and break the ERP's existing
 * summary consumers for no functional gain. Additive fields are free.
 */
export type SurveyGroupBreakdownType = {
  __typename?: 'SurveyGroupBreakdownType';
  assignmentId: Scalars['ID'];
  averageRating?: Maybe<Scalars['Float']>;
  /** Spec 0038 — mean of the 0–100 normalized scale answers. */
  avgScore?: Maybe<Scalars['Float']>;
  courseId?: Maybe<Scalars['ID']>;
  courseName?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  eligibleCount: Scalars['Int'];
  groupId: Scalars['ID'];
  groupName: Scalars['String'];
  isActive: Scalars['Boolean'];
  lessonDate?: Maybe<Scalars['Date']>;
  lessonId: Scalars['ID'];
  lessonName: Scalars['String'];
  lessonNumber: Scalars['Int'];
  /** Spec 0038 — percent of responses containing at least one bad answer. Counted off the WORST answer, not the mean: 5★ everywhere and 1★ to the teacher is a negative response. */
  negativeShare?: Maybe<Scalars['Float']>;
  origin: Scalars['String'];
  planId?: Maybe<Scalars['ID']>;
  respondedCount: Scalars['Int'];
  /** Percent, or null when nobody is eligible — «никого не спрашивали» is not the same fact as 0%. */
  responseRate?: Maybe<Scalars['Float']>;
  surveyId: Scalars['ID'];
  surveyTitle: Scalars['String'];
  teacherId?: Maybe<Scalars['ID']>;
  teacherName?: Maybe<Scalars['String']>;
};

export type SurveyInput = {
  courseId?: InputMaybe<Scalars['ID']>;
  defaultLessonNumber?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  questions: Array<SurveyQuestionInput>;
  title: Scalars['String'];
};

/**
 * One cell of the answer table.
 *
 * Its own type rather than a reuse of `SurveyAnswerViewType`: that one
 * resolves attributes off a SurveyAnswer MODEL, and the matrix builds plain
 * dicts (it never loads the objects). Reusing it produced a resolver error
 * at exactly one path in the response — invisible to a service-level test,
 * caught only by opening the screen.
 */
export type SurveyMatrixAnswerType = {
  __typename?: 'SurveyMatrixAnswerType';
  questionId: Scalars['ID'];
  value: Scalars['JSONString'];
};

/** One respondent's row in the answer table. */
export type SurveyMatrixRowType = {
  __typename?: 'SurveyMatrixRowType';
  answers: Array<SurveyMatrixAnswerType>;
  fullName: Scalars['String'];
  groupId: Scalars['ID'];
  groupName: Scalars['String'];
  lessonNumber?: Maybe<Scalars['Int']>;
  responseId: Scalars['ID'];
  score?: Maybe<Scalars['Float']>;
  sentiment: Scalars['String'];
  studentId: Scalars['ID'];
  submittedAt: Scalars['DateTime'];
};

/** Parent is a Group the rule currently points at. */
export type SurveyPlanGroupRefType = {
  __typename?: 'SurveyPlanGroupRefType';
  groupId: Scalars['ID'];
  groupName: Scalars['String'];
};

/**
 * One targeting rule (spec 0027). `id` present = update that rule,
 * absent = create; a saved rule the client omits is deleted.
 */
export type SurveyPlanInput = {
  /** Required for scope='course' unless the survey is already course-bound. */
  courseId?: InputMaybe<Scalars['ID']>;
  groupIds?: InputMaybe<Array<Scalars['ID']>>;
  id?: InputMaybe<Scalars['ID']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  onlyActiveGroups?: InputMaybe<Scalars['Boolean']>;
  /** 'groups' (frozen list) | 'course' (live rule, picks up future groups too). */
  scope: Scalars['String'];
  skipPastLessons?: InputMaybe<Scalars['Boolean']>;
  /** 'lesson_number' | 'last_lesson'. Both resolve to a concrete lesson — that is what keeps the student's agreement bounds and the teacher attribution working. */
  triggerKind: Scalars['String'];
  triggerLessonNumber?: InputMaybe<Scalars['Int']>;
};

/** Parent is a SurveyPlan instance. */
export type SurveyPlanType = {
  __typename?: 'SurveyPlanType';
  assignmentsCount: Scalars['Int'];
  courseId?: Maybe<Scalars['ID']>;
  courseName?: Maybe<Scalars['String']>;
  /** The groups the rule points at RIGHT NOW — the frozen list for scope=groups, the derived one for scope=course (so a group created after the rule shows up here). */
  groups: Array<SurveyPlanGroupRefType>;
  /** Once true, the rule's trigger is frozen (PLAN_LOCKED) — add a second rule instead of moving it. */
  hasResponses: Scalars['Boolean'];
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  onlyActiveGroups: Scalars['Boolean'];
  respondedCount: Scalars['Int'];
  scope: Scalars['String'];
  skipPastLessons: Scalars['Boolean'];
  triggerKind: Scalars['String'];
  triggerLessonNumber?: Maybe<Scalars['Int']>;
};

/**
 * One question, split by a dimension.
 *
 * Every distribution is produced by the SAME `results._aggregate` the other
 * two result screens use, fed raw `value`s per slice — not re-derived from
 * `numeric_value`. That is the only way `total` can be guaranteed identical
 * to the matching `surveySummary.questionResults` entry, which a parity
 * test asserts field for field.
 */
export type SurveyQuestionBreakdownType = {
  __typename?: 'SurveyQuestionBreakdownType';
  dimension: Scalars['String'];
  question: SurveyQuestionType;
  slices: Array<SurveyQuestionSliceType>;
  total: SurveyQuestionResultType;
};

/** Parent is a SurveyQuestion instance. */
export type SurveyQuestionForStudentType = {
  __typename?: 'SurveyQuestionForStudentType';
  id: Scalars['ID'];
  number: Scalars['Int'];
  options: Array<Scalars['String']>;
  questionType: Scalars['String'];
  required: Scalars['Boolean'];
  text: Scalars['String'];
};

export type SurveyQuestionInput = {
  id?: InputMaybe<Scalars['ID']>;
  metric?: InputMaybe<Scalars['String']>;
  options?: InputMaybe<Array<Scalars['String']>>;
  questionType: Scalars['String'];
  required: Scalars['Boolean'];
  text: Scalars['String'];
};

/** Parent is the dict built by services.results._aggregate. */
export type SurveyQuestionResultType = {
  __typename?: 'SurveyQuestionResultType';
  answersCount: Scalars['Int'];
  average?: Maybe<Scalars['Float']>;
  distribution: Array<SurveyDistributionBucketType>;
  question: SurveyQuestionType;
};

/** One slice of a single question's answers. */
export type SurveyQuestionSliceType = {
  __typename?: 'SurveyQuestionSliceType';
  key?: Maybe<Scalars['ID']>;
  label: Scalars['String'];
  responsesCount: Scalars['Int'];
  result: SurveyQuestionResultType;
  sortKey: Scalars['String'];
};

/** One question on the bulk-tagging screen (spec 0038). */
export type SurveyQuestionTagRowType = {
  __typename?: 'SurveyQuestionTagRowType';
  courseName?: Maybe<Scalars['String']>;
  metric: Scalars['String'];
  number: Scalars['Int'];
  questionId: Scalars['ID'];
  questionType: Scalars['String'];
  /** Keyword guess for an untagged question, '' when unsure. A human confirms every row — a wrong guess costs one click, a missing one costs reading the question. */
  suggestedMetric: Scalars['String'];
  surveyId: Scalars['ID'];
  surveyTitle: Scalars['String'];
  text: Scalars['String'];
};

/** Parent is a SurveyQuestion instance. */
export type SurveyQuestionType = {
  __typename?: 'SurveyQuestionType';
  id: Scalars['ID'];
  /** Spec 0038 — what the question measures, independent of how it is asked: lesson | teacher | materials | homework | platform | support | nps, or '' when untagged. This is what makes pooling one metric across DIFFERENT surveys meaningful. Editable even after the survey has answers. */
  metric: Scalars['String'];
  number: Scalars['Int'];
  options: Array<Scalars['String']>;
  questionType: Scalars['String'];
  required: Scalars['Boolean'];
  text: Scalars['String'];
};

/** Parent is {'student': Student, 'response': SurveyResponse|None}. */
export type SurveyRespondentStatusType = {
  __typename?: 'SurveyRespondentStatusType';
  email?: Maybe<Scalars['String']>;
  fullName: Scalars['String'];
  responded: Scalars['Boolean'];
  responseId?: Maybe<Scalars['ID']>;
  studentId: Scalars['ID'];
  submittedAt?: Maybe<Scalars['DateTime']>;
};

/** Parent is {'response': SurveyResponse, 'answers': [SurveyAnswer]}. */
export type SurveyResponseDetailType = {
  __typename?: 'SurveyResponseDetailType';
  answers: Array<SurveyAnswerViewType>;
  fullName: Scalars['String'];
  responseId: Scalars['ID'];
  studentId: Scalars['ID'];
  submittedAt: Scalars['DateTime'];
};

/**
 * Respondents × questions for one survey (spec 0038 revision).
 *
 * The per-assignment screen shows one group's roster and opens ONE student
 * at a time in a drawer; «как отвечают разные люди на один и тот же опрос»
 * meant opening it N times.
 */
export type SurveyResponseMatrixType = {
  __typename?: 'SurveyResponseMatrixType';
  questions: Array<SurveyQuestionType>;
  rows: Array<SurveyMatrixRowType>;
  survey: SurveyType;
};

/** An outlier worth acting on. */
export type SurveySignalType = {
  __typename?: 'SurveySignalType';
  delta?: Maybe<Scalars['Float']>;
  dimension: Scalars['String'];
  key?: Maybe<Scalars['ID']>;
  /** low_rating | low_response_rate | high_negative_share | rating_drop | no_responses */
  kind: Scalars['String'];
  label: Scalars['String'];
  previousValue?: Maybe<Scalars['Float']>;
  /** Rows below minSample are suppressed (an under-sampled alert is noise) — but N is always reported for the ones that survive. */
  sampleSize: Scalars['Int'];
  /** warning | critical */
  severity: Scalars['String'];
  value: Scalars['Float'];
};

/**
 * Parent is the dict built by services.results.survey_summary (0027).
 *
 * The per-question maths is the SAME `_aggregate` the per-assignment screen
 * uses, on a wider value pool — so the two screens can never disagree about
 * the same answers.
 */
export type SurveySummaryType = {
  __typename?: 'SurveySummaryType';
  assignmentsCount: Scalars['Int'];
  eligibleCount: Scalars['Int'];
  groupBreakdown: Array<SurveyGroupBreakdownType>;
  groupsCount: Scalars['Int'];
  questionResults: Array<SurveyQuestionResultType>;
  respondedCount: Scalars['Int'];
  responseRate?: Maybe<Scalars['Float']>;
  survey: SurveyType;
};

/**
 * Parent is the dict built by services.targeting_preview.
 *
 * The point of this type is that «в группе нет занятия №8» becomes a greyed
 * row with a reason BEFORE the manager saves, instead of an entry in the
 * skip report afterwards.
 */
export type SurveyTargetGroupType = {
  __typename?: 'SurveyTargetGroupType';
  alreadyAttached: Scalars['Boolean'];
  courseId?: Maybe<Scalars['ID']>;
  courseName?: Maybe<Scalars['String']>;
  groupId: Scalars['ID'];
  groupName: Scalars['String'];
  isActive: Scalars['Boolean'];
  lessonsCount: Scalars['Int'];
  resolvedLessonDate?: Maybe<Scalars['Date']>;
  resolvedLessonId?: Maybe<Scalars['ID']>;
  resolvedLessonIsOver: Scalars['Boolean'];
  resolvedLessonName?: Maybe<Scalars['String']>;
  resolvedLessonNumber?: Maybe<Scalars['Int']>;
  /** NO_LESSON | LESSON_OVER | COURSE_MISMATCH, or null when the group would be attached cleanly. */
  skipReason?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['Date']>;
};

/**
 * Parent is a dict from services.plans (`skipped[]`).
 *
 * A populated list alongside `success: true` is the NORMAL outcome — the
 * rule saved, some groups just have no lesson N.
 */
export type SurveyTargetingSkipType = {
  __typename?: 'SurveyTargetingSkipType';
  groupId: Scalars['ID'];
  groupName: Scalars['String'];
  reason: Scalars['String'];
};

/** Parent is the report dict from services.plans / builder. */
export type SurveyTargetingType = {
  __typename?: 'SurveyTargetingType';
  assignmentsAdopted: Scalars['Int'];
  assignmentsCreated: Scalars['Int'];
  assignmentsDeactivated: Scalars['Int'];
  assignmentsDeleted: Scalars['Int'];
  plans: Array<SurveyPlanType>;
  skipped: Array<SurveyTargetingSkipType>;
};

/**
 * Parent is a Survey instance (course select_related, questions
 * prefetched by the queries).
 */
export type SurveyType = {
  __typename?: 'SurveyType';
  assignmentsCount: Scalars['Int'];
  courseId?: Maybe<Scalars['ID']>;
  courseName?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  defaultLessonNumber?: Maybe<Scalars['Int']>;
  description: Scalars['String'];
  /** Spec 0038 — names of the groups this survey is attached to (capped). The list used to show only a count, which answered «сколько» but never «какие». */
  groupNames: Array<Scalars['String']>;
  hasResponses: Scalars['Boolean'];
  id: Scalars['ID'];
  isArchived: Scalars['Boolean'];
  questions: Array<SurveyQuestionType>;
  questionsCount: Scalars['Int'];
  title: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

/** Sync accounts + every cloud recording in Zoom for a date range. */
export type SyncAllZoomRecordingsMutation = {
  __typename?: 'SyncAllZoomRecordingsMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
};

/**
 * On-demand «обновить сообщения»: enqueue a Slack backfill PLUS a Gmail
 * backfill of the latest mail (metadata-first, so it's cheap). Without
 * group_id it syncs every ENABLED workspace of an ACTIVE group (last lesson
 * within SYNC_ACTIVE_DAYS, or no lessons yet — spec 0032; the old predicate
 * demanded a FUTURE lesson and on real data matched nothing) plus legacy
 * channel links; with group_id it
 * syncs that group's workspace regardless of activity — the group-card
 * button keeps working for finished groups. Async via Celery — the button
 * returns immediately; new messages appear once the worker finishes.
 */
export type SyncCommunicationsNowMutation = {
  __typename?: 'SyncCommunicationsNowMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  queued?: Maybe<Scalars['Boolean']>;
  success?: Maybe<Scalars['Boolean']>;
};

/**
 * On-demand 'refresh mail' button: enqueue a Gmail backfill of the latest
 * ~100 messages per mailbox. Runs async via Celery so the request returns
 * immediately; the new mail appears once the worker finishes.
 */
export type SyncGmailNowMutation = {
  __typename?: 'SyncGmailNowMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  queued?: Maybe<Scalars['Boolean']>;
  success?: Maybe<Scalars['Boolean']>;
};

/**
 * Create (if needed) and refill the group's SendGrid contact list.
 *
 * Idempotent — contacts are upserted by email, so re-running re-syncs rather
 * than duplicating. SendGrid processes the upload asynchronously, so the
 * contact count updates a few seconds later.
 */
export type SyncGroupSendgridList = {
  __typename?: 'SyncGroupSendgridList';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  list?: Maybe<SendgridGroupListType>;
  success?: Maybe<Scalars['Boolean']>;
};

/**
 * Кнопка «Пересчитать навыки» на карточке участника.
 *
 * 🔴 Поля обязаны покрывать ВСЮ сводку `skill_grant.grant_for_student`:
 * ответ собирается как `cls(**stats)`, и лишний ключ — это `TypeError`, то
 * есть пятисотка на кнопку. Так и было с `reattributed`: сводка его отдавала
 * с самого начала, а поля для него не завели, и кнопка падала на любом
 * студенте (ТЗ 0040, попутная находка). Тест `test_sync_button_returns_full_stats`
 * держит два списка вместе.
 */
export type SyncStudentCourseSkills = {
  __typename?: 'SyncStudentCourseSkills';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  demoted?: Maybe<Scalars['Int']>;
  granted?: Maybe<Scalars['Int']>;
  promoted?: Maybe<Scalars['Int']>;
  raised?: Maybe<Scalars['Int']>;
  reattributed?: Maybe<Scalars['Int']>;
  success?: Maybe<Scalars['Boolean']>;
  unchanged?: Maybe<Scalars['Int']>;
};

export type SyncZoomAccountsMutation = {
  __typename?: 'SyncZoomAccountsMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type SyncZoomRecordingsMutation = {
  __typename?: 'SyncZoomRecordingsMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
};

/** Refresh the Zoom account usage summary (storage quota + counts). */
export type SyncZoomUsageMutation = {
  __typename?: 'SyncZoomUsageMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
};

/**
 * Что сервер принимает — чтобы у клиента не завелась вторая копия списка.
 *
 * Тот же приём, что у `taskLinkKinds`: правило живёт на сервере в одном
 * экземпляре, клиент его читает, а не повторяет.
 */
export type TaskAttachmentLimitsType = {
  __typename?: 'TaskAttachmentLimitsType';
  /** Готовая строка для атрибута `accept` поля выбора файла. */
  acceptAttribute: Scalars['String'];
  allowedExtensions: Array<Scalars['String']>;
  maxBytes: Scalars['Int'];
  maxPerTask: Scalars['Int'];
};

/** Короткоживущая подписанная ссылка. Клиент НЕ кеширует её. */
export type TaskAttachmentUrlType = {
  __typename?: 'TaskAttachmentUrlType';
  expiresAt: Scalars['DateTime'];
  originalName: Scalars['String'];
  url: Scalars['String'];
};

/**
 * Ссылка на объект: вид + его pk. Одна форма и для фильтра, и для записи.
 *
 * `id` — сырой pk, а не relay-id: половина связуемых типов (дофинансирование,
 * опросы) вообще не relay-ноды, и общего кодирования у них нет. `to_pk`
 * переварит оба варианта.
 */
export type TaskLinkInput = {
  id: Scalars['ID'];
  kind: Scalars['String'];
};

/** Вид связи, доступный ЭТОМУ пользователю (`taskLinkKinds`). */
export type TaskLinkKindType = {
  __typename?: 'TaskLinkKindType';
  key: Scalars['String'];
  label: Scalars['String'];
};

/**
 * Одна связь задачи — ПЛОСКОЙ записью, а не union'ом из двенадцати типов.
 *
 * Union заставил бы клиента писать двенадцать инлайн-фрагментов и тянуть
 * тяжёлые типы (`StudentType` со всеми его обходами) ради строки-подписи; к
 * тому же три дофин-типа — вовсе не `DjangoObjectType`. Здесь ровно то, что
 * рисует строка списка: чем является объект, как он называется и жив ли он.
 */
export type TaskLinkType = {
  __typename?: 'TaskLinkType';
  /** Когда связь завели. Пусто у подсказок поиска — там связи ещё нет. */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** Кто завёл связь. Это ВСЯ активность по связям, которую мы честно знаем: снятие нигде не журналируется, строка просто исчезает. */
  createdByName?: Maybe<Scalars['String']>;
  /** Приписка: курс у группы, дата у занятия, e-mail у человека. */
  hint: Scalars['String'];
  id: Scalars['ID'];
  kind: Scalars['String'];
  /** Объекта больше нет в базе. Связь НЕ прячется: задача без неё теряет причину своего существования — покажите её как «объект удалён» и дайте снять. */
  missing: Scalars['Boolean'];
  /** Подпись объекта. У удалённого объекта — служебная метка; смотрите `missing`. */
  name: Scalars['String'];
  objectId: Scalars['ID'];
};

/**
 * Старый язык предмета задачи (ТЗ 0014), сохранённый ради совместимости.
 *
 * До 0064 предмет был один, и применение `subject` переписывало все четыре
 * взаимоисключающих FK разом. Колонок больше нет: теперь это «заменить связи
 * ЭТИХ видов на такие-то» (`SUBJECT_LINK_KINDS`). Им ходят MCP и клиенты,
 * написанные до 0064; новый код пишет `links`.
 */
export type TaskSubjectInput = {
  /** kind="student" only — the roster row (договор) the task is filed against. */
  agreementId?: InputMaybe<Scalars['ID']>;
  /** kind="student" only — the group the student was picked from (context shown on the card). */
  groupId?: InputMaybe<Scalars['ID']>;
  /** PK of the subject. Required unless kind is "none". */
  id?: InputMaybe<Scalars['ID']>;
  /** One of "student" | "group" | "teacher" | "none". "none" is a personal to-do with no subject. */
  kind: Scalars['String'];
};

/** Строка сводки «ходит ли робот»: одна задача, её последний прогон. */
export type TaskSummaryType = {
  __typename?: 'TaskSummaryType';
  lastRun?: Maybe<ImportRunType>;
  /** Имя переменной окружения — чтобы человек знал, что именно включать. */
  scheduleFlag: Scalars['String'];
  /** Ходит ли по расписанию. Все три флага по умолчанию выключены, и без этого «последний прогон вчера» читается как поломка, хотя задача просто не включена. */
  scheduled: Scalars['Boolean'];
  /** Короткое имя: watch | match | … */
  task: Scalars['String'];
  /** Полное имя, оно же ключ в журнале. */
  taskName: Scalars['String'];
};

/** Parent is a TeacherAiProfile instance. */
export type TeacherAiProfileType = {
  __typename?: 'TeacherAiProfileType';
  aiModel: Scalars['String'];
  analyzedAt?: Maybe<Scalars['DateTime']>;
  communication: Array<AiSourceTextType>;
  communicationScore?: Maybe<Scalars['Int']>;
  errorMessage: Scalars['String'];
  languages: Array<AiLanguageType>;
  promptVersion: Scalars['String'];
  provenance: Array<AiFieldProvenanceType>;
  redFlags: Array<Scalars['String']>;
  runs: Array<TeacherAiRunType>;
  skills: Array<AiSkillType>;
  status: Scalars['String'];
  strengths: Array<Scalars['String']>;
  suggestions: Array<TeacherCourseSuggestionType>;
  summary: Array<AiSourceTextType>;
  suspicionNotes: Scalars['String'];
  suspicious: Scalars['Boolean'];
  teacherId: Scalars['ID'];
  teachingExperience: Array<AiSourceTextType>;
  teachingScore?: Maybe<Scalars['Int']>;
  yearsExperienceTeaching?: Maybe<Scalars['Int']>;
  yearsExperienceTotal?: Maybe<Scalars['Int']>;
};

export type TeacherAiRunType = {
  __typename?: 'TeacherAiRunType';
  aiModel: Scalars['String'];
  analyzedAt?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  documentId?: Maybe<Scalars['ID']>;
  /** Course ids the model invented that were dropped server-side. Surfaced rather than swallowed so systematic hallucination is visible in the data. */
  droppedCourseIds: Array<Scalars['String']>;
  errorMessage: Scalars['String'];
  id: Scalars['ID'];
  interviewId?: Maybe<Scalars['ID']>;
  promptVersion: Scalars['String'];
  sourceKind: Scalars['String'];
  status: Scalars['String'];
};

/** A group the teacher is qualified for that still needs staffing. */
export type TeacherCandidateGroupType = {
  __typename?: 'TeacherCandidateGroupType';
  courseId?: Maybe<Scalars['ID']>;
  courseName?: Maybe<Scalars['String']>;
  groupId: Scalars['ID'];
  groupName: Scalars['String'];
  nextOpenDate?: Maybe<Scalars['Date']>;
  /** Future lessons with no teacher application, or with a terminated one. */
  openLessons: Scalars['Int'];
  startDate?: Maybe<Scalars['Date']>;
};

/**
 * Строка преподавателя в средней колонке коммуникатора (ТЗ 0032).
 *
 * Та же форма, что у студенческой, минус `in_roster`/`terminated`: у
 * преподавателя нет договора со студенческой семантикой, а «ведёт группу или
 * нет» уже решено самим попаданием в список.
 */
export type TeacherCommsBadgeRow = {
  __typename?: 'TeacherCommsBadgeRow';
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  teacherId: Scalars['ID'];
  unhandled: Scalars['Boolean'];
  unhandledMail: Scalars['Boolean'];
  unhandledSlack: Scalars['Boolean'];
  unread: Scalars['Int'];
  unreadMail: Scalars['Int'];
  unreadSlack: Scalars['Int'];
};

/** Minimal {id, name} of a course a teacher is qualified to teach. */
export type TeacherCourseRef = {
  __typename?: 'TeacherCourseRef';
  id: Scalars['ID'];
  name: Scalars['String'];
};

/**
 * A PROPOSAL. Accepting it is what writes `coursesCanTeach`; nothing here
 * is applied automatically.
 */
export type TeacherCourseSuggestionType = {
  __typename?: 'TeacherCourseSuggestionType';
  /** The course is ALREADY in coursesCanTeach — accepting adds nothing new. */
  alreadyQualified: Scalars['Boolean'];
  confidence: Scalars['Float'];
  courseId: Scalars['ID'];
  courseName?: Maybe<Scalars['String']>;
  decidedAt?: Maybe<Scalars['DateTime']>;
  decidedByName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  rationale: Scalars['String'];
  sourceKind: Scalars['String'];
  status: Scalars['String'];
};

/**
 * The extracted body, fetched separately — it is large, and only the
 * «посмотреть текст» drawer needs it.
 *
 * Exposed on purpose: the operator must be able to read EXACTLY what the model
 * read, otherwise the AI assessment is unauditable.
 */
export type TeacherDocumentTextType = {
  __typename?: 'TeacherDocumentTextType';
  documentId: Scalars['ID'];
  extractionStatus: Scalars['String'];
  text: Scalars['String'];
};

/** Parent is a TeacherDocument instance. */
export type TeacherDocumentType = {
  __typename?: 'TeacherDocumentType';
  contentType: Scalars['String'];
  /** pending|done|failed|unsupported. `failed` on a PDF means it has no text layer (a scan) — the file is fine, and `setTeacherDocumentText` is the recovery path. */
  extractionStatus: Scalars['String'];
  hasText: Scalars['Boolean'];
  id: Scalars['ID'];
  /** The newest version of this kind. Older ones are kept deliberately — «что он заявлял в 2024?» is a real hiring question. */
  isCurrent: Scalars['Boolean'];
  kind: Scalars['String'];
  originalName: Scalars['String'];
  sizeBytes?: Maybe<Scalars['Float']>;
  teacherId: Scalars['ID'];
  textChars: Scalars['Int'];
  uploadedAt: Scalars['DateTime'];
  uploadedByName?: Maybe<Scalars['String']>;
  version: Scalars['Int'];
};

export type TeacherFilterType = Node & {
  __typename?: 'TeacherFilterType';
  accessToLms: Scalars['Boolean'];
  applications?: Maybe<ApplicationConnection>;
  availability?: Maybe<Scalars['String']>;
  courses?: Maybe<Array<Maybe<Scalars['String']>>>;
  coursesCanTeach?: Maybe<Array<TeacherCourseRef>>;
  description?: Maybe<Scalars['String']>;
  employmentTypes?: Maybe<Array<Maybe<EmploymentType>>>;
  expenses: Array<ExpenseType>;
  fullName?: Maybe<Scalars['String']>;
  groupsCount?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  individualentrepreneur?: Maybe<IndividualEntrepreneurType>;
  internalNote: Scalars['String'];
  interview?: Maybe<Scalars['String']>;
  /** @deprecated Use teacherInterviews (spec 0028 B). */
  interviewRecording?: Maybe<Scalars['String']>;
  interviewTitle?: Maybe<Scalars['String']>;
  isDismissed?: Maybe<Scalars['Boolean']>;
  legalentity?: Maybe<LegalEntityType>;
  mainTeachers: MainTeacherWebTypeConnection;
  naturalperson?: Maybe<NaturalPersonType>;
  photo?: Maybe<Scalars['String']>;
  rating?: Maybe<Scalars['Int']>;
  selfemployed?: Maybe<SelfEmployedType>;
  siteDisplay: Scalars['Boolean'];
  studentComments?: Maybe<Array<TeacherStudentCommentType>>;
  studentRating?: Maybe<Scalars['Float']>;
  studentRatingCount: Scalars['Int'];
  teacher: TeacherWebTypeConnection;
  user: CustomUserType;
};


export type TeacherFilterTypeApplicationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type TeacherFilterTypeMainTeachersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type TeacherFilterTypeTeacherArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type TeacherFilterTypeConnection = {
  __typename?: 'TeacherFilterTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<TeacherFilterTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `TeacherFilterType` and its cursor. */
export type TeacherFilterTypeEdge = {
  __typename?: 'TeacherFilterTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<TeacherType>;
};

/**
 * The transcript body, fetched separately — it is large and only the
 * «посмотреть/править расшифровку» drawer needs it.
 */
export type TeacherInterviewTranscriptType = {
  __typename?: 'TeacherInterviewTranscriptType';
  interviewId: Scalars['ID'];
  text: Scalars['String'];
  transcriptSource: Scalars['String'];
};

/** Parent is a TeacherInterview instance. */
export type TeacherInterviewType = {
  __typename?: 'TeacherInterviewType';
  createdAt: Scalars['DateTime'];
  createdByName?: Maybe<Scalars['String']>;
  durationMinutes: Scalars['Int'];
  errorMessage: Scalars['String'];
  /** Set for source='link' (including the legacy Teacher.interviewRecording import). */
  externalUrl?: Maybe<Scalars['String']>;
  hasTranscript: Scalars['Boolean'];
  /** A stored MP4 exists in private S3. Fetch the playable URL through `teacherInterviewVideoUrl` — it is signed, short-lived and audited on every issue. */
  hasVideo: Scalars['Boolean'];
  id: Scalars['ID'];
  recordedAt?: Maybe<Scalars['DateTime']>;
  retryCount: Scalars['Int'];
  sizeBytes?: Maybe<Scalars['Float']>;
  source: Scalars['String'];
  status: Scalars['String'];
  teacherId: Scalars['ID'];
  title: Scalars['String'];
  transcriptChars: Scalars['Int'];
  transcriptSource: Scalars['String'];
  zoomAccountEmail?: Maybe<Scalars['String']>;
  zoomRecordingId?: Maybe<Scalars['ID']>;
  zoomTopic?: Maybe<Scalars['String']>;
};

/** Parent is a row of services.teacher_insight.teacher_leaderboard. */
export type TeacherLeaderboardRowType = {
  __typename?: 'TeacherLeaderboardRowType';
  average?: Maybe<Scalars['Float']>;
  commentsCount: Scalars['Int'];
  coursesCount: Scalars['Int'];
  /** False when the teacher has fewer than `minResponses` ratings. The row is still returned — «данных мало» is a finding, and hiding it would imply there is no problem. */
  enoughData: Scalars['Boolean'];
  ratingsCount: Scalars['Int'];
  teacherId: Scalars['ID'];
  teacherName: Scalars['String'];
};

export type TeacherLessonAttachmentType = Node & {
  __typename?: 'TeacherLessonAttachmentType';
  file: Scalars['String'];
  id: Scalars['ID'];
  lesson?: Maybe<GroupLessonType>;
  title: Scalars['String'];
};

export type TeacherLessonAttachmentTypeConnection = {
  __typename?: 'TeacherLessonAttachmentTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<TeacherLessonAttachmentTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `TeacherLessonAttachmentType` and its cursor. */
export type TeacherLessonAttachmentTypeEdge = {
  __typename?: 'TeacherLessonAttachmentTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<TeacherLessonAttachmentType>;
};

export type TeacherLessonAttachmentsType = Node & {
  __typename?: 'TeacherLessonAttachmentsType';
  courseLesson?: Maybe<CourseLessonType>;
  file?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  title: Scalars['String'];
};

export type TeacherLessonAttachmentsTypeConnection = {
  __typename?: 'TeacherLessonAttachmentsTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<TeacherLessonAttachmentsTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `TeacherLessonAttachmentsType` and its cursor. */
export type TeacherLessonAttachmentsTypeEdge = {
  __typename?: 'TeacherLessonAttachmentsTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<TeacherLessonAttachmentsType>;
};

/** Per-application rollup. Note the two DIFFERENT «remaining» numbers. */
export type TeacherLoadApplicationType = {
  __typename?: 'TeacherLoadApplicationType';
  applicationId: Scalars['ID'];
  contractedLessons: Scalars['Int'];
  groupId?: Maybe<Scalars['ID']>;
  groupName?: Maybe<Scalars['String']>;
  lastLessonDate?: Maybe<Scalars['Date']>;
  /** Scheduled AND still in the future — the real remaining load. */
  remainingLessons: Scalars['Int'];
  scheduledLessons: Scalars['Int'];
  title?: Maybe<Scalars['String']>;
  /** Contracted minus scheduled — a PLANNING GAP (lessons agreed but not yet on the calendar), NOT remaining work. */
  unscheduledLessons: Scalars['Int'];
};

/** Parent is the dict from services.load_service.teacher_load. */
export type TeacherLoadType = {
  __typename?: 'TeacherLoadType';
  activeApplications: Scalars['Int'];
  activeGroups: Scalars['Int'];
  applications: Array<TeacherLoadApplicationType>;
  horizonDays: Scalars['Int'];
  hoursNext30Days: Scalars['Float'];
  hoursPerWeek: Scalars['Float'];
  lessonsNext30Days: Scalars['Int'];
  /** 'free' | 'light' | 'normal' | 'loaded', from the TEACHER_LOAD_*_HOURS_PER_WEEK settings. Separate from TeacherType.availability, which stays two-valued. */
  loadBand: Scalars['String'];
  nextLessonDate?: Maybe<Scalars['Date']>;
  weeks: Array<TeacherLoadWeekType>;
};

/** One bucket of the forward histogram. */
export type TeacherLoadWeekType = {
  __typename?: 'TeacherLoadWeekType';
  groups: Scalars['Int'];
  lessons: Scalars['Int'];
  /** Clamped to [0, one week]: a lesson running past midnight yields a negative interval in Postgres. */
  minutes: Scalars['Int'];
  weekStart: Scalars['Date'];
};

/** A per-course or per-group split: {'id', 'name', 'average', 'count'}. */
export type TeacherRatingBucketType = {
  __typename?: 'TeacherRatingBucketType';
  average?: Maybe<Scalars['Float']>;
  count: Scalars['Int'];
  id: Scalars['ID'];
  name: Scalars['String'];
};

/** One trend bucket: {'period': 'YYYY-MM'|'YYYY-Qn', 'average', 'count'}. */
export type TeacherRatingPointType = {
  __typename?: 'TeacherRatingPointType';
  average?: Maybe<Scalars['Float']>;
  count: Scalars['Int'];
  period: Scalars['String'];
};

/**
 * One named student comment about the teacher, from a survey
 * `teacher_comment` answer (spec 0011 extension). ERP-staff only.
 */
export type TeacherStudentCommentType = {
  __typename?: 'TeacherStudentCommentType';
  comment: Scalars['String'];
  courseName?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  groupName?: Maybe<Scalars['String']>;
  studentName: Scalars['String'];
};

/**
 * Parent is the dict from services.teacher_insight.
 * `comments` reuses the existing TeacherStudentCommentType so the ERP renders
 * the same shape it already renders on the teacher profile.
 */
export type TeacherSurveyFeedbackReportType = {
  __typename?: 'TeacherSurveyFeedbackReportType';
  average?: Maybe<Scalars['Float']>;
  byCourse: Array<TeacherRatingBucketType>;
  byGroup: Array<TeacherRatingBucketType>;
  comments: Array<TeacherStudentCommentType>;
  commentsCount: Scalars['Int'];
  ratingsCount: Scalars['Int'];
  teacherId: Scalars['ID'];
  teacherName: Scalars['String'];
  trend: Array<TeacherRatingPointType>;
};

export type TeacherType = Node & {
  __typename?: 'TeacherType';
  accessToLms: Scalars['Boolean'];
  applications?: Maybe<ApplicationConnection>;
  availability?: Maybe<Scalars['String']>;
  courses?: Maybe<Array<Maybe<Scalars['String']>>>;
  coursesCanTeach?: Maybe<Array<TeacherCourseRef>>;
  description?: Maybe<Scalars['String']>;
  employmentTypes?: Maybe<Array<Maybe<EmploymentType>>>;
  expenses: Array<ExpenseType>;
  fullName?: Maybe<Scalars['String']>;
  groupsCount?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  internalNote: Scalars['String'];
  interview?: Maybe<Scalars['String']>;
  /** @deprecated Use teacherInterviews (spec 0028 B). */
  interviewRecording?: Maybe<Scalars['String']>;
  interviewTitle?: Maybe<Scalars['String']>;
  isDismissed?: Maybe<Scalars['Boolean']>;
  mainTeachers: MainTeacherWebTypeConnection;
  photo?: Maybe<Scalars['String']>;
  rating?: Maybe<Scalars['Int']>;
  siteDisplay: Scalars['Boolean'];
  studentComments?: Maybe<Array<TeacherStudentCommentType>>;
  studentRating?: Maybe<Scalars['Float']>;
  studentRatingCount: Scalars['Int'];
  teacher: TeacherWebTypeConnection;
  user: CustomUserType;
};


export type TeacherTypeApplicationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type TeacherTypeMainTeachersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type TeacherTypeTeacherArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type TeacherWebType = Node & {
  __typename?: 'TeacherWebType';
  course?: Maybe<CourseFilterType>;
  description: Scalars['String'];
  id: Scalars['ID'];
  teachersPreview: TeacherFilterTypeConnection;
  title: Scalars['String'];
};


export type TeacherWebTypeTeachersPreviewArgs = {
  after?: InputMaybe<Scalars['String']>;
  availability?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  course?: InputMaybe<Scalars['Decimal']>;
  first?: InputMaybe<Scalars['Int']>;
  hasDescription?: InputMaybe<Scalars['Boolean']>;
  hasInterview?: InputMaybe<Scalars['Boolean']>;
  hasPhoto?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  minRating?: InputMaybe<Scalars['Decimal']>;
  offset?: InputMaybe<Scalars['Int']>;
  siteDisplay?: InputMaybe<Scalars['Boolean']>;
};

export type TeacherWebTypeConnection = {
  __typename?: 'TeacherWebTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<TeacherWebTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `TeacherWebType` and its cursor. */
export type TeacherWebTypeEdge = {
  __typename?: 'TeacherWebTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<TeacherWebType>;
};

export type TeacherWithTypeInput = {
  accessToLms?: InputMaybe<Scalars['Boolean']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  middleName?: InputMaybe<Scalars['String']>;
  phone: Scalars['String'];
  siteDisplay?: InputMaybe<Scalars['Boolean']>;
};

export type TeachersPageInfoType = {
  __typename?: 'TeachersPageInfoType';
  description: Scalars['String'];
  id: Scalars['ID'];
  seoDescription: Scalars['String'];
  seoImage: Scalars['String'];
  seoKeywords: Scalars['String'];
  seoTitle: Scalars['String'];
  title: Scalars['String'];
};

export type TelegramLinkType = {
  __typename?: 'TelegramLinkType';
  deepLink: Scalars['String'];
  expiresAt: Scalars['DateTime'];
};

/**
 * Safe one-click agreement termination — see docs/groups/groups_upgrade.md §B3.
 *
 * Replaces the chained `updateStudentWithAgreement` workaround that
 * re-sent the student's PII just to flip `terminated=True`. This mutation
 * touches only the agreement and writes an audit log entry; contributions
 * and deferred payments are deliberately left alone.
 */
export type TerminateAgreementMutation = {
  __typename?: 'TerminateAgreementMutation';
  agreement?: Maybe<AgreementType>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
  success?: Maybe<Scalars['Boolean']>;
};

export enum TerminatedReasonEnum {
  NonPayment = 'NON_PAYMENT',
  Other = 'OTHER',
  StudentRequest = 'STUDENT_REQUEST',
  Transfer = 'TRANSFER'
}

export type ThesesType = {
  __typename?: 'ThesesType';
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  successStory?: Maybe<SuccessStoriesType>;
  title?: Maybe<Scalars['String']>;
};

export enum TimelineEventTypeEnum {
  InvoiceIssued = 'INVOICE_ISSUED',
  InvoiceLinked = 'INVOICE_LINKED',
  Moved = 'MOVED',
  Note = 'NOTE',
  Paid = 'PAID',
  Signed = 'SIGNED',
  TaskCreated = 'TASK_CREATED',
  TaskDone = 'TASK_DONE',
  Terminated = 'TERMINATED'
}

export type ToggleAchievement = {
  __typename?: 'ToggleAchievement';
  achievement?: Maybe<AchievementErpType>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
};

/**
 * Скрыть или вернуть анкету. Удаления нет: оно снесло бы сдачи вместе с
 * журналом того, что уехало студентам в резюме.
 */
export type ToggleCareerExerciseTemplate = {
  __typename?: 'ToggleCareerExerciseTemplate';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
  template?: Maybe<CareerExerciseTemplateType>;
};

export type ToggleGrowthTrack = {
  __typename?: 'ToggleGrowthTrack';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
  track?: Maybe<GrowthTrackErpType>;
};

export type ToggleSiteCourse = {
  __typename?: 'ToggleSiteCourse';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  siteCourse?: Maybe<SiteCourseErpType>;
  success?: Maybe<Scalars['Boolean']>;
};

/**
 * Значок профессии для пикера в ERP (ТЗ 0040, доводка).
 *
 * Отдаётся сервером по той же причине, что и реестр правил рядом: список,
 * скопированный в TypeScript, однажды разойдётся с тем, что принимает
 * `upsert_track`, и оператор получит отказ на значок, который ему же и
 * предложили. Рисунок при этом остаётся на фронтенде — это SVG, не данные.
 */
export type TrackIconType = {
  __typename?: 'TrackIconType';
  label: Scalars['String'];
  value: Scalars['String'];
};

/**
 * Group-scoped Fakturownia sync — docs/groups/group_dashboard.md §G10.
 *
 * Same Celery task as `triggerFakturowniaSync`, but the dedup lock is
 * scoped per `(group_id, period)` so a busy operator can fire syncs
 * for several groups without the global trigger getting in the way.
 * The payer-email UNION (agreement.buyer_email + student.email) is
 * recorded in the audit log and the returned `message`; narrowing the
 * actual Fakturownia API call by that list is intentionally deferred —
 * the mirror only ever grows, and the new canonical `groupId` filter
 * (§G7) will surface the new rows on the group's FinancesTab as soon
 * as the sync completes.
 */
export type TriggerFakturowniaGroupSyncMutation = {
  __typename?: 'TriggerFakturowniaGroupSyncMutation';
  /** Count of unique payer emails on the group's agreements + students. Recorded for audit; the API query itself is not narrowed yet. */
  emailsTargeted?: Maybe<Scalars['Int']>;
  enqueued?: Maybe<Scalars['Boolean']>;
  lastRun?: Maybe<FakturowniaSyncRunType>;
  message?: Maybe<Scalars['String']>;
};

/**
 * Fire-and-forget: enqueue a Fakturownia sync via Celery.
 *
 * The frontend pattern is: call this mutation → poll
 * `fakturownia_sync_status` until `is_running` flips back to false →
 * read `last_run.stats` to render "synced N invoices". The returned
 * `last_run` is the state *before* the new task starts so the UI can
 * show "synced 14:23 (… enqueueing new run …)" instantly.
 */
export type TriggerFakturowniaSyncMutation = {
  __typename?: 'TriggerFakturowniaSyncMutation';
  enqueued?: Maybe<Scalars['Boolean']>;
  /** Latest run *before* this trigger fired. Poll `fakturownia_sync_status` afterwards to see the new run. */
  lastRun?: Maybe<FakturowniaSyncRunType>;
  message?: Maybe<Scalars['String']>;
};

/**
 * Enqueue a full PandaDoc re-sync (list + details, with student folder
 * backfill). Powers the dashboard 'refresh everything' button — the Celery
 * task self-chains until the whole details backlog is drained.
 */
export type TriggerPandadocSyncMutation = {
  __typename?: 'TriggerPandadocSyncMutation';
  enqueued?: Maybe<Scalars['Boolean']>;
  message?: Maybe<Scalars['String']>;
  syncStatus?: Maybe<PandaDocSyncStatusType>;
};

/**
 * Manual Zoom sync scoped to one group — docs/groups/group_dashboard.md
 * §G9. Re-runs `sync_recordings` for the window and the matcher against
 * the group's lessons. 60-sec dedup lock per group so a frantic operator
 * doesn't queue ten copies.
 */
export type TriggerZoomGroupProcessMutation = {
  __typename?: 'TriggerZoomGroupProcessMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  enqueued?: Maybe<Scalars['Boolean']>;
  message?: Maybe<Scalars['String']>;
  queuedCount?: Maybe<Scalars['Int']>;
  success?: Maybe<Scalars['Boolean']>;
};

/**
 * Restore a student's LMS access by hand (ТЗ 0074 §3.4). The already
 * overdue invoices the suspension was tied to are forgiven (`waived`) — a
 * NEW overdue invoice (or a tied one that was not due yet) suspends again.
 */
export type UnblockStudentLmsAccessMutation = {
  __typename?: 'UnblockStudentLmsAccessMutation';
  accessBlock?: Maybe<StudentAccessBlockType>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type UnionGroupConnection = {
  __typename?: 'UnionGroupConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<UnionGroupEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `UnionGroup` and its cursor. */
export type UnionGroupEdge = {
  __typename?: 'UnionGroupEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<UnionGroupType>;
};

export type UnionGroupType = GroupType | MethodistGroupType | StudentGroupType;

export type UnionLessonType = GroupLessonForLmsType | MethodistLessonType | StudentLessonType;

export type UnlinkCandidateFromUser = {
  __typename?: 'UnlinkCandidateFromUser';
  candidate?: Maybe<FundingCandidateType>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
};

/**
 * Detach the Payment from a Contribution. The Payment stays alive as
 * an orphan (visible in the "вне графика" block); the Contribution
 * flips back to `complete=False, remainder=amount_foreign`.
 */
export type UnlinkContributionMutation = {
  __typename?: 'UnlinkContributionMutation';
  contribution?: Maybe<ContributionType>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  payment?: Maybe<PaymentType>;
  success?: Maybe<Scalars['Boolean']>;
};

export type UnlinkLessonRecordingMutation = {
  __typename?: 'UnlinkLessonRecordingMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type UnlinkLessonWhiteboardMutation = {
  __typename?: 'UnlinkLessonWhiteboardMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
  whiteboard?: Maybe<WhiteboardType>;
};

/** Detach a manually-linked PandaDoc document from its agreement. */
export type UnlinkPandadocDocumentMutation = {
  __typename?: 'UnlinkPandadocDocumentMutation';
  document?: Maybe<PandaDocDocumentType>;
  errors?: Maybe<Scalars['JSONString']>;
};

/** Detach a PandaDoc document from its teacher. */
export type UnlinkPandadocTeacherMutation = {
  __typename?: 'UnlinkPandadocTeacherMutation';
  document?: Maybe<PandaDocDocumentType>;
  errors?: Maybe<Scalars['JSONString']>;
};

export type UnlinkTelegram = {
  __typename?: 'UnlinkTelegram';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  settings?: Maybe<StaffNotificationSettingsType>;
  success?: Maybe<Scalars['Boolean']>;
};

/**
 * The inverse view — answers «did I miss anyone?», which the operator
 * needs more than the per-file errors.
 */
export type UnmatchedStudentType = {
  __typename?: 'UnmatchedStudentType';
  fullName?: Maybe<Scalars['String']>;
  missingLanguages: Array<Scalars['String']>;
  student: DiplomaStudentType;
};

/**
 * Когда навык откроется на курсе, где студент УЖЕ учится (ТЗ 0040, доводка).
 *
 * Без этого карта навыков умела отвечать только «купите курс» — то есть
 * предлагала купить то, на что человек ходит, вместо того чтобы сказать,
 * когда это придёт.
 */
export type UpcomingUnlockType = {
  __typename?: 'UpcomingUnlockType';
  lessonNumber: Scalars['Int'];
  lessonsLeft: Scalars['Int'];
};

export type UpdateApplicationInputType = {
  applicationId: Scalars['ID'];
  comment?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['ID']>;
  currency: Currencies;
  date: Scalars['Date'];
  group: Scalars['ID'];
  isTerminated: Scalars['Boolean'];
  lastLessonDate?: InputMaybe<Scalars['Date']>;
  lessonsCount: Scalars['Int'];
  riaPrice?: InputMaybe<Scalars['Float']>;
  servicePrice: Scalars['Float'];
  teacherType: EmploymentTypes;
  title: Scalars['String'];
};

export type UpdateAttendanceMutation = {
  __typename?: 'UpdateAttendanceMutation';
  attendance?: Maybe<AttendanceType>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type UpdateCareerApplication = {
  __typename?: 'UpdateCareerApplication';
  application?: Maybe<CareerApplicationType>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type UpdateCareerMember = {
  __typename?: 'UpdateCareerMember';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  member?: Maybe<CareerMemberType>;
  success?: Maybe<Scalars['Boolean']>;
};

export type UpdateCompanyInput = {
  comment: Scalars['String'];
  email: Scalars['String'];
  name: Scalars['String'];
  phone: Scalars['String'];
  responsiblePerson: Scalars['String'];
};

export type UpdateCompanyMutation = {
  __typename?: 'UpdateCompanyMutation';
  company?: Maybe<CompanyType>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type UpdateCourseMutation = {
  __typename?: 'UpdateCourseMutation';
  course?: Maybe<CourseType>;
};

export type UpdateExpenseInput = {
  amount?: InputMaybe<Scalars['Float']>;
  categorySlug?: InputMaybe<Scalars['String']>;
  counterpartyName?: InputMaybe<Scalars['String']>;
  counterpartyTaxNo?: InputMaybe<Scalars['String']>;
  currency?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['Date']>;
  description?: InputMaybe<Scalars['String']>;
  documentUrl?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  legalEntityId?: InputMaybe<Scalars['ID']>;
  notes?: InputMaybe<Scalars['String']>;
  paidAt?: InputMaybe<Scalars['Date']>;
  recurrence?: InputMaybe<Scalars['String']>;
  recurrenceDay?: InputMaybe<Scalars['Int']>;
  recurrenceUntil?: InputMaybe<Scalars['Date']>;
  /** Link a received Fakturownia invoice — prefills and locks amount/currency/date/counterparty from it, sets source='fakturownia'. */
  relatedFakturowniaInvoiceId?: InputMaybe<Scalars['ID']>;
  relatedGroupId?: InputMaybe<Scalars['ID']>;
  relatedTeacherId?: InputMaybe<Scalars['ID']>;
  status?: InputMaybe<Scalars['String']>;
};

export type UpdateGroupInput = {
  course_id: Scalars['Int'];
  currency: Scalars['String'];
  daysOfClass: Array<DayOfClassInput>;
  modules: Array<InputMaybe<UpdateModuleInput>>;
  name: Scalars['String'];
  price: Scalars['Float'];
  startDate: Scalars['Date'];
};

export type UpdateGroupMutation = {
  __typename?: 'UpdateGroupMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
  group?: Maybe<GroupType>;
  success?: Maybe<Scalars['Boolean']>;
};

export type UpdateJournalsMutation = {
  __typename?: 'UpdateJournalsMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type UpdateLessonInput = {
  additional?: InputMaybe<Scalars['Boolean']>;
  application_id?: InputMaybe<Scalars['ID']>;
  lesson_id: Scalars['Int'];
  name?: InputMaybe<Scalars['String']>;
  teacher_id?: InputMaybe<Scalars['Int']>;
};

export type UpdateMaterialInput = {
  description?: InputMaybe<Scalars['String']>;
  dueDate?: InputMaybe<Scalars['Date']>;
  kind?: InputMaybe<MaterialKindEnum>;
  lessonId?: InputMaybe<Scalars['ID']>;
  title?: InputMaybe<Scalars['String']>;
};

export type UpdateMaterialMutation = {
  __typename?: 'UpdateMaterialMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  material?: Maybe<MaterialType>;
  success?: Maybe<Scalars['Boolean']>;
};

export type UpdateModuleInput = {
  lessons: Array<InputMaybe<UpdateLessonInput>>;
  module_id: Scalars['Int'];
};

export type UpdatePaymentCorrectionInput = {
  amount?: InputMaybe<Scalars['Float']>;
  date?: InputMaybe<Scalars['Date']>;
  id: Scalars['ID'];
  reason?: InputMaybe<Scalars['String']>;
};

export type UpdatePaymentCorrectionMutation = {
  __typename?: 'UpdatePaymentCorrectionMutation';
  correction?: Maybe<PaymentCorrectionType>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type UpdatePaymentInput = {
  amountAgreement?: InputMaybe<Scalars['Float']>;
  date?: InputMaybe<Scalars['Date']>;
  id: Scalars['ID'];
};

/**
 * Patch a Payment's amount and/or date.
 *
 * Re-derives `amount_byn` / `amount_foreign` via `PaymentBase.save()` —
 * that's how the existing forms-based path keeps the chargeback / debt
 * tables consistent.
 */
export type UpdatePaymentMutation = {
  __typename?: 'UpdatePaymentMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  payment?: Maybe<PaymentType>;
  success?: Maybe<Scalars['Boolean']>;
};

export type UpdatePlannedPaymentInput = {
  amount?: InputMaybe<Scalars['Float']>;
  categorySlug?: InputMaybe<Scalars['String']>;
  comment?: InputMaybe<Scalars['String']>;
  currency?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['Date']>;
  id: Scalars['ID'];
  legalEntityId?: InputMaybe<Scalars['ID']>;
  recurrence?: InputMaybe<Scalars['String']>;
  recurrenceDay?: InputMaybe<Scalars['Int']>;
  recurrenceUntil?: InputMaybe<Scalars['Date']>;
  relatedGroupId?: InputMaybe<Scalars['ID']>;
  relatedTeacherId?: InputMaybe<Scalars['ID']>;
  status?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type UpdateStaffNotificationSettings = {
  __typename?: 'UpdateStaffNotificationSettings';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  settings?: Maybe<StaffNotificationSettingsType>;
  success?: Maybe<Scalars['Boolean']>;
};

export type UpdateStaffTaskInput = {
  agreementId?: InputMaybe<Scalars['ID']>;
  assigneeId?: InputMaybe<Scalars['ID']>;
  clearDueDate?: InputMaybe<Scalars['Boolean']>;
  clearStartDate?: InputMaybe<Scalars['Boolean']>;
  clearTargets?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<Scalars['String']>;
  dueDate?: InputMaybe<Scalars['Date']>;
  groupId?: InputMaybe<Scalars['ID']>;
  id: Scalars['ID'];
  priority?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['Date']>;
  studentId?: InputMaybe<Scalars['ID']>;
  subject?: InputMaybe<TaskSubjectInput>;
  title?: InputMaybe<Scalars['String']>;
};

export type UpdateStaffTaskMutation = {
  __typename?: 'UpdateStaffTaskMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
  task?: Maybe<StaffTaskType>;
};

export type UpdateStudentInput = {
  accountsPayable?: InputMaybe<AccountsPayableInput>;
  agreement: AgreementInput;
  chargeback?: InputMaybe<ChargebackInput>;
  company?: InputMaybe<SetCompanyInput>;
  contributions?: InputMaybe<Array<InputMaybe<ContributionInput>>>;
  student: StudentInput;
  studentLessons?: InputMaybe<AgreementLessonsInput>;
  usedPayables?: InputMaybe<Array<Scalars['ID']>>;
};

export type UpdateStudentNoteInput = {
  body?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  pinned?: InputMaybe<Scalars['Boolean']>;
  sentiment?: InputMaybe<Scalars['String']>;
};

export type UpdateStudentNoteMutation = {
  __typename?: 'UpdateStudentNoteMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  note?: Maybe<StudentNoteType>;
  success?: Maybe<Scalars['Boolean']>;
};

export type UpdateSurveyAssignmentMutation = {
  __typename?: 'UpdateSurveyAssignmentMutation';
  assignment?: Maybe<SurveyAssignmentType>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type UpdateSurveyMutation = {
  __typename?: 'UpdateSurveyMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
  survey?: Maybe<SurveyType>;
};

/** Move a task between statuses; stamps/clears `completed_at` on done. */
export type UpdateTaskStatusMutation = {
  __typename?: 'UpdateTaskStatusMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
  task?: Maybe<StaffTaskType>;
};

export type UpdateTeacherApplication = {
  __typename?: 'UpdateTeacherApplication';
  application?: Maybe<ApplicationType>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type UpdateTeacherWithTypeMutation = {
  __typename?: 'UpdateTeacherWithTypeMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
  success?: Maybe<Scalars['Boolean']>;
  teacher?: Maybe<TeacherType>;
};

/**
 * ERP: upload a lesson video (multipart, server-side write to the private
 * bucket — the same path as attachments, diplomas and the Django-admin file
 * widget, so no bucket CORS is required).
 */
export type UploadCareerLessonVideo = {
  __typename?: 'UploadCareerLessonVideo';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  lesson?: Maybe<CareerLessonType>;
  success?: Maybe<Scalars['Boolean']>;
};

export type UploadLessonVideo = {
  __typename?: 'UploadLessonVideo';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
  success?: Maybe<Scalars['Boolean']>;
};

/** Attach or replace one student's diploma in one language. */
export type UploadStudentDiplomaMutation = {
  __typename?: 'UploadStudentDiplomaMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  diploma?: Maybe<DiplomaType>;
  success?: Maybe<Scalars['Boolean']>;
};

/**
 * Upload a CV (or certificate / portfolio) and extract its text.
 *
 * Extraction runs INLINE, not in Celery: `pypdf` on a resume is milliseconds,
 * and a background hop would make the client poll for a status that is already
 * known by the time this response is written.
 *
 * Versioned, never replaced — a re-sent CV becomes v2 and v1 stays readable.
 */
export type UploadTeacherDocument = {
  __typename?: 'UploadTeacherDocument';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  document?: Maybe<TeacherDocumentType>;
  success?: Maybe<Scalars['Boolean']>;
};

/**
 * Multipart upload for an interview recorded outside Zoom.
 *
 * One mutation per file, the diploma rule. Capped at
 * MAX_TEACHER_INTERVIEW_VIDEO_BYTES: a full 90-minute 1080p recording is
 * 1-2 GB, and raising nginx `client_max_body_size` to match would affect every
 * endpoint and pin one sync gunicorn worker for the whole transfer — such
 * recordings belong on the Zoom path, which streams server-to-server.
 */
export type UploadTeacherInterviewVideo = {
  __typename?: 'UploadTeacherInterviewVideo';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  interview?: Maybe<TeacherInterviewType>;
  success?: Maybe<Scalars['Boolean']>;
};

/**
 * Pastes an image onto a board (spec 0010 rev.3): the bytes go to the
 * private bucket, the scene keeps only the fileId reference.
 */
export type UploadWhiteboardFileMutation = {
  __typename?: 'UploadWhiteboardFileMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  file?: Maybe<WhiteboardFileType>;
  success?: Maybe<Scalars['Boolean']>;
};

export type UpsertCareerLesson = {
  __typename?: 'UpsertCareerLesson';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  lesson?: Maybe<CareerLessonType>;
  success?: Maybe<Scalars['Boolean']>;
};

/** Завести или поправить навык справочника. */
export type UpsertCareerSkill = {
  __typename?: 'UpsertCareerSkill';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  skill?: Maybe<SkillType>;
  success?: Maybe<Scalars['Boolean']>;
};

/**
 * Teacher creates or edits the lesson's homework assignment (backed by
 * materials.Material kind=HOMEWORK; ≤1 per lesson via this path).
 */
export type UpsertHomeworkAssignmentMutation = {
  __typename?: 'UpsertHomeworkAssignmentMutation';
  assignment?: Maybe<HomeworkAssignmentType>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
};

/** Завести или поправить акцию (ТЗ 0039, шаг 6). */
export type UpsertPromoCampaign = {
  __typename?: 'UpsertPromoCampaign';
  campaignId?: Maybe<Scalars['ID']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
};

/** ERP: текст поста правится БЕЗ выката — это маркетинг, а не интерфейс. */
export type UpsertShareTemplate = {
  __typename?: 'UpsertShareTemplate';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type UpsertVacancy = {
  __typename?: 'UpsertVacancy';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
  vacancy?: Maybe<VacancyType>;
};

/**
 * Тип пользователя (ТЗ 0021, стадия 4 — база больше не `graphql_auth.schema.UserNode`).
 *
 * Четыре поля пакета (`pk`, `archived`, `verified`, `secondary_email`) и его
 * `get_queryset` перенесены сюда ВЕРБАТИМНО и объявлены ПЕРВЫМИ: graphene 2
 * складывает поля обходом reversed-MRO, и в текущем SDL они идут именно перед
 * проектными `activeRole`/`methodistGroupsCount`/… — порядок менять нельзя.
 */
export type UserNode = Node & {
  __typename?: 'UserNode';
  activeRole?: Maybe<Scalars['String']>;
  archived?: Maybe<Scalars['Boolean']>;
  dateJoined: Scalars['DateTime'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  /** The ID of the object */
  id: Scalars['ID'];
  /** Określa czy użytkownika należy uważać za aktywnego. Odznacz zamiast usuwać konto. */
  isActive: Scalars['Boolean'];
  /** Określa czy użytkownik może zalogować się do panelu administracyjnego. */
  isStaff: Scalars['Boolean'];
  lastLogin?: Maybe<Scalars['DateTime']>;
  lastName: Scalars['String'];
  lmsAccessBlock?: Maybe<LmsAccessBlockType>;
  methodistGroupsCount?: Maybe<Scalars['Int']>;
  middleName?: Maybe<Scalars['String']>;
  /** Of them, past their payment date (LMS token acting as Student, own node only; 0 otherwise). */
  overdueInvoicesCount: Scalars['Int'];
  pendingSurveysCount?: Maybe<Scalars['Int']>;
  phone?: Maybe<Scalars['String']>;
  pk?: Maybe<Scalars['Int']>;
  roles: Array<Scalars['String']>;
  secondaryEmail?: Maybe<Scalars['String']>;
  student?: Maybe<StudentType>;
  teacher?: Maybe<TeacherFilterType>;
  /** Unpaid invoices in «Moje faktury» (LMS token acting as Student, own node only; 0 otherwise). */
  unpaidInvoicesCount: Scalars['Int'];
  /** Wymagana. 150 lub mniej znaków. Jedynie litery, cyfry i @/./+/-/_. */
  username: Scalars['String'];
  verified?: Maybe<Scalars['Boolean']>;
};

export type UserNodeConnection = {
  __typename?: 'UserNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<UserNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `UserNode` and its cursor. */
export type UserNodeEdge = {
  __typename?: 'UserNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<UserNode>;
};

export type UserSettingsDeleteMutation = {
  __typename?: 'UserSettingsDeleteMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type UserSettingsRolesAddMutation = {
  __typename?: 'UserSettingsRolesAddMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
  success?: Maybe<Scalars['Boolean']>;
  user?: Maybe<CustomUserType>;
};

export type UserSettingsUpdateMutation = {
  __typename?: 'UserSettingsUpdateMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
  success?: Maybe<Scalars['Boolean']>;
  user?: Maybe<UserNode>;
};

export type UsersSettingsConnection = {
  __typename?: 'UsersSettingsConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<UsersSettingsEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `UsersSettings` and its cursor. */
export type UsersSettingsEdge = {
  __typename?: 'UsersSettingsEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<UserNode>;
};

/**
 * Страница ERP-доски (ТЗ 0035).
 *
 * Отдельный тип от `VacancyConnection`: у ленты есть `relevanceApplied`, а на
 * доске модерации это поле — бессмысленный шум. Курсор кейсетный по той же
 * причине, что и у ленты: агент вставляет строки в голову сортировки ровно
 * тогда, когда модератор листает очередь.
 */
export type VacancyBoardConnection = {
  __typename?: 'VacancyBoardConnection';
  edges: Array<VacancyEdge>;
  pageInfo: VacancyPageInfo;
  totalCount: Scalars['Int'];
  totalCountCapped: Scalars['Boolean'];
};

/**
 * Keyset `(score, sort_at, id)` connection — correct under head inserts,
 * unlike an offset cursor, which skips and duplicates exactly when a nightly
 * agent files rows into the top of the order while someone is paging.
 */
export type VacancyConnection = {
  __typename?: 'VacancyConnection';
  edges: Array<VacancyEdge>;
  matchContext: VacancyMatchContextType;
  pageInfo: VacancyPageInfo;
  relevanceApplied: Scalars['Boolean'];
  totalAvailable: Scalars['Int'];
  totalCount: Scalars['Int'];
  totalCountCapped: Scalars['Boolean'];
};

/**
 * Подозрение, что это та же вакансия с другой площадки (ТЗ 0035).
 *
 * Именно ПОДОЗРЕНИЕ: решает человек. Формулировка в интерфейсе — «похоже
 * на №…», никогда не «дубль».
 */
export type VacancyDuplicateHintType = {
  __typename?: 'VacancyDuplicateHintType';
  companyName: Scalars['String'];
  score: Scalars['Int'];
  status: Scalars['String'];
  title: Scalars['String'];
  vacancyId: Scalars['ID'];
};

export type VacancyEdge = {
  __typename?: 'VacancyEdge';
  cursor: Scalars['String'];
  node: VacancyType;
};

export type VacancyInput = {
  applyUrl: Scalars['String'];
  companyName?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  directionIds?: InputMaybe<Array<Scalars['ID']>>;
  employmentType?: InputMaybe<Scalars['String']>;
  expiresAt?: InputMaybe<Scalars['Date']>;
  location?: InputMaybe<Scalars['String']>;
  salaryCurrency?: InputMaybe<Scalars['String']>;
  salaryMax?: InputMaybe<Scalars['Int']>;
  salaryMin?: InputMaybe<Scalars['Int']>;
  seniority?: InputMaybe<Scalars['String']>;
  skillIds?: InputMaybe<Array<Scalars['ID']>>;
  title: Scalars['String'];
  workMode?: InputMaybe<Scalars['String']>;
};

/**
 * Чем именно подобрана эта лента (ТЗ 0070).
 *
 * ⚠️ Не украшение. В режиме GOAL `matchedSkillCount` на карточке значит
 * «совпало 3 ТРЕБОВАНИЯ профессии», а в PROFILE — «совпало 3 МОИХ навыка».
 * Одно поле, два смысла; контекст — единственное, что делает число читаемым.
 *
 * 🔴 Отдаём то, что ПРИМЕНИЛИ, а не то, что просили: правило `relevanceApplied`
 * («интерфейс не имеет права заявить подбор, которого не было») здесь ровно
 * то же.
 */
export type VacancyMatchContextType = {
  __typename?: 'VacancyMatchContextType';
  fallbackReason: Scalars['String'];
  matchMode: Scalars['String'];
  relevanceApplied: Scalars['Boolean'];
  requestedMatchMode: Scalars['String'];
  trackCode: Scalars['String'];
  trackTitle: Scalars['String'];
};

export type VacancyPageInfo = {
  __typename?: 'VacancyPageInfo';
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage: Scalars['Boolean'];
};

/**
 * Соответствие навыков студента требованиям вакансии (ТЗ 0073).
 *
 * Один результат на все экраны: карточка, панель деталей, подсветка и
 * «чего не хватает» читают ИМЕННО его. Считается по навыкам студента
 * независимо от режима подбора — режим GOAL решает, какие вакансии
 * показать, но не объявляет навык профессии навыком студента. Счётчики
 * выводятся из списков, а не считаются отдельно.
 */
export type VacancySkillMatchType = {
  __typename?: 'VacancySkillMatchType';
  matchedCount: Scalars['Int'];
  matchedSkills: Array<SkillType>;
  missingSkills: Array<SkillType>;
  /** 'ok' | 'no_skills' — у студента нет ни одного оценённого навыка; тогда `missingSkills` пуст (мы не знаем, чего не хватает). */
  status: Scalars['String'];
  totalCount: Scalars['Int'];
  /** Упомянуты в CV, но не оценены: не засчитаны и не недостающие. */
  unratedSkills: Array<SkillType>;
};

/**
 * A curated job opening. `my_interaction` is set only on the LMS feed
 * (the calling member's SAVED/APPLIED state); it's None on the ERP side.
 * Direction/skill refs are flat light lists.
 */
export type VacancyType = {
  __typename?: 'VacancyType';
  appliedCount?: Maybe<Scalars['Int']>;
  applyUrl: Scalars['String'];
  cityId?: Maybe<Scalars['ID']>;
  cityName?: Maybe<Scalars['String']>;
  companyName: Scalars['String'];
  createdAt: Scalars['DateTime'];
  createdByName?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  descriptionShort: Scalars['String'];
  directionIds: Array<Scalars['ID']>;
  directionTitles: Array<Scalars['String']>;
  duplicateOf: Array<VacancyDuplicateHintType>;
  employmentType: Scalars['String'];
  expiresAt?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  isNew: Scalars['Boolean'];
  location: Scalars['String'];
  matchApplied: Scalars['Boolean'];
  matchedSkillCount: Scalars['Int'];
  matchedSkillNames: Array<Scalars['String']>;
  missingSkillCount: Scalars['Int'];
  missingSkillNames: Array<Scalars['String']>;
  missingSkills: Array<SkillType>;
  myInteraction?: Maybe<Scalars['String']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  reviewedAt?: Maybe<Scalars['DateTime']>;
  reviewedByName?: Maybe<Scalars['String']>;
  salaryCurrency: Scalars['String'];
  salaryMax?: Maybe<Scalars['Int']>;
  salaryMin?: Maybe<Scalars['Int']>;
  seniority: Scalars['String'];
  skillIds: Array<Scalars['ID']>;
  skillMatch?: Maybe<VacancySkillMatchType>;
  skillNames: Array<Scalars['String']>;
  skills: Array<SkillType>;
  source: Scalars['String'];
  status: Scalars['String'];
  title: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  workMode: Scalars['String'];
};

export type VerifiedStudent = {
  __typename?: 'VerifiedStudent';
  code: Scalars['String'];
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  message?: Maybe<Scalars['String']>;
  student?: Maybe<StudentType>;
  user?: Maybe<CustomUserType>;
};

export type VerifiedTeacher = {
  __typename?: 'VerifiedTeacher';
  code: Scalars['String'];
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  message?: Maybe<Scalars['String']>;
  teacher?: Maybe<TeacherType>;
  user?: Maybe<CustomUserType>;
};

/** SDL: {payload: GenericScalar, success, errors}. */
export type VerifyToken = {
  __typename?: 'VerifyToken';
  errors?: Maybe<Scalars['ExpectedErrorType']>;
  payload?: Maybe<Scalars['GenericScalar']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type VideoTrailerType = {
  __typename?: 'VideoTrailerType';
  course?: Maybe<CourseFilterType>;
  description: Scalars['String'];
  id: Scalars['ID'];
  url: Scalars['String'];
};

export type VoivodeshipType = {
  __typename?: 'VoivodeshipType';
  code: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

/**
 * Строка сводки «что мешает роботу следить» (ТЗ 0054).
 *
 * 🔴 Живёт в журнале прогонов, а НЕ в реестре операторов. Владелец: «никаких
 * ошибок в интерфейсе видеть не хочу» — поломки убраны с экрана менеджера,
 * но не из системы: без них четырнадцать операторов из ста двадцати семи
 * выглядели бы спокойными, хотя робот к ним не ходит вовсе.
 */
export type WatchHealthType = {
  __typename?: 'WatchHealthType';
  count: Scalars['Int'];
  /** Имена, а не id: строку читают глазами. Не больше 50. */
  operators: Array<Scalars['String']>;
  /** Чинится по-разному, поэтому причины разные: no_url (адрес не задан) / error (последний заход не удался) / blind (страница открылась, но следить не за чем) / never (адрес есть, робот ни разу не дошёл) / url_suspect (адрес похож не на страницу новостей). */
  problem: Scalars['String'];
};

export type WeeksBudget = {
  __typename?: 'WeeksBudget';
  BYN?: Maybe<Scalars['CustomFloat']>;
  EUR?: Maybe<Scalars['CustomFloat']>;
  PLN?: Maybe<Scalars['CustomFloat']>;
  RUB?: Maybe<Scalars['CustomFloat']>;
  USD?: Maybe<Scalars['CustomFloat']>;
  week?: Maybe<Scalars['Int']>;
};

export type WeeksBudgetInfo = {
  __typename?: 'WeeksBudgetInfo';
  budget?: Maybe<Array<Maybe<WeeksBudget>>>;
  plan?: Maybe<Array<Maybe<WeeksBudget>>>;
};

/**
 * One image of a board, living on the private bucket rather than inside
 * the scene JSON. `url` is a short-TTL presigned link the client fetches and
 * feeds back to excalidraw via addFiles.
 */
export type WhiteboardFileType = {
  __typename?: 'WhiteboardFileType';
  fileId: Scalars['String'];
  mimeType?: Maybe<Scalars['String']>;
  url: Scalars['String'];
};

/**
 * A linked lesson, as shown in the continue-picker. Parent is a
 * GroupLesson instance.
 */
export type WhiteboardLessonRefType = {
  __typename?: 'WhiteboardLessonRefType';
  lessonDate?: Maybe<Scalars['Date']>;
  lessonId: Scalars['ID'];
  lessonName?: Maybe<Scalars['String']>;
  lessonNumber?: Maybe<Scalars['Int']>;
};

/**
 * The school-wide component library (spec 0010 rev.2). `itemsJson` is
 * the LibraryItems ARRAY serialized as a string — same size-guard-before-
 * parse rationale as WhiteboardType.sceneJson.
 */
export type WhiteboardLibraryType = {
  __typename?: 'WhiteboardLibraryType';
  itemsJson: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  version: Scalars['Int'];
};

/** Light shape for lists (continue picker) — no scene payload. */
export type WhiteboardMetaType = {
  __typename?: 'WhiteboardMetaType';
  id: Scalars['ID'];
  lessons: Array<WhiteboardLessonRefType>;
  name: Scalars['String'];
  sceneVersion: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};

/** Full shape — the serialized scene plus its S3-hosted images. */
export type WhiteboardType = {
  __typename?: 'WhiteboardType';
  createdAt: Scalars['DateTime'];
  files: Array<WhiteboardFileType>;
  id: Scalars['ID'];
  lessons: Array<WhiteboardLessonRefType>;
  name: Scalars['String'];
  sceneJson: Scalars['String'];
  sceneVersion: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};

export type WorkExperienceType = {
  __typename?: 'WorkExperienceType';
  company: Scalars['String'];
  description: Scalars['String'];
  endMonth?: Maybe<Scalars['Int']>;
  endYear?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  isCurrent: Scalars['Boolean'];
  position: Scalars['String'];
  startMonth?: Maybe<Scalars['Int']>;
  startYear?: Maybe<Scalars['Int']>;
};

/**
 * Zero an UNPAID contribution's amount on a transfer-out agreement.
 *
 * `Contribution.save()` re-derives `remainder = amount_foreign` for any
 * unpaid row, so "set remainder=0" is impossible — the legitimate way to
 * drop a contribution to zero is to set its AMOUNT to 0. This is strictly
 * gated:
 *
 * * the agreement must be `terminated` AND `transfer_out` — i.e. wound down
 *   via `ChangeAgreementGroup`, which clones the schedule onto the NEW group,
 *   so the obligation is re-attributed there, not erased; and
 * * the contribution must NOT have a linked Payment — real received money is
 *   never destroyed here. To move already-received cash out of the old group,
 *   use a Chargeback / AccountsPayable carry-out (capped at `paid_amount`),
 *   not this mutation.
 *
 * Every call is audited. The old terminated contract is already excluded from
 * debtors / finance / the calendar by the `terminated_date` cutoff; zeroing
 * additionally makes the old agreement read literally zero, which is what the
 * "обнулить старую группу" workflow asks for.
 */
export type ZeroOutContributionMutation = {
  __typename?: 'ZeroOutContributionMutation';
  contribution?: Maybe<ContributionType>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type ZoomAccountConnection = {
  __typename?: 'ZoomAccountConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ZoomAccountEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `ZoomAccount` and its cursor. */
export type ZoomAccountEdge = {
  __typename?: 'ZoomAccountEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<ZoomAccountType>;
};

export type ZoomAccountType = Node & {
  __typename?: 'ZoomAccountType';
  createdAt: Scalars['DateTime'];
  displayName: Scalars['String'];
  email: Scalars['String'];
  /** The ID of the object */
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  notes: Scalars['String'];
  syncedAt?: Maybe<Scalars['DateTime']>;
  zoomUserId: Scalars['String'];
};

export type ZoomAccountUsageType = Node & {
  __typename?: 'ZoomAccountUsageType';
  filesCount: Scalars['Int'];
  /** The ID of the object */
  id: Scalars['ID'];
  planRecordingType: Scalars['String'];
  planStorageFreeBytes?: Maybe<Scalars['Float']>;
  planStorageTotalBytes?: Maybe<Scalars['Float']>;
  planStorageUsedBytes?: Maybe<Scalars['Float']>;
  planUsageAvailable: Scalars['Boolean'];
  recordingsCount: Scalars['Int'];
  recordingsSizeBytes?: Maybe<Scalars['Float']>;
  storageUsedPercent?: Maybe<Scalars['Float']>;
  syncedAt: Scalars['DateTime'];
  usersCount: Scalars['Int'];
};

export type ZoomAuditLogConnection = {
  __typename?: 'ZoomAuditLogConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ZoomAuditLogEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `ZoomAuditLog` and its cursor. */
export type ZoomAuditLogEdge = {
  __typename?: 'ZoomAuditLogEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<ZoomAuditLogType>;
};

export type ZoomAuditLogType = Node & {
  __typename?: 'ZoomAuditLogType';
  action: Scalars['String'];
  createdAt: Scalars['DateTime'];
  details: Scalars['JSONString'];
  /** The ID of the object */
  id: Scalars['ID'];
  targetId: Scalars['Int'];
  targetKind: Scalars['String'];
  user?: Maybe<CustomUserType>;
};

/** Исход по одной записи в пакетном удалении. */
export type ZoomBulkDeleteRowType = {
  __typename?: 'ZoomBulkDeleteRowType';
  id: Scalars['ID'];
  queued: Scalars['Boolean'];
  /** Почему запись пропущена; пусто, если поставлена в очередь. */
  reason?: Maybe<Scalars['String']>;
};

export type ZoomDashboardPipelineCounts = {
  __typename?: 'ZoomDashboardPipelineCounts';
  aiCompleted?: Maybe<Scalars['Int']>;
  aiProcessing?: Maybe<Scalars['Int']>;
  downloading?: Maybe<Scalars['Int']>;
  failed?: Maybe<Scalars['Int']>;
  published?: Maybe<Scalars['Int']>;
  uploaded?: Maybe<Scalars['Int']>;
};

export type ZoomDashboardType = {
  __typename?: 'ZoomDashboardType';
  dateFrom?: Maybe<Scalars['Date']>;
  dateTo?: Maybe<Scalars['Date']>;
  lessonsMatched?: Maybe<Scalars['Int']>;
  lessonsMissing?: Maybe<Scalars['Int']>;
  lessonsSkipped?: Maybe<Scalars['Int']>;
  lessonsTotal?: Maybe<Scalars['Int']>;
  pipeline?: Maybe<ZoomDashboardPipelineCounts>;
  recordingsOrphan?: Maybe<Scalars['Int']>;
  recordingsTotal?: Maybe<Scalars['Int']>;
};

export type ZoomLessonConnection = {
  __typename?: 'ZoomLessonConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ZoomLessonEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `ZoomLesson` and its cursor. */
export type ZoomLessonEdge = {
  __typename?: 'ZoomLessonEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<GroupLessonForLmsType>;
};

export type ZoomProcessingLogConnection = {
  __typename?: 'ZoomProcessingLogConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ZoomProcessingLogEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `ZoomProcessingLog` and its cursor. */
export type ZoomProcessingLogEdge = {
  __typename?: 'ZoomProcessingLogEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<ZoomProcessingLogType>;
};

/** An enumeration. */
export enum ZoomProcessingLogLevel {
  /** Błąd */
  Error = 'ERROR',
  /** Info */
  Info = 'INFO',
  /** Warning */
  Warning = 'WARNING'
}

/** An enumeration. */
export enum ZoomProcessingLogStep {
  /** AI completed */
  AiCompleted = 'AI_COMPLETED',
  /** AI started */
  AiStarted = 'AI_STARTED',
  /** AI waiting (lock busy) */
  AiWaiting = 'AI_WAITING',
  /** Download audio */
  DownloadAudio = 'DOWNLOAD_AUDIO',
  /** Download chat */
  DownloadChat = 'DOWNLOAD_CHAT',
  /** Download transcript */
  DownloadTranscript = 'DOWNLOAD_TRANSCRIPT',
  /** Download video */
  DownloadVideo = 'DOWNLOAD_VIDEO',
  /** Błąd */
  Error = 'ERROR',
  /** Matched */
  Matched = 'MATCHED',
  /** Published */
  Published = 'PUBLISHED',
  /** Status change */
  StatusChange = 'STATUS_CHANGE'
}

export type ZoomProcessingLogType = Node & {
  __typename?: 'ZoomProcessingLogType';
  createdAt: Scalars['DateTime'];
  details: Scalars['JSONString'];
  /** The ID of the object */
  id: Scalars['ID'];
  lesson: GroupLessonType;
  lessonRecording?: Maybe<LessonRecordingType>;
  level: ZoomProcessingLogLevel;
  message: Scalars['String'];
  step: ZoomProcessingLogStep;
};

export type ZoomProcessingLogTypeConnection = {
  __typename?: 'ZoomProcessingLogTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ZoomProcessingLogTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `ZoomProcessingLogType` and its cursor. */
export type ZoomProcessingLogTypeEdge = {
  __typename?: 'ZoomProcessingLogTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<ZoomProcessingLogType>;
};

export type ZoomRecordingConnection = {
  __typename?: 'ZoomRecordingConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ZoomRecordingEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `ZoomRecording` and its cursor. */
export type ZoomRecordingEdge = {
  __typename?: 'ZoomRecordingEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<ZoomRecordingType>;
};

export enum ZoomRecordingStatusEnum {
  Failed = 'FAILED',
  Orphan = 'ORPHAN',
  Processing = 'PROCESSING',
  Ready = 'READY',
  TooShort = 'TOO_SHORT'
}

export type ZoomRecordingType = Node & {
  __typename?: 'ZoomRecordingType';
  deletedAt?: Maybe<Scalars['DateTime']>;
  deletedFromZoom: Scalars['Boolean'];
  durationMinutes: Scalars['Int'];
  failureReason?: Maybe<Scalars['String']>;
  files: Scalars['JSONString'];
  /** The ID of the object */
  id: Scalars['ID'];
  isMatched?: Maybe<Scalars['Boolean']>;
  isOrphan?: Maybe<Scalars['Boolean']>;
  isTooShort?: Maybe<Scalars['Boolean']>;
  lessonRecordings?: Maybe<Array<Maybe<LessonRecordingType>>>;
  pk?: Maybe<Scalars['Int']>;
  startTime: Scalars['DateTime'];
  status?: Maybe<ZoomRecordingStatusEnum>;
  syncedAt: Scalars['DateTime'];
  topic: Scalars['String'];
  totalSizeBytes?: Maybe<Scalars['Float']>;
  zoomAccount: ZoomAccountType;
  zoomMeetingId?: Maybe<Scalars['String']>;
  zoomMeetingUuid: Scalars['String'];
};

export type RegisterUserMutationVariables = Exact<{
  firstName: Scalars['String'];
  phone: Scalars['String'];
  email: Scalars['String'];
  recaptchaToken: Scalars['String'];
}>;


export type RegisterUserMutation = { __typename?: 'Mutation', lmsStudentSignUp?: { __typename?: 'StudentSignUpLMSMutation', success?: boolean | null, errors?: any | null, customErrors?: Array<{ __typename?: 'CustomErrorType', code?: string | null, field?: string | null, message?: string | null } | null> | null, student?: { __typename?: 'StudentType', user?: { __typename?: 'CustomUserType', firstName: string, email: string, phone?: string | null } | null } | null } | null };

export type CacheIdentityProbeQueryVariables = Exact<{ [key: string]: never; }>;


export type CacheIdentityProbeQuery = { __typename?: 'Query', careerProfessions: Array<{ __typename?: 'ProfessionType', code: string, skills: Array<{ __typename?: 'ProfessionSkillType', id: string, slug: string, priority: string, requirementStatus: string }> }> };

export type FeedModeProbeQueryVariables = Exact<{
  matchMode?: InputMaybe<Scalars['String']>;
}>;


export type FeedModeProbeQuery = { __typename?: 'Query', careerVacancyFeed: { __typename?: 'VacancyConnection', totalCount: number, edges: Array<{ __typename?: 'VacancyEdge', node: { __typename?: 'VacancyType', id: string, title: string } }> } };

export type LessonProbeQueryVariables = Exact<{ [key: string]: never; }>;


export type LessonProbeQuery = { __typename?: 'Query', me?: { __typename?: 'UserNode', id: string } | null };

export type CareerProfileFieldsFragment = { __typename?: 'CareerProfileType', id: string, firstName: string, lastName: string, email: string, phone: string, photoUrl?: string | null, city: string, country: string, relocationReady: boolean, workMode: string, workPermit: string, availableFrom?: any | null, seniority: string, desiredPosition: string, desiredSalary: string, githubUrl: string, linkedinUrl: string, portfolioUrl: string, customSkills: Array<string>, isSearchable: boolean, contactsVisible: boolean, completeness: number, skills: Array<{ __typename?: 'StudentSkillType', skillId: string, name: string, slug: string, iconUrl?: string | null, category: string, level: number, years?: number | null, source: string, isHidden: boolean, grantedCourseName?: string | null, grantedLessonNumber?: number | null }>, projects: Array<{ __typename?: 'PortfolioProjectType', id: string, title: string, description: string, role: string, repoUrl: string, demoUrl: string, technologyIds: Array<string>, technologyNames: Array<string>, technologies: Array<{ __typename?: 'SkillType', id: string, name: string, slug: string, category: string, iconUrl?: string | null }> }>, experience: Array<{ __typename?: 'WorkExperienceType', id: string, company: string, position: string, description: string, startYear?: number | null, startMonth?: number | null, endYear?: number | null, endMonth?: number | null, isCurrent: boolean }>, education: Array<{ __typename?: 'EducationType', id: string, institution: string, degree: string, specialization: string, startYear?: number | null, startMonth?: number | null, endYear?: number | null, endMonth?: number | null }>, languages: Array<{ __typename?: 'LanguageSkillType', id: string, language: string, level: string }>, certificates: Array<{ __typename?: 'CertificateType', id: string, title: string, issuer: string, issuedAt?: any | null, url: string, fileUrl?: string | null }>, locales: Array<{ __typename?: 'CvLocaleType', language: string, jobTitle: string, about: string }>, cvSkillSuggestions: Array<{ __typename?: 'CvSkillSuggestionType', mentionedAs: string, skill: { __typename?: 'SkillType', id: string, slug: string, name: string, category: string, iconUrl?: string | null } }> };

export type UserFieldsFragment = { __typename?: 'UserNode', id: string, activeRole?: string | null, username: string, firstName: string, middleName?: string | null, lastName: string, email: string, roles: Array<string>, phone?: string | null, methodistGroupsCount?: number | null, pendingSurveysCount?: number | null, unpaidInvoicesCount: number, overdueInvoicesCount: number, lmsAccessBlock?: { __typename?: 'LmsAccessBlockType', isBlocked: boolean, blockedAt?: any | null, amountsDue: Array<{ __typename?: 'LmsAmountDueType', amount: number, currency: string }> } | null, student?: { __typename?: 'StudentType', groupsCount?: number | null } | null, teacher?: { __typename?: 'TeacherFilterType', photo?: string | null, groupsCount?: number | null } | null };

export type SendAuthCodeMutationVariables = Exact<{
  email: Scalars['String'];
  scope: Scalars['String'];
}>;


export type SendAuthCodeMutation = { __typename?: 'Mutation', sendLmsAuthEmail?: { __typename?: 'SendAuthenticationCode', success?: boolean | null, createdAt?: any | null, customErrors?: Array<{ __typename?: 'CustomErrorType', code?: string | null, field?: string | null, message?: string | null } | null> | null } | null };

export type LoginMutationVariables = Exact<{
  authenticationCode: Scalars['String'];
  email: Scalars['String'];
  scope: Scalars['String'];
}>;


export type LoginMutation = { __typename?: 'Mutation', customLogin?: { __typename?: 'CustomObtainJSONWebToken', success?: boolean | null, token?: string | null, refreshToken?: string | null, customErrors?: Array<{ __typename?: 'CustomErrorType', code?: string | null, field?: string | null, message?: string | null } | null> | null, user?: { __typename?: 'UserNode', id: string, activeRole?: string | null, username: string, firstName: string, middleName?: string | null, lastName: string, email: string, roles: Array<string>, phone?: string | null, methodistGroupsCount?: number | null, pendingSurveysCount?: number | null, unpaidInvoicesCount: number, overdueInvoicesCount: number, lmsAccessBlock?: { __typename?: 'LmsAccessBlockType', isBlocked: boolean, blockedAt?: any | null, amountsDue: Array<{ __typename?: 'LmsAmountDueType', amount: number, currency: string }> } | null, student?: { __typename?: 'StudentType', groupsCount?: number | null } | null, teacher?: { __typename?: 'TeacherFilterType', photo?: string | null, groupsCount?: number | null } | null } | null } | null };

export type RefreshTokenMutationVariables = Exact<{
  refresh_token: Scalars['String'];
  scope: Scalars['String'];
  activeRole?: InputMaybe<LmsRoles>;
}>;


export type RefreshTokenMutation = { __typename?: 'Mutation', refreshToken?: { __typename?: 'CustomRefreshToken', token?: string | null, refreshToken?: string | null, payload?: any | null, errors?: any | null } | null };

export type DemoLoginMutationVariables = Exact<{
  email: Scalars['String'];
  scope: Scalars['String'];
}>;


export type DemoLoginMutation = { __typename?: 'Mutation', demoCustomLogin?: { __typename?: 'CustomObtainJSONWebToken', token?: string | null, refreshToken?: string | null, errors?: any | null } | null };

export type MarkCareerLessonDoneMutationVariables = Exact<{
  lessonId: Scalars['ID'];
  artifactUrl?: InputMaybe<Scalars['String']>;
}>;


export type MarkCareerLessonDoneMutation = { __typename?: 'Mutation', completeCareerLesson?: { __typename?: 'CompleteCareerLesson', success?: boolean | null, lessonsCompleted?: number | null, lessonsTotal?: number | null, reward?: { __typename?: 'GrowthRewardType', grantedTitles: Array<string>, promoCodes: Array<string> } | null, customErrors?: Array<{ __typename?: 'CustomErrorType', field?: string | null, message?: string | null, code?: string | null } | null> | null } | null };

export type TouchCareerLessonMutationVariables = Exact<{
  lessonId: Scalars['ID'];
}>;


export type TouchCareerLessonMutation = { __typename?: 'Mutation', markCareerLessonOpened?: { __typename?: 'MarkCareerLessonOpened', success?: boolean | null, openCount?: number | null, customErrors?: Array<{ __typename?: 'CustomErrorType', field?: string | null, message?: string | null, code?: string | null } | null> | null } | null };

export type StoreCareerLessonNotesMutationVariables = Exact<{
  lessonId: Scalars['ID'];
  notes: Scalars['String'];
}>;


export type StoreCareerLessonNotesMutation = { __typename?: 'Mutation', saveCareerLessonNotes?: { __typename?: 'SaveCareerLessonNotes', success?: boolean | null, notes?: string | null, customErrors?: Array<{ __typename?: 'CustomErrorType', field?: string | null, message?: string | null, code?: string | null } | null> | null } | null };

export type ToggleCareerLessonBookmarkMutationVariables = Exact<{
  lessonId: Scalars['ID'];
  isBookmarked: Scalars['Boolean'];
}>;


export type ToggleCareerLessonBookmarkMutation = { __typename?: 'Mutation', setCareerLessonBookmark?: { __typename?: 'SetCareerLessonBookmark', success?: boolean | null, isBookmarked?: boolean | null, customErrors?: Array<{ __typename?: 'CustomErrorType', field?: string | null, message?: string | null, code?: string | null } | null> | null } | null };

export type GradeCareerQuizMutationVariables = Exact<{
  lessonId: Scalars['ID'];
  answers: Array<CareerQuizAnswerInput> | CareerQuizAnswerInput;
}>;


export type GradeCareerQuizMutation = { __typename?: 'Mutation', submitCareerQuiz?: { __typename?: 'SubmitCareerQuiz', success?: boolean | null, score?: number | null, maxScore?: number | null, customErrors?: Array<{ __typename?: 'CustomErrorType', field?: string | null, message?: string | null, code?: string | null } | null> | null, results?: Array<{ __typename?: 'CareerQuizResultType', questionId: string, correct: boolean, correctIndexes: Array<number> }> | null } | null };

export type SubmitVacancyInteractionMutationVariables = Exact<{
  vacancyId: Scalars['ID'];
  kind: Scalars['String'];
}>;


export type SubmitVacancyInteractionMutation = { __typename?: 'Mutation', markVacancyInteraction?: { __typename?: 'MarkVacancyInteraction', success?: boolean | null, customErrors?: Array<{ __typename?: 'CustomErrorType', field?: string | null, message?: string | null, code?: string | null } | null> | null, vacancy?: { __typename?: 'VacancyType', id: string, myInteraction?: string | null } | null } | null };

export type SubmitCareerExerciseMutationVariables = Exact<{
  lessonId: Scalars['ID'];
  answers: Array<CareerExerciseAnswerInput> | CareerExerciseAnswerInput;
}>;


export type SubmitCareerExerciseMutation = { __typename?: 'Mutation', submitCareerLessonExercise?: { __typename?: 'SubmitCareerLessonExercise', success?: boolean | null, lessonsCompleted?: number | null, lessonsTotal?: number | null, reward?: { __typename?: 'GrowthRewardType', grantedTitles: Array<string>, promoCodes: Array<string> } | null, submission?: { __typename?: 'CareerExerciseSubmissionType', id: string, submittedAt: any } | null, applyReport?: { __typename?: 'CareerExerciseApplyReportType', writtenTargets: Array<string>, skippedTargets: Array<string>, profileCompleteness: number } | null, customErrors?: Array<{ __typename?: 'CustomErrorType', field?: string | null, message?: string | null, code?: string | null } | null> | null } | null };

export type ChooseGrowthTrackMutationVariables = Exact<{
  trackCode: Scalars['String'];
}>;


export type ChooseGrowthTrackMutation = { __typename?: 'Mutation', chooseGrowthTrack?: { __typename?: 'ChooseGrowthTrack', success?: boolean | null, trackCode?: string | null, customErrors?: Array<{ __typename?: 'CustomErrorType', code?: string | null, field?: string | null, message?: string | null } | null> | null } | null };

export type RegisterShareMutationVariables = Exact<{
  channel: Scalars['String'];
}>;


export type RegisterShareMutation = { __typename?: 'Mutation', registerShare?: { __typename?: 'RegisterShare', success?: boolean | null, result?: { __typename?: 'ShareResultType', counted: boolean, grantedTitles: Array<string>, promoCodes: Array<string> } | null, customErrors?: Array<{ __typename?: 'CustomErrorType', code?: string | null, field?: string | null, message?: string | null } | null> | null } | null };

export type TrackJobApplicationMutationVariables = Exact<{
  input: CareerApplicationInput;
}>;


export type TrackJobApplicationMutation = { __typename?: 'Mutation', createCareerApplication?: { __typename?: 'CreateCareerApplication', success?: boolean | null, duplicate?: boolean | null, application?: { __typename?: 'CareerApplicationType', id: string, vacancyId?: string | null, companyName: string, position: string, applyUrl: string, status: string, appliedAt?: any | null, nextActionAt?: any | null, note: string, source: string, isPlacementConfirmed: boolean, createdAt: any, updatedAt: any } | null, customErrors?: Array<{ __typename?: 'CustomErrorType', code?: string | null, field?: string | null, message?: string | null } | null> | null } | null };

export type ReviseJobApplicationMutationVariables = Exact<{
  id: Scalars['ID'];
  input: CareerApplicationInput;
}>;


export type ReviseJobApplicationMutation = { __typename?: 'Mutation', updateCareerApplication?: { __typename?: 'UpdateCareerApplication', success?: boolean | null, application?: { __typename?: 'CareerApplicationType', id: string, vacancyId?: string | null, companyName: string, position: string, applyUrl: string, status: string, appliedAt?: any | null, nextActionAt?: any | null, note: string, source: string, isPlacementConfirmed: boolean, createdAt: any, updatedAt: any } | null, customErrors?: Array<{ __typename?: 'CustomErrorType', code?: string | null, field?: string | null, message?: string | null } | null> | null } | null };

export type MoveJobApplicationMutationVariables = Exact<{
  id: Scalars['ID'];
  status: Scalars['String'];
}>;


export type MoveJobApplicationMutation = { __typename?: 'Mutation', setCareerApplicationStatus?: { __typename?: 'SetCareerApplicationStatus', success?: boolean | null, application?: { __typename?: 'CareerApplicationType', id: string, vacancyId?: string | null, companyName: string, position: string, applyUrl: string, status: string, appliedAt?: any | null, nextActionAt?: any | null, note: string, source: string, isPlacementConfirmed: boolean, createdAt: any, updatedAt: any } | null, customErrors?: Array<{ __typename?: 'CustomErrorType', code?: string | null, field?: string | null, message?: string | null } | null> | null } | null };

export type DropJobApplicationMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DropJobApplicationMutation = { __typename?: 'Mutation', deleteCareerApplication?: { __typename?: 'DeleteCareerApplication', success?: boolean | null, deleted?: boolean | null, customErrors?: Array<{ __typename?: 'CustomErrorType', code?: string | null, field?: string | null, message?: string | null } | null> | null } | null };

export type SaveCareerProfileFormMutationVariables = Exact<{
  input: CareerProfileInput;
  photo?: InputMaybe<Scalars['Upload']>;
  clearPhoto?: InputMaybe<Scalars['Boolean']>;
}>;


export type SaveCareerProfileFormMutation = { __typename?: 'Mutation', saveCareerProfile?: { __typename?: 'SaveCareerProfile', success?: boolean | null, customErrors?: Array<{ __typename?: 'CustomErrorType', field?: string | null, message?: string | null, code?: string | null } | null> | null, profile?: { __typename?: 'CareerProfileType', id: string, firstName: string, lastName: string, email: string, phone: string, photoUrl?: string | null, city: string, country: string, relocationReady: boolean, workMode: string, workPermit: string, availableFrom?: any | null, seniority: string, desiredPosition: string, desiredSalary: string, githubUrl: string, linkedinUrl: string, portfolioUrl: string, customSkills: Array<string>, isSearchable: boolean, contactsVisible: boolean, completeness: number, skills: Array<{ __typename?: 'StudentSkillType', skillId: string, name: string, slug: string, iconUrl?: string | null, category: string, level: number, years?: number | null, source: string, isHidden: boolean, grantedCourseName?: string | null, grantedLessonNumber?: number | null }>, projects: Array<{ __typename?: 'PortfolioProjectType', id: string, title: string, description: string, role: string, repoUrl: string, demoUrl: string, technologyIds: Array<string>, technologyNames: Array<string>, technologies: Array<{ __typename?: 'SkillType', id: string, name: string, slug: string, category: string, iconUrl?: string | null }> }>, experience: Array<{ __typename?: 'WorkExperienceType', id: string, company: string, position: string, description: string, startYear?: number | null, startMonth?: number | null, endYear?: number | null, endMonth?: number | null, isCurrent: boolean }>, education: Array<{ __typename?: 'EducationType', id: string, institution: string, degree: string, specialization: string, startYear?: number | null, startMonth?: number | null, endYear?: number | null, endMonth?: number | null }>, languages: Array<{ __typename?: 'LanguageSkillType', id: string, language: string, level: string }>, certificates: Array<{ __typename?: 'CertificateType', id: string, title: string, issuer: string, issuedAt?: any | null, url: string, fileUrl?: string | null }>, locales: Array<{ __typename?: 'CvLocaleType', language: string, jobTitle: string, about: string }>, cvSkillSuggestions: Array<{ __typename?: 'CvSkillSuggestionType', mentionedAs: string, skill: { __typename?: 'SkillType', id: string, slug: string, name: string, category: string, iconUrl?: string | null } }> } | null } | null };

export type SetProfileSearchableMutationVariables = Exact<{
  isSearchable: Scalars['Boolean'];
  contactsVisible?: InputMaybe<Scalars['Boolean']>;
}>;


export type SetProfileSearchableMutation = { __typename?: 'Mutation', setProfileSearchable?: { __typename?: 'SetProfileSearchable', success?: boolean | null, customErrors?: Array<{ __typename?: 'CustomErrorType', field?: string | null, message?: string | null, code?: string | null } | null> | null, profile?: { __typename?: 'CareerProfileType', id: string, isSearchable: boolean, contactsVisible: boolean } | null } | null };

export type SetMySkillLevelChoiceMutationVariables = Exact<{
  skillId: Scalars['ID'];
  level: Scalars['Int'];
}>;


export type SetMySkillLevelChoiceMutation = { __typename?: 'Mutation', setMySkillLevel?: { __typename?: 'SetMySkillLevel', success?: boolean | null, customErrors?: Array<{ __typename?: 'CustomErrorType', field?: string | null, message?: string | null, code?: string | null } | null> | null, skill?: { __typename?: 'StudentSkillType', skillId: string, level: number, source: string } | null } | null };

export type SubmitLessonHomeworkMutationVariables = Exact<{
  lessonId: Scalars['ID'];
  githubUrl?: InputMaybe<Scalars['String']>;
  file?: InputMaybe<Scalars['Upload']>;
}>;


export type SubmitLessonHomeworkMutation = { __typename?: 'Mutation', submitHomework?: { __typename?: 'SubmitHomeworkMutation', success?: boolean | null, customErrors?: Array<{ __typename?: 'CustomErrorType', code?: string | null, field?: string | null, message?: string | null } | null> | null, submission?: { __typename?: 'MyHomeworkSubmissionType', id: string, githubUrl?: string | null, fileName?: string | null, status: string, attempt: number, submittedAt: any, hwMark?: string | null, teacherComment?: string | null } | null } | null };

export type UpsertLessonHomeworkAssignmentMutationVariables = Exact<{
  lessonId: Scalars['ID'];
  title?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
  textbookRef?: InputMaybe<Scalars['String']>;
  dueDate?: InputMaybe<Scalars['Date']>;
}>;


export type UpsertLessonHomeworkAssignmentMutation = { __typename?: 'Mutation', upsertHomeworkAssignment?: { __typename?: 'UpsertHomeworkAssignmentMutation', success?: boolean | null, customErrors?: Array<{ __typename?: 'CustomErrorType', code?: string | null, field?: string | null, message?: string | null } | null> | null, assignment?: { __typename?: 'HomeworkAssignmentType', id: string, lessonId: string, title: string, text: string, textbookRef: string, dueDate?: any | null, updatedAt: any } | null } | null };

export type GradeHomeworkSubmissionMutationVariables = Exact<{
  lessonId: Scalars['ID'];
  studentId: Scalars['ID'];
  hwMark: Scalars['String'];
  comment?: InputMaybe<Scalars['String']>;
  attempt?: InputMaybe<Scalars['Int']>;
}>;


export type GradeHomeworkSubmissionMutation = { __typename?: 'Mutation', gradeHomework?: { __typename?: 'GradeHomeworkMutation', success?: boolean | null, customErrors?: Array<{ __typename?: 'CustomErrorType', code?: string | null, field?: string | null, message?: string | null } | null> | null, row?: { __typename?: 'HomeworkRosterRowType', studentId: string, hwMark?: string | null, submission?: { __typename?: 'HomeworkSubmissionType', id: string, status: string, teacherComment?: string | null, gradedByName?: string | null } | null } | null } | null };

export type RerunSubmissionAiReviewMutationVariables = Exact<{
  submissionId: Scalars['ID'];
}>;


export type RerunSubmissionAiReviewMutation = { __typename?: 'Mutation', rerunHomeworkAiReview?: { __typename?: 'RerunHomeworkAiReviewMutation', success?: boolean | null, aiReviewStatus?: string | null, customErrors?: Array<{ __typename?: 'CustomErrorType', code?: string | null, field?: string | null, message?: string | null } | null> | null } | null };

export type FinishLessonMutationVariables = Exact<{
  groupLessonId: Scalars['Int'];
  comment: Scalars['String'];
}>;


export type FinishLessonMutation = { __typename?: 'Mutation', finishLmsLesson?: { __typename?: 'FinishLmsLessonMutation', success?: boolean | null, errors?: any | null, customErrors?: Array<{ __typename?: 'CustomErrorType', code?: string | null, field?: string | null, message?: string | null } | null> | null } | null };

export type SetLessonAttendanceMutationVariables = Exact<{
  attendanceId: Scalars['Int'];
  attendance: Scalars['Boolean'];
}>;


export type SetLessonAttendanceMutation = { __typename?: 'Mutation', lmsSetAttendance?: { __typename?: 'LmsSetAttendanceMutation', success?: boolean | null, customErrors?: Array<{ __typename?: 'CustomErrorType', code?: string | null, field?: string | null, message?: string | null } | null> | null, attendance?: { __typename?: 'LessonAttendancesType', id: string, attendance?: boolean | null, source?: string | null, markedAt?: any | null, markedByName?: string | null } | null } | null };

export type UploadLessonVideoMutationVariables = Exact<{
  lessonId: Scalars['Int'];
  videoUrl: Scalars['String'];
}>;


export type UploadLessonVideoMutation = { __typename?: 'Mutation', uploadLessonVideo?: { __typename?: 'UploadLessonVideo', success?: boolean | null, customErrors?: Array<{ __typename?: 'CustomErrorType', code?: string | null, field?: string | null, message?: string | null } | null> | null } | null };

export type CancelUploadVideoMutationVariables = Exact<{
  lessonId: Scalars['Int'];
}>;


export type CancelUploadVideoMutation = { __typename?: 'Mutation', cancelVideoUpload?: { __typename?: 'CancelVideoUpload', customErrors?: Array<{ __typename?: 'CustomErrorType', field?: string | null, code?: string | null, message?: string | null } | null> | null } | null };

export type AddStudentsMarksMutationVariables = Exact<{
  lessonId: Scalars['Int'];
  taskType: LessonTaskTypeEnum;
  studentsMarks: Array<InputMaybe<LessonMarkInput>> | InputMaybe<LessonMarkInput>;
  date: Scalars['Date'];
}>;


export type AddStudentsMarksMutation = { __typename?: 'Mutation', setStudentsMarks?: { __typename?: 'SetStudentsMarksMutation', success?: boolean | null, customErrors?: Array<{ __typename?: 'CustomErrorType', field?: string | null, code?: string | null, message?: string | null } | null> | null } | null };

export type SendSurveyResponseMutationVariables = Exact<{
  assignmentId: Scalars['ID'];
  answers: Array<SurveyAnswerInput> | SurveyAnswerInput;
}>;


export type SendSurveyResponseMutation = { __typename?: 'Mutation', submitSurveyResponse?: { __typename?: 'SubmitSurveyResponseMutation', success?: boolean | null, customErrors?: Array<{ __typename?: 'CustomErrorType', code?: string | null, field?: string | null, message?: string | null } | null> | null } | null };

export type CreateWhiteboardForLessonMutationVariables = Exact<{
  lessonId: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
}>;


export type CreateWhiteboardForLessonMutation = { __typename?: 'Mutation', createLessonWhiteboard?: { __typename?: 'CreateLessonWhiteboardMutation', success?: boolean | null, customErrors?: Array<{ __typename?: 'CustomErrorType', code?: string | null, field?: string | null, message?: string | null } | null> | null, whiteboard?: { __typename?: 'WhiteboardType', id: string, name: string, sceneJson: string, sceneVersion: number } | null } | null };

export type LinkWhiteboardToLessonMutationVariables = Exact<{
  lessonId: Scalars['ID'];
  whiteboardId: Scalars['ID'];
}>;


export type LinkWhiteboardToLessonMutation = { __typename?: 'Mutation', linkLessonWhiteboard?: { __typename?: 'LinkLessonWhiteboardMutation', success?: boolean | null, customErrors?: Array<{ __typename?: 'CustomErrorType', code?: string | null, field?: string | null, message?: string | null } | null> | null, whiteboard?: { __typename?: 'WhiteboardType', id: string, name: string, sceneJson: string, sceneVersion: number } | null } | null };

export type SaveBoardSceneMutationVariables = Exact<{
  whiteboardId: Scalars['ID'];
  sceneJson: Scalars['String'];
  expectedVersion: Scalars['Int'];
}>;


export type SaveBoardSceneMutation = { __typename?: 'Mutation', saveWhiteboardScene?: { __typename?: 'SaveWhiteboardSceneMutation', success?: boolean | null, sceneVersion?: number | null, customErrors?: Array<{ __typename?: 'CustomErrorType', code?: string | null, field?: string | null, message?: string | null } | null> | null, whiteboard?: { __typename?: 'WhiteboardType', id: string, sceneVersion: number } | null } | null };

export type RenameBoardMutationVariables = Exact<{
  whiteboardId: Scalars['ID'];
  name: Scalars['String'];
}>;


export type RenameBoardMutation = { __typename?: 'Mutation', renameWhiteboard?: { __typename?: 'RenameWhiteboardMutation', success?: boolean | null, customErrors?: Array<{ __typename?: 'CustomErrorType', code?: string | null, field?: string | null, message?: string | null } | null> | null, whiteboard?: { __typename?: 'WhiteboardType', id: string, name: string } | null } | null };

export type UnlinkWhiteboardFromLessonMutationVariables = Exact<{
  lessonId: Scalars['ID'];
}>;


export type UnlinkWhiteboardFromLessonMutation = { __typename?: 'Mutation', unlinkLessonWhiteboard?: { __typename?: 'UnlinkLessonWhiteboardMutation', success?: boolean | null, customErrors?: Array<{ __typename?: 'CustomErrorType', code?: string | null, field?: string | null, message?: string | null } | null> | null } | null };

export type UploadBoardImageMutationVariables = Exact<{
  whiteboardId: Scalars['ID'];
  fileId: Scalars['String'];
  mimeType?: InputMaybe<Scalars['String']>;
  file: Scalars['Upload'];
}>;


export type UploadBoardImageMutation = { __typename?: 'Mutation', uploadWhiteboardFile?: { __typename?: 'UploadWhiteboardFileMutation', success?: boolean | null, customErrors?: Array<{ __typename?: 'CustomErrorType', code?: string | null, field?: string | null, message?: string | null } | null> | null, file?: { __typename?: 'WhiteboardFileType', fileId: string, mimeType?: string | null, url: string } | null } | null };

export type SaveSchoolLibraryMutationVariables = Exact<{
  itemsJson: Scalars['String'];
  expectedVersion: Scalars['Int'];
}>;


export type SaveSchoolLibraryMutation = { __typename?: 'Mutation', saveWhiteboardLibrary?: { __typename?: 'SaveWhiteboardLibraryMutation', success?: boolean | null, version?: number | null, customErrors?: Array<{ __typename?: 'CustomErrorType', code?: string | null, field?: string | null, message?: string | null } | null> | null } | null };

export type JoinLessonNowMutationVariables = Exact<{
  groupLessonId: Scalars['Int'];
}>;


export type JoinLessonNowMutation = { __typename?: 'Mutation', lmsJoinLesson?: { __typename?: 'LmsJoinLesson', success?: boolean | null, redirectUrl?: string | null, customErrors?: Array<{ __typename?: 'CustomErrorType', field?: string | null, code?: string | null, message?: string | null } | null> | null } | null };

export type PutTodayLessonLinkMutationVariables = Exact<{
  groupId: Scalars['Int'];
  joinUrl: Scalars['String'];
}>;


export type PutTodayLessonLinkMutation = { __typename?: 'Mutation', lmsSetTodayLessonLink?: { __typename?: 'LmsSetTodayLessonLink', success?: boolean | null, customErrors?: Array<{ __typename?: 'CustomErrorType', field?: string | null, code?: string | null, message?: string | null } | null> | null } | null };

export type DropTodayLessonLinkMutationVariables = Exact<{
  groupId: Scalars['Int'];
}>;


export type DropTodayLessonLinkMutation = { __typename?: 'Mutation', lmsClearTodayLessonLink?: { __typename?: 'LmsClearTodayLessonLink', success?: boolean | null, customErrors?: Array<{ __typename?: 'CustomErrorType', field?: string | null, code?: string | null, message?: string | null } | null> | null } | null };

export type StudentGroupAttendanceQueryVariables = Exact<{
  groupId: Scalars['ID'];
}>;


export type StudentGroupAttendanceQuery = { __typename?: 'Query', myAttendance: Array<{ __typename?: 'MyLessonAttendanceType', lessonId: string, lessonName: string, lessonNumber: number, date?: any | null, attendance?: boolean | null }> };

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { __typename?: 'Query', me?: { __typename?: 'UserNode', id: string, activeRole?: string | null, username: string, firstName: string, middleName?: string | null, lastName: string, email: string, roles: Array<string>, phone?: string | null, methodistGroupsCount?: number | null, pendingSurveysCount?: number | null, unpaidInvoicesCount: number, overdueInvoicesCount: number, lmsAccessBlock?: { __typename?: 'LmsAccessBlockType', isBlocked: boolean, blockedAt?: any | null, amountsDue: Array<{ __typename?: 'LmsAmountDueType', amount: number, currency: string }> } | null, student?: { __typename?: 'StudentType', groupsCount?: number | null } | null, teacher?: { __typename?: 'TeacherFilterType', photo?: string | null, groupsCount?: number | null } | null } | null };

export type MyCareerCenterInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type MyCareerCenterInfoQuery = { __typename?: 'Query', myCareerCenter?: { __typename?: 'CareerCenterType', isPreview: boolean, memberId?: string | null, status: string, directionTitle?: string | null, directionId?: string | null, directionSource?: string | null, enrolledAt?: any | null, lessonsCompleted: number, lessonsTotal: number } | null };

export type CareerLessonsListQueryVariables = Exact<{ [key: string]: never; }>;


export type CareerLessonsListQuery = { __typename?: 'Query', careerLessons: Array<{ __typename?: 'CareerLessonType', id: string, order: number, title: string, summary: string, durationMin?: number | null, completionKind: string, outcomeKind: string, outcomeLabel: string, state: string, materialLanguage: string, hasVideo: boolean, attachmentsCount: number, quizQuestionsCount: number, hasExercise: boolean, isUnlocked: boolean, isCompleted: boolean, completedAt?: any | null, isOpened: boolean, isBookmarked: boolean, unlockAfter?: { __typename?: 'CareerLessonUnlockType', lessonId: string, order: number, title: string } | null }> };

export type CareerLessonDetailQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CareerLessonDetailQuery = { __typename?: 'Query', careerLesson?: { __typename?: 'CareerLessonType', id: string, order: number, title: string, summary: string, durationMin?: number | null, completionKind: string, outcomeKind: string, outcomeLabel: string, state: string, materialLanguage: string, hasVideo: boolean, attachmentsCount: number, quizQuestionsCount: number, hasExercise: boolean, artifactHint: string, isUnlocked: boolean, isCompleted: boolean, completedAt?: any | null, isOpened: boolean, openedAt?: any | null, openCount: number, peersCompleted?: number | null, myNotes: string, isBookmarked: boolean, content?: string | null, videoUrl?: string | null, unlockAfter?: { __typename?: 'CareerLessonUnlockType', lessonId: string, order: number, title: string } | null, attachments: Array<{ __typename?: 'CareerLessonAttachmentType', id: string, originalName: string, contentType: string, sizeBytes: number, url?: string | null }>, quizQuestions: Array<{ __typename?: 'CareerQuizQuestionType', id: string, order: number, text: string, options: Array<string>, correctIndexes: Array<number> }>, exercise?: { __typename?: 'CareerLessonExerciseType', id: string, intro: string, outro: string, fields: Array<{ __typename?: 'CareerExerciseFieldType', id: string, number: number, label: string, helpText: string, placeholder: string, fieldType: string, required: boolean, options: Array<string>, maxLength?: number | null, binding: string, bindingLanguage?: string | null, prefill?: any | null }>, mySubmission?: { __typename?: 'CareerExerciseSubmissionType', id: string, submittedAt: any, answers: Array<{ __typename?: 'CareerExerciseAnswerType', fieldId: string, value?: any | null }> } | null } | null } | null };

export type MyCareerVacanciesQueryVariables = Exact<{
  directionId?: InputMaybe<Scalars['ID']>;
  skillId?: InputMaybe<Scalars['ID']>;
  workMode?: InputMaybe<Scalars['String']>;
  seniority?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  savedOnly?: InputMaybe<Scalars['Boolean']>;
}>;


export type MyCareerVacanciesQuery = { __typename?: 'Query', careerVacancies: Array<{ __typename?: 'VacancyType', id: string, title: string, companyName: string, applyUrl: string, location: string, workMode: string, seniority: string, employmentType: string, salaryMin?: number | null, salaryMax?: number | null, salaryCurrency: string, description: string, publishedAt?: any | null, expiresAt?: any | null, directionIds: Array<string>, directionTitles: Array<string>, skillNames: Array<string>, myInteraction?: string | null }> };

export type MyCareerVacancyFeedQueryVariables = Exact<{
  directionId?: InputMaybe<Scalars['ID']>;
  skillIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  cityId?: InputMaybe<Scalars['ID']>;
  workMode?: InputMaybe<Scalars['String']>;
  seniority?: InputMaybe<Scalars['String']>;
  employmentType?: InputMaybe<Scalars['String']>;
  salaryFrom?: InputMaybe<Scalars['Int']>;
  freshness?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  savedOnly?: InputMaybe<Scalars['Boolean']>;
  sort?: InputMaybe<Scalars['String']>;
  matchMode?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type MyCareerVacancyFeedQuery = { __typename?: 'Query', careerVacancyFeed: { __typename?: 'VacancyConnection', totalCount: number, totalCountCapped: boolean, totalAvailable: number, relevanceApplied: boolean, matchContext: { __typename?: 'VacancyMatchContextType', matchMode: string, trackCode: string, trackTitle: string, fallbackReason: string }, pageInfo: { __typename?: 'VacancyPageInfo', hasNextPage: boolean, endCursor?: string | null }, edges: Array<{ __typename?: 'VacancyEdge', cursor: string, node: { __typename?: 'VacancyType', id: string, title: string, companyName: string, applyUrl: string, location: string, cityId?: string | null, cityName?: string | null, workMode: string, seniority: string, employmentType: string, salaryMin?: number | null, salaryMax?: number | null, salaryCurrency: string, descriptionShort: string, publishedAt?: any | null, expiresAt?: any | null, isNew: boolean, directionIds: Array<string>, directionTitles: Array<string>, skillIds: Array<string>, skillNames: Array<string>, myInteraction?: string | null, skills: Array<{ __typename?: 'SkillType', id: string, name: string, slug: string, category: string, iconUrl?: string | null }>, skillMatch?: { __typename?: 'VacancySkillMatchType', status: string, matchedCount: number, totalCount: number, matchedSkills: Array<{ __typename?: 'SkillType', id: string }>, missingSkills: Array<{ __typename?: 'SkillType', id: string }>, unratedSkills: Array<{ __typename?: 'SkillType', id: string }> } | null } }> } };

export type MyCareerVacancyQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type MyCareerVacancyQuery = { __typename?: 'Query', careerVacancy?: { __typename?: 'VacancyType', id: string, title: string, companyName: string, applyUrl: string, location: string, cityName?: string | null, workMode: string, seniority: string, employmentType: string, salaryMin?: number | null, salaryMax?: number | null, salaryCurrency: string, description: string, publishedAt?: any | null, expiresAt?: any | null, isNew: boolean, directionTitles: Array<string>, skillIds: Array<string>, skillNames: Array<string>, myInteraction?: string | null, skills: Array<{ __typename?: 'SkillType', id: string, name: string, slug: string, category: string, iconUrl?: string | null }>, skillMatch?: { __typename?: 'VacancySkillMatchType', status: string, matchedCount: number, totalCount: number, matchedSkills: Array<{ __typename?: 'SkillType', id: string }>, missingSkills: Array<{ __typename?: 'SkillType', id: string }>, unratedSkills: Array<{ __typename?: 'SkillType', id: string }> } | null } | null };

export type MyCareerFilterDictionariesQueryVariables = Exact<{ [key: string]: never; }>;


export type MyCareerFilterDictionariesQuery = { __typename?: 'Query', careerDirectionsLms: Array<{ __typename?: 'CareerDirectionType', id: string, title: string }>, careerCities: Array<{ __typename?: 'CareerCityType', id: string, name: string, country: string }> };

export type MyGrowthQueryVariables = Exact<{ [key: string]: never; }>;


export type MyGrowthQuery = { __typename?: 'Query', myGrowth?: { __typename?: 'GrowthOverviewType', xp: number, level: number, levelTitle: string, levelFloorXp: number, nextLevelXp?: number | null, availableTotal: number, lockedTotal: number, isCareerMember: boolean, levels: Array<{ __typename?: 'GrowthLevelType', index: number, title: string, threshold: number, reached: boolean }>, achievements: Array<{ __typename?: 'GrowthAchievementType', code: string, title: string, description: string, icon: string, category: string, points: number, earned: boolean, earnedAt?: any | null, current: number, target: number, locked: boolean, hidden: boolean, progressKind: string }> } | null };

export type MySkillMapQueryVariables = Exact<{ [key: string]: never; }>;


export type MySkillMapQuery = { __typename?: 'Query', mySkillMap?: { __typename?: 'SkillMapType', trackCode?: string | null, trackTitle?: string | null, demandComputedAt?: any | null, nextCourses: Array<{ __typename?: 'NextCourseType', courseId: string, courseName: string, courseUrl: string, adds: Array<string>, covered: number, totalMissing: number }>, mine: Array<{ __typename?: 'MySkillType', level: number, source: string, isHidden: boolean, grantedCourseName?: string | null, grantedLessonNumber?: number | null, skill: { __typename?: 'SkillType', id: string, name: string, slug: string, category: string, description: string, iconUrl?: string | null }, demand?: { __typename?: 'SkillDemandType', liveVacancies: number, band: number } | null, providers: Array<{ __typename?: 'SkillProviderType', courseId: string, courseName: string, courseUrl: string, level: number, completed: boolean }> }>, missing: Array<{ __typename?: 'MissingSkillType', upcoming?: { __typename?: 'UpcomingUnlockType', lessonNumber: number, lessonsLeft: number } | null, skill: { __typename?: 'SkillType', id: string, name: string, slug: string, category: string, description: string, iconUrl?: string | null }, demand?: { __typename?: 'SkillDemandType', liveVacancies: number, band: number } | null, providers: Array<{ __typename?: 'SkillProviderType', courseId: string, courseName: string, courseUrl: string, level: number, completed: boolean }> }> } | null };

export type MyPromoCodesQueryVariables = Exact<{ [key: string]: never; }>;


export type MyPromoCodesQuery = { __typename?: 'Query', myPromoCodes: Array<{ __typename?: 'PromoCodeType', id: string, code: string, status: string, expiresAt?: any | null, campaignTitle: string, campaignDescription: string, discountKind: string, discountValue: number, currency: string }> };

export type MyShareOptionsQueryVariables = Exact<{
  language?: InputMaybe<Scalars['String']>;
}>;


export type MyShareOptionsQuery = { __typename?: 'Query', myShareOptions: Array<{ __typename?: 'ShareOptionType', channel: string, text: string, targetUrl: string, shareUrl?: string | null, bonusAvailable: boolean, bonusPoints: number, bonusPromo: boolean }> };

export type CareerProfessionsQueryVariables = Exact<{ [key: string]: never; }>;


export type CareerProfessionsQuery = { __typename?: 'Query', careerProfessions: Array<{ __typename?: 'ProfessionType', code: string, title: string, summary: string, about: string, icon: string, salaryFrom?: number | null, salaryTo?: number | null, salaryCurrency: string, haveCount: number, totalCount: number, liveVacancies: number, isChosen: boolean, hasRequirements: boolean, stepsDone: number, stepsTotal: number, skillProgress: { __typename?: 'CareerSkillProgressType', requiredCount: number, meetsRequiredLevelCount: number, needsImprovementCount: number, missingCount: number, verifiedMeetsRequiredLevelCount: number }, topGaps: Array<{ __typename?: 'CareerSkillGapType', slug: string, name: string, status: string, priority: string, requiredLevel: number, myLevel?: number | null }>, steps: Array<{ __typename?: 'GrowthTrackStepType', title: string, description: string, satisfied: boolean, current: number, target: number, progressKind: string }>, skills: Array<{ __typename?: 'ProfessionSkillType', id: string, name: string, slug: string, category: string, iconUrl?: string | null, have: boolean, requirementStatus: string, priority: string, requiredLevel: number, myLevel?: number | null }>, courses: Array<{ __typename?: 'ProfessionCourseType', courseId: string, courseName: string, courseUrl: string, completed: boolean }> }> };

export type CareerSkillDetailQueryVariables = Exact<{
  slug: Scalars['String'];
}>;


export type CareerSkillDetailQuery = { __typename?: 'Query', careerSkillDetail?: { __typename?: 'SkillDetailType', myLevel?: number | null, mySource?: string | null, mentionedInCv: boolean, grantedCourseName?: string | null, grantedLessonNumber?: number | null, skill: { __typename?: 'SkillType', id: string, name: string, slug: string, category: string, description: string, iconUrl?: string | null, levelCriteria: Array<{ __typename?: 'SkillLevelCriteriaType', level: number, points: Array<string>, example: string }> }, demand?: { __typename?: 'SkillDemandType', liveVacancies: number, band: number } | null, providers: Array<{ __typename?: 'SkillProviderType', courseId: string, courseName: string, courseUrl: string, level: number, completed: boolean }>, professions: Array<{ __typename?: 'SkillProfessionType', code: string, title: string, icon: string, summary: string, haveCount: number, totalCount: number, usageNote: string, skillProgress: { __typename?: 'CareerSkillProgressType', requiredCount: number, meetsRequiredLevelCount: number, needsImprovementCount: number, missingCount: number, verifiedMeetsRequiredLevelCount: number } }> } | null };

export type CareerProfessionCourseQueryVariables = Exact<{ [key: string]: never; }>;


export type CareerProfessionCourseQuery = { __typename?: 'Query', careerProfessions: Array<{ __typename?: 'ProfessionType', code: string, nextCourse?: { __typename?: 'CareerCourseRecommendationType', courseId: string, courseName: string, courseUrl: string, careerOutcome: string, durationLabel: string, access: string, closesSkillNames: Array<string>, criticalGaps: number, importantGaps: number, reasonCode: string } | null }> };

export type CareerJourneyBoardQueryVariables = Exact<{ [key: string]: never; }>;


export type CareerJourneyBoardQuery = { __typename?: 'Query', myCareerJourney?: { __typename?: 'CareerJourneyType', isMember: boolean, isPreview: boolean, memberStatus?: string | null, phase: string, hasGoal: boolean, alignment: { __typename?: 'CareerProfileAlignmentType', status: string, goalTrackCode?: string | null, goalTitle?: string | null, profileHeadline: string, profileDirection: string, suggestedHeadline?: string | null }, sections: Array<{ __typename?: 'CareerJourneySectionType', key: string, state: string, isCurrent: boolean, route: string, isBlocked: boolean, blockReason?: string | null, metrics: Array<{ __typename?: 'JourneyMetricType', key: string, value: number, target?: number | null, route?: string | null, isDone?: boolean | null, isBlocked?: boolean | null }> }>, primaryAction?: { __typename?: 'JourneyActionType', id: string, kind: string, stageKey?: string | null, route: string, targetId?: string | null, reasonCode: string, subjectTitle: string, position?: number | null, positionTotal?: number | null, expectedOutcome: string, estimatedMinutes?: number | null, dueDate?: any | null } | null, secondaryActions: Array<{ __typename?: 'JourneyActionType', id: string, kind: string, stageKey?: string | null, route: string, targetId?: string | null, reasonCode: string, subjectTitle: string, position?: number | null, positionTotal?: number | null, expectedOutcome: string, estimatedMinutes?: number | null, dueDate?: any | null }>, goal?: { __typename?: 'CareerGoalType', trackCode: string, title: string, icon: string, isChosen: boolean, targetSkillsMine: number, targetSkillsTotal: number, salaryFrom?: number | null, salaryTo?: number | null, salaryCurrency: string, skillProgress?: { __typename?: 'CareerSkillProgressType', requiredCount: number, meetsRequiredLevelCount: number, needsImprovementCount: number, missingCount: number, verifiedMeetsRequiredLevelCount: number } | null } | null, stages: Array<{ __typename?: 'JourneyStageType', key: string, done: number, total: number, isDone: boolean, isBlocked: boolean, blockReason?: string | null, route: string, targetId?: string | null }>, nextAction?: { __typename?: 'JourneyActionType', kind: string, stageKey?: string | null, route: string, targetId?: string | null } | null, locked: Array<{ __typename?: 'JourneyLockedType', key: string, reasonCode: string }>, cvChecklist: Array<{ __typename?: 'JourneyCheckType', key: string, isDone: boolean }>, applications: { __typename?: 'JourneyApplicationsType', total: number, active: number, applied: number, interview: number, offer: number, rejected: number, hired: number, nextFollowUp?: { __typename?: 'CareerApplicationType', id: string, companyName: string, position: string, status: string, nextActionAt?: any | null } | null, recent: Array<{ __typename?: 'CareerApplicationType', id: string, companyName: string, position: string, status: string, appliedAt?: any | null, nextActionAt?: any | null }> } } | null };

export type CareerApplicationsListQueryVariables = Exact<{
  status?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type CareerApplicationsListQuery = { __typename?: 'Query', myCareerApplications: Array<{ __typename?: 'CareerApplicationType', id: string, vacancyId?: string | null, companyName: string, position: string, applyUrl: string, status: string, appliedAt?: any | null, nextActionAt?: any | null, note: string, source: string, isPlacementConfirmed: boolean, createdAt: any, updatedAt: any }> };

export type MyCareerProfileQueryVariables = Exact<{ [key: string]: never; }>;


export type MyCareerProfileQuery = { __typename?: 'Query', myCareerProfile?: { __typename?: 'CareerProfileType', id: string, firstName: string, lastName: string, email: string, phone: string, photoUrl?: string | null, city: string, country: string, relocationReady: boolean, workMode: string, workPermit: string, availableFrom?: any | null, seniority: string, desiredPosition: string, desiredSalary: string, githubUrl: string, linkedinUrl: string, portfolioUrl: string, customSkills: Array<string>, isSearchable: boolean, contactsVisible: boolean, completeness: number, skills: Array<{ __typename?: 'StudentSkillType', skillId: string, name: string, slug: string, iconUrl?: string | null, category: string, level: number, years?: number | null, source: string, isHidden: boolean, grantedCourseName?: string | null, grantedLessonNumber?: number | null }>, projects: Array<{ __typename?: 'PortfolioProjectType', id: string, title: string, description: string, role: string, repoUrl: string, demoUrl: string, technologyIds: Array<string>, technologyNames: Array<string>, technologies: Array<{ __typename?: 'SkillType', id: string, name: string, slug: string, category: string, iconUrl?: string | null }> }>, experience: Array<{ __typename?: 'WorkExperienceType', id: string, company: string, position: string, description: string, startYear?: number | null, startMonth?: number | null, endYear?: number | null, endMonth?: number | null, isCurrent: boolean }>, education: Array<{ __typename?: 'EducationType', id: string, institution: string, degree: string, specialization: string, startYear?: number | null, startMonth?: number | null, endYear?: number | null, endMonth?: number | null }>, languages: Array<{ __typename?: 'LanguageSkillType', id: string, language: string, level: string }>, certificates: Array<{ __typename?: 'CertificateType', id: string, title: string, issuer: string, issuedAt?: any | null, url: string, fileUrl?: string | null }>, locales: Array<{ __typename?: 'CvLocaleType', language: string, jobTitle: string, about: string }>, cvSkillSuggestions: Array<{ __typename?: 'CvSkillSuggestionType', mentionedAs: string, skill: { __typename?: 'SkillType', id: string, slug: string, name: string, category: string, iconUrl?: string | null } }> } | null };

export type CareerSkillsSearchQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
}>;


export type CareerSkillsSearchQuery = { __typename?: 'Query', careerSkills: Array<{ __typename?: 'SkillType', id: string, name: string, slug: string, iconUrl?: string | null, category: string }> };

export type CareerSkillGraphBoardQueryVariables = Exact<{
  trackCode?: InputMaybe<Scalars['String']>;
}>;


export type CareerSkillGraphBoardQuery = { __typename?: 'Query', myCareerSkillGraph?: { __typename?: 'CareerSkillGraphType', trackCode: string, trackTitle: string, trackIcon: string, trackIsDefault: boolean, isChosenGoal: boolean, isFallback: boolean, fallbackReason: string, computedAt?: any | null, skillProgress: { __typename?: 'CareerSkillProgressType', requiredCount: number, meetsRequiredLevelCount: number, needsImprovementCount: number, missingCount: number, verifiedMeetsRequiredLevelCount: number }, clusters: Array<{ __typename?: 'CareerSkillClusterType', code: string, title: string, description: string, icon: string, order: number }>, nodes: Array<{ __typename?: 'CareerSkillNodeType', id: string, slug: string, name: string, description: string, iconUrl?: string | null, clusterCode: string, requiredLevel: number, priority: string, status: string, requirementStatus: string, myLevel?: number | null, source: string, skill: { __typename?: 'SkillType', category: string }, demand?: { __typename?: 'SkillDemandType', liveVacancies: number, rank: number, band: number, computedAt?: any | null } | null, upcoming?: { __typename?: 'UpcomingUnlockType', lessonNumber: number, lessonsLeft: number } | null, providers: Array<{ __typename?: 'SkillProviderType', courseId: string, courseName: string, courseUrl: string, level: number, completed: boolean }> }>, edges: Array<{ __typename?: 'CareerSkillEdgeType', from: string, to: string, kind: string }>, recommendedCourses: Array<{ __typename?: 'CareerCourseRecommendationType', courseId: string, courseName: string, courseUrl: string, closesNodes: Array<string>, criticalGaps: number, importantGaps: number, careerOutcome: string, durationLabel: string, status: string, access: string, closesSkillNames: Array<string>, reasonCode: string }> } | null };

export type AllCoursesQueryVariables = Exact<{
  active?: InputMaybe<Scalars['Boolean']>;
  finished?: InputMaybe<Scalars['Boolean']>;
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  last?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  courseId?: InputMaybe<Scalars['ID']>;
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  lessonDate?: InputMaybe<Scalars['Date']>;
}>;


export type AllCoursesQuery = { __typename?: 'Query', allGroupsForLms?: { __typename?: 'UnionGroupConnection', totalCount?: number | null, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'UnionGroupEdge', cursor: string, node?: { __typename?: 'GroupType', id: string, passedLessonsCount?: number | null, lessonsCount?: number | null, studentsCount?: number | null, name: string, statusFinished?: boolean | null, datetimeNextLesson?: any | null, course: { __typename?: 'CourseFilterType', id: string, courseIcon?: string | null, educationForm?: string | null, name: string } } | { __typename?: 'MethodistGroupType', id: string, passedLessonsCount?: number | null, lessonsCount?: number | null, studentsCount?: number | null, name: string, statusFinished?: boolean | null, datetimeNextLesson?: any | null, course: { __typename?: 'CourseFilterType', id: string, courseIcon?: string | null, educationForm?: string | null, name: string } } | { __typename?: 'StudentGroupType', id: string, passedLessonsCount?: number | null, lessonsCount?: number | null, studentsCount?: number | null, name: string, statusFinished?: boolean | null, datetimeNextLesson?: any | null, course: { __typename?: 'CourseFilterType', id: string, courseIcon?: string | null, educationForm?: string | null, name: string } } | null } | null> } | null };

export type MethodistGroupOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type MethodistGroupOptionsQuery = { __typename?: 'Query', allGroupsForLms?: { __typename?: 'UnionGroupConnection', edges: Array<{ __typename?: 'UnionGroupEdge', node?: { __typename?: 'GroupType' } | { __typename?: 'MethodistGroupType', id: string, name: string, course: { __typename?: 'CourseFilterType', id: string, name: string } } | { __typename?: 'StudentGroupType' } | null } | null> } | null };

export type GroupForLmsQueryVariables = Exact<{
  groupId?: InputMaybe<Scalars['ID']>;
}>;


export type GroupForLmsQuery = { __typename?: 'Query', groupForLms?: { __typename?: 'GroupType', id: string, statusFinished?: boolean | null, isFree: boolean, passedLessonsCount?: number | null, lessonsCount?: number | null, studentsCount?: number | null, name: string, course: { __typename?: 'CourseFilterType', id: string, courseIcon?: string | null, name: string }, lessons?: Array<{ __typename?: 'GroupLessonType', id: string, name: string, date: any, index?: number | null, needToFinish?: boolean | null }> | null } | { __typename?: 'MethodistGroupType', id: string, statusFinished?: boolean | null, isFree: boolean, passedLessonsCount?: number | null, lessonsCount?: number | null, studentsCount?: number | null, name: string, course: { __typename?: 'CourseFilterType', id: string, courseIcon?: string | null, name: string }, lessons?: Array<{ __typename?: 'GroupLessonType', id: string, name: string, date: any, index?: number | null }> | null } | { __typename?: 'StudentGroupType', id: string, statusFinished?: boolean | null, isFree: boolean, passedLessonsCount?: number | null, lessonsCount?: number | null, studentsCount?: number | null, name: string, course: { __typename?: 'CourseFilterType', id: string, courseIcon?: string | null, name: string }, lessons?: Array<{ __typename?: 'GroupLessonType', id: string, name: string, date: any, index?: number | null }> | null, skillPlan: Array<{ __typename?: 'LessonSkillUnlockType', lessonNumber: number, lessonId?: string | null, isOver: boolean, skills: Array<{ __typename?: 'SkillType', id: string, name: string, slug: string, category: string, iconUrl?: string | null, description: string, unlockLevel?: number | null, courseLevel?: number | null, demandVacancies?: number | null, demandBand?: number | null }> }> } | null };

export type StudentDiplomasQueryVariables = Exact<{ [key: string]: never; }>;


export type StudentDiplomasQuery = { __typename?: 'Query', myDiplomas: Array<{ __typename?: 'MyDiplomaType', id: string, language: DiplomaLanguageEnum, groupName?: string | null, courseName?: string | null, originalName?: string | null, sizeBytes?: number | null, issuedAt?: any | null }> };

export type StudentDiplomaDownloadUrlQueryVariables = Exact<{
  diplomaId: Scalars['ID'];
}>;


export type StudentDiplomaDownloadUrlQuery = { __typename?: 'Query', myDiplomaDownloadUrl?: { __typename?: 'DiplomaDownloadUrlType', url: string, expiresAt: any } | null };

export type MyLessonHomeworkQueryVariables = Exact<{
  lessonId: Scalars['ID'];
}>;


export type MyLessonHomeworkQuery = { __typename?: 'Query', lessonTextbookFiles: Array<{ __typename?: 'LessonTextbookFileType', id: string, title: string, fileName: string, isPdf: boolean }>, myLessonHomework?: { __typename?: 'HomeworkAssignmentForStudentType', id: string, lessonId: string, hasTeacherAssignment: boolean, title?: string | null, text?: string | null, textbookRef?: string | null, dueDate?: any | null, canSubmit: boolean, mySubmission?: { __typename?: 'MyHomeworkSubmissionType', id: string, githubUrl?: string | null, fileName?: string | null, status: string, attempt: number, submittedAt: any, hwMark?: string | null, teacherComment?: string | null } | null } | null };

export type LmsLessonHomeworkQueryVariables = Exact<{
  lessonId: Scalars['ID'];
}>;


export type LmsLessonHomeworkQuery = { __typename?: 'Query', lessonTextbookFiles: Array<{ __typename?: 'LessonTextbookFileType', id: string, title: string, fileName: string, isPdf: boolean }>, lessonHomework?: { __typename?: 'HomeworkAssignmentType', id: string, lessonId: string, title: string, text: string, textbookRef: string, dueDate?: any | null, updatedAt: any } | null };

export type LmsHomeworkRosterQueryVariables = Exact<{
  lessonId: Scalars['ID'];
}>;


export type LmsHomeworkRosterQuery = { __typename?: 'Query', homeworkAiEnabled: boolean, homeworkRoster: Array<{ __typename?: 'HomeworkRosterRowType', studentId: string, studentName: string, hwMark?: string | null, submission?: { __typename?: 'HomeworkSubmissionType', id: string, githubUrl?: string | null, fileName?: string | null, fileSizeBytes?: number | null, status: string, attempt: number, submittedAt: any, teacherComment?: string | null, gradedAt?: any | null, gradedByName?: string | null, aiReview?: { __typename?: 'HomeworkAiReviewType', status: string, aiScore?: number | null, aiSummary?: string | null, aiJustification?: string | null, suspiciousContent: boolean, suspicionNotes?: string | null, errorMessage?: string | null, analyzedAt?: any | null, truncatedBasis?: boolean | null, filesUsedCount?: number | null, assignmentSource?: string | null } | null } | null }> };

export type LmsHomeworkSubmissionDownloadUrlQueryVariables = Exact<{
  submissionId: Scalars['ID'];
}>;


export type LmsHomeworkSubmissionDownloadUrlQuery = { __typename?: 'Query', homeworkSubmissionDownloadUrl?: string | null };

export type StudentInvoicesQueryVariables = Exact<{ [key: string]: never; }>;


export type StudentInvoicesQuery = { __typename?: 'Query', myInvoices?: Array<{ __typename?: 'StudentInvoiceType', fakturowniaId?: string | null, number?: string | null, status?: string | null, issueDate?: any | null, paymentTo?: any | null, currency?: string | null, priceGross?: number | null, paid?: number | null, outstanding?: number | null, isOverdue?: boolean | null, daysOverdue?: number | null, viewUrl?: string | null, paymentUrl?: string | null, isCorrected?: boolean | null, correctionReason?: string | null, isBlocking: boolean } | null> | null };

export type LessonForLmsQueryVariables = Exact<{
  groupLessonId?: InputMaybe<Scalars['ID']>;
}>;


export type LessonForLmsQuery = { __typename?: 'Query', lessonForLms?: { __typename?: 'GroupLessonForLMSType', id: string, name: string, date: any, index?: number | null, lmsDescription?: string | null, startTime: any, endTime: any, finished: boolean, needToFinish?: boolean | null, comment?: string | null, video?: string | null, taskTypes: Array<string>, hasTeacherAttachment?: boolean | null, whiteboardId?: string | null, homeworkAssignmentId?: string | null, homeworkAvailable?: boolean | null, hasJoinLink?: boolean | null, linkOverrideActive?: boolean | null } | { __typename?: 'MethodistLessonType', id: string, name: string, date: any, index?: number | null, lmsDescription?: string | null, startTime: any, endTime: any, finished: boolean, comment?: string | null, video?: string | null, hasTeacherAttachment?: boolean | null, hasStudentAttachment?: boolean | null, whiteboardId?: string | null, homeworkAssignmentId?: string | null, homeworkAvailable?: boolean | null, hasJoinLink?: boolean | null, linkOverrideActive?: boolean | null } | { __typename?: 'StudentLessonType', id: string, name: string, date: any, index?: number | null, lmsDescription?: string | null, startTime: any, endTime: any, finished: boolean, comment?: string | null, video?: string | null, hasStudentMarks?: boolean | null, hasStudentAttachment?: boolean | null, whiteboardId?: string | null, homeworkAssignmentId?: string | null, homeworkAvailable?: boolean | null, hasJoinLink?: boolean | null, linkOverrideActive?: boolean | null } | null };

export type GroupLessonAttendanceForLmsQueryVariables = Exact<{
  groupLessonId?: InputMaybe<Scalars['ID']>;
}>;


export type GroupLessonAttendanceForLmsQuery = { __typename?: 'Query', groupLessonAttendanceForLms?: Array<{ __typename?: 'LessonAttendancesType', id: string, attendance?: boolean | null, source?: string | null, markedAt?: any | null, markedByName?: string | null, student: { __typename?: 'StudentType', id: string, user?: { __typename?: 'CustomUserType', id: string, firstName: string, lastName: string } | null } } | null> | null };

export type GroupLessonAttachmentForLmsQueryVariables = Exact<{
  groupLessonId?: InputMaybe<Scalars['ID']>;
  attachmentRole?: InputMaybe<Scalars['String']>;
}>;


export type GroupLessonAttachmentForLmsQuery = { __typename?: 'Query', groupLessonAttachmentForLms?: Array<{ __typename?: 'LessonAttachmentsForLMSType', id: string, title: string, file: string } | null> | null };

export type GroupLessonAttachmentQueryVariables = Exact<{
  attachmentId?: InputMaybe<Scalars['ID']>;
  attachmentRole?: InputMaybe<Scalars['String']>;
}>;


export type GroupLessonAttachmentQuery = { __typename?: 'Query', groupLessonAttachment?: { __typename?: 'LessonAttachmentsType', id?: string | null, title?: string | null, file?: string | null } | null };

export type StudentsMarksQueryVariables = Exact<{
  lessonsId: Scalars['ID'];
  lessonIdForMarks: Scalars['String'];
  taskType: Scalars['String'];
}>;


export type StudentsMarksQuery = { __typename?: 'Query', studentsMarks?: { __typename?: 'StudentConnection', edges: Array<{ __typename?: 'StudentEdge', node?: { __typename?: 'StudentType', id: string, user?: { __typename?: 'CustomUserType', id: string, firstName: string, lastName: string, student?: { __typename?: 'StudentType', id: string } | null } | null, marks: { __typename?: 'StudentsMarkTypeConnection', edges: Array<{ __typename?: 'StudentsMarkTypeEdge', node?: { __typename?: 'StudentsMarkType', id: string, date: any, mark?: number | null, hwMark?: StudentsMarkHwMark | null } | null } | null> } } | null } | null> } | null };

export type StudentMarksQueryVariables = Exact<{
  lessonsId: Scalars['ID'];
}>;


export type StudentMarksQuery = { __typename?: 'Query', studentMarks?: { __typename?: 'StudentsMarkConnection', edges: Array<{ __typename?: 'StudentsMarkEdge', node?: { __typename?: 'StudentsMarkType', mark?: number | null, hwMark?: StudentsMarkHwMark | null, date: any, taskType?: StudentsMarkTaskType | null } | null } | null> } | null };

export type StudentPendingSurveysQueryVariables = Exact<{ [key: string]: never; }>;


export type StudentPendingSurveysQuery = { __typename?: 'Query', mySurveys: Array<{ __typename?: 'PendingSurveyType', assignmentId: string, title: string, description: string, groupName: string, lessonName: string, lessonNumber: number, teacherName?: string | null, questions: Array<{ __typename?: 'SurveyQuestionForStudentType', id: string, number: number, text: string, questionType: string, required: boolean, options: Array<string> }> }> };

export type StudentSubmittedSurveysQueryVariables = Exact<{ [key: string]: never; }>;


export type StudentSubmittedSurveysQuery = { __typename?: 'Query', mySubmittedSurveys: Array<{ __typename?: 'SubmittedSurveyType', responseId: string, surveyTitle: string, groupName: string, lessonName: string, lessonNumber: number, submittedAt: any, questions: Array<{ __typename?: 'SurveyQuestionForStudentType', id: string, number: number, text: string, questionType: string, required: boolean, options: Array<string> }>, answers: Array<{ __typename?: 'SurveyAnswerViewType', questionId: string, value: any }> }> };

export type GetLessonWhiteboardQueryVariables = Exact<{
  lessonId: Scalars['ID'];
}>;


export type GetLessonWhiteboardQuery = { __typename?: 'Query', lessonWhiteboard?: { __typename?: 'WhiteboardType', id: string, name: string, sceneJson: string, sceneVersion: number, createdAt: any, updatedAt: any, lessons: Array<{ __typename?: 'WhiteboardLessonRefType', lessonId: string, lessonName?: string | null, lessonNumber?: number | null, lessonDate?: any | null }>, files: Array<{ __typename?: 'WhiteboardFileType', fileId: string, mimeType?: string | null, url: string }> } | null };

export type GetWhiteboardLibraryQueryVariables = Exact<{ [key: string]: never; }>;


export type GetWhiteboardLibraryQuery = { __typename?: 'Query', whiteboardLibrary?: { __typename?: 'WhiteboardLibraryType', itemsJson: string, version: number } | null };

export type GetGroupWhiteboardsQueryVariables = Exact<{
  groupId: Scalars['ID'];
}>;


export type GetGroupWhiteboardsQuery = { __typename?: 'Query', groupWhiteboards: Array<{ __typename?: 'WhiteboardMetaType', id: string, name: string, sceneVersion: number, updatedAt: any, lessons: Array<{ __typename?: 'WhiteboardLessonRefType', lessonId: string, lessonName?: string | null, lessonNumber?: number | null, lessonDate?: any | null }> }> };

export type LessonJoinHintsQueryVariables = Exact<{
  groupLessonId: Scalars['Int'];
}>;


export type LessonJoinHintsQuery = { __typename?: 'Query', lmsLessonJoinClicks?: Array<{ __typename?: 'LmsLessonJoinClickType', studentId: number, studentName: string, clickedAt: any } | null> | null };

export const CareerProfileFieldsFragmentDoc = gql`
    fragment CareerProfileFields on CareerProfileType {
  id
  firstName
  lastName
  email
  phone
  photoUrl
  city
  country
  relocationReady
  workMode
  workPermit
  availableFrom
  seniority
  desiredPosition
  desiredSalary
  githubUrl
  linkedinUrl
  portfolioUrl
  customSkills
  isSearchable
  contactsVisible
  completeness
  skills {
    skillId
    name
    slug
    iconUrl
    category
    level
    years
    source
    isHidden
    grantedCourseName
    grantedLessonNumber
  }
  projects {
    id
    title
    description
    role
    repoUrl
    demoUrl
    technologyIds
    technologyNames
    technologies {
      id
      name
      slug
      category
      iconUrl
    }
  }
  experience {
    id
    company
    position
    description
    startYear
    startMonth
    endYear
    endMonth
    isCurrent
  }
  education {
    id
    institution
    degree
    specialization
    startYear
    startMonth
    endYear
    endMonth
  }
  languages {
    id
    language
    level
  }
  certificates {
    id
    title
    issuer
    issuedAt
    url
    fileUrl
  }
  locales {
    language
    jobTitle
    about
  }
  cvSkillSuggestions {
    mentionedAs
    skill {
      id
      slug
      name
      category
      iconUrl
    }
  }
}
    `;
export const UserFieldsFragmentDoc = gql`
    fragment UserFields on UserNode {
  id
  activeRole
  username
  firstName
  middleName
  lastName
  email
  roles
  phone
  methodistGroupsCount
  pendingSurveysCount
  unpaidInvoicesCount
  overdueInvoicesCount
  lmsAccessBlock {
    isBlocked
    blockedAt
    amountsDue {
      amount
      currency
    }
  }
  student {
    groupsCount
  }
  teacher {
    photo
    groupsCount
  }
}
    `;
export const RegisterUserDocument = gql`
    mutation RegisterUser($firstName: String!, $phone: String!, $email: String!, $recaptchaToken: String!) {
  lmsStudentSignUp(
    studentInput: {firstName: $firstName, phone: $phone, email: $email, recaptchaToken: $recaptchaToken}
  ) {
    success
    errors
    customErrors {
      code
      field
      message
    }
    student {
      user {
        firstName
        email
        phone
      }
    }
  }
}
    `;
export type RegisterUserMutationFn = Apollo.MutationFunction<RegisterUserMutation, RegisterUserMutationVariables>;

/**
 * __useRegisterUserMutation__
 *
 * To run a mutation, you first call `useRegisterUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerUserMutation, { data, loading, error }] = useRegisterUserMutation({
 *   variables: {
 *      firstName: // value for 'firstName'
 *      phone: // value for 'phone'
 *      email: // value for 'email'
 *      recaptchaToken: // value for 'recaptchaToken'
 *   },
 * });
 */
export function useRegisterUserMutation(baseOptions?: Apollo.MutationHookOptions<RegisterUserMutation, RegisterUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterUserMutation, RegisterUserMutationVariables>(RegisterUserDocument, options);
      }
export type RegisterUserMutationHookResult = ReturnType<typeof useRegisterUserMutation>;
export type RegisterUserMutationResult = Apollo.MutationResult<RegisterUserMutation>;
export type RegisterUserMutationOptions = Apollo.BaseMutationOptions<RegisterUserMutation, RegisterUserMutationVariables>;
export const CacheIdentityProbeDocument = gql`
    query CacheIdentityProbe {
  careerProfessions {
    code
    skills {
      id
      slug
      priority
      requirementStatus
    }
  }
}
    `;

/**
 * __useCacheIdentityProbeQuery__
 *
 * To run a query within a React component, call `useCacheIdentityProbeQuery` and pass it any options that fit your needs.
 * When your component renders, `useCacheIdentityProbeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCacheIdentityProbeQuery({
 *   variables: {
 *   },
 * });
 */
export function useCacheIdentityProbeQuery(baseOptions?: Apollo.QueryHookOptions<CacheIdentityProbeQuery, CacheIdentityProbeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CacheIdentityProbeQuery, CacheIdentityProbeQueryVariables>(CacheIdentityProbeDocument, options);
      }
export function useCacheIdentityProbeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CacheIdentityProbeQuery, CacheIdentityProbeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CacheIdentityProbeQuery, CacheIdentityProbeQueryVariables>(CacheIdentityProbeDocument, options);
        }
export type CacheIdentityProbeQueryHookResult = ReturnType<typeof useCacheIdentityProbeQuery>;
export type CacheIdentityProbeLazyQueryHookResult = ReturnType<typeof useCacheIdentityProbeLazyQuery>;
export type CacheIdentityProbeQueryResult = Apollo.QueryResult<CacheIdentityProbeQuery, CacheIdentityProbeQueryVariables>;
export const FeedModeProbeDocument = gql`
    query FeedModeProbe($matchMode: String) {
  careerVacancyFeed(matchMode: $matchMode) {
    totalCount
    edges {
      node {
        id
        title
      }
    }
  }
}
    `;

/**
 * __useFeedModeProbeQuery__
 *
 * To run a query within a React component, call `useFeedModeProbeQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeedModeProbeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeedModeProbeQuery({
 *   variables: {
 *      matchMode: // value for 'matchMode'
 *   },
 * });
 */
export function useFeedModeProbeQuery(baseOptions?: Apollo.QueryHookOptions<FeedModeProbeQuery, FeedModeProbeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FeedModeProbeQuery, FeedModeProbeQueryVariables>(FeedModeProbeDocument, options);
      }
export function useFeedModeProbeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FeedModeProbeQuery, FeedModeProbeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FeedModeProbeQuery, FeedModeProbeQueryVariables>(FeedModeProbeDocument, options);
        }
export type FeedModeProbeQueryHookResult = ReturnType<typeof useFeedModeProbeQuery>;
export type FeedModeProbeLazyQueryHookResult = ReturnType<typeof useFeedModeProbeLazyQuery>;
export type FeedModeProbeQueryResult = Apollo.QueryResult<FeedModeProbeQuery, FeedModeProbeQueryVariables>;
export const LessonProbeDocument = gql`
    query LessonProbe {
  me {
    id
  }
}
    `;

/**
 * __useLessonProbeQuery__
 *
 * To run a query within a React component, call `useLessonProbeQuery` and pass it any options that fit your needs.
 * When your component renders, `useLessonProbeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLessonProbeQuery({
 *   variables: {
 *   },
 * });
 */
export function useLessonProbeQuery(baseOptions?: Apollo.QueryHookOptions<LessonProbeQuery, LessonProbeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LessonProbeQuery, LessonProbeQueryVariables>(LessonProbeDocument, options);
      }
export function useLessonProbeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LessonProbeQuery, LessonProbeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LessonProbeQuery, LessonProbeQueryVariables>(LessonProbeDocument, options);
        }
export type LessonProbeQueryHookResult = ReturnType<typeof useLessonProbeQuery>;
export type LessonProbeLazyQueryHookResult = ReturnType<typeof useLessonProbeLazyQuery>;
export type LessonProbeQueryResult = Apollo.QueryResult<LessonProbeQuery, LessonProbeQueryVariables>;
export const SendAuthCodeDocument = gql`
    mutation sendAuthCode($email: String!, $scope: String!) {
  sendLmsAuthEmail(authenticationInput: {email: $email, scope: $scope}) {
    success
    createdAt
    customErrors {
      code
      field
      message
    }
  }
}
    `;
export type SendAuthCodeMutationFn = Apollo.MutationFunction<SendAuthCodeMutation, SendAuthCodeMutationVariables>;

/**
 * __useSendAuthCodeMutation__
 *
 * To run a mutation, you first call `useSendAuthCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendAuthCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendAuthCodeMutation, { data, loading, error }] = useSendAuthCodeMutation({
 *   variables: {
 *      email: // value for 'email'
 *      scope: // value for 'scope'
 *   },
 * });
 */
export function useSendAuthCodeMutation(baseOptions?: Apollo.MutationHookOptions<SendAuthCodeMutation, SendAuthCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendAuthCodeMutation, SendAuthCodeMutationVariables>(SendAuthCodeDocument, options);
      }
export type SendAuthCodeMutationHookResult = ReturnType<typeof useSendAuthCodeMutation>;
export type SendAuthCodeMutationResult = Apollo.MutationResult<SendAuthCodeMutation>;
export type SendAuthCodeMutationOptions = Apollo.BaseMutationOptions<SendAuthCodeMutation, SendAuthCodeMutationVariables>;
export const LoginDocument = gql`
    mutation login($authenticationCode: String!, $email: String!, $scope: String!) {
  customLogin(
    authenticationCode: $authenticationCode
    email: $email
    scope: $scope
  ) {
    success
    token
    refreshToken
    customErrors {
      code
      field
      message
    }
    user {
      ...UserFields
    }
  }
}
    ${UserFieldsFragmentDoc}`;
export type LoginMutationFn = Apollo.MutationFunction<LoginMutation, LoginMutationVariables>;

/**
 * __useLoginMutation__
 *
 * To run a mutation, you first call `useLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginMutation, { data, loading, error }] = useLoginMutation({
 *   variables: {
 *      authenticationCode: // value for 'authenticationCode'
 *      email: // value for 'email'
 *      scope: // value for 'scope'
 *   },
 * });
 */
export function useLoginMutation(baseOptions?: Apollo.MutationHookOptions<LoginMutation, LoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginMutation, LoginMutationVariables>(LoginDocument, options);
      }
export type LoginMutationHookResult = ReturnType<typeof useLoginMutation>;
export type LoginMutationResult = Apollo.MutationResult<LoginMutation>;
export type LoginMutationOptions = Apollo.BaseMutationOptions<LoginMutation, LoginMutationVariables>;
export const RefreshTokenDocument = gql`
    mutation refreshToken($refresh_token: String!, $scope: String!, $activeRole: LmsRoles) {
  refreshToken(
    refreshToken: $refresh_token
    scope: $scope
    activeRole: $activeRole
  ) {
    token
    refreshToken
    payload
    errors
  }
}
    `;
export type RefreshTokenMutationFn = Apollo.MutationFunction<RefreshTokenMutation, RefreshTokenMutationVariables>;

/**
 * __useRefreshTokenMutation__
 *
 * To run a mutation, you first call `useRefreshTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshTokenMutation, { data, loading, error }] = useRefreshTokenMutation({
 *   variables: {
 *      refresh_token: // value for 'refresh_token'
 *      scope: // value for 'scope'
 *      activeRole: // value for 'activeRole'
 *   },
 * });
 */
export function useRefreshTokenMutation(baseOptions?: Apollo.MutationHookOptions<RefreshTokenMutation, RefreshTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefreshTokenMutation, RefreshTokenMutationVariables>(RefreshTokenDocument, options);
      }
export type RefreshTokenMutationHookResult = ReturnType<typeof useRefreshTokenMutation>;
export type RefreshTokenMutationResult = Apollo.MutationResult<RefreshTokenMutation>;
export type RefreshTokenMutationOptions = Apollo.BaseMutationOptions<RefreshTokenMutation, RefreshTokenMutationVariables>;
export const DemoLoginDocument = gql`
    mutation demoLogin($email: String!, $scope: String!) {
  demoCustomLogin(email: $email, scope: $scope) {
    token
    refreshToken
    errors
  }
}
    `;
export type DemoLoginMutationFn = Apollo.MutationFunction<DemoLoginMutation, DemoLoginMutationVariables>;

/**
 * __useDemoLoginMutation__
 *
 * To run a mutation, you first call `useDemoLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDemoLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [demoLoginMutation, { data, loading, error }] = useDemoLoginMutation({
 *   variables: {
 *      email: // value for 'email'
 *      scope: // value for 'scope'
 *   },
 * });
 */
export function useDemoLoginMutation(baseOptions?: Apollo.MutationHookOptions<DemoLoginMutation, DemoLoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DemoLoginMutation, DemoLoginMutationVariables>(DemoLoginDocument, options);
      }
export type DemoLoginMutationHookResult = ReturnType<typeof useDemoLoginMutation>;
export type DemoLoginMutationResult = Apollo.MutationResult<DemoLoginMutation>;
export type DemoLoginMutationOptions = Apollo.BaseMutationOptions<DemoLoginMutation, DemoLoginMutationVariables>;
export const MarkCareerLessonDoneDocument = gql`
    mutation MarkCareerLessonDone($lessonId: ID!, $artifactUrl: String) {
  completeCareerLesson(lessonId: $lessonId, artifactUrl: $artifactUrl) {
    success
    reward {
      grantedTitles
      promoCodes
    }
    customErrors {
      field
      message
      code
    }
    lessonsCompleted
    lessonsTotal
  }
}
    `;
export type MarkCareerLessonDoneMutationFn = Apollo.MutationFunction<MarkCareerLessonDoneMutation, MarkCareerLessonDoneMutationVariables>;

/**
 * __useMarkCareerLessonDoneMutation__
 *
 * To run a mutation, you first call `useMarkCareerLessonDoneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkCareerLessonDoneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markCareerLessonDoneMutation, { data, loading, error }] = useMarkCareerLessonDoneMutation({
 *   variables: {
 *      lessonId: // value for 'lessonId'
 *      artifactUrl: // value for 'artifactUrl'
 *   },
 * });
 */
export function useMarkCareerLessonDoneMutation(baseOptions?: Apollo.MutationHookOptions<MarkCareerLessonDoneMutation, MarkCareerLessonDoneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkCareerLessonDoneMutation, MarkCareerLessonDoneMutationVariables>(MarkCareerLessonDoneDocument, options);
      }
export type MarkCareerLessonDoneMutationHookResult = ReturnType<typeof useMarkCareerLessonDoneMutation>;
export type MarkCareerLessonDoneMutationResult = Apollo.MutationResult<MarkCareerLessonDoneMutation>;
export type MarkCareerLessonDoneMutationOptions = Apollo.BaseMutationOptions<MarkCareerLessonDoneMutation, MarkCareerLessonDoneMutationVariables>;
export const TouchCareerLessonDocument = gql`
    mutation TouchCareerLesson($lessonId: ID!) {
  markCareerLessonOpened(lessonId: $lessonId) {
    success
    customErrors {
      field
      message
      code
    }
    openCount
  }
}
    `;
export type TouchCareerLessonMutationFn = Apollo.MutationFunction<TouchCareerLessonMutation, TouchCareerLessonMutationVariables>;

/**
 * __useTouchCareerLessonMutation__
 *
 * To run a mutation, you first call `useTouchCareerLessonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTouchCareerLessonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [touchCareerLessonMutation, { data, loading, error }] = useTouchCareerLessonMutation({
 *   variables: {
 *      lessonId: // value for 'lessonId'
 *   },
 * });
 */
export function useTouchCareerLessonMutation(baseOptions?: Apollo.MutationHookOptions<TouchCareerLessonMutation, TouchCareerLessonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TouchCareerLessonMutation, TouchCareerLessonMutationVariables>(TouchCareerLessonDocument, options);
      }
export type TouchCareerLessonMutationHookResult = ReturnType<typeof useTouchCareerLessonMutation>;
export type TouchCareerLessonMutationResult = Apollo.MutationResult<TouchCareerLessonMutation>;
export type TouchCareerLessonMutationOptions = Apollo.BaseMutationOptions<TouchCareerLessonMutation, TouchCareerLessonMutationVariables>;
export const StoreCareerLessonNotesDocument = gql`
    mutation StoreCareerLessonNotes($lessonId: ID!, $notes: String!) {
  saveCareerLessonNotes(lessonId: $lessonId, notes: $notes) {
    success
    customErrors {
      field
      message
      code
    }
    notes
  }
}
    `;
export type StoreCareerLessonNotesMutationFn = Apollo.MutationFunction<StoreCareerLessonNotesMutation, StoreCareerLessonNotesMutationVariables>;

/**
 * __useStoreCareerLessonNotesMutation__
 *
 * To run a mutation, you first call `useStoreCareerLessonNotesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStoreCareerLessonNotesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [storeCareerLessonNotesMutation, { data, loading, error }] = useStoreCareerLessonNotesMutation({
 *   variables: {
 *      lessonId: // value for 'lessonId'
 *      notes: // value for 'notes'
 *   },
 * });
 */
export function useStoreCareerLessonNotesMutation(baseOptions?: Apollo.MutationHookOptions<StoreCareerLessonNotesMutation, StoreCareerLessonNotesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StoreCareerLessonNotesMutation, StoreCareerLessonNotesMutationVariables>(StoreCareerLessonNotesDocument, options);
      }
export type StoreCareerLessonNotesMutationHookResult = ReturnType<typeof useStoreCareerLessonNotesMutation>;
export type StoreCareerLessonNotesMutationResult = Apollo.MutationResult<StoreCareerLessonNotesMutation>;
export type StoreCareerLessonNotesMutationOptions = Apollo.BaseMutationOptions<StoreCareerLessonNotesMutation, StoreCareerLessonNotesMutationVariables>;
export const ToggleCareerLessonBookmarkDocument = gql`
    mutation ToggleCareerLessonBookmark($lessonId: ID!, $isBookmarked: Boolean!) {
  setCareerLessonBookmark(lessonId: $lessonId, isBookmarked: $isBookmarked) {
    success
    customErrors {
      field
      message
      code
    }
    isBookmarked
  }
}
    `;
export type ToggleCareerLessonBookmarkMutationFn = Apollo.MutationFunction<ToggleCareerLessonBookmarkMutation, ToggleCareerLessonBookmarkMutationVariables>;

/**
 * __useToggleCareerLessonBookmarkMutation__
 *
 * To run a mutation, you first call `useToggleCareerLessonBookmarkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleCareerLessonBookmarkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleCareerLessonBookmarkMutation, { data, loading, error }] = useToggleCareerLessonBookmarkMutation({
 *   variables: {
 *      lessonId: // value for 'lessonId'
 *      isBookmarked: // value for 'isBookmarked'
 *   },
 * });
 */
export function useToggleCareerLessonBookmarkMutation(baseOptions?: Apollo.MutationHookOptions<ToggleCareerLessonBookmarkMutation, ToggleCareerLessonBookmarkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleCareerLessonBookmarkMutation, ToggleCareerLessonBookmarkMutationVariables>(ToggleCareerLessonBookmarkDocument, options);
      }
export type ToggleCareerLessonBookmarkMutationHookResult = ReturnType<typeof useToggleCareerLessonBookmarkMutation>;
export type ToggleCareerLessonBookmarkMutationResult = Apollo.MutationResult<ToggleCareerLessonBookmarkMutation>;
export type ToggleCareerLessonBookmarkMutationOptions = Apollo.BaseMutationOptions<ToggleCareerLessonBookmarkMutation, ToggleCareerLessonBookmarkMutationVariables>;
export const GradeCareerQuizDocument = gql`
    mutation GradeCareerQuiz($lessonId: ID!, $answers: [CareerQuizAnswerInput!]!) {
  submitCareerQuiz(lessonId: $lessonId, answers: $answers) {
    success
    customErrors {
      field
      message
      code
    }
    score
    maxScore
    results {
      questionId
      correct
      correctIndexes
    }
  }
}
    `;
export type GradeCareerQuizMutationFn = Apollo.MutationFunction<GradeCareerQuizMutation, GradeCareerQuizMutationVariables>;

/**
 * __useGradeCareerQuizMutation__
 *
 * To run a mutation, you first call `useGradeCareerQuizMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGradeCareerQuizMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [gradeCareerQuizMutation, { data, loading, error }] = useGradeCareerQuizMutation({
 *   variables: {
 *      lessonId: // value for 'lessonId'
 *      answers: // value for 'answers'
 *   },
 * });
 */
export function useGradeCareerQuizMutation(baseOptions?: Apollo.MutationHookOptions<GradeCareerQuizMutation, GradeCareerQuizMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GradeCareerQuizMutation, GradeCareerQuizMutationVariables>(GradeCareerQuizDocument, options);
      }
export type GradeCareerQuizMutationHookResult = ReturnType<typeof useGradeCareerQuizMutation>;
export type GradeCareerQuizMutationResult = Apollo.MutationResult<GradeCareerQuizMutation>;
export type GradeCareerQuizMutationOptions = Apollo.BaseMutationOptions<GradeCareerQuizMutation, GradeCareerQuizMutationVariables>;
export const SubmitVacancyInteractionDocument = gql`
    mutation SubmitVacancyInteraction($vacancyId: ID!, $kind: String!) {
  markVacancyInteraction(vacancyId: $vacancyId, kind: $kind) {
    success
    customErrors {
      field
      message
      code
    }
    vacancy {
      id
      myInteraction
    }
  }
}
    `;
export type SubmitVacancyInteractionMutationFn = Apollo.MutationFunction<SubmitVacancyInteractionMutation, SubmitVacancyInteractionMutationVariables>;

/**
 * __useSubmitVacancyInteractionMutation__
 *
 * To run a mutation, you first call `useSubmitVacancyInteractionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitVacancyInteractionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitVacancyInteractionMutation, { data, loading, error }] = useSubmitVacancyInteractionMutation({
 *   variables: {
 *      vacancyId: // value for 'vacancyId'
 *      kind: // value for 'kind'
 *   },
 * });
 */
export function useSubmitVacancyInteractionMutation(baseOptions?: Apollo.MutationHookOptions<SubmitVacancyInteractionMutation, SubmitVacancyInteractionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitVacancyInteractionMutation, SubmitVacancyInteractionMutationVariables>(SubmitVacancyInteractionDocument, options);
      }
export type SubmitVacancyInteractionMutationHookResult = ReturnType<typeof useSubmitVacancyInteractionMutation>;
export type SubmitVacancyInteractionMutationResult = Apollo.MutationResult<SubmitVacancyInteractionMutation>;
export type SubmitVacancyInteractionMutationOptions = Apollo.BaseMutationOptions<SubmitVacancyInteractionMutation, SubmitVacancyInteractionMutationVariables>;
export const SubmitCareerExerciseDocument = gql`
    mutation SubmitCareerExercise($lessonId: ID!, $answers: [CareerExerciseAnswerInput!]!) {
  submitCareerLessonExercise(lessonId: $lessonId, answers: $answers) {
    success
    reward {
      grantedTitles
      promoCodes
    }
    lessonsCompleted
    lessonsTotal
    submission {
      id
      submittedAt
    }
    applyReport {
      writtenTargets
      skippedTargets
      profileCompleteness
    }
    customErrors {
      field
      message
      code
    }
  }
}
    `;
export type SubmitCareerExerciseMutationFn = Apollo.MutationFunction<SubmitCareerExerciseMutation, SubmitCareerExerciseMutationVariables>;

/**
 * __useSubmitCareerExerciseMutation__
 *
 * To run a mutation, you first call `useSubmitCareerExerciseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitCareerExerciseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitCareerExerciseMutation, { data, loading, error }] = useSubmitCareerExerciseMutation({
 *   variables: {
 *      lessonId: // value for 'lessonId'
 *      answers: // value for 'answers'
 *   },
 * });
 */
export function useSubmitCareerExerciseMutation(baseOptions?: Apollo.MutationHookOptions<SubmitCareerExerciseMutation, SubmitCareerExerciseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitCareerExerciseMutation, SubmitCareerExerciseMutationVariables>(SubmitCareerExerciseDocument, options);
      }
export type SubmitCareerExerciseMutationHookResult = ReturnType<typeof useSubmitCareerExerciseMutation>;
export type SubmitCareerExerciseMutationResult = Apollo.MutationResult<SubmitCareerExerciseMutation>;
export type SubmitCareerExerciseMutationOptions = Apollo.BaseMutationOptions<SubmitCareerExerciseMutation, SubmitCareerExerciseMutationVariables>;
export const ChooseGrowthTrackDocument = gql`
    mutation ChooseGrowthTrack($trackCode: String!) {
  chooseGrowthTrack(trackCode: $trackCode) {
    success
    trackCode
    customErrors {
      code
      field
      message
    }
  }
}
    `;
export type ChooseGrowthTrackMutationFn = Apollo.MutationFunction<ChooseGrowthTrackMutation, ChooseGrowthTrackMutationVariables>;

/**
 * __useChooseGrowthTrackMutation__
 *
 * To run a mutation, you first call `useChooseGrowthTrackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChooseGrowthTrackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [chooseGrowthTrackMutation, { data, loading, error }] = useChooseGrowthTrackMutation({
 *   variables: {
 *      trackCode: // value for 'trackCode'
 *   },
 * });
 */
export function useChooseGrowthTrackMutation(baseOptions?: Apollo.MutationHookOptions<ChooseGrowthTrackMutation, ChooseGrowthTrackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChooseGrowthTrackMutation, ChooseGrowthTrackMutationVariables>(ChooseGrowthTrackDocument, options);
      }
export type ChooseGrowthTrackMutationHookResult = ReturnType<typeof useChooseGrowthTrackMutation>;
export type ChooseGrowthTrackMutationResult = Apollo.MutationResult<ChooseGrowthTrackMutation>;
export type ChooseGrowthTrackMutationOptions = Apollo.BaseMutationOptions<ChooseGrowthTrackMutation, ChooseGrowthTrackMutationVariables>;
export const RegisterShareDocument = gql`
    mutation RegisterShare($channel: String!) {
  registerShare(channel: $channel) {
    success
    result {
      counted
      grantedTitles
      promoCodes
    }
    customErrors {
      code
      field
      message
    }
  }
}
    `;
export type RegisterShareMutationFn = Apollo.MutationFunction<RegisterShareMutation, RegisterShareMutationVariables>;

/**
 * __useRegisterShareMutation__
 *
 * To run a mutation, you first call `useRegisterShareMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterShareMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerShareMutation, { data, loading, error }] = useRegisterShareMutation({
 *   variables: {
 *      channel: // value for 'channel'
 *   },
 * });
 */
export function useRegisterShareMutation(baseOptions?: Apollo.MutationHookOptions<RegisterShareMutation, RegisterShareMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterShareMutation, RegisterShareMutationVariables>(RegisterShareDocument, options);
      }
export type RegisterShareMutationHookResult = ReturnType<typeof useRegisterShareMutation>;
export type RegisterShareMutationResult = Apollo.MutationResult<RegisterShareMutation>;
export type RegisterShareMutationOptions = Apollo.BaseMutationOptions<RegisterShareMutation, RegisterShareMutationVariables>;
export const TrackJobApplicationDocument = gql`
    mutation TrackJobApplication($input: CareerApplicationInput!) {
  createCareerApplication(input: $input) {
    success
    duplicate
    application {
      id
      vacancyId
      companyName
      position
      applyUrl
      status
      appliedAt
      nextActionAt
      note
      source
      isPlacementConfirmed
      createdAt
      updatedAt
    }
    customErrors {
      code
      field
      message
    }
  }
}
    `;
export type TrackJobApplicationMutationFn = Apollo.MutationFunction<TrackJobApplicationMutation, TrackJobApplicationMutationVariables>;

/**
 * __useTrackJobApplicationMutation__
 *
 * To run a mutation, you first call `useTrackJobApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTrackJobApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [trackJobApplicationMutation, { data, loading, error }] = useTrackJobApplicationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTrackJobApplicationMutation(baseOptions?: Apollo.MutationHookOptions<TrackJobApplicationMutation, TrackJobApplicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TrackJobApplicationMutation, TrackJobApplicationMutationVariables>(TrackJobApplicationDocument, options);
      }
export type TrackJobApplicationMutationHookResult = ReturnType<typeof useTrackJobApplicationMutation>;
export type TrackJobApplicationMutationResult = Apollo.MutationResult<TrackJobApplicationMutation>;
export type TrackJobApplicationMutationOptions = Apollo.BaseMutationOptions<TrackJobApplicationMutation, TrackJobApplicationMutationVariables>;
export const ReviseJobApplicationDocument = gql`
    mutation ReviseJobApplication($id: ID!, $input: CareerApplicationInput!) {
  updateCareerApplication(id: $id, input: $input) {
    success
    application {
      id
      vacancyId
      companyName
      position
      applyUrl
      status
      appliedAt
      nextActionAt
      note
      source
      isPlacementConfirmed
      createdAt
      updatedAt
    }
    customErrors {
      code
      field
      message
    }
  }
}
    `;
export type ReviseJobApplicationMutationFn = Apollo.MutationFunction<ReviseJobApplicationMutation, ReviseJobApplicationMutationVariables>;

/**
 * __useReviseJobApplicationMutation__
 *
 * To run a mutation, you first call `useReviseJobApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReviseJobApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reviseJobApplicationMutation, { data, loading, error }] = useReviseJobApplicationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReviseJobApplicationMutation(baseOptions?: Apollo.MutationHookOptions<ReviseJobApplicationMutation, ReviseJobApplicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReviseJobApplicationMutation, ReviseJobApplicationMutationVariables>(ReviseJobApplicationDocument, options);
      }
export type ReviseJobApplicationMutationHookResult = ReturnType<typeof useReviseJobApplicationMutation>;
export type ReviseJobApplicationMutationResult = Apollo.MutationResult<ReviseJobApplicationMutation>;
export type ReviseJobApplicationMutationOptions = Apollo.BaseMutationOptions<ReviseJobApplicationMutation, ReviseJobApplicationMutationVariables>;
export const MoveJobApplicationDocument = gql`
    mutation MoveJobApplication($id: ID!, $status: String!) {
  setCareerApplicationStatus(id: $id, status: $status) {
    success
    application {
      id
      vacancyId
      companyName
      position
      applyUrl
      status
      appliedAt
      nextActionAt
      note
      source
      isPlacementConfirmed
      createdAt
      updatedAt
    }
    customErrors {
      code
      field
      message
    }
  }
}
    `;
export type MoveJobApplicationMutationFn = Apollo.MutationFunction<MoveJobApplicationMutation, MoveJobApplicationMutationVariables>;

/**
 * __useMoveJobApplicationMutation__
 *
 * To run a mutation, you first call `useMoveJobApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveJobApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveJobApplicationMutation, { data, loading, error }] = useMoveJobApplicationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useMoveJobApplicationMutation(baseOptions?: Apollo.MutationHookOptions<MoveJobApplicationMutation, MoveJobApplicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MoveJobApplicationMutation, MoveJobApplicationMutationVariables>(MoveJobApplicationDocument, options);
      }
export type MoveJobApplicationMutationHookResult = ReturnType<typeof useMoveJobApplicationMutation>;
export type MoveJobApplicationMutationResult = Apollo.MutationResult<MoveJobApplicationMutation>;
export type MoveJobApplicationMutationOptions = Apollo.BaseMutationOptions<MoveJobApplicationMutation, MoveJobApplicationMutationVariables>;
export const DropJobApplicationDocument = gql`
    mutation DropJobApplication($id: ID!) {
  deleteCareerApplication(id: $id) {
    success
    deleted
    customErrors {
      code
      field
      message
    }
  }
}
    `;
export type DropJobApplicationMutationFn = Apollo.MutationFunction<DropJobApplicationMutation, DropJobApplicationMutationVariables>;

/**
 * __useDropJobApplicationMutation__
 *
 * To run a mutation, you first call `useDropJobApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDropJobApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dropJobApplicationMutation, { data, loading, error }] = useDropJobApplicationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDropJobApplicationMutation(baseOptions?: Apollo.MutationHookOptions<DropJobApplicationMutation, DropJobApplicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DropJobApplicationMutation, DropJobApplicationMutationVariables>(DropJobApplicationDocument, options);
      }
export type DropJobApplicationMutationHookResult = ReturnType<typeof useDropJobApplicationMutation>;
export type DropJobApplicationMutationResult = Apollo.MutationResult<DropJobApplicationMutation>;
export type DropJobApplicationMutationOptions = Apollo.BaseMutationOptions<DropJobApplicationMutation, DropJobApplicationMutationVariables>;
export const SaveCareerProfileFormDocument = gql`
    mutation SaveCareerProfileForm($input: CareerProfileInput!, $photo: Upload, $clearPhoto: Boolean) {
  saveCareerProfile(input: $input, photo: $photo, clearPhoto: $clearPhoto) {
    success
    customErrors {
      field
      message
      code
    }
    profile {
      ...CareerProfileFields
    }
  }
}
    ${CareerProfileFieldsFragmentDoc}`;
export type SaveCareerProfileFormMutationFn = Apollo.MutationFunction<SaveCareerProfileFormMutation, SaveCareerProfileFormMutationVariables>;

/**
 * __useSaveCareerProfileFormMutation__
 *
 * To run a mutation, you first call `useSaveCareerProfileFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveCareerProfileFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveCareerProfileFormMutation, { data, loading, error }] = useSaveCareerProfileFormMutation({
 *   variables: {
 *      input: // value for 'input'
 *      photo: // value for 'photo'
 *      clearPhoto: // value for 'clearPhoto'
 *   },
 * });
 */
export function useSaveCareerProfileFormMutation(baseOptions?: Apollo.MutationHookOptions<SaveCareerProfileFormMutation, SaveCareerProfileFormMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveCareerProfileFormMutation, SaveCareerProfileFormMutationVariables>(SaveCareerProfileFormDocument, options);
      }
export type SaveCareerProfileFormMutationHookResult = ReturnType<typeof useSaveCareerProfileFormMutation>;
export type SaveCareerProfileFormMutationResult = Apollo.MutationResult<SaveCareerProfileFormMutation>;
export type SaveCareerProfileFormMutationOptions = Apollo.BaseMutationOptions<SaveCareerProfileFormMutation, SaveCareerProfileFormMutationVariables>;
export const SetProfileSearchableDocument = gql`
    mutation SetProfileSearchable($isSearchable: Boolean!, $contactsVisible: Boolean) {
  setProfileSearchable(
    isSearchable: $isSearchable
    contactsVisible: $contactsVisible
  ) {
    success
    customErrors {
      field
      message
      code
    }
    profile {
      id
      isSearchable
      contactsVisible
    }
  }
}
    `;
export type SetProfileSearchableMutationFn = Apollo.MutationFunction<SetProfileSearchableMutation, SetProfileSearchableMutationVariables>;

/**
 * __useSetProfileSearchableMutation__
 *
 * To run a mutation, you first call `useSetProfileSearchableMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetProfileSearchableMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setProfileSearchableMutation, { data, loading, error }] = useSetProfileSearchableMutation({
 *   variables: {
 *      isSearchable: // value for 'isSearchable'
 *      contactsVisible: // value for 'contactsVisible'
 *   },
 * });
 */
export function useSetProfileSearchableMutation(baseOptions?: Apollo.MutationHookOptions<SetProfileSearchableMutation, SetProfileSearchableMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetProfileSearchableMutation, SetProfileSearchableMutationVariables>(SetProfileSearchableDocument, options);
      }
export type SetProfileSearchableMutationHookResult = ReturnType<typeof useSetProfileSearchableMutation>;
export type SetProfileSearchableMutationResult = Apollo.MutationResult<SetProfileSearchableMutation>;
export type SetProfileSearchableMutationOptions = Apollo.BaseMutationOptions<SetProfileSearchableMutation, SetProfileSearchableMutationVariables>;
export const SetMySkillLevelChoiceDocument = gql`
    mutation SetMySkillLevelChoice($skillId: ID!, $level: Int!) {
  setMySkillLevel(skillId: $skillId, level: $level) {
    success
    customErrors {
      field
      message
      code
    }
    skill {
      skillId
      level
      source
    }
  }
}
    `;
export type SetMySkillLevelChoiceMutationFn = Apollo.MutationFunction<SetMySkillLevelChoiceMutation, SetMySkillLevelChoiceMutationVariables>;

/**
 * __useSetMySkillLevelChoiceMutation__
 *
 * To run a mutation, you first call `useSetMySkillLevelChoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetMySkillLevelChoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setMySkillLevelChoiceMutation, { data, loading, error }] = useSetMySkillLevelChoiceMutation({
 *   variables: {
 *      skillId: // value for 'skillId'
 *      level: // value for 'level'
 *   },
 * });
 */
export function useSetMySkillLevelChoiceMutation(baseOptions?: Apollo.MutationHookOptions<SetMySkillLevelChoiceMutation, SetMySkillLevelChoiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetMySkillLevelChoiceMutation, SetMySkillLevelChoiceMutationVariables>(SetMySkillLevelChoiceDocument, options);
      }
export type SetMySkillLevelChoiceMutationHookResult = ReturnType<typeof useSetMySkillLevelChoiceMutation>;
export type SetMySkillLevelChoiceMutationResult = Apollo.MutationResult<SetMySkillLevelChoiceMutation>;
export type SetMySkillLevelChoiceMutationOptions = Apollo.BaseMutationOptions<SetMySkillLevelChoiceMutation, SetMySkillLevelChoiceMutationVariables>;
export const SubmitLessonHomeworkDocument = gql`
    mutation SubmitLessonHomework($lessonId: ID!, $githubUrl: String, $file: Upload) {
  submitHomework(lessonId: $lessonId, githubUrl: $githubUrl, file: $file) {
    success
    customErrors {
      code
      field
      message
    }
    submission {
      id
      githubUrl
      fileName
      status
      attempt
      submittedAt
      hwMark
      teacherComment
    }
  }
}
    `;
export type SubmitLessonHomeworkMutationFn = Apollo.MutationFunction<SubmitLessonHomeworkMutation, SubmitLessonHomeworkMutationVariables>;

/**
 * __useSubmitLessonHomeworkMutation__
 *
 * To run a mutation, you first call `useSubmitLessonHomeworkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitLessonHomeworkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitLessonHomeworkMutation, { data, loading, error }] = useSubmitLessonHomeworkMutation({
 *   variables: {
 *      lessonId: // value for 'lessonId'
 *      githubUrl: // value for 'githubUrl'
 *      file: // value for 'file'
 *   },
 * });
 */
export function useSubmitLessonHomeworkMutation(baseOptions?: Apollo.MutationHookOptions<SubmitLessonHomeworkMutation, SubmitLessonHomeworkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitLessonHomeworkMutation, SubmitLessonHomeworkMutationVariables>(SubmitLessonHomeworkDocument, options);
      }
export type SubmitLessonHomeworkMutationHookResult = ReturnType<typeof useSubmitLessonHomeworkMutation>;
export type SubmitLessonHomeworkMutationResult = Apollo.MutationResult<SubmitLessonHomeworkMutation>;
export type SubmitLessonHomeworkMutationOptions = Apollo.BaseMutationOptions<SubmitLessonHomeworkMutation, SubmitLessonHomeworkMutationVariables>;
export const UpsertLessonHomeworkAssignmentDocument = gql`
    mutation UpsertLessonHomeworkAssignment($lessonId: ID!, $title: String, $text: String, $textbookRef: String, $dueDate: Date) {
  upsertHomeworkAssignment(
    lessonId: $lessonId
    title: $title
    text: $text
    textbookRef: $textbookRef
    dueDate: $dueDate
  ) {
    success
    customErrors {
      code
      field
      message
    }
    assignment {
      id
      lessonId
      title
      text
      textbookRef
      dueDate
      updatedAt
    }
  }
}
    `;
export type UpsertLessonHomeworkAssignmentMutationFn = Apollo.MutationFunction<UpsertLessonHomeworkAssignmentMutation, UpsertLessonHomeworkAssignmentMutationVariables>;

/**
 * __useUpsertLessonHomeworkAssignmentMutation__
 *
 * To run a mutation, you first call `useUpsertLessonHomeworkAssignmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertLessonHomeworkAssignmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertLessonHomeworkAssignmentMutation, { data, loading, error }] = useUpsertLessonHomeworkAssignmentMutation({
 *   variables: {
 *      lessonId: // value for 'lessonId'
 *      title: // value for 'title'
 *      text: // value for 'text'
 *      textbookRef: // value for 'textbookRef'
 *      dueDate: // value for 'dueDate'
 *   },
 * });
 */
export function useUpsertLessonHomeworkAssignmentMutation(baseOptions?: Apollo.MutationHookOptions<UpsertLessonHomeworkAssignmentMutation, UpsertLessonHomeworkAssignmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertLessonHomeworkAssignmentMutation, UpsertLessonHomeworkAssignmentMutationVariables>(UpsertLessonHomeworkAssignmentDocument, options);
      }
export type UpsertLessonHomeworkAssignmentMutationHookResult = ReturnType<typeof useUpsertLessonHomeworkAssignmentMutation>;
export type UpsertLessonHomeworkAssignmentMutationResult = Apollo.MutationResult<UpsertLessonHomeworkAssignmentMutation>;
export type UpsertLessonHomeworkAssignmentMutationOptions = Apollo.BaseMutationOptions<UpsertLessonHomeworkAssignmentMutation, UpsertLessonHomeworkAssignmentMutationVariables>;
export const GradeHomeworkSubmissionDocument = gql`
    mutation GradeHomeworkSubmission($lessonId: ID!, $studentId: ID!, $hwMark: String!, $comment: String, $attempt: Int) {
  gradeHomework(
    lessonId: $lessonId
    studentId: $studentId
    hwMark: $hwMark
    comment: $comment
    attempt: $attempt
  ) {
    success
    customErrors {
      code
      field
      message
    }
    row {
      studentId
      hwMark
      submission {
        id
        status
        teacherComment
        gradedByName
      }
    }
  }
}
    `;
export type GradeHomeworkSubmissionMutationFn = Apollo.MutationFunction<GradeHomeworkSubmissionMutation, GradeHomeworkSubmissionMutationVariables>;

/**
 * __useGradeHomeworkSubmissionMutation__
 *
 * To run a mutation, you first call `useGradeHomeworkSubmissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGradeHomeworkSubmissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [gradeHomeworkSubmissionMutation, { data, loading, error }] = useGradeHomeworkSubmissionMutation({
 *   variables: {
 *      lessonId: // value for 'lessonId'
 *      studentId: // value for 'studentId'
 *      hwMark: // value for 'hwMark'
 *      comment: // value for 'comment'
 *      attempt: // value for 'attempt'
 *   },
 * });
 */
export function useGradeHomeworkSubmissionMutation(baseOptions?: Apollo.MutationHookOptions<GradeHomeworkSubmissionMutation, GradeHomeworkSubmissionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GradeHomeworkSubmissionMutation, GradeHomeworkSubmissionMutationVariables>(GradeHomeworkSubmissionDocument, options);
      }
export type GradeHomeworkSubmissionMutationHookResult = ReturnType<typeof useGradeHomeworkSubmissionMutation>;
export type GradeHomeworkSubmissionMutationResult = Apollo.MutationResult<GradeHomeworkSubmissionMutation>;
export type GradeHomeworkSubmissionMutationOptions = Apollo.BaseMutationOptions<GradeHomeworkSubmissionMutation, GradeHomeworkSubmissionMutationVariables>;
export const RerunSubmissionAiReviewDocument = gql`
    mutation RerunSubmissionAiReview($submissionId: ID!) {
  rerunHomeworkAiReview(submissionId: $submissionId) {
    success
    customErrors {
      code
      field
      message
    }
    aiReviewStatus
  }
}
    `;
export type RerunSubmissionAiReviewMutationFn = Apollo.MutationFunction<RerunSubmissionAiReviewMutation, RerunSubmissionAiReviewMutationVariables>;

/**
 * __useRerunSubmissionAiReviewMutation__
 *
 * To run a mutation, you first call `useRerunSubmissionAiReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRerunSubmissionAiReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rerunSubmissionAiReviewMutation, { data, loading, error }] = useRerunSubmissionAiReviewMutation({
 *   variables: {
 *      submissionId: // value for 'submissionId'
 *   },
 * });
 */
export function useRerunSubmissionAiReviewMutation(baseOptions?: Apollo.MutationHookOptions<RerunSubmissionAiReviewMutation, RerunSubmissionAiReviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RerunSubmissionAiReviewMutation, RerunSubmissionAiReviewMutationVariables>(RerunSubmissionAiReviewDocument, options);
      }
export type RerunSubmissionAiReviewMutationHookResult = ReturnType<typeof useRerunSubmissionAiReviewMutation>;
export type RerunSubmissionAiReviewMutationResult = Apollo.MutationResult<RerunSubmissionAiReviewMutation>;
export type RerunSubmissionAiReviewMutationOptions = Apollo.BaseMutationOptions<RerunSubmissionAiReviewMutation, RerunSubmissionAiReviewMutationVariables>;
export const FinishLessonDocument = gql`
    mutation finishLesson($groupLessonId: Int!, $comment: String!) {
  finishLmsLesson(groupLessonId: $groupLessonId, comment: $comment) {
    success
    errors
    customErrors {
      code
      field
      message
    }
  }
}
    `;
export type FinishLessonMutationFn = Apollo.MutationFunction<FinishLessonMutation, FinishLessonMutationVariables>;

/**
 * __useFinishLessonMutation__
 *
 * To run a mutation, you first call `useFinishLessonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinishLessonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [finishLessonMutation, { data, loading, error }] = useFinishLessonMutation({
 *   variables: {
 *      groupLessonId: // value for 'groupLessonId'
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useFinishLessonMutation(baseOptions?: Apollo.MutationHookOptions<FinishLessonMutation, FinishLessonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FinishLessonMutation, FinishLessonMutationVariables>(FinishLessonDocument, options);
      }
export type FinishLessonMutationHookResult = ReturnType<typeof useFinishLessonMutation>;
export type FinishLessonMutationResult = Apollo.MutationResult<FinishLessonMutation>;
export type FinishLessonMutationOptions = Apollo.BaseMutationOptions<FinishLessonMutation, FinishLessonMutationVariables>;
export const SetLessonAttendanceDocument = gql`
    mutation SetLessonAttendance($attendanceId: Int!, $attendance: Boolean!) {
  lmsSetAttendance(attendanceId: $attendanceId, attendance: $attendance) {
    success
    customErrors {
      code
      field
      message
    }
    attendance {
      id
      attendance
      source
      markedAt
      markedByName
    }
  }
}
    `;
export type SetLessonAttendanceMutationFn = Apollo.MutationFunction<SetLessonAttendanceMutation, SetLessonAttendanceMutationVariables>;

/**
 * __useSetLessonAttendanceMutation__
 *
 * To run a mutation, you first call `useSetLessonAttendanceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetLessonAttendanceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setLessonAttendanceMutation, { data, loading, error }] = useSetLessonAttendanceMutation({
 *   variables: {
 *      attendanceId: // value for 'attendanceId'
 *      attendance: // value for 'attendance'
 *   },
 * });
 */
export function useSetLessonAttendanceMutation(baseOptions?: Apollo.MutationHookOptions<SetLessonAttendanceMutation, SetLessonAttendanceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetLessonAttendanceMutation, SetLessonAttendanceMutationVariables>(SetLessonAttendanceDocument, options);
      }
export type SetLessonAttendanceMutationHookResult = ReturnType<typeof useSetLessonAttendanceMutation>;
export type SetLessonAttendanceMutationResult = Apollo.MutationResult<SetLessonAttendanceMutation>;
export type SetLessonAttendanceMutationOptions = Apollo.BaseMutationOptions<SetLessonAttendanceMutation, SetLessonAttendanceMutationVariables>;
export const UploadLessonVideoDocument = gql`
    mutation uploadLessonVideo($lessonId: Int!, $videoUrl: String!) {
  uploadLessonVideo(lessonId: $lessonId, videoUrl: $videoUrl) {
    success
    customErrors {
      code
      field
      message
    }
  }
}
    `;
export type UploadLessonVideoMutationFn = Apollo.MutationFunction<UploadLessonVideoMutation, UploadLessonVideoMutationVariables>;

/**
 * __useUploadLessonVideoMutation__
 *
 * To run a mutation, you first call `useUploadLessonVideoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadLessonVideoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadLessonVideoMutation, { data, loading, error }] = useUploadLessonVideoMutation({
 *   variables: {
 *      lessonId: // value for 'lessonId'
 *      videoUrl: // value for 'videoUrl'
 *   },
 * });
 */
export function useUploadLessonVideoMutation(baseOptions?: Apollo.MutationHookOptions<UploadLessonVideoMutation, UploadLessonVideoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadLessonVideoMutation, UploadLessonVideoMutationVariables>(UploadLessonVideoDocument, options);
      }
export type UploadLessonVideoMutationHookResult = ReturnType<typeof useUploadLessonVideoMutation>;
export type UploadLessonVideoMutationResult = Apollo.MutationResult<UploadLessonVideoMutation>;
export type UploadLessonVideoMutationOptions = Apollo.BaseMutationOptions<UploadLessonVideoMutation, UploadLessonVideoMutationVariables>;
export const CancelUploadVideoDocument = gql`
    mutation cancelUploadVideo($lessonId: Int!) {
  cancelVideoUpload(lessonId: $lessonId) {
    customErrors {
      field
      code
      message
    }
  }
}
    `;
export type CancelUploadVideoMutationFn = Apollo.MutationFunction<CancelUploadVideoMutation, CancelUploadVideoMutationVariables>;

/**
 * __useCancelUploadVideoMutation__
 *
 * To run a mutation, you first call `useCancelUploadVideoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelUploadVideoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelUploadVideoMutation, { data, loading, error }] = useCancelUploadVideoMutation({
 *   variables: {
 *      lessonId: // value for 'lessonId'
 *   },
 * });
 */
export function useCancelUploadVideoMutation(baseOptions?: Apollo.MutationHookOptions<CancelUploadVideoMutation, CancelUploadVideoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelUploadVideoMutation, CancelUploadVideoMutationVariables>(CancelUploadVideoDocument, options);
      }
export type CancelUploadVideoMutationHookResult = ReturnType<typeof useCancelUploadVideoMutation>;
export type CancelUploadVideoMutationResult = Apollo.MutationResult<CancelUploadVideoMutation>;
export type CancelUploadVideoMutationOptions = Apollo.BaseMutationOptions<CancelUploadVideoMutation, CancelUploadVideoMutationVariables>;
export const AddStudentsMarksDocument = gql`
    mutation addStudentsMarks($lessonId: Int!, $taskType: LessonTaskTypeEnum!, $studentsMarks: [LessonMarkInput]!, $date: Date!) {
  setStudentsMarks(
    lessonId: $lessonId
    taskType: $taskType
    studentsMarks: $studentsMarks
    date: $date
  ) {
    success
    customErrors {
      field
      code
      message
    }
  }
}
    `;
export type AddStudentsMarksMutationFn = Apollo.MutationFunction<AddStudentsMarksMutation, AddStudentsMarksMutationVariables>;

/**
 * __useAddStudentsMarksMutation__
 *
 * To run a mutation, you first call `useAddStudentsMarksMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddStudentsMarksMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addStudentsMarksMutation, { data, loading, error }] = useAddStudentsMarksMutation({
 *   variables: {
 *      lessonId: // value for 'lessonId'
 *      taskType: // value for 'taskType'
 *      studentsMarks: // value for 'studentsMarks'
 *      date: // value for 'date'
 *   },
 * });
 */
export function useAddStudentsMarksMutation(baseOptions?: Apollo.MutationHookOptions<AddStudentsMarksMutation, AddStudentsMarksMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddStudentsMarksMutation, AddStudentsMarksMutationVariables>(AddStudentsMarksDocument, options);
      }
export type AddStudentsMarksMutationHookResult = ReturnType<typeof useAddStudentsMarksMutation>;
export type AddStudentsMarksMutationResult = Apollo.MutationResult<AddStudentsMarksMutation>;
export type AddStudentsMarksMutationOptions = Apollo.BaseMutationOptions<AddStudentsMarksMutation, AddStudentsMarksMutationVariables>;
export const SendSurveyResponseDocument = gql`
    mutation SendSurveyResponse($assignmentId: ID!, $answers: [SurveyAnswerInput!]!) {
  submitSurveyResponse(assignmentId: $assignmentId, answers: $answers) {
    success
    customErrors {
      code
      field
      message
    }
  }
}
    `;
export type SendSurveyResponseMutationFn = Apollo.MutationFunction<SendSurveyResponseMutation, SendSurveyResponseMutationVariables>;

/**
 * __useSendSurveyResponseMutation__
 *
 * To run a mutation, you first call `useSendSurveyResponseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendSurveyResponseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendSurveyResponseMutation, { data, loading, error }] = useSendSurveyResponseMutation({
 *   variables: {
 *      assignmentId: // value for 'assignmentId'
 *      answers: // value for 'answers'
 *   },
 * });
 */
export function useSendSurveyResponseMutation(baseOptions?: Apollo.MutationHookOptions<SendSurveyResponseMutation, SendSurveyResponseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendSurveyResponseMutation, SendSurveyResponseMutationVariables>(SendSurveyResponseDocument, options);
      }
export type SendSurveyResponseMutationHookResult = ReturnType<typeof useSendSurveyResponseMutation>;
export type SendSurveyResponseMutationResult = Apollo.MutationResult<SendSurveyResponseMutation>;
export type SendSurveyResponseMutationOptions = Apollo.BaseMutationOptions<SendSurveyResponseMutation, SendSurveyResponseMutationVariables>;
export const CreateWhiteboardForLessonDocument = gql`
    mutation CreateWhiteboardForLesson($lessonId: ID!, $name: String) {
  createLessonWhiteboard(lessonId: $lessonId, name: $name) {
    success
    customErrors {
      code
      field
      message
    }
    whiteboard {
      id
      name
      sceneJson
      sceneVersion
    }
  }
}
    `;
export type CreateWhiteboardForLessonMutationFn = Apollo.MutationFunction<CreateWhiteboardForLessonMutation, CreateWhiteboardForLessonMutationVariables>;

/**
 * __useCreateWhiteboardForLessonMutation__
 *
 * To run a mutation, you first call `useCreateWhiteboardForLessonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWhiteboardForLessonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWhiteboardForLessonMutation, { data, loading, error }] = useCreateWhiteboardForLessonMutation({
 *   variables: {
 *      lessonId: // value for 'lessonId'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCreateWhiteboardForLessonMutation(baseOptions?: Apollo.MutationHookOptions<CreateWhiteboardForLessonMutation, CreateWhiteboardForLessonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateWhiteboardForLessonMutation, CreateWhiteboardForLessonMutationVariables>(CreateWhiteboardForLessonDocument, options);
      }
export type CreateWhiteboardForLessonMutationHookResult = ReturnType<typeof useCreateWhiteboardForLessonMutation>;
export type CreateWhiteboardForLessonMutationResult = Apollo.MutationResult<CreateWhiteboardForLessonMutation>;
export type CreateWhiteboardForLessonMutationOptions = Apollo.BaseMutationOptions<CreateWhiteboardForLessonMutation, CreateWhiteboardForLessonMutationVariables>;
export const LinkWhiteboardToLessonDocument = gql`
    mutation LinkWhiteboardToLesson($lessonId: ID!, $whiteboardId: ID!) {
  linkLessonWhiteboard(lessonId: $lessonId, whiteboardId: $whiteboardId) {
    success
    customErrors {
      code
      field
      message
    }
    whiteboard {
      id
      name
      sceneJson
      sceneVersion
    }
  }
}
    `;
export type LinkWhiteboardToLessonMutationFn = Apollo.MutationFunction<LinkWhiteboardToLessonMutation, LinkWhiteboardToLessonMutationVariables>;

/**
 * __useLinkWhiteboardToLessonMutation__
 *
 * To run a mutation, you first call `useLinkWhiteboardToLessonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkWhiteboardToLessonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkWhiteboardToLessonMutation, { data, loading, error }] = useLinkWhiteboardToLessonMutation({
 *   variables: {
 *      lessonId: // value for 'lessonId'
 *      whiteboardId: // value for 'whiteboardId'
 *   },
 * });
 */
export function useLinkWhiteboardToLessonMutation(baseOptions?: Apollo.MutationHookOptions<LinkWhiteboardToLessonMutation, LinkWhiteboardToLessonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LinkWhiteboardToLessonMutation, LinkWhiteboardToLessonMutationVariables>(LinkWhiteboardToLessonDocument, options);
      }
export type LinkWhiteboardToLessonMutationHookResult = ReturnType<typeof useLinkWhiteboardToLessonMutation>;
export type LinkWhiteboardToLessonMutationResult = Apollo.MutationResult<LinkWhiteboardToLessonMutation>;
export type LinkWhiteboardToLessonMutationOptions = Apollo.BaseMutationOptions<LinkWhiteboardToLessonMutation, LinkWhiteboardToLessonMutationVariables>;
export const SaveBoardSceneDocument = gql`
    mutation SaveBoardScene($whiteboardId: ID!, $sceneJson: String!, $expectedVersion: Int!) {
  saveWhiteboardScene(
    whiteboardId: $whiteboardId
    sceneJson: $sceneJson
    expectedVersion: $expectedVersion
  ) {
    success
    customErrors {
      code
      field
      message
    }
    sceneVersion
    whiteboard {
      id
      sceneVersion
    }
  }
}
    `;
export type SaveBoardSceneMutationFn = Apollo.MutationFunction<SaveBoardSceneMutation, SaveBoardSceneMutationVariables>;

/**
 * __useSaveBoardSceneMutation__
 *
 * To run a mutation, you first call `useSaveBoardSceneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveBoardSceneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveBoardSceneMutation, { data, loading, error }] = useSaveBoardSceneMutation({
 *   variables: {
 *      whiteboardId: // value for 'whiteboardId'
 *      sceneJson: // value for 'sceneJson'
 *      expectedVersion: // value for 'expectedVersion'
 *   },
 * });
 */
export function useSaveBoardSceneMutation(baseOptions?: Apollo.MutationHookOptions<SaveBoardSceneMutation, SaveBoardSceneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveBoardSceneMutation, SaveBoardSceneMutationVariables>(SaveBoardSceneDocument, options);
      }
export type SaveBoardSceneMutationHookResult = ReturnType<typeof useSaveBoardSceneMutation>;
export type SaveBoardSceneMutationResult = Apollo.MutationResult<SaveBoardSceneMutation>;
export type SaveBoardSceneMutationOptions = Apollo.BaseMutationOptions<SaveBoardSceneMutation, SaveBoardSceneMutationVariables>;
export const RenameBoardDocument = gql`
    mutation RenameBoard($whiteboardId: ID!, $name: String!) {
  renameWhiteboard(whiteboardId: $whiteboardId, name: $name) {
    success
    customErrors {
      code
      field
      message
    }
    whiteboard {
      id
      name
    }
  }
}
    `;
export type RenameBoardMutationFn = Apollo.MutationFunction<RenameBoardMutation, RenameBoardMutationVariables>;

/**
 * __useRenameBoardMutation__
 *
 * To run a mutation, you first call `useRenameBoardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRenameBoardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [renameBoardMutation, { data, loading, error }] = useRenameBoardMutation({
 *   variables: {
 *      whiteboardId: // value for 'whiteboardId'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useRenameBoardMutation(baseOptions?: Apollo.MutationHookOptions<RenameBoardMutation, RenameBoardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RenameBoardMutation, RenameBoardMutationVariables>(RenameBoardDocument, options);
      }
export type RenameBoardMutationHookResult = ReturnType<typeof useRenameBoardMutation>;
export type RenameBoardMutationResult = Apollo.MutationResult<RenameBoardMutation>;
export type RenameBoardMutationOptions = Apollo.BaseMutationOptions<RenameBoardMutation, RenameBoardMutationVariables>;
export const UnlinkWhiteboardFromLessonDocument = gql`
    mutation UnlinkWhiteboardFromLesson($lessonId: ID!) {
  unlinkLessonWhiteboard(lessonId: $lessonId) {
    success
    customErrors {
      code
      field
      message
    }
  }
}
    `;
export type UnlinkWhiteboardFromLessonMutationFn = Apollo.MutationFunction<UnlinkWhiteboardFromLessonMutation, UnlinkWhiteboardFromLessonMutationVariables>;

/**
 * __useUnlinkWhiteboardFromLessonMutation__
 *
 * To run a mutation, you first call `useUnlinkWhiteboardFromLessonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlinkWhiteboardFromLessonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlinkWhiteboardFromLessonMutation, { data, loading, error }] = useUnlinkWhiteboardFromLessonMutation({
 *   variables: {
 *      lessonId: // value for 'lessonId'
 *   },
 * });
 */
export function useUnlinkWhiteboardFromLessonMutation(baseOptions?: Apollo.MutationHookOptions<UnlinkWhiteboardFromLessonMutation, UnlinkWhiteboardFromLessonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnlinkWhiteboardFromLessonMutation, UnlinkWhiteboardFromLessonMutationVariables>(UnlinkWhiteboardFromLessonDocument, options);
      }
export type UnlinkWhiteboardFromLessonMutationHookResult = ReturnType<typeof useUnlinkWhiteboardFromLessonMutation>;
export type UnlinkWhiteboardFromLessonMutationResult = Apollo.MutationResult<UnlinkWhiteboardFromLessonMutation>;
export type UnlinkWhiteboardFromLessonMutationOptions = Apollo.BaseMutationOptions<UnlinkWhiteboardFromLessonMutation, UnlinkWhiteboardFromLessonMutationVariables>;
export const UploadBoardImageDocument = gql`
    mutation UploadBoardImage($whiteboardId: ID!, $fileId: String!, $mimeType: String, $file: Upload!) {
  uploadWhiteboardFile(
    whiteboardId: $whiteboardId
    fileId: $fileId
    mimeType: $mimeType
    file: $file
  ) {
    success
    customErrors {
      code
      field
      message
    }
    file {
      fileId
      mimeType
      url
    }
  }
}
    `;
export type UploadBoardImageMutationFn = Apollo.MutationFunction<UploadBoardImageMutation, UploadBoardImageMutationVariables>;

/**
 * __useUploadBoardImageMutation__
 *
 * To run a mutation, you first call `useUploadBoardImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadBoardImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadBoardImageMutation, { data, loading, error }] = useUploadBoardImageMutation({
 *   variables: {
 *      whiteboardId: // value for 'whiteboardId'
 *      fileId: // value for 'fileId'
 *      mimeType: // value for 'mimeType'
 *      file: // value for 'file'
 *   },
 * });
 */
export function useUploadBoardImageMutation(baseOptions?: Apollo.MutationHookOptions<UploadBoardImageMutation, UploadBoardImageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadBoardImageMutation, UploadBoardImageMutationVariables>(UploadBoardImageDocument, options);
      }
export type UploadBoardImageMutationHookResult = ReturnType<typeof useUploadBoardImageMutation>;
export type UploadBoardImageMutationResult = Apollo.MutationResult<UploadBoardImageMutation>;
export type UploadBoardImageMutationOptions = Apollo.BaseMutationOptions<UploadBoardImageMutation, UploadBoardImageMutationVariables>;
export const SaveSchoolLibraryDocument = gql`
    mutation SaveSchoolLibrary($itemsJson: String!, $expectedVersion: Int!) {
  saveWhiteboardLibrary(itemsJson: $itemsJson, expectedVersion: $expectedVersion) {
    success
    customErrors {
      code
      field
      message
    }
    version
  }
}
    `;
export type SaveSchoolLibraryMutationFn = Apollo.MutationFunction<SaveSchoolLibraryMutation, SaveSchoolLibraryMutationVariables>;

/**
 * __useSaveSchoolLibraryMutation__
 *
 * To run a mutation, you first call `useSaveSchoolLibraryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveSchoolLibraryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveSchoolLibraryMutation, { data, loading, error }] = useSaveSchoolLibraryMutation({
 *   variables: {
 *      itemsJson: // value for 'itemsJson'
 *      expectedVersion: // value for 'expectedVersion'
 *   },
 * });
 */
export function useSaveSchoolLibraryMutation(baseOptions?: Apollo.MutationHookOptions<SaveSchoolLibraryMutation, SaveSchoolLibraryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveSchoolLibraryMutation, SaveSchoolLibraryMutationVariables>(SaveSchoolLibraryDocument, options);
      }
export type SaveSchoolLibraryMutationHookResult = ReturnType<typeof useSaveSchoolLibraryMutation>;
export type SaveSchoolLibraryMutationResult = Apollo.MutationResult<SaveSchoolLibraryMutation>;
export type SaveSchoolLibraryMutationOptions = Apollo.BaseMutationOptions<SaveSchoolLibraryMutation, SaveSchoolLibraryMutationVariables>;
export const JoinLessonNowDocument = gql`
    mutation JoinLessonNow($groupLessonId: Int!) {
  lmsJoinLesson(groupLessonId: $groupLessonId) {
    success
    redirectUrl
    customErrors {
      field
      code
      message
    }
  }
}
    `;
export type JoinLessonNowMutationFn = Apollo.MutationFunction<JoinLessonNowMutation, JoinLessonNowMutationVariables>;

/**
 * __useJoinLessonNowMutation__
 *
 * To run a mutation, you first call `useJoinLessonNowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useJoinLessonNowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [joinLessonNowMutation, { data, loading, error }] = useJoinLessonNowMutation({
 *   variables: {
 *      groupLessonId: // value for 'groupLessonId'
 *   },
 * });
 */
export function useJoinLessonNowMutation(baseOptions?: Apollo.MutationHookOptions<JoinLessonNowMutation, JoinLessonNowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<JoinLessonNowMutation, JoinLessonNowMutationVariables>(JoinLessonNowDocument, options);
      }
export type JoinLessonNowMutationHookResult = ReturnType<typeof useJoinLessonNowMutation>;
export type JoinLessonNowMutationResult = Apollo.MutationResult<JoinLessonNowMutation>;
export type JoinLessonNowMutationOptions = Apollo.BaseMutationOptions<JoinLessonNowMutation, JoinLessonNowMutationVariables>;
export const PutTodayLessonLinkDocument = gql`
    mutation PutTodayLessonLink($groupId: Int!, $joinUrl: String!) {
  lmsSetTodayLessonLink(groupId: $groupId, joinUrl: $joinUrl) {
    success
    customErrors {
      field
      code
      message
    }
  }
}
    `;
export type PutTodayLessonLinkMutationFn = Apollo.MutationFunction<PutTodayLessonLinkMutation, PutTodayLessonLinkMutationVariables>;

/**
 * __usePutTodayLessonLinkMutation__
 *
 * To run a mutation, you first call `usePutTodayLessonLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePutTodayLessonLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [putTodayLessonLinkMutation, { data, loading, error }] = usePutTodayLessonLinkMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      joinUrl: // value for 'joinUrl'
 *   },
 * });
 */
export function usePutTodayLessonLinkMutation(baseOptions?: Apollo.MutationHookOptions<PutTodayLessonLinkMutation, PutTodayLessonLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PutTodayLessonLinkMutation, PutTodayLessonLinkMutationVariables>(PutTodayLessonLinkDocument, options);
      }
export type PutTodayLessonLinkMutationHookResult = ReturnType<typeof usePutTodayLessonLinkMutation>;
export type PutTodayLessonLinkMutationResult = Apollo.MutationResult<PutTodayLessonLinkMutation>;
export type PutTodayLessonLinkMutationOptions = Apollo.BaseMutationOptions<PutTodayLessonLinkMutation, PutTodayLessonLinkMutationVariables>;
export const DropTodayLessonLinkDocument = gql`
    mutation DropTodayLessonLink($groupId: Int!) {
  lmsClearTodayLessonLink(groupId: $groupId) {
    success
    customErrors {
      field
      code
      message
    }
  }
}
    `;
export type DropTodayLessonLinkMutationFn = Apollo.MutationFunction<DropTodayLessonLinkMutation, DropTodayLessonLinkMutationVariables>;

/**
 * __useDropTodayLessonLinkMutation__
 *
 * To run a mutation, you first call `useDropTodayLessonLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDropTodayLessonLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dropTodayLessonLinkMutation, { data, loading, error }] = useDropTodayLessonLinkMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useDropTodayLessonLinkMutation(baseOptions?: Apollo.MutationHookOptions<DropTodayLessonLinkMutation, DropTodayLessonLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DropTodayLessonLinkMutation, DropTodayLessonLinkMutationVariables>(DropTodayLessonLinkDocument, options);
      }
export type DropTodayLessonLinkMutationHookResult = ReturnType<typeof useDropTodayLessonLinkMutation>;
export type DropTodayLessonLinkMutationResult = Apollo.MutationResult<DropTodayLessonLinkMutation>;
export type DropTodayLessonLinkMutationOptions = Apollo.BaseMutationOptions<DropTodayLessonLinkMutation, DropTodayLessonLinkMutationVariables>;
export const StudentGroupAttendanceDocument = gql`
    query StudentGroupAttendance($groupId: ID!) {
  myAttendance(groupId: $groupId) {
    lessonId
    lessonName
    lessonNumber
    date
    attendance
  }
}
    `;

/**
 * __useStudentGroupAttendanceQuery__
 *
 * To run a query within a React component, call `useStudentGroupAttendanceQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentGroupAttendanceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentGroupAttendanceQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useStudentGroupAttendanceQuery(baseOptions: Apollo.QueryHookOptions<StudentGroupAttendanceQuery, StudentGroupAttendanceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StudentGroupAttendanceQuery, StudentGroupAttendanceQueryVariables>(StudentGroupAttendanceDocument, options);
      }
export function useStudentGroupAttendanceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StudentGroupAttendanceQuery, StudentGroupAttendanceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StudentGroupAttendanceQuery, StudentGroupAttendanceQueryVariables>(StudentGroupAttendanceDocument, options);
        }
export type StudentGroupAttendanceQueryHookResult = ReturnType<typeof useStudentGroupAttendanceQuery>;
export type StudentGroupAttendanceLazyQueryHookResult = ReturnType<typeof useStudentGroupAttendanceLazyQuery>;
export type StudentGroupAttendanceQueryResult = Apollo.QueryResult<StudentGroupAttendanceQuery, StudentGroupAttendanceQueryVariables>;
export const MeDocument = gql`
    query me {
  me {
    ...UserFields
  }
}
    ${UserFieldsFragmentDoc}`;

/**
 * __useMeQuery__
 *
 * To run a query within a React component, call `useMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useMeQuery(baseOptions?: Apollo.QueryHookOptions<MeQuery, MeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MeQuery, MeQueryVariables>(MeDocument, options);
      }
export function useMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeQuery, MeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MeQuery, MeQueryVariables>(MeDocument, options);
        }
export type MeQueryHookResult = ReturnType<typeof useMeQuery>;
export type MeLazyQueryHookResult = ReturnType<typeof useMeLazyQuery>;
export type MeQueryResult = Apollo.QueryResult<MeQuery, MeQueryVariables>;
export const MyCareerCenterInfoDocument = gql`
    query MyCareerCenterInfo {
  myCareerCenter {
    isPreview
    memberId
    status
    directionTitle
    directionId
    directionSource
    enrolledAt
    lessonsCompleted
    lessonsTotal
  }
}
    `;

/**
 * __useMyCareerCenterInfoQuery__
 *
 * To run a query within a React component, call `useMyCareerCenterInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyCareerCenterInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyCareerCenterInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyCareerCenterInfoQuery(baseOptions?: Apollo.QueryHookOptions<MyCareerCenterInfoQuery, MyCareerCenterInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyCareerCenterInfoQuery, MyCareerCenterInfoQueryVariables>(MyCareerCenterInfoDocument, options);
      }
export function useMyCareerCenterInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyCareerCenterInfoQuery, MyCareerCenterInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyCareerCenterInfoQuery, MyCareerCenterInfoQueryVariables>(MyCareerCenterInfoDocument, options);
        }
export type MyCareerCenterInfoQueryHookResult = ReturnType<typeof useMyCareerCenterInfoQuery>;
export type MyCareerCenterInfoLazyQueryHookResult = ReturnType<typeof useMyCareerCenterInfoLazyQuery>;
export type MyCareerCenterInfoQueryResult = Apollo.QueryResult<MyCareerCenterInfoQuery, MyCareerCenterInfoQueryVariables>;
export const CareerLessonsListDocument = gql`
    query CareerLessonsList {
  careerLessons {
    id
    order
    title
    summary
    durationMin
    completionKind
    outcomeKind
    outcomeLabel
    state
    materialLanguage
    unlockAfter {
      lessonId
      order
      title
    }
    hasVideo
    attachmentsCount
    quizQuestionsCount
    hasExercise
    isUnlocked
    isCompleted
    completedAt
    isOpened
    isBookmarked
  }
}
    `;

/**
 * __useCareerLessonsListQuery__
 *
 * To run a query within a React component, call `useCareerLessonsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useCareerLessonsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCareerLessonsListQuery({
 *   variables: {
 *   },
 * });
 */
export function useCareerLessonsListQuery(baseOptions?: Apollo.QueryHookOptions<CareerLessonsListQuery, CareerLessonsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CareerLessonsListQuery, CareerLessonsListQueryVariables>(CareerLessonsListDocument, options);
      }
export function useCareerLessonsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CareerLessonsListQuery, CareerLessonsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CareerLessonsListQuery, CareerLessonsListQueryVariables>(CareerLessonsListDocument, options);
        }
export type CareerLessonsListQueryHookResult = ReturnType<typeof useCareerLessonsListQuery>;
export type CareerLessonsListLazyQueryHookResult = ReturnType<typeof useCareerLessonsListLazyQuery>;
export type CareerLessonsListQueryResult = Apollo.QueryResult<CareerLessonsListQuery, CareerLessonsListQueryVariables>;
export const CareerLessonDetailDocument = gql`
    query CareerLessonDetail($id: ID!) {
  careerLesson(id: $id) {
    id
    order
    title
    summary
    durationMin
    completionKind
    outcomeKind
    outcomeLabel
    state
    materialLanguage
    unlockAfter {
      lessonId
      order
      title
    }
    hasVideo
    attachmentsCount
    quizQuestionsCount
    hasExercise
    artifactHint
    isUnlocked
    isCompleted
    completedAt
    isOpened
    openedAt
    openCount
    peersCompleted
    myNotes
    isBookmarked
    content
    videoUrl
    attachments {
      id
      originalName
      contentType
      sizeBytes
      url
    }
    quizQuestions {
      id
      order
      text
      options
      correctIndexes
    }
    exercise {
      id
      intro
      outro
      fields {
        id
        number
        label
        helpText
        placeholder
        fieldType
        required
        options
        maxLength
        binding
        bindingLanguage
        prefill
      }
      mySubmission {
        id
        submittedAt
        answers {
          fieldId
          value
        }
      }
    }
  }
}
    `;

/**
 * __useCareerLessonDetailQuery__
 *
 * To run a query within a React component, call `useCareerLessonDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useCareerLessonDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCareerLessonDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCareerLessonDetailQuery(baseOptions: Apollo.QueryHookOptions<CareerLessonDetailQuery, CareerLessonDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CareerLessonDetailQuery, CareerLessonDetailQueryVariables>(CareerLessonDetailDocument, options);
      }
export function useCareerLessonDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CareerLessonDetailQuery, CareerLessonDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CareerLessonDetailQuery, CareerLessonDetailQueryVariables>(CareerLessonDetailDocument, options);
        }
export type CareerLessonDetailQueryHookResult = ReturnType<typeof useCareerLessonDetailQuery>;
export type CareerLessonDetailLazyQueryHookResult = ReturnType<typeof useCareerLessonDetailLazyQuery>;
export type CareerLessonDetailQueryResult = Apollo.QueryResult<CareerLessonDetailQuery, CareerLessonDetailQueryVariables>;
export const MyCareerVacanciesDocument = gql`
    query MyCareerVacancies($directionId: ID, $skillId: ID, $workMode: String, $seniority: String, $search: String, $savedOnly: Boolean) {
  careerVacancies(
    directionId: $directionId
    skillId: $skillId
    workMode: $workMode
    seniority: $seniority
    search: $search
    savedOnly: $savedOnly
  ) {
    id
    title
    companyName
    applyUrl
    location
    workMode
    seniority
    employmentType
    salaryMin
    salaryMax
    salaryCurrency
    description
    publishedAt
    expiresAt
    directionIds
    directionTitles
    skillNames
    myInteraction
  }
}
    `;

/**
 * __useMyCareerVacanciesQuery__
 *
 * To run a query within a React component, call `useMyCareerVacanciesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyCareerVacanciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyCareerVacanciesQuery({
 *   variables: {
 *      directionId: // value for 'directionId'
 *      skillId: // value for 'skillId'
 *      workMode: // value for 'workMode'
 *      seniority: // value for 'seniority'
 *      search: // value for 'search'
 *      savedOnly: // value for 'savedOnly'
 *   },
 * });
 */
export function useMyCareerVacanciesQuery(baseOptions?: Apollo.QueryHookOptions<MyCareerVacanciesQuery, MyCareerVacanciesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyCareerVacanciesQuery, MyCareerVacanciesQueryVariables>(MyCareerVacanciesDocument, options);
      }
export function useMyCareerVacanciesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyCareerVacanciesQuery, MyCareerVacanciesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyCareerVacanciesQuery, MyCareerVacanciesQueryVariables>(MyCareerVacanciesDocument, options);
        }
export type MyCareerVacanciesQueryHookResult = ReturnType<typeof useMyCareerVacanciesQuery>;
export type MyCareerVacanciesLazyQueryHookResult = ReturnType<typeof useMyCareerVacanciesLazyQuery>;
export type MyCareerVacanciesQueryResult = Apollo.QueryResult<MyCareerVacanciesQuery, MyCareerVacanciesQueryVariables>;
export const MyCareerVacancyFeedDocument = gql`
    query MyCareerVacancyFeed($directionId: ID, $skillIds: [ID!], $cityId: ID, $workMode: String, $seniority: String, $employmentType: String, $salaryFrom: Int, $freshness: String, $search: String, $savedOnly: Boolean, $sort: String, $matchMode: String, $first: Int, $after: String) {
  careerVacancyFeed(
    directionId: $directionId
    skillIds: $skillIds
    cityId: $cityId
    workMode: $workMode
    seniority: $seniority
    employmentType: $employmentType
    salaryFrom: $salaryFrom
    freshness: $freshness
    search: $search
    savedOnly: $savedOnly
    sort: $sort
    matchMode: $matchMode
    first: $first
    after: $after
  ) {
    totalCount
    totalCountCapped
    totalAvailable
    relevanceApplied
    matchContext {
      matchMode
      trackCode
      trackTitle
      fallbackReason
    }
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      cursor
      node {
        id
        title
        companyName
        applyUrl
        location
        cityId
        cityName
        workMode
        seniority
        employmentType
        salaryMin
        salaryMax
        salaryCurrency
        descriptionShort
        publishedAt
        expiresAt
        isNew
        directionIds
        directionTitles
        skillIds
        skillNames
        skills {
          id
          name
          slug
          category
          iconUrl
        }
        skillMatch {
          status
          matchedCount
          totalCount
          matchedSkills {
            id
          }
          missingSkills {
            id
          }
          unratedSkills {
            id
          }
        }
        myInteraction
      }
    }
  }
}
    `;

/**
 * __useMyCareerVacancyFeedQuery__
 *
 * To run a query within a React component, call `useMyCareerVacancyFeedQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyCareerVacancyFeedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyCareerVacancyFeedQuery({
 *   variables: {
 *      directionId: // value for 'directionId'
 *      skillIds: // value for 'skillIds'
 *      cityId: // value for 'cityId'
 *      workMode: // value for 'workMode'
 *      seniority: // value for 'seniority'
 *      employmentType: // value for 'employmentType'
 *      salaryFrom: // value for 'salaryFrom'
 *      freshness: // value for 'freshness'
 *      search: // value for 'search'
 *      savedOnly: // value for 'savedOnly'
 *      sort: // value for 'sort'
 *      matchMode: // value for 'matchMode'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useMyCareerVacancyFeedQuery(baseOptions?: Apollo.QueryHookOptions<MyCareerVacancyFeedQuery, MyCareerVacancyFeedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyCareerVacancyFeedQuery, MyCareerVacancyFeedQueryVariables>(MyCareerVacancyFeedDocument, options);
      }
export function useMyCareerVacancyFeedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyCareerVacancyFeedQuery, MyCareerVacancyFeedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyCareerVacancyFeedQuery, MyCareerVacancyFeedQueryVariables>(MyCareerVacancyFeedDocument, options);
        }
export type MyCareerVacancyFeedQueryHookResult = ReturnType<typeof useMyCareerVacancyFeedQuery>;
export type MyCareerVacancyFeedLazyQueryHookResult = ReturnType<typeof useMyCareerVacancyFeedLazyQuery>;
export type MyCareerVacancyFeedQueryResult = Apollo.QueryResult<MyCareerVacancyFeedQuery, MyCareerVacancyFeedQueryVariables>;
export const MyCareerVacancyDocument = gql`
    query MyCareerVacancy($id: ID!) {
  careerVacancy(id: $id) {
    id
    title
    companyName
    applyUrl
    location
    cityName
    workMode
    seniority
    employmentType
    salaryMin
    salaryMax
    salaryCurrency
    description
    publishedAt
    expiresAt
    isNew
    directionTitles
    skillIds
    skillNames
    skills {
      id
      name
      slug
      category
      iconUrl
    }
    skillMatch {
      status
      matchedCount
      totalCount
      matchedSkills {
        id
      }
      missingSkills {
        id
      }
      unratedSkills {
        id
      }
    }
    myInteraction
  }
}
    `;

/**
 * __useMyCareerVacancyQuery__
 *
 * To run a query within a React component, call `useMyCareerVacancyQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyCareerVacancyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyCareerVacancyQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMyCareerVacancyQuery(baseOptions: Apollo.QueryHookOptions<MyCareerVacancyQuery, MyCareerVacancyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyCareerVacancyQuery, MyCareerVacancyQueryVariables>(MyCareerVacancyDocument, options);
      }
export function useMyCareerVacancyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyCareerVacancyQuery, MyCareerVacancyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyCareerVacancyQuery, MyCareerVacancyQueryVariables>(MyCareerVacancyDocument, options);
        }
export type MyCareerVacancyQueryHookResult = ReturnType<typeof useMyCareerVacancyQuery>;
export type MyCareerVacancyLazyQueryHookResult = ReturnType<typeof useMyCareerVacancyLazyQuery>;
export type MyCareerVacancyQueryResult = Apollo.QueryResult<MyCareerVacancyQuery, MyCareerVacancyQueryVariables>;
export const MyCareerFilterDictionariesDocument = gql`
    query MyCareerFilterDictionaries {
  careerDirectionsLms {
    id
    title
  }
  careerCities {
    id
    name
    country
  }
}
    `;

/**
 * __useMyCareerFilterDictionariesQuery__
 *
 * To run a query within a React component, call `useMyCareerFilterDictionariesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyCareerFilterDictionariesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyCareerFilterDictionariesQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyCareerFilterDictionariesQuery(baseOptions?: Apollo.QueryHookOptions<MyCareerFilterDictionariesQuery, MyCareerFilterDictionariesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyCareerFilterDictionariesQuery, MyCareerFilterDictionariesQueryVariables>(MyCareerFilterDictionariesDocument, options);
      }
export function useMyCareerFilterDictionariesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyCareerFilterDictionariesQuery, MyCareerFilterDictionariesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyCareerFilterDictionariesQuery, MyCareerFilterDictionariesQueryVariables>(MyCareerFilterDictionariesDocument, options);
        }
export type MyCareerFilterDictionariesQueryHookResult = ReturnType<typeof useMyCareerFilterDictionariesQuery>;
export type MyCareerFilterDictionariesLazyQueryHookResult = ReturnType<typeof useMyCareerFilterDictionariesLazyQuery>;
export type MyCareerFilterDictionariesQueryResult = Apollo.QueryResult<MyCareerFilterDictionariesQuery, MyCareerFilterDictionariesQueryVariables>;
export const MyGrowthDocument = gql`
    query MyGrowth {
  myGrowth {
    xp
    level
    levelTitle
    levelFloorXp
    nextLevelXp
    levels {
      index
      title
      threshold
      reached
    }
    availableTotal
    lockedTotal
    isCareerMember
    achievements {
      code
      title
      description
      icon
      category
      points
      earned
      earnedAt
      current
      target
      locked
      hidden
      progressKind
    }
  }
}
    `;

/**
 * __useMyGrowthQuery__
 *
 * To run a query within a React component, call `useMyGrowthQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyGrowthQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyGrowthQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyGrowthQuery(baseOptions?: Apollo.QueryHookOptions<MyGrowthQuery, MyGrowthQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyGrowthQuery, MyGrowthQueryVariables>(MyGrowthDocument, options);
      }
export function useMyGrowthLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyGrowthQuery, MyGrowthQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyGrowthQuery, MyGrowthQueryVariables>(MyGrowthDocument, options);
        }
export type MyGrowthQueryHookResult = ReturnType<typeof useMyGrowthQuery>;
export type MyGrowthLazyQueryHookResult = ReturnType<typeof useMyGrowthLazyQuery>;
export type MyGrowthQueryResult = Apollo.QueryResult<MyGrowthQuery, MyGrowthQueryVariables>;
export const MySkillMapDocument = gql`
    query MySkillMap {
  mySkillMap {
    trackCode
    trackTitle
    demandComputedAt
    nextCourses {
      courseId
      courseName
      courseUrl
      adds
      covered
      totalMissing
    }
    mine {
      level
      source
      isHidden
      grantedCourseName
      grantedLessonNumber
      skill {
        id
        name
        slug
        category
        description
        iconUrl
      }
      demand {
        liveVacancies
        band
      }
      providers {
        courseId
        courseName
        courseUrl
        level
        completed
      }
    }
    missing {
      upcoming {
        lessonNumber
        lessonsLeft
      }
      skill {
        id
        name
        slug
        category
        description
        iconUrl
      }
      demand {
        liveVacancies
        band
      }
      providers {
        courseId
        courseName
        courseUrl
        level
        completed
      }
    }
  }
}
    `;

/**
 * __useMySkillMapQuery__
 *
 * To run a query within a React component, call `useMySkillMapQuery` and pass it any options that fit your needs.
 * When your component renders, `useMySkillMapQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMySkillMapQuery({
 *   variables: {
 *   },
 * });
 */
export function useMySkillMapQuery(baseOptions?: Apollo.QueryHookOptions<MySkillMapQuery, MySkillMapQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MySkillMapQuery, MySkillMapQueryVariables>(MySkillMapDocument, options);
      }
export function useMySkillMapLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MySkillMapQuery, MySkillMapQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MySkillMapQuery, MySkillMapQueryVariables>(MySkillMapDocument, options);
        }
export type MySkillMapQueryHookResult = ReturnType<typeof useMySkillMapQuery>;
export type MySkillMapLazyQueryHookResult = ReturnType<typeof useMySkillMapLazyQuery>;
export type MySkillMapQueryResult = Apollo.QueryResult<MySkillMapQuery, MySkillMapQueryVariables>;
export const MyPromoCodesDocument = gql`
    query MyPromoCodes {
  myPromoCodes {
    id
    code
    status
    expiresAt
    campaignTitle
    campaignDescription
    discountKind
    discountValue
    currency
  }
}
    `;

/**
 * __useMyPromoCodesQuery__
 *
 * To run a query within a React component, call `useMyPromoCodesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyPromoCodesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyPromoCodesQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyPromoCodesQuery(baseOptions?: Apollo.QueryHookOptions<MyPromoCodesQuery, MyPromoCodesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyPromoCodesQuery, MyPromoCodesQueryVariables>(MyPromoCodesDocument, options);
      }
export function useMyPromoCodesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyPromoCodesQuery, MyPromoCodesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyPromoCodesQuery, MyPromoCodesQueryVariables>(MyPromoCodesDocument, options);
        }
export type MyPromoCodesQueryHookResult = ReturnType<typeof useMyPromoCodesQuery>;
export type MyPromoCodesLazyQueryHookResult = ReturnType<typeof useMyPromoCodesLazyQuery>;
export type MyPromoCodesQueryResult = Apollo.QueryResult<MyPromoCodesQuery, MyPromoCodesQueryVariables>;
export const MyShareOptionsDocument = gql`
    query MyShareOptions($language: String) {
  myShareOptions(language: $language) {
    channel
    text
    targetUrl
    shareUrl
    bonusAvailable
    bonusPoints
    bonusPromo
  }
}
    `;

/**
 * __useMyShareOptionsQuery__
 *
 * To run a query within a React component, call `useMyShareOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyShareOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyShareOptionsQuery({
 *   variables: {
 *      language: // value for 'language'
 *   },
 * });
 */
export function useMyShareOptionsQuery(baseOptions?: Apollo.QueryHookOptions<MyShareOptionsQuery, MyShareOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyShareOptionsQuery, MyShareOptionsQueryVariables>(MyShareOptionsDocument, options);
      }
export function useMyShareOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyShareOptionsQuery, MyShareOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyShareOptionsQuery, MyShareOptionsQueryVariables>(MyShareOptionsDocument, options);
        }
export type MyShareOptionsQueryHookResult = ReturnType<typeof useMyShareOptionsQuery>;
export type MyShareOptionsLazyQueryHookResult = ReturnType<typeof useMyShareOptionsLazyQuery>;
export type MyShareOptionsQueryResult = Apollo.QueryResult<MyShareOptionsQuery, MyShareOptionsQueryVariables>;
export const CareerProfessionsDocument = gql`
    query CareerProfessions {
  careerProfessions {
    code
    title
    summary
    about
    icon
    salaryFrom
    salaryTo
    salaryCurrency
    haveCount
    totalCount
    skillProgress {
      requiredCount
      meetsRequiredLevelCount
      needsImprovementCount
      missingCount
      verifiedMeetsRequiredLevelCount
    }
    topGaps {
      slug
      name
      status
      priority
      requiredLevel
      myLevel
    }
    liveVacancies
    isChosen
    hasRequirements
    stepsDone
    stepsTotal
    steps {
      title
      description
      satisfied
      current
      target
      progressKind
    }
    skills {
      id
      name
      slug
      category
      iconUrl
      have
      requirementStatus
      priority
      requiredLevel
      myLevel
    }
    courses {
      courseId
      courseName
      courseUrl
      completed
    }
  }
}
    `;

/**
 * __useCareerProfessionsQuery__
 *
 * To run a query within a React component, call `useCareerProfessionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCareerProfessionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCareerProfessionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCareerProfessionsQuery(baseOptions?: Apollo.QueryHookOptions<CareerProfessionsQuery, CareerProfessionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CareerProfessionsQuery, CareerProfessionsQueryVariables>(CareerProfessionsDocument, options);
      }
export function useCareerProfessionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CareerProfessionsQuery, CareerProfessionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CareerProfessionsQuery, CareerProfessionsQueryVariables>(CareerProfessionsDocument, options);
        }
export type CareerProfessionsQueryHookResult = ReturnType<typeof useCareerProfessionsQuery>;
export type CareerProfessionsLazyQueryHookResult = ReturnType<typeof useCareerProfessionsLazyQuery>;
export type CareerProfessionsQueryResult = Apollo.QueryResult<CareerProfessionsQuery, CareerProfessionsQueryVariables>;
export const CareerSkillDetailDocument = gql`
    query CareerSkillDetail($slug: String!) {
  careerSkillDetail(slug: $slug) {
    myLevel
    mySource
    mentionedInCv
    grantedCourseName
    grantedLessonNumber
    skill {
      id
      name
      slug
      category
      description
      iconUrl
      levelCriteria {
        level
        points
        example
      }
    }
    demand {
      liveVacancies
      band
    }
    providers {
      courseId
      courseName
      courseUrl
      level
      completed
    }
    professions {
      code
      title
      icon
      summary
      haveCount
      totalCount
      usageNote
      skillProgress {
        requiredCount
        meetsRequiredLevelCount
        needsImprovementCount
        missingCount
        verifiedMeetsRequiredLevelCount
      }
    }
  }
}
    `;

/**
 * __useCareerSkillDetailQuery__
 *
 * To run a query within a React component, call `useCareerSkillDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useCareerSkillDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCareerSkillDetailQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useCareerSkillDetailQuery(baseOptions: Apollo.QueryHookOptions<CareerSkillDetailQuery, CareerSkillDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CareerSkillDetailQuery, CareerSkillDetailQueryVariables>(CareerSkillDetailDocument, options);
      }
export function useCareerSkillDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CareerSkillDetailQuery, CareerSkillDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CareerSkillDetailQuery, CareerSkillDetailQueryVariables>(CareerSkillDetailDocument, options);
        }
export type CareerSkillDetailQueryHookResult = ReturnType<typeof useCareerSkillDetailQuery>;
export type CareerSkillDetailLazyQueryHookResult = ReturnType<typeof useCareerSkillDetailLazyQuery>;
export type CareerSkillDetailQueryResult = Apollo.QueryResult<CareerSkillDetailQuery, CareerSkillDetailQueryVariables>;
export const CareerProfessionCourseDocument = gql`
    query CareerProfessionCourse {
  careerProfessions {
    code
    nextCourse {
      courseId
      courseName
      courseUrl
      careerOutcome
      durationLabel
      access
      closesSkillNames
      criticalGaps
      importantGaps
      reasonCode
    }
  }
}
    `;

/**
 * __useCareerProfessionCourseQuery__
 *
 * To run a query within a React component, call `useCareerProfessionCourseQuery` and pass it any options that fit your needs.
 * When your component renders, `useCareerProfessionCourseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCareerProfessionCourseQuery({
 *   variables: {
 *   },
 * });
 */
export function useCareerProfessionCourseQuery(baseOptions?: Apollo.QueryHookOptions<CareerProfessionCourseQuery, CareerProfessionCourseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CareerProfessionCourseQuery, CareerProfessionCourseQueryVariables>(CareerProfessionCourseDocument, options);
      }
export function useCareerProfessionCourseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CareerProfessionCourseQuery, CareerProfessionCourseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CareerProfessionCourseQuery, CareerProfessionCourseQueryVariables>(CareerProfessionCourseDocument, options);
        }
export type CareerProfessionCourseQueryHookResult = ReturnType<typeof useCareerProfessionCourseQuery>;
export type CareerProfessionCourseLazyQueryHookResult = ReturnType<typeof useCareerProfessionCourseLazyQuery>;
export type CareerProfessionCourseQueryResult = Apollo.QueryResult<CareerProfessionCourseQuery, CareerProfessionCourseQueryVariables>;
export const CareerJourneyBoardDocument = gql`
    query CareerJourneyBoard {
  myCareerJourney {
    isMember
    isPreview
    memberStatus
    phase
    alignment {
      status
      goalTrackCode
      goalTitle
      profileHeadline
      profileDirection
      suggestedHeadline
    }
    sections {
      key
      state
      isCurrent
      route
      isBlocked
      blockReason
      metrics {
        key
        value
        target
        route
        isDone
        isBlocked
      }
    }
    hasGoal
    primaryAction {
      id
      kind
      stageKey
      route
      targetId
      reasonCode
      subjectTitle
      position
      positionTotal
      expectedOutcome
      estimatedMinutes
      dueDate
    }
    secondaryActions {
      id
      kind
      stageKey
      route
      targetId
      reasonCode
      subjectTitle
      position
      positionTotal
      expectedOutcome
      estimatedMinutes
      dueDate
    }
    goal {
      trackCode
      title
      icon
      isChosen
      targetSkillsMine
      targetSkillsTotal
      skillProgress {
        requiredCount
        meetsRequiredLevelCount
        needsImprovementCount
        missingCount
        verifiedMeetsRequiredLevelCount
      }
      salaryFrom
      salaryTo
      salaryCurrency
    }
    stages {
      key
      done
      total
      isDone
      isBlocked
      blockReason
      route
      targetId
    }
    nextAction {
      kind
      stageKey
      route
      targetId
    }
    locked {
      key
      reasonCode
    }
    cvChecklist {
      key
      isDone
    }
    applications {
      total
      active
      applied
      interview
      offer
      rejected
      hired
      nextFollowUp {
        id
        companyName
        position
        status
        nextActionAt
      }
      recent {
        id
        companyName
        position
        status
        appliedAt
        nextActionAt
      }
    }
  }
}
    `;

/**
 * __useCareerJourneyBoardQuery__
 *
 * To run a query within a React component, call `useCareerJourneyBoardQuery` and pass it any options that fit your needs.
 * When your component renders, `useCareerJourneyBoardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCareerJourneyBoardQuery({
 *   variables: {
 *   },
 * });
 */
export function useCareerJourneyBoardQuery(baseOptions?: Apollo.QueryHookOptions<CareerJourneyBoardQuery, CareerJourneyBoardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CareerJourneyBoardQuery, CareerJourneyBoardQueryVariables>(CareerJourneyBoardDocument, options);
      }
export function useCareerJourneyBoardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CareerJourneyBoardQuery, CareerJourneyBoardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CareerJourneyBoardQuery, CareerJourneyBoardQueryVariables>(CareerJourneyBoardDocument, options);
        }
export type CareerJourneyBoardQueryHookResult = ReturnType<typeof useCareerJourneyBoardQuery>;
export type CareerJourneyBoardLazyQueryHookResult = ReturnType<typeof useCareerJourneyBoardLazyQuery>;
export type CareerJourneyBoardQueryResult = Apollo.QueryResult<CareerJourneyBoardQuery, CareerJourneyBoardQueryVariables>;
export const CareerApplicationsListDocument = gql`
    query CareerApplicationsList($status: String, $limit: Int) {
  myCareerApplications(status: $status, limit: $limit) {
    id
    vacancyId
    companyName
    position
    applyUrl
    status
    appliedAt
    nextActionAt
    note
    source
    isPlacementConfirmed
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useCareerApplicationsListQuery__
 *
 * To run a query within a React component, call `useCareerApplicationsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useCareerApplicationsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCareerApplicationsListQuery({
 *   variables: {
 *      status: // value for 'status'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useCareerApplicationsListQuery(baseOptions?: Apollo.QueryHookOptions<CareerApplicationsListQuery, CareerApplicationsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CareerApplicationsListQuery, CareerApplicationsListQueryVariables>(CareerApplicationsListDocument, options);
      }
export function useCareerApplicationsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CareerApplicationsListQuery, CareerApplicationsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CareerApplicationsListQuery, CareerApplicationsListQueryVariables>(CareerApplicationsListDocument, options);
        }
export type CareerApplicationsListQueryHookResult = ReturnType<typeof useCareerApplicationsListQuery>;
export type CareerApplicationsListLazyQueryHookResult = ReturnType<typeof useCareerApplicationsListLazyQuery>;
export type CareerApplicationsListQueryResult = Apollo.QueryResult<CareerApplicationsListQuery, CareerApplicationsListQueryVariables>;
export const MyCareerProfileDocument = gql`
    query MyCareerProfile {
  myCareerProfile {
    ...CareerProfileFields
  }
}
    ${CareerProfileFieldsFragmentDoc}`;

/**
 * __useMyCareerProfileQuery__
 *
 * To run a query within a React component, call `useMyCareerProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyCareerProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyCareerProfileQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyCareerProfileQuery(baseOptions?: Apollo.QueryHookOptions<MyCareerProfileQuery, MyCareerProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyCareerProfileQuery, MyCareerProfileQueryVariables>(MyCareerProfileDocument, options);
      }
export function useMyCareerProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyCareerProfileQuery, MyCareerProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyCareerProfileQuery, MyCareerProfileQueryVariables>(MyCareerProfileDocument, options);
        }
export type MyCareerProfileQueryHookResult = ReturnType<typeof useMyCareerProfileQuery>;
export type MyCareerProfileLazyQueryHookResult = ReturnType<typeof useMyCareerProfileLazyQuery>;
export type MyCareerProfileQueryResult = Apollo.QueryResult<MyCareerProfileQuery, MyCareerProfileQueryVariables>;
export const CareerSkillsSearchDocument = gql`
    query CareerSkillsSearch($search: String, $category: String) {
  careerSkills(search: $search, category: $category) {
    id
    name
    slug
    iconUrl
    category
  }
}
    `;

/**
 * __useCareerSkillsSearchQuery__
 *
 * To run a query within a React component, call `useCareerSkillsSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useCareerSkillsSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCareerSkillsSearchQuery({
 *   variables: {
 *      search: // value for 'search'
 *      category: // value for 'category'
 *   },
 * });
 */
export function useCareerSkillsSearchQuery(baseOptions?: Apollo.QueryHookOptions<CareerSkillsSearchQuery, CareerSkillsSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CareerSkillsSearchQuery, CareerSkillsSearchQueryVariables>(CareerSkillsSearchDocument, options);
      }
export function useCareerSkillsSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CareerSkillsSearchQuery, CareerSkillsSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CareerSkillsSearchQuery, CareerSkillsSearchQueryVariables>(CareerSkillsSearchDocument, options);
        }
export type CareerSkillsSearchQueryHookResult = ReturnType<typeof useCareerSkillsSearchQuery>;
export type CareerSkillsSearchLazyQueryHookResult = ReturnType<typeof useCareerSkillsSearchLazyQuery>;
export type CareerSkillsSearchQueryResult = Apollo.QueryResult<CareerSkillsSearchQuery, CareerSkillsSearchQueryVariables>;
export const CareerSkillGraphBoardDocument = gql`
    query CareerSkillGraphBoard($trackCode: String) {
  myCareerSkillGraph(trackCode: $trackCode) {
    trackCode
    trackTitle
    trackIcon
    trackIsDefault
    isChosenGoal
    isFallback
    fallbackReason
    computedAt
    skillProgress {
      requiredCount
      meetsRequiredLevelCount
      needsImprovementCount
      missingCount
      verifiedMeetsRequiredLevelCount
    }
    clusters {
      code
      title
      description
      icon
      order
    }
    nodes {
      id
      slug
      name
      description
      iconUrl
      skill {
        category
      }
      clusterCode
      requiredLevel
      priority
      status
      requirementStatus
      myLevel
      source
      demand {
        liveVacancies
        rank
        band
        computedAt
      }
      upcoming {
        lessonNumber
        lessonsLeft
      }
      providers {
        courseId
        courseName
        courseUrl
        level
        completed
      }
    }
    edges {
      from
      to
      kind
    }
    recommendedCourses {
      courseId
      courseName
      courseUrl
      closesNodes
      criticalGaps
      importantGaps
      careerOutcome
      durationLabel
      status
      access
      closesSkillNames
      reasonCode
    }
  }
}
    `;

/**
 * __useCareerSkillGraphBoardQuery__
 *
 * To run a query within a React component, call `useCareerSkillGraphBoardQuery` and pass it any options that fit your needs.
 * When your component renders, `useCareerSkillGraphBoardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCareerSkillGraphBoardQuery({
 *   variables: {
 *      trackCode: // value for 'trackCode'
 *   },
 * });
 */
export function useCareerSkillGraphBoardQuery(baseOptions?: Apollo.QueryHookOptions<CareerSkillGraphBoardQuery, CareerSkillGraphBoardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CareerSkillGraphBoardQuery, CareerSkillGraphBoardQueryVariables>(CareerSkillGraphBoardDocument, options);
      }
export function useCareerSkillGraphBoardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CareerSkillGraphBoardQuery, CareerSkillGraphBoardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CareerSkillGraphBoardQuery, CareerSkillGraphBoardQueryVariables>(CareerSkillGraphBoardDocument, options);
        }
export type CareerSkillGraphBoardQueryHookResult = ReturnType<typeof useCareerSkillGraphBoardQuery>;
export type CareerSkillGraphBoardLazyQueryHookResult = ReturnType<typeof useCareerSkillGraphBoardLazyQuery>;
export type CareerSkillGraphBoardQueryResult = Apollo.QueryResult<CareerSkillGraphBoardQuery, CareerSkillGraphBoardQueryVariables>;
export const AllCoursesDocument = gql`
    query AllCourses($active: Boolean, $finished: Boolean, $first: Int, $after: String, $last: Int, $search: String, $courseId: ID, $groupIds: [ID], $lessonDate: Date) {
  allGroupsForLms(
    active: $active
    finished: $finished
    first: $first
    after: $after
    last: $last
    search: $search
    courseId: $courseId
    groupIds: $groupIds
    lessonDate: $lessonDate
  ) {
    totalCount
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      cursor
      node {
        ... on GroupType {
          id
          course {
            id
            courseIcon
            educationForm
            name
          }
          passedLessonsCount
          lessonsCount
          studentsCount
          name
          statusFinished
          datetimeNextLesson
        }
        ... on StudentGroupType {
          id
          course {
            id
            courseIcon
            educationForm
            name
          }
          passedLessonsCount
          lessonsCount
          studentsCount
          name
          statusFinished
          datetimeNextLesson
        }
        ... on MethodistGroupType {
          id
          course {
            id
            courseIcon
            educationForm
            name
          }
          passedLessonsCount
          lessonsCount
          studentsCount
          name
          statusFinished
          datetimeNextLesson
        }
      }
    }
  }
}
    `;

/**
 * __useAllCoursesQuery__
 *
 * To run a query within a React component, call `useAllCoursesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllCoursesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllCoursesQuery({
 *   variables: {
 *      active: // value for 'active'
 *      finished: // value for 'finished'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      last: // value for 'last'
 *      search: // value for 'search'
 *      courseId: // value for 'courseId'
 *      groupIds: // value for 'groupIds'
 *      lessonDate: // value for 'lessonDate'
 *   },
 * });
 */
export function useAllCoursesQuery(baseOptions?: Apollo.QueryHookOptions<AllCoursesQuery, AllCoursesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllCoursesQuery, AllCoursesQueryVariables>(AllCoursesDocument, options);
      }
export function useAllCoursesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllCoursesQuery, AllCoursesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllCoursesQuery, AllCoursesQueryVariables>(AllCoursesDocument, options);
        }
export type AllCoursesQueryHookResult = ReturnType<typeof useAllCoursesQuery>;
export type AllCoursesLazyQueryHookResult = ReturnType<typeof useAllCoursesLazyQuery>;
export type AllCoursesQueryResult = Apollo.QueryResult<AllCoursesQuery, AllCoursesQueryVariables>;
export const MethodistGroupOptionsDocument = gql`
    query MethodistGroupOptions {
  allGroupsForLms(first: 500) {
    edges {
      node {
        ... on MethodistGroupType {
          id
          name
          course {
            id
            name
          }
        }
      }
    }
  }
}
    `;

/**
 * __useMethodistGroupOptionsQuery__
 *
 * To run a query within a React component, call `useMethodistGroupOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMethodistGroupOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMethodistGroupOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMethodistGroupOptionsQuery(baseOptions?: Apollo.QueryHookOptions<MethodistGroupOptionsQuery, MethodistGroupOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MethodistGroupOptionsQuery, MethodistGroupOptionsQueryVariables>(MethodistGroupOptionsDocument, options);
      }
export function useMethodistGroupOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MethodistGroupOptionsQuery, MethodistGroupOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MethodistGroupOptionsQuery, MethodistGroupOptionsQueryVariables>(MethodistGroupOptionsDocument, options);
        }
export type MethodistGroupOptionsQueryHookResult = ReturnType<typeof useMethodistGroupOptionsQuery>;
export type MethodistGroupOptionsLazyQueryHookResult = ReturnType<typeof useMethodistGroupOptionsLazyQuery>;
export type MethodistGroupOptionsQueryResult = Apollo.QueryResult<MethodistGroupOptionsQuery, MethodistGroupOptionsQueryVariables>;
export const GroupForLmsDocument = gql`
    query groupForLms($groupId: ID) {
  groupForLms(groupId: $groupId) {
    ... on GroupType {
      id
      course {
        id
        courseIcon
        name
      }
      statusFinished
      isFree
      lessons {
        id
        name
        date
        index
        needToFinish
      }
      passedLessonsCount
      lessonsCount
      studentsCount
      name
    }
    ... on StudentGroupType {
      id
      course {
        id
        courseIcon
        name
      }
      statusFinished
      isFree
      lessons {
        id
        name
        date
        index
      }
      skillPlan {
        lessonNumber
        lessonId
        isOver
        skills {
          id
          name
          slug
          category
          iconUrl
          description
          unlockLevel
          courseLevel
          demandVacancies
          demandBand
        }
      }
      passedLessonsCount
      lessonsCount
      studentsCount
      name
    }
    ... on MethodistGroupType {
      id
      course {
        id
        courseIcon
        name
      }
      statusFinished
      isFree
      lessons {
        id
        name
        date
        index
      }
      passedLessonsCount
      lessonsCount
      studentsCount
      name
    }
  }
}
    `;

/**
 * __useGroupForLmsQuery__
 *
 * To run a query within a React component, call `useGroupForLmsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupForLmsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupForLmsQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useGroupForLmsQuery(baseOptions?: Apollo.QueryHookOptions<GroupForLmsQuery, GroupForLmsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GroupForLmsQuery, GroupForLmsQueryVariables>(GroupForLmsDocument, options);
      }
export function useGroupForLmsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GroupForLmsQuery, GroupForLmsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GroupForLmsQuery, GroupForLmsQueryVariables>(GroupForLmsDocument, options);
        }
export type GroupForLmsQueryHookResult = ReturnType<typeof useGroupForLmsQuery>;
export type GroupForLmsLazyQueryHookResult = ReturnType<typeof useGroupForLmsLazyQuery>;
export type GroupForLmsQueryResult = Apollo.QueryResult<GroupForLmsQuery, GroupForLmsQueryVariables>;
export const StudentDiplomasDocument = gql`
    query StudentDiplomas {
  myDiplomas {
    id
    language
    groupName
    courseName
    originalName
    sizeBytes
    issuedAt
  }
}
    `;

/**
 * __useStudentDiplomasQuery__
 *
 * To run a query within a React component, call `useStudentDiplomasQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentDiplomasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentDiplomasQuery({
 *   variables: {
 *   },
 * });
 */
export function useStudentDiplomasQuery(baseOptions?: Apollo.QueryHookOptions<StudentDiplomasQuery, StudentDiplomasQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StudentDiplomasQuery, StudentDiplomasQueryVariables>(StudentDiplomasDocument, options);
      }
export function useStudentDiplomasLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StudentDiplomasQuery, StudentDiplomasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StudentDiplomasQuery, StudentDiplomasQueryVariables>(StudentDiplomasDocument, options);
        }
export type StudentDiplomasQueryHookResult = ReturnType<typeof useStudentDiplomasQuery>;
export type StudentDiplomasLazyQueryHookResult = ReturnType<typeof useStudentDiplomasLazyQuery>;
export type StudentDiplomasQueryResult = Apollo.QueryResult<StudentDiplomasQuery, StudentDiplomasQueryVariables>;
export const StudentDiplomaDownloadUrlDocument = gql`
    query StudentDiplomaDownloadUrl($diplomaId: ID!) {
  myDiplomaDownloadUrl(diplomaId: $diplomaId) {
    url
    expiresAt
  }
}
    `;

/**
 * __useStudentDiplomaDownloadUrlQuery__
 *
 * To run a query within a React component, call `useStudentDiplomaDownloadUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentDiplomaDownloadUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentDiplomaDownloadUrlQuery({
 *   variables: {
 *      diplomaId: // value for 'diplomaId'
 *   },
 * });
 */
export function useStudentDiplomaDownloadUrlQuery(baseOptions: Apollo.QueryHookOptions<StudentDiplomaDownloadUrlQuery, StudentDiplomaDownloadUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StudentDiplomaDownloadUrlQuery, StudentDiplomaDownloadUrlQueryVariables>(StudentDiplomaDownloadUrlDocument, options);
      }
export function useStudentDiplomaDownloadUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StudentDiplomaDownloadUrlQuery, StudentDiplomaDownloadUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StudentDiplomaDownloadUrlQuery, StudentDiplomaDownloadUrlQueryVariables>(StudentDiplomaDownloadUrlDocument, options);
        }
export type StudentDiplomaDownloadUrlQueryHookResult = ReturnType<typeof useStudentDiplomaDownloadUrlQuery>;
export type StudentDiplomaDownloadUrlLazyQueryHookResult = ReturnType<typeof useStudentDiplomaDownloadUrlLazyQuery>;
export type StudentDiplomaDownloadUrlQueryResult = Apollo.QueryResult<StudentDiplomaDownloadUrlQuery, StudentDiplomaDownloadUrlQueryVariables>;
export const MyLessonHomeworkDocument = gql`
    query MyLessonHomework($lessonId: ID!) {
  lessonTextbookFiles(lessonId: $lessonId) {
    id
    title
    fileName
    isPdf
  }
  myLessonHomework(lessonId: $lessonId) {
    id
    lessonId
    hasTeacherAssignment
    title
    text
    textbookRef
    dueDate
    canSubmit
    mySubmission {
      id
      githubUrl
      fileName
      status
      attempt
      submittedAt
      hwMark
      teacherComment
    }
  }
}
    `;

/**
 * __useMyLessonHomeworkQuery__
 *
 * To run a query within a React component, call `useMyLessonHomeworkQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyLessonHomeworkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyLessonHomeworkQuery({
 *   variables: {
 *      lessonId: // value for 'lessonId'
 *   },
 * });
 */
export function useMyLessonHomeworkQuery(baseOptions: Apollo.QueryHookOptions<MyLessonHomeworkQuery, MyLessonHomeworkQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyLessonHomeworkQuery, MyLessonHomeworkQueryVariables>(MyLessonHomeworkDocument, options);
      }
export function useMyLessonHomeworkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyLessonHomeworkQuery, MyLessonHomeworkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyLessonHomeworkQuery, MyLessonHomeworkQueryVariables>(MyLessonHomeworkDocument, options);
        }
export type MyLessonHomeworkQueryHookResult = ReturnType<typeof useMyLessonHomeworkQuery>;
export type MyLessonHomeworkLazyQueryHookResult = ReturnType<typeof useMyLessonHomeworkLazyQuery>;
export type MyLessonHomeworkQueryResult = Apollo.QueryResult<MyLessonHomeworkQuery, MyLessonHomeworkQueryVariables>;
export const LmsLessonHomeworkDocument = gql`
    query LmsLessonHomework($lessonId: ID!) {
  lessonTextbookFiles(lessonId: $lessonId) {
    id
    title
    fileName
    isPdf
  }
  lessonHomework(lessonId: $lessonId) {
    id
    lessonId
    title
    text
    textbookRef
    dueDate
    updatedAt
  }
}
    `;

/**
 * __useLmsLessonHomeworkQuery__
 *
 * To run a query within a React component, call `useLmsLessonHomeworkQuery` and pass it any options that fit your needs.
 * When your component renders, `useLmsLessonHomeworkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLmsLessonHomeworkQuery({
 *   variables: {
 *      lessonId: // value for 'lessonId'
 *   },
 * });
 */
export function useLmsLessonHomeworkQuery(baseOptions: Apollo.QueryHookOptions<LmsLessonHomeworkQuery, LmsLessonHomeworkQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LmsLessonHomeworkQuery, LmsLessonHomeworkQueryVariables>(LmsLessonHomeworkDocument, options);
      }
export function useLmsLessonHomeworkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LmsLessonHomeworkQuery, LmsLessonHomeworkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LmsLessonHomeworkQuery, LmsLessonHomeworkQueryVariables>(LmsLessonHomeworkDocument, options);
        }
export type LmsLessonHomeworkQueryHookResult = ReturnType<typeof useLmsLessonHomeworkQuery>;
export type LmsLessonHomeworkLazyQueryHookResult = ReturnType<typeof useLmsLessonHomeworkLazyQuery>;
export type LmsLessonHomeworkQueryResult = Apollo.QueryResult<LmsLessonHomeworkQuery, LmsLessonHomeworkQueryVariables>;
export const LmsHomeworkRosterDocument = gql`
    query LmsHomeworkRoster($lessonId: ID!) {
  homeworkAiEnabled
  homeworkRoster(lessonId: $lessonId) {
    studentId
    studentName
    hwMark
    submission {
      id
      githubUrl
      fileName
      fileSizeBytes
      status
      attempt
      submittedAt
      teacherComment
      gradedAt
      gradedByName
      aiReview {
        status
        aiScore
        aiSummary
        aiJustification
        suspiciousContent
        suspicionNotes
        errorMessage
        analyzedAt
        truncatedBasis
        filesUsedCount
        assignmentSource
      }
    }
  }
}
    `;

/**
 * __useLmsHomeworkRosterQuery__
 *
 * To run a query within a React component, call `useLmsHomeworkRosterQuery` and pass it any options that fit your needs.
 * When your component renders, `useLmsHomeworkRosterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLmsHomeworkRosterQuery({
 *   variables: {
 *      lessonId: // value for 'lessonId'
 *   },
 * });
 */
export function useLmsHomeworkRosterQuery(baseOptions: Apollo.QueryHookOptions<LmsHomeworkRosterQuery, LmsHomeworkRosterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LmsHomeworkRosterQuery, LmsHomeworkRosterQueryVariables>(LmsHomeworkRosterDocument, options);
      }
export function useLmsHomeworkRosterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LmsHomeworkRosterQuery, LmsHomeworkRosterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LmsHomeworkRosterQuery, LmsHomeworkRosterQueryVariables>(LmsHomeworkRosterDocument, options);
        }
export type LmsHomeworkRosterQueryHookResult = ReturnType<typeof useLmsHomeworkRosterQuery>;
export type LmsHomeworkRosterLazyQueryHookResult = ReturnType<typeof useLmsHomeworkRosterLazyQuery>;
export type LmsHomeworkRosterQueryResult = Apollo.QueryResult<LmsHomeworkRosterQuery, LmsHomeworkRosterQueryVariables>;
export const LmsHomeworkSubmissionDownloadUrlDocument = gql`
    query LmsHomeworkSubmissionDownloadUrl($submissionId: ID!) {
  homeworkSubmissionDownloadUrl(submissionId: $submissionId)
}
    `;

/**
 * __useLmsHomeworkSubmissionDownloadUrlQuery__
 *
 * To run a query within a React component, call `useLmsHomeworkSubmissionDownloadUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useLmsHomeworkSubmissionDownloadUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLmsHomeworkSubmissionDownloadUrlQuery({
 *   variables: {
 *      submissionId: // value for 'submissionId'
 *   },
 * });
 */
export function useLmsHomeworkSubmissionDownloadUrlQuery(baseOptions: Apollo.QueryHookOptions<LmsHomeworkSubmissionDownloadUrlQuery, LmsHomeworkSubmissionDownloadUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LmsHomeworkSubmissionDownloadUrlQuery, LmsHomeworkSubmissionDownloadUrlQueryVariables>(LmsHomeworkSubmissionDownloadUrlDocument, options);
      }
export function useLmsHomeworkSubmissionDownloadUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LmsHomeworkSubmissionDownloadUrlQuery, LmsHomeworkSubmissionDownloadUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LmsHomeworkSubmissionDownloadUrlQuery, LmsHomeworkSubmissionDownloadUrlQueryVariables>(LmsHomeworkSubmissionDownloadUrlDocument, options);
        }
export type LmsHomeworkSubmissionDownloadUrlQueryHookResult = ReturnType<typeof useLmsHomeworkSubmissionDownloadUrlQuery>;
export type LmsHomeworkSubmissionDownloadUrlLazyQueryHookResult = ReturnType<typeof useLmsHomeworkSubmissionDownloadUrlLazyQuery>;
export type LmsHomeworkSubmissionDownloadUrlQueryResult = Apollo.QueryResult<LmsHomeworkSubmissionDownloadUrlQuery, LmsHomeworkSubmissionDownloadUrlQueryVariables>;
export const StudentInvoicesDocument = gql`
    query StudentInvoices {
  myInvoices {
    fakturowniaId
    number
    status
    issueDate
    paymentTo
    currency
    priceGross
    paid
    outstanding
    isOverdue
    daysOverdue
    viewUrl
    paymentUrl
    isCorrected
    correctionReason
    isBlocking
  }
}
    `;

/**
 * __useStudentInvoicesQuery__
 *
 * To run a query within a React component, call `useStudentInvoicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentInvoicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentInvoicesQuery({
 *   variables: {
 *   },
 * });
 */
export function useStudentInvoicesQuery(baseOptions?: Apollo.QueryHookOptions<StudentInvoicesQuery, StudentInvoicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StudentInvoicesQuery, StudentInvoicesQueryVariables>(StudentInvoicesDocument, options);
      }
export function useStudentInvoicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StudentInvoicesQuery, StudentInvoicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StudentInvoicesQuery, StudentInvoicesQueryVariables>(StudentInvoicesDocument, options);
        }
export type StudentInvoicesQueryHookResult = ReturnType<typeof useStudentInvoicesQuery>;
export type StudentInvoicesLazyQueryHookResult = ReturnType<typeof useStudentInvoicesLazyQuery>;
export type StudentInvoicesQueryResult = Apollo.QueryResult<StudentInvoicesQuery, StudentInvoicesQueryVariables>;
export const LessonForLmsDocument = gql`
    query lessonForLms($groupLessonId: ID) {
  lessonForLms(groupLessonId: $groupLessonId) {
    ... on GroupLessonForLMSType {
      id
      name
      date
      index
      lmsDescription
      startTime
      endTime
      finished
      needToFinish
      comment
      video
      taskTypes
      hasTeacherAttachment
      whiteboardId
      homeworkAssignmentId
      homeworkAvailable
      hasJoinLink
      linkOverrideActive
    }
    ... on StudentLessonType {
      id
      name
      date
      index
      lmsDescription
      startTime
      endTime
      finished
      comment
      video
      hasStudentMarks
      hasStudentAttachment
      whiteboardId
      homeworkAssignmentId
      homeworkAvailable
      hasJoinLink
      linkOverrideActive
    }
    ... on MethodistLessonType {
      id
      name
      date
      index
      lmsDescription
      startTime
      endTime
      finished
      comment
      video
      hasTeacherAttachment
      hasStudentAttachment
      whiteboardId
      homeworkAssignmentId
      homeworkAvailable
      hasJoinLink
      linkOverrideActive
    }
  }
}
    `;

/**
 * __useLessonForLmsQuery__
 *
 * To run a query within a React component, call `useLessonForLmsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLessonForLmsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLessonForLmsQuery({
 *   variables: {
 *      groupLessonId: // value for 'groupLessonId'
 *   },
 * });
 */
export function useLessonForLmsQuery(baseOptions?: Apollo.QueryHookOptions<LessonForLmsQuery, LessonForLmsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LessonForLmsQuery, LessonForLmsQueryVariables>(LessonForLmsDocument, options);
      }
export function useLessonForLmsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LessonForLmsQuery, LessonForLmsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LessonForLmsQuery, LessonForLmsQueryVariables>(LessonForLmsDocument, options);
        }
export type LessonForLmsQueryHookResult = ReturnType<typeof useLessonForLmsQuery>;
export type LessonForLmsLazyQueryHookResult = ReturnType<typeof useLessonForLmsLazyQuery>;
export type LessonForLmsQueryResult = Apollo.QueryResult<LessonForLmsQuery, LessonForLmsQueryVariables>;
export const GroupLessonAttendanceForLmsDocument = gql`
    query groupLessonAttendanceForLms($groupLessonId: ID) {
  groupLessonAttendanceForLms(groupLessonId: $groupLessonId) {
    id
    attendance
    source
    markedAt
    markedByName
    student {
      id
      user {
        id
        firstName
        lastName
      }
    }
  }
}
    `;

/**
 * __useGroupLessonAttendanceForLmsQuery__
 *
 * To run a query within a React component, call `useGroupLessonAttendanceForLmsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupLessonAttendanceForLmsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupLessonAttendanceForLmsQuery({
 *   variables: {
 *      groupLessonId: // value for 'groupLessonId'
 *   },
 * });
 */
export function useGroupLessonAttendanceForLmsQuery(baseOptions?: Apollo.QueryHookOptions<GroupLessonAttendanceForLmsQuery, GroupLessonAttendanceForLmsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GroupLessonAttendanceForLmsQuery, GroupLessonAttendanceForLmsQueryVariables>(GroupLessonAttendanceForLmsDocument, options);
      }
export function useGroupLessonAttendanceForLmsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GroupLessonAttendanceForLmsQuery, GroupLessonAttendanceForLmsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GroupLessonAttendanceForLmsQuery, GroupLessonAttendanceForLmsQueryVariables>(GroupLessonAttendanceForLmsDocument, options);
        }
export type GroupLessonAttendanceForLmsQueryHookResult = ReturnType<typeof useGroupLessonAttendanceForLmsQuery>;
export type GroupLessonAttendanceForLmsLazyQueryHookResult = ReturnType<typeof useGroupLessonAttendanceForLmsLazyQuery>;
export type GroupLessonAttendanceForLmsQueryResult = Apollo.QueryResult<GroupLessonAttendanceForLmsQuery, GroupLessonAttendanceForLmsQueryVariables>;
export const GroupLessonAttachmentForLmsDocument = gql`
    query groupLessonAttachmentForLms($groupLessonId: ID, $attachmentRole: String) {
  groupLessonAttachmentForLms(
    groupLessonId: $groupLessonId
    attachmentRole: $attachmentRole
  ) {
    id
    title
    file
  }
}
    `;

/**
 * __useGroupLessonAttachmentForLmsQuery__
 *
 * To run a query within a React component, call `useGroupLessonAttachmentForLmsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupLessonAttachmentForLmsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupLessonAttachmentForLmsQuery({
 *   variables: {
 *      groupLessonId: // value for 'groupLessonId'
 *      attachmentRole: // value for 'attachmentRole'
 *   },
 * });
 */
export function useGroupLessonAttachmentForLmsQuery(baseOptions?: Apollo.QueryHookOptions<GroupLessonAttachmentForLmsQuery, GroupLessonAttachmentForLmsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GroupLessonAttachmentForLmsQuery, GroupLessonAttachmentForLmsQueryVariables>(GroupLessonAttachmentForLmsDocument, options);
      }
export function useGroupLessonAttachmentForLmsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GroupLessonAttachmentForLmsQuery, GroupLessonAttachmentForLmsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GroupLessonAttachmentForLmsQuery, GroupLessonAttachmentForLmsQueryVariables>(GroupLessonAttachmentForLmsDocument, options);
        }
export type GroupLessonAttachmentForLmsQueryHookResult = ReturnType<typeof useGroupLessonAttachmentForLmsQuery>;
export type GroupLessonAttachmentForLmsLazyQueryHookResult = ReturnType<typeof useGroupLessonAttachmentForLmsLazyQuery>;
export type GroupLessonAttachmentForLmsQueryResult = Apollo.QueryResult<GroupLessonAttachmentForLmsQuery, GroupLessonAttachmentForLmsQueryVariables>;
export const GroupLessonAttachmentDocument = gql`
    query groupLessonAttachment($attachmentId: ID, $attachmentRole: String) {
  groupLessonAttachment(
    attachmentId: $attachmentId
    attachmentRole: $attachmentRole
  ) {
    id
    title
    file
  }
}
    `;

/**
 * __useGroupLessonAttachmentQuery__
 *
 * To run a query within a React component, call `useGroupLessonAttachmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupLessonAttachmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupLessonAttachmentQuery({
 *   variables: {
 *      attachmentId: // value for 'attachmentId'
 *      attachmentRole: // value for 'attachmentRole'
 *   },
 * });
 */
export function useGroupLessonAttachmentQuery(baseOptions?: Apollo.QueryHookOptions<GroupLessonAttachmentQuery, GroupLessonAttachmentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GroupLessonAttachmentQuery, GroupLessonAttachmentQueryVariables>(GroupLessonAttachmentDocument, options);
      }
export function useGroupLessonAttachmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GroupLessonAttachmentQuery, GroupLessonAttachmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GroupLessonAttachmentQuery, GroupLessonAttachmentQueryVariables>(GroupLessonAttachmentDocument, options);
        }
export type GroupLessonAttachmentQueryHookResult = ReturnType<typeof useGroupLessonAttachmentQuery>;
export type GroupLessonAttachmentLazyQueryHookResult = ReturnType<typeof useGroupLessonAttachmentLazyQuery>;
export type GroupLessonAttachmentQueryResult = Apollo.QueryResult<GroupLessonAttachmentQuery, GroupLessonAttachmentQueryVariables>;
export const StudentsMarksDocument = gql`
    query studentsMarks($lessonsId: ID!, $lessonIdForMarks: String!, $taskType: String!) {
  studentsMarks(lessonsId: $lessonsId) {
    edges {
      node {
        id
        user {
          id
          firstName
          lastName
          student {
            id
          }
        }
        marks(taskType: $taskType, lessonId: $lessonIdForMarks) {
          edges {
            node {
              id
              date
              mark
              hwMark
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useStudentsMarksQuery__
 *
 * To run a query within a React component, call `useStudentsMarksQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentsMarksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentsMarksQuery({
 *   variables: {
 *      lessonsId: // value for 'lessonsId'
 *      lessonIdForMarks: // value for 'lessonIdForMarks'
 *      taskType: // value for 'taskType'
 *   },
 * });
 */
export function useStudentsMarksQuery(baseOptions: Apollo.QueryHookOptions<StudentsMarksQuery, StudentsMarksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StudentsMarksQuery, StudentsMarksQueryVariables>(StudentsMarksDocument, options);
      }
export function useStudentsMarksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StudentsMarksQuery, StudentsMarksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StudentsMarksQuery, StudentsMarksQueryVariables>(StudentsMarksDocument, options);
        }
export type StudentsMarksQueryHookResult = ReturnType<typeof useStudentsMarksQuery>;
export type StudentsMarksLazyQueryHookResult = ReturnType<typeof useStudentsMarksLazyQuery>;
export type StudentsMarksQueryResult = Apollo.QueryResult<StudentsMarksQuery, StudentsMarksQueryVariables>;
export const StudentMarksDocument = gql`
    query studentMarks($lessonsId: ID!) {
  studentMarks(lessonsId: $lessonsId) {
    edges {
      node {
        mark
        hwMark
        date
        taskType
      }
    }
  }
}
    `;

/**
 * __useStudentMarksQuery__
 *
 * To run a query within a React component, call `useStudentMarksQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentMarksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentMarksQuery({
 *   variables: {
 *      lessonsId: // value for 'lessonsId'
 *   },
 * });
 */
export function useStudentMarksQuery(baseOptions: Apollo.QueryHookOptions<StudentMarksQuery, StudentMarksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StudentMarksQuery, StudentMarksQueryVariables>(StudentMarksDocument, options);
      }
export function useStudentMarksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StudentMarksQuery, StudentMarksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StudentMarksQuery, StudentMarksQueryVariables>(StudentMarksDocument, options);
        }
export type StudentMarksQueryHookResult = ReturnType<typeof useStudentMarksQuery>;
export type StudentMarksLazyQueryHookResult = ReturnType<typeof useStudentMarksLazyQuery>;
export type StudentMarksQueryResult = Apollo.QueryResult<StudentMarksQuery, StudentMarksQueryVariables>;
export const StudentPendingSurveysDocument = gql`
    query StudentPendingSurveys {
  mySurveys {
    assignmentId
    title
    description
    groupName
    lessonName
    lessonNumber
    teacherName
    questions {
      id
      number
      text
      questionType
      required
      options
    }
  }
}
    `;

/**
 * __useStudentPendingSurveysQuery__
 *
 * To run a query within a React component, call `useStudentPendingSurveysQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentPendingSurveysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentPendingSurveysQuery({
 *   variables: {
 *   },
 * });
 */
export function useStudentPendingSurveysQuery(baseOptions?: Apollo.QueryHookOptions<StudentPendingSurveysQuery, StudentPendingSurveysQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StudentPendingSurveysQuery, StudentPendingSurveysQueryVariables>(StudentPendingSurveysDocument, options);
      }
export function useStudentPendingSurveysLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StudentPendingSurveysQuery, StudentPendingSurveysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StudentPendingSurveysQuery, StudentPendingSurveysQueryVariables>(StudentPendingSurveysDocument, options);
        }
export type StudentPendingSurveysQueryHookResult = ReturnType<typeof useStudentPendingSurveysQuery>;
export type StudentPendingSurveysLazyQueryHookResult = ReturnType<typeof useStudentPendingSurveysLazyQuery>;
export type StudentPendingSurveysQueryResult = Apollo.QueryResult<StudentPendingSurveysQuery, StudentPendingSurveysQueryVariables>;
export const StudentSubmittedSurveysDocument = gql`
    query StudentSubmittedSurveys {
  mySubmittedSurveys {
    responseId
    surveyTitle
    groupName
    lessonName
    lessonNumber
    submittedAt
    questions {
      id
      number
      text
      questionType
      required
      options
    }
    answers {
      questionId
      value
    }
  }
}
    `;

/**
 * __useStudentSubmittedSurveysQuery__
 *
 * To run a query within a React component, call `useStudentSubmittedSurveysQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentSubmittedSurveysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentSubmittedSurveysQuery({
 *   variables: {
 *   },
 * });
 */
export function useStudentSubmittedSurveysQuery(baseOptions?: Apollo.QueryHookOptions<StudentSubmittedSurveysQuery, StudentSubmittedSurveysQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StudentSubmittedSurveysQuery, StudentSubmittedSurveysQueryVariables>(StudentSubmittedSurveysDocument, options);
      }
export function useStudentSubmittedSurveysLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StudentSubmittedSurveysQuery, StudentSubmittedSurveysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StudentSubmittedSurveysQuery, StudentSubmittedSurveysQueryVariables>(StudentSubmittedSurveysDocument, options);
        }
export type StudentSubmittedSurveysQueryHookResult = ReturnType<typeof useStudentSubmittedSurveysQuery>;
export type StudentSubmittedSurveysLazyQueryHookResult = ReturnType<typeof useStudentSubmittedSurveysLazyQuery>;
export type StudentSubmittedSurveysQueryResult = Apollo.QueryResult<StudentSubmittedSurveysQuery, StudentSubmittedSurveysQueryVariables>;
export const GetLessonWhiteboardDocument = gql`
    query GetLessonWhiteboard($lessonId: ID!) {
  lessonWhiteboard(lessonId: $lessonId) {
    id
    name
    sceneJson
    sceneVersion
    createdAt
    updatedAt
    lessons {
      lessonId
      lessonName
      lessonNumber
      lessonDate
    }
    files {
      fileId
      mimeType
      url
    }
  }
}
    `;

/**
 * __useGetLessonWhiteboardQuery__
 *
 * To run a query within a React component, call `useGetLessonWhiteboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLessonWhiteboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLessonWhiteboardQuery({
 *   variables: {
 *      lessonId: // value for 'lessonId'
 *   },
 * });
 */
export function useGetLessonWhiteboardQuery(baseOptions: Apollo.QueryHookOptions<GetLessonWhiteboardQuery, GetLessonWhiteboardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLessonWhiteboardQuery, GetLessonWhiteboardQueryVariables>(GetLessonWhiteboardDocument, options);
      }
export function useGetLessonWhiteboardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLessonWhiteboardQuery, GetLessonWhiteboardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLessonWhiteboardQuery, GetLessonWhiteboardQueryVariables>(GetLessonWhiteboardDocument, options);
        }
export type GetLessonWhiteboardQueryHookResult = ReturnType<typeof useGetLessonWhiteboardQuery>;
export type GetLessonWhiteboardLazyQueryHookResult = ReturnType<typeof useGetLessonWhiteboardLazyQuery>;
export type GetLessonWhiteboardQueryResult = Apollo.QueryResult<GetLessonWhiteboardQuery, GetLessonWhiteboardQueryVariables>;
export const GetWhiteboardLibraryDocument = gql`
    query GetWhiteboardLibrary {
  whiteboardLibrary {
    itemsJson
    version
  }
}
    `;

/**
 * __useGetWhiteboardLibraryQuery__
 *
 * To run a query within a React component, call `useGetWhiteboardLibraryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWhiteboardLibraryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWhiteboardLibraryQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetWhiteboardLibraryQuery(baseOptions?: Apollo.QueryHookOptions<GetWhiteboardLibraryQuery, GetWhiteboardLibraryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWhiteboardLibraryQuery, GetWhiteboardLibraryQueryVariables>(GetWhiteboardLibraryDocument, options);
      }
export function useGetWhiteboardLibraryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWhiteboardLibraryQuery, GetWhiteboardLibraryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWhiteboardLibraryQuery, GetWhiteboardLibraryQueryVariables>(GetWhiteboardLibraryDocument, options);
        }
export type GetWhiteboardLibraryQueryHookResult = ReturnType<typeof useGetWhiteboardLibraryQuery>;
export type GetWhiteboardLibraryLazyQueryHookResult = ReturnType<typeof useGetWhiteboardLibraryLazyQuery>;
export type GetWhiteboardLibraryQueryResult = Apollo.QueryResult<GetWhiteboardLibraryQuery, GetWhiteboardLibraryQueryVariables>;
export const GetGroupWhiteboardsDocument = gql`
    query GetGroupWhiteboards($groupId: ID!) {
  groupWhiteboards(groupId: $groupId) {
    id
    name
    sceneVersion
    updatedAt
    lessons {
      lessonId
      lessonName
      lessonNumber
      lessonDate
    }
  }
}
    `;

/**
 * __useGetGroupWhiteboardsQuery__
 *
 * To run a query within a React component, call `useGetGroupWhiteboardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGroupWhiteboardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGroupWhiteboardsQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useGetGroupWhiteboardsQuery(baseOptions: Apollo.QueryHookOptions<GetGroupWhiteboardsQuery, GetGroupWhiteboardsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGroupWhiteboardsQuery, GetGroupWhiteboardsQueryVariables>(GetGroupWhiteboardsDocument, options);
      }
export function useGetGroupWhiteboardsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGroupWhiteboardsQuery, GetGroupWhiteboardsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGroupWhiteboardsQuery, GetGroupWhiteboardsQueryVariables>(GetGroupWhiteboardsDocument, options);
        }
export type GetGroupWhiteboardsQueryHookResult = ReturnType<typeof useGetGroupWhiteboardsQuery>;
export type GetGroupWhiteboardsLazyQueryHookResult = ReturnType<typeof useGetGroupWhiteboardsLazyQuery>;
export type GetGroupWhiteboardsQueryResult = Apollo.QueryResult<GetGroupWhiteboardsQuery, GetGroupWhiteboardsQueryVariables>;
export const LessonJoinHintsDocument = gql`
    query LessonJoinHints($groupLessonId: Int!) {
  lmsLessonJoinClicks(groupLessonId: $groupLessonId) {
    studentId
    studentName
    clickedAt
  }
}
    `;

/**
 * __useLessonJoinHintsQuery__
 *
 * To run a query within a React component, call `useLessonJoinHintsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLessonJoinHintsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLessonJoinHintsQuery({
 *   variables: {
 *      groupLessonId: // value for 'groupLessonId'
 *   },
 * });
 */
export function useLessonJoinHintsQuery(baseOptions: Apollo.QueryHookOptions<LessonJoinHintsQuery, LessonJoinHintsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LessonJoinHintsQuery, LessonJoinHintsQueryVariables>(LessonJoinHintsDocument, options);
      }
export function useLessonJoinHintsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LessonJoinHintsQuery, LessonJoinHintsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LessonJoinHintsQuery, LessonJoinHintsQueryVariables>(LessonJoinHintsDocument, options);
        }
export type LessonJoinHintsQueryHookResult = ReturnType<typeof useLessonJoinHintsQuery>;
export type LessonJoinHintsLazyQueryHookResult = ReturnType<typeof useLessonJoinHintsLazyQuery>;
export type LessonJoinHintsQueryResult = Apollo.QueryResult<LessonJoinHintsQuery, LessonJoinHintsQueryVariables>;